// Hardcoded content for พ.ศ. 2566 / ค.ศ. 2023. Edit this year folder directly when updating content.
// Academic year: พ.ศ. 2566 / ค.ศ. 2023
const yearContent = {
  "meta": {
    "ce": "2023",
    "be": "2566",
    "source": "sut_db_12042026.gz",
    "note": ""
  },
  "pages": {
    "home": {
      "code": 200,
      "status": "Get data success",
      "data": {
        "page": "หน้าแรก",
        "visitor": 189455,
        "visitor_of_year": 43202,
        "section": [
          {
            "id": "19",
            "pageID": "1",
            "title": "เราจะอยู่เป็นเพื่อนน้อง ๆ\r\nตลอดปีการศึกษา",
            "content": "เว็บไซต์คู่มือสำหรับน้อง ๆ มทส. ปี 1 ทุกคำตอบของคำถามรวมอยู่ที่นี่",
            "media": "",
            "link": null,
            "createAt": "2022-07-09 03:10:51",
            "updateAt": "2022-07-09 03:10:51",
            "year": "2025"
          },
          {
            "id": "20",
            "pageID": "1",
            "title": "สารจากอธิการบดี",
            "content": "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry’s standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.",
            "media": "",
            "link": null,
            "createAt": "2022-07-09 03:11:33",
            "updateAt": "2022-07-09 03:11:33",
            "year": "2025"
          }
        ]
      }
    },
    "course": {
      "code": 200,
      "status": "Get data success",
      "data": {
        "page": "แนะนำหลักสูตร",
        "section": [],
        "course": [
          {
            "id": "1",
            "nameTH": "สำนักวิชาวิทยาศาสตร์",
            "nameEN": "Institute of Science",
            "slang": "department-science",
            "image": "__PUBLIC_URL__/service-sut/image/Institute/pic-01.png",
            "createAt": "2022-07-09 03:48:04",
            "updataAt": "2022-07-09 03:48:04",
            "link": "__PUBLIC_URL__/service-sut/ebook-freshmen/2566/Institute_of_Science/Institute_of_Science.html"
          },
          {
            "id": "2",
            "nameTH": "สำนักวิชาเทคโนโลยีสังคม",
            "nameEN": "Institute of Social Technology",
            "slang": "department-social",
            "image": "__PUBLIC_URL__/service-sut/image/Institute/pic-02.png",
            "createAt": "2022-07-09 03:48:04",
            "updataAt": "2022-07-09 03:48:04",
            "link": "__PUBLIC_URL__/service-sut/ebook-freshmen/2566/Institute_of_Social_Technology/Institute_of_Social_Technology.html"
          },
          {
            "id": "3",
            "nameTH": "สำนักวิชาเทคโนโลยีการเกษตร",
            "nameEN": "Institute of Agricultural Technology",
            "slang": "department-agricultural",
            "image": "__PUBLIC_URL__/service-sut/image/Institute/pic-03.png",
            "createAt": "2022-07-09 03:48:36",
            "updataAt": "2022-07-09 03:48:36",
            "link": "__PUBLIC_URL__/service-sut/ebook-freshmen/2566/Institute_of_Agricultural_Technology/Institute_of_Agricultural_Technology.html"
          },
          {
            "id": "4",
            "nameTH": "สำนักวิชาวิศวกรรมศาสตร์",
            "nameEN": "Institute of Engineering",
            "slang": "department-engineering",
            "image": "__PUBLIC_URL__/service-sut/image/Institute/pic-04.png",
            "createAt": "2022-07-09 03:48:36",
            "updataAt": "2022-07-09 03:48:36",
            "link": "__PUBLIC_URL__/service-sut/ebook-freshmen/2566/Institute_of_Engineering/Institute_of_Engineering.html"
          },
          {
            "id": "5",
            "nameTH": "สำนักวิชาแพทยศาสตร์",
            "nameEN": "Institute of Medicine",
            "slang": "department-medicine",
            "image": "__PUBLIC_URL__/service-sut/image/Institute/pic-05.png",
            "createAt": "2022-07-09 03:49:33",
            "updataAt": "2022-07-09 03:49:33",
            "link": "__PUBLIC_URL__/service-sut/ebook-freshmen/2566/Institute_of_Medicine/Institute_of_Medicine.html"
          },
          {
            "id": "6",
            "nameTH": "สำนักวิชาพยาบาลศาสตร์",
            "nameEN": "Institute of Nursing",
            "slang": "department-nursing",
            "image": "__PUBLIC_URL__/service-sut/image/Institute/pic-06.png",
            "createAt": "2022-07-09 03:49:33",
            "updataAt": "2022-07-09 03:49:33",
            "link": "__PUBLIC_URL__/service-sut/ebook-freshmen/2566/Institute_of_Nursing/Institute_of_Nursing.html"
          },
          {
            "id": "7",
            "nameTH": "สำนักวิชาทันตแพทยศาสตร์",
            "nameEN": "Institute of Dentistry",
            "slang": "department-dentistry",
            "image": "__PUBLIC_URL__/service-sut/image/Institute/pic-07.png",
            "createAt": "2022-07-09 03:49:59",
            "updataAt": "2022-07-09 03:49:59",
            "link": "__PUBLIC_URL__/service-sut/ebook-freshmen/2566/Institute_of_Dentistry/Institute_of_Dentistry.html"
          },
          {
            "id": "8",
            "nameTH": "สำนักวิชาสาธารณสุขศาสตร์",
            "nameEN": "Institute of Public Health",
            "slang": "department-public-health",
            "image": "__PUBLIC_URL__/service-sut/image/image_2024/Img/08-PubH/08-PublicHealth.png",
            "createAt": "2022-07-09 03:49:59",
            "updataAt": "2022-07-09 03:49:59",
            "link": "__PUBLIC_URL__/service-sut/ebook-freshmen/2566/Institute_of_Public_Health/Institute_of_Public_Health.html"
          },
          {
            "id": "9",
            "nameTH": "สำนักวิชาศาสตร์และศิลป์ดิจิทัล",
            "nameEN": "Institute of Digital Art and Science",
            "slang": "department-degitech",
            "image": "__PUBLIC_URL__/service-sut/image/Institute/pic-09.png",
            "createAt": "2022-07-09 03:50:32",
            "updataAt": "2022-07-09 03:50:32",
            "link": "__PUBLIC_URL__/service-sut/ebook-freshmen/2566/Institute_of_Digital_Arts_&_Science/Institute_of_Digital_Arts_&_Science.html"
          }
        ]
      }
    },
    "enrollment": {
      "code": 200,
      "status": "Get data success",
      "data": {
        "page": "การลงทะเบียนเรียน",
        "visitor": 189455,
        "visitor_of_year": 43202,
        "section": [
          {
            "id": "21",
            "pageID": "3",
            "title": "การลงทะเบียนเรียน",
            "content": "ระบบลงทะเบียน,ลงทะเบียนต่ำกว่า 9 และมากกว่า 22 หน่วยกิต,ลงทะเบียน GPAX ต่ำกว่า 2 หน่วยกิต,ผ่อนผันค่าลงทะเบียน,การเลือกสาขา,คำนวนเกรด และตัวอย่าง,ขอย้ายสาขา/สำนัก,สถานภาพ และ Re-Entry,ศูนย์บริการ นศ.",
            "media": "",
            "link": null,
            "createAt": "2022-07-09 04:00:30",
            "updateAt": "2022-07-09 04:00:30",
            "year": "2025",
            "menu_data": [
              {
                "name": "ระบบลงทะเบียน",
                "slung": "registration-system"
              },
              {
                "name": "ลงทะเบียนมากกว่า 22 หน่วยกิต",
                "slung": "registered-credits"
              },
              {
                "name": "ผ่อนผันค่าลงทะเบียน",
                "slung": "registration-fees"
              },
              {
                "name": "การเลือกสาขาวิขา",
                "slung": "branch-selection"
              },
              {
                "name": "คำนวณเกรด และตัวอย่าง",
                "slung": "calculate-grade"
              },
              {
                "name": "ขอย้ายสาขาวิชา/สำนักวิชา",
                "slung": "request-to-move-branch"
              },
              {
                "name": "สถานภาพ",
                "slung": "re-entry"
              },
              {
                "name": "การขอกลับเข้าศึกษาใหม่ RE-ENTRY",
                "slung": "retern-entry"
              },
              {
                "name": "การทดสอบความรู้ภาษาอังกฤษและการเทียบเคียงผลการสอบ",
                "slung": "test-eng"
              },
              {
                "name": "ศูนย์บริการนักศึกษา",
                "slung": "service-center"
              }
            ]
          },
          {
            "id": "22",
            "pageID": "3",
            "title": "ตารางปฏิทินการศึกษา",
            "content": "",
            "media": "__PUBLIC_URL__/service-sut/image/SUT-Calendar.png",
            "link": "__PUBLIC_URL__/service-sut/image/2025/SUTCalendar2568.pdf",
            "createAt": "2022-07-09 04:00:30",
            "updateAt": "2022-07-09 04:00:30",
            "year": "2025",
            "conent_0": ""
          },
          {
            "id": "29",
            "pageID": "3",
            "title": "ข้อมูลติดต่อศูนย์บริการนักศึกษา",
            "content": "0-4422-3011 ถึง 2,จันทร์ - ศุกร์ | 08.30 - 16.30 น.,http://www.sut.ac.th/ces,ศูนย์บริการการศึกษา มทส. อาคารเรียนรวม 2 111 ถ.มหาวิทยาลัย ต.สุรนารี อ.เมือง จ.นครราชสีมา 3000",
            "media": "",
            "link": null,
            "createAt": "2022-07-16 13:43:07",
            "updateAt": "2022-07-16 13:43:07",
            "year": "2025",
            "conent_0": "0-4422-3011 ถึง 2",
            "conent_1": "จันทร์ - ศุกร์ | 08.30 - 16.30 น.",
            "conent_2": "http://www.sut.ac.th/ces",
            "conent_3": "ศูนย์บริการการศึกษา มทส. อาคารเรียนรวม 2 111 ถ.มหาวิทยาลัย ต.สุรนารี อ.เมือง จ.นครราชสีมา 3000"
          }
        ]
      }
    },
    "leave_conditions": {
      "code": 200,
      "status": "Get data success",
      "data": {
        "page": "เงื่อนไขการลา",
        "section": [
          {
            "id": "23",
            "pageID": "4",
            "title": "ลาระหว่างเรียน",
            "content": "เขียนคำร้อง ท.95 ระบบเหตุผลของการลาให้ชัดเจนและครบถ้วน พร้อมลงลายมือชื่อ,\nแนบเอกสารหลักฐาน ประกอบการลา (ถ้ามี) เช่น ใบรับรองแพทย์ ใบเรียกทหาร เป็นต้น,\nเตรียมเอกสารให้ครบ นำเข้าพบอาจารย์ผู้สอนให้ลงนาม,\nทำสำเนาเก็บไว้ให้อาจารย์ผู้สอน และให้นักศึกษาเก็บตัวจริงไว้เป็นหลักฐาน โดยไม่ต้องนำส่งฝ่ายทะเบียนนักศึกษา,\n\nสำคัญ!! ต้องยื่นคำร้องภายใน 1 สัปดาห์ นับจากวันที่นักศึกษาเริ่มป่วยหรือเกิดเหตุสุดวิสัย และอย่าลืม!! ติดตามขอสอบย้อนหลังกับอาจารย์ผู้สอนด้วยนะคะ",
            "media": "__PUBLIC_URL__/service-sut/image/illus-maindata_H72-1.png",
            "link": "http://web.sut.ac.th/ces/2018/ces/formST/21.pdf",
            "createAt": "2022-07-09 04:02:16",
            "updateAt": "2022-07-09 04:02:16",
            "year": "2025",
            "conent_0": "เขียนคำร้อง ท.95 ระบบเหตุผลของการลาให้ชัดเจนและครบถ้วน พร้อมลงลายมือชื่อ",
            "conent_1": "\nแนบเอกสารหลักฐาน ประกอบการลา (ถ้ามี) เช่น ใบรับรองแพทย์ ใบเรียกทหาร เป็นต้น",
            "conent_2": "\nเตรียมเอกสารให้ครบ นำเข้าพบอาจารย์ผู้สอนให้ลงนาม",
            "conent_3": "\nทำสำเนาเก็บไว้ให้อาจารย์ผู้สอน และให้นักศึกษาเก็บตัวจริงไว้เป็นหลักฐาน โดยไม่ต้องนำส่งฝ่ายทะเบียนนักศึกษา",
            "conent_4": "\n\nสำคัญ!! ต้องยื่นคำร้องภายใน 1 สัปดาห์ นับจากวันที่นักศึกษาเริ่มป่วยหรือเกิดเหตุสุดวิสัย และอย่าลืม!! ติดตามขอสอบย้อนหลังกับอาจารย์ผู้สอนด้วยนะคะ"
          },
          {
            "id": "24",
            "pageID": "4",
            "title": "ลาช่วงสอบ",
            "content": "เขียนคำร้อง ท.95/1 ระบบเหตุผลของการลาให้ชัดเจนและครบถ้วน พร้อมลงลายมือชื่อ,แนบเอกสารหลักฐาน ประกอบการลา (ถ้ามี) โดยเตรียมให้เท่ากับจำนวนวิชาที่ขอลา,เตรียมเอกสารให้ครบ นำเข้าพบผู้พิจารณา ตามลำดับดังนี้\n    1 อาจารย์ที่ปรึกษา > 2 อาจารย์ผู้สอน > 3 หัวหน้าสาขาวิชาฯ ที่นักศึกษาสังกัด,ทำสำเนาเก็บไว้ให้อาจารย์ผู้สอน เพื่อกำหนดวัน/เวลา/สถานที่สอบ ในช่องความเห็นของอาจารย์ผู้สอน และให้นักศึกษาเก็บตัวจริงไว้เป็นหลักฐาน โดยไม่ต้องนำส่งฝ่ายทะเบียนนักศึกษา,สำคัญ!! ต้องยื่นคำร้องภายใน 1 สัปดาห์ นับจากวันที่นักศึกษาเริ่มป่วยหรือเกิดเหตุสุดวิสัย และอย่าลืม!! ติดตามขอสอบย้อนหลังกับอาจารย์ผู้สอนด้วยนะคะ",
            "media": "__PUBLIC_URL__/service-sut/image/illus-maindata_H72-2.png",
            "link": "http://web.sut.ac.th/ces/2018/ces/formST/22_2.pdf",
            "createAt": "2022-07-09 04:02:16",
            "updateAt": "2022-07-09 04:02:16",
            "year": "2025",
            "conent_0": "เขียนคำร้อง ท.95/1 ระบบเหตุผลของการลาให้ชัดเจนและครบถ้วน พร้อมลงลายมือชื่อ",
            "conent_1": "แนบเอกสารหลักฐาน ประกอบการลา (ถ้ามี) โดยเตรียมให้เท่ากับจำนวนวิชาที่ขอลา",
            "conent_2": "เตรียมเอกสารให้ครบ นำเข้าพบผู้พิจารณา ตามลำดับดังนี้\n    1 อาจารย์ที่ปรึกษา > 2 อาจารย์ผู้สอน > 3 หัวหน้าสาขาวิชาฯ ที่นักศึกษาสังกัด",
            "conent_3": "ทำสำเนาเก็บไว้ให้อาจารย์ผู้สอน เพื่อกำหนดวัน/เวลา/สถานที่สอบ ในช่องความเห็นของอาจารย์ผู้สอน และให้นักศึกษาเก็บตัวจริงไว้เป็นหลักฐาน โดยไม่ต้องนำส่งฝ่ายทะเบียนนักศึกษา",
            "conent_4": "สำคัญ!! ต้องยื่นคำร้องภายใน 1 สัปดาห์ นับจากวันที่นักศึกษาเริ่มป่วยหรือเกิดเหตุสุดวิสัย และอย่าลืม!! ติดตามขอสอบย้อนหลังกับอาจารย์ผู้สอนด้วยนะคะ"
          },
          {
            "id": "25",
            "pageID": "4",
            "title": "ลาพักเรียน",
            "content": "เขียนคำร้อง ท.97\n,ส่งคำร้องฯ พร้อมระบุเหตุผลและแนบเอกสารประกอบ (ถ้ามี) ต่อเจ้าหน้าที่สาขาวิชา/สำนักวิชา เพื่อเสนอผู้มีอำนาจพิจารณา,นำคำร้องที่ได้รับการอนุมัติแล้ว ส่งฝ่ายทะเบียนนักศึกษา ศูนย์บริการการศึกษา อาคารเรียนรวม 2\n,ตรวจสอบข้อมูล ในระบบทะเบียนและประเมินผล เลือกเมนู ระเบียบประวัติ และตรวจสอบที่สถานภาพ\n,ชำระเงินค่ารักษาสถานภาพ ภายใน 15 วัน หลังจากที่ได้รับอนุมัติให้ลาพักการศึกษา มิฉะนั้นจะพ้นสถานภาพนักศึกษา (หากชำระค่าลงทะเบียนเรียนแล้ว ไม่ต้องชำระอีก)\n,นักศึกษาที่ต้องการกลับเข้าศึกษาก่อนระยะเวลาที่ได้รับอนุมัติให้ลาพักการศึกษา ให้ยื่นคำร้องขอกลับเข้าศึกษาก่อนกำหนดวันลงทะเบียนเทอมถัดไป ไม่น้อยกว่า 1 สัปดาห์ สำหรับระบบไตรภาค หรือตามช่วงเวลาที่สำนักวิชากำหนด สำหรับระบบปีการศึกษา\n\n,สำคัญ!! หากยังไม่ได้ลงทะเบียนเรียน ต้องยื่นคำร้องภายใน 10 วัน หรือหากลงทะเบียนเรียนแล้ว ให้ยื่นภายในเทอมของปีการศึกษานั้น และอย่าลืม!! ติดตามขอสอบย้อนหลังกับอาจารย์ผู้สอนด้วยนะคะ",
            "media": "__PUBLIC_URL__/service-sut/image/illus-maindata_H72-3.png",
            "link": "http://web.sut.ac.th/ces/2018/ces/formST/24_3.pdf",
            "createAt": "2022-07-09 04:05:07",
            "updateAt": "2022-07-09 04:05:07",
            "year": "2025",
            "conent_0": "เขียนคำร้อง ท.97\n",
            "conent_1": "ส่งคำร้องฯ พร้อมระบุเหตุผลและแนบเอกสารประกอบ (ถ้ามี) ต่อเจ้าหน้าที่สาขาวิชา/สำนักวิชา เพื่อเสนอผู้มีอำนาจพิจารณา",
            "conent_2": "นำคำร้องที่ได้รับการอนุมัติแล้ว ส่งฝ่ายทะเบียนนักศึกษา ศูนย์บริการการศึกษา อาคารเรียนรวม 2\n",
            "conent_3": "ตรวจสอบข้อมูล ในระบบทะเบียนและประเมินผล เลือกเมนู ระเบียบประวัติ และตรวจสอบที่สถานภาพ\n",
            "conent_4": "ชำระเงินค่ารักษาสถานภาพ ภายใน 15 วัน หลังจากที่ได้รับอนุมัติให้ลาพักการศึกษา มิฉะนั้นจะพ้นสถานภาพนักศึกษา (หากชำระค่าลงทะเบียนเรียนแล้ว ไม่ต้องชำระอีก)\n",
            "conent_5": "นักศึกษาที่ต้องการกลับเข้าศึกษาก่อนระยะเวลาที่ได้รับอนุมัติให้ลาพักการศึกษา ให้ยื่นคำร้องขอกลับเข้าศึกษาก่อนกำหนดวันลงทะเบียนเทอมถัดไป ไม่น้อยกว่า 1 สัปดาห์ สำหรับระบบไตรภาค หรือตามช่วงเวลาที่สำนักวิชากำหนด สำหรับระบบปีการศึกษา\n\n",
            "conent_6": "สำคัญ!! หากยังไม่ได้ลงทะเบียนเรียน ต้องยื่นคำร้องภายใน 10 วัน หรือหากลงทะเบียนเรียนแล้ว ให้ยื่นภายในเทอมของปีการศึกษานั้น และอย่าลืม!! ติดตามขอสอบย้อนหลังกับอาจารย์ผู้สอนด้วยนะคะ"
          },
          {
            "id": "26",
            "pageID": "4",
            "title": "ลาออก",
            "content": "เขียนคำร้อง ท.96 เลือกดาวน์โหลดแบบฟอร์ม ท.96 \n,นำคำร้องเข้าพบผู้พิจารณาอนุมัติ ตามลำดับดังนี้\n     1 อาจารย์ที่ปรึกษา เพื่อขอความเห็นชอบ\n     2 เจ้าหน้าที่สาขา/สำนักวิชา เพื่อเสนอคณบดีสำนักวิชาที่นักศึกษาสังกัด เพื่อพิจารณาอนุมัติ \n \nหากเป็นนักศึกษา ป.ตรี ในสังกัดสำนักวิชาเทคโนโลยีสังคม ให้เสนอหัวหน้าสาขาวิชา เพื่อความเห็นชอบด้วยก่อนเสนอคณบดี\n\n,ส่งคำร้องที่ฝ่ายทะเบียนนักศึกษา ศูนย์บริการการศึกษา อาคารเรียนรวม 2\n,ติดต่อส่วนการเงินและบัญชี เพื่อขอรับเงินประกันทั่วไปคืน หลังจากได้ยื่นคำร้องที่ฝ่ายทะเบียนนักศึกษาแล้ว ประมาณ 8 สัปดาห์\n\n,สำคัญ!! หากยังไม่ได้ลงทะเบียนเรียน ต้องยื่นคำร้องภายใน 10 วันนับจากวันที่เปิดเทอม\n\n,แต่หากลงทะเบียนเรียนแล้ว ให้ยื่นภายใน 11 วันนับจากวันที่เปิดเทอม เพื่อยกเลิกการลงทะเบียนเรียนและลบค่าใช้จ่าย ต้องยื่นภายในเทอมของปีการศึกษานั้นค่ะ",
            "media": "__PUBLIC_URL__/service-sut/image/illus-maindata_H72-4.png",
            "link": "http://web.sut.ac.th/ces/2018/ces/formST/23_1.pdf",
            "createAt": "2022-07-09 04:05:07",
            "updateAt": "2022-07-09 04:05:07",
            "year": "2025",
            "conent_0": "เขียนคำร้อง ท.96 เลือกดาวน์โหลดแบบฟอร์ม ท.96 \n",
            "conent_1": "นำคำร้องเข้าพบผู้พิจารณาอนุมัติ ตามลำดับดังนี้\n     1 อาจารย์ที่ปรึกษา เพื่อขอความเห็นชอบ\n     2 เจ้าหน้าที่สาขา/สำนักวิชา เพื่อเสนอคณบดีสำนักวิชาที่นักศึกษาสังกัด เพื่อพิจารณาอนุมัติ \n \nหากเป็นนักศึกษา ป.ตรี ในสังกัดสำนักวิชาเทคโนโลยีสังคม ให้เสนอหัวหน้าสาขาวิชา เพื่อความเห็นชอบด้วยก่อนเสนอคณบดี\n\n",
            "conent_2": "ส่งคำร้องที่ฝ่ายทะเบียนนักศึกษา ศูนย์บริการการศึกษา อาคารเรียนรวม 2\n",
            "conent_3": "ติดต่อส่วนการเงินและบัญชี เพื่อขอรับเงินประกันทั่วไปคืน หลังจากได้ยื่นคำร้องที่ฝ่ายทะเบียนนักศึกษาแล้ว ประมาณ 8 สัปดาห์\n\n",
            "conent_4": "สำคัญ!! หากยังไม่ได้ลงทะเบียนเรียน ต้องยื่นคำร้องภายใน 10 วันนับจากวันที่เปิดเทอม\n\n",
            "conent_5": "แต่หากลงทะเบียนเรียนแล้ว ให้ยื่นภายใน 11 วันนับจากวันที่เปิดเทอม เพื่อยกเลิกการลงทะเบียนเรียนและลบค่าใช้จ่าย ต้องยื่นภายในเทอมของปีการศึกษานั้นค่ะ"
          }
        ]
      }
    },
    "cooperative": {
      "code": 200,
      "status": "Get data success",
      "data": {
        "page": "การปฏิบัติงานสหกิจศึกษา",
        "section": [
          {
            "id": "27",
            "pageID": "5",
            "title": "สหกิจศึกษา",
            "content": "Cooperative Education เป็นระบบการศึกษา ที่เน้นการปฏิบัติงานใน สถานประกอบการอย่างมีระบบ โดยจัดให้มีการเรียนในสถานศึกษาร่วมกับการจัดให้ นักศึกษาไปปฏิบัติงานจริง ณ สถานประกอบการ งานที่นักศึกษาปฏิบัติจะตรงกับ สาขาวิชาของนักศึกษา โดยเน้นการเรียนรู้โดยใช้ประสบการณ์จากการทำงานจริงเป็นหลัก หรือ Work-based learning หรือ โครงงานพิเศษ (Project) ที่มีประโยชน์กับสถานประกอบการ เช่น การปรับปรุง หรือการเพิ่มประสิทธิภาพ หรือการแก้ปัญหาของกระบวนการทำงาน ซึ่ง นักศึกษาสามารถปฏิบัติงานให้สำเร็จได้ภายใน 4 เดือน ทำให้นักศึกษาสามารถเรียนรู้ ประสบการณ์จากการทำงาน และมีคุณภาพตรงตามที่สถานประกอบการต้องการมากที่สุด นักศึกษาที่จะปฏิบัติสหกิจศึกษาได้ ต้องมีคุณสมบัติดังนี้,สอบผ่านรายวิชาเตรียมสหกิจ,GPAX ไม่ต่ำกว่า 2.00 นับถึงเทอมสุดท้าย ก่อนทำการสมัครงานสหกิจศึกษา,ผ่านเงื่อนไขทางวิชาการที่สาขาวิชากำหนด,ไม่อยู่ระหว่างถูกพักการศึกษาในเทอมที่จะปฏิบัติสหกิจศึกษา,ไม่เคยต้องโทษวินัยนักศึกษาตั้งแต่ระดับพักการศึกษาขั้นไป เว้นแต่จะได้รับความเห็นชอบจากสาขาวิชา และได้รับการรับรองความประพฤติจากผู้ปกครองเป็นลายลักษณ์อักษรก่อน,ไม่เป็นโรคที่เป็นอุปสรรคต่อการปฏิบัติงานในสถานประกอบการ",
            "media": "__PUBLIC_URL__/service-sut/image/Pic-01-Coop.png",
            "link": null,
            "createAt": "2022-07-09 04:07:01",
            "updateAt": "2022-07-09 04:07:01",
            "year": "2025",
            "conent_0": "Cooperative Education เป็นระบบการศึกษา ที่เน้นการปฏิบัติงานใน สถานประกอบการอย่างมีระบบ โดยจัดให้มีการเรียนในสถานศึกษาร่วมกับการจัดให้ นักศึกษาไปปฏิบัติงานจริง ณ สถานประกอบการ งานที่นักศึกษาปฏิบัติจะตรงกับ สาขาวิชาของนักศึกษา โดยเน้นการเรียนรู้โดยใช้ประสบการณ์จากการทำงานจริงเป็นหลัก หรือ Work-based learning หรือ โครงงานพิเศษ (Project) ที่มีประโยชน์กับสถานประกอบการ เช่น การปรับปรุง หรือการเพิ่มประสิทธิภาพ หรือการแก้ปัญหาของกระบวนการทำงาน ซึ่ง นักศึกษาสามารถปฏิบัติงานให้สำเร็จได้ภายใน 4 เดือน ทำให้นักศึกษาสามารถเรียนรู้ ประสบการณ์จากการทำงาน และมีคุณภาพตรงตามที่สถานประกอบการต้องการมากที่สุด นักศึกษาที่จะปฏิบัติสหกิจศึกษาได้ ต้องมีคุณสมบัติดังนี้",
            "conent_1": "สอบผ่านรายวิชาเตรียมสหกิจ",
            "conent_2": "GPAX ไม่ต่ำกว่า 2.00 นับถึงเทอมสุดท้าย ก่อนทำการสมัครงานสหกิจศึกษา",
            "conent_3": "ผ่านเงื่อนไขทางวิชาการที่สาขาวิชากำหนด",
            "conent_4": "ไม่อยู่ระหว่างถูกพักการศึกษาในเทอมที่จะปฏิบัติสหกิจศึกษา",
            "conent_5": "ไม่เคยต้องโทษวินัยนักศึกษาตั้งแต่ระดับพักการศึกษาขั้นไป เว้นแต่จะได้รับความเห็นชอบจากสาขาวิชา และได้รับการรับรองความประพฤติจากผู้ปกครองเป็นลายลักษณ์อักษรก่อน",
            "conent_6": "ไม่เป็นโรคที่เป็นอุปสรรคต่อการปฏิบัติงานในสถานประกอบการ"
          },
          {
            "id": "28",
            "pageID": "5",
            "title": "สหกิจศึกษานานาชาติ",
            "content": "สหกิจศึกษา (Cooperative Education) เป็นการเรียนรู้โดยใช้ประสบการณ์จากการทำงานจริงเป็นหลัก (Work-based Learning) เพื่อให้น้อง ๆ ได้รับประสบการณ์ตรงกับสาขาวิชาที่เรียน ซึ่งถือเป็นการบูรณาการการเรียนรู้กับการปฏิบัติงานโดยน้อง ๆ สามารถเลือกสหกิจศึกษาได้ทั้งในประเทศและต่างประเทศ หากน้อง ๆ สนใจที่จะไปปฏิบัติงานสหกิจศึกษาในต่างประเทศนั้น  จะต้องมีคุณสมบัติ ดังนี้,GPAX ไม่ต่ำ กว่า 2.50 ,TOEIC ไม่ต่ำ กว่า 500 หากประสงค์สมัครขอรับทุนฯ ต้องมีคะแนน TOEIC ไม่ต่ำ กว่า 600 (คะแนนมีอายุไม่เกิน 2 ปี),ผ่านการเข้าร่วมกิจกรรมเตรียมสหกิจศึกษานานาชาติ,Note: ในขณะที่ไปปฏิบัติงานสหกิจนานาชาติน้องที่รับทุนฯ จะได้รับเงิน สนับสนุนตามจ่ายจริง ไม่เกิน 50,000 บาท (ห้าหมื่นบาทถ้วน) รุ่นพี่เคยไป Inter Co-op ที่ประเทศออสเตรเลีย แคนาดา เยอรมนี ญี่ปุ่น มาเลเซีย จีน และ อื่น ๆ  Link",
            "media": "__PUBLIC_URL__/service-sut/image/Pic-02-InterCoop-2.png",
            "link": null,
            "createAt": "2022-07-09 04:07:01",
            "updateAt": "2022-07-09 04:07:01",
            "year": "2025",
            "conent_0": "สหกิจศึกษา (Cooperative Education) เป็นการเรียนรู้โดยใช้ประสบการณ์จากการทำงานจริงเป็นหลัก (Work-based Learning) เพื่อให้น้อง ๆ ได้รับประสบการณ์ตรงกับสาขาวิชาที่เรียน ซึ่งถือเป็นการบูรณาการการเรียนรู้กับการปฏิบัติงานโดยน้อง ๆ สามารถเลือกสหกิจศึกษาได้ทั้งในประเทศและต่างประเทศ หากน้อง ๆ สนใจที่จะไปปฏิบัติงานสหกิจศึกษาในต่างประเทศนั้น  จะต้องมีคุณสมบัติ ดังนี้",
            "conent_1": "GPAX ไม่ต่ำ กว่า 2.50 ",
            "conent_2": "TOEIC ไม่ต่ำ กว่า 500 หากประสงค์สมัครขอรับทุนฯ ต้องมีคะแนน TOEIC ไม่ต่ำ กว่า 600 (คะแนนมีอายุไม่เกิน 2 ปี)",
            "conent_3": "ผ่านการเข้าร่วมกิจกรรมเตรียมสหกิจศึกษานานาชาติ",
            "conent_4": "Note: ในขณะที่ไปปฏิบัติงานสหกิจนานาชาติน้องที่รับทุนฯ จะได้รับเงิน สนับสนุนตามจ่ายจริง ไม่เกิน 50",
            "conent_5": "000 บาท (ห้าหมื่นบาทถ้วน) รุ่นพี่เคยไป Inter Co-op ที่ประเทศออสเตรเลีย แคนาดา เยอรมนี ญี่ปุ่น มาเลเซีย จีน และ อื่น ๆ  Link"
          }
        ]
      }
    },
    "question": {
      "code": 200,
      "status": "Get data success",
      "data": {
        "page": "คำถามที่พบบ่อย",
        "sub_title": [
          "การลาระหว่างเรียน /สอบ และพักการศึกษา",
          "การเพิ่ม / ลด / ถอนรายวิชา /เปลี่ยนกลุ่มรายวิชา/ ระยะเวลาที่ลดโดยไม่เสียเงินเต็มจํานวน",
          "การเงิน",
          "การแจ้งจบ การขอ Transcript การขอใบรับรอง"
        ],
        "link": "https://sutgateway.sut.ac.th/ces/%E0%B8%99%E0%B8%B1%E0%B8%81%E0%B8%A8%E0%B8%B6%E0%B8%81%E0%B8%A9%E0%B8%B2/%E0%B8%84%E0%B8%B3%E0%B8%96%E0%B8%B2%E0%B8%A1%E0%B8%97%E0%B8%B5%E0%B9%88%E0%B8%9E%E0%B8%9A%E0%B8%9A%E0%B9%88%E0%B8%AD%E0%B8%A2/",
        "section": [
          {
            "id": "1",
            "name": "การลาระหว่างเรียน /สอบ และพักการศึกษา",
            "createAt": "2022-07-09 03:35:49",
            "updateAt": "2022-07-09 03:35:49",
            "question": [
              {
                "id": "1",
                "typeID": "1",
                "question": "ถ้าไม่สามารถเข้าสอบได้ตามตารางสอบจะขอเลื่อนสอบได้หรือไม่คะ ?",
                "answer": "1.ติดต่ออาจารย์ผู้ประสานงานรายวิชา,2.ยื่นคําร้องขอลาระหว่างสอบโดยผ่านความเห็นชอบอาจารย์ที่ปรึกษา อาจารย์ผู้สอน และหัวหน้าสาขาวิชา(สําหรับกรณีที่ยังไม่สังกัดสาขาวิชาหัวหน้าสาขาหมายถึง หัวหน้าสาขาของอาจารย์ที่ปรึกษาสังกัด),3.เมื่อได้รับอนุมัติให้ลาระหว่างสอบแล้ว ให้นักศึกษาส่งสําเนาเอกสารให้กับ อาจารย์ผู้สอน 1 ชุด และนําเอกสารฉบับจริงส่งที่ฝ่ายทะเบียนนักศึกษา",
                "createAt": "2022-07-09 03:36:49",
                "updateAt": "2022-07-09 03:36:49",
                "answer_0": "1.ติดต่ออาจารย์ผู้ประสานงานรายวิชา",
                "answer_1": "2.ยื่นคําร้องขอลาระหว่างสอบโดยผ่านความเห็นชอบอาจารย์ที่ปรึกษา อาจารย์ผู้สอน และหัวหน้าสาขาวิชา(สําหรับกรณีที่ยังไม่สังกัดสาขาวิชาหัวหน้าสาขาหมายถึง หัวหน้าสาขาของอาจารย์ที่ปรึกษาสังกัด)",
                "answer_2": "3.เมื่อได้รับอนุมัติให้ลาระหว่างสอบแล้ว ให้นักศึกษาส่งสําเนาเอกสารให้กับ อาจารย์ผู้สอน 1 ชุด และนําเอกสารฉบับจริงส่งที่ฝ่ายทะเบียนนักศึกษา"
              },
              {
                "id": "2",
                "typeID": "1",
                "question": "การลาระหว่างเรียนต้องทําอย่างไรคะ ?",
                "answer": "เขียนคําร้องขอลาระหว่างเรียน และติดต่ออาจารย์ผู้สอนค่ะ",
                "createAt": "2022-07-09 03:36:49",
                "updateAt": "2022-07-09 03:36:49",
                "answer_0": "เขียนคําร้องขอลาระหว่างเรียน และติดต่ออาจารย์ผู้สอนค่ะ"
              }
            ]
          },
          {
            "id": "2",
            "name": "การเพิ่ม / ลด / ถอนรายวิชา /เปลี่ยนกลุ่มรายวิชา/ ระยะเวลาที่ลดโดยไม่เสียเงินเต็มจํานวน",
            "createAt": "2022-07-09 03:35:49",
            "updateAt": "2022-07-09 03:35:49",
            "question": [
              {
                "id": "3",
                "typeID": "2",
                "question": "การลงทะเบียนเพิ่มรายวิชา/เปลี่ยนกลุ่ม ต้องทําอย่างไรบ้างครับ ?",
                "answer": "นักศึกษาสามารถเพิ่ม / ลด / เปลี่ยนกลุ่มรายวิชา ในระบบ reg.sut.ac.th หากดําเนินการ ภายใน 5 วัน แรกนับจากการเปิดภาคการศึกษา จะได้รับเงินคืนเต็มจํานวน แต่เสียค่าธรรมเนียม ครั้งละ 50 บาท หากดําเนินการหลังกําหนดดังกล่าว จะไม่ได้รับเงินคืนเต็มจํานวน (นับเปิดภาค 10 วัน)",
                "createAt": "2022-07-09 03:38:58",
                "updateAt": "2022-07-09 03:38:58",
                "answer_0": "นักศึกษาสามารถเพิ่ม / ลด / เปลี่ยนกลุ่มรายวิชา ในระบบ reg.sut.ac.th หากดําเนินการ ภายใน 5 วัน แรกนับจากการเปิดภาคการศึกษา จะได้รับเงินคืนเต็มจํานวน แต่เสียค่าธรรมเนียม ครั้งละ 50 บาท หากดําเนินการหลังกําหนดดังกล่าว จะไม่ได้รับเงินคืนเต็มจํานวน (นับเปิดภาค 10 วัน)"
              },
              {
                "id": "4",
                "typeID": "2",
                "question": "ถ้าเลยระยะเวลาที่กําหนดเกิน 10 วันไปแล้ว ต้องทําอย่างไรบ้างครับ ?",
                "answer": "นักศึกษาจะต้องติดต่อที่ศูนย์บริการการศึกษาเท่านั้น เพื่อเขียนคําร้องขอลงทะเบียนเพิ่ม/เปลี่ยนกลุ่ม กรณีกลุ่มเต็ม/ลดรายวิชา (ท.1) และผ่านคําแนะนําจากอาจารย์ที่ปรึกษา และความเห็นชอบจากอาจารย์ผู้สอน โดยยื่นคําร้องที่ฝ่ายทะเบียนนักศึกษา",
                "createAt": "2022-07-09 03:38:58",
                "updateAt": "2022-07-09 03:38:58",
                "answer_0": "นักศึกษาจะต้องติดต่อที่ศูนย์บริการการศึกษาเท่านั้น เพื่อเขียนคําร้องขอลงทะเบียนเพิ่ม/เปลี่ยนกลุ่ม กรณีกลุ่มเต็ม/ลดรายวิชา (ท.1) และผ่านคําแนะนําจากอาจารย์ที่ปรึกษา และความเห็นชอบจากอาจารย์ผู้สอน โดยยื่นคําร้องที่ฝ่ายทะเบียนนักศึกษา"
              },
              {
                "id": "5",
                "typeID": "2",
                "question": "ถ้าเกิดว่าเกรดเราไม่ถึง 1.50 แล้วเราจะต้องทําไงครับ ต้องลาออกก่อนแล้วรีรหัส หรือว่ารอให้เกรดเทอมสามออกก่อนครับ ถึงจะรีรหัสได้ครับ",
                "answer": "ถ้าเทอม 1-2 นักศึกษาเกรดไม่ถึง 1.50 นักศึกษาจะยังมีสภาพปกติ แต่ถ้าเทอม 3 เกรดนักศึกษายังไม่ถึง 1.50 นักศึกษาจะพ้นสภาพ (Retire) ทันที และถ้านักศึกษาต้องการ ขอกลับเข้าศึกษาใหม่ นักศึกษาต้องยื่นสมัครให้ทันเวลา แต่ถ้าคิดว่าเกรดจะออกไม่ทันก็ต้องลาออกก่อนค่ะ ซึ่งสํานักวิชาวิศวกรรมศาสตร์ จะเปิดรับสมัคร Re-entry ในเทอม 3 ของทุกปีการศึกษา สามารถติดตามข่าวสารได้ที่แฟนเพจสํานักวิชาวิศวกรรมศาสตร์ค่ะ",
                "createAt": "2022-07-09 03:40:40",
                "updateAt": "2022-07-09 03:40:40",
                "answer_0": "ถ้าเทอม 1-2 นักศึกษาเกรดไม่ถึง 1.50 นักศึกษาจะยังมีสภาพปกติ แต่ถ้าเทอม 3 เกรดนักศึกษายังไม่ถึง 1.50 นักศึกษาจะพ้นสภาพ (Retire) ทันที และถ้านักศึกษาต้องการ ขอกลับเข้าศึกษาใหม่ นักศึกษาต้องยื่นสมัครให้ทันเวลา แต่ถ้าคิดว่าเกรดจะออกไม่ทันก็ต้องลาออกก่อนค่ะ ซึ่งสํานักวิชาวิศวกรรมศาสตร์ จะเปิดรับสมัคร Re-entry ในเทอม 3 ของทุกปีการศึกษา สามารถติดตามข่าวสารได้ที่แฟนเพจสํานักวิชาวิศวกรรมศาสตร์ค่ะ"
              }
            ]
          },
          {
            "id": "3",
            "name": "การเงิน",
            "createAt": "2022-07-09 03:36:28",
            "updateAt": "2022-07-09 03:36:28",
            "question": [
              {
                "id": "6",
                "typeID": "3",
                "question": "การขอผ่อนผันชําระเงินค่าธรรมเนียมการลงทะเบียนเรียนสามารถขอผ่อนผันฯ ได้ถึงเมื่อไหร่คะ ?",
                "answer": "นักศึกษาขอผ่อนผันได้ 4 สัปดาห์นับจากเปิดภาคการศึกษา แต่นักศึกษาจะต้องยื่นคําร้องขอผ่อนผันฯ ภายใน 11 วันนับจากเปิดภาคการศึกษา",
                "createAt": "2022-07-09 03:43:44",
                "updateAt": "2022-07-09 03:43:44",
                "answer_0": "นักศึกษาขอผ่อนผันได้ 4 สัปดาห์นับจากเปิดภาคการศึกษา แต่นักศึกษาจะต้องยื่นคําร้องขอผ่อนผันฯ ภายใน 11 วันนับจากเปิดภาคการศึกษา"
              }
            ]
          },
          {
            "id": "4",
            "name": "การแจ้งจบ การขอ Transcript การขอใบรับรอง",
            "createAt": "2022-07-09 03:36:28",
            "updateAt": "2022-07-09 03:36:28",
            "question": [
              {
                "id": "7",
                "typeID": "4",
                "question": "การแจ้งจบต้องใช้เอกสารอะไรบ้างครับ?",
                "answer": "ยื่นคําร้องแจ้งจบผ่าน http://reg.sut.ac.th ดูกําหนดการที่ปฏิทินการศึกษา และตรวจสอบรายชื่อผู้แจ้งจบที่เมนู “ตรวจสอบ – แจ้งจบ”",
                "createAt": "2022-07-09 03:43:44",
                "updateAt": "2022-07-09 03:43:44",
                "answer_0": "ยื่นคําร้องแจ้งจบผ่าน http://reg.sut.ac.th ดูกําหนดการที่ปฏิทินการศึกษา และตรวจสอบรายชื่อผู้แจ้งจบที่เมนู “ตรวจสอบ – แจ้งจบ”"
              },
              {
                "id": "8",
                "typeID": "4",
                "question": "ถ้าไม่สะดวกไปรับเอกสารสําเร็จการศึกษาด้วยตนเองให้คนอื่นไปรับแทนได้ไหม แล้วต้องทําอย่างไร?",
                "answer": "ได้ค่ะ เขียนใบมอบฉันทะ และแนบสําเนาบัตรประจําตัวประชาชน ทั้งของผู้มอบฉันทะและผู้รับมอบฉันทะให้คนที่จะมารับแทนยื่นรับเอกสารได้ที่ฝ่ายประมวลผลและข้อมูลบัณฑิต ที่ศูนย์บริการการศึกษาอาคารเรียนรวม 2",
                "createAt": "2022-07-09 03:44:21",
                "updateAt": "2022-07-09 03:44:21",
                "answer_0": "ได้ค่ะ เขียนใบมอบฉันทะ และแนบสําเนาบัตรประจําตัวประชาชน ทั้งของผู้มอบฉันทะและผู้รับมอบฉันทะให้คนที่จะมารับแทนยื่นรับเอกสารได้ที่ฝ่ายประมวลผลและข้อมูลบัณฑิต ที่ศูนย์บริการการศึกษาอาคารเรียนรวม 2"
              },
              {
                "id": "9",
                "typeID": "4",
                "question": "ถ้าจะขอใบรับรองสําเร็จการศึกษาทางไปรณีย์ต้องส่งเอกสารอะไรไปบ้างและจะใช้เวลาดําเนินการประมาณกี่วัน ?",
                "answer": "ได้ค่ะโดยยื่นคําร้องขอเอกสาร Online ในระบบ จากนั้นโอนเงินค่าธรรมเนียมการจัดทำเอกสารตามจํานวนที่ระบบแจ้ง เข้าบัญชี ธ.ไทยพาณิชย์ จํากัด (มหาชน) เลขที่บัญชี 707-2-35379-0 ชื่อบัญชีมหาวิทยาลัยเทคโนโลยีสุรนารี จากนั้นส่งหลักฐานการโอนเงิน และบัตรประจําตัว พร้อมทั้ง แจ้งชื่อ-สกุล รหัสนักศึกษา และที่อยู่ที่จัดส่งเอกสารมาที่อีเมลล์ graduate@sut.ac.th เมื่อได้รับหลักฐานแล้วจะดําเนินการจัดทําเอกสารและส่งกลับทางไปรษณีย์ (EMS) ในวันถัดไป",
                "createAt": "2022-07-09 03:44:21",
                "updateAt": "2022-07-09 03:44:21",
                "answer_0": "ได้ค่ะโดยยื่นคําร้องขอเอกสาร Online ในระบบ จากนั้นโอนเงินค่าธรรมเนียมการจัดทำเอกสารตามจํานวนที่ระบบแจ้ง เข้าบัญชี ธ.ไทยพาณิชย์ จํากัด (มหาชน) เลขที่บัญชี 707-2-35379-0 ชื่อบัญชีมหาวิทยาลัยเทคโนโลยีสุรนารี จากนั้นส่งหลักฐานการโอนเงิน และบัตรประจําตัว พร้อมทั้ง แจ้งชื่อ-สกุล รหัสนักศึกษา และที่อยู่ที่จัดส่งเอกสารมาที่อีเมลล์ graduate@sut.ac.th เมื่อได้รับหลักฐานแล้วจะดําเนินการจัดทําเอกสารและส่งกลับทางไปรษณีย์ (EMS) ในวันถัดไป"
              }
            ]
          }
        ]
      }
    },
    "how_to_register": {
      "code": 200,
      "status": "Get data success",
      "data": {
        "page_th": "ขั้นตอนต่างๆ",
        "page_en": "how to Registration",
        "section": [
          {
            "id": "1",
            "title": "ระบบลงทะเบียน",
            "sub_title": "ระบบลงทะเบียนออนไลน์ ทำอะไรได้บ้าง ?",
            "slung": "registration-system",
            "content": "การลงทะเบียนเรียน ลงทะเบียนเรียนล่าช้า การเพิ่ม – ลดรายวิชา การเปลี่ยนกลุ่มรายวิชา และการถอนรายวิชา|เมื่อถึงเวลาของการเพิ่ม – ลด – ถอน – เปลี่ยนกลุ่ม จะปรากฏเมนู “ลงทะเบียนเพิ่ม ลด ถอน เปลี่ยนกลุ่ม”|ตรวจสอบตารางสอนของอาจารย์|ประเมินการเรียนการสอน|ตรวจสอบรายวิชาที่เปิดในแต่ละเทอม|ตรวจสอบปฏิทินการศึกษาในแต่ละเทอม|ตรวจสอบรายวิชาการจบการศึกษา|ตรวจสอบตารางเรียน",
            "image": null,
            "createAt": "2022-07-22 08:39:53",
            "updateAt": "2022-07-22 08:39:53",
            "conent_0": "การลงทะเบียนเรียน ลงทะเบียนเรียนล่าช้า การเพิ่ม – ลดรายวิชา การเปลี่ยนกลุ่มรายวิชา และการถอนรายวิชา",
            "conent_1": "เมื่อถึงเวลาของการเพิ่ม – ลด – ถอน – เปลี่ยนกลุ่ม จะปรากฏเมนู “ลงทะเบียนเพิ่ม ลด ถอน เปลี่ยนกลุ่ม”",
            "conent_2": "ตรวจสอบตารางสอนของอาจารย์",
            "conent_3": "ประเมินการเรียนการสอน",
            "conent_4": "ตรวจสอบรายวิชาที่เปิดในแต่ละเทอม",
            "conent_5": "ตรวจสอบปฏิทินการศึกษาในแต่ละเทอม",
            "conent_6": "ตรวจสอบรายวิชาการจบการศึกษา",
            "conent_7": "ตรวจสอบตารางเรียน"
          },
          {
            "id": "2",
            "title": "ลงทะเบียนมากกว่า 22 หน่วยกิต",
            "sub_title": "ลงทะเบียนมากกว่า 22 หน่วยกิต ต้องทำอย่างไร ?",
            "slung": "registered-credits",
            "content": "สำหรับนักศึกษาระดับปริญญาตรี ที่ใช้ข้อบังคับฯ มทส. พ.ศ. 2566  ไม่มีการกำหนดลงทะเบียนเรียนขั้นต่ำ แต่กำหนดเกณฑ์ให้ลงทะเบียนเรียนได้ไม่เกิน 22 หน่วยกิต และต้องเตรียมการยื่นคำร้องภายใน 10 วันนับจากเปิดภาคการศึกษา ตามขั้นตอนดังนี้|1 ยื่นคำร้องผ่าน reg.sut.ac.th ที่เมนู “ลงทะเบียนเพิ่มลด” ก่อนหมดกำหนดเพิ่มรายวิชา 1 วัน\n\n|2 เลือกรายการ “เพิ่มรายวิชา” หรือ “เปลี่ยนกลุ่ม”\n\n|3 ใส่รหัสวิชา > กด Enter > เลือกกลุ่มเรียน\n\n|4 หากปรากฏข้อความ “ที่นั่งกันสำรองเต็มแล้ว/ไม่มีที่นั่งอื่นเหลือ” ให้ตรวจสอบรายวิชาอีกครั้ง แล้วให้เลือกเมนู “ยื่นคำร้องออนไลน์”\n\n|5 จากนั้น จะปรากฏรายวิชาที่ต้องการลงเพิ่ม/เปลี่ยนกลุ่ม ให้ตรวจสอบอีกครั้ง หากต้องการยื่นคำร้อง ให้เลือกเมนู “ทำรายการ” > ระบุเหตุผล \n\n|6 เมื่อทำรายการเสร็จ ให้นักศึกษาติดตามคำร้อง โดยเลือกเมนู “ติดตามผลขอเพิ่มถอน” และตรวจสอบผลได้ที่เมนู “ผลการลงทะเบียน”|Note\n|1) ให้นักศึกษาตรวจสอบจำนวนที่นั่งคงเหลือในกลุ่มเรียนก่อน หากกลุ่มเต็ม ให้ยื่นคำร้องขอเพิ่มรายวิชา/เปลี่ยนกลุ่ม กรณีกลุ่มเต็ม/ลดรายวิชา (ท.1) \n|2) ตรวจสอบวันเวลาเรียน - เวลาสอบ\n|3) ทั้งนี้การลงทะเบียนเรียนต้องไม่เกิน 28 หน่วยกิต\n|4) นอกจากนี้ หากในภาคการศึกษานั้นไม่มีหน่วยกิตเรียน ต้องดำเนินการลาพักการศึกษา หรือรักษาสถานภาพ",
            "image": null,
            "createAt": "2022-07-22 08:39:53",
            "updateAt": "2022-07-22 08:39:53",
            "conent_0": "สำหรับนักศึกษาระดับปริญญาตรี ที่ใช้ข้อบังคับฯ มทส. พ.ศ. 2566  ไม่มีการกำหนดลงทะเบียนเรียนขั้นต่ำ แต่กำหนดเกณฑ์ให้ลงทะเบียนเรียนได้ไม่เกิน 22 หน่วยกิต และต้องเตรียมการยื่นคำร้องภายใน 10 วันนับจากเปิดภาคการศึกษา ตามขั้นตอนดังนี้",
            "conent_1": "1 ยื่นคำร้องผ่าน reg.sut.ac.th ที่เมนู “ลงทะเบียนเพิ่มลด” ก่อนหมดกำหนดเพิ่มรายวิชา 1 วัน\n\n",
            "conent_2": "2 เลือกรายการ “เพิ่มรายวิชา” หรือ “เปลี่ยนกลุ่ม”\n\n",
            "conent_3": "3 ใส่รหัสวิชา > กด Enter > เลือกกลุ่มเรียน\n\n",
            "conent_4": "4 หากปรากฏข้อความ “ที่นั่งกันสำรองเต็มแล้ว/ไม่มีที่นั่งอื่นเหลือ” ให้ตรวจสอบรายวิชาอีกครั้ง แล้วให้เลือกเมนู “ยื่นคำร้องออนไลน์”\n\n",
            "conent_5": "5 จากนั้น จะปรากฏรายวิชาที่ต้องการลงเพิ่ม/เปลี่ยนกลุ่ม ให้ตรวจสอบอีกครั้ง หากต้องการยื่นคำร้อง ให้เลือกเมนู “ทำรายการ” > ระบุเหตุผล \n\n",
            "conent_6": "6 เมื่อทำรายการเสร็จ ให้นักศึกษาติดตามคำร้อง โดยเลือกเมนู “ติดตามผลขอเพิ่มถอน” และตรวจสอบผลได้ที่เมนู “ผลการลงทะเบียน”",
            "conent_7": "Note\n",
            "conent_8": "1) ให้นักศึกษาตรวจสอบจำนวนที่นั่งคงเหลือในกลุ่มเรียนก่อน หากกลุ่มเต็ม ให้ยื่นคำร้องขอเพิ่มรายวิชา/เปลี่ยนกลุ่ม กรณีกลุ่มเต็ม/ลดรายวิชา (ท.1) \n",
            "conent_9": "2) ตรวจสอบวันเวลาเรียน - เวลาสอบ\n",
            "conent_10": "3) ทั้งนี้การลงทะเบียนเรียนต้องไม่เกิน 28 หน่วยกิต\n",
            "conent_11": "4) นอกจากนี้ หากในภาคการศึกษานั้นไม่มีหน่วยกิตเรียน ต้องดำเนินการลาพักการศึกษา หรือรักษาสถานภาพ"
          },
          {
            "id": "4",
            "title": "ผ่อนผันค่าลงทะเบียน",
            "sub_title": "ขอผ่อนผันค่าลงทะเบียน ต้องทำอย่างไร ?",
            "slung": "registration-fees",
            "content": "ให้นักศึกษาต้องเตรียมการยื่นคำร้องภายใน 11 วันนับจากเปิดภาคการศึกษา ตามขั้นตอนดังนี้\n\n|1 ลงทะเบียนตามปกติ\n\n|2 กรอกข้อมูล เลือกดาวน์โหลดแบบฟอร์ม ท.21 \n\n|3 นำคำร้องให้อาจารย์ที่ปรึกษาพิจารณา และส่งคำร้องที่ฝ่ายทะเบียนนักศึกษา ที่อาคารเรียนรวม 2\n\n|4 ตรวจสอบผลการพิจารณาได้ที่ reg.sut.ac.th ที่เมนู “ภาระค่าใช้จ่ายทุน” ช่อง “วันผ่อนชำระ” จะปรากฏวันที่ได้รับอนุมัติให้ผ่อนผันฯ\n\n|Warning\n|1) หากไม่พบข้อมูลวันผ่อนชำระฯ ให้ติดต่อฝ่ายทะเบียนนักศึกษ อาคารเรียนรวม 2 โทร 0-4422-3016-7\n|2) นักศึกษาที่ได้รับทุนการศึกษา หากรอผลประกาศทุนการศึกษาให้ยื่นคำร้องขอผ่อนผันฯ ทุก 4 สัปดาห์ จนกว่าจะมีประกาศทุนการศึกษาจากมหาวิทยาลัยเทคโนโลยีสุรนารี พร้อมแนบเอกสารเสนอชื่อเพื่อรับทุนมาด้วย",
            "image": null,
            "createAt": "2022-07-22 08:39:53",
            "updateAt": "2022-07-22 08:39:53",
            "conent_0": "ให้นักศึกษาต้องเตรียมการยื่นคำร้องภายใน 11 วันนับจากเปิดภาคการศึกษา ตามขั้นตอนดังนี้\n\n",
            "conent_1": "1 ลงทะเบียนตามปกติ\n\n",
            "conent_2": "2 กรอกข้อมูล เลือกดาวน์โหลดแบบฟอร์ม ท.21 \n\n",
            "conent_3": "3 นำคำร้องให้อาจารย์ที่ปรึกษาพิจารณา และส่งคำร้องที่ฝ่ายทะเบียนนักศึกษา ที่อาคารเรียนรวม 2\n\n",
            "conent_4": "4 ตรวจสอบผลการพิจารณาได้ที่ reg.sut.ac.th ที่เมนู “ภาระค่าใช้จ่ายทุน” ช่อง “วันผ่อนชำระ” จะปรากฏวันที่ได้รับอนุมัติให้ผ่อนผันฯ\n\n",
            "conent_5": "Warning\n",
            "conent_6": "1) หากไม่พบข้อมูลวันผ่อนชำระฯ ให้ติดต่อฝ่ายทะเบียนนักศึกษ อาคารเรียนรวม 2 โทร 0-4422-3016-7\n",
            "conent_7": "2) นักศึกษาที่ได้รับทุนการศึกษา หากรอผลประกาศทุนการศึกษาให้ยื่นคำร้องขอผ่อนผันฯ ทุก 4 สัปดาห์ จนกว่าจะมีประกาศทุนการศึกษาจากมหาวิทยาลัยเทคโนโลยีสุรนารี พร้อมแนบเอกสารเสนอชื่อเพื่อรับทุนมาด้วย"
          },
          {
            "id": "5",
            "title": "การเลือกสาขาวิขา",
            "sub_title": "เลือกสาขาวิชา ต้องทำอย่างไร ?",
            "slung": "branch-selection",
            "content": "1 เข้าระบบ REG \n|ควรเก็บรักษา Username และ Password เป็นความลับส่วนบุคคล\n|!!! หากเกิดข้อผิดพลาด สํานักวิชาฯ จะไม่รับผิดชอบ\n\n|2 เลือกหลักสูตร (สาขาวิชา) ตามที่สนใจ\n|อย่าลืมเรียงลําดับให้ครบทุกหลักสูตรมิฉะนั้นระบบจะไม่บันทึกข้อมูล \n\n|เลือกสาขาวิชาในเวลาที่กําหนด\n|อย่าลืม!! กดยืนยันทุกครั้ง เมื่อเปลี่ยนใจเลือกสาขาอื่น และตรวจสอบการเลือก|สาขา อีกครั้งก่อนหมดเวลา\n\n|ถ้าพบข้อผิดพลาดในการเลือกสาขาวิชา\n|เขียนคําร้อง ท.9 และส่งเอกสารที่สํานักวิชาฯ\n|เลือกดาวน์โหลดแบบฟอร์ม ท.9\n\n|Warning: 1) ประกาศผลก่อนลงทะเบียนเทอมถัดไป 2) การจัดเข้าสาขา พิจารณาจาก Grade Point เท่านั้น ดูวิธีคิด Grade Point 3) Grade Point สูงกว่ามีโอกาสได้สาขาที่อยากเรียนน",
            "image": null,
            "createAt": "2022-07-22 08:39:53",
            "updateAt": "2022-07-22 08:39:53",
            "conent_0": "1 เข้าระบบ REG \n",
            "conent_1": "ควรเก็บรักษา Username และ Password เป็นความลับส่วนบุคคล\n",
            "conent_2": "!!! หากเกิดข้อผิดพลาด สํานักวิชาฯ จะไม่รับผิดชอบ\n\n",
            "conent_3": "2 เลือกหลักสูตร (สาขาวิชา) ตามที่สนใจ\n",
            "conent_4": "อย่าลืมเรียงลําดับให้ครบทุกหลักสูตรมิฉะนั้นระบบจะไม่บันทึกข้อมูล \n\n",
            "conent_5": "เลือกสาขาวิชาในเวลาที่กําหนด\n",
            "conent_6": "อย่าลืม!! กดยืนยันทุกครั้ง เมื่อเปลี่ยนใจเลือกสาขาอื่น และตรวจสอบการเลือก",
            "conent_7": "สาขา อีกครั้งก่อนหมดเวลา\n\n",
            "conent_8": "ถ้าพบข้อผิดพลาดในการเลือกสาขาวิชา\n",
            "conent_9": "เขียนคําร้อง ท.9 และส่งเอกสารที่สํานักวิชาฯ\n",
            "conent_10": "เลือกดาวน์โหลดแบบฟอร์ม ท.9\n\n",
            "conent_11": "Warning: 1) ประกาศผลก่อนลงทะเบียนเทอมถัดไป 2) การจัดเข้าสาขา พิจารณาจาก Grade Point เท่านั้น ดูวิธีคิด Grade Point 3) Grade Point สูงกว่ามีโอกาสได้สาขาที่อยากเรียนน"
          },
          {
            "id": "6",
            "title": "คำนวณเกรด และตัวอย่าง",
            "sub_title": "ขั้นตอนการเข้าใช้โปรแกรมทดสอบเกรด",
            "slung": "calculate-grade",
            "content": "",
            "image": null,
            "createAt": "2022-07-22 08:39:53",
            "updateAt": "2022-07-22 08:39:53",
            "conent_0": ""
          },
          {
            "id": "7",
            "title": "ขอย้ายสาขาวิชา/สำนักวิชา",
            "sub_title": "ถ้าจะขอย้ายสาขาวิชา หรือ เปลี่ยนสำนักวิชา ต้องทำอย่างไร ?",
            "slung": "request-to-move-branch",
            "content": "เขียนคำร้อง ท.11\n|1 ควรเข้าพบหัวหน้าสาขาวิชา โดยด่วนที่สุดหลังการตัดสินใจว่าต้องการย้ายสาขาวิชา เพื่อการทำเกรดให้ตรงตามเกณฑ์การรับเข้าสาขาวิชา ตามที่กำหนด\n\n|2 กรอกข้อมูลในแบบฟอร์ม ท.11 ให้ถูกต้อง ครบถ้วนพร้อมกับแนบใบแสดงผลการศึกษา (Transcript) เลือกดาวน์โหลดแบบฟอร์ม ท.21 \n\n|3 นำคำร้องฯ เสนออาจารย์ที่ปรึกษาให้ความเห็นชอบ\n\n|4 นำคำร้องฯ ที่ได้รับความเห็นชอบจากอาจารย์ที่ปรึกษาแล้ว ส่งที่ฝ่ายทะเบียนนักศึกษา อาคารเรียนรวม 2\n\n         |ตรวจสอบเกณฑ์การย้ายเข้า/ออก ที่นี่\n         |หากเป็นไปตามเกณฑ์\n         |นำคำร้องเข้าพบ อาจารย์ที่ปรึกษาพิจารณา\n|ส่งคำร้องที่ฝ่ายทะเบียนนักศึกษา อาคารเรียนรวม 2\n         |หากไม่เป็นไปตามเกณฑ์ \n         |ยังทำเรื่องย้ายสาขาวิชาฯ ไม่ได้ จนกว่าจะเป็นไปตามเกณฑ์ของสาขาวิชา\n\n         |เมื่อ ท.11 ได้รับอนุมัติแล้ว จะต้องทำตามขั้นตอนดังต่อไปนี้\n|1 ติดต่อรับคำร้องโอนย้ายรายวิชา กรณีย้ายสาขาวิชา ที่ฝ่ายทะเบียนนักศึกษา ภายใน 10 วันนับจากเปิดภาคการศึกษา\n\n|2 นักศึกษาเลือกรายวิชาที่ต้องการโอนย้ายในหมวดเลือกเสรี ดังนี้\n        |กรอกเครื่องหมาย / ในรายวิชาที่ต้องการโอนย้าย\n       |กรอกเครื่องหมาย X ในรายวิชาที่ไม่ต้องการโอนย้าย\n\n|3 นำคำร้องขอโอนย้ายรายวิชา เสนออาจารย์ที่ปรึกษา และหัวหน้าสาขาวิชาพิจารณาอนุมัติ\n\n|4 นำคำร้องที่ผ่านการพิจารณาแล้ว ส่งฝ่ายทะเบียนนักศึกษา\n\n|5 ตรวจสอบการบันทึกรายวิชาที่ไม่โอนย้ายในระบบทะเบียนและประมวลผล",
            "image": null,
            "createAt": "2022-07-22 08:39:53",
            "updateAt": "2022-07-22 08:39:53",
            "conent_0": "เขียนคำร้อง ท.11\n",
            "conent_1": "1 ควรเข้าพบหัวหน้าสาขาวิชา โดยด่วนที่สุดหลังการตัดสินใจว่าต้องการย้ายสาขาวิชา เพื่อการทำเกรดให้ตรงตามเกณฑ์การรับเข้าสาขาวิชา ตามที่กำหนด\n\n",
            "conent_2": "2 กรอกข้อมูลในแบบฟอร์ม ท.11 ให้ถูกต้อง ครบถ้วนพร้อมกับแนบใบแสดงผลการศึกษา (Transcript) เลือกดาวน์โหลดแบบฟอร์ม ท.21 \n\n",
            "conent_3": "3 นำคำร้องฯ เสนออาจารย์ที่ปรึกษาให้ความเห็นชอบ\n\n",
            "conent_4": "4 นำคำร้องฯ ที่ได้รับความเห็นชอบจากอาจารย์ที่ปรึกษาแล้ว ส่งที่ฝ่ายทะเบียนนักศึกษา อาคารเรียนรวม 2\n\n         ",
            "conent_5": "ตรวจสอบเกณฑ์การย้ายเข้า/ออก ที่นี่\n         ",
            "conent_6": "หากเป็นไปตามเกณฑ์\n         ",
            "conent_7": "นำคำร้องเข้าพบ อาจารย์ที่ปรึกษาพิจารณา\n",
            "conent_8": "ส่งคำร้องที่ฝ่ายทะเบียนนักศึกษา อาคารเรียนรวม 2\n         ",
            "conent_9": "หากไม่เป็นไปตามเกณฑ์ \n         ",
            "conent_10": "ยังทำเรื่องย้ายสาขาวิชาฯ ไม่ได้ จนกว่าจะเป็นไปตามเกณฑ์ของสาขาวิชา\n\n         ",
            "conent_11": "เมื่อ ท.11 ได้รับอนุมัติแล้ว จะต้องทำตามขั้นตอนดังต่อไปนี้\n",
            "conent_12": "1 ติดต่อรับคำร้องโอนย้ายรายวิชา กรณีย้ายสาขาวิชา ที่ฝ่ายทะเบียนนักศึกษา ภายใน 10 วันนับจากเปิดภาคการศึกษา\n\n",
            "conent_13": "2 นักศึกษาเลือกรายวิชาที่ต้องการโอนย้ายในหมวดเลือกเสรี ดังนี้\n        ",
            "conent_14": "กรอกเครื่องหมาย / ในรายวิชาที่ต้องการโอนย้าย\n       ",
            "conent_15": "กรอกเครื่องหมาย X ในรายวิชาที่ไม่ต้องการโอนย้าย\n\n",
            "conent_16": "3 นำคำร้องขอโอนย้ายรายวิชา เสนออาจารย์ที่ปรึกษา และหัวหน้าสาขาวิชาพิจารณาอนุมัติ\n\n",
            "conent_17": "4 นำคำร้องที่ผ่านการพิจารณาแล้ว ส่งฝ่ายทะเบียนนักศึกษา\n\n",
            "conent_18": "5 ตรวจสอบการบันทึกรายวิชาที่ไม่โอนย้ายในระบบทะเบียนและประมวลผล"
          },
          {
            "id": "8",
            "title": "สถานภาพ",
            "sub_title": "สถานภาพ",
            "slung": "re-entry",
            "content": "ยกเว้นนักศึกษาแพทยศาสตร์ และทันตแพทยศาสตร์ ให้เป็นไปตามเกณฑ์ข้อบังคับของสำนักวิชา",
            "image": null,
            "createAt": "2022-07-22 08:39:53",
            "updateAt": "2022-07-22 08:39:53",
            "conent_0": "ยกเว้นนักศึกษาแพทยศาสตร์ และทันตแพทยศาสตร์ ให้เป็นไปตามเกณฑ์ข้อบังคับของสำนักวิชา"
          },
          {
            "id": "10",
            "title": "การขอกลับเข้าศึกษาใหม่ RE-ENTRY",
            "sub_title": "การขอกลับเข้าศึกษาใหม่ RE-ENTRY",
            "slung": "retern-entry",
            "content": "ยื่นสมัคร Online ผ่านเว็บรับสมัคร sutgateway.sut.ac.th|นักศึกษาที่ยื่นใบสมัครเพื่อกลับเข้าศึกษาใหม่ ตรวจสอบคุณสมบัติผู้สมัคร โดยดูที่เว็บรับสมัคร  sutgateway.sut.ac.th\n|นักศึกษาต้องไม่เคยได้รับอนุมัติให้กลับเข้าศึกษาใหม่ ในมหาวิทยาลัยมาก่อน|สำนักวิชาฯ จะพิจารณารับนักศึกษาที่ยื่นคำร้องขอกลับเข้าศึกษาใหม่ในสำนักวิชา ที่เลือกสาขาในสำนักวิชาฯ เป็นอันดับ 1 เท่านั้น|ประกาศผลการคัดเลือก|ผู้ผ่านการคัดเลือก อย่าลืมจ่ายค่าธรรมเนียมการขึ้นทะเบียน|Note: Re-entry ได้เพียงครั้งเดียวเท่านั้น|รายงานตัวขึ้นทะเบียนนักศึกษาใหม่ Online ภายในวันที่กำหนดอย่างเคร่งครัด",
            "image": null,
            "createAt": "0000-00-00 00:00:00",
            "updateAt": "0000-00-00 00:00:00",
            "conent_0": "ยื่นสมัคร Online ผ่านเว็บรับสมัคร sutgateway.sut.ac.th",
            "conent_1": "นักศึกษาที่ยื่นใบสมัครเพื่อกลับเข้าศึกษาใหม่ ตรวจสอบคุณสมบัติผู้สมัคร โดยดูที่เว็บรับสมัคร  sutgateway.sut.ac.th\n",
            "conent_2": "นักศึกษาต้องไม่เคยได้รับอนุมัติให้กลับเข้าศึกษาใหม่ ในมหาวิทยาลัยมาก่อน",
            "conent_3": "สำนักวิชาฯ จะพิจารณารับนักศึกษาที่ยื่นคำร้องขอกลับเข้าศึกษาใหม่ในสำนักวิชา ที่เลือกสาขาในสำนักวิชาฯ เป็นอันดับ 1 เท่านั้น",
            "conent_4": "ประกาศผลการคัดเลือก",
            "conent_5": "ผู้ผ่านการคัดเลือก อย่าลืมจ่ายค่าธรรมเนียมการขึ้นทะเบียน",
            "conent_6": "Note: Re-entry ได้เพียงครั้งเดียวเท่านั้น",
            "conent_7": "รายงานตัวขึ้นทะเบียนนักศึกษาใหม่ Online ภายในวันที่กำหนดอย่างเคร่งครัด"
          },
          {
            "id": "11",
            "title": "การทดสอบความรู้ภาษาอังกฤษและการเทียบเคียงผลการสอบ",
            "sub_title": "การทดสอบความรู้ภาษาอังกฤษและการเทียบเคียงผลการสอบ",
            "slung": "test-eng",
            "content": "นักศึกษาระดับปริญญาตรีทุกคนต้องเข้ารับการทดสอบความรู้ความสามารถภาษาอังกฤษด้วยข้อสอบ Oxford Online Placement Test ซึ่งเป็นการสอบด้านการใช้ภาษา (Language Use) และความสามารถด้านการฟัง (Listening Skill)\n|ผลการสอบจะเป็นการจัดระดับตามกรอบมาตรฐานการประเมินความสามารถทางภาษาจากประเทศในกลุ่มสหภาพยุโรป หรือ Common European Framework of Reference for Languages (CEFR) ซึ่งมี 6 ระดับ สรุปสาระสำคัญได้ดังนี้\n|ระดับผู้ใช้ภาษาเบื้องต้น (Basic Language User-A1, A2) \n|A1 ความสามารถทางภาษาที่อยู่ในขอบเขตของความต้องการส่วนตัวและภาษาที่ใช้เป็นลักษณะของภาษาที่ท่องจำมาจากที่เรียน \n|A2 ความสามารถทางภาษาที่สามารถสื่อสารได้ในสถานการณ์ปกติทั่วไปในชีวิตประจำวันหรือสนทนาในหัวข้อที่ตนเองคุ้นเคย \n|ระดับผู้ใช้ภาษาเอกเทศ (Independent Language User-B1, B2) \n|B1 สามารถใช้ภาษาพูดคุยในหัวข้อที่เกี่ยวกับสถานการณ์ทั่วไป ในชีวิตประจำวันได้อย่างมีประสิทธิภาพโดยใช้ภาษาที่ง่าย ๆ ในหัวข้อที่เป็นที่รู้จักดี \n|B2 สามารถใช้ภาษาในการสนทนาให้ข้อมูลและภาษาการสนทนาโต้ตอบอย่างมีประสิทธิภาพรวมถึงการใช้ความรู้และความเข้าใจทางภาษา เพื่อเป็นเครื่องมือในการวางแผนและแก้ไขข้อผิดพลาดของตนเอง\n|C1 สามารถใช้ภาษาในการสนทนาโต้ตอบได้อย่างคล่องแคล่ว และรวดเร็วทันต่อเหตุการณ์ และภาษาที่ใช้จะนำไปสู่การทำงานที่ซับซ้อนที่สำเร็จลุล่วงได้เป็นอย่างดี \n|C2 สามารถใช้ภาษาได้อย่างคล่องแคล่วถูกต้องและเหมาะสมกับสถานการณ์",
            "image": "__PUBLIC_URL__/service-sut/image/Table.png",
            "createAt": "0000-00-00 00:00:00",
            "updateAt": "0000-00-00 00:00:00",
            "conent_0": "นักศึกษาระดับปริญญาตรีทุกคนต้องเข้ารับการทดสอบความรู้ความสามารถภาษาอังกฤษด้วยข้อสอบ Oxford Online Placement Test ซึ่งเป็นการสอบด้านการใช้ภาษา (Language Use) และความสามารถด้านการฟัง (Listening Skill)\n",
            "conent_1": "ผลการสอบจะเป็นการจัดระดับตามกรอบมาตรฐานการประเมินความสามารถทางภาษาจากประเทศในกลุ่มสหภาพยุโรป หรือ Common European Framework of Reference for Languages (CEFR) ซึ่งมี 6 ระดับ สรุปสาระสำคัญได้ดังนี้\n",
            "conent_2": "ระดับผู้ใช้ภาษาเบื้องต้น (Basic Language User-A1, A2) \n",
            "conent_3": "A1 ความสามารถทางภาษาที่อยู่ในขอบเขตของความต้องการส่วนตัวและภาษาที่ใช้เป็นลักษณะของภาษาที่ท่องจำมาจากที่เรียน \n",
            "conent_4": "A2 ความสามารถทางภาษาที่สามารถสื่อสารได้ในสถานการณ์ปกติทั่วไปในชีวิตประจำวันหรือสนทนาในหัวข้อที่ตนเองคุ้นเคย \n",
            "conent_5": "ระดับผู้ใช้ภาษาเอกเทศ (Independent Language User-B1, B2) \n",
            "conent_6": "B1 สามารถใช้ภาษาพูดคุยในหัวข้อที่เกี่ยวกับสถานการณ์ทั่วไป ในชีวิตประจำวันได้อย่างมีประสิทธิภาพโดยใช้ภาษาที่ง่าย ๆ ในหัวข้อที่เป็นที่รู้จักดี \n",
            "conent_7": "B2 สามารถใช้ภาษาในการสนทนาให้ข้อมูลและภาษาการสนทนาโต้ตอบอย่างมีประสิทธิภาพรวมถึงการใช้ความรู้และความเข้าใจทางภาษา เพื่อเป็นเครื่องมือในการวางแผนและแก้ไขข้อผิดพลาดของตนเอง\n",
            "conent_8": "C1 สามารถใช้ภาษาในการสนทนาโต้ตอบได้อย่างคล่องแคล่ว และรวดเร็วทันต่อเหตุการณ์ และภาษาที่ใช้จะนำไปสู่การทำงานที่ซับซ้อนที่สำเร็จลุล่วงได้เป็นอย่างดี \n",
            "conent_9": "C2 สามารถใช้ภาษาได้อย่างคล่องแคล่วถูกต้องและเหมาะสมกับสถานการณ์"
          },
          {
            "id": "12",
            "title": "ศูนย์บริการนักศึกษา",
            "sub_title": "",
            "slung": "service-center",
            "content": "0-4422-3011 ถึง 2|จันทร์ - ศุกร์ | 08.30 - 16.30 น.|http://www.sut.ac.th/ces|ศูนย์บริการการศึกษา มทส. อาคารเรียนรวม 2 111 ถ.มหาวิทยาลัย ต.สุรนารี อ.เมือง จ.นครราชสีมา 30000",
            "image": "__PUBLIC_URL__/service-sut/image/student_comp-01.png",
            "createAt": "0000-00-00 00:00:00",
            "updateAt": "0000-00-00 00:00:00",
            "conent_0": "0-4422-3011 ถึง 2",
            "conent_1": "จันทร์ - ศุกร์ ",
            "conent_2": " 08.30 - 16.30 น.",
            "conent_3": "http://www.sut.ac.th/ces",
            "conent_4": "ศูนย์บริการการศึกษา มทส. อาคารเรียนรวม 2 111 ถ.มหาวิทยาลัย ต.สุรนารี อ.เมือง จ.นครราชสีมา 30000"
          }
        ]
      }
    },
    "table_grade": {
      "code": 200,
      "status": "Get data success",
      "data": [
        {
          "id": "16",
          "grade": "A",
          "point": "4",
          "detail": "ดีเยี่ยม"
        },
        {
          "id": "17",
          "grade": "B+",
          "point": "3.5",
          "detail": "ดีมาก"
        },
        {
          "id": "18",
          "grade": "B",
          "point": "3",
          "detail": "ดี"
        },
        {
          "id": "19",
          "grade": "C+",
          "point": "2.5",
          "detail": "ดีพอใช้"
        },
        {
          "id": "20",
          "grade": "C",
          "point": "2",
          "detail": "พอใช้"
        },
        {
          "id": "21",
          "grade": "D+",
          "point": "1.5",
          "detail": "อ่อน"
        },
        {
          "id": "22",
          "grade": "D",
          "point": "1",
          "detail": "อ่อนมาก"
        },
        {
          "id": "23",
          "grade": "F",
          "point": "-",
          "detail": "ตก"
        },
        {
          "id": "24",
          "grade": "I",
          "point": "-",
          "detail": "การวัดผลไม่สมบรูณ์*"
        },
        {
          "id": "25",
          "grade": "M",
          "point": "-",
          "detail": "นักศึกษาขาดสอบ*"
        },
        {
          "id": "26",
          "grade": "X",
          "point": "-",
          "detail": "ยังไม่ได้รับผลการประเมิน*"
        },
        {
          "id": "27",
          "grade": "P",
          "point": "-",
          "detail": "การสอนยังไม่สิ้นสุด**"
        },
        {
          "id": "28",
          "grade": "W",
          "point": "-",
          "detail": "การถอนรายวิชา"
        },
        {
          "id": "29",
          "grade": "S",
          "point": "-",
          "detail": "ผลการประเมินเป็นที่พอใจ"
        },
        {
          "id": "30",
          "grade": "U",
          "point": "-",
          "detail": "ผลการประเมินไม่เป็นที่พอใจ"
        }
      ]
    },
    "table_retry": {
      "code": 200,
      "status": "Get data success",
      "data": [
        {
          "titel": "ตัวอย่างที่ 1",
          "detail": [
            {
              "id": "1",
              "title": "ภาคการศึกษา",
              "year_1_1": "1",
              "year_1_2": "2",
              "year_1_3": "3",
              "year_2_1": "1",
              "year_2_2": "2",
              "year_2_3": "3"
            },
            {
              "id": "2",
              "title": "GPAX",
              "year_1_1": "0.50",
              "year_1_2": "1.25",
              "year_1_3": "1.50",
              "year_2_1": "1.69",
              "year_2_2": "1.79",
              "year_2_3": "1.79"
            },
            {
              "id": "3",
              "title": "สถานภาพ",
              "year_1_1": "ยังไม่จำแนกสถานภาพ",
              "year_1_2": "ยังไม่จำแนกสถานภาพ",
              "year_1_3": "รอพินิจ ครั้งที่ 1",
              "year_2_1": "รอพินิจ ครั้งที่ 2",
              "year_2_2": "รอพินิจ ครั้งที่ 3",
              "year_2_3": "พ้นสถานภาพ"
            }
          ]
        },
        {
          "titel": "ตัวอย่างที่ 2",
          "detail": [
            {
              "id": "4",
              "title": "ภาคการศึกษา",
              "year_1_1": "1",
              "year_1_2": "2",
              "year_1_3": "3",
              "year_2_1": "1",
              "year_2_2": "2",
              "year_2_3": "3"
            },
            {
              "id": "5",
              "title": "GPAX",
              "year_1_1": "0.50",
              "year_1_2": "1.25",
              "year_1_3": "1.50",
              "year_2_1": "1.69",
              "year_2_2": "1.79",
              "year_2_3": "1.79"
            },
            {
              "id": "6",
              "title": "สถานภาพ",
              "year_1_1": "ยังไม่จำแนกสถานภาพ",
              "year_1_2": "ยังไม่จำแนกสถานภาพ",
              "year_1_3": "รอการพินิจ ครั้งที่ 1",
              "year_2_1": "รอการพินิจ ครั้งที่ 2",
              "year_2_2": "รอการพินิจ ครั้งที่ 3",
              "year_2_3": "พ้นสถานภาพ"
            }
          ]
        }
      ]
    },
    "service": {
      "code": 200,
      "status": "Get data success",
      "data": [
        {
          "id": "8",
          "nameTH": "การขอ E-mail",
          "nameEN": "SUT Mail",
          "image": "__PUBLIC_URL__/service-sut/image/Pic-01.png",
          "createAt": "2022-07-09 03:52:24",
          "updateAt": "2022-07-09 03:52:24",
          "link": "__PUBLIC_URL__/service-sut/file/2025/%e0%b8%81%e0%b8%b2%e0%b8%a3%e0%b9%83%e0%b8%ab%e0%b9%89%e0%b8%9a%e0%b8%a3%e0%b8%b4%e0%b8%81%e0%b8%b2%e0%b8%a3-1-Email-Wifi.pdf",
          "year": "2025"
        },
        {
          "id": "9",
          "nameTH": "การใช้ E-Learning",
          "nameEN": "SUT E-Learning",
          "image": "__PUBLIC_URL__/service-sut/image/Pic-02.png",
          "createAt": "2022-07-09 03:52:24",
          "updateAt": "2022-07-09 03:52:24",
          "link": "https://sites.google.com/g.sut.ac.th/sut-e-learning/student",
          "year": "2025"
        },
        {
          "id": "10",
          "nameTH": "ห้องสมุด",
          "nameEN": "SUT Library",
          "image": "__PUBLIC_URL__/service-sut/image/Pic-03.png",
          "createAt": "2022-07-09 03:54:24",
          "updateAt": "2022-07-09 03:54:24",
          "link": "__PUBLIC_URL__/service-sut/file/2025/%e0%b8%81%e0%b8%b2%e0%b8%a3%e0%b9%83%e0%b8%ab%e0%b9%89%e0%b8%9a%e0%b8%a3%e0%b8%b4%e0%b8%81%e0%b8%b2%e0%b8%a3-3-%e0%b8%9a%e0%b8%a3%e0%b8%a3%e0%b8%93%e0%b8%aa%e0%b8%b2%e0%b8%a3.pdf",
          "year": "2025"
        },
        {
          "id": "11",
          "nameTH": "สถานกีฬาฯ",
          "nameEN": "SUT Sport",
          "image": "__PUBLIC_URL__/service-sut/image/Pic-04.png",
          "createAt": "2022-07-09 03:54:24",
          "updateAt": "2022-07-09 03:54:24",
          "link": "__PUBLIC_URL__/service-sut/image/image_2024/PDF/%E0%B8%81%E0%B8%B2%E0%B8%A3%E0%B9%83%E0%B8%AB%E0%B9%89%E0%B8%9A%E0%B8%A3%E0%B8%B4%E0%B8%81%E0%B8%B2%E0%B8%A3-4-%E0%B8%AA%E0%B8%96%E0%B8%B2%E0%B8%99%E0%B8%81%E0%B8%B5%E0%B8%AC%E0%B8%B2.pdf",
          "year": "2025"
        },
        {
          "id": "12",
          "nameTH": "การรักษาพยาบาล",
          "nameEN": "SUT Hospital",
          "image": "__PUBLIC_URL__/service-sut/image/Pic-05.png",
          "createAt": "2022-07-09 03:54:55",
          "updateAt": "2022-07-09 03:54:55",
          "link": "__PUBLIC_URL__/service-sut/image/image_2024/PDF/%E0%B8%81%E0%B8%B2%E0%B8%A3%E0%B9%83%E0%B8%AB%E0%B9%89%E0%B8%9A%E0%B8%A3%E0%B8%B4%E0%B8%81%E0%B8%B2%E0%B8%A3-5-%E0%B8%81%E0%B8%B2%E0%B8%A3%E0%B8%A3%E0%B8%B1%E0%B8%81%E0%B8%A9%E0%B8%B2%E0%B8%9E%E0%B8%A2%E0%B8%B2%E0%B8%9A%E0%B8%B2%E0%B8%A5.pdf",
          "year": "2025"
        },
        {
          "id": "13",
          "nameTH": "ทุนการศึกษา",
          "nameEN": "SUT Scholarship",
          "image": "__PUBLIC_URL__/service-sut/image/Pic-06.png",
          "createAt": "2022-07-09 03:54:55",
          "updateAt": "2022-07-09 03:54:55",
          "link": "__PUBLIC_URL__/service-sut/file/2025/%e0%b8%81%e0%b8%b2%e0%b8%a3%e0%b9%83%e0%b8%ab%e0%b9%89%e0%b8%9a%e0%b8%a3%e0%b8%b4%e0%b8%81%e0%b8%b2%e0%b8%a3-6-%e0%b8%97%e0%b8%b8%e0%b8%99%e0%b8%81%e0%b8%b2%e0%b8%a3%e0%b8%a8%e0%b8%b6%e0%b8%81%e0%b8%a9%e0%b8%b2.pdf",
          "year": "2025"
        },
        {
          "id": "14",
          "nameTH": "หอพัก",
          "nameEN": "SUT Dormitory",
          "image": "__PUBLIC_URL__/service-sut/image/Pic-07.png",
          "createAt": "2022-07-09 03:55:15",
          "updateAt": "2022-07-09 03:55:15",
          "link": "__PUBLIC_URL__/service-sut/image/image_2024/PDF/%E0%B8%81%E0%B8%B2%E0%B8%A3%E0%B9%83%E0%B8%AB%E0%B9%89%E0%B8%9A%E0%B8%A3%E0%B8%B4%E0%B8%81%E0%B8%B2%E0%B8%A3-7-%E0%B8%AB%E0%B8%AD%E0%B8%9E%E0%B8%B1%E0%B8%81%E0%B8%99%E0%B8%B1%E0%B8%81%E0%B8%A8%E0%B8%B6%E0%B8%81%E0%B8%A9%E0%B8%B2.pdf",
          "year": "2025"
        }
      ]
    }
  },
  "table_gpa": {
    "all": {
      "code": 200,
      "status": "Get data success",
      "data": [
        {
          "id": "1",
          "tableGroup": "1",
          "subjectID": "SCI03 1001",
          "unit": "4",
          "grade": "F=0.0",
          "cout": "4",
          "gradePoint": "0.0 X 4.0 = 0",
          "subject": ""
        },
        {
          "id": "2",
          "tableGroup": "1",
          "subjectID": "SCI05 1191",
          "unit": "1",
          "grade": "D=1.0",
          "cout": "1",
          "gradePoint": "1.0 X 1.0 = 1",
          "subject": ""
        },
        {
          "id": "3",
          "tableGroup": "1",
          "subjectID": "SCI05 1001",
          "unit": "4",
          "grade": "B+=3.5",
          "cout": "4",
          "gradePoint": "3.5 X 4.0 = 14",
          "subject": ""
        },
        {
          "id": "4",
          "tableGroup": "1",
          "subjectID": "IST20 1001",
          "unit": "2",
          "grade": "D=1.0",
          "cout": "2",
          "gradePoint": "1.0 X 2.0 = 2",
          "subject": ""
        },
        {
          "id": "5",
          "tableGroup": "2",
          "subjectID": "SCI03 1001 (Re-Grade)",
          "unit": "4",
          "grade": "B=3.0",
          "cout": "4",
          "gradePoint": "0.0 X 4.0 = 0",
          "subject": ""
        },
        {
          "id": "6",
          "tableGroup": "2",
          "subjectID": "SCI05 1191 (Re-Grade)",
          "unit": "1",
          "grade": "F=0.0",
          "cout": "1",
          "gradePoint": "1.0 X 1.0 = 1",
          "subject": ""
        },
        {
          "id": "7",
          "tableGroup": "2",
          "subjectID": "IST20 1001 (Re-Grade)",
          "unit": "2",
          "grade": "W",
          "cout": "0",
          "gradePoint": "3.5 X 4.0 = 14",
          "subject": ""
        },
        {
          "id": "8",
          "tableGroup": "2",
          "subjectID": "ENG31 1001",
          "unit": "4",
          "grade": "A=4.0",
          "cout": "4",
          "gradePoint": "1.0 X 2.0 = 5",
          "subject": ""
        },
        {
          "id": "9",
          "tableGroup": "2",
          "subjectID": "ENG23 1001",
          "unit": "2",
          "grade": "C+=2.5",
          "cout": "2",
          "gradePoint": "2.5 X 2.0 = 5",
          "subject": ""
        },
        {
          "id": "10",
          "tableGroup": "3",
          "subjectID": "SCI03 1001",
          "unit": "4",
          "grade": "F=0.0",
          "cout": "4",
          "gradePoint": "0.0 X 4.0 = 0",
          "subject": ""
        },
        {
          "id": "11",
          "tableGroup": "3",
          "subjectID": "SCI05 1191",
          "unit": "1",
          "grade": "D=1.0",
          "cout": "1",
          "gradePoint": "1.0 X 1.0 =1",
          "subject": ""
        },
        {
          "id": "12",
          "tableGroup": "3",
          "subjectID": "SCI05 1001",
          "unit": "4",
          "grade": "B+=3.5",
          "cout": "4",
          "gradePoint": "3.5 X 4.0 = 14",
          "subject": ""
        },
        {
          "id": "13",
          "tableGroup": "3",
          "subjectID": "IST20 1001",
          "unit": "2",
          "grade": "D=1.0",
          "cout": "2",
          "gradePoint": "1.0 X 2.0 = 2",
          "subject": ""
        },
        {
          "id": "14",
          "tableGroup": "3",
          "subjectID": "SCI03 1001",
          "unit": "4",
          "grade": "F=0.0",
          "cout": "4",
          "gradePoint": "0.0 X 4.0 = 0",
          "subject": ""
        },
        {
          "id": "15",
          "tableGroup": "3",
          "subjectID": "SCI05 11911",
          "unit": "1",
          "grade": "D=1.0",
          "cout": "1",
          "gradePoint": "1.0 X 1.0 = 1",
          "subject": ""
        },
        {
          "id": "16",
          "tableGroup": "3",
          "subjectID": "SCI05 1001",
          "unit": "4",
          "grade": "B+=3.5",
          "cout": "4",
          "gradePoint": "3.5 X 4.0 = 14",
          "subject": ""
        },
        {
          "id": "17",
          "tableGroup": "3",
          "subjectID": "IST20 1001",
          "unit": "2",
          "grade": "D=1.0",
          "cout": "2",
          "gradePoint": "1.0 X 2.0 = 2",
          "subject": ""
        },
        {
          "id": "18",
          "tableGroup": "3",
          "subjectID": "SCI05 1001",
          "unit": "4",
          "grade": "B+=3.5",
          "cout": "4",
          "gradePoint": "3.5 x 4.0 = 14",
          "subject": ""
        },
        {
          "id": "19",
          "tableGroup": "499",
          "subjectID": "SCI02 1111",
          "unit": "4",
          "grade": "",
          "cout": "0",
          "gradePoint": "",
          "subject": "เคมีพื้นฐาน 1"
        },
        {
          "id": "20",
          "tableGroup": "499",
          "subjectID": "SCI02 1112",
          "unit": "1",
          "grade": "",
          "cout": "0",
          "gradePoint": "",
          "subject": "ปฏิบัติการเคมีพื้นฐาน 1"
        },
        {
          "id": "21",
          "tableGroup": "499",
          "subjectID": "SCI03 1001",
          "unit": "4",
          "grade": "",
          "cout": "0",
          "gradePoint": "",
          "subject": "แคลคูลัส 1"
        },
        {
          "id": "22",
          "tableGroup": "499",
          "subjectID": "IST20 1001",
          "unit": "2",
          "grade": "",
          "cout": "0",
          "gradePoint": "",
          "subject": "การรู้ดิจิทัล"
        },
        {
          "id": "23",
          "tableGroup": "499",
          "subjectID": "IST20 1002",
          "unit": "1",
          "grade": "",
          "cout": "0",
          "gradePoint": "",
          "subject": "การใช้โปรแกรมประยุกต์เพื่อการเรียนรู้"
        },
        {
          "id": "24",
          "tableGroup": "499",
          "subjectID": "IST30 1101",
          "unit": "3",
          "grade": "",
          "cout": "0",
          "gradePoint": "",
          "subject": "ภาษาอังกฤษเพื่อการสื่อสาร 1"
        },
        {
          "id": "25",
          "tableGroup": "499",
          "subjectID": "ENG25 1010",
          "unit": "2",
          "grade": "",
          "cout": "0",
          "gradePoint": "",
          "subject": "การเขียนแบบวิศวกรรม 1"
        },
        {
          "id": "26",
          "tableGroup": "499",
          "subjectID": "SCI03 1002",
          "unit": "4",
          "grade": "",
          "cout": "0",
          "gradePoint": "",
          "subject": "แคลคูลัส 2"
        },
        {
          "id": "27",
          "tableGroup": "499",
          "subjectID": "SCI05 1001",
          "unit": "4",
          "grade": "",
          "cout": "0",
          "gradePoint": "",
          "subject": "ฟิสิกส์ 1"
        },
        {
          "id": "28",
          "tableGroup": "499",
          "subjectID": "SCI05 1191",
          "unit": "1",
          "grade": "",
          "cout": "0",
          "gradePoint": "",
          "subject": "ปฏิบัติการฟิสิกส์ 1"
        },
        {
          "id": "29",
          "tableGroup": "499",
          "subjectID": "IST20 1003",
          "unit": "3",
          "grade": "",
          "cout": "0",
          "gradePoint": "",
          "subject": "ทักษะชีวิต"
        },
        {
          "id": "30",
          "tableGroup": "499",
          "subjectID": "IST30 1102",
          "unit": "3",
          "grade": "",
          "cout": "0",
          "gradePoint": "",
          "subject": "ภาษาอังกฤษเพื่อการสื่อสาร 2"
        },
        {
          "id": "31",
          "tableGroup": "499",
          "subjectID": "ENG23 1001",
          "unit": "1",
          "grade": "",
          "cout": "0",
          "gradePoint": "",
          "subject": "แนะนําาวิชาชีพวิศวกร"
        },
        {
          "id": "32",
          "tableGroup": "499",
          "subjectID": "ENG20 1010",
          "unit": "3",
          "grade": "",
          "cout": "0",
          "gradePoint": "",
          "subject": "การเขียนโปรแกรมคอมพิวเตอร์ 1"
        },
        {
          "id": "33",
          "tableGroup": "499",
          "subjectID": "SCI03 1005",
          "unit": "4",
          "grade": "",
          "cout": "0",
          "gradePoint": "",
          "subject": "แคลคูลัส 3"
        },
        {
          "id": "34",
          "tableGroup": "499",
          "subjectID": "SCI05 1002",
          "unit": "4",
          "grade": "",
          "cout": "0",
          "gradePoint": "",
          "subject": "ฟิสิกส์ 2"
        },
        {
          "id": "35",
          "tableGroup": "499",
          "subjectID": "SCI05 1192",
          "unit": "1",
          "grade": "",
          "cout": "0",
          "gradePoint": "",
          "subject": "ปฏิบัติการฟิสิกส์ 2"
        },
        {
          "id": "36",
          "tableGroup": "499",
          "subjectID": "IST20 1004",
          "unit": "3",
          "grade": "",
          "cout": "0",
          "gradePoint": "",
          "subject": "ความเป็นพลเมืองและพลเมืองโลก"
        },
        {
          "id": "37",
          "tableGroup": "499",
          "subjectID": "ENG31 1001",
          "unit": "2",
          "grade": "",
          "cout": "0",
          "gradePoint": "",
          "subject": "วัสดุวิศวกรรม"
        }
      ]
    },
    "1": {
      "code": 200,
      "status": "Get data success",
      "data": [
        {
          "id": "1",
          "tableGroup": "1",
          "subjectID": "SCI03 1001",
          "unit": "4",
          "grade": "F=0.0",
          "cout": "4",
          "gradePoint": "0.0 X 4.0 = 0",
          "subject": ""
        },
        {
          "id": "2",
          "tableGroup": "1",
          "subjectID": "SCI05 1191",
          "unit": "1",
          "grade": "D=1.0",
          "cout": "1",
          "gradePoint": "1.0 X 1.0 = 1",
          "subject": ""
        },
        {
          "id": "3",
          "tableGroup": "1",
          "subjectID": "SCI05 1001",
          "unit": "4",
          "grade": "B+=3.5",
          "cout": "4",
          "gradePoint": "3.5 X 4.0 = 14",
          "subject": ""
        },
        {
          "id": "4",
          "tableGroup": "1",
          "subjectID": "IST20 1001",
          "unit": "2",
          "grade": "D=1.0",
          "cout": "2",
          "gradePoint": "1.0 X 2.0 = 2",
          "subject": ""
        }
      ]
    },
    "2": {
      "code": 200,
      "status": "Get data success",
      "data": [
        {
          "id": "5",
          "tableGroup": "2",
          "subjectID": "SCI03 1001 (Re-Grade)",
          "unit": "4",
          "grade": "B=3.0",
          "cout": "4",
          "gradePoint": "0.0 X 4.0 = 0",
          "subject": ""
        },
        {
          "id": "6",
          "tableGroup": "2",
          "subjectID": "SCI05 1191 (Re-Grade)",
          "unit": "1",
          "grade": "F=0.0",
          "cout": "1",
          "gradePoint": "1.0 X 1.0 = 1",
          "subject": ""
        },
        {
          "id": "7",
          "tableGroup": "2",
          "subjectID": "IST20 1001 (Re-Grade)",
          "unit": "2",
          "grade": "W",
          "cout": "0",
          "gradePoint": "3.5 X 4.0 = 14",
          "subject": ""
        },
        {
          "id": "8",
          "tableGroup": "2",
          "subjectID": "ENG31 1001",
          "unit": "4",
          "grade": "A=4.0",
          "cout": "4",
          "gradePoint": "1.0 X 2.0 = 5",
          "subject": ""
        },
        {
          "id": "9",
          "tableGroup": "2",
          "subjectID": "ENG23 1001",
          "unit": "2",
          "grade": "C+=2.5",
          "cout": "2",
          "gradePoint": "2.5 X 2.0 = 5",
          "subject": ""
        }
      ]
    },
    "3": {
      "code": 200,
      "status": "Get data success",
      "data": [
        {
          "id": "10",
          "tableGroup": "3",
          "subjectID": "SCI03 1001",
          "unit": "4",
          "grade": "F=0.0",
          "cout": "4",
          "gradePoint": "0.0 X 4.0 = 0",
          "subject": ""
        },
        {
          "id": "11",
          "tableGroup": "3",
          "subjectID": "SCI05 1191",
          "unit": "1",
          "grade": "D=1.0",
          "cout": "1",
          "gradePoint": "1.0 X 1.0 =1",
          "subject": ""
        },
        {
          "id": "12",
          "tableGroup": "3",
          "subjectID": "SCI05 1001",
          "unit": "4",
          "grade": "B+=3.5",
          "cout": "4",
          "gradePoint": "3.5 X 4.0 = 14",
          "subject": ""
        },
        {
          "id": "13",
          "tableGroup": "3",
          "subjectID": "IST20 1001",
          "unit": "2",
          "grade": "D=1.0",
          "cout": "2",
          "gradePoint": "1.0 X 2.0 = 2",
          "subject": ""
        },
        {
          "id": "14",
          "tableGroup": "3",
          "subjectID": "SCI03 1001",
          "unit": "4",
          "grade": "F=0.0",
          "cout": "4",
          "gradePoint": "0.0 X 4.0 = 0",
          "subject": ""
        },
        {
          "id": "15",
          "tableGroup": "3",
          "subjectID": "SCI05 11911",
          "unit": "1",
          "grade": "D=1.0",
          "cout": "1",
          "gradePoint": "1.0 X 1.0 = 1",
          "subject": ""
        },
        {
          "id": "16",
          "tableGroup": "3",
          "subjectID": "SCI05 1001",
          "unit": "4",
          "grade": "B+=3.5",
          "cout": "4",
          "gradePoint": "3.5 X 4.0 = 14",
          "subject": ""
        },
        {
          "id": "17",
          "tableGroup": "3",
          "subjectID": "IST20 1001",
          "unit": "2",
          "grade": "D=1.0",
          "cout": "2",
          "gradePoint": "1.0 X 2.0 = 2",
          "subject": ""
        },
        {
          "id": "18",
          "tableGroup": "3",
          "subjectID": "SCI05 1001",
          "unit": "4",
          "grade": "B+=3.5",
          "cout": "4",
          "gradePoint": "3.5 x 4.0 = 14",
          "subject": ""
        }
      ]
    },
    "499": {
      "code": 200,
      "status": "Get data success",
      "data": [
        {
          "id": "19",
          "tableGroup": "499",
          "subjectID": "SCI02 1111",
          "unit": "4",
          "grade": "",
          "cout": "0",
          "gradePoint": "",
          "subject": "เคมีพื้นฐาน 1"
        },
        {
          "id": "20",
          "tableGroup": "499",
          "subjectID": "SCI02 1112",
          "unit": "1",
          "grade": "",
          "cout": "0",
          "gradePoint": "",
          "subject": "ปฏิบัติการเคมีพื้นฐาน 1"
        },
        {
          "id": "21",
          "tableGroup": "499",
          "subjectID": "SCI03 1001",
          "unit": "4",
          "grade": "",
          "cout": "0",
          "gradePoint": "",
          "subject": "แคลคูลัส 1"
        },
        {
          "id": "22",
          "tableGroup": "499",
          "subjectID": "IST20 1001",
          "unit": "2",
          "grade": "",
          "cout": "0",
          "gradePoint": "",
          "subject": "การรู้ดิจิทัล"
        },
        {
          "id": "23",
          "tableGroup": "499",
          "subjectID": "IST20 1002",
          "unit": "1",
          "grade": "",
          "cout": "0",
          "gradePoint": "",
          "subject": "การใช้โปรแกรมประยุกต์เพื่อการเรียนรู้"
        },
        {
          "id": "24",
          "tableGroup": "499",
          "subjectID": "IST30 1101",
          "unit": "3",
          "grade": "",
          "cout": "0",
          "gradePoint": "",
          "subject": "ภาษาอังกฤษเพื่อการสื่อสาร 1"
        },
        {
          "id": "25",
          "tableGroup": "499",
          "subjectID": "ENG25 1010",
          "unit": "2",
          "grade": "",
          "cout": "0",
          "gradePoint": "",
          "subject": "การเขียนแบบวิศวกรรม 1"
        },
        {
          "id": "26",
          "tableGroup": "499",
          "subjectID": "SCI03 1002",
          "unit": "4",
          "grade": "",
          "cout": "0",
          "gradePoint": "",
          "subject": "แคลคูลัส 2"
        },
        {
          "id": "27",
          "tableGroup": "499",
          "subjectID": "SCI05 1001",
          "unit": "4",
          "grade": "",
          "cout": "0",
          "gradePoint": "",
          "subject": "ฟิสิกส์ 1"
        },
        {
          "id": "28",
          "tableGroup": "499",
          "subjectID": "SCI05 1191",
          "unit": "1",
          "grade": "",
          "cout": "0",
          "gradePoint": "",
          "subject": "ปฏิบัติการฟิสิกส์ 1"
        },
        {
          "id": "29",
          "tableGroup": "499",
          "subjectID": "IST20 1003",
          "unit": "3",
          "grade": "",
          "cout": "0",
          "gradePoint": "",
          "subject": "ทักษะชีวิต"
        },
        {
          "id": "30",
          "tableGroup": "499",
          "subjectID": "IST30 1102",
          "unit": "3",
          "grade": "",
          "cout": "0",
          "gradePoint": "",
          "subject": "ภาษาอังกฤษเพื่อการสื่อสาร 2"
        },
        {
          "id": "31",
          "tableGroup": "499",
          "subjectID": "ENG23 1001",
          "unit": "1",
          "grade": "",
          "cout": "0",
          "gradePoint": "",
          "subject": "แนะนําาวิชาชีพวิศวกร"
        },
        {
          "id": "32",
          "tableGroup": "499",
          "subjectID": "ENG20 1010",
          "unit": "3",
          "grade": "",
          "cout": "0",
          "gradePoint": "",
          "subject": "การเขียนโปรแกรมคอมพิวเตอร์ 1"
        },
        {
          "id": "33",
          "tableGroup": "499",
          "subjectID": "SCI03 1005",
          "unit": "4",
          "grade": "",
          "cout": "0",
          "gradePoint": "",
          "subject": "แคลคูลัส 3"
        },
        {
          "id": "34",
          "tableGroup": "499",
          "subjectID": "SCI05 1002",
          "unit": "4",
          "grade": "",
          "cout": "0",
          "gradePoint": "",
          "subject": "ฟิสิกส์ 2"
        },
        {
          "id": "35",
          "tableGroup": "499",
          "subjectID": "SCI05 1192",
          "unit": "1",
          "grade": "",
          "cout": "0",
          "gradePoint": "",
          "subject": "ปฏิบัติการฟิสิกส์ 2"
        },
        {
          "id": "36",
          "tableGroup": "499",
          "subjectID": "IST20 1004",
          "unit": "3",
          "grade": "",
          "cout": "0",
          "gradePoint": "",
          "subject": "ความเป็นพลเมืองและพลเมืองโลก"
        },
        {
          "id": "37",
          "tableGroup": "499",
          "subjectID": "ENG31 1001",
          "unit": "2",
          "grade": "",
          "cout": "0",
          "gradePoint": "",
          "subject": "วัสดุวิศวกรรม"
        }
      ]
    }
  },
  "institutes": {
    "department-science": {
      "code": 200,
      "status": "Get data success",
      "data": {
        "id": "1",
        "nameTH": "สำนักวิชาวิทยาศาสตร์",
        "nameEN": "Institute of Science",
        "slang": "department-science",
        "image": "__PUBLIC_URL__/service-sut/image/Institute/pic-01.png",
        "createAt": "2022-07-09 03:48:04",
        "updataAt": "2022-07-09 03:48:04",
        "y2025": null,
        "y2024": null,
        "y2023": "__PUBLIC_URL__/service-sut/ebook-freshmen/2566/Institute_of_Science/Institute_of_Science.html",
        "y2022": "__PUBLIC_URL__/service-sut/ebook-freshmen/2565/Institute_of_Science/Institute_of_Science.html",
        "y2021": "__PUBLIC_URL__/service-sut/ebook-freshmen/2564/Institute_of_Science/Institute_of_Science.html",
        "y2020": "__PUBLIC_URL__/service-sut/ebook-freshmen/2563/Institute_of_Science/Institute_of_Science.html",
        "message": {
          "title": "สารจากคณบดี\nศาสตราจารย์ ดร.สันติ แม้นศิริ\n",
          "text": [
            {
              "text_0": "สวัสดีนักศึกษาวิทยาศาสตร์ทุกคน ผมขอเป็นตัวแทนของสำนักวิชาวิทยาศาสตร์ในการต้อนรับพวกเราทุกคนเข้าสู่รั้วมหาวิทยาลัย มทส. ซึ่งเป็นมหาวิทยาลัยที่ติดอันดับหนึ่งในสิบของประเทศไทยจาก World University Ranking Times Higher Education ในสาขาทางด้าน Physical Science ถูกจัดให้เป็นระดับแนวหน้าของประเทศไทย และยังคงพัฒนาไปข้างหน้าอย่างต่อเนื่อง ที่ มทส. พวกเราจะได้เรียนรู้และฝึกฝนทักษะต่าง ๆ ที่สำคัญในการทำงานที่เราชอบ และ เตรียมความพร้อมในการศึกษาต่อในขั้นที่สูงขึ้นไปจากคณาจารย์ที่มีประสบการณ์สูงที่สำเร็จการศึกษามาจากทั่วโลก ในเชิงปฏิบัติการจะมีศูนย์เครื่องมือฯ ที่มีทั้งเครื่องมือพื้นฐานและเครื่องมือขั้นสูงที่ดีเป็นระดับต้น ๆ ของประเทศ รองรับการเรียนการสอนและการวิจัย ทั้งนี้นักศึกษาที่มีความพร้อมยังมีโอกาสไปร่วมงานวิชาการหรือทำวิจัยระยะสั้นในต่างประเทศตั้งแต่ปริญญาตรีได้อีกด้วย นอกจากการเรียนการสอนทางด้านวิทยาศาสตร์ หลักสูตรยังเปิดทางเลือกให้ผู้ที่สนใจสามารถเรียนรู้ศาสตร์ทางด้านความเป็นผู้ประกอบการที่เกี่ยวข้องกับการบริหารทั้งในเชิงธุรกิจและแขนงอื่น ๆ ที่เกี่ยวข้องกับวิทยาศาสตร์ สร้างความเป็นผู้นำและเข้าใจระบบต่าง ๆ ได้ดีขึ้น นอกจากนั้นแล้วมหาวิทยาลัยยังมีพื้นที่ 7,000 ไร่ มีความเป็นมหาวิทยาลัยสีเขียว มีอากาศที่สะอาด มีสถานที่ออกกำลังกายกลางแจ้งและในร่ม มีโรงพยาบาล มทส. คอยดูแลสุขภาพพวกเรา\n\n         ",
              "text_1": "ในท้ายที่สุดนี้ ผมขออวยพรให้พวกเราสามารถค้นหาตัวเองจนพบ มีความสนุกในศาสตร์ที่ชอบ เรียนรู้และฝึกฝนทักษะที่จำเป็น มีสุขภาพกายและจิตที่เข้มแข็ง และสำเร็จการศึกษาเป็นบัณฑิต ที่เป็นทั้งคนดีคนเก่งต่อไป"
            }
          ],
          "image": [
            {
              "image_0": "__PUBLIC_URL__/service-sut/image/2023/department-science/01-Science.png",
              "image_1": "__PUBLIC_URL__/service-sut/image/science/VDO.png",
              "image_2": "__PUBLIC_URL__/service-sut/image/2_Institute/vdo/vdo1-sci.mp4ฅ"
            }
          ]
        },
        "teacher": {
          "title": "ความสำคัญของการเข้าพบอาจารย์ที่ปรึกษา",
          "text": [
            {
              "text_0": "1 ท่านมีมุมมองและวิธีรับมือกับปัญหาอย่างมืออาชีพ\n",
              "text_1": "2 ท่านมีประสบการณ์ที่สั่งสมจากความสำเร็จและความผิดพลาดของนักศึกษารุ่นก่อน\n",
              "text_2": "3 ควรเข้าพบเพื่อวางแผนการเรียนในแต่ละเทอม\n",
              "text_3": "4 ควรหาโอกาสไปพบอาจารย์ที่ปรึกษาเพื่อรับคำแนะนำก่อนวันสุดท้ายของการถอนรายวิชาเมื่อสอบกลางภาคแล้ว\n"
            }
          ],
          "image": [
            {
              "image_0": "__PUBLIC_URL__/service-sut/image/science/photoslide-1.png"
            }
          ]
        },
        "teacher_1": {
          "title": "ความสำคัญของการเข้าพบอาจารย์ที่ปรึกษา",
          "text": [
            {
              "text_0": "ช่องทางการตรวจสอบเวลาว่างของอาจารย์ที่ปรึกษา\n",
              "text_1": "1) ตรวจสอบตารางสอนของอาจารย์ที่ปรึกษา ผ่านระบบ reg.sut.ac.th https://reg.sut.ac.th/\n",
              "text_2": "2) นักศึกษาสามารถ E-mail หาอาจารย์ได้โดยตรงเพื่อขอพบ ดูข้อมูลติดต่อบุคลากรในสำนักวิชาวิทยาศาสตร์ https://www.sut.ac.th/phone/show_dept.php?id=1010000\n",
              "text_3": "3) ค้นหาเบอร์โทรศัพท์ E-mail ของอาจารย์ หรือสาขาวิชาที่อาจารย์สังกัด ดูข้อมูลติดต่อของบุคลากร https://www.sut.ac.th/2012/phone/"
            }
          ],
          "image": [
            {
              "image_0": ""
            }
          ]
        },
        "plane": {
          "title": "การเลือกแผนการศึกษาและการสังกัดสาขา",
          "text": [
            {
              "text_0": "โครงสร้างหลักสูตรวิทยาศาสตรบัณฑิต สาขาวิชาคณิตศาสตร์ เคมี ชีววิทยา และฟิสิกส์ พ.ศ. 2565 / สาขาวิชาจุลชีววิทยา และวิทยาศาสตร์การแพทย์ พ.ศ. 2566 / สาขาวิชาวิทยาศาสตร์คอมพิวเตอร์ พ.ศ. 2566 นักศึกษาสามารถเลือกแผนการศึกษาที่มุ่งเน้นด้านต่าง ๆ เพิ่มเติมจากแผนการศึกษาปกติได้ ดังนี้\n",
              "text_1": "เน้นศึกษาต่อระดับบัณฑิตศึกษา โดยสามารถเลือกศึกษาวิชา ระดับบัณฑิตศึกษาเพิ่มเติม\n",
              "text_2": "เน้นสหกิจศึกษา โดยสามารถเลือกสหกิจศึกษา 1 และ 2 เพิ่มเติม\n",
              "text_3": "เน้นความเป็นผู้ประกอบการ โดยสามารถเลือกศึกษา วิชาทางด้านความเป็นผู้ประกอบการเพิ่มเติม\n",
              "text_4": "Note: สํานักวิชาจะจัดกิจกรรมแนะนำสาขาวิชาต่างๆ ภายในภาคการศึกษาที่ 1 ของชั้นปีที่ 1 และจะให้นักศึกษาทําการเลือกแผนการศึกษาที่สนใจ ในช่วงปลายภาคการศึกษาที่ 2 ของชั้นปีที่ 1 และจะสังกัดสาขาวิชาในชั้นปีที่ 2 ในส่วนของสาขาวิชาวิทยาศาสตร์การกีฬา และสาขาวิชาวิทยาการคอมพิวเตอร์ นักศึกษาได้สังกัดสาขาวิชาตั้งแต่ภาคการศึกษาที่ 1 ของชั้นปีที่ 1",
              "text_5": "เน้นผลิตครู (เฉพาะสาขาคณิตศาสตร์ เคมี ชีววิทยา และฟิสิกส์) เรียนปริญญาตรีวิทยาศาสตร์ 4 ปี + เรียนปริญญาโทศึกษาศาสตร์ 2 ปี = ครู"
            }
          ],
          "image": [
            {
              "image_0": "__PUBLIC_URL__/service-sut/image/science/photo-studyplan-01.png",
              "image_1": "__PUBLIC_URL__/service-sut/image/science/photo-studyplan-02.png",
              "image_2": "__PUBLIC_URL__/service-sut/image/science/photo-studyplan-03.png",
              "image_3": "__PUBLIC_URL__/service-sut/image/image-2023/department-science/01-06-04.png"
            }
          ]
        },
        "result": {
          "title": "ตั้งใจเรียนแล้วได้อะไร ?",
          "text": [
            {
              "text_0": "เกรดเฉลี่ยเกรดเฉลี่ยสะสม 3.50 ขึ้นไป ไม่มี U และ F ไม่เรียนซ้ำเพื่อปรับเกรด D D+ จะได้รับ\n",
              "text_1": "ปริญญาเกียรตินิยมอันดับหนึ่งและเหรียญทองเกียรตินิยม \n",
              "text_2": "หากได้รับปริญญาเกียรตินิยมอันดับหนึ่ง พร้อมทั้งมีแต้มเฉลี่ยสูงสุดในสาขา จะได้รับ\n",
              "text_3": "เข็มทองคำ\n",
              "text_4": "ทุนการศึกษาต่อระดับบัณฑิตศึกษา\n",
              "text_5": "ทุนกิตติบัณฑิต ทุนศักยภาพ\n",
              "text_6": "ทุนเรียนดี เป็นต้น \n",
              "text_7": "เกรดเฉลี่ยสะสม 3.25 ขึ้นไป ไม่มี U และ F ไม่เรียนซ้ำเพื่อปรับเกรด D D+ จะได้รับ ",
              "text_8": "ปริญญาเกียรตินิยมอันดับสอง และเหรียญเงินเกียรตินิยม"
            }
          ],
          "image": [
            {
              "image_0": "__PUBLIC_URL__/service-sut/image/science/IMG_9979.png"
            }
          ]
        },
        "estimate": {
          "title": "ความสำคัญของการประเมินการสอน",
          "text": [
            {
              "text_0": "อาจารย์สามารถปรับปรุงและพัฒนาการสอนในแต่ละวิชาให้มีประสิทธิภาพมากขึ้น",
              "text_1": "วิธีเข้าประเมินการสอน",
              "text_2": "1) Log in : reg.sut.ac.th",
              "text_3": "2) ไปที่เมนู “ประเมินอาจารย์”",
              "text_4": "3) นักศึกษาตอบคำถามในแบบประเมิน และสามารถแสดงความคิดเห็นได้ โดยที่อาจารย์ไม่สามารถเห็นชื่อนักศึกษาที่เข้าประเมินได้",
              "text_5": "4) สามารถเข้าประเมินได้ในสัปดาห์ที่ 6 ถึงสอบปลายภาคการศึกษา"
            }
          ],
          "image": [
            {
              "image_0": "__PUBLIC_URL__/service-sut/image/science/DSC_7531.png"
            }
          ]
        },
        "project": {
          "title": "การทำกิจกรรม/โครงการต้องเตรียมอะไรบ้าง ?",
          "text": [
            {
              "text_0": "ขั้นตอนการกรอกแบบฟอร์มขอจัดกิจกรรมของนักศึกษา",
              "text_1": "1) ร่างโครงการและแบบฟอร์มขอจัดกิจกรรมของนักศึกษาให้เรียบร้อย เพื่อขออนุมัติต่อ รองอธิการบดีฝ่ายกิจการนักศึกษาและศิษย์เก่าสัมพันธ์ (กรณีเป็นกิจกรรมของชมรม) และคณบดีของสำนักวิชา (กรณีเป็นกิจกรรมของสำนักวิชา)",
              "text_2": "2) ติดต่อประสานงานการขอใช้สถานที่หลังจากได้รับอนุมัติ",
              "text_3": "Note: ควรตรวจสอบเรื่องสถานที่ในเบื้องต้นจากหน่วยงานที่ดูแลสถานที่ก่อนว่าว่างหรือไม่"
            }
          ],
          "image": [
            {
              "image_0": "__PUBLIC_URL__/service-sut/image/science/289528060_1472437639869376_7888043661252405211_n.png"
            }
          ],
          "link": [
            {
              "link_0": "https://beta.sut.ac.th/dsa/งานกิจกรรมนักศึกษา/แบบฟอร์มงานกิจกรรมนักศ"
            }
          ]
        },
        "final": {
          "title": "การสิ้นสุดสภาพรับทุนเฉลิมพระเกียรติ 84 พรรษา และทุนศักยบัณทิต",
          "text": [
            {
              "text_0": "นักศึกษาจะสิ้นสุดสภาพรับทุนโดยไม่ต้องชดใช้ทุนที่ได้รับไปแล้ว เมื่อเข้าข่ายข้อใดข้อหนึ่ง ดังนี้ \r\n",
              "text_1": "1) มีแต้มระดับคะแนนเฉลี่ยสะสมเมื่อสิ้นปีการศึกษาต่ำกว่า 3.00",
              "text_2": "2) มีรายวิชาที่ได้รับคะแนนตัวอักษร F หรือ U ",
              "text_3": "3) มีการเรียนซ้ำในรายวิชาใด ๆ เพื่อปรับคะแนน D หรือ D+",
              "text_4": "4) มีระยะเวลาการศึกษาครบตามระยะเวลาการศึกษาของหลักสูตร",
              "text_5": "5) มีความประพฤติเสื่อมเสีย หรือถูกลงโทษทางวินัยถึงขั้นพักการศึกษา",
              "text_6": "Note: ประกาศมหาวิทยาลัยเทคโนโลยีสุรนารี เรื่อง หลักเกณฑ์การให้ทุนการศึกษา เฉลิมพระเกียรติ 84 พรรษา พ.ศ. 2561 และประกาศมหาวิทยาลัยเทคโนโลยีสุรนารี เรื่อง หลักเกณฑ์การให้ทุนการศึกษา มทส. ศักยบัณทิต พ.ศ. 2561"
            }
          ],
          "image": [
            {
              "image_0": "__PUBLIC_URL__/service-sut/image/science/illus-maindata_sci-scholaship-end.png"
            }
          ]
        },
        "advice": {
          "title": "ข้อแนะนำของสำนักวิชาวิทยาศาสตร์",
          "text": [
            {
              "text_0": "เรียน มทส. อย่างไรให้จบตามเวลา ?",
              "text_1": "ความสำคัญของการเข้าพบอาจารย์ที่ปรึกษา",
              "text_2": "การเลือกแผนการศึกษาและการสังกัดสาขา",
              "text_3": "ตั้งใจเรียนแล้วได้อะไร ?",
              "text_4": "การทำกิจกรรม/โครงการต้องเตรียมอะไรบ้าง ?",
              "text_5": "ความสำคัญของการประเมินการสอน",
              "text_6": "การสิ้นสุดสภาพรับทุนเฉลิมพระเกียรติ 84 พรรษา และทุนศักยบัณทิต",
              "text_7": "กิจกรรมนักศึกษา",
              "text_8": "การลงทะเบียนเรียน",
              "text_9": "การคำนวณเกรด",
              "text_10": "ข่าวสารจากคณะประสานงาน",
              "text_11": "ข่าวจากสำนักฯ"
            }
          ],
          "image": [
            {
              "image_0": ""
            }
          ]
        },
        "activity": {
          "title": "กิจกรรมนักศึกษา",
          "text": [
            {
              "text_0": "ในการเพิ่มพูนประสบการณ์ที่มีค่า เพื่อให้น้อง ๆ ได้ฝึกประสบการณ์การบริหารเวลา การรับผิดชอบตัวเอง และการทํางานร่วมกันกับผู้อื่น รวมถึงการส่งเสริมและพัฒนาความเป็นผู้นําของน้อง ๆ ตัวอย่างกิจกรรมนักศึกษาในแต่ละปี\n       ",
              "text_1": "1) จัดกิจกรรมวันสัมภาษณ์น้อง ๆ รอบ Portfolio\n       ",
              "text_2": "2) กิจกรรม Freshy night สำนักวิชาวิทยาศาสตร์\n       ",
              "text_3": "3) การแข่งขันกีฬาน้องใหม่\n       ",
              "text_4": "4) การแข่งขันกีฬาสานสัมพันธ์ สำนักวิทย์\n       ",
              "text_5": "5) เข้าร่วมเป็นส่วนหนึ่งของคณะประสานงานกิจกรรมนักศึกษาสำนักวิทย์ \n       ",
              "text_6": "6) เข้าร่วมชมรมของนักศึกษา เช่น ชมรมเชียร์ลีดเดอร์ ชมรมโรบอท ชมรมการบิน ชมรมหมากกระดาน"
            }
          ],
          "image": [
            {
              "image_0": "__PUBLIC_URL__/service-sut/image/image_2024/Img/01-Sci/08/08-1.jpg",
              "image_1": "__PUBLIC_URL__/service-sut/image/image_2024/Img/01-Sci/08/08-2.jpg",
              "image_2": "__PUBLIC_URL__/service-sut/image/image_2024/Img/01-Sci/08/08-3.jpg"
            }
          ]
        },
        "register": {
          "title": "การลงทะเบียนเรียน",
          "text": [
            {
              "text_0": "และขั้นตอนต่าง ๆ ที่จำเป็นต้องรู้ \nอ่านต่อ http://bulletin.sut.ac.th/enrollment"
            }
          ],
          "image": [
            {
              "image_0": ""
            }
          ]
        },
        "grade": {
          "title": "การคำนวณเกรด",
          "text": [
            {
              "text_0": "และตัวอย่าง\nอ่านต่อ http://bulletin.sut.ac.th/enrollment/calculate-grade"
            }
          ],
          "image": [
            {
              "image_0": ""
            }
          ]
        },
        "news": {
          "title": "ข่าวสารจากคณะประสานงาน",
          "text": [
            {
              "text_0": "ช่องทางติดตามข่าวสารและกิจกรรมต่าง ๆ จากคณะประสานงานวิทยาศาสตร์ มทส.\nติดตามเฟซบุ๊ก https://web.facebook.com/sciencesutstudents"
            }
          ],
          "image": [
            {
              "image_0": ""
            }
          ]
        },
        "news_1": {
          "title": "ข่าวจากสำนักฯ",
          "text": [
            {
              "text_0": "ช่องทางติดตามข่าวประชาสัมพันธ์/กิจกรรม/ทุน จากสำนักวิชาวิทยาศาสตร์\nอ่านต่อ https://science-sut.notion.site/a1cf60801656475dbd280aa657b568dc?pvs=4"
            }
          ],
          "image": [
            {
              "image_0": ""
            }
          ]
        },
        "study": {
          "title": "เรียนอย่างไรให้จบตามเวลา ?",
          "data": [
            {
              "id": "53",
              "courseID": "1",
              "detail": "เราเรียนระบบ 3 เทอม แต่ละเทอมจะมีเพียง 12 สัปดาห์ สิ่งที่ต้องทำให้ได้คือ การแบ่งเวลา เวลาเรียน เวลาเล่น เวลาทำกิจกรรมทำทุกอย่างให้สมดุล\r\n",
              "image": "__PUBLIC_URL__/service-sut/image/science/study/H05-sci-1.png",
              "createAt": "2022-07-22 12:31:34",
              "updataAt": "2022-07-22 12:31:34",
              "year": "2025"
            },
            {
              "id": "54",
              "courseID": "1",
              "detail": "ตั้งใจเข้าเรียนสม่ำเสมอ อาศัยความเพียรและความมุ่งมั่นเป็นที่ตั้ง",
              "image": "__PUBLIC_URL__/service-sut/image/science/study/H05-sci-2.png",
              "createAt": "2022-07-22 12:31:34",
              "updataAt": "2022-07-22 12:31:34",
              "year": "2025"
            },
            {
              "id": "55",
              "courseID": "1",
              "detail": "ทบทวนและฝึกทำการบ้านด้วยตนเอง ไม่ลอกการบ้านใคร “ถ้าไม่เข้าใจให้ไปพบอาจารย์ผู้สอน”",
              "image": "__PUBLIC_URL__/service-sut/image/science/study/H05-sci-3.png",
              "createAt": "2022-07-22 12:31:34",
              "updataAt": "2022-07-22 12:31:34",
              "year": "2025"
            },
            {
              "id": "56",
              "courseID": "1",
              "detail": "พบอาจารย์ที่ปรึกษาอย่างสม่ำเสมอ จะทำให้เราได้ที่พึ่งทั้งการเรียนและการใช้ชีวิต",
              "image": "__PUBLIC_URL__/service-sut/image/science/study/H05-sci-4.png",
              "createAt": "2022-07-22 12:31:34",
              "updataAt": "2022-07-22 12:31:34",
              "year": "2025"
            },
            {
              "id": "57",
              "courseID": "1",
              "detail": "เมื่อใดที่เริ่มตามบทเรียนไม่ทัน ต้องหยุดทำกิจกรรมและมุ่งที่การเรียนก่อน",
              "image": "__PUBLIC_URL__/service-sut/image/science/study/H05-sci-5.png",
              "createAt": "2022-07-22 12:31:34",
              "updataAt": "2022-07-22 12:31:34",
              "year": "2025"
            },
            {
              "id": "58",
              "courseID": "1",
              "detail": "อย่าลืมออกกำลังกายเป็นประจำ ถ้าร่างกายไม่แข็งแรงจะเป็นส่วนสำคัญมากที่จะทำให้ไม่สำเร็จการศึกษา",
              "image": "__PUBLIC_URL__/service-sut/image/science/study/H05-sci-6.png",
              "createAt": "2022-07-22 12:31:34",
              "updataAt": "2022-07-22 12:31:34",
              "year": "2025"
            }
          ]
        },
        "contract": [
          {
            "id": "435",
            "courseID": "1",
            "slang": "science",
            "department": "หลักสูตรสาขาวิชาของสำนักวิชาวิทยาศาสตร์",
            "phone": "",
            "site": "",
            "createAt": "2022-07-30 15:30:05",
            "updateAt": "2022-07-30 15:30:05",
            "year": "2025"
          },
          {
            "id": "436",
            "courseID": "1",
            "slang": "physics",
            "department": "หลักสูตรสาขาวิชาฟิสิกส์",
            "phone": "0-4422-4319,0-4422-4185",
            "site": "http://science.sut.ac.th/curri/major/modules/index.php?name=physics",
            "createAt": "2022-07-16 14:16:34",
            "updateAt": "2022-07-16 14:16:34",
            "year": "2025"
          },
          {
            "id": "437",
            "courseID": "1",
            "slang": "chemical",
            "department": "หลักสูตรสาขาวิชาเคมี",
            "phone": "0-4422-4639,0-4422-4185",
            "site": "http://science.sut.ac.th/curri/major/modules/index.php?name=chem",
            "createAt": "2022-07-16 14:16:34",
            "updateAt": "2023-07-07 14:16:34",
            "year": "2025"
          },
          {
            "id": "438",
            "courseID": "1",
            "slang": "sports-science",
            "department": "หลักสูตรสาขาวิชาวิทยาศาสตร์การกีฬา",
            "phone": "0-4422-4158,0-4422-4185",
            "site": "http://science.sut.ac.th/curri/major/modules/index.php?name=sportsci https://beta.sut.ac.th/is-sport",
            "createAt": "2022-07-16 14:16:34",
            "updateAt": "2022-07-16 14:16:34",
            "year": "2025"
          },
          {
            "id": "439",
            "courseID": "1",
            "slang": "mathematics",
            "department": "หลักสูตรสาขาวิชาคณิตศาสตร์",
            "phone": "0-4422-4626,0-4422-4649",
            "site": "http://science.sut.ac.th/curri/major/modules/index.php?name=math",
            "createAt": "2022-07-16 14:16:34",
            "updateAt": "2022-07-16 14:16:34",
            "year": "2025"
          },
          {
            "id": "440",
            "courseID": "1",
            "slang": "geographical-informatics",
            "department": "หลักสูตรสาขาวิชาวิทยาการข้อมูลและภูมิสารสนเทศประยุกต์",
            "phone": "0-4422-4652,0-4422-4185",
            "site": "http://science.sut.ac.th/curri/major/modules/index.php?name=gi",
            "createAt": "2022-07-16 14:16:34",
            "updateAt": "2022-07-16 14:16:34",
            "year": "2025"
          },
          {
            "id": "441",
            "courseID": "1",
            "slang": "biology",
            "department": "หลักสูตรสาขาวิชาชีววิทยา",
            "phone": "0-4422-4633,0-4422-4185",
            "site": "http://science.sut.ac.th/curri/major/modules/index.php?name=bio",
            "createAt": "2022-07-16 14:16:34",
            "updateAt": "2023-07-07 14:16:34",
            "year": "2025"
          },
          {
            "id": "465",
            "courseID": "1",
            "slang": "micorbiology",
            "department": "หลักสูตรสาขาวิชาจุลชีววิทยา",
            "phone": "",
            "site": "",
            "createAt": "0000-00-00 00:00:00",
            "updateAt": "0000-00-00 00:00:00",
            "year": "2025"
          },
          {
            "id": "466",
            "courseID": "1",
            "slang": "medical-sciences",
            "department": "หลักสูตรสาขาวิชาวิทยาศาสตร์การแพทย์",
            "phone": "",
            "site": "",
            "createAt": "0000-00-00 00:00:00",
            "updateAt": "0000-00-00 00:00:00",
            "year": "2025"
          },
          {
            "id": "467",
            "courseID": "1",
            "slang": "computer-science",
            "department": "หลักสูตรสาขาวิชาวิทยาการคอมพิวเตอร์",
            "phone": "",
            "site": "",
            "createAt": "0000-00-00 00:00:00",
            "updateAt": "0000-00-00 00:00:00",
            "year": "2025"
          }
        ],
        "visitor": 8665,
        "visitor_of_year": 1582
      }
    },
    "department-social": {
      "code": 200,
      "status": "Get data success",
      "data": {
        "id": "2",
        "nameTH": "สำนักวิชาเทคโนโลยีสังคม",
        "nameEN": "Institute of Social Technology",
        "slang": "department-social",
        "image": "__PUBLIC_URL__/service-sut/image/Institute/pic-02.png",
        "createAt": "2022-07-09 03:48:04",
        "updataAt": "2022-07-09 03:48:04",
        "y2025": null,
        "y2024": null,
        "y2023": "__PUBLIC_URL__/service-sut/ebook-freshmen/2566/Institute_of_Social_Technology/Institute_of_Social_Technology.html",
        "y2022": "__PUBLIC_URL__/service-sut/ebook-freshmen/2565/Institute_of_Social_Technology/Institute_of_Social_Technology.html",
        "y2021": "__PUBLIC_URL__/service-sut/ebook-freshmen/2564/Institute_of_Social_Technology/Institute_of_Social_Technology.html",
        "y2020": "__PUBLIC_URL__/service-sut/ebook-freshmen/2563/Institute_of_Social_Technology/Institute_of_Social_Technology.html",
        "message": {
          "title": "สารจากคณบดี\nรองศาสตราจารย์ ดร.อัญชลี วรรณรักษ์",
          "text": [
            {
              "text_0": "สำนักวิชาเทคโนโลยีสังคม มหาวิทยาลัยเทคโนโลยีสุรนารี ขอต้อนรับนักศึกษาปีบทองช่อที่ 33 สู่รั้วแสดทองด้วยความยินดียิ่ง\n            ",
              "text_1": "วันนี้นักศึกษาอาจมีคำถามว่าจะเกิดอะไรกับตัวเองบ้างในสี่ปีข้างหน้า แน่นอนว่าสำหรับบางคน ชีวิตนักศึกษามหาวิทยาลัยอาจแตกต่างอย่างสิ้นเชิงจากชีวิตนักเรียนมัธยม เราอาจไม่มีเพื่อนมาจากโรงเรียนเดียวกันเลย อาจรู้สึกเคว้งคว้างในโลกใบใหม่ ในฐานะที่ครูเป็นส่วนหนึ่งของมหาวิทยาลัย ขอให้ความมั่นใจต่อนักศึกษาว่ามหาวิทยาลัยในทุกภาคส่วนจะพยายามให้นักศึกษาได้รับประสบการณ์การศึกษาที่ดีที่สุด และพัฒนาตนเองไปในทุกมิติที่เป็นไปได้ มหาวิทยาลัยมีคณาจารย์ที่มีประสบการณ์และความเชี่ยวชาญในสาขาวิชาต่างๆ ที่พร้อมในคำแนะนำและสนับสนุนนักศึกษาได้พัฒนาตนเอง ให้มีทักษะการเรียนรู้ตลอดชีวิตและทักษะการใช้ชีวิต สามารถปรับตัวได้ตามสถานการณ์โลกที่เปลี่ยนแปลงไปอย่างรวดเร็ว อาจเป็นไปได้ว่าในบางช่วงของชีวิตนักศึกษาที่มทส. อาจมีปัญหาเข้ามาทดสอบความแข็งแกร่งของเราบ้าง แต่ขอให้มั่นใจว่าคณาจารย์และหน่วยงานต่างๆในมหาวิทยาลัยยินดีที่จะให้คำปรึกษา สนับสนุน เพื่อช่วยให้นักศึกษาสามารถเผชิญกับอุปสรรคและความท้าทายได้อย่างมั่นคง ขอเพียงอย่างเดียวหากนักศึกษาไม่สามารถแก้ปัญหานั้นๆได้ ก็อย่าคิดที่จะเผชิญปัญหาตามลำพัง แต่ขอให้เข้ามาพบอาจารย์ที่ปรึกษา อาจารย์ที่สาขา หรือพี่ๆที่สำนักวิชา ทุกคนพร้อมที่จะช่วยนักศึกษาอย่างเต็มความสามารถ\n            ",
              "text_2": "สุดท้ายนี้ในนามของคณาจารย์และบุคลากรสำนักวิชาเทคโนโลยีสังคม ขอต้อนรับนักศึกษาสู่รั้วแสดทองอีกครั้ง ขอให้นักศึกษาใช้ชีวิตในรั้วมหาวิทยาลัยอย่างมีความสุขและสนุก เก็บเกี่ยวความรู้และประสบการณ์ที่มีคุณค่า เพื่ออนาคตของตนเองและประเทศชาติต่อไป\n"
            }
          ],
          "image": [
            {
              "image_0": "__PUBLIC_URL__/service-sut/image/2023/department-social/02-Social%20Technology.png",
              "image_1": "__PUBLIC_URL__/service-sut/image/2_Institute/vdo/Cover/vdo2-soct-cover.png",
              "image_2": "__PUBLIC_URL__/service-sut/image/2_Institute/vdo/vdo2-soct.mp4"
            }
          ]
        },
        "information": {
          "title": "ข้อมูลทำความรู้จักหลักสูตร",
          "text": [
            {
              "text_0": "หลักสูตรการจัดการบัณฑิต\n",
              "text_1": "หลักสูตรการจัดการบัณฑิต มุ่งเน้นทักษะในศตวรรษที่ 21 ฝึกฝนการเรียนรู้ใช้เทคโนโลยีสมัยใหม่ มีการออกสหกิจศึกษา ปฏิบัติงานในสถานประกอบการจริง 1 ภาคการศึกษา\n\n",
              "text_2": "หลักสูตรการจัดการบัณฑิต สาขาวิชานวัตกรรมเทคโนโลยีอุตสาหกรรมบริการ\n",
              "text_3": "1) หลักสูตรปริญญาตรี 4 ปี\n",
              "text_4": "2) ประกอบด้วยวิชาเกี่ยวกับอุตสาหกรรมบริการทั้ง 4 ด้าน ได้แก่ การท่องเที่ยว การโรงแรม การบิน และไมซ์ (MICE) มุ่งเน้นนวัตกรรมและเทคโนโลยีที่เกี่ยวข้อง ตลอดจนการผนวกทักษะความเป็นผู้ประกอบการ\n",
              "text_5": "3) การเรียนการสอนแบบ Modular Curriculums ที่มีความทันสมัยและครอบคลุมอาชีพในอุตสาหกรรมบริการ\n",
              "text_6": "4) มุ่งเน้นความรู้ภาคทฤษฎีและพัฒนาทักษะผ่านการปฏิบัติจริง\n",
              "text_7": "5) เลือกเรียนชุดวิชาได้อย่างอิสระตามความสนใจในการประกอบอาชีพภายใต้หน่วยกิตที่กำหนด\n",
              "text_8": "6) เลือกเรียนภาษาในกลุ่มวิชาภาษาต่างประเทศเพื่อธุรกิจได้\n",
              "text_9": "7) สอนโดยคณาจารย์ผู้เชี่ยวชาญในอุตสาหกรรมบริการ"
            }
          ],
          "image": [
            {
              "image_0": "__PUBLIC_URL__/service-sut/image/2023/department-social/02-01-01.png",
              "image_1": "__PUBLIC_URL__/service-sut/image/2023/department-social/02-01-02.png",
              "image_2": "__PUBLIC_URL__/service-sut/image/2023/department-social/VDO-1.mp4",
              "image_3": "__PUBLIC_URL__/service-sut/image/2023/department-social/VDO-2.mp4"
            }
          ]
        },
        "occupation": {
          "title": "แนวทางการประกอบอาชีพ",
          "text": [
            {
              "text_0": "หลักสูตรการจัดการบัณฑิต\n",
              "text_1": "อาชีพที่สามารถประกอบได้ คือ อาชีพที่เกี่ยวกับเทคโนโลยีด้านการจัดการ ตามกลุ่มสาขาวิชาเฉพาะ ได้แก่\n         ",
              "text_2": "1. นักการจัดการการตลาด ด้านการบริหารผลิตภัณฑ์ การบริหารลูกค้า การวิเคราะห์ตลาด การวิจัยตลาด การสื่อสารการตลาด การพัฒนาธุรกิจ การขาย และการออกแบบการบริการ\n         ",
              "text_3": "2. นักการจัดการโลจิสติกส์ ด้านการวางแผนจัดการการขนส่งและการ กระจายสินค้า การวิเคราะห์และวางแผนระบบงานโลจิสติกส์ การจัดการนำเข้า-ส่งออกสินค้า การวางแผนและควบคุมสินค้าคงคลัง การจัดหาจัดซื้อ การวาง แผนและควบคุมการผลิต การจัดการคลังสินค้า การจัดการระบบสารสนเทศ ด้านโลจิสติกส์และโซ่อุปทาน การบริการลูกค้า และการจัดการห่วงโซ่อุปทาน\n         ",
              "text_4": "3. นักการจัดการ ที่ใช้องค์ความรู้ความเป็นผู้ประกอบการในการทำงาน ด้านการออกแบบและพัฒนาผลิตภัณฑ์ การวิเคราะห์และพัฒนาธุรกิจ การวิเคราะห์โครงการและการให้สินเชื่อ การวิจัยตลาดและธุรกิจ การให้บริการ ส่งเสริม และสนับสนุนผู้ประกอบการ\n         ",
              "text_5": "4. ผู้ประกอบการธุรกิจ ที่เกี่ยวเนื่องกับการตลาด โลจิสติกส์ และการเป็นผู้สืบทอดธุรกิจครอบครัว\n\n",
              "text_6": "หลักสูตรการจัดการบัณฑิต สาขาวิชานวัตกรรมเทคโนโลยีอุตสาหกรรมบริการ\n",
              "text_7": "แนะนำอาชีพที่สามารถประกอบได้ คือ\n         ",
              "text_8": "1. ด้านการท่องเที่ยว สามารถประกอบอาชีพในธุรกิจนำเที่ยว ได้แก่ การรับจอง, บริการจัดนำเที่ยว, การขายและการตลาด, Data Entry และสามารถทำงานในหน่วยงานภาครัฐในตำแหน่งต่าง ๆ เช่น นักพัฒนาการท่องเที่ยว (กรมการท่องเที่ยว), พนักงานส่งเสริมการท่องเที่ยว (ททท.)\n         ",
              "text_9": "2. ด้านการโรงแรม สามารถประกอบอาชีพในแผนกต่าง ๆ เช่น การดำเนินงานและการจัดการด้านห้องพัก, การดำเนินงานและการจัดการ ด้านอาหารและเครื่องดื่ม, การขายและการตลาดดิจิทัลเพื่อการโรงแรม ระบบการบริหารรายได้และการจัดจำหน่ายออนไลน์, การบริหารงานโรงแรม\n         ",
              "text_10": "3. ด้านการบิน เช่น พนักงานต้อนรับผู้โดยสารภาคพื้น, พนักงานสายการบิน, พนักงานต้อนรับผู้โดยสารบนเครื่องบิน, พนักงานในธุรกิจขนส่งทางอากาศ, พนักงานสำรองที่นั่ง\n         ",
              "text_11": "4. ด้านไมซ์ เช่น นักวางแผนการจัดงาน, เจ้าหน้าที่ประสานงานโครงการ, เจ้าหน้าที่ฝ่ายขาย ในบริษัทวางแผนการจัดงาน เช่น Professional Conference Organizer (PCO), Destination Management Company (DMC), Professional Exhibition/ Event Organizer (PEO)\n         ",
              "text_12": "5. ผู้ประกอบการธุรกิจ การท่องเที่ยว ธุรกิจที่พัก ธุรกิจที่เกี่ยวเนื่องกับการบิน และธุรกิจไมซ์ ที่เน้นเทคโนโลยีและนวัตกรรม"
            }
          ],
          "image": [
            {
              "image_0": "__PUBLIC_URL__/service-sut/image/image_2024/Img/02-SocTech/3-1.jpg",
              "image_1": "__PUBLIC_URL__/service-sut/image/image-2023/department-social/02-03-02.png"
            }
          ]
        },
        "success": {
          "title": "หนทางสู่ความสำเร็จด้านการเรียน",
          "text": [
            {
              "text_0": "1. ตั้งเป้าหมายในการเรียน กำหนดเป้าหมายให้ชัดเจน เรียนไปเพื่ออะไรและต้องทำอย่างไรจึงจะประสบผลสำเร็จตามที่ตั้งไว้ จากนั้นลงมือทำ พัฒนาตนเองไปสู่เป้าหมาย\n",
              "text_1": "2. วางแผนการเรียน จัดระเบียบตนเอง รู้จักการบริการเวลาให้เป็น จึงจะเรียนได้อย่างมีความสุข\n",
              "text_2": "3. เรียนรู้ร่วมกับเพื่อน การมีเพื่อนเรียนช่วยกระตุ้นซึ่งกันและกัน ทำให้กระตือรือร้นกับการเรียนมากขึ้น\n",
              "text_3": "4. ทดสอบตัวเอง ลองฝึกทำควิซ ทำข้อสอบด้วยตัวเอง และฝึกทำซ้ำไปซ้ำมาจนกว่าจะได้ผลลัพธ์ที่พอใจ\n",
              "text_4": "5. สร้างกิจวัตรในการเรียน สภาพแวดล้อมถือเป็นปัจจัยสำคัญอย่างหนึ่งสำหรับการเรียน ลองหาที่ที่เหมาะสมสำหรับตนเองในการทำกิจกรรมนั้น เช่น อ่านหนังสือ ทำการบ้าน\n",
              "text_5": "6. อย่าละเลยในเรื่องสุขภาพ การพักผ่อนให้เพียงพอ ทานอาหารที่มีประโยชน์ จะส่งผลให้สมองปลอดโปร่ง ผ่อนคลาย และพร้อมรับความรู้ใหม่ ๆ ในแต่ละวัน\n",
              "text_6": "7. คิดบวก ทัศนคติคือปัจจัยสำคัญในการเรียน ลองประเมินตนเองว่า มีจุดแข็งอะไรบ้างเพื่อที่จะประสบความสำเร็จในการเรียน นอกจากนี้การคิดบวกยังทำให้เราวิตกกังวลน้อยลงด้วย"
            }
          ],
          "image": [
            {
              "image_0": "__PUBLIC_URL__/service-sut/image/2023/department-social/02-05-01.png"
            }
          ]
        },
        "advice": {
          "title": "ข้อแนะนำของสำนักวิชาเทคโนโลยีสังคม",
          "text": [
            {
              "text_0": "ข้อมูลทำความรู้จักหลักสูตร",
              "text_1": "เรียนอะไรบ้าง ?",
              "text_2": "แนวทางการประกอบอาชีพ",
              "text_3": "เรียนอย่างไรให้จบตามเวลา ?",
              "text_4": "หนทางสู่ความสำเร็จด้านการเรียน",
              "text_5": "ความสำคัญของการเข้าพบอาจารย์ที่ปรึกษา",
              "text_6": "ความสำคัญของการประเมินการสอน",
              "text_7": "นักศึกษาจะต้องทำอย่างไร จึงจะสามารถเรียนเข้ากับระบบการเรียน 3 ภาคการศึกษาได้",
              "text_8": "ถ้านักศึกษาเรียนกับอาจารย์ต่างประเทศและฟังสำเนียงไม่เข้าใจจะต้องทำอย่างไร",
              "text_9": "วิธีการที่ทำให้อ่านหนังสือแล้วมีความสุข",
              "text_10": "กิจกรรมปฏิบัติการที่เกี่ยวข้องกับการเรียน",
              "text_11": "กิจกรรมศึกษาดูงานประจำหลักสูตร",
              "text_12": "กิจกรรมอื่น ๆ ของสาขา"
            }
          ],
          "image": [
            {
              "image_0": ""
            }
          ]
        },
        "teacher": {
          "title": "ความสำคัญของการเข้าพบอาจารย์ที่ปรึกษา",
          "text": [
            {
              "text_0": "1. อาจารย์มีมุมมองและวิธีรับมือกับปัญหาอย่างมืออาชีพ\n",
              "text_1": "2. อาจารย์มีประสบการณ์ที่สั่งสมจากความสำเร็จและความผิดพลาดของนักศึกษารุ่นก่อน\n",
              "text_2": "3. เข้าพบเพื่อวางแผนการเรียนตั้งแต่ต้นเทอม\n",
              "text_3": "4. เข้าพบอาจารย์ที่ปรึกษาเพื่อรับคำแนะนำก่อนวันสุดท้ายของการถอนรายวิชา เมื่อสอบกลางภาคแล้ว\n\n",
              "text_4": "ช่องทางการตรวจสอบเวลาว่างของอาจารย์ที่ปรึกษา\n",
              "text_5": "1) ตรวจสอบตารางสอนของอาจารย์ที่ปรึกษา ผ่านระบบ reg.sut.ac.th\n",
              "text_6": "2) ค้นหาเบอร์โทรศัพท์ E-mail ของอาจารย์ หรือสาขาวิชาที่อาจารย์สังกัด ได้ที่ www.sut.ac.th/2012/phone/\n",
              "text_7": "3) OFFICE HOURS ประจำภาคการศึกษาที่เว็บไซต์หรือ facebook ของสาขาวิชา"
            }
          ],
          "image": [
            {
              "image_0": "__PUBLIC_URL__/service-sut/image/2023/department-social/02-06-01.png"
            }
          ]
        },
        "estimate": {
          "title": "ความสำคัญของการประเมินการสอน",
          "text": [
            {
              "text_0": "1. ช่วยให้อาจารย์ทราบถึงปัญหาที่เกิดจากการสอน เช่น วิธีสอน สื่อที่ใช้ ข้อสอบ เป็นต้น\n",
              "text_1": "2. อาจารย์สามารถปรับปรุงและพัฒนาการสอนในแต่ละวิชาให้มีประสิทธิภาพมากขึ้น\n",
              "text_2": "3. อาจารย์ที่ตั้งใจสอน และได้ผลประเมินดีมากจะได้มีกำลังใจทำเพื่อนักศึกษาต่อไป\n        ",
              "text_3": "วิธีเข้าประเมินการสอน\n        ",
              "text_4": "1)  Log in: reg.sut.ac.th\n        ",
              "text_5": "2) ไปที่เมนู “ประเมินอาจารย์”\n        ",
              "text_6": "3) นักศึกษาตอบคำถามในแบบประเมิน และสามารถแสดงความคิดเห็นได้ โดยที่อาจารย์ ไม่สามารถเห็นชื่อนักศึกษาที่เข้าประเมินได้\n        ",
              "text_7": "4) สามารถเข้าประเมินได้ในสัปดาห์ที่ 6 ถึงสอบปลายภาคการศึกษา"
            }
          ],
          "image": [
            {
              "image_0": "__PUBLIC_URL__/service-sut/image/2023/department-social/02-07-01.png"
            }
          ]
        },
        "q1": {
          "title": "เรียนอะไรบ้าง ?",
          "text": [
            {
              "text_0": "หลักสูตรการจัดการบัณฑิต\n",
              "text_1": "แบ่งออกเป็น 3 กลุ่มวิชาเฉพาะ ดังนี้\n        ",
              "text_2": "1. กลุ่มวิชาเฉพาะ การจัดการโลจิสติกส์การจัดการโลจิสติกส์ จะเกี่ยวกับการวางแผนและ บริหารจัดการตลอดห่วงโซ่อุปทาน (Supply Chain) ของสินค้าและบริการให้มีประสิทธิภาพ ตั้งแต่การจัดซื้อจัดหา การวางแผน การผลิต การจัดการสินค้าคงคลัง การจัดการคลังสินค้า การกระจายสินค้า การจัดการ การจัดการสินค้าคงคลัง การจัดการคลัง สินค้า การกระจายสินค้า การจัดการ การขนส่ง การนำเข้า-ส่งออกจนถึง มือลูกค้า\n        ",
              "text_3": "2. กลุ่มวิชาเฉพาะ การจัดการการตลาด การจัดการการตลาดสมัยใหม่ ที่มุ่งเน้นการวิเคราะห์วิจัยและศึกษาเกี่ยวกับพฤติกรรมผู้บริโภค กลุ่ม ลูกค้าเป้าหมาย การวางแผนและการดำเนินกิจกรรมทางการตลาด การแข่งขันและการจัดการผลิตภัณฑ์และบริการ การจัดการช่องทาง การกระจายสินค้า ตลอดจนการส่งเสริมการตลาดและการขาย รวมถึงการ ตลาดดิจิทัล\n        ",
              "text_4": "3. กลุ่มวิชาเฉพาะ การประกอบการ เน้นกระบวนการสร้างธุรกิจใหม่ ทั้งในฐานะผู้ประกอบการหรือบุคลากรในองค์กร เพื่อตอบสนองต่อโอกาส ทางธุรกิจ การประกอบการหรือบุคลากรในองค์กร เพื่อตอบสนองต่อ โอกาสทางธุรกิจ การประกอบการหรือบุคลากรในองค์กร เพื่อตอบสนอง ต่อโอกาสทางธุรกิจ การออกแบบโครงสร้างการเงินที่เหมาะสม ตลอดจน ศึกษาการพัฒนาของธุรกิจใหม่ และผลกระทบในภาพรวมต่อโครงสร้าง อุตสาหกรรมและเศรษฐกิจในระยะยาว\n\n",
              "text_5": "แผนการเรียน\n      ",
              "text_6": "แผนการศึกษา หลักสูตรการจัดการบัณฑิต (หลักสูตรปรับปรุง พ.ศ. 2568) มีดังนี้\n      ",
              "text_7": "1. แบบวิชาการจัดการ (การจัดการการตลาด การจัดการโลจิสติกส์ หรือการประกอบการ)\n      ",
              "text_8": "2. แบบวิชาการจัดการ (การจัดการการตลาด หรือการจัดการโลจิสติกส์) และวิชาโทความเป็นผู้ประกอบการ\nจำนวนหน่วยกิตรวมตลอดหลักสูตร 174 หน่วยกิต\n\n      ",
              "text_9": "นักศึกษาสามารถเลือกลงกลุ่มวิชาต่างประเทศเพื่อธุรกิจ ตามความสนใจ ของตนเองนักศึกษาจำเป็นต้องเลือกศึกษาเพียงหนึ่งกลุ่มภาษาต่างประเทศ จากทั้งหมดสามกลุ่ม  โดยจะต้องลงทะเบียนเรียนรายวิชาให้ครบทั้ง 15 หน่วยกิตภายในกลุ่มภาษาที่ตนเลือก ทั้งนี้ไม่อนุญาตให้นักศึกษาลงทะเบียน เรียนรายวิชาข้ามกลุ่มแล้วนำหน่วยกิตจากต่างกลุ่มภาษามารวมกัน\n\n",
              "text_10": "หลักสูตรการจัดการบัณฑิต สาขาวิชานวัตกรรมเทคโนโลยีอุตสาหกรรมบริการ\n",
              "text_11": "ผู้เรียนจะได้เรียนรู้เนื้อหาเหล่านี้\n        ",
              "text_12": "1. เนื้อหาและพัฒนาทักษะสำคัญเพื่อการทำงานในอุตสาหกรรมบริการ ในด้านการท่องเที่ยว การโรงแรม การบิน และไมซ์ โดยมุ่งเน้นการ ประยุกต์ใช้เทคโนโลยีและนวัตกรรมในการดำเนินงานและการจัดการ และฝึกปฏิบัติโดยใช้โปรแกรมสำหรับการทำงานจริง เช่น ซอฟต์แวร์ บริหารงานสำหรับธุรกิจท่องเที่ยว (Toursys Asia-Tourism software solutions) ซอฟต์แวร์บริหารงานด้านโรงแรม (ADS Hotel Software) และซอฟต์แวร์อื่น ๆ ที่ใช้สำหรับการทำงานในปัจจุบัน\n        ",
              "text_13": "2. สาขาวิชาได้มีการผนวกทักษะความเป็นผู้ประกอบการ เพื่อเพิ่มโอกาส ในการประกอบอาชีพให้แก่ผู้เรียนในบทบาทการเป็นผู้ประกอบการ\n        ",
              "text_14": "3. สามารถเลือกเรียนภาษาในกลุ่มวิชาภาษาต่างประเทศเพื่อธุรกิจ เพื่อเป็นการเพิ่มทักษะความรู้ด้านภาษาและเพิ่มโอกาสในการทำงานทั้งใน และต่างประเทศ โดยมีให้เลือกทั้งภาษาอังกฤษเพื่อธุรกิจ ภาษาจีน และภาษาญี่ปุ่น"
            }
          ],
          "image": [
            {
              "image_0": "__PUBLIC_URL__/service-sut/image/2023/department-social/02-02-01.png",
              "image_1": "__PUBLIC_URL__/service-sut/image/image-2023/department-social/02-02-02.png"
            }
          ]
        },
        "q1_1": {
          "title": "เรียนอะไรบ้าง ?",
          "text": [
            {
              "text_0": "แผนการเรียน\n      ",
              "text_1": "แผนการศึกษา หลักสูตรการจัดการบัณฑิต (หลักสูตรปรับปรุง พ.ศ. 2563)\n        ",
              "text_2": "1) กลุ่มวิชาเฉพาะ การจัดการโลจิสติกส์การจัดการโลจิสติกส์จะเกี่ยวกับการวางแผนและบริหารจัดการตลอดห่วง\n        ",
              "text_3": "2) แบบวิชาการจัดการ (การตลาด หรือโลจิสติกส์) และวิชาโทความเป็นผู้ประกอบการ\n       ",
              "text_4": "จำนวนหน่วยกิตรวมตลอดหลักสูตร 178 หน่วยกิต\n       ",
              "text_5": "นักศึกษาสามารถเลือกลงกลุ่มวิชาต่างประเทศเพื่อธุรกิจ ตามความสนใจของตนเอง"
            }
          ],
          "image": [
            {
              "image_0": ""
            }
          ]
        },
        "q1_2": {
          "title": "เรียนอะไรบ้าง ?",
          "text": [
            {
              "text_0": "กลุ่มวิชาภาษาต่างประเทศเพื่อธุรกิจ\n",
              "text_1": "ให้ผู้เรียนเลือกศึกษาภาษาต่างประเทศ 1 กลุ่มภาษา จากภาษาต่างประเทศ 3 ภาษา จำนวน 15 หน่วยกิต ดังต่อไปนี้\n\n",
              "text_2": "English for Business\n",
              "text_3": "1) English for Business Correspondence\n",
              "text_4": "2) English for Business Negotiation ",
              "text_5": "3) English for Business Presentation\n",
              "text_6": "4) English for Business Meetings\n",
              "text_7": "5) English for Customer Service\n\n",
              "text_8": "Business Chinese\n",
              "text_9": "1) Chinese I\n",
              "text_10": "2) Chinese II\n",
              "text_11": "3) Chinese III\n",
              "text_12": "4) Business Chinese I\n",
              "text_13": "5) Business Chinese II\n\n",
              "text_14": "Business Japanese\n",
              "text_15": "1) Japanese I\n",
              "text_16": "2) Japanese II\n",
              "text_17": "3) Japanese III\n",
              "text_18": "4) Business Japanese I\n",
              "text_19": "5) Business Japanese II"
            }
          ],
          "image": [
            {
              "image_0": ""
            }
          ]
        },
        "q2": {
          "title": "นักศึกษาจะต้องทำอย่างไร จึงจะสามารถเรียนเข้ากับระบบการเรียน 3 ภาคการศึกษาได้",
          "text": [
            {
              "text_0": "1) ทำความเข้าใจหรือศึกษาถึงลักษณะการเรียนในระบบ 3 ภาคการศึกษาให้เข้าใจและวางแผนการเรียนของตนเองให้เหมาะสมกับจำนวนวิชาที่เรียนในแต่ละภาคการศึกษานั้น ๆ \n",
              "text_1": "2) ต้องมีความพยายาม ความขยัน ตั้งแต่เปิดภาคการศึกษา หมั่นทบทวนรายวิชา\n",
              "text_2": "3) เข้าหาอาจารย์ ปรับพฤติกรรมประจำวันของตนให้เข้ากับระบบกาเรียนให้ได้ จนกว่าตัวเองจะรู้สึกว่าสามารถหาแนวทางการเรียนที่เหมาะสมกับตนเองได้แล้ว เมื่อนั้นนักศึกษาจึงค่อยไปสนใจทำกิจกรรมอื่น ๆ เพื่อเพิ่มประสบการณ์ชีวิตของตนเอง"
            }
          ],
          "image": [
            {
              "image_0": "__PUBLIC_URL__/service-sut/image/2023/department-social/02-08-01.png"
            }
          ]
        },
        "q3": {
          "title": "ถ้านักศึกษาเรียนกับอาจารย์ต่างประเทศและฟังสำเนียงไม่เข้าใจจะต้องทำอย่างไร",
          "text": [
            {
              "text_0": "1) อ่านเอกสารหรือตำราที่เกี่ยวข้องกับบทเรียนนั้น ๆ ไปล่วงหน้า จะช่วยให้เกิดความค้นเคยกับเรื่องที่อาจารย์ผู้นั้นพูดมากขึ้น จะฟังได้รู้เรื่องมากขึ้น\n",
              "text_1": "2) ในขณะฟังให้คิดตามไปด้วย ได้ยินคำใดที่ฟังไม่รู้เรื่อง ให้จดคำนั้นเป็นภาษาไทยมาก่อน โดยจดตามที่ได้ยิน แล้วนำมาทำความเข้าใจภายหลัง\n",
              "text_2": "3) เมื่อกลับมาถึงหอพักแล้ว ให้นำบทบรรยายที่จดมา อ่านทบทวน ทำความเข้าใจอีกทีหนึ่ง หากยังไม่เข้าใจอยู่อีกให้ไปพบอาจารย์ผู้สอนที่ห้องทำงานเพื่อซักถาม\n",
              "text_3": "4) ทำงานที่อาจารย์มอบหมายให้ครบถ้วนเสมอ"
            }
          ],
          "image": [
            {
              "image_0": "__PUBLIC_URL__/service-sut/image/2023/department-social/02-09-01.png"
            }
          ]
        },
        "q4": {
          "title": "วิธีการที่ทำให้อ่านหนังสือแล้วมีความสุข",
          "text": [
            {
              "text_0": "1) ควรเริ่มต้นจากการเตือนตนเองอยู่เป็นประจำว่า สิ่งที่กำลังเรียนนี้ นักศึกษาจะต้องใช้ในการประกอบวิชาชีพในอนาคต เราจึงต้องการความรู้ที่สามารถใช้งานได้จริงเพื่อให้เราทำงานอยู่ได้โดยตลอด\n",
              "text_1": "2) หากนักศึกษาเข้าเรียนโดยสม่ำเสมอ และจดบันทึกคำสอนในชั้นเรียน ผลที่ตามมาคือ นักศึกษาจะเข้าใจรายวิชาดี เมื่อนักศึกษาใช้เวลาว่างอ่านหนังสือตาม นักศึกษาจะพบว่า นักศึกษาเข้าใจรายวิชามากขึ้น นักศึกษาจะพบรายละเอียดที่ฟังไม่ทัน หรือที่อาจารย์ข้ามไป\n",
              "text_2": "3) คุณสมบัติหนึ่งของผู้ที่มีความก้าวหน้าในหน้าที่การงาน คือ เรียนรู้อยู่ตลอดเวลา ซึ่งหากนักศึกษาฝึกฝนตนเองตั้งแต่เป็นนักศึกษา ให้อ่านหนังสือเพื่อเพิ่มพูนความรู้อยู่เสมอ ในแต่ละวันก่อนจะนอนให้ถามตนเองว่า วันนี้ตนเองได้เรียนรู้อะไรใหม่บ้าง นักศึกษาจะพบว่า เมื่ออ่านหนังสือเรียนและพบว่าตนเองเข้าใจวิชามากขึ้น\n",
              "text_3": "4) นักศึกษาจะมีความสุขที่พบว่า นักศึกษาได้เพิ่มพูนความรู้ที่เป็นประโยชน์แก่ตนเองในทุกวันที่ชีวิตดำเนินไป"
            }
          ],
          "image": [
            {
              "image_0": "__PUBLIC_URL__/service-sut/image/2023/department-social/02-10-01.png"
            }
          ]
        },
        "ac_2": {
          "title": "กิจกรรมศึกษาดูงานประจำหลักสูตร",
          "text": [
            {
              "text_0": "เพื่อให้นักศึกษาได้รับความรู้ และได้เปิดมุมมองให้กว้างขึ้น ประสบการณ์และโอกาสที่สามารถนำไปประยุกต์ใช้ ทั้งการเรียนและการทำงานจริงหลักจบการศึกษา"
            }
          ],
          "image": [
            {
              "image_0": "__PUBLIC_URL__/service-sut/image/image_2024/Img/02-SocTech/12/12-1.jpg",
              "image_1": "__PUBLIC_URL__/service-sut/image/image_2024/Img/02-SocTech/12/12-2.jpg",
              "image_2": "__PUBLIC_URL__/service-sut/image/image_2024/Img/02-SocTech/12/12-3.jpg"
            }
          ]
        },
        "ac_3": {
          "title": "กิจกรรมอื่น ๆ ของสาขา",
          "text": [
            {
              "text_0": "กิจกรรมเตรียมความพร้อมปฐมนิเทศนักศึกษาใหม่ และพัฒนา ทักษะชีวิตในมหาวิทยาลัย ของนักศึกษาสำนักวิชาเทคโนโลยีสังคม\n\n",
              "text_1": "กิจกรรมเชื่อมสัมพันธ์ MT & HTI Family Day โดยคณาจารย์ บุคลากร และนักศึกษาเพื่อให้นักศึกษาได้ทำกิจกรรมร่วมกันระหว่างเพื่อน รุ่นพี่ รุ่นน้อง และได้ฝึกทักษา Soft skill การวางแผน การสื่อสาร\n\n",
              "text_2": "กิจกรรมค่ายตามรายวิชาต่าง ๆ ที่มีการฝึกปฏิบัติ สามารถประยุกต์ใช้ความรู้ใน ห้องเรียนไปลงมือปฏิบัติจริง เช่น ค่ายพัฒนาภาวะผู้นำ ค่ายพัฒนาทักษะด้านการประกอบการ\n\n",
              "text_3": "กิจกรรมแนะนำแผนการเรียน, กลุ่มวิชาเฉพาะ (เมเจอร์) และภาษาต่างประเทศเพื่อธุรกิจ เป็นแนวทางในการเลือกแผนการเรียน\n\n",
              "text_4": "กิจกรรม Mini Courses (English Proficiency Exam) ให้นักศึกษาเตรียมความพร้อมสำหรับสอบ CEFR และเพิ่มทักษะทางภาษาอังกฤษ\n\n",
              "text_5": "กิจกรรมพบอาจารย์ที่ปรึกษา"
            }
          ],
          "image": [
            {
              "image_0": "__PUBLIC_URL__/service-sut/image/image_2024/Img/02-SocTech/13/13-1.jpg",
              "image_1": "__PUBLIC_URL__/service-sut/image/image_2024/Img/02-SocTech/13/13-2.jpg",
              "image_2": "__PUBLIC_URL__/service-sut/image/image_2024/Img/02-SocTech/13/13-3.jpg",
              "image_3": "__PUBLIC_URL__/service-sut/image/image_2024/Img/02-SocTech/13/13-4.jpg",
              "image_4": "__PUBLIC_URL__/service-sut/image/image_2024/Img/02-SocTech/13/13-5.jpg",
              "image_5": "__PUBLIC_URL__/service-sut/image/image_2024/Img/02-SocTech/13/13-6.jpg"
            }
          ]
        },
        "ac_1_1": {
          "title": "กิจกรรมปฏิบัติการที่เกี่ยวข้องกับการเรียน",
          "text": [
            {
              "text_0": "ห้องปฏิบัติการด้านการจัดการ (Management Lab: MLab)\n                ",
              "text_1": "ฝึกปฏิบัติ เรียนรู้จากกรณีศึกษา และการปฏิบัติจริงภายใต้การดูแลของคณาจารย์ และผู้ทรงคุณวุฒิที่มีประสบการณ์เฉพาะจากภายนอก ได้รับความรู้และการฝึกปฏิบัติการเกี่ยวกับระบบงาน TPS โดยผู้เชี่ยวชาญด้านระบบ TPS (Toyota production system) จากบริษัท สมบูรณ์ แอ๊ดว๊านซ์ เทคโนโลยี จำกัดมหาชน ฝึกให้นักศึกษาโลจิสติกส์ได้เสริมประสบการณ์ใหม่ ๆ ด้านการวางแผนการผลิตและระบบงานต่าง ๆ"
            }
          ],
          "image": [
            {
              "image_0": "__PUBLIC_URL__/service-sut/image/image_2024/Img/02-SocTech/11/11-1.jpg",
              "image_1": "__PUBLIC_URL__/service-sut/image/image_2024/Img/02-SocTech/11/11-2.jpg",
              "image_2": "__PUBLIC_URL__/service-sut/image/image_2024/Img/02-SocTech/11/11-3.jpg",
              "image_3": "__PUBLIC_URL__/service-sut/image/image_2024/Img/02-SocTech/11/11-4.jpg"
            }
          ]
        },
        "ac_1_2": {
          "title": "กิจกรรมปฏิบัติการที่เกี่ยวข้องกับการเรียน",
          "text": [
            {
              "text_0": "Science and Innovation Park และสถานพัฒนาความเป็นผู้ประกอบการสำหรับนักศึกษา SEDA\n                ",
              "text_1": "สำหรับทดลองฝึกปฏิบัติ และการทำงานจริงในการทำโครงงานหรือการทำธุรกิจ การประกวดแข่งขันทั้งทางด้านการตลาดและการประกอบการ"
            }
          ],
          "image": [
            {
              "image_0": "__PUBLIC_URL__/service-sut/image/image_2024/Img/02-SocTech/11/11-5.jpg",
              "image_1": "__PUBLIC_URL__/service-sut/image/image_2024/Img/02-SocTech/11/11-6.jpg",
              "image_2": "__PUBLIC_URL__/service-sut/image/image_2024/Img/02-SocTech/11/11-7.jpg"
            }
          ]
        },
        "study": {
          "title": "เรียนอย่างไรให้จบตามเวลา ?",
          "data": [
            {
              "id": "86",
              "courseID": "2",
              "detail": "เราเรียนระบบ 3 เทอม แต่ละเทอมจะมีเพียง 12 สัปดาห์ สิ่งที่ต้องทำให้ได้คือ การแบ่งเวลา เวลาเรียน เวลาเล่น เวลาทำกิจกรรมทำทุกอย่างให้สมดุล",
              "image": "__PUBLIC_URL__/service-sut/image/2023/department-social/04-icon/SocTech-04-01.png",
              "createAt": "0000-00-00 00:00:00",
              "updataAt": "0000-00-00 00:00:00",
              "year": "2025"
            },
            {
              "id": "87",
              "courseID": "2",
              "detail": "ตั้งใจเข้าเรียนสม่ำเสมอ อาศัยความเพียรและความมุ่งมั่นเป็นที่ตั้ง",
              "image": "__PUBLIC_URL__/service-sut/image/2023/department-social/04-icon/SocTech-04-02.png",
              "createAt": "0000-00-00 00:00:00",
              "updataAt": "0000-00-00 00:00:00",
              "year": "2025"
            },
            {
              "id": "88",
              "courseID": "2",
              "detail": "ทบทวนและฝึกทำการบ้านด้วยตนเอง ไม่ลอกการบ้านใคร “ถ้าไม่เข้าใจให้ไปพบอาจารย์ผู้สอน”",
              "image": "__PUBLIC_URL__/service-sut/image/2023/department-social/04-icon/SocTech-04-03.png",
              "createAt": "0000-00-00 00:00:00",
              "updataAt": "0000-00-00 00:00:00",
              "year": "2025"
            },
            {
              "id": "89",
              "courseID": "2",
              "detail": "พบอาจารย์ที่ปรึกษาอย่างสม่ำเสมอ จะทำให้เราได้ที่พึ่งทั้งการเรียนและการใช้ชีวิต",
              "image": "__PUBLIC_URL__/service-sut/image/2023/department-social/04-icon/SocTech-04-04.png",
              "createAt": "0000-00-00 00:00:00",
              "updataAt": "0000-00-00 00:00:00",
              "year": "2025"
            },
            {
              "id": "90",
              "courseID": "2",
              "detail": "เมื่อใดที่เริ่มตามบทเรียนไม่ทัน ต้องหยุดทำกิจกรรมและมุ่งที่การเรียนก่อน",
              "image": "__PUBLIC_URL__/service-sut/image/2023/department-social/04-icon/SocTech-04-05.png",
              "createAt": "0000-00-00 00:00:00",
              "updataAt": "0000-00-00 00:00:00",
              "year": "2025"
            },
            {
              "id": "91",
              "courseID": "2",
              "detail": "อย่าลืมออกกำลังกายเป็นประจำ ถ้าร่างกายไม่แข็งแรงจะเป็นส่วนสำคัญมากที่จะทำให้ไม่สำเร็จการศึกษา",
              "image": "__PUBLIC_URL__/service-sut/image/2023/department-social/04-icon/SocTech-04-06.png",
              "createAt": "0000-00-00 00:00:00",
              "updataAt": "0000-00-00 00:00:00",
              "year": "2025"
            }
          ]
        },
        "contract": [
          {
            "id": "442",
            "courseID": "2",
            "slang": "department-social",
            "department": "หลักสูตรสำนักวิชาเทคโนโลยีสังคม",
            "phone": "0 4422 4207-9,0 4422 4205",
            "site": "http://soctech.sut.ac.th",
            "createAt": "2022-07-16 14:20:42",
            "updateAt": "2022-07-16 14:20:42",
            "year": "2025"
          },
          {
            "id": "443",
            "courseID": "2",
            "slang": "management-tectnology",
            "department": "หลักสูตรการจัดการบัณฑิต",
            "phone": "0-4422-4521",
            "site": "http://www.soctech.sut.ac.th/mt",
            "createAt": "2022-07-16 14:20:42",
            "updateAt": "2022-07-16 14:20:42",
            "year": "2025"
          },
          {
            "id": "459",
            "courseID": "2",
            "slang": "management-tectnology-innovation",
            "department": "หลักสูตรการจัดการบัณฑิต สาขาวิชานวัตกรรมเทคโนโลยีอุตสาหกรรมบริการ",
            "phone": "",
            "site": "",
            "createAt": "0000-00-00 00:00:00",
            "updateAt": "0000-00-00 00:00:00",
            "year": "2025"
          }
        ],
        "visitor": 6284,
        "visitor_of_year": 836
      }
    },
    "department-agricultural": {
      "code": 200,
      "status": "Get data success",
      "data": {
        "id": "3",
        "nameTH": "สำนักวิชาเทคโนโลยีการเกษตร",
        "nameEN": "Institute of Agricultural Technology",
        "slang": "department-agricultural",
        "image": "__PUBLIC_URL__/service-sut/image/Institute/pic-03.png",
        "createAt": "2022-07-09 03:48:36",
        "updataAt": "2022-07-09 03:48:36",
        "y2025": null,
        "y2024": null,
        "y2023": "__PUBLIC_URL__/service-sut/ebook-freshmen/2566/Institute_of_Agricultural_Technology/Institute_of_Agricultural_Technology.html",
        "y2022": "__PUBLIC_URL__/service-sut/ebook-freshmen/2565/Institute_of_Agricultural_Technology/Institute_of_Agricultural_Technology.html",
        "y2021": "__PUBLIC_URL__/service-sut/ebook-freshmen/2564/Institute_of_Agricultural_Technology/Institute_of_Agricultural_Technology.html",
        "y2020": "__PUBLIC_URL__/service-sut/ebook-freshmen/2563/Institute_of_Agricultural_Technology/Institute_of_Agricultural_Technology.html",
        "message": {
          "title": "สารจากคณบดี\nศาสตราจารย์ ดร.หนึ่ง เตียอำรุง",
          "text": [
            {
              "text_0": "สวัสดีครับลูก ๆ นักศึกษาสำนักวิชาเทคโนโลยีการเกษตร ในนามของสำนักวิชาเทคโนโลยีการเกษตร ขอต้อนรับลูก ๆ เข้าสู่รั้วมหาวิทยาลัยเทคโนโลยีสุรนารี (มทส.) ด้วยความยินดียิ่ง การก้าวเข้าสู่รั้วมหาวิทยาลัยถือเป็นก้าวที่สำคัญอีกก้าวหนึ่งของชีวิต เป็นก้าวแห่งการเปลี่ยนแปลงในชีวิตจากนักเรียนสู่นักศึกษา จากวัยเด็กเข้าสู่วัยผู้ใหญ่ ซึ่งลูก ๆ ต้องอาศัยและตระหนักถึงความรับผิดชอบในหน้าที่ใหม่ให้เพิ่มมากขึ้น\n\n            ",
              "text_1": "รูปแบบการเรียนการสอนใน มทส. จะแตกต่างจากระบบการเรียนที่ผ่านมา ในระยะเวลาสี่ปีนับจากวันนี้ไป สำนักวิชาเทคโนโลยีการเกษตรจะเป็นสถานที่ฝึกฝนให้ลูก ๆ ทุกคนเป็นผู้มีหลักคิด หลักการทำงานแบบนักวิทยาศาสตร์และเทคโนโลยี รวมถึงการใช้โจทย์ในการใช้ความคิดสร้างสรรค์ตามปรัชญาทางการศึกษาของสำนักวิชาที่กำหนดไว้ว่า “สร้างความเป็นเลิศด้านนวัตกรรมการเกษตรบูรณาการและส่งเสริมความเป็นผู้ประกอบการ เพื่อการพัฒนาอย่างยั่งยืน (Creating Excellent Integrated Agricultural Innovation and Entrepreneurship for Sustainability)” นั่นคือ คิดเป็นระบบ ทำงานอย่างมีขั้นตอนและคิดนอกกรอบ ซึ่งความรู้ความสามารถของลูก ๆ ที่ได้สั่งสมตลอดระยะเวลาการศึกษาในรั้ว มทส. นี้ จะนำพาประเทศให้มีความเจริญก้าวหน้าต่อไป ท้ายนี้ ขออำนวยพรให้ลูก ๆ ทุกคน มีความสุขในการเรียน การใช้ชีวิตในมหาวิทยาลัย จัดสรรเวลาให้เหมาะสมในการเรียน การแสวงหาโอกาสใหม่ ๆ การทำกิจกรรม จนสำเร็จการศึกษาเป็นบัณฑิตที่มีคุณภาพ มีความรู้ ทักษะ เพื่อใช้ในการก้าวเข้าสู่วัยทำงานตามที่ตนเองและครอบครัวมุ่งหวังไว้ทุกคน"
            }
          ],
          "image": [
            {
              "image_0": "__PUBLIC_URL__/service-sut/image/2023/department-agricultural/03-Agricultural%20Technology.png",
              "image_1": "__PUBLIC_URL__/service-sut/image/2_Institute/vdo/Cover/vdo3-agri-cover.png",
              "image_2": "__PUBLIC_URL__/service-sut/image/2_Institute/vdo/vdo3-agri.mp4"
            }
          ]
        },
        "teacher": {
          "title": "ความสำคัญของการเข้าพบอาจารย์ที่ปรึกษา",
          "text": [
            {
              "text_0": "1) อาจารย์มีมุมมองและวิธีรับมือกับปัญหาอย่างมืออาชีพ",
              "text_1": "2) อาจารย์มีประสบการณ์ที่สั่งสมจากความสำเร็จและความผิดพลาดของนักศึกษารุ่นก่อน",
              "text_2": "3) เข้าพบเพื่อวางแผนการเรียนตั้งแต่ต้นเทอม",
              "text_3": "4) เข้าพบอาจารย์ที่ปรึกษาเพื่อรับคำแนะนำก่อนวันสุดท้ายของการถอนรายวิชา เมื่อสอบกลางภาคแล้ว",
              "text_4": "ช่องทางการตรวจสอบเวลาว่างของอาจารย์ที่ปรึกษา",
              "text_5": "1) ตรวจสอบตารางสอนของอาจารย์ที่ปรึกษา ผ่านระบบ reg.sut.ac.th",
              "text_6": "2) ค้นหาเบอร์โทรศัพท์ E-mail ของอาจารย์ หรือสาขาวิชาที่อาจารย์สังกัด ได้ที่ www.sut.ac.th/2012/phone/",
              "text_7": "3) นักศึกษาสามารถ E-mail หาอาจารย์ได้โดยตรงเพื่อขอพบ"
            }
          ],
          "image": [
            {
              "image_0": "__PUBLIC_URL__/service-sut/image/agricultural/Ajan-1.jpg",
              "image_1": "__PUBLIC_URL__/service-sut/image/agricultural/Ajan-2.jpg",
              "image_2": "__PUBLIC_URL__/service-sut/image/agricultural/Ajan-3.jpg"
            }
          ]
        },
        "result": {
          "title": "ตั้งใจเรียนแล้วได้อะไร ?",
          "text": [
            {
              "text_0": "นางสาวชนกนันท์ คำอุ่น",
              "text_1": "ทำให้เรามีเกรดเฉลี่ยที่ดี ทำให้พ่อแม่และครอบครัวภาคภูมิใจ อีกทั้งยังสามารถสอบชิงทุนการศึกษาให้แก่ตัวเองและเพื่อช่วยพ่อแม่ลดค่าใช้จ่ายในการเรียนได้",
              "text_2": "นายสิทธิพงษ์ รักงาม",
              "text_3": "เพื่อสร้างโอกาสให้กับตนเอง เพื่อให้ได้ความรู้ รวมถึงเพื่อให้เป็นที่ชมเชยและได้รับการยอมรับจากสังคม เพื่อทำให้เกิดแรงบัลดาลใจในการขับเคลื่อนสู่ปลายทางแห่งความสำเร็จดังที่ตั้งไว้ และเป็นใบเบิกทางให้มีหน้าที่การงานที่ดีในอนาคต",
              "text_4": "เกรดเฉลี่ยสะสม 3.50 ขึ้นไป ไม่มี U และ F ไม่เรียนซ้ำเพื่อปรับเกรด D D+ จะได้รับ",
              "text_5": "ปริญญาเกียรตินิยมอันดับหนึ่งและเหรียญทองเกียรตินิยม และหากได้รับปริญญาเกียรตินิยมอันดับหนึ่ง พร้อมทั้งมีแต้มเฉลี่ยสูงสุดในสาขา จะได้รับ",
              "text_6": "เข็มทองคำ",
              "text_7": "ทุนการศึกษาต่อระดับบัณฑิตศึกษา",
              "text_8": "ทุนกิตติบัณฑิต ทุนศักยภาพ",
              "text_9": "ทุนเรียนดี เป็นต้น",
              "text_10": "เกรดเฉลี่ยสะสม 3.25 ขึ้นไป ไม่มี U และ F ไม่เรียนซ้ำเพื่อปรับเกรด D D+ จะได้รับ",
              "text_11": "ปริญญาเกียรตินิยมอันดับสอง และเหรียญเงินเกียรตินิยม"
            }
          ],
          "image": [
            {
              "image_0": "__PUBLIC_URL__/service-sut/image/agricultural/Gradu.png",
              "image_1": "__PUBLIC_URL__/service-sut/image/agricultural/Gradu2-2.jpg"
            }
          ]
        },
        "estimate": {
          "title": "ความสำคัญของการประเมินการสอน",
          "text": [
            {
              "text_0": "1) ช่วยให้อาจารย์ทราบถึงปัญหาที่เกิดจากการสอน เช่น วิธีสอน สื่อที่ใช้ ข้อสอบ เป็นต้น",
              "text_1": "2) อาจารย์สามารถปรับปรุงและพัฒนาการสอนในแต่ละวิชาให้มีประสิทธิภาพมากขึ้น",
              "text_2": "3) อาจารย์ที่ตั้งใจสอน และได้ผลประเมินดีมากจะได้มีกำลังใจทำเพื่อนักศึกษาต่อไป",
              "text_3": "วิธีเข้าประเมินการสอน",
              "text_4": "1 Log in: reg.sut.ac.th",
              "text_5": "2 ไปที่เมนู “ประเมินอาจารย์”",
              "text_6": "3 นักศึกษาตอบคำถามในแบบประเมิน และสามารถแสดงความคิดเห็นได้ โดยที่อาจารย์ ไม่สามารถเห็นชื่อนักศึกษาที่เข้าประเมินได้",
              "text_7": "4 สามารถเข้าประเมินได้ในสัปดาห์ที่ 6 ถึงสอบปลายภาคการศึกษา"
            }
          ],
          "image": [
            {
              "image_0": "__PUBLIC_URL__/service-sut/image/agricultural/Evalua-1.jpg",
              "image_1": "__PUBLIC_URL__/service-sut/image/agricultural/Evalua-2.jpg",
              "image_2": "__PUBLIC_URL__/service-sut/image/agricultural/Evalua-3.jpg"
            }
          ]
        },
        "project": {
          "title": "การทำกิจกรรม/โครงการต้องเตรียมอะไรบ้าง ?",
          "text": [
            {
              "text_0": "ขั้นตอนการกรอกแบบฟอร์มขอจัดกิจกรรมของนักศึกษา",
              "text_1": "1) ร่างโครงการและแบบฟอร์มขอจัดกิจกรรมของนักศึกษาให้เรียบร้อย เพื่อขออนุมัติต่อ รองอธิการบดีฝ่ายกิจการนักศึกษาและศิษย์เก่าสัมพันธ์ (กรณีเป็นกิจกรรมของชมรม) และคณบดีของสำนักวิชา (กรณีเป็นกิจกรรมของสำนักวิชา)",
              "text_2": "2) ติดต่อประสานงานการขอใช้สถานที่หลังจากได้รับอนุมัติ",
              "text_3": "Note: ควรตรวจสอบเรื่องสถานที่ในเบื้องต้นจากหน่วยงานที่ดูแลสถานที่ก่อนว่าว่างหรือไม่"
            }
          ],
          "image": [
            {
              "image_0": "__PUBLIC_URL__/service-sut/image/agricultural/Activity_1.png",
              "image_1": "__PUBLIC_URL__/service-sut/image/agricultural/Activity_2.png",
              "image_2": "__PUBLIC_URL__/service-sut/image/agricultural/Activity_3.png"
            }
          ],
          "link": [
            {
              "link_0": "https://beta.sut.ac.th/dsa/งานกิจกรรมนักศึกษา/แบบฟอร์มงานกิจกรรมนักศ"
            }
          ]
        },
        "advice": {
          "title": "ข้อแนะนำของสำนักวิชาเทคโนโลยีการเกษตร",
          "text": [
            {
              "text_0": "เรียน มทส. อย่างไรให้จบตามเวลา ?",
              "text_1": "ความสำคัญของการเข้าพบอาจารย์ที่ปรึกษา",
              "text_2": "ตั้งใจเรียนแล้วได้อะไร ?",
              "text_3": "ความสำคัญของการประเมินการสอน",
              "text_4": "การทำกิจกรรม/โครงการต้องเตรียมอะไรบ้าง ?"
            }
          ],
          "image": [
            {
              "image_0": ""
            }
          ]
        },
        "study": {
          "title": "เรียนอย่างไรให้จบตามเวลา ?",
          "data": [
            {
              "id": "59",
              "courseID": "3",
              "detail": "เราเรียนระบบ 3 เทอม แต่ละเทอมจะมีเพียง 12 สัปดาห์ สิ่งที่ต้องทำให้ได้คือ การแบ่งเวลา เวลาเรียน เวลาเล่น เวลาทำกิจกรรมทำทุกอย่างให้สมดุล",
              "image": "__PUBLIC_URL__/service-sut/image/agricultural/H05-agri-1.png",
              "createAt": "2022-07-22 17:13:46",
              "updataAt": "2022-07-22 17:13:46",
              "year": "2025"
            },
            {
              "id": "60",
              "courseID": "3",
              "detail": "ตั้งใจเข้าเรียนสม่ำเสมอ อาศัยความเพียรและความมุ่งมั่นเป็นที่ตั้ง",
              "image": "__PUBLIC_URL__/service-sut/image/agricultural/H05-agri-2.png",
              "createAt": "2022-07-22 17:13:46",
              "updataAt": "2022-07-22 17:13:46",
              "year": "2025"
            },
            {
              "id": "61",
              "courseID": "3",
              "detail": "ทบทวนและฝึกทำการบ้านด้วยตนเอง ไม่ลอกการบ้านใคร “ถ้าไม่เข้าใจให้ไปพบอาจารย์ผู้สอน”",
              "image": "__PUBLIC_URL__/service-sut/image/agricultural/H05-agri-3.png",
              "createAt": "2022-07-22 17:13:46",
              "updataAt": "2022-07-22 17:13:46",
              "year": "2025"
            },
            {
              "id": "62",
              "courseID": "3",
              "detail": "พบอาจารย์ที่ปรึกษาอย่างสม่ำเสมอ จะทำให้เราได้ที่พึ่งทั้งการเรียนและการใช้ชีวิต",
              "image": "__PUBLIC_URL__/service-sut/image/agricultural/H05-agri-4.png",
              "createAt": "2022-07-22 17:13:46",
              "updataAt": "2022-07-22 17:13:46",
              "year": "2025"
            },
            {
              "id": "63",
              "courseID": "3",
              "detail": "เมื่อใดที่เริ่มตามบทเรียนไม่ทัน ต้องหยุดทำกิจกรรมและมุ่งที่การเรียนก่อน",
              "image": "__PUBLIC_URL__/service-sut/image/agricultural/H05-agri-5.png",
              "createAt": "2022-07-22 17:13:46",
              "updataAt": "2022-07-22 17:13:46",
              "year": "2025"
            },
            {
              "id": "64",
              "courseID": "3",
              "detail": "อย่าลืมออกกำลังกายเป็นประจำ ถ้าร่างกายไม่แข็งแรงจะเป็นส่วนสำคัญมากที่จะทำให้ไม่สำเร็จการศึกษา",
              "image": "__PUBLIC_URL__/service-sut/image/agricultural/H05-agri-6.png",
              "createAt": "2022-07-22 17:13:46",
              "updataAt": "2022-07-22 17:13:46",
              "year": "2025"
            }
          ]
        },
        "contract": [
          {
            "id": "444",
            "courseID": "3",
            "slang": "",
            "department": "สาขาวิชา/หลักสูตรของสำนักวิชาเทคโนโลยีการเกษตร",
            "phone": "0 4422 4356,0 4422 4150",
            "site": "",
            "createAt": "2022-07-16 14:22:28",
            "updateAt": "2022-07-16 14:22:28",
            "year": "2025"
          },
          {
            "id": "445",
            "courseID": "3",
            "slang": "crop-production-technology",
            "department": "สาขาวิชาเทคโนโลยีการผลิตพืช\r\n",
            "phone": "0 4422 4202, 4204,0 4422 4281",
            "site": "",
            "createAt": "2022-07-16 14:22:28",
            "updateAt": "2022-07-16 14:22:28",
            "year": "2025"
          },
          {
            "id": "446",
            "courseID": "3",
            "slang": "animal-technology-and-innovation",
            "department": "สาขาวิชาเทคโนโลยีและนวัตกรรมทางสัตว์",
            "phone": "0 4422 4378,0 4422 4376",
            "site": "",
            "createAt": "2022-07-16 14:22:28",
            "updateAt": "2022-07-16 14:22:28",
            "year": "2025"
          },
          {
            "id": "447",
            "courseID": "3",
            "slang": "food-technology",
            "department": "สาขาวิชาเทคโนโลยีอาหาร",
            "phone": "0 4422 4240, 4233,0 4422 4150",
            "site": "",
            "createAt": "2022-07-16 14:22:28",
            "updateAt": "2022-07-16 14:22:28",
            "year": "2025"
          },
          {
            "id": "462",
            "courseID": "3",
            "slang": "technology-program-in-innovative-agripreneur",
            "department": "หลักสูตรเทคโนโลยีบัณฑิตสาขาวิชาผู้ประกอบการเกษตรเชิงนวัตกรรม (หลักสูตรนานาชาติ)",
            "phone": "",
            "site": "",
            "createAt": "0000-00-00 00:00:00",
            "updateAt": "0000-00-00 00:00:00",
            "year": "2025"
          }
        ],
        "visitor": 1459,
        "visitor_of_year": 251
      }
    },
    "department-engineering": {
      "code": 200,
      "status": "Get data success",
      "data": {
        "id": "4",
        "nameTH": "สำนักวิชาวิศวกรรมศาสตร์",
        "nameEN": "Institute of Engineering",
        "slang": "department-engineering",
        "image": "__PUBLIC_URL__/service-sut/image/Institute/pic-04.png",
        "createAt": "2022-07-09 03:48:36",
        "updataAt": "2022-07-09 03:48:36",
        "y2025": null,
        "y2024": null,
        "y2023": "__PUBLIC_URL__/service-sut/ebook-freshmen/2566/Institute_of_Engineering/Institute_of_Engineering.html",
        "y2022": "__PUBLIC_URL__/service-sut/ebook-freshmen/2565/Institute_of_Engineering/Institute_of_Engineering.html",
        "y2021": "__PUBLIC_URL__/service-sut/ebook-freshmen/2564/Institute_of_Engineering/Institute_of_Engineering.html",
        "y2020": "__PUBLIC_URL__/service-sut/ebook-freshmen/2563/Institute_of_Engineering/Institute_of_Engineering.html",
        "message": {
          "title": "สารจากคณบดี\nรองศาสตราจารย์ ดร.พรศิริ จงกล",
          "text": [
            {
              "text_0": "สวัสดีค่ะ นักศึกษาวิศวกรรมศาสตร์ทุกคน ในนามสำนักวิชาวิศวกรรมศาสตร์ มหาวิทยาลัยเทคโนโลยีสุรนารี ขอต้อนรับเข้าสู่มหาวิทยาลัยแห่งนี้ด้วยความยินดียิ่ง การก้าวเข้าสู่รั้วมหาวิทยาลัย ถือเป็นก้าวที่ยิ่งใหญ่และมีความสำคัญยิ่ง เป็นก้าวแห่งการเปลี่ยนแปลงในชีวิต เปลี่ยนจากนักเรียรสู่นักศึกษา เปลี่ยนจากเด็กเป็นผู้ใหญ่ ซึ่งการเปลี่ยนแปลงเหล่านี้ต้องอาศัยความตระหนักในภาระรับผิดชอบที่เพิ่มมากขึ้นด้วย\n     ",
              "text_1": "รูปแบบการเรียนการสอนในมหาวิทยาลัย มีการเปลี่ยนแปลงไปจากเดิมที่มีผู้สอนและติดตาม\nอย่างใกล้ชิด ต้องปรับเป็นการค้นคว้าหาความรู้และเรียนรู้ด้วยตนเอง มีการจัดการเรียนการสอนที่ใช้เทคโนโลยีมากขึ้น นอกจากนี้ นักศึกษายังต้องมีความรับผิดชอบต่อการปฏิบัติตามกฎระเบียบของมหาวิทยาลัยอีกด้วย ทางสำนักวิชาฯ จึงได้จัดเตรียมเอกสารนี้ เพื่อที่นักศึกษาจะได้ใช้เป็นเอกสารอ้างอิงต่อไป อย่างไรก็ตาม \nหากนักศึกษามีปัญหาใดๆ ก็ตาม ให้ระลึกอยู่เสมอว่าอาจารย์ที่ปรึกษาของนักศึกษา จะสามารถช่วยเหลือ\nในเรื่องต่างๆ ได้\n     ",
              "text_2": "การที่นักศึกษาเข้าเรียนในด้านวิศวกรรมศาสต์นี้ ขอให้นักศึกษาเข้าใจว่าความรู้ความสามารถและทักษะด้านต่างๆ รวมทั้งการใช้ภาษาต่างประเทศ เป็นเรื่องที่สำคัญมากสำหรับที่ต้องใช้ในการประกอบวิชาชีพต่อไป ประเทศไทยในขณะนี้ได้ฝากความหวังไว้กับนักศึกษา ที่จะพัฒนาตนเองเป็นวิศวกรที่มีคุณภาพ และ\nช่วยพัฒนาประเทศให้มีความสามารถในการแข่งขันได้ในอนาคต\n      ",
              "text_3": "สุดท้ายนี้ ขออวยพรให้นักศึกษา ทุกคนจงมีคามสุขในการเรียนและการใช้ชีวิต มีพลังกาย พลังใจ\nที่เข้มแข็ง สามารถฟันฝ่าอุปสรรคทั้งหลาย เพื่อสำเร็จการศึกษาเป็นบัณฑิตที่มีคุณภาพ มีความรู้ ทักษะ ประสบการณ์และจริยธรรม เพื่อร่วมกันส่งเสริมความเจริญรุ่งเรืองของประเทศชาติอย่างยั่งยืน"
            }
          ],
          "image": [
            {
              "image_0": "__PUBLIC_URL__/service-sut/image/image_2024/Img/04-Engi/Dean_Engineer.png",
              "image_1": "__PUBLIC_URL__/service-sut/image/2_Institute/vdo/Cover/vdo4-engi-cover.png",
              "image_2": "__PUBLIC_URL__/service-sut/image/2_Institute/vdo/vdo4-engi.mp4"
            }
          ]
        },
        "result": {
          "title": "เกียรตินิยมอยู่แค่เอื้อม",
          "text": [
            {
              "text_0": "เกรดเฉลี่ยสะสม 3.50 ขึ้นไป ไม่มี U และ F ไม่เรียนซ้ำเพื่อปรับเกรด D D+ จะได้รับ",
              "text_1": "ปริญญาเกียรตินิยมอันดับหนึ่งและเหรียญทองเกียรตินิยม",
              "text_2": "และหากได้รับปริญญาเกียรตินิยมอันดับหนึ่ง พร้อมทั้งมีแต้มเฉลี่ยสูงสุดในสาขา จะได้รับ",
              "text_3": "เข็มทองคำ",
              "text_4": "ทุนการศึกษาต่อระดับบัณฑิตศึกษา",
              "text_5": "ทุนกิตติบัณฑิต ทุนศักยภาพ",
              "text_6": "ทุนเรียนดี เป็นต้น",
              "text_7": "เกรดเฉลี่ยสะสม 3.25 ขึ้นไป ไม่มี U และ F ไม่เรียนซ้ำเพื่อปรับเกรด D D+",
              "text_8": "จะได้รับ ปริญญาเกียรตินิยมอันดับสอง และเหรียญเงินเกียรตินิยม"
            }
          ],
          "image": [
            {
              "image_0": "__PUBLIC_URL__/service-sut/image/engineering/Group%20336.png"
            }
          ]
        },
        "teacher": {
          "title": "ความสำคัญของการ เข้าพบอาจารย์ที่ปรึกษา",
          "text": [
            {
              "text_0": "1) อาจารย์มีมุมมองและวิธีรับมือกับปัญหาอย่างมืออาชีพ\n",
              "text_1": "2) อาจารย์มีประสบการณ์ที่สั่งสมจากความสำเร็จและความผิดพลาดของนักศึกษารุ่นก่อน\n",
              "text_2": "3) เข้าพบเพื่อวางแผนการเรียนตั้งแต่ต้นเทอม\n",
              "text_3": "4) เข้าพบอาจารย์ที่ปรึกษาเพื่อรับคำแนะนำก่อนวันสุดท้ายของการถอนรายวิชา เมื่อสอบกลางภาคแล้ว\n\n",
              "text_4": "ช่องทางการตรวจสอบเวลาว่างของอาจารย์ที่ปรึกษา\n",
              "text_5": "1) ตรวจสอบตารางสอนของอาจารย์ที่ปรึกษา ผ่านระบบ reg.sut.ac.th\n",
              "text_6": "2) ค้นหาเบอร์โทรศัพท์ E-mail ของอาจารย์ หรือสาขาวิชาที่อาจารย์สังกัด ได้ที่\nwww.sut.ac.th/2012/phone/\n",
              "text_7": "3) นักศึกษาสามารถ E-mail หาอาจารย์ได้โดยตรงเพื่อขอพบ\n",
              "text_8": "4) ข้อมูลติดต่อบุคลากรในสำนักวิชาวิศวกรรมศาสตร์ ดูต่อ http://www.sut.ac.th/2012/phone/show_dept.php?id=1070000"
            }
          ],
          "image": [
            {
              "image_0": "__PUBLIC_URL__/service-sut/image/engineering/Group%20341.png"
            }
          ]
        },
        "estimate": {
          "title": "ความสำคัญของการประเมินการสอน",
          "text": [
            {
              "text_0": "อาจารย์สามารถปรับปรุงและพัฒนาการสอนในแต่ละวิชาให้มีประสิทธิภาพมากขึ้น",
              "text_1": "วิธีเข้าประเมินการสอน",
              "text_2": "1) Log in : reg.sut.ac.th",
              "text_3": "2) ไปที่เมนู “ประเมินอาจารย์”",
              "text_4": "3) นักศึกษาตอบคำถามในแบบประเมิน และสามารถแสดงความคิดเห็นได้ โดยที่อาจารย์ไม่สามารถเห็นชื่อนักศึกษาที่เข้าประเมินได้",
              "text_5": "4) สามารถเข้าประเมินได้ในสัปดาห์ที่ 6 ถึงสอบปลายภาคการศึกษา"
            }
          ],
          "image": [
            {
              "image_0": "__PUBLIC_URL__/service-sut/image/engineering/Group%20342.png"
            }
          ]
        },
        "activity": {
          "title": "กิจกรรมนักศึกษา",
          "text": [
            {
              "text_0": "ในการเพิ่มพูนประสบการณ์ที่มีค่า เพื่อให้น้อง ๆ ได้ฝึกประสบการณ์การบริหารเวลา การรับผิดชอบตัวเอง และการทํางานร่วมกันกับผู้อื่น รวมถึงการส่งเสริมและพัฒนาความเป็นผู้นําของน้อง ๆ ตัวอย่างกิจกรรมนักศึกษาในแต่ละปี\n\n",
              "text_1": "1) กิจกรรมต้อนรับน้องโควตา\n",
              "text_2": "2) การแข่งขันกีฬาน้องใหม่\n",
              "text_3": "3) โครงการจิตอาสา\n",
              "text_4": "4) ชมรมของนักศึกษา เช่น ชมรมเชียร์ลีดเดอร์ ชมรมโรบอท ชมรมการบิน ชมรมยานยนต์\n",
              "text_5": "5) คณะกรรมการส่งเสริมการพัฒนานักศึกษาวิศวกรรมศาสตร์ (กสวศ. หรือ พี่พัฒน์) (Engineering Student Development Promotion Commission: ENGi Plus)\n\n",
              "text_6": "“ปริญญาทําให้คนมีงานทํากิจกรรมทําให้คนทํางานเป็น”"
            }
          ],
          "image": [
            {
              "image_0": "__PUBLIC_URL__/service-sut/image/engineering/Group%20345.png"
            }
          ]
        },
        "project": {
          "title": "การทำกิจกรรม/โครงการต้องเตรียมอะไรบ้าง ?",
          "text": [
            {
              "text_0": "ขั้นตอนการกรอกแบบฟอร์มขอจัดกิจกรรมของนักศึกษา",
              "text_1": "1) ร่างโครงการและแบบฟอร์มขอจัดกิจกรรมของนักศึกษาให้เรียบร้อย เพื่อขออนุมัติต่อ รองอธิการบดีฝ่ายกิจการนักศึกษาและศิษย์เก่าสัมพันธ์ (กรณีเป็นกิจกรรมของชมรม) และคณบดีของสำนักวิชา (กรณีเป็นกิจกรรมของสำนักวิชา)",
              "text_2": "2) ติดต่อประสานงานการขอใช้สถานที่หลังจากได้รับอนุมัติ",
              "text_3": "Note: ควรตรวจสอบเรื่องสถานที่ในเบื้องต้นจากหน่วยงานที่ดูแลสถานที่ก่อนว่าว่างหรือไม่"
            }
          ],
          "image": [
            {
              "image_0": "__PUBLIC_URL__/service-sut/image/engineering/Activity-1.png"
            }
          ],
          "link": [
            {
              "link_0": "https://beta.sut.ac.th/dsa/งานกิจกรรมนักศึกษา/แบบฟอร์มงานกิจกรรมนักศ"
            }
          ]
        },
        "project_show": {
          "title": "โครงการรณรงค์สวมหมวกนิรภัยและ กวดขันวินัยจราจร",
          "text": [
            {
              "text_0": "1) ต้องมีใบอนุญาตขับขี่\n\n",
              "text_1": "2) ต้องมีบัตรผ่านเข้า-ออก มทส. ติดที่หน้ารถ ในกรณีรถสูญหายในเขต มทส. บริษัท รปภ. จะรับผิดชอบ ตามเงื่อนไขของสัญญาจ้าง เมื่อจอดในพื้นที่ ให้จอดเท่านั้น\n",
              "text_2": "Download แบบฟอร์ม 09 การทําบัตรผ่านเข้า-ออก มทส. สำหรับ นักศึกษา\n\n",
              "text_3": "3) ต้องสวมใส่หมวกนิรภัยทั้งผู้ขับขี่และผู้ซ้อนท้าย เพื่อลด ปัญหาการเกิดอุบัติเหตุและอัตราสูญเสียทางจราจร\n\n",
              "text_4": "Note: สอบถามข้อมูลเพิ่มเติมได้ที่ งานรักษาความปลอดภัย (วงเวียนหน้า มทส.) โทรศัพท์หมายเลข 0-4444-4563"
            }
          ],
          "image": [
            {
              "image_0": "__PUBLIC_URL__/service-sut/image/engineering/Group%20351.png"
            }
          ]
        },
        "advice": {
          "title": "ข้อแนะนำของสำนักวิชาวิศวกรรมศาสตร์",
          "text": [
            {
              "text_0": "วิสัยทัศน์/พันธกิจ/ค่านิยม",
              "text_1": "เรียน มทส. อย่างไรให้จบตามเวลา ?",
              "text_2": "เกียรตินิยมอยู่แค่เอื้อม",
              "text_3": "ความสำคัญของการ เข้าพบอาจารย์ที่ปรึกษา",
              "text_4": "ความสำคัญของการประเมินการสอน",
              "text_5": "กิจกรรมนักศึกษา",
              "text_6": "การทำกิจกรรม/โครงการต้องเตรียมอะไรบ้าง ?",
              "text_7": "โครงการรณรงค์สวมหมวกนิรภัยและ กวดขันวินัยจราจร",
              "text_8": "สละสิทธิ์สาขาวิชา ต้องทำอย่างไร ?",
              "text_9": "รายวิชาที่ใช้สำหรับการเลือกสาขาวิชา",
              "text_10": "เลือกสาขาวิชา ต้องทำอย่างไร ?",
              "text_11": "ลงทะเบียน GPAX ต่ำกว่า 2 ต้องทำอย่างไร ?"
            }
          ],
          "image": [
            {
              "image_0": ""
            }
          ]
        },
        "select_subject": {
          "title": "เลือกสาขาวิชา ต้องทำอย่างไร ?",
          "text": [
            {
              "text_0": "เข้าระบบ REG\n",
              "text_1": "ควรเก็บรักษา Username และ Password เป็นความลับส่วนบุคคล\n",
              "text_2": "!!! หากเกิดข้อผิดพลาด สํานักวิชาฯ จะไม่รับผิดชอบ\n\n",
              "text_3": "เลือกหลักสูตร (สาขาวิชา) ตามที่สนใจ\n",
              "text_4": "อย่าลืมเรียงลําดับให้ครบทุกหลักสูตรมิฉะนั้นระบบจะไม่บันทึกข้อมูล \n\n",
              "text_5": "เลือกสาขาวิชาในเวลาที่กําหนด\n",
              "text_6": "อย่าลืม!! กดยืนยันทุกครั้ง เมื่อเปลี่ยนใจเลือกสาขาอื่น และตรวจสอบการเลือกสาขา อีกครั้งก่อนหมดเวลา\n\n",
              "text_7": "ถ้าพบข้อผิดพลาดในการเลือกสาขาวิชา\n",
              "text_8": "เขียนคําร้อง ท.9 และส่งเอกสารที่สํานักวิชาฯ\n",
              "text_9": "ดาวน์โหลดแบบฟอร์ม\n\n",
              "text_10": "Warning: 1) ประกาศผลก่อนลงทะเบียนเทอมถัดไป 2) การจัดเข้าสาขา พิจารณาจาก Grade Point เท่านั้น ดูวิธีคิด Grade Point 3) Grade Point สูงกว่ามีโอกาสได้สาขาที่อยากเรียน"
            }
          ],
          "image": [
            {
              "image_0": "__PUBLIC_URL__/service-sut/image/engineering/illus-maindata_H28-1.png",
              "image_1": "__PUBLIC_URL__/service-sut/image/engineering/illus-maindata_H28-2.png"
            }
          ]
        },
        "q1": {
          "title": "สละสิทธิ์สาขาวิชา ต้องทำอย่างไร ?",
          "text": [
            {
              "text_0": "เฉพาะนักศึกษาโควตาปี 1 ที่สังกสัดสาขาวิชาแล้ว\n",
              "text_1": "1. กรอกแบบฟอร์มขอสละสิทธิ์ ดาวน์โหลดแบบฟอร์ม https://beta.sut.ac.th/ie\n",
              "text_2": "2. นําํแบบฟอร์ม เข้าพบและขออนุมัติ ตามลําดับ\n",
              "text_3": "อาจารย์ที่ปรึกษา > หัวหน้าสาขา > นําแบบฟอร์มส่งที่สำนักวิชาวิศวกรรมศาสตร์\n",
              "text_4": "3. ตรวจสอบรายชื่อได้ 2 ทาง\n   ",
              "text_5": "1) เว็บไซต์ศูนย์บริการการศึกษา CES  http://web.sut.ac.th/ces/\n   ",
              "text_6": "2) เว็บไซต์สำนักวิชาวิศวกรรมศาสตร์  https://beta.sut.ac.th/ie"
            }
          ],
          "image": [
            {
              "image_0": ""
            }
          ]
        },
        "table_grad": {
          "title": "การคำนวณผลรวม Grade Point 3 ภาคเรียนสำหรับให้เลือกสาขาวิชา",
          "text": [
            {
              "text_0": "รายวิชาที่ใช้สำหรับการเลือกสาขาวิชา",
              "text_1": "ภาคการศึกษา 1 - 7 รายวิชา",
              "text_2": "ภาคการศึกษา 2 - 6 รายวิชา",
              "text_3": "ภาคการศึกษา 3 - 6 รายวิชา",
              "text_4": "Warning: 1) หากอยากได้สาขาที่ถูกใจ ต้องทํา Grade Point ให้สูงเข้าไว้ 2) อาจมีการสลับเทอมของกลุ่มการลงทะเบียน ตามกลุ่มนักศึกษา"
            }
          ],
          "image": [
            {
              "image_0": ""
            }
          ]
        },
        "registered_GPAX": {
          "title": "ลงทะเบียน GPAX ต่ำกว่า 2 ต้องทำอย่างไร ?",
          "text": [
            {
              "text_0": "ลงทะเบียนตามปกติ",
              "text_1": "กรอกข้อมูลและต้องเข้าพบอาจารย์ที่ปรึกษาภายใน 2 สัปดาห์ หลังเปิด ภาคการศึกษา (ก่อนหมดเขตการเพิ่ม – ลด รายวิชา)",
              "text_2": "ส่งเอกสารที่สำนักวิชาวิศวกรรมศาสตร์",
              "text_3": "ถือว่าการลงทะเบียนเป็นการเสร็จสมบูรณ์",
              "text_4": "Note: ถ้าเบี้ยว!! ไม่ยอมไปพบอาจารย์ที่ปรึกษาการลงทะเบียนจะถือเป็นโมฆะ และ 1) ยังไงก็ต้องกลับไปพบอาจารย์ที่ปรึกษา 2) ลงทะเบียนใหม่และเสียค่าปรับ 3) ถูกตัดคะแนนความประพฤติ"
            }
          ],
          "image": [
            {
              "image_0": ""
            }
          ]
        },
        "study": {
          "title": "เรียนอย่างไรให้จบตามเวลา ?",
          "data": [
            {
              "id": "65",
              "courseID": "4",
              "detail": "เราเรียนระบบ 3 เทอม แต่ละเทอมจะมีเพียง 12 สัปดาห์ สิ่งที่ต้องทำให้ได้คือ การแบ่งเวลา เวลาเรียน เวลาเล่น เวลาทำกิจกรรมทำทุกอย่างให้สมดุล",
              "image": "__PUBLIC_URL__/service-sut/image/engineering/H05-engi-1.png",
              "createAt": "2022-07-22 18:13:00",
              "updataAt": "2022-07-22 18:13:00",
              "year": "2025"
            },
            {
              "id": "66",
              "courseID": "4",
              "detail": "ตั้งใจเข้าเรียนสม่ำเสมอ อาศัยความเพียรและความมุ่งมั่นเป็นที่ตั้ง",
              "image": "__PUBLIC_URL__/service-sut/image/engineering/H05-engi-2.png",
              "createAt": "2022-07-22 18:13:00",
              "updataAt": "2022-07-22 18:13:00",
              "year": "2025"
            },
            {
              "id": "67",
              "courseID": "4",
              "detail": "ทบทวนและฝึกทำการบ้านด้วยตนเอง ไม่ลอกการบ้านใคร “ถ้าไม่เข้าใจให้ไปพบอาจารย์ผู้สอน”",
              "image": "__PUBLIC_URL__/service-sut/image/engineering/H05-engi-3.png",
              "createAt": "2022-07-22 18:13:00",
              "updataAt": "2022-07-22 18:13:00",
              "year": "2025"
            },
            {
              "id": "68",
              "courseID": "4",
              "detail": "พบอาจารย์ที่ปรึกษาอย่างสม่ำเสมอ จะทำให้เราได้ที่พึ่งทั้งการเรียนและการใช้ชีวิต",
              "image": "__PUBLIC_URL__/service-sut/image/engineering/H05-engi-4.png",
              "createAt": "2022-07-22 18:13:00",
              "updataAt": "2022-07-22 18:13:00",
              "year": "2025"
            },
            {
              "id": "69",
              "courseID": "4",
              "detail": "เมื่อใดที่เริ่มตามบทเรียนไม่ทัน ต้องหยุดทำกิจกรรมและมุ่งที่การเรียนก่อน",
              "image": "__PUBLIC_URL__/service-sut/image/engineering/H05-engi-5.png",
              "createAt": "2022-07-22 18:13:00",
              "updataAt": "2022-07-22 18:13:00",
              "year": "2025"
            },
            {
              "id": "70",
              "courseID": "4",
              "detail": "เมื่อใดที่เริ่มตามบทเรียนไม่ทัน ต้องหยุดทำกิจกรรมและมุ่งที่การเรียนก่อน",
              "image": "__PUBLIC_URL__/service-sut/image/engineering/H05-engi-6.png",
              "createAt": "2022-07-22 18:13:00",
              "updataAt": "2022-07-22 18:13:00",
              "year": "2025"
            }
          ]
        },
        "misstion": {
          "title": "วิสัยทัศน์/พันธกิจ/ค่านิยม",
          "data": [
            {
              "title": "วิสัยทัศน์",
              "image": "__PUBLIC_URL__/service-sut/image/engineering/Group%20333.png",
              "text_0": "เป็นองค์กรที่โดดเด่นในการสร้างกำลังคนและความรู้ด้านวิศวกรรมศาสตร์ของประเทศ"
            },
            {
              "title": "พันธกิจ",
              "image": "__PUBLIC_URL__/service-sut/image/engineering/Group%20332.png",
              "text_0": "1.ผลิตและพัฒนากำลังคนที่มีความรู้และทักษะด้านวิศวกรรมศาสตร์ที่พร้อมในการทำงานภาคอุตสาหกรรม \n",
              "text_1": "2.วิจัยเพื่อสร้างองค์ความรู้ เทคโนโลยีและนวัตกรรม ด้านวิศวกรรมศาสตร์ในการนำไปใช้ประโยชน์เพื่อพัฒนาประเทศ\n",
              "text_2": "3.บริการวิชาการ ปรับแปลง และถ่ายทอดเทคโนโลยีเพื่อส่งเสริมศักยภาพในการแข่งขันของภาคอุตสาหกรรมและพัฒนาชุมชน"
            },
            {
              "title": "ค่านิยม “WELL”",
              "image": "__PUBLIC_URL__/service-sut/image/engineering/Group%20331.png",
              "text_0": "W-Working Smart with Facts\n",
              "text_1": "(การทำงานอย่างชาญฉลาดบนพื้นฐานของข้อมูลจริง)\n",
              "text_2": "E-Embrace Excellence\n",
              "text_3": "(การมุ่งเน้นผลลัพธ์ที่มีคุณค่าต่อผู้เรียน และลูกค้ากลุ่มอื่น) \n",
              "text_4": "L-Lifelong Learning and Agility\n",
              "text_5": "(การเรียนรู้อย่างต่อเนื่องและทันต่อการเปลี่ยนแปลง)\n",
              "text_6": "L: Launching Innovation for Community Betterment\n",
              "text_7": "(การนำนวัตกรรมไปใช้ให้เกิดประโยชน์ต่อองค์กรและสังคม)"
            },
            {
              "title": "เป้าหมาย",
              "image": "",
              "text_0": "เป็น 1 ใน 3 ของประเทศด้านวิศวกรรมศาสตร์ ภายในปี พ.ศ. 2568"
            }
          ]
        },
        "contract": [
          {
            "id": "448",
            "courseID": "4",
            "slang": "",
            "department": "หลักสูตรที่เปิดสอน",
            "phone": "0-4422-4517",
            "site": "www.dst_admin@sut.com",
            "createAt": "2022-07-16 14:25:41",
            "updateAt": "2022-07-16 14:25:41",
            "year": "2025"
          },
          {
            "id": "468",
            "courseID": "4",
            "slang": "",
            "department": "สาขาวิชาวิศวกรรมเกษตรและอาหาร",
            "phone": "",
            "site": "https://eng.sut.ac.th/ENG2023/schools/school-of-agricultural-engineering/",
            "createAt": "0000-00-00 00:00:00",
            "updateAt": "0000-00-00 00:00:00",
            "year": "2025"
          },
          {
            "id": "469",
            "courseID": "4",
            "slang": "",
            "department": "สาขาวิชาวิศวกรรมเซรามิก",
            "phone": "",
            "site": "https://eng.sut.ac.th/ENG2023/schools/school-of-ceramic-engineering/",
            "createAt": "0000-00-00 00:00:00",
            "updateAt": "0000-00-00 00:00:00",
            "year": "2025"
          },
          {
            "id": "470",
            "courseID": "4",
            "slang": "",
            "department": "สาขาวิชาวิศวกรรมเคมี",
            "phone": "",
            "site": "https://sites.google.com/g.sut.ac.th/chemengsut/home",
            "createAt": "0000-00-00 00:00:00",
            "updateAt": "0000-00-00 00:00:00",
            "year": "2025"
          },
          {
            "id": "471",
            "courseID": "4",
            "slang": "",
            "department": "สาขาวิชาวิศวกรรมโยธา",
            "phone": "",
            "site": "https://eng.sut.ac.th/ENG2023/beng-in-civil-engineering",
            "createAt": "0000-00-00 00:00:00",
            "updateAt": "0000-00-00 00:00:00",
            "year": "2025"
          },
          {
            "id": "472",
            "courseID": "4",
            "slang": "",
            "department": "สาขาวิชาวิศวกรรมคอมพิวเตอร์",
            "phone": "",
            "site": "https://eng.sut.ac.th/ENG2023/schools/school-of-computer-engineering/",
            "createAt": "0000-00-00 00:00:00",
            "updateAt": "0000-00-00 00:00:00",
            "year": "2025"
          },
          {
            "id": "473",
            "courseID": "4",
            "slang": "",
            "department": "สาขาวิชาวิศวกรรมไฟฟ้า",
            "phone": "",
            "site": "https://eng.sut.ac.th/ENG2023/schools/school-of-electrical-engineering/",
            "createAt": "0000-00-00 00:00:00",
            "updateAt": "0000-00-00 00:00:00",
            "year": "2025"
          },
          {
            "id": "474",
            "courseID": "4",
            "slang": "",
            "department": "สาขาวิชาวิศวกรรมอิเล็กทรอนิกส์และระบบสมองกลฝังตัว",
            "phone": "",
            "site": "https://eng.sut.ac.th/ENG2023/schools/school-of-electronic-engineering/",
            "createAt": "0000-00-00 00:00:00",
            "updateAt": "0000-00-00 00:00:00",
            "year": "2025"
          },
          {
            "id": "475",
            "courseID": "4",
            "slang": "",
            "department": "สาขาวิชาวิศวกรรมสิ่งแวดล้อม",
            "phone": "",
            "site": "https://eng.sut.ac.th/ENG2023/schools/school-of-environmental-engineering/",
            "createAt": "0000-00-00 00:00:00",
            "updateAt": "0000-00-00 00:00:00",
            "year": "2025"
          },
          {
            "id": "476",
            "courseID": "4",
            "slang": "",
            "department": "สาขาวิชาวิศวกรรมธรณี",
            "phone": "",
            "site": "https://eng.sut.ac.th/ENG2023/schools/school-of-geotechnology/",
            "createAt": "0000-00-00 00:00:00",
            "updateAt": "0000-00-00 00:00:00",
            "year": "2025"
          },
          {
            "id": "477",
            "courseID": "4",
            "slang": "",
            "department": "สาขาวิชาวิศวกรรมอุตสาหการ",
            "phone": "",
            "site": "https://eng.sut.ac.th/ENG2023/schools/school-of-industrial-engineering/",
            "createAt": "0000-00-00 00:00:00",
            "updateAt": "0000-00-00 00:00:00",
            "year": "2025"
          },
          {
            "id": "478",
            "courseID": "4",
            "slang": "",
            "department": "สาขาวิศวกรรมการผลิตอัจฉริยะ",
            "phone": "",
            "site": "https://eng.sut.ac.th/ENG2023/schools/school-of-manufacturing-engineering/",
            "createAt": "0000-00-00 00:00:00",
            "updateAt": "0000-00-00 00:00:00",
            "year": "2025"
          },
          {
            "id": "479",
            "courseID": "4",
            "slang": "",
            "department": "สาขาวิชาวิศวกรรมเครื่องกล",
            "phone": "",
            "site": "https://eng.sut.ac.th/ENG2023/schools/school-of-mechanical-engineering/",
            "createAt": "0000-00-00 00:00:00",
            "updateAt": "0000-00-00 00:00:00",
            "year": "2025"
          },
          {
            "id": "480",
            "courseID": "4",
            "slang": "",
            "department": "สาขาวิชาวิศวกรรมโลหการ",
            "phone": "",
            "site": "https://eng.sut.ac.th/ENG2023/undergraduate-study/",
            "createAt": "0000-00-00 00:00:00",
            "updateAt": "0000-00-00 00:00:00",
            "year": "2025"
          },
          {
            "id": "481",
            "courseID": "4",
            "slang": "",
            "department": "สาขาวิชาวิศวกรรมปิโตรเลียมและเทคโนโลยีธรณี",
            "phone": "",
            "site": "https://eng.sut.ac.th/ENG2023/schools/school-of-polymer-engineering/",
            "createAt": "0000-00-00 00:00:00",
            "updateAt": "0000-00-00 00:00:00",
            "year": "2025"
          },
          {
            "id": "482",
            "courseID": "4",
            "slang": "",
            "department": "สาขาวิชาวิศวกรรมพอลิเมอร์",
            "phone": "",
            "site": "https://eng.sut.ac.th/ENG2023/schools/school-of-polymer-engineering/",
            "createAt": "0000-00-00 00:00:00",
            "updateAt": "0000-00-00 00:00:00",
            "year": "2025"
          },
          {
            "id": "483",
            "courseID": "4",
            "slang": "",
            "department": "สาขาวิชาวิศวกรรมโทรคมนาคมและโครงข่ายอัจฉริยะ",
            "phone": "",
            "site": "https://eng.sut.ac.th/ENG2023/schools/school-of-computer-engineering/",
            "createAt": "0000-00-00 00:00:00",
            "updateAt": "0000-00-00 00:00:00",
            "year": "2025"
          },
          {
            "id": "484",
            "courseID": "4",
            "slang": "",
            "department": "สาขาวิชาวิศวกรรมขนส่งและโลจิสติกส์",
            "phone": "",
            "site": "https://eng.sut.ac.th/ENG2023/schools/school-of-transportation-engineering/",
            "createAt": "0000-00-00 00:00:00",
            "updateAt": "0000-00-00 00:00:00",
            "year": "2025"
          },
          {
            "id": "485",
            "courseID": "4",
            "slang": "",
            "department": "สาขาวิชาวิศวกรรมโยธาและโครงสร้างพื้นฐาน",
            "phone": "",
            "site": "https://eng.sut.ac.th/ENG2023/beng-in-civil-and-infrastructure-engineering/#",
            "createAt": "0000-00-00 00:00:00",
            "updateAt": "0000-00-00 00:00:00",
            "year": "2025"
          },
          {
            "id": "486",
            "courseID": "4",
            "slang": "",
            "department": "สาขาวิชาการประกอบการด้วยเทคโนโลยีดิจิทัล",
            "phone": "",
            "site": "https://eng.sut.ac.th/ENG2023/undergraduate-study/beng-in-digital-technology-entrepreneurship/",
            "createAt": "0000-00-00 00:00:00",
            "updateAt": "0000-00-00 00:00:00",
            "year": "2025"
          },
          {
            "id": "487",
            "courseID": "4",
            "slang": "",
            "department": "สาขาวิชาวิศวกรรมไฟฟ้าอุตสาหกรรม",
            "phone": "",
            "site": "https://iee.sut.ac.th/",
            "createAt": "0000-00-00 00:00:00",
            "updateAt": "0000-00-00 00:00:00",
            "year": "2025"
          },
          {
            "id": "488",
            "courseID": "4",
            "slang": "",
            "department": "สาขาวิชาวิศวกรรมอุตสาหการและการจัดการข้อมูล",
            "phone": "",
            "site": "https://eng.sut.ac.th/ENG2023/beng-in-industrial-engineering-and-data-management",
            "createAt": "0000-00-00 00:00:00",
            "updateAt": "0000-00-00 00:00:00",
            "year": "2025"
          },
          {
            "id": "489",
            "courseID": "4",
            "slang": "",
            "department": "สาขาวิชาวิศวกรรมระบบสมองกลอัจฉริยะและอิเล็กทรอนิกส์ความถี่สูง",
            "phone": "",
            "site": "https://eng.sut.ac.th/ENG2023/schools/school-of-electronic-engineering/",
            "createAt": "0000-00-00 00:00:00",
            "updateAt": "0000-00-00 00:00:00",
            "year": "2025"
          },
          {
            "id": "490",
            "courseID": "4",
            "slang": "",
            "department": "สาขาวิชาวิศวกรรมเครื่องกลและกระบวนการผลิต",
            "phone": "",
            "site": "https://eng.sut.ac.th/ENG2023/beng-in-mechanical-engineering-and-production-system",
            "createAt": "0000-00-00 00:00:00",
            "updateAt": "0000-00-00 00:00:00",
            "year": "2025"
          },
          {
            "id": "491",
            "courseID": "4",
            "slang": "",
            "department": "สาขาวิชาวิศวกรรมเมคคาทรอนิกส์",
            "phone": "",
            "site": "http://mecha.sut.ac.th/",
            "createAt": "0000-00-00 00:00:00",
            "updateAt": "0000-00-00 00:00:00",
            "year": "2025"
          },
          {
            "id": "492",
            "courseID": "4",
            "slang": "",
            "department": "สาขาวิชาวิศวกรรมยานยนต์สมัยใหม่",
            "phone": "",
            "site": "http://mecha.sut.ac.th/",
            "createAt": "0000-00-00 00:00:00",
            "updateAt": "0000-00-00 00:00:00",
            "year": "2025"
          },
          {
            "id": "493",
            "courseID": "4",
            "slang": "",
            "department": "สาขาวิชาวิศวกรรมโยธา",
            "phone": "",
            "site": "https://eng.sut.ac.th/ENG2023/beng-in-civil-engineering-international-program",
            "createAt": "0000-00-00 00:00:00",
            "updateAt": "0000-00-00 00:00:00",
            "year": "2025"
          },
          {
            "id": "494",
            "courseID": "4",
            "slang": "",
            "department": "สาขาวิชาวิศวกรรมเครื่องกลและอากาศยาน",
            "phone": "",
            "site": "https://eng.sut.ac.th/ENG2023/schools/school-of-mechanical-engineering/",
            "createAt": "0000-00-00 00:00:00",
            "updateAt": "0000-00-00 00:00:00",
            "year": "2025"
          },
          {
            "id": "495",
            "courseID": "4",
            "slang": "",
            "department": "สาขาวิชาวิศวกรรมปิโตรเคมีและพอลิเมอร์",
            "phone": "",
            "site": "https://eng.sut.ac.th/ENG2023/beng-in-petrochemical-and-polymer-engineering-international-program",
            "createAt": "0000-00-00 00:00:00",
            "updateAt": "0000-00-00 00:00:00",
            "year": "2025"
          }
        ],
        "visitor": 20249,
        "visitor_of_year": 4617
      }
    },
    "department-medicine": {
      "code": 200,
      "status": "Get data success",
      "data": {
        "id": "5",
        "nameTH": "สำนักวิชาแพทยศาสตร์",
        "nameEN": "Institute of Medicine",
        "slang": "department-medicine",
        "image": "__PUBLIC_URL__/service-sut/image/Institute/pic-05.png",
        "createAt": "2022-07-09 03:49:33",
        "updataAt": "2022-07-09 03:49:33",
        "y2025": null,
        "y2024": null,
        "y2023": "__PUBLIC_URL__/service-sut/ebook-freshmen/2566/Institute_of_Medicine/Institute_of_Medicine.html",
        "y2022": "__PUBLIC_URL__/service-sut/ebook-freshmen/2565/Institute_of_Medicine/Institute_of_Medicine.html",
        "y2021": "__PUBLIC_URL__/service-sut/ebook-freshmen/2564/Institute_of_Medicine/Institute_of_Medicine.html",
        "y2020": "__PUBLIC_URL__/service-sut/ebook-freshmen/2563/Institute_of_Medicine/Institute_of_Medicine.html",
        "message": {
          "title": "สารจากคณบดี\nรองศาสตราจารย์ นายแพทย์สุธรรม ปิ่นเจริญ",
          "text": [
            {
              "text_0": "สวัสดีนักศึกษาทุกคน สำนักวิชาแพทยศาสตร์มีความยินดีขอต้อนรับนักศึกษา สู่รั้วมหาวิทยาลัยเทคโนโลยีสุรนารี ด้วยความยินดีอย่างยิ่ง (ปีบทองช่อที่ 33) ขอขอบคุณทุกคนที่เลือกมาศึกษา ณ มหาวิทยาลัยแห่งนี้ ทุกคนต่างไม่เคยรู้จักกัน หรือบางคนอาจจะมาจากที่เดียวกัน จังหวัดเดียวกัน บางคนก็ไม่เคยรู้จักกัน อยู่กับเพื่อนต่างสาขา ดังนั้นจึงขอให้นักศึกษาช่วยเหลือซึ่งกันและกัน เกื้อกูลกันและกัน\n            ",
              "text_1": "การเรียนการสอนหลักสูตรแพทยศาตรบัณฑิต มีการเรียนที่แตกต่างจากสาขาอื่น ๆ ระยะเวลาเรียน ตั้งแต่ปีที่ 1-6 เป็นต้นไป จึงขอให้นักศึกษาปรับตัวให้ทันต่อการเปลี่ยนแปลง และขอให้ฝ่าฟันอุปสรรคต่าง ๆ ให้ผ่านไปได้ด้วยดี หากช่วงเวลาที่นักศึกษาเรียนอยู่ ณ มหาวิทยาลัยแห่งนี้ มีปัญหา คับข้องใจ มีปัญหาต่าง ๆ นานา ขอให้อย่าเก็บความเครียดหรือปัญหานั้นไว้เพียงคนเดียว ขอให้นักศึกษาไปพบอาจารย์ที่ปรึกษาได้ และเมื่อสำเร็จการศึกษาแล้ววิชาชีพนี้จะต้องเป็นผู้ที่ต้องเสียสละมากกว่าอาชีพอื่น ๆ\n            ",
              "text_2": "สำนักวิชาแพทยศาสตร์ จึงขอให้นักศึกษาที่รักยิ่ง ศึกษาคู่มือการศึกษาระดับปริญญาตรีเล่มนี้ เพื่อง่ายต่อการเรียนของนักศึกษาเอง ประกอบด้วย โครงสร้างหลักสูตรข้อบังคับ ระเบียบ และประกาศต่าง ๆ ที่เกี่ยวข้องกับการเรียนการสอน ที่นักศึกษาควรทราบเพื่อจะได้ปฏิบัติอย่างถูกต้อง\n            ",
              "text_3": "หวังเป็นอย่างยิ่งว่า นักศึกษาจะสามารถเรียนแพทย์ การใช้ชีวิตในมหาวิทยาลัย สามารถเผชิญปัญหาต่าง ๆ อย่างมีความสุข และนำความรู้ไปใช้เพื่อผู้ป่วยในอนาคตต่อไปให้สมกับเป็น “หมอดีแห่งแผ่นดิน”"
            }
          ],
          "image": [
            {
              "image_0": "__PUBLIC_URL__/service-sut/image/image-2023/department-medicine/05-Medicine.png",
              "image_1": "__PUBLIC_URL__/service-sut/image/2_Institute/vdo/Cover/vdo5-med-cover.png",
              "image_2": "__PUBLIC_URL__/service-sut/image/2_Institute/vdo/vdo5-med.mp4"
            }
          ]
        },
        "advice": {
          "title": "ข้อแนะนำของสำนักวิชาแพทยศาสตร์",
          "text": [
            {
              "text_0": "แนะนำหลักสาขาวิชา",
              "text_1": "สถานที่จัดการเรียนการสอน",
              "text_2": "การลงทะเบียนเรียน สำหรับนักศึกษาแพทย์",
              "text_3": "การสอบ NL (National License - NL)",
              "text_4": "สิ่งสนับสนุนการเรียนรู้",
              "text_5": "ข้อบังคับว่าด้วย การศึกษาเพื่อปริญญาแพทยศาสตรบัณฑิต พ.ศ. 2564",
              "text_6": "Frequently Asked Questions"
            }
          ],
          "image": [
            {
              "image_0": ""
            }
          ]
        },
        "introduct": {
          "title": "แนะนำหลักสาขาวิชา",
          "text": [
            {
              "text_0": "หลักสูตรแพทยศาสตร์\n",
              "text_1": "เป็นสาขาของวิทยาศาสตร์สุขภาพที่เกี่ยวกับการนําความรู้ทางวิทยาศาสตร์และศิลปศาสตร์มาใช้ในการบริบาลเวชกรรม ซึ่งครอบคลุมการดูแลรักษาสุขภาพของมนุษย์เพื่อการสร้าง เสริมสุขภาพ การป้องกันโรค การตรวจวินิจฉัย การบำบัดโรคและความเจ็บป่วย และการฟื้นฟูสมรรถภาพตามเกณฑ์มาตรฐานผู้ประกอบวิชาชีพเวชกรรมของแพทยสภา\n",
              "text_2": "ค่านิยมขององค์กร: “MEDSUT”\n",
              "text_3": "M = Model ภูมิธรรม\n",
              "text_4": "E = Engagement การผูกพันและมีส่วนร่วมต่อภารกิจ\n",
              "text_5": "D = Dignity ศักดิ์ศรี ภูมิฐาน สง่างาม\n",
              "text_6": "S = Smart ภูมิปัญหาเปรื่องปราด\n",
              "text_7": "U = Ultimate goal เพื่อประโยชน์อันสูงสุด\n",
              "text_8": "T = Teamwork ทำงานเป็นทีม"
            }
          ],
          "image": [
            {
              "image_0": "__PUBLIC_URL__/service-sut/image/medicin/Group%20454.png"
            }
          ]
        },
        "teaching_management": {
          "title": "สถานที่จัดการเรียนการสอน",
          "text": [
            {
              "text_0": "ภายในพื้นที่มหาวิทยาลัยเทคโนโลยีสุรนารี\n",
              "text_1": "สำนักวิชาแพทยศาสตร์ มหาวิทยาลัยเทคโนโลยีสุรนารี และโรงพยาบาลมหาวิทยาลัยเทคโนโลยีสุรนารี"
            }
          ],
          "image": [
            {
              "image_0": "__PUBLIC_URL__/service-sut/image/image_2024/Img/06-Med/02/02-1.jpg",
              "image_1": "__PUBLIC_URL__/service-sut/image/image_2024/Img/06-Med/02/02-2.jpg",
              "image_2": "__PUBLIC_URL__/service-sut/image/image_2024/Img/06-Med/02/02-3.jpg"
            }
          ]
        },
        "teaching_management_1": {
          "title": "สถานที่จัดการเรียนการสอน",
          "text": [
            {
              "text_0": "โรงพยาบาลในสังกัดกระทรวงสาธารณสุข ได้แก่ \n      ",
              "text_1": "ศูนย์แพทยศาสตรศึกษาชั้นคลินิก โรงพยาบาลสุรินทร์ \n      ",
              "text_2": "ศูนย์แพทยศาสตรศึกษาชั้นคลินิก โรงพยาบาลบุรีรัมย์ \n      ",
              "text_3": "ศูนย์แพทยศาสตรศึกษาชั้นคลินิก โรงพยาบาลชัยภูมิ\n      ",
              "text_4": "ระบบสุขภาพในเขตสุขภาพที่ 9 (สำนักงานสาธารณสุขจังหวัด โรงพยาบาลชุมชน โรงพยาบาลส่งเสริมสุขภาพตำบล และสถานบริการสุขภาพต่าง ๆ )\n"
            }
          ],
          "image": [
            {
              "image_0": "__PUBLIC_URL__/service-sut/image/image_2024/Img/06-Med/02/02-4.jpg",
              "image_1": "__PUBLIC_URL__/service-sut/image/image_2024/Img/06-Med/02/02-5.jpg",
              "image_2": "__PUBLIC_URL__/service-sut/image/image_2024/Img/06-Med/02/02-6.jpg"
            }
          ]
        },
        "register": {
          "title": "การลงทะเบียนเรียน สำหรับนักศึกษาแพทย์",
          "text": [
            {
              "text_0": "ชั้นปีที่ 1 \n",
              "text_1": "1) ลงทะเบียนตามกําหนดเวลาของมหาวิทยาลัย\n",
              "text_2": "2) ตรวจสอบรายวิชา และกลุ่มเรียนที่สามารถลงได้ตามสาขาวิชาได้ที่ http://web.sut.ac.th/ces \n",
              "text_3": "3) ระบบทะเบียน http://reg.sut.ac.th\n\n",
              "text_4": "ชั้นปีที่ 2- 6\n",
              "text_5": "1) ลงทะเบียน 1 ครั้งตลอดปีการศึกษา\n",
              "text_6": "2) นักศึกษาที่มีสถานการณ์เรียนปกติตรวจสอบรายวิชาที่สามารถลงทะเบียนได้จาก แผนการเรียน\n",
              "text_7": "3) มีปัญหาเรื่องการลงทะเบียน ติดต่อได้ที่ สถานแพทยศาสตรศึกษา"
            }
          ],
          "image": [
            {
              "image_0": ""
            }
          ]
        },
        "nl": {
          "title": "การสอบ NL (National License - NL)",
          "text": [
            {
              "text_0": "การประเมินและรับรองความรู้ความสามารถในการประกอบวิชาชีพเวชกรรมหรือ NATIONAL LICENSE เป็นของแพทยสภาประกอบด้วยการสอบ 3 ขั้นตอนแต่ละขั้นตอนมีจุดประสงค์ดังนี้\n          ",
              "text_1": "1. BASIC MEDICAL SCIENCES เป็นการสอบขั้นตอนที่ 1 เพื่อประเมินความรู้ทางด้านวิทยาศาสตร์การแพทย์พื้นฐาน สอบตอนจบปี 3 ความรู้ pre-clinic มีสอบปีละ 3 ครั้ง\n          ",
              "text_2": "2. CLINICAL SCIENCES เป็นการสอบขั้นที่ 2 เพื่อประเมินความรู้ทางด้านวิทยาศาสตร์การแพทย์คลินิก สอบตอนจบปี 5\n          ",
              "text_3": "3. OBJECTIVE STRUCTURED CLINICAL EXAMINATION : OSCE เป็นการสอบขั้นที่ 3 เพื่อประเมินทักษะและหัตถการทางคลินิก สอบตอนจบปี 6\nNote: การที่จะสอบ ขั้นตอนที่ 3 ได้ต้องผ่านขั้นตอนที่ 1 และขั้นตอนที่ 2 เสียก่อนแต่ถ้านักศึกษาแพทย์สอบขั้นตอนที่ 1 ไม่ผ่าน ก็ยังสามารถสอบขั้นตอนที่ 2 ได้ (ยังขึ้นไปเรียนชั้นปี 4 ได้)\n\n",
              "text_4": "คุณสมบัติของผู้สมัครสอบ\n          ",
              "text_5": "1. เป็นผู้ที่กําลังศึกษาหลักสูตรแพทยศาสตรบัณฑิตในสถาบันการศึกษาในประเทศไทยหรือในต่างประเทศที่แพทยสภารับรอง หรือ\n          ",
              "text_6": "2. เป็นผู้ที่สําเร็จศึกษาหลักสูตรแพทยศาสตรบัณฑิตในสถาบันการศึกษาในประเทศไทยหรือในต่างประเทศที่แพทยสภารับรอง\n          ",
              "text_7": "3. การสอบขั้นตอนที่ 1 ต้องได้รับการรับรองจากสถานศึกษาว่าได้ศึกษาวิทยาศาสตร์การแพทย์พื้นฐาน (ระดับปรีคลินิก) หรือเทียบเท่ามาแล้วไม่น้อยกว่า 2 ปีการศึกษา\n          ",
              "text_8": "4. การสอบขั้นตอนที่ 2 ต้องได้รับการรับรองจากสถานศึกษาว่าได้ศึกษาวิทยาศาสตร์การแพทย์คลินิก (ระดับคลินิก) มาแล้วไม่น้อยกว่า 2 ปีการศึกษา\n          ",
              "text_9": "5. การสอบขั้นตอนที่ 3 ต้องเป็นผู้ที่สอบผ่านขั้นตอนที่ 1 และ 2แล้ว โดยแต่ละขั้นตอนต้องสอบผ่านมาแล้วเป็นเวลาไม่เกิน 7 ปีนับจากวันที่แพทยสภาอนุมัติผลสอบ"
            }
          ],
          "image": [
            {
              "image_0": "__PUBLIC_URL__/service-sut/image/image_2024/Img/06-Med/04-1.jpg"
            }
          ]
        },
        "support": {
          "title": "สิ่งสนับสนุนการเรียนรู้",
          "text": [
            {
              "text_0": "งานทุนและกู้ยืมการศึกษา\n",
              "text_1": "1) ทุนเรียนดี (ได้รับยกเว้นค่าหน่วยกิต) ดูเกณฑ์การให้ทุน \n",
              "text_2": "2) ทุนขาดแคลนทุนทรัพย์ แหล่งทุนที่ได้รับมาจากภายนอกมหาวิทยาลัย สำนักวิชาฯ เป็นผู้พิจารณาให้ทุน\nเฟซบุ๊กงานทุน สวพ. มทส. https://www.facebook.com/med.scholarship/\n",
              "text_3": "3) กองทุนให้กู้ยืมเพื่อการศึกษา กยศ. กรอ. ดำเนินการผ่านงานทุนการศึกษาของมหาวิทยาลัย \nเฟซบุ๊ก กยศ. มหาวิทยาลัยเทคโนโลยีสุรนารี  \n",
              "text_4": "ระบบอาจารย์ที่ปรึกษาและให้คำปรึกษา\n",
              "text_5": "• อาจารย์ที่ปรึกษาสายรหัส\n",
              "text_6": "• อาจารย์ที่ปรึกษาประจำรายวิชา\n",
              "text_7": "• คลินิกวัยรุ่น รพ.มทส เปิดให้บริการทุกวันพฤหัสบดี เวลา 13.00-16.00 น. \n",
              "text_8": "เฟซบุ๊ก คลินิกวัยรุ่น รพ.มหาวิทยาลัยเทคโนโลยีสุรนารี \nหอพักนักศึกษา \n",
              "text_9": "เว็บไซต์หอพักนักศึกษา มหาวิทยาลัยเทคโนโลยีสุรนารี \n",
              "text_10": "0-4422-5126, 0-4422-5120 \n",
              "text_11": "หอพักหญิง หอพักสุรนิเวศ 1-2 (ห้องน้ำรวม) \n",
              "text_12": "หอพักสุรนิเวศ 5-6 (ห้องน้ำรวม) \n",
              "text_13": "หอพักสุรนิเวศ 14-16 (ห้องน้ำในตัว) \n",
              "text_14": "หอพักสุรนิเวศ 18 (Air-ห้องน้ำในตัว) \n",
              "text_15": "หอพักชาย ",
              "text_16": "หอพักสุรนิเวศ 7-12 (ห้องน้ำรวม) \n",
              "text_17": "หอพักสุรนิเวศ 13 (ห้องน้ำในตัว)\nคลินิกวัยรุ่น รพ.มทส \n",
              "text_18": "เฟซบุ๊ก คลินิกวัยรุ่น รพ.มหาวิทยาลัยเทคโนโลยีสุรนารี \n",
              "text_19": "เปิดให้บริการทุกวันพฤหัสบดี เวลา 13.00-16.00 น. ที่ชั้น 2 อาคารรัตนเวชพัฒน์ \n",
              "text_20": "บริการให้คำปรึกษา คัดกรอง ตรวจรักษา \n",
              "text_21": "• โรคติดต่อทางเพศสัมพันธ์ \n",
              "text_22": "• ปรึกษาปัญหาน้ำหนักเกิน/โรคอ้วน \n",
              "text_23": "• ปัญหาเรื่องท้องไม่พร้อม ยุติการตั้งครรภ์ คุมกำเนิด\nคลินิกสุขภาพจิต \n",
              "text_24": "เว็บไซต์คลินิกสุขภาพจิต \n",
              "text_25": "นัดหมายได้ที่ 0-4437-6555 ต่อ 6122 หรือ 063-081-5535 ในวันและเวลาราชการ หรือ ลงทะเบียนผ่าน Google form รอเจ้าหน้าที่โทรติดต่อกลับภายใน 2 วันทำการ Click \n",
              "text_26": "ปัญหาสุขภาพจิต พบนักจิตวิทยาให้คำปรึกษา \n",
              "text_27": "• ปัญหาสุขภาพจิต เครียด โรคซึมเศร้า \n",
              "text_28": "• ปัญหาครอบครัว การเรียน ความรัก\n",
              "text_29": "สิ่งอํานวยความสะดวก และสิ่งสนับสนุนอื่น ๆ\n",
              "text_30": "• หอพักนักศึกษา\n",
              "text_31": "• การเดินทางใน มทส."
            }
          ],
          "image": [
            {
              "image_0": "http://bulletin.sut.ac.th/static/media/medicine-1.85193c7317b9a779271d.png",
              "image_1": "\n__PUBLIC_URL__/service-sut/image/2025/05Med/img01-1.jpg",
              "image_2": "\n__PUBLIC_URL__/service-sut/image/2025/05Med/img02-1.jpg",
              "image_3": "\n__PUBLIC_URL__/service-sut/image/2025/05Med/img03-1.jpg",
              "image_4": "\n__PUBLIC_URL__/service-sut/image/2025/05Med/img04-1.jpg",
              "image_5": "\n__PUBLIC_URL__/service-sut/image/2025/05Med/img05-1.jpg",
              "image_6": "\nhttp://bulletin.sut.ac.th/static/media/medicine-3.36c58628b939be1f74e0.jpg"
            }
          ],
          "link": [
            {
              "link_0": "https://beta.sut.ac.th/dsa-scholar/wp-content/uploads/sites/183/2021/07/%E0%B8%9B%E0%B8%A3%E0%B8%B0%E0%B8%81%E0%B8%B2%E0%B8%A8-%E0%B8%AB%E0%B8%A5%E0%B8%B1%E0%B8%81%E0%B9%80%E0%B8%81%E0%B8%93%E0%B8%91%E0%B9%8C-%E0%B8%81%E0%B8%B2%E0%B8%A3%E0%B9%83%E0%B8%AB%E0%B9%89%E0%B8%97%E0%B8%B8%E0%B8%99.pdf\n",
              "link_1": "https://www.facebook.com/sut.studentloan.fanpage/\n",
              "link_2": "https://www.facebook.com/people/%E0%B8%84%E0%B8%A5%E0%B8%B4%E0%B8%99%E0%B8%B4%E0%B8%81%E0%B8%A7%E0%B8%B1%E0%B8%A2%E0%B8%A3%E0%B8%B8%E0%B9%88%E0%B8%99-%E0%B8%A3%E0%B8%9E%E0%B8%A1%E0%B8%AB%E0%B8%B2%E0%B8%A7%E0%B8%B4%E0%B8%97%E0%B8%A2%E0%B8%B2%E0%B8%A5%E0%B8%B1%E0%B8%A2%E0%B9%80%E0%B8%97%E0%B8%84%E0%B9%82%E0%B8%99%E0%B9%82%E0%B8%A5%E0%B8%A2%E0%B8%B5%E0%B8%AA%E0%B8%B8%E0%B8%A3%E0%B8%99%E0%B8%B2%E0%B8%A3%E0%B8%B5/100057333614334/\n"
            }
          ]
        },
        "rule": {
          "title": "ข้อบังคับว่าด้วย การศึกษาเพื่อปริญญาแพทยศาสตรบัณฑิต พ.ศ. 2564",
          "text": [
            {
              "text_0": "ดูรายละเอียดข้อบังคับฉบับเต็ม \n\n",
              "text_1": "เรียนตลอดหลักสูตรแบ่งเป็น 3 ระยะ\n          ",
              "text_2": "ระยะที่ 1 >> ศึกษาในระดับชั้นปีที่ 1-3 มีระยะเวลาการศึกษาไม่เกิน 6 ปีการศึกษา\n          ",
              "text_3": "ระยะที่ 2 >> ศึกษาในระดับชั้นปีที่ 4-5 มีระยะเวลาการศึกษาไม่เกิน 4 ปีการศึกษา\n          ",
              "text_4": "ระยะที่ 3 >> ศึกษาในระดับชั้นปีที่ 6 มีระยะเวลาศึกษาไม่เกิน 2 ปีการศึกษา\n\n",
              "text_5": "ข้อบังคับการเรียนตามระยะเวลา\n          ",
              "text_6": "• นักศึกษาที่จะสามารถลงทะเบียนการศึกษาระยะที่ 2 ได้ จะต้องสอบ ผ่าน รายวิชาตามข้อกํา หนดของหลักสูตรในการเรียนระยะที่ 1 ทุกรายวิชา และมีคะแนนเฉลี่ยสะสมไม่ต่ำกว่า 2.00 ของรายวิชาตามที่กําหนด\n          ",
              "text_7": "• นักศึกษาที่จะสามารถลงทะเบียนการศึกษาระยะที่ 3 ได้ จะต้องสอบ ผ่าน รายวิชาตามข้อกํา หนดของหลักสูตรในการเรียนระยะที่ 2 ทุกรายวิชา และมีคะแนนเฉลี่ยสะสมไม่ต่ำกว่า 2.00 ของรายวิชาตามที่กําหนด\n\n",
              "text_8": "การสอบประมวลความรู้ (Comprehensive Examination)\n          ",
              "text_9": "• การสอบประกอบด้วย 2 ขั้นตอน\n                - ขั้นตอนที่ 1 ความรู้ทางวิทยาศาสตร์การแพทย์พื้นฐาน\n                - ขั้นตอนที่ 2 ความรู้ทางวิทยาศาสตร์การแพทย์ชั้นคลินิก\n          ",
              "text_10": "• นักศึกษาจะต้องสอบผ่านทั้งขั้นตอนที่ 1 และ 2 ถึงจะถือว่าสําเร็จการศึกษาในหลักสูตรฯ\n          ",
              "text_11": "• ผู้มีสิทธิ์สอบขั้นตอนที่ 1 จะต้องลงทะเบียนเรียนในระยะเวลาที่ 1 ครบทุกรายวิชาตามที่กําหนด\n          ",
              "text_12": "• ผู้มีสิทธิ์สอบขั้นตอนที่ 2 จะต้องลงทะเบียนเรียนในระยะเวลาที่ 1 และ 2 ครบทุกรายวิชาตามที่กําหนด\n          ",
              "text_13": "• จะต้องสอบผ่านการสอบทั้ง 2 ขั้นตอน โดยแสดงผลการสอบเป็นสัญลักษณ์ S (สอบผ่าน) และแสดงผลเป็น U (สอบไม่ผ่าน) โดยจะต้องสอบใหม่จนกว่าจะผ่าน\n          ",
              "text_14": "• การผ่านขึ้นไปศึกษาระยะที่ 2 ได้ นักศึกษาต้องสอบผ่านขั้นตอนที่ 1"
            }
          ],
          "image": [
            {
              "image_0": ""
            }
          ],
          "link": [
            {
              "link_0": "https://web.sut.ac.th/ces/2018/ces/rules/rules2/med64.pdf"
            }
          ]
        },
        "introduct_1": {
          "title": "แนะนำหลักสาขาวิชา",
          "text": [
            {
              "text_0": "ตราสัญลักษณ์ประจำสำนักวิชาแพทยศาสตร์ และตราสัญลักษณ์มหาวิทยาลัย มหาวิทยาลัยเทคโนโลยีสุรนารี โดยมีสีประจำมหาวิทยาลัยคือ สีแสด-ทอง\n\n",
              "text_1": "ความหมาย\n",
              "text_2": "รูปลักษณ์ของตราสัญลักษณ์วงกลม: แสดงถึงการทำหน้าที่ของแพทย์ที่ไม่มีจุดสิ้นสุด\nสีเขียว: สีประจำสำนักวิชาแพทยศาสตร์ มหาวิทยาลัยเทคโนโลยีสุรนารี\nคทาแอสคลีเพียส: สัญลักษณ์ทางการแพทย์ ใช้สีประจำมหาวิทยาลัย แสด-ทอง เป็นสีของคทา หัวคทากลมแสดงถึงความเป็นอันหนึ่งอันเดียวระหว่างแพทย์และสหวิชาชีพ\nด้านบนคทา: เป็นตราสัญลักษณ์ของมหาวิทยาลัยซึ่งหมายถึงความรุ่งเรือง\nรูปพื้นหลังช่อดอกปีบทอง: เป็นดอกไม้ประจำมหาวิทยาลัยเทคโนโลยีสุรนารี\nดอกปีบทอง (มองจากด้านบน) ระหว่างตัวอักษร ซึ่งมี 5 แฉก หมายถึง: คุณหมอ 5 ดาว\nสีพื้นหลังเป็นสีขาว: หมายถึง เสื้อกาวน์สีขาวของแพทย์\n\n",
              "text_3": "มาตรฐานคุณวุฒิในสาขาวิชาแพทยศาสตร์ ระดับปริญญาตรี พ.ศ.2566\nอ่านรายละเอียดฉบับเต็ม อ่านรายละเอียดฉบับเต็ม \n\n\n",
              "text_4": "เกณฑ์ความรู้ความสามารถฯเพื่อรับใบอนุญาตเป็นผู้ประกอบวิชาชีพเวชกรรม พ.ศ.2567\nอ่านรายละเอียดฉบับเต็ม อ่านรายละเอียดฉบับเต็ม\n\n",
              "text_5": "จากปรัชญา สู่คุณลักษณะบัณฑิตที่พึงประสงค์\nอ่านรายละเอียดฉบับเต็ม อ่านรายละเอียดฉบับเต็ม"
            }
          ],
          "image": [
            {
              "image_0": "__PUBLIC_URL__/service-sut/image/2025/LOG0-2.jpg"
            }
          ],
          "link": [
            {
              "link_0": "https://www.cotmes.net/wp-content/uploads/2024/03/2144_%E0%B8%9B%E0%B8%A3%E0%B8%B0%E0%B8%81%E0%B8%B2%E0%B8%A8-%E0%B8%81%E0%B8%A1%E0%B8%AD.-%E0%B9%80%E0%B8%A3%E0%B8%B7%E0%B9%88%E0%B8%AD%E0%B8%87-%E0%B8%A1%E0%B8%B2%E0%B8%95%E0%B8%A3%E0%B8%90%E0%B8%B2%E0%B8%99%E0%B8%84%E0%B8%B8%E0%B8%93%E0%B8%A7%E0%B8%B8%E0%B8%92%E0%B8%B4%E0%B9%83%E0%B8%99%E0%B8%AA%E0%B8%B2%E0%B8%82%E0%B8%B2%E0%B8%A7%E0%B8%B4%E0%B8%8A%E0%B8%B2%E0%B9%81%E0%B8%9E%E0%B8%97%E0%B8%A2%E0%B8%A8%E0%B8%B2%E0%B8%AA%E0%B8%95%E0%B8%A3%E0%B9%8C-%E0%B8%9E.%E0%B8%A8.2566.pdf",
              "link_1": "https://tmc.or.th/Media/media-2024-01-22-09-40-35.pdf",
              "link_2": "https://drive.google.com/file/d/1saHwHOLQXzfk4GTkkAMZXAWE8ZUme7ms/view"
            }
          ]
        },
        "question": {
          "title": "Frequently Asked Questions",
          "type": [
            {
              "id": "5",
              "courseID": "5",
              "title": "เกี่ยวกับการแจ้งจบ การขอ Transcript การขอใบรับรอง",
              "createAt": "2022-07-23 10:12:11",
              "updateAt": "2022-07-23 10:12:11",
              "year": "2025",
              "question": [
                {
                  "id": "19",
                  "questionTypeID": "5",
                  "question": "การแจ้งจบต้องใช้เอกสารอะไรบ้างครับ ?",
                  "answers": "ยื่นคำร้องแจ้งผ่าน Web ดูกำหนดการที่ปฏิทินการศึกษา ที่ฝ่ายประมวลผลฯ ศูนย์บริการการศึกษา",
                  "year": "2025"
                },
                {
                  "id": "20",
                  "questionTypeID": "5",
                  "question": "ถ้าไม่สะดวกไปรับเอกสารสําเร็จการศึกษาด้วยตนเองให้คนอื่นไปรับแทนได้ไหม แล้วต้องทําอย่างไร ?",
                  "answers": "ได้คะ เขียนใบมอบฉันทะ และแนบสำเนาบัตรประชาชน ทั้งผู้มอบฉันทะ และผู้รับมอบฉันทะ ให้คนที่จะมารับแทนยื่น",
                  "year": "2025"
                },
                {
                  "id": "21",
                  "questionTypeID": "5",
                  "question": "ถ้าเอกสารสำเร็จการศึกษาสูญหาย ประสงค์จะขอใหม่ต้องใช้เอกสารอะไรบ้าง ?",
                  "answers": "ให้เขียนคำร้องที่ศูนย์บริการการศึกษา และชำระเงินค่าธรรมเนียมค่ะ",
                  "year": "2025"
                }
              ]
            },
            {
              "id": "6",
              "courseID": "5",
              "title": "เกี่ยวกับสัญญาการเป็นนักศึกษาแพทย์",
              "createAt": "2022-07-23 10:12:11",
              "updateAt": "2022-07-23 10:12:11",
              "year": "2025",
              "question": [
                {
                  "id": "22",
                  "questionTypeID": "6",
                  "question": "สัญญาการเป็นนักศึกษาแพทย์ จะได้รับเมื่อไหร่ ?",
                  "answers": "ได้รับเมื่อนายแพทย์สาธารณสุขจังหวัด ลงนามในสัญญาเรียบร้อยแล้ว",
                  "year": "2025"
                },
                {
                  "id": "23",
                  "questionTypeID": "6",
                  "question": "สัญญาการเป็นนักศึกษาแพทย์ สูญหาย จะดำเนินการอย่างไร ?",
                  "answers": "ติดต่อยื่นคำร้องที่สำนักวิชาแพทยศาสตร์",
                  "year": "2025"
                }
              ]
            },
            {
              "id": "7",
              "courseID": "5",
              "title": "เกี่ยวกับการเงิน",
              "createAt": "2022-07-23 10:12:11",
              "updateAt": "2022-07-23 10:12:11",
              "year": "2025",
              "question": [
                {
                  "id": "24",
                  "questionTypeID": "7",
                  "question": "การขอผ่อนผันชําระเงินค่าธรรมเนียมการลงทะเบียนเรียนสามารถขอผ่อนผันฯ ได้ถึงเมื่อไหร่คะ ?",
                  "answers": "นักศึกษาขอผ่อนผันได้ 4 สัปดาห์ นับจากเปิดภาคการศึกษา แต่นักศึกษาจะต้องยื่นคําร้อง ขอผ่อนผันฯ ภายใน 11 วัน นับจากเปิดภาคการศึกษา",
                  "year": "2025"
                }
              ]
            },
            {
              "id": "8",
              "courseID": "5",
              "title": "เกี่ยวกับใบประกอบวิชาชีพเวชกรรม",
              "createAt": "2022-07-23 10:12:11",
              "updateAt": "2022-07-23 10:12:11",
              "year": "2025",
              "question": [
                {
                  "id": "25",
                  "questionTypeID": "8",
                  "question": "เลขที่อนุมัติใบประกอบวิชาชีพ จะทราบได้อย่างไร ?",
                  "answers": "แพทยสภา จะเป็นผู้แจ้งให้แก่นักศึกษาเอง ผ่านระบบของแพทยสภา",
                  "year": "2025"
                },
                {
                  "id": "26",
                  "questionTypeID": "8",
                  "question": "ใบประกอบวิชาชีพจะรับได้เมื่อไหร่ ?",
                  "answers": "ช่วงเดือนตุลาคม-พฤศจิกายนของทุกปี โดยสำนักวิชาแพทยศาสตร์จะเป็นผู้รับจากแพทยสภา และนำส่งให้แก่นักศึกษา",
                  "year": "2025"
                },
                {
                  "id": "27",
                  "questionTypeID": "8",
                  "question": "ภาพถ่ายติดใบสมัครขึ้นทะเบียนเป็นผู้ประกอบวิชาชีพ จะต้องแต่งกายอย่างไร ?",
                  "answers": "สวมครุยวิทยะฐานะ และขนาดตามที่แพทยสภากำหนด",
                  "year": "2025"
                },
                {
                  "id": "28",
                  "questionTypeID": "8",
                  "question": "สามารถสอบประเมินความรู้ความสามารถในการประกอบวิชาชีพเวชกรรม ได้กี่ครั้ง ?",
                  "answers": "ยังไม่ได้จำกัดจำนวนครั้ง แต่ต้องสอบขั้นตอนที่ 1 และ 2 ให้ผ่านก่อนถึงจะมีสิทธิ์สอบขั้นตอนที่ 3 ได้",
                  "year": "2025"
                },
                {
                  "id": "29",
                  "questionTypeID": "8",
                  "question": "สามารถเก็บผลการสอบไว้ได้กี่ปี ?",
                  "answers": "ผลการสอบขั้นตอนที่ 1 และ 2 แต่ละขั้นตอนสามารถเก็บไว้ได้ 7 ปี นับจากวันที่แพทยสภาอนุมัติผลการสอบนั้น ๆ จนถึงวันยื่นสมัครสอบขั้นตอนที่ 3 และขั้นตอนที่ 3 สามารถเก็บไว้ได้ 3 ปี นับจากวันที่แพทยสภารับรองผลการสอบ",
                  "year": "2025"
                },
                {
                  "id": "30",
                  "questionTypeID": "8",
                  "question": "ผลการสอบมีวันหมดอายุหรือไม่ ?",
                  "answers": "ผลการสอบขั้นตอนที่ 1 และ 2 แต่ละขั้นตอนมีอายุ 7 ปี นับจากวันที่แพทยสภาอนุมัติผลการสอบนั้น ๆ จนถึงวันยื่นสมัครสอบขั้นตอนที่ 3 และขั้นตอนที่ 3 มีอายุ 3 ปี นับจากวันที่แพทยสภารับรองผลการสอบ",
                  "year": "2025"
                }
              ]
            }
          ]
        },
        "contract": [
          {
            "id": "449",
            "courseID": "5",
            "slang": "",
            "department": "หลักสูตรของสำนักวิชาแพทยศาสตร์",
            "phone": "044-223-922, 044-223-975",
            "site": "https://beta.sut.ac.th/im/",
            "createAt": "2022-07-16 14:39:53",
            "updateAt": "2022-07-16 14:39:53",
            "year": "2025"
          },
          {
            "id": "453",
            "courseID": "5",
            "slang": "medicine",
            "department": "แพทยศาสตรบัณฑิต",
            "phone": "",
            "site": "",
            "createAt": "2022-07-27 05:24:33",
            "updateAt": "2022-07-27 05:24:33",
            "year": "2025"
          }
        ],
        "visitor": 2773,
        "visitor_of_year": 442
      }
    },
    "department-nursing": {
      "code": 200,
      "status": "Get data success",
      "data": {
        "id": "6",
        "nameTH": "สำนักวิชาพยาบาลศาสตร์",
        "nameEN": "Institute of Nursing",
        "slang": "department-nursing",
        "image": "__PUBLIC_URL__/service-sut/image/Institute/pic-06.png",
        "createAt": "2022-07-09 03:49:33",
        "updataAt": "2022-07-09 03:49:33",
        "y2025": null,
        "y2024": null,
        "y2023": "__PUBLIC_URL__/service-sut/ebook-freshmen/2566/Institute_of_Nursing/Institute_of_Nursing.html",
        "y2022": "__PUBLIC_URL__/service-sut/ebook-freshmen/2565/Institute_of_Nursing/Institute_of_Nursing.html",
        "y2021": "__PUBLIC_URL__/service-sut/ebook-freshmen/2564/Institute_of_Nursing/Institute_of_Nursing.html",
        "y2020": "__PUBLIC_URL__/service-sut/ebook-freshmen/2563/Institute_of_Nursing/Institute_of_Nursing.html",
        "message": {
          "title": "สารจากคณบดี\nรองศาสตราจารย์ ดร.ศรีเกียรติ อนันต์สวัสดิ์",
          "text": [
            {
              "text_0": "ยินดีต้อนรับนักศึกษาใหม่ทุกคน ที่จะก้าวเข้าสู่รั้วของสำนักวิชาพยาบาลศาสตร์ มหาวิทยาลัยเทคโนโลยีสุรนารี สำนักวิชาพยาบาลศาสตร์เป็นสำนักวิชาแห่งการสร้างสรรค์นวัตกรรม ผลิตบัณฑิตพยาบาลให้มีอัตลักษณ์  “ผู้มีภูมิรู้ ภูมิธรรม ภูมิปัญญา ภูมิฐาน” การจัดการศึกษาในสำนักวิชาพยาบาลศาสตร์ นอกจากการเรียนภาคทฤษฎี ต้องทดลองปฏิบัติการพยาบาลในห้องปฏิบัติทักษะการพยาบาล และการฝึกปฏิบัติการพยาบาลกับผู้ป่วยจริง ซึ่งเป็นหัวใจของหลักสูตรพยาบาล ที่ต้องฝึกงานในโรงพยาบาลระดับต่าง ๆ ที่มีความพร้อม และได้มาตรฐาน ต้องประยุกต์ความรู้มาใช้ในการดูแลสุขภาพประชาชนแบบองค์รวมทั้งด้านร่างกาย จิตใจและสังคม และจิตวิญญาณ ซึ่งนักศึกษาต้องมีระเบียบวินัย มีความรับผิดชอบ เพราะเป็นการเรียนที่เกี่ยวข้องกับชีวิตของมนุษย์ ดังคำสอนของสมเด็จย่า “เด็กๆ ต้องฝึกหัดอบรมทั้งกายทั้งใจให้เข้มแข็งเป็นระเบียบและสุจริต เพื่อประโยชน์ของตนในภายหน้า เพราะคนที่ไม่เข้มแข็ง ไม่สามารถควบคุมกายใจให้อยู่ในระเบียบและความดียากนักที่จะได้ประสบความสำเร็จและความเจริญอย่างแท้จริง”  การศึกษาพยาบาลเป็นวิชาชีพที่ต้องยึดหลักเมตตา กรุณา เอื้ออาทร ฉะนั้นทุกวันที่ฝึกงานนักศึกษาจะได้รับคำอวยพร ยกย่องจากผู้ป่วย เป็นการสร้างบุญ ทำบุญกับผู้ที่มีความทุกข์ยากและสามารถนำองค์ความรู้มาดูแลบิดา มารดา ญาติพี่น้องของตนได้ด้วย นอกจากนี้สำนักวิชาฯ ยังส่งเสริมให้นักศึกษาพัฒนาและใช้ผลงานวิจัย หรือพัฒนานวัตกรรมในการดูแลสุขภาพประชาชน อีกทั้งยังสนับสนุนการเข้าใจความแตกต่างวัฒนธรรมของผู้รับบริการ การส่งเสริมความเป็นนานาชาติ ซึ่งสำนักวิชาฯ มีเครืองข่ายความร่วมมือทั้งเอเชีย ภาคพื้นยุโรป และสหรัฐอเมริกา เป็นต้น เพื่อเป็นบัณฑิตพยาบาลที่มีคุณลักษณะตามที่ผู้ใช้บัณฑิตต้องการ ในองค์ความรู้ที่กว้างไกลและลึกซึ้ง เพื่อให้มีความพร้อมในการปฏิบัติการพยาบาลได้ตามความต้องการของสังคม"
            }
          ],
          "image": [
            {
              "image_0": "__PUBLIC_URL__/service-sut/image/image_2024/Img/07-Nurs/06-Nursing.png",
              "image_1": "__PUBLIC_URL__/service-sut/image/nursing/VDO.png",
              "image_2": "__PUBLIC_URL__/service-sut/image/2_Institute/vdo/vdo6-nurs.mp4"
            }
          ]
        },
        "criterion": {
          "title": "การพิจารณาตัดสินผลของรายวิชาพยาบาลศาสตร์",
          "text": [
            {
              "text_0": "เกณฑ์การตัดสินผล รายวิชาทฤษฎี",
              "text_1": "1) เกณฑ์ได้/ตก ตัดสินผลแบบอิงเกณฑ์ ผ่านร้อยละ 60",
              "text_2": "คือ A, B+, B, C+, C, D และ F",
              "text_3": "2) เกณฑ์การตัดเกรด",
              "text_4": "≥80 = A",
              "text_5": "75 - 79 = B+",
              "text_6": "70 - 74 = B",
              "text_7": "65 - 69 = C+",
              "text_8": "60 - 64 = C",
              "text_9": "55 - 59 = D+",
              "text_10": "50 - 54 = D",
              "text_11": "<50 = F"
            }
          ],
          "image": [
            {
              "image_0": ""
            }
          ]
        },
        "criterion1": {
          "title": "เกณฑ์การตัดสินผล รายวิชาภาคปฏิบัติ",
          "text": [
            {
              "text_0": "1) เกณฑ์ได้/ตก ตัดสินแบบอิงเกณฑ์ผ่านขั้นต่ำ ร้อยละ 70",
              "text_1": "2) มีประสบการณ์ขั้นต่ำตามที่รายวิชากำหนด",
              "text_2": "3) มีเวลาในการฝึกงานครบ 100%",
              "text_3": "4) เกณฑ์การตัดเกรด ตัดสินแบบอิงเกณฑ์",
              "text_4": "90 - 100 = A",
              "text_5": "85 - 89 = B+",
              "text_6": "80 - 84 = B",
              "text_7": "75 - 79 = C+",
              "text_8": "70 - 74 = C"
            }
          ],
          "image": [
            {
              "image_0": ""
            }
          ]
        },
        "teacher": {
          "title": "ความสำคัญของการเข้าพบอาจารย์ที่ปรึกษา",
          "text": [
            {
              "text_0": "1) ท่านมีมุมมองและวิธีรับมือกับปัญหาอย่างมืออาชีพ",
              "text_1": "2) ท่านมีประสบการณ์ที่สั่งสมจากความสำเร็จและความผิดพลาดของนักศึกษารุ่นก่อน ๆ",
              "text_2": "3) ควรเข้าพบเพื่อวางแผนการเรียนในแต่ละเทอม",
              "text_3": "4) ควรหาโอกาสไปพบอาจารย์ที่ปรึกษาเพื่อรับคำแนะนำก่อนวันสุดท้ายของการถอนรายวิชาเมื่อสอบกลางภาคแล้ว",
              "text_4": "Note: ควรนัดหมายอาจารย์ที่ปรึกษาก่อนเข้าพบทาง E-mail หรือช่องทางอื่นที่อาจารย์ที่ปรึกษาแจ้ง"
            }
          ],
          "image": [
            {
              "image_0": "__PUBLIC_URL__/service-sut/image/nursing/Group%20377.png"
            }
          ]
        },
        "estermate": {
          "title": "ความสำคัญของการประเมินการสอน",
          "text": [
            {
              "text_0": "1) ช่วยให้อาจารย์ทราบถึงปัญหาที่เกิดจากการสอน เช่น วิธีสอน สื่อที่ใช้ ข้อสอบ เป็นต้น",
              "text_1": "2) อาจารย์สามารถปรับปรุงและพัฒนาการสอนในแต่ละวิชาให้มีประสิทธิภาพมากขึ้น",
              "text_2": "3) อาจารย์ที่ตั้งใจสอน และได้ผลประเมินดีมากจะได้มีกำลังใจทำเพื่อนักศึกษาต่อไป",
              "text_3": "วิธีเข้าประเมินการสอน",
              "text_4": "1) Log in: reg.sut.ac.th",
              "text_5": "2) ไปที่เมนู “ประเมินอาจารย์”",
              "text_6": "3) นักศึกษาตอบคำถามในแบบประเมิน และสามารถแสดงความคิดเห็นได้ โดยที่อาจารย์ ไม่สามารถเห็นชื่อนักศึกษาที่เข้าประเมินได้",
              "text_7": "4) สามารถเข้าประเมินได้ในสัปดาห์ที่ 6 ถึงสอบปลายภาคการศึกษา"
            }
          ],
          "image": [
            {
              "image_0": "__PUBLIC_URL__/service-sut/image/nursing/Group%20342.png"
            }
          ]
        },
        "vow": {
          "title": "คำปฏิญาณตนขอรับตะเกียง",
          "text": [
            {
              "text_0": "“ข้าพเจ้า (ชื่อ) ขอปฏิญาณต่อพระศรีรัตนตรัย และที่ประชุมนี้ว่า ข้าพเจ้าจะใช้ความรู้ความสามารถ ซึ่งได้รับประสิทธิ์ประสาทจากสถาบันแห่งนี้ ไปประกอบอาชีพแต่ในทางที่เป็นคุณเพื่อประโยชน์สุขของเพื่อนมนุษย์ทั้งปวง",
              "text_1": "ข้าพเจ้าจะดำเนินชีวิตอยู่ในหลักธรรมอันดี ปฏิบัติหน้าที่อย่างเต็มกำลังความสามารถด้วยความซื่อสัตย์สุจริต รับผิดชอบในการงานที่ได้รับมอบหมายให้ และจะพยายามศึกษาค้นคว้าหาความรู้ เพิ่มเติมอยู่เสมอ เพื่อเชิดชูวิทยฐานะของวิชาชีพให้เด่นขึ้น",
              "text_2": "ข้าพเจ้า จะเป็นผู้ไว้วางใจได้ในเรื่องส่วนตัว และความลับของครอบครัว ของผู้ที่อยู่ในการรักษาของข้าพเจ้า ข้าพเจ้า จะเสียสละ บำเพ็ญตน เพื่อประโยชน์ส่วนรวมตลอดไป”"
            }
          ],
          "image": [
            {
              "image_0": "__PUBLIC_URL__/service-sut/image/nursing/Group%20390.png"
            }
          ]
        },
        "song": {
          "title": "เพลงมาร์ชพยาบาล",
          "text": [
            {
              "text_0": "“อันความกรุณาปราณี",
              "text_1": "จะมีใครบังคับก็หาไม่",
              "text_2": "หลั่งมาเองเหมือนฝนอันชื่นใจ",
              "text_3": "จากฟากฟ้าสุราลัยสู่แดนดิน",
              "text_4": "ข้อความนี้องค์พระธีรราชเจ้า",
              "text_5": "พระโปรดเกล้าประทานให้ใจถวิล",
              "text_6": "ใช้คุณค่ากรุณาไว้อาจิณ",
              "text_7": "ดั่งวารินจากฟ้าสู่สากล",
              "text_8": "อันพวกเราเหล่านักเรียนพยาบาล",
              "text_9": "ปณิธานอนุกูลเพิ่มพูนผล",
              "text_10": "เรียนวิชากรุณาช่วยปวงชน",
              "text_11": "ผู้เจ็บไข้ได้พ้นทุกข์ทรมาน",
              "text_12": "แม้โรคร้ายจะแพร่พิษถึงปลิดชีพ",
              "text_13": "จะยึดหลักดวงประทีปคือสงสาร",
              "text_14": "ยอมเหนื่อยยากตรากตรำใจสำราญ",
              "text_15": "อุทิศงานเพื่อคนไข้ทั้งใจกาย",
              "text_16": "พระราชนิพนธ์ โดย",
              "text_17": "พระบาทสมเด็จพระมงกุฎเกล้าเจ้าอยู่หัว",
              "text_18": "และท่านผู้หญิงละเอียด พิบูลสงคราม\r\n“"
            }
          ],
          "image": [
            {
              "image_0": ""
            }
          ]
        },
        "advice": {
          "title": "ข้อแนะนำของสำนักวิชาพยาบาลศาสตร์",
          "text": [
            {
              "text_0": "รายละเอียดของรายวิชาในหลักสูตร",
              "text_1": "เรียนพยาบาล มทส. อย่างไรให้จบตามเวลา ?",
              "text_2": "การพิจารณาตัดสินผลของรายวิชาพยาบาลศาสตร์",
              "text_3": "ความสำคัญของการเข้าพบอาจารย์ที่ปรึกษา",
              "text_4": "ความสำคัญของการประเมินการสอน",
              "text_5": "ระบบรับเรื่องอุทธรณ์ร้องทุกข์",
              "text_6": "คำปฏิญาณตนขอรับตะเกียง",
              "text_7": "เพลงมาร์ชพยาบาล",
              "text_8": "ข้อบังคับว่าด้วยการศึกษาขั้นปริญญาตรี",
              "text_9": "ผลการเรียนรู้ที่คาดหวังของหลักสูตร"
            }
          ],
          "image": [
            {
              "image_0": ""
            }
          ]
        },
        "curriculum": {
          "title": "รายละเอียดของรายวิชาในหลักสูตร",
          "text": [
            {
              "text_0": "เพราะสิ่งที่ต้องเรียนนั้น มีรายละเอียดมากมาย มาดูข้อมูลรายละเอียดรายวิชาต่าง ๆ ที่น้อง ๆ ต้องเตรียมศึกษากันค่ะ\n\n",
              "text_1": "ดูข้อมูล"
            }
          ],
          "image": [
            {
              "image_0": "__PUBLIC_URL__/service-sut/image/2025/06/Img01-1.jpg"
            }
          ],
          "link": [
            {
              "link_0": "https://nurse.sut.ac.th/tqfdb/"
            }
          ]
        },
        "complaints_system": {
          "title": "ระบบรับเรื่องอุทธรณ์ร้องทุกข์",
          "text": [
            {
              "text_0": "เสียงของน้อง ๆ นักศึกษานั้น เราพร้อมรับฟัง หากสงสัยในการ “การตัดสินผลการเรียน” มาใช้ระบบรับเรื่องอุทธรณ์ร้องทุกข์ “การตัดสินผลการเรียน” สำหรับนักศึกษากันค่ะ\n\n",
              "text_1": "ไปหน้าระบบ"
            }
          ],
          "image": [
            {
              "image_0": "__PUBLIC_URL__/service-sut/image/2025/06/Img02-1.png"
            }
          ],
          "link": [
            {
              "link_0": "https://nurse.sut.ac.th/tqfdb/"
            }
          ]
        },
        "Expected_learning": {
          "title": "ผลการเรียนรู้ที่คาดหวังของหลักสูตร",
          "text": [
            {
              "text_0": "เมื่อจบการศึกษาตามหลักสูตรแล้ว ผู้เรียนจะมีสมรรถนะ 8 ด้าน (ผลการเรียนรู้ที่คาดหวังของหลักสูตร: Program learning outcomes) ดังนี้"
            }
          ],
          "image": [
            {
              "image_0": "__PUBLIC_URL__/service-sut/image/2025/06/POL2565%20Infographic%208%20Outcomes.png"
            }
          ]
        },
        "Regulations": {
          "title": "ข้อบังคับว่าด้วยการศึกษาขั้นปริญญาตรี",
          "text": [
            {
              "text_0": "ชวนน้อง ๆ มาอ่านกันข้อบังคับที่ควรรู้กัน\nอ่านฉบับแรก ปี พ.ศ. 2566\nอ่านฉบับที่สอง ปี พ.ศ. 2567"
            }
          ],
          "image": [
            {
              "image_0": "__PUBLIC_URL__/service-sut/image/2025/06/NURSE-Paper.png"
            }
          ],
          "link": [
            {
              "link_0": "__PUBLIC_URL__/service-sut/image/2025/06/%e0%b8%82%e0%b9%89%e0%b8%ad%e0%b8%9a%e0%b8%b1%e0%b8%87%e0%b8%84%e0%b8%a3%e0%b8%b1%e0%b8%9a%e0%b8%9b%e0%b8%a3%e0%b8%b4%e0%b8%8d%e0%b8%8d%e0%b8%b2%e0%b8%95%e0%b8%a3%e0%b8%b52566.pdf",
              "link_1": "__PUBLIC_URL__/service-sut/image/2025/06/%e0%b8%82%e0%b9%89%e0%b8%ad%e0%b8%9a%e0%b8%b1%e0%b8%87%e0%b8%84%e0%b8%b1%e0%b8%9a%e0%b8%9b%e0%b8%a3%e0%b8%b4%e0%b8%8d%e0%b8%8d%e0%b8%b2%e0%b8%95%e0%b8%a3%e0%b8%b52567.pdf"
            }
          ]
        },
        "study": {
          "title": "เรียนอย่างไรให้จบตามเวลา ?",
          "data": [
            {
              "id": "71",
              "courseID": "6",
              "detail": "เมื่อใดที่เริ่มตามบทเรียนไม่ทัน ต้องหยุดทำกิจกรรมและมุ่งที่การเรียนก่อน",
              "image": "__PUBLIC_URL__/service-sut/image/medicin/H06-med-6.png",
              "createAt": "2022-07-22 18:47:05",
              "updataAt": "2022-07-22 18:47:05",
              "year": "2025"
            },
            {
              "id": "72",
              "courseID": "6",
              "detail": "ไม่ขาดเรียน อาศัยความเพียร ความมุ่งมั่นเป็นที่ตั้ง",
              "image": "__PUBLIC_URL__/service-sut/image/nursing/H07-nurs-1.png",
              "createAt": "2022-07-23 10:36:22",
              "updataAt": "2022-07-23 10:36:22",
              "year": "2025"
            },
            {
              "id": "73",
              "courseID": "6",
              "detail": "ยึดหลักการที่จะไม่ลอกการบ้านใคร ทำการบ้านไม่ได้ให้ไปหาอาจารย์ผู้สอน",
              "image": "__PUBLIC_URL__/service-sut/image/nursing/H07-nurs-2.png",
              "createAt": "2022-07-23 10:36:22",
              "updataAt": "2022-07-23 10:36:22",
              "year": "2025"
            },
            {
              "id": "74",
              "courseID": "6",
              "detail": "ทบทวนและทำการบ้านด้วยตนเอง หลังการเรียนทุกครั้ง",
              "image": "__PUBLIC_URL__/service-sut/image/nursing/H07-nurs-3.png",
              "createAt": "2022-07-23 10:36:22",
              "updataAt": "2022-07-23 10:36:22",
              "year": "2025"
            },
            {
              "id": "75",
              "courseID": "6",
              "detail": "เข้าไปฝึกทักษะการพยาบาล ในห้องทดลองปฏิบัติการพยาบาล (Nursing Skill Laboratory) บ่อย ๆ",
              "image": "__PUBLIC_URL__/service-sut/image/nursing/H07-nurs-4.png",
              "createAt": "2022-07-23 10:36:22",
              "updataAt": "2022-07-23 10:36:22",
              "year": "2025"
            },
            {
              "id": "76",
              "courseID": "6",
              "detail": "พบอาจารย์ที่ปรึกษาอย่างสม่ำเสมอ จะทำให้เราได้ที่พึ่งทั้งการเรียนและการใช้ชีวิต",
              "image": "__PUBLIC_URL__/service-sut/image/nursing/H07-nurs-5.png",
              "createAt": "2022-07-23 10:36:22",
              "updataAt": "2022-07-23 10:36:22",
              "year": "2025"
            },
            {
              "id": "77",
              "courseID": "6",
              "detail": "เมื่อใดที่เริ่มตามบทเรียนไม่ทัน ต้องหยุดทำกิจกรรมและมุ่งที่การเรียนก่อน",
              "image": "__PUBLIC_URL__/service-sut/image/nursing/H07-nurs-6.png",
              "createAt": "2022-07-23 10:36:22",
              "updataAt": "2022-07-23 10:36:22",
              "year": "2025"
            },
            {
              "id": "78",
              "courseID": "6",
              "detail": "อย่าลืมออกกำลังกายเป็นประจำ ถ้าร่างกายไม่แข็งแรงจะเป็นส่วนสำคัญมากที่จะทำให้ไม่สำเร็จการศึกษา",
              "image": "__PUBLIC_URL__/service-sut/image/nursing/H07-nurs-7.png",
              "createAt": "2022-07-23 10:36:22",
              "updataAt": "2022-07-23 10:36:22",
              "year": "2025"
            }
          ],
          "sub_title": "เราเรียนระบบ 3 เทอม แต่ละเทอมจะมีเวลาเพียง 12 สัปดาห์ สิ่งที่ต้องทำให้ได้คือการแบ่งเวลา เวลาเรียน เวลาเล่น เวลาทำกิจกรรมทำทุกอย่างให้สมดุล"
        },
        "contract": [
          {
            "id": "455",
            "courseID": "6",
            "slang": "nursing-science",
            "department": "หลักสูตรของสำนักวิชาพยาบาลศาสตร์",
            "phone": "",
            "site": "",
            "createAt": "2022-07-27 05:27:38",
            "updateAt": "2022-07-27 05:27:38",
            "year": "2025"
          },
          {
            "id": "464",
            "courseID": "6",
            "slang": "nursing-science-65",
            "department": "พยาบาลศาสตรบัณฑิต (หลักสูตรปรับปรุง พ.ศ. 2565)",
            "phone": "",
            "site": "",
            "createAt": "2022-07-30 15:54:17",
            "updateAt": "2022-07-30 15:54:17",
            "year": "2025"
          }
        ],
        "visitor": 2567,
        "visitor_of_year": 664
      }
    },
    "department-dentistry": {
      "code": 200,
      "status": "Get data success",
      "data": {
        "id": "7",
        "nameTH": "สำนักวิชาทันตแพทยศาสตร์",
        "nameEN": "Institute of Dentistry",
        "slang": "department-dentistry",
        "image": "__PUBLIC_URL__/service-sut/image/Institute/pic-07.png",
        "createAt": "2022-07-09 03:49:59",
        "updataAt": "2022-07-09 03:49:59",
        "y2025": null,
        "y2024": null,
        "y2023": "__PUBLIC_URL__/service-sut/ebook-freshmen/2566/Institute_of_Dentistry/Institute_of_Dentistry.html",
        "y2022": "__PUBLIC_URL__/service-sut/ebook-freshmen/2565/Institute_of_Dentistry/Institute_of_Dentistry.html",
        "y2021": "__PUBLIC_URL__/service-sut/ebook-freshmen/2564/Institute_of_Dentistry/Institute_of_Dentistry.html",
        "y2020": "__PUBLIC_URL__/service-sut/ebook-freshmen/2563/Institute_of_Dentistry/Institute_of_Dentistry.html",
        "message": {
          "title": "สารจากคณบดี\nศาสตราจารย์  ทันตแพทย์ ดร.พสุธา ธัญญะกิจไพศาล",
          "text": [
            {
              "text_0": "ในนามของอาจารย์และเจ้าหน้าที่สำนักวิชาทันตแพทยศาสตร์ทุกคน ขอแสดงความยินดีกับต้นกล้าปีบทองที่ได้ก้าวเข้าสู่รั้วของมหาวิทยาลัยเทคโนโลยีสุรนารี การใช้ชีวิตในมหาวิทยาลัยเป็นช่วงเวลาที่มีค่าและสำคัญในการบ่มเพาะให้น้องๆเข้มแข็ง เรียนรู้ชีวิตจากการเรียนในห้องเรียนและการปฏิบีติการ การเข้าสังคมและการดำรงชีพ จึงขอแนะให้น้องใหม่ทุกคนเก็บเกี่ยวความรู้ ประสบการณ์ และรู้จักเพื่อนใหม่ทั้งในสำนักต่างสำนักและต่างมหาวิทยาลัย ตลอดระยะเวลาที่ศึกษา ณ มหาวิทยาลัยแห่งนี้\n\n            ",
              "text_1": "สุดท้ายนี้ สำนักวิชาทันตแพทยศาสตร์ มทส. ขออวยพรให้นักศึกษาใหม่ทุกคน มีความสุขทั้งการเรียนและการใช้ชีวิต มีสุขภาพ พลานามัยแข็งแรงปลอดภัย มีพลังกาย พลังใจ ประสบความสำเร็จในทุกด้านตามที่ตนเองและครอบครัวมุ่งหวังไว้ เป็นกำลังสำคัญและเป็นผู้นำของประเทศในอนาคต\n\n            ",
              "text_2": "“เมื่อมีโอกาสให้ทำอย่างดีที่สุด เพราะโอกาสไม่ใช่อากาศที่มีให้ตลอดเวลา”\n            ",
              "text_3": "ยินดีด้วยครับ"
            }
          ],
          "image": [
            {
              "image_0": "__PUBLIC_URL__/service-sut/image/2023/department-dentistry/07-Dentistry.png",
              "image_1": "__PUBLIC_URL__/service-sut/image/dentistry/VDO.png",
              "image_2": "__PUBLIC_URL__/service-sut/image/2_Institute/vdo/vdo7-pubh.mp4"
            }
          ]
        },
        "regulations": {
          "title": "ข้อบังคับนักศึกษาทันตแพทย์",
          "text": [
            {
              "text_0": "ข้อบังคับว่าด้วยการศึกษาเพื่อปริญญาทันตแพทยศาตรบัณฑิต พ.ศ. 2564"
            }
          ],
          "image": [
            {
              "image_0": ""
            }
          ]
        },
        "pay": {
          "title": "ค่าใช้จ่ายในการเรียน",
          "text": [
            {
              "text_0": "หลักสูตรทันตแพทยศาสตร์ ระดับปริญญาตรี ตลอดหลักสูตร โดยประมาณ"
            }
          ],
          "image": [
            {
              "image_0": ""
            }
          ]
        },
        "pros": {
          "title": "จุดเด่นของทันตแพทย์ มทส.",
          "text": [
            {
              "text_0": "เรียนหมุนเวียน มทส. – รพ.แหล่งฝึก ",
              "text_1": "ในชั้นคลินิกปีที่ 5 มีการจัดการเรียนการสอนร่วมกับโรงพยาบาลในเขตสุขภาพที่ 9 (กลุ่มนครชัยบุรินทร์) โดยจะมีการหมุนเวียนนักศึกษาไปฝึกทักษะทางคลินิก เพื่อให้นักศึกษาได้คุ้นเคยกับสภาพแวดล้อมที่จะปฏิบัติงานภายหลังจากการสำเร็จการศึกษา ทำให้เกิดการปรับตัวและเรียนรู้งานได้เร็ว",
              "text_2": "ผลิตบัณฑิตในลักษณะแพทย์ช่องปาก",
              "text_3": "นักศึกษาทันตแพทย์จะได้เรียนรู้เกี่ยวกับระบบร่างกายก่อนจะลงลึกในส่วนของช่องปาก รวมถึงจะได้เรียนรู้ และฝึกให้การรักษาแบบเป็นองค์รวม ที่ไม่ได้ดูแลเฉพาะช่องปากเพียงอย่างเดียว ",
              "text_4": "เรียนรู้ในชุมชนจริง",
              "text_5": "บัณฑิตทันตแพทย์จะปฏิบัติงานชดใช้ทุนเมื่อสำเร็จการศึกษา ในสถานพยาบาลและหน่วยงานที่เกี่ยวข้อง หลักสูตรจึงจัดให้นักศึกษาทันตแพทย์เข้าไปสัมผัสกับพื้นที่เร็วขึ้น โดยกำหนดให้เรียนกลุ่มวิชาชนบทศึกษาทางการแพทย์และกลุ่มวิชาสุขภาพช่องปากครอบครัวและชุมชนตั้งแต่ชั้นปีที่ 2 รวมถึงมีการฝึกปฏิบัติงานในโรงพยาบาลต่าง ๆ ในชั้นคลินิก จึงทำให้นักศึกษาสามารถทำงานร่วมกับบุคลากรทางการแพทย์และสหวิชาชีพอื่น ๆ ได้ดีขึ้น"
            }
          ],
          "image": [
            {
              "image_0": "__PUBLIC_URL__/service-sut/image/dentistry/1-2.jpg",
              "image_1": "__PUBLIC_URL__/service-sut/image/dentistry/2-2.jpg",
              "image_2": "__PUBLIC_URL__/service-sut/image/dentistry/3-1.JPG"
            }
          ]
        },
        "q1": {
          "title": "นักศึกษาทันตแพทย์ เรียนอย่างไร ?",
          "text": [
            {
              "text_0": "ชั้นปีที่ 1 ",
              "text_1": "เรียนในกลุ่มรายวิชาศึกษาทั่วไป และวิทยาศาสตร์พื้นฐาน ",
              "text_2": "ดูวิดีโอ DENT SUT Y1 __PUBLIC_URL__/service-sut/image/image-2023/department-dentistry/VDO/DENT%20SUT%20Y1.mp4 ",
              "text_3": "ชั้นปีที่ 2-3 ",
              "text_4": "เรียนรายวิชาด้านวิทยาศาสตร์การแพทย์ (ระบบการทำงานของอวัยวะภายในร่างกาย ที่เกี่ยวข้องกับงานทันตกรรม) และวิชาชีพทันตแพทย์พื้นฐาน (สุขภาพช่องปากครอบครัวและชุมชน สุขภาพช่องปากของบุคคลวัยต่าง ๆ ทักษะทางคลินิกทันตกรรม ฯลฯ) ",
              "text_5": "ดูวิดีโอ DENT SUT Y2, ดูวิดีโอ DENT SUT Y3 __PUBLIC_URL__/service-sut/image/image-2023/department-dentistry/VDO/DENT%20SUT%20Y2.mp4 __PUBLIC_URL__/service-sut/image/image-2023/department-dentistry/VDO/DENT%20SUT%20Y3.mp4",
              "text_6": "ชั้นปีที่ 4 ",
              "text_7": "เรียนวิชาเฉพาะด้านวิชาชีพทันตแพทย์ ทั้งภาคทฤษฎีและฝึกทักษะในห้องปฏิบัติการ ",
              "text_8": "ดูวิดีโอ เปิดห้องแลปทันตแพทย์ มทส., ดูวิดีโอ DENT SUT Y4 __PUBLIC_URL__/service-sut/image/image-2023/department-dentistry/VDO/lab.mp4 h__PUBLIC_URL__/service-sut/image/image-2023/department-dentistry/VDO/DENT%20SUT%20Y4.mp4",
              "text_9": "ชั้นปีที่ 5 ",
              "text_10": "เรียนวิชาเฉพาะทางด้านวิชาชีพทันตแพทย์ และฝึกปฏิบัติงานคลินิกหมุนเวียนระหว่างศูนย์สุขภาพช่องปาก รพ.มทส. และในโรงพยาบาลแหล่งฝึก (รพ.มหาราชนครราชสีมา รพ.ชัยภูมิ รพ.บุรีรัมย์ รพ.สุรินทร์ และ รพ.ภูเขียวเฉลิมพระเกียรติ) ",
              "text_11": "ดูวิดีโอ DENT SUT Y5 __PUBLIC_URL__/service-sut/image/image-2023/department-dentistry/VDO/DENT%20SUT%20Y5.mp4 ",
              "text_12": "ชั้นปีที่ 6",
              "text_13": " ฝึกประสบการณ์ด้านคลินิก และฝึกปฏิบัติงานในสถานพยาบาลระดับต่าง ๆ เพื่อเรียนรู้ระบบการทำงานในสถานที่จริง รวมถึงเรียนรู้เกี่ยวกับนวัตกรรมวิทยาการสุขภาพช่องปาก และโครงการวิจัย ",
              "text_14": "ดูวิดีโอ DENT SUT Y6 __PUBLIC_URL__/service-sut/image/image-2023/department-dentistry/VDO/DENT%20SUT%20Y6.mp4",
              "text_15": "__PUBLIC_URL__/service-sut/image/image-2023/department-dentistry/VDO/Screenshot%20DENT%20SUT%20Y1-crop.png __PUBLIC_URL__/service-sut/image/image-2023/department-dentistry/VDO/Screenshot%20DENT%20SUT%20Y2-crop.png __PUBLIC_URL__/service-sut/image/image-2023/department-dentistry/VDO/Screenshot%20DENT%20SUT%20Y3-crop.png __PUBLIC_URL__/service-sut/image/image-2023/department-dentistry/VDO/Screenshot%20%e0%b9%80%e0%b8%9b%e0%b8%b4%e0%b8%94%e0%b8%ab%e0%b9%89%e0%b8%ad%e0%b8%87%e0%b9%81%e0%b8%a5%e0%b8%9b%e0%b8%97%e0%b8%b1%e0%b8%99%e0%b8%95%e0%b9%81%e0%b8%9e%e0%b8%97%e0%b8%a2%e0%b9%8c%20%e0%b8%a1%e0%b8%97%e0%b8%aa.-crop.png __PUBLIC_URL__/service-sut/image/image-2023/department-dentistry/VDO/Screenshot%20DENT%20SUT%20Y4-crop.png __PUBLIC_URL__/service-sut/image/image-2023/department-dentistry/VDO/Screenshot%20DENT%20SUT%20Y5-crop.png __PUBLIC_URL__/service-sut/image/image-2023/department-dentistry/VDO/Screenshot%20DENT%20SUT%20Y6-crop.png"
            }
          ],
          "image": [
            {
              "image_0": "__PUBLIC_URL__/service-sut/image/2023/department-dentistry/07-04-01.png",
              "image_1": "__PUBLIC_URL__/service-sut/image/dentistry/how_study/2.jpg",
              "image_2": "__PUBLIC_URL__/service-sut/image/dentistry/how_study/3.JPG"
            }
          ]
        },
        "q2": {
          "title": "นักศึกษาทันตแพทย์เรียนที่ไหน ?",
          "text": [
            {
              "text_0": "ห้องปฏิบัติการพัฒนาทักษะทางคลินิกสุขภาพช่องปาก DENT SUT https://www.youtube.com/watch?v=CvpRsIT1gy8\n",
              "text_1": "OHC Fun Fun https://youtu.be/-8RRTkFFhyg\n"
            }
          ],
          "image": [
            {
              "image_0": "__PUBLIC_URL__/service-sut/image/2023/department-dentistry/05/where_study-01.jpeg",
              "image_1": "__PUBLIC_URL__/service-sut/image/2023/department-dentistry/05/where_study-02.jpeg",
              "image_2": "__PUBLIC_URL__/service-sut/image/2023/department-dentistry/05/where_study-03.jpeg",
              "image_3": "__PUBLIC_URL__/service-sut/image/2023/department-dentistry/05/where_study-04.jpeg",
              "image_4": "__PUBLIC_URL__/service-sut/image/2023/department-dentistry/05/where_study-05.jpeg",
              "image_5": "__PUBLIC_URL__/service-sut/image/2023/department-dentistry/05/where_study-06.jpeg",
              "image_6": "__PUBLIC_URL__/service-sut/image/2023/department-dentistry/05/where_study-07.jpeg",
              "image_7": "__PUBLIC_URL__/service-sut/image/2023/department-dentistry/05/where_study-08.jpeg"
            }
          ]
        },
        "q3": {
          "title": "การสอบแก้ตัว คืออะไร ?",
          "text": [
            {
              "text_0": "ในการเรียนการสอนตั้งแต่ชั้นปีที่ 2 จะเรียนแบบ Block Course System คือ เมื่อเรียนจบในแต่ละวิชา จะมีการสอบวัดผลการศึกษาให้แล้วเสร็จจึงเรียนในรายวิชาถัดไป ดังนั้น หากนักศึกษาสอบไม่ผ่านตามเกณฑ์ที่รายวิชากำหนด รายวิชาจะจัดให้มีการสอบแก้ตัว แต่ทั้งนี้ รูปแบบ และเกณฑ์การสอบจะเป็นไปตามที่รายวิชากำหนด"
            }
          ],
          "image": [
            {
              "image_0": ""
            }
          ]
        },
        "q4": {
          "title": "ถ้าติด F จะต้องทำอย่างไร ?",
          "text": [
            {
              "text_0": "1. วางแผนการเรียนร่วมกับสำนักวิชาฯ",
              "text_1": "2. ลงทะเบียนเรียนใหม่เมื่อ\nรายวิชาที่ได้ “F” เปิดสอน"
            }
          ],
          "image": [
            {
              "image_0": ""
            }
          ]
        },
        "q5": {
          "title": "ความสําคัญของการประเมินการเรียนสอน",
          "text": [
            {
              "text_0": "1) ช่วยให้อาจารย์ทราบถึงปัญหาที่เกิดขึ้นในกระบวนการเรียนการสอน เช่น วิธีสอน สื่อที่ใช้ ข้อสอบ เป็นต้น\n",
              "text_1": "2) อาจารย์สามารถปรับปรุงและพัฒนาการสอนในแต่ละวิชาให้มีประสิทธิภาพมากขึ้น\n\n",
              "text_2": "วิธีเข้าประเมินการสอน\n",
              "text_3": "1) Log in: reg.sut.ac.th\n",
              "text_4": "2) ไปที่เมนู “ประเมินอาจารย์”\n",
              "text_5": "3) นักศึกษาตอบคำถามในแบบประเมิน และสามารถแสดงความคิดเห็นได้ โดยที่อาจารย์ ไม่สามารถเห็นชื่อนักศึกษาที่เข้าประเมินได้\n",
              "text_6": "4) สามารถเข้าประเมินในระยะเวลาภายใน 1 สัปดาห์หลังสิ้นสุดการเรียนการสอน"
            }
          ],
          "image": [
            {
              "image_0": "__PUBLIC_URL__/service-sut/image/dentistry/Group%20342.png"
            }
          ]
        },
        "q6": {
          "title": "ทำไมนักศึกษาทันตแพทย์ ควรอยู่หอพักในมหาวิทยาลัย ?",
          "text": [
            {
              "text_0": "1) ได้รู้จักเพื่อนต่างสาขา (จากการทำกิจกรรม และอื่น ๆ)",
              "text_1": "2) เนื่องจากในปี 5 และ 6 จะต้องเรียนชั้นคลินิกแบบหมุนเวียนระหว่างศูนย์สุขภาพช่องปาก โรงพยาบาล มทส. และโรงพยาบาลแหล่งฝึก (ที่ละ 20 สัปดาห์โดยประมาณ)",
              "text_2": "ดังนั้น การมีหอพักในมหาวิทยาลัยจึงสะดวกประหยัดและปลอดภัย",
              "text_3": "รีวิวมทส. หอพักหญิงมทส. ห้องแอร์ https://www.youtube.com/watch?v=2aNaasEuj18\n",
              "text_4": "Live in SUT EP.08 : เป็นเด็กหอ มทส. ต้องเจอสิ่งนี้!! https://www.youtube.com/watch?v=64HMEN8Qn8I"
            }
          ],
          "image": [
            {
              "image_0": "__PUBLIC_URL__/service-sut/image/2023/department-dentistry/07-09-01.png",
              "image_1": "__PUBLIC_URL__/service-sut/image/2023/department-dentistry/07-09-02.png",
              "image_2": "__PUBLIC_URL__/service-sut/image/2023/department-dentistry/07-09-03.png"
            }
          ]
        },
        "q7": {
          "title": "นักศึกษาทันตแพทย์แต่งตัวอย่างไร ?",
          "text": [
            {
              "text_0": "ข้อบังคับมหาวิทยาลัยเทคโนโลยีสุรนารี ว่าด้วย เครื่องแต่งกายนักศึกษามหาวิทยาลัยเทคโนโลยีสุรนารี พ.ศ. 2545 http://web.sut.ac.th/dsa/discipline/images/vinai/sh45.pdf\n",
              "text_1": "แนวปฏิบัติการแต่งกายนักศึกษาทันตแพทย์ชั้นคลินิก https://drive.google.com/file/d/1Yed35yq_DzFckxO7E1ffHp5S6EoLBi28/view\n",
              "text_2": "ระเบียบการแต่งกายนักศึกษา คลินิกการเรียนการสอน แหล่งฝึกศูนย์สุขภาพช่องปาก โรงพยาบาลมหาวิทยาลัยเทคโนโลยีสุรนารี https://drive.google.com/file/d/1idZvrD7PtCD4e0TQgCoQE2gRk5BaTeFn/view",
              "text_3": "ชุดพิธีการ\n",
              "text_4": "ชุดนักศึกษา (ชั้นปรีคลินิก)\n",
              "text_5": "ชุดนักศึกษา (ชั้นคลินิก)\n",
              "text_6": "ชุดปฏิบัติการ (ชั้นปรีคลินิก)\n",
              "text_7": "ชุดปฏิบัติการ (ชั้นคลินิก)"
            }
          ],
          "image": [
            {
              "image_0": "__PUBLIC_URL__/service-sut/image/2023/department-dentistry/10/%e0%b8%9e%e0%b8%b4%e0%b8%98%e0%b8%b5%e0%b8%81%e0%b8%b2%e0%b8%a31.png __PUBLIC_URL__/service-sut/image/2023/department-dentistry/10/%e0%b8%9e%e0%b8%b4%e0%b8%98%e0%b8%b5%e0%b8%81%e0%b8%b2%e0%b8%a32.png \n|\n__PUBLIC_URL__/service-sut/image/2023/department-dentistry/10/%e0%b8%99%e0%b8%b1%e0%b8%81%e0%b8%a8%e0%b8%b6%e0%b8%81%e0%b8%a9%e0%b8%b2-%e0%b8%8a%e0%b8%b1%e0%b9%89%e0%b8%99%e0%b8%9b%e0%b8%a3%e0%b8%b5%e0%b8%84%e0%b8%a5%e0%b8%b4%e0%b8%99%e0%b8%b4%e0%b8%811.png __PUBLIC_URL__/service-sut/image/2023/department-dentistry/10/%e0%b8%99%e0%b8%b1%e0%b8%81%e0%b8%a8%e0%b8%b6%e0%b8%81%e0%b8%a9%e0%b8%b2-%e0%b8%8a%e0%b8%b1%e0%b9%89%e0%b8%99%e0%b8%9b%e0%b8%a3%e0%b8%b5%e0%b8%84%e0%b8%a5%e0%b8%b4%e0%b8%99%e0%b8%b4%e0%b8%812.png __PUBLIC_URL__/service-sut/image/2023/department-dentistry/10/%e0%b8%99%e0%b8%b1%e0%b8%81%e0%b8%a8%e0%b8%b6%e0%b8%81%e0%b8%a9%e0%b8%b2-%e0%b8%8a%e0%b8%b1%e0%b9%89%e0%b8%99%e0%b8%9b%e0%b8%a3%e0%b8%b5%e0%b8%84%e0%b8%a5%e0%b8%b4%e0%b8%99%e0%b8%b4%e0%b8%813.png __PUBLIC_URL__/service-sut/image/2023/department-dentistry/10/%e0%b8%99%e0%b8%b1%e0%b8%81%e0%b8%a8%e0%b8%b6%e0%b8%81%e0%b8%a9%e0%b8%b2-%e0%b8%8a%e0%b8%b1%e0%b9%89%e0%b8%99%e0%b8%9b%e0%b8%a3%e0%b8%b5%e0%b8%84%e0%b8%a5%e0%b8%b4%e0%b8%99%e0%b8%b4%e0%b8%814.png \n|\n__PUBLIC_URL__/service-sut/image/2023/department-dentistry/10/%e0%b8%99%e0%b8%b1%e0%b8%81%e0%b8%a8%e0%b8%b6%e0%b8%81%e0%b8%a9%e0%b8%b2-%e0%b8%84%e0%b8%a5%e0%b8%b4%e0%b8%99%e0%b8%b4%e0%b8%811.png __PUBLIC_URL__/service-sut/image/2023/department-dentistry/10/%e0%b8%99%e0%b8%b1%e0%b8%81%e0%b8%a8%e0%b8%b6%e0%b8%81%e0%b8%a9%e0%b8%b2-%e0%b8%84%e0%b8%a5%e0%b8%b4%e0%b8%99%e0%b8%b4%e0%b8%812.png __PUBLIC_URL__/service-sut/image/2023/department-dentistry/10/%e0%b8%99%e0%b8%b1%e0%b8%81%e0%b8%a8%e0%b8%b6%e0%b8%81%e0%b8%a9%e0%b8%b2-%e0%b8%84%e0%b8%a5%e0%b8%b4%e0%b8%99%e0%b8%b4%e0%b8%813.png \n|\n__PUBLIC_URL__/service-sut/image/image-2023/department-dentistry/10/%e0%b8%9b%e0%b8%8f%e0%b8%b4%e0%b8%9a%e0%b8%b1%e0%b8%95%e0%b8%b4%e0%b8%81%e0%b8%b2%e0%b8%a3%20%e0%b8%9b%e0%b8%a3%e0%b8%b51.png __PUBLIC_URL__/service-sut/image/image-2023/department-dentistry/10/%e0%b8%9b%e0%b8%8f%e0%b8%b4%e0%b8%9a%e0%b8%b1%e0%b8%95%e0%b8%b4%e0%b8%81%e0%b8%b2%e0%b8%a3%20%e0%b8%9b%e0%b8%a3%e0%b8%b52.png __PUBLIC_URL__/service-sut/image/image-2023/department-dentistry/10/%e0%b8%9b%e0%b8%8f%e0%b8%b4%e0%b8%9a%e0%b8%b1%e0%b8%95%e0%b8%b4%e0%b8%81%e0%b8%b2%e0%b8%a3%20%e0%b8%9b%e0%b8%a3%e0%b8%b53.png \n|\n__PUBLIC_URL__/service-sut/image/image-2023/department-dentistry/10/%e0%b8%9b%e0%b8%8f%e0%b8%b4%e0%b8%9a%e0%b8%b1%e0%b8%95%e0%b8%b4%e0%b8%84%e0%b8%a5%e0%b8%b4%e0%b8%99%e0%b8%b4%e0%b8%81%201.png"
            }
          ]
        },
        "q8": {
          "title": "อาจารย์ที่ปรึกษาคือใคร ?",
          "text": [
            {
              "text_0": "“อาจารย์ที่ปรึกษา” คือ อาจารย์ที่จะให้คำปรึกษาแนะนำด้านวิชาการเกี่ยวกับหลักสูตร การลงทะเบียนเรียน วิธีการเรียนเพื่อให้นักศึกษาสามารถศึกษาจนสำเร็จครบตามหลักสูตร รวมถึง ช่วยส่งเสริมนักศึกษาให้สามารถใช้ชีวิตในมหาวิทยาลัยและแก้ปัญหาได้อย่างเหมาะสมจนสำเร็จการศึกษา"
            }
          ],
          "image": [
            {
              "image_0": "__PUBLIC_URL__/service-sut/image/dentistry/Group%20417.png"
            }
          ]
        },
        "teacher": {
          "title": "ความสำคัญของการเข้าพบอาจารย์ที่ปรึกษา",
          "text": [
            {
              "text_0": "1) ท่านมีมุมมองและวิธีรับมือกับปัญหาอย่างมืออาชีพ สามารถให้มุมมองและวิธีรับมือกับปัญหาได้หลากหลาย",
              "text_1": "2) ท่านมีประสบการณ์ที่สั่งสมจากความสำเร็จและความผิดพลาดของนักศึกษารุ่นก่อนสามารถแลกเปลี่ยนประสบการณ์ที่มาจากความสำเร็จและความผิดพลาดของนักศึกษารุ่นก่อนได้",
              "text_2": "3) ควรเข้าพบเพื่อวางแผนการเรียนในแต่ละเทอม ปรึกษา และร่วมวางแผนการเรียน ตลอดจนการใช้ชีวิตในแต่ละช่วงของการเรียนในมหาวิทยาลัย"
            }
          ],
          "image": [
            {
              "image_0": "__PUBLIC_URL__/service-sut/image/dentistry/Group%20401.png"
            }
          ]
        },
        "q9": {
          "title": "นักศึกษาทันตแพทย์มีกิจกรรมอะไรบ้าง ?",
          "text": [
            {
              "text_0": "“อาจารย์ประจำชั้นปี” คือ อาจารย์ที่ดูแลและเป็นที่ปรึกษาของชั้นปีนั้น ๆ ซึ่งจะดูแลภาพรวมนักศึกษาทั้งชั้นปี นอกจากอาจารย์ที่ปรึกษาแล้ว นักศึกษายังสามารถปรึกษาอาจารย์ประจำชั้นปีได้",
              "text_1": "“อาจารย์ที่ปรึกษา” คือ อาจารย์ที่จะให้คำปรึกษาแนะนำด้านวิชาการเกี่ยวกับหลักสูตร การลงทะเบียนเรียน วิธีการเรียนเพื่อให้นักศึกษาสามารถศึกษาจนสำเร็จครบตามหลักสูตร รวมถึง ช่วยส่งเสริมนักศึกษาให้สามารถใช้ชีวิตในมหาวิทยาลัยและแก้ปัญหาได้อย่างเหมาะสมจนสำเร็จการศึกษา"
            }
          ],
          "image": [
            {
              "image_0": "__PUBLIC_URL__/service-sut/image/2023/department-dentistry/07-13-01.png",
              "image_1": "__PUBLIC_URL__/service-sut/image/dentistry/activity/Act-1-2.png",
              "image_2": "__PUBLIC_URL__/service-sut/image/dentistry/activity/Act-1-3.png"
            }
          ]
        },
        "q10": {
          "title": "นักศึกษาทันตแพทย์มีกิจกรรมอะไรบ้าง ?",
          "text": [
            {
              "text_0": "1) กิจกรรมมหาวิทยาลัยเทคโนโลยีสุรนารี\n",
              "text_1": "2) กิจกรรมสำนักวิชาทันตแพทยศาสตร์ ประกอบด้วย กิจกรรมเสริมหลักสูตร กิจกรรมนอกหลักสูตร และกิจกรรมอื่น ๆ \n",
              "text_2": "3) กิจกรรมร่วมกับกลุ่มคณะทันตแพทยศาสตร์ในประเทศไทย"
            }
          ],
          "image": [
            {
              "image_0": ""
            }
          ]
        },
        "q11": {
          "title": "ทำไมต้องเข้าร่วมกิจกรรม ?",
          "text": [
            {
              "text_0": "1) ได้รู้จักการวางแผน เรียนรู้การบริหารจัดการ การแก้ไขปัญหาในสถานการณ์ที่ไม่คาดฝัน\n",
              "text_1": "2) ได้ฝึกการทำงานร่วมกับผู้อื่น การติดต่อประสานงาน\n",
              "text_2": "3) ได้รับประสบการณ์ตรงนอกห้องเรียน \n",
              "text_3": "4) ได้ฝึกทักษะการสื่อสาร การประยุกต์ใช้ความรู้ ฝึกทักษะความสามารถที่จำเป็นต่อการประกอบวิชาชีพ"
            }
          ],
          "image": [
            {
              "image_0": ""
            }
          ]
        },
        "advice": {
          "title": "ข้อแนะนำของสำนักวิชาทันตแพทยศาสตร์",
          "text": [
            {
              "text_0": "ข้อบังคับนักศึกษาทันตแพทย์",
              "text_1": "ค่าใช้จ่ายในการเรียน",
              "text_2": "จุดเด่นของทันตแพทย์ มทส.",
              "text_3": "นักศึกษาทันตแพทย์ เรียนอย่างไร ?",
              "text_4": "นักศึกษาทันตแพทย์เรียนที่ไหน ?",
              "text_5": "การสอบแก้ตัว คืออะไร ?",
              "text_6": "ถ้าติด F จะต้องทำอย่างไร ?",
              "text_7": "เมื่อได้รับผลการศึกษาที่อยู่ในระดับดี",
              "text_8": "ความสําคัญของการประเมินการเรียนสอน",
              "text_9": "ทำไมนักศึกษาทันตแพทย์ ควรอยู่หอพักในมหาวิทยาลัย ?",
              "text_10": "นักศึกษาทันตแพทย์แต่งตัวอย่างไร ?",
              "text_11": "อาจารย์ที่ปรึกษาคือใคร ?",
              "text_12": "ความสำคัญของการเข้าพบอาจารย์ที่ปรึกษา",
              "text_13": "นักศึกษาทันตแพทย์มีกิจกรรมอะไรบ้าง ?",
              "text_14": "ทำไมต้องเข้าร่วมกิจกรรม ?",
              "text_15": "8 เทคนิคเรียนทันตแพทย์ยังไงให้ปัง !!!",
              "text_16": "Frequently Asked Questions",
              "text_17": "เรื่องนี้ต้องติดต่อใคร"
            }
          ],
          "image": [
            {
              "image_0": ""
            }
          ]
        },
        "result": {
          "title": "เมื่อได้รับผลการศึกษาที่อยู่ในระดับดี",
          "text": [
            {
              "text_0": "รางวัลภายในมหาวิทยาลัย\n",
              "text_1": "เกรดเฉลี่ยสะสม 3.50 ขึ้นไป : ไม่มี U และ F\n",
              "text_2": "ไม่เรียนซ้ำเพื่อปรับเกรด D  D+ ได้รับปริญญา จะได้รับเกียรตินิยมอันดับหนึ่ง และเหรียญทองเกียรตินิยม และหากได้รับปริญญาเกียรตินิยมอันดับหนึ่งพร้อมมีแต้มเฉลี่ยสูงสุดในสาขา\n",
              "text_3": "จะได้รับเข็มทองคำ\n\n",
              "text_4": "เกรดเฉลี่ยสะสม 3.25 ขึ้นไป : ไม่มี U และ F ไม่เรียนซ้ำเพื่อปรับเกรด D  D+ ได้รับปริญญา เกียรตินิยมอันดับสอง และเหรียญเงิน\nเกียรตินิยม\n",
              "text_5": "รางวัลจากสำนักวิชาทันตแพทยศาสตร์ \n\n",
              "text_6": "รางวัลภายนอกมหาวิทยาลัย\n",
              "text_7": "รางวัลจากทันตแพทยสมาคม\n",
              "text_8": "ใบประกาศเกียรติคุณบัณฑิตทันตแพทยศาสตร์ดีเยี่ยม จากมูลนิธิสมเด็จพระมหิตลาธิเบศร\n",
              "text_9": "อดุลยเดชวิกรม พระบรมราชชนก\n",
              "text_10": "รางวัล “หลวงวาจวิทยาวัฑฒน์”\n",
              "text_11": "รางวัลผลการศึกษายอดเยี่ยม\n",
              "text_12": "ทางวิทยาศาสตร์ มูลนิธิศาสตราจารย์ ดร.แถบ นีละนิธิ"
            }
          ],
          "image": [
            {
              "image_0": "__PUBLIC_URL__/service-sut/image/dentistry/7.2.JPG",
              "image_1": "__PUBLIC_URL__/service-sut/image/dentistry/7.3.JPG",
              "image_2": "__PUBLIC_URL__/service-sut/image/dentistry/7.4.JPG"
            }
          ]
        },
        "retry": {
          "title": "การพ้นสถานภาพของนักศึกษาทันตแพทยศาสตร์",
          "text": [
            {
              "text_0": "จะเริ่มจำแนกเมื่อสิ้นภาคการศึกษาที่ 3 เป็นต้นไป นับตั้งแต่เริ่มเข้า",
              "text_1": "ศึกษา โดยมีเกณฑ์ดังนี้\n",
              "text_2": "ต่ำกว่า 1.50 พ้นสถานภาพ\n",
              "text_3": "1.50 – 2.00  รอพินิจ\n",
              "text_4": "2.00 ขึ้นไป ปกติ\n",
              "text_5": "ถ้า   รอพินิจ    ต่อเนื่องกัน 4 ภาคการศึกษา =   พ้นสถานภาพ   นักศึกษา"
            }
          ],
          "image": [
            {
              "image_0": ""
            }
          ]
        },
        "should_contact": [
          {
            "id": "7",
            "courseID": "7",
            "category": "ภายในสำนักวิชาทันตแพทยศาสตร์",
            "title": "การบริการการศึกษา",
            "detail": "เช่น การลงทะเบียนเรียน ทุนการศึกษา การสอบ การชำระค่าลงทะเบียนและค่าธรรมเนียมพิเศษภาพ",
            "image": "__PUBLIC_URL__/service-sut/image/2025/07/dent-Line.png",
            "link_1": "https://line.me/R/ti/p/@782ytjse",
            "link_2": "",
            "link_3": "",
            "year": "2025"
          },
          {
            "id": "8",
            "courseID": "7",
            "category": "ภายในสำนักวิชาทันตแพทยศาสตร์",
            "title": "กิจการนักศึกษา",
            "detail": "เช่น งานกิจกรรม สวัสดิการนักศึกษา",
            "image": "__PUBLIC_URL__/service-sut/image/2025/07/dent_01.png",
            "link_1": "https://www.facebook.com/groups/398554307266828",
            "link_2": "",
            "link_3": "",
            "year": "2025"
          },
          {
            "id": "9",
            "courseID": "7",
            "category": "ภายในสำนักวิชาทันตแพทยศาสตร์",
            "title": "การเรียนการสอนและกิจกรรมในรายวิชา (ทางทันตแพทย์)",
            "detail": "อาจารย์ผู้รับผิดชอบรายวิชา และเจ้าหน้าที่ประจำสาขา",
            "image": "__PUBLIC_URL__/service-sut/image/image-2023/department-dentistry/07-17-01.png",
            "link_1": "https://beta.sut.ac.th/id/about-us/คณาจารย์-บุคลากร",
            "link_2": "",
            "link_3": "",
            "year": "2025"
          },
          {
            "id": "10",
            "courseID": "7",
            "category": "ภายในมหาวิทยาลัย",
            "title": "ชำระค่าลงทะเบียน ค่าธรรมเนียมพิเศษ",
            "detail": "ส่วนการเงินและบัญชี (อาคารบริหาร ชั้น 1)",
            "image": "__PUBLIC_URL__/service-sut/image/dentistry/should_contact/contact-2-1.png",
            "link_1": "https://beta.sut.ac.th/dfa/เกี่ยวกับหน่วยงาน/บุคลากร",
            "link_2": "",
            "link_3": "",
            "year": "2025"
          },
          {
            "id": "11",
            "courseID": "7",
            "category": "ภายในมหาวิทยาลัย",
            "title": "การลงทะเบียน การเพิ่ม-รายวิชา สถานภาพ นักศึกษา",
            "detail": "ศูนย์บริการการศึกษา (อาคารเรียนรวม 2 ชั้น 1)",
            "image": "__PUBLIC_URL__/service-sut/image/dentistry/should_contact/contact-2-2.png",
            "link_1": "http://web.sut.ac.th/ces/2018/",
            "link_2": "",
            "link_3": "",
            "year": "2025"
          },
          {
            "id": "12",
            "courseID": "7",
            "category": "ภายในมหาวิทยาลัย",
            "title": "การทำกิจกรรม งานทุน สวัสดิการนักศึกษา หอพัก",
            "detail": "ส่วนกิจการนักศึกษา (อาคารกิจการนักศึกษา)",
            "image": "__PUBLIC_URL__/service-sut/image/dentistry/should_contact/contact-2-3.png",
            "link_1": "https://beta.sut.ac.th/dsa/",
            "link_2": "https://www.facebook.com/sut.fund.fanpage/",
            "link_3": "https://www.facebook.com/หอพักนักศึกษา-มทส-259864224070691/",
            "year": "2025"
          }
        ],
        "contract": [
          {
            "id": "450",
            "courseID": "7",
            "slang": "",
            "department": "หลักสูตรของสำนักวิชาทันตแพทยศาสตร์",
            "phone": "044-223-592",
            "site": "http://dent.sut.ac.th/",
            "createAt": "2022-07-16 14:40:47",
            "updateAt": "2022-07-16 14:40:47",
            "year": "2025"
          },
          {
            "id": "461",
            "courseID": "7",
            "slang": "doctor-of-dental-surgery",
            "department": "ทันตแพทยศาสตรบัณฑิต",
            "phone": "",
            "site": "",
            "createAt": "2022-07-30 15:55:00",
            "updateAt": "2022-07-30 15:55:00",
            "year": "2025"
          }
        ],
        "visitor": 1715,
        "visitor_of_year": 305
      }
    },
    "department-public-health": {
      "code": 200,
      "status": "Get data success",
      "data": {
        "id": "8",
        "nameTH": "สำนักวิชาสาธารณสุขศาสตร์",
        "nameEN": "Institute of Public Health",
        "slang": "department-public-health",
        "image": "__PUBLIC_URL__/service-sut/image/image_2024/Img/08-PubH/08-PublicHealth.png",
        "createAt": "2022-07-09 03:49:59",
        "updataAt": "2022-07-09 03:49:59",
        "y2025": null,
        "y2024": null,
        "y2023": "__PUBLIC_URL__/service-sut/ebook-freshmen/2566/Institute_of_Public_Health/Institute_of_Public_Health.html",
        "y2022": "__PUBLIC_URL__/service-sut/ebook-freshmen/2565/Institute_of_Public_Health/Institute_of_Public_Health.html",
        "y2021": "__PUBLIC_URL__/service-sut/ebook-freshmen/2564/Institute_of_Public_Health/Institute_of_Public_Health.html",
        "y2020": "__PUBLIC_URL__/service-sut/ebook-freshmen/2563/Institute_of_Public_Health/Institute_of_Public_Health.html",
        "message": {
          "title": "สารจากคณบดี\nผู้ช่วยศาสตราจารย์ ดร.ชลาลัย หาญเจนลักษณ์",
          "text": [
            {
              "text_0": "สำนักวิชาสาธารณสุขศาสตร์ มหาวิทยาลัยเทคโนโลยีสุรนารี ขอแสดงความยินดีกับนักศึกษาใหม่ทุกคน และยินดีต้อนรับสู่ครอบครัว สา’สุข แห่งนี้ \n\n            ",
              "text_1": "นักศึกษาที่เข้าศึกษาในหลักสูตรวิทยาศาสตรบัณฑิต สาขาวิชาอนามัยสิ่งแวดล้อม  หลักสูตรวิทยาศาสตรบัณฑิต สาขาวิชาอาชีวอนามัยและความปลอดภัย หลักสูตรวิทยาศาสตรบัณฑิต สาขาวิชาโภชนวิทยาและการกำหนดอาหาร ทั้ง 3 หลักสูตร มีระยะเวลาเรียนตลอดหลักสูตร 4 ปี ในช่วงเวลาที่ศึกษาอยู่นี้ เราจะได้พัฒนาทักษะด้านวิชาชีพ และทักษะการทำงานอื่น ๆ ที่จำเป็นในการทำงานเกือบทุกด้าน ขอพวกเราทุกคนตั้งใจ มุ่งมั่น ขยัน และอดทน แล้วเราจะเรียนสำเร็จได้อย่างที่ตั้งใจไว้ \n\n            ",
              "text_2": "จงใช้คู่มือการศึกษาเล่มนี้ให้เกิดประโยชน์สูงสุด หากมีสิ่งใดที่นักศึกษาต้องการความช่วยเหลือ ขอให้ปรึกษาอาจารย์ที่ปรึกษาซึ่งทุกท่านพร้อมที่จะให้การสนับสนุนและช่วยเหลือพวกเราได้อีกทางหนึ่ง \n\n            ",
              "text_3": "ขออวยพรให้นักศึกษาทุกคนประสบความสำเร็จ สมหวังดังตั้งใจ และเป้าหมายที่ตั้งไว้\n            ",
              "text_4": "จงใช้สติ ปัญญา ในการเล่าเรียนให้มาก ๆ ดูแลตนเองให้ดี เพื่อรอวันสำเร็จที่จะมาถึงในอนาคตของทุกคน"
            }
          ],
          "image": [
            {
              "image_0": "__PUBLIC_URL__/service-sut/image/2025/08/Dean_PubH.png",
              "image_1": "__PUBLIC_URL__/service-sut/image/image_2024/Img/08-PubH/VDO%20Cover.png",
              "image_2": "__PUBLIC_URL__/service-sut/image/image_2024/Img/08-PubH/vdo.mp4"
            }
          ]
        },
        "teacher": {
          "title": "ความสำคัญของการเข้าพบอาจารย์ที่ปรึกษา",
          "text": [
            {
              "text_0": "1) อาจารย์มีมุมมองและวิธีรับมือกับปัญหาอย่างมืออาชีพ",
              "text_1": "2) อาจารย์มีประสบการณ์ที่สั่งสมจากความสำเร็จและความผิดพลาดของนักศึกษารุ่นก่อน",
              "text_2": "3) เข้าพบเพื่อวางแผนการเรียนตั้งแต่ต้นเทอม",
              "text_3": "4) เข้าพบอาจารย์ที่ปรึกษาเพื่อรับคำแนะนำก่อนวันสุดท้ายของการถอนรายวิชา เมื่อสอบกลางภาคแล้ว",
              "text_4": "ช่องทางการตรวจสอบเวลาว่างของอาจารย์ที่ปรึกษา\n1) ตรวจสอบตารางสอนของอาจารย์ที่ปรึกษา โดย Login ผ่านระบบ reg.sut.ac.th \n2) นักศึกษาสามารถ E-mail หาอาจารย์ได้โดยตรงเพื่อขอพบ \nสาขาวิชาอนามัยสิ่งแวดล้อม ดูข้อมูลอาจารย์ ",
              "text_5": "สาขาวิชาอาชีวอนามัยและความปลอดภัย ดูข้อมูลอาจารย์ ",
              "text_6": "สาขาวิชาโภชนวิทยาและการกำหนดอาหาร ดูข้อมูลอาจารย์"
            }
          ],
          "image": [
            {
              "image_0": "__PUBLIC_URL__/service-sut/image/2025/08/Advisor/Advisor%20meeting%201%20-%20SUT%20PubH.jpg",
              "image_1": "__PUBLIC_URL__/service-sut/image/2025/08/Advisor/Advisor%20meeting%202%20-%20SUT%20PubH.jpg",
              "image_2": "__PUBLIC_URL__/service-sut/image/2025/08/Advisor/Advisor%20meeting%203%20-%20SUT%20PubH(1).jpg",
              "image_3": "__PUBLIC_URL__/service-sut/image/2025/08/Advisor/Advisor%20meeting%203%20-%20SUT%20PubH.jpg"
            }
          ],
          "link": [
            {
              "link_0": "https://iph.sut.ac.th/personnel/envi-teacher/",
              "link_1": "https://iph.sut.ac.th/personnel/occ-teacher/ ",
              "link_2": "https://iph.sut.ac.th/personnel/food-teacher/"
            }
          ]
        },
        "advice": {
          "title": "ข้อแนะนำของสำนักวิชา ฯ",
          "text": [
            {
              "text_0": "วิสัยทัศน์/พันธกิจ/ค่านิยม",
              "text_1": "เกี่ยวกับการเรียน",
              "text_2": "ความสำคัญของการประเมินการสอน",
              "text_3": "สาธารณสุขเรียนเกี่ยวกับอะไรจบแล้วทำงานอะไร ?",
              "text_4": "เรียนอย่างไรให้จบตามเวลา ?",
              "text_5": "ความสำคัญของการเข้าพบอาจารย์ที่ปรึกษา",
              "text_6": "กิจกรรมเสริมหลักสูตร",
              "text_7": "บทบาทหน้าที่คณะทำงานกิจกรรมนักศึกษาในแต่ละชั้นปี",
              "text_8": "ระบบบริการนักศึกษาของสำนักวิชา ฯ",
              "text_9": "ระบบการให้คําปรึกษาของอาจารย์ที่ปรึกษา",
              "text_10": "รายวิชาต่อเนื่อง",
              "text_11": "เกณฑ์การย้ายสังกัดสาขาวิชา",
              "text_12": "การรับฟังความคิดเห็นและข้อร้องเรียน"
            }
          ],
          "image": [
            {
              "image_0": ""
            }
          ]
        },
        "end": {
          "title": "สาธารณสุขเรียนเกี่ยวกับอะไรจบแล้วทำงานอะไร ?",
          "text": [
            {
              "text_0": "ในปีการศึกษา 2565 สำนักวิชาสาธารณสุขศาสตร์ เปิดรับนักศึกษาระดับปริญญาตรี 2 สาขาวิชา ได้แก่ สาขาวิชาอนามัยสิ่งแวดล้อม และสาขาวิชาอาชีวอนามัยและความปลอดภัย นักศึกษาจะได้เลือกสาขาวิชาในภาคการศึกษาที่ 2 ของชั้นปีที่ 1 และจะได้แยกสาขาวิชาในภาคการศึกษาที่ 3 ของชั้นปีที่ 1 เมื่อนักศึกษาจบการศึกษา จะได้ทำงานตามสายงานตามสาขาที่ได้ศึกษา ดังนี้"
            }
          ],
          "image": [
            {
              "image_0": ""
            }
          ]
        },
        "end_1": {
          "title": "1) สาขาวิชาอนามัยสิ่งแวดล้อม",
          "text": [
            {
              "text_0": "ศึกษาเกี่ยวกับการควบคุมและจัดการคุณภาพสิ่งแวดล้อมที่อาจส่งผลกระทบต่อคุณภาพชีวิตและสุขภาพของประชาชนทั่วไป   โดยนำความรู้ที่ได้จากการเรียนทั้งภาคทฤษฎี ภาคปฏิบัติ และการทำงานในโครงการสหกิจศึกษาและพัฒนาอาชีพ  มาประยุกต์ใช้ในการปฏิบัติงานในหน่วยงาน  โรงงานอุตสาหกรรม และสถานประกอบการต่างๆ ที่เกี่ยวข้อง เพื่อการควบคุมและจัดการมลพิษสิ่งแวดล้อมที่อาจมีผลกระทบต่อสุขภาพได้อย่างมีประสิทธิภาพและเกิดผลในทางปฏิบัติจริงและมีความสอดคล้องกับสถานการณ์ปัจจุบันและปรัชญาการจัดการหลักสูตรของมหาวิทยาลัย ที่คำนึงถึงความจำเป็น (needs) ของผู้มีส่วนได้ส่วนเสีย (Stakeholders) เป็นสำคัญ เช่น ผู้ใช้บัณฑิต ศิษย์เก่า นักศึกษาปัจจุบัน คณาจารย์และบุคลากร เป็นต้น โดยปรัชญาของหลักสูตรฯมุ่งเน้นให้ผู้เรียนสามารถบรรลุทักษะสำคัญในการทำงาน คือ “รู้ชัด ปฏิบัติได้”\nอาชีพที่เกี่ยวข้อง\n",
              "text_1": "ภาคเอกชน\n                ",
              "text_2": "-  เจ้าหน้าที่สิ่งแวดล้อม (โรงงาน, โรงพยาบาล, สถานประกอบการ)\n",
              "text_3": "ภาครัฐบาล\n                ",
              "text_4": "-  นักวิชาการสิ่งแวดล้อม \n                ",
              "text_5": "-  นักวิชาการสาธารณสุข\n                ",
              "text_6": "-  นักวิชาการสุขาภิบาล"
            }
          ],
          "image": [
            {
              "image_0": "__PUBLIC_URL__/service-sut/image/public-health/Envi2.jpg"
            }
          ]
        },
        "end_2": {
          "title": "2) สาขาวิชาอาชีวอนามัยและความปลอดภัย",
          "text": [
            {
              "text_0": "ศึกษาเกี่ยวกับหลักการป้องกันและควบคุมสภาพแวดล้อมให้มีความปลอดภัยต่อการทำงาน โดยนำความรู้ไปประยุกต์ใช้ในการส่งเสริมสุขภาพและความปลอดภัยของผู้ปฏิบัติงาน การป้องกันการเกิดอุบัติเหตุเนื่องจากการทำงาน การจัดสภาพแวดล้อมในการทำงานที่เหมาะสม เช่น แสง เสียง ความร้อน ฝุ่นละออง สารเคมี ให้เป็นไปตามกฎหมายที่เกี่ยวข้องกำหนด เพื่อให้ผู้ปฏิบัติงานมีสุขภาพอนามัยสมบูรณ์ทั้งร่างกายและจิตใจในการประกอบอาชีพ สร้างเสริมการเรียนรู้ด้วยทฤษฎีและการปฏิบัติจากประสบการณ์จริง  รวมถึงการปฏิบัติงานจริง ณ สถานประกอบการ เพื่อให้ผู้ศึกษาสามารถคิด  วิเคราะห์  ค้นคว้าหาคำตอบ  สังเคราะห์เป็นความรู้ความเข้าใจ  และสามารถปฏิบัติได้จริงและเป็นการลดความสูญเสีย และค่าใช้จ่ายเนื่องจากการเกิดอุบัติเหตุและโรคจากการทำงานทั้งภาครัฐและเอกชน  ซึ่งเป็นบทบาทและหน้าที่ของเจ้าหน้าที่ความปลอดภัยในการทำงาน\n",
              "text_1": "อาชีพที่เกี่ยวข้อง\n",
              "text_2": "ภาคเอกชน\n        ",
              "text_3": "-  เจ้าหน้าที่ความปลอดภัยในการทำงานระดับวิชาชีพ\n",
              "text_4": "ภาครัฐบาล\n        ",
              "text_5": "-  นักวิชาการแรงงานด้านความปลอดภัย\n        ",
              "text_6": "-  นักวิชาการด้านอาชีวอนามัยและความปลอดภัย"
            }
          ],
          "image": [
            {
              "image_0": "__PUBLIC_URL__/service-sut/image/public-health/Occ2.jpg"
            }
          ]
        },
        "activity": {
          "title": "กิจกรรมเสริมหลักสูตร",
          "text": [
            {
              "text_0": "นอกจากกิจกรรมที่มหาวิทยาลัยจัดแล้ว ยังมีกิจกรรมเสริมหลักสูตรที่ทางสำนักวิชาฯ จัดให้กับนักศึกษา และกิจกรรมที่นักศึกษาจัดโดยอยู่ภายใต้การดูแลของสำนักวิชาฯ เพื่อให้นักศึกษามีคุณลักษณะเป็นบัณฑิตที่พึงประสงค์ 5 ด้าน สำนักวิชาฯ จึงบรรจุกิจกรรมเหล่านี้ไว้ให้นักศึกษาได้เข้าร่วมและเรียนรู้ร่วมกับการใช้ชีวิตในมหาวิทยาลัย\n\n          ",
              "text_1": "- วันมหิดล\n          ",
              "text_2": "- สานสัมพันธ์นักศึกษาสาธารณสุขศาสตร์\n          ",
              "text_3": "- กีฬาสาธารณสุขสัมพันธ์\n          ",
              "text_4": "- กิจกรรมแสดงความยินดีกับพี่บัณฑิต\n          ",
              "text_5": "- กิจกรรม Bye Nior\n          ",
              "text_6": "- กิจกรรมเสริมสร้างทักษะนักศึกษาในศตวรรษที่ 21\n          ",
              "text_7": "- กิจกรรมพัฒนาทักษะการใช้ชีวิตในมหาวิทยาลัย\n          ",
              "text_8": "- งานสัปดาห์ความปลอดภัยแห่งชาติ\n          ",
              "text_9": "- วันอนามัยสิ่งแวดล้อมไทย\n          ",
              "text_10": "- ศึกษาดูงานนอกสถานที่\n          ",
              "text_11": "- การอบรมคุณธรรมและจริยธรรม\n\n",
              "text_12": "“ปริญญาทําให้คนมีงานทํา กิจกรรมทําให้คนทํางานเป็น”"
            }
          ],
          "image": [
            {
              "image_0": "__PUBLIC_URL__/service-sut/image/2025/08/Exgtra/Extra_01.jpg",
              "image_1": "__PUBLIC_URL__/service-sut/image/2025/08/Exgtra/Extra_02.jpg",
              "image_2": "__PUBLIC_URL__/service-sut/image/2025/08/Exgtra/Extra_03.jpg",
              "image_3": "__PUBLIC_URL__/service-sut/image/2025/08/Exgtra/Extra_04.JPG"
            }
          ]
        },
        "role": {
          "title": "บทบาทหน้าที่คณะทำงานกิจกรรมนักศึกษาในแต่ละชั้นปี",
          "text": [
            {
              "text_0": "ในแต่ละปีการศึกษา นักศึกษาจะเลือกผู้แทนนักศึกษาเข้ามาทำหน้าที่เป็นคณะทำงานกิจกรรมนักศึกษา ประกอบด้วย ประธาน รองประธาน เลขานุการ ผู้ช่วยเลขานุการ คณะทำงานฝ่ายวิชาการ คณะทำงานฝ่ายกิจกรรม คณะทำงานฝ่ายเหรัญญิก และคณะทำงานฝ่ายประชาสัมพันธ์ โดยมีหน้าที่ดังนี้ ",
              "text_1": "1) วางแผนจัดกิจกรรมนักศึกษาที่ส่งเสริมผลการเรียนรู้ตามกรอบมาตรฐานคุณวุฒิระดับอุดมศึกษาแห่งชาติ ",
              "text_2": "2) บริหารและดำเนินงานกิจกรรมที่เกี่ยวข้องกับนักศึกษาชั้นปี ให้เป็นไปตามนโยบายของทางสำนักวิชาสาธารณสุขศาสตร์และมหาวิทยาลัย ",
              "text_3": "3) บันทึกรายงานการประชุมและรายงานผลการทำงานต่อที่ปรึกษาคณะทำงานกิจกรรมนักศึกษาชั้นปีที่ 1 สำนักวิชาสาธารณสุขศาสตร์ ",
              "text_4": "4) งานอื่น ๆ ที่เกี่ยวข้องกับนักศึกษาชั้นปีที่ 1 สำนักวิชาสาธารณสุขศาสตร์"
            }
          ],
          "image": [
            {
              "image_0": "__PUBLIC_URL__/service-sut/image/2025/08/Student-Act/Student%20Act%20-%20SUT%20PubH%201.jpg",
              "image_1": "__PUBLIC_URL__/service-sut/image/2025/08/Student-Act/Student%20Act%20-%20SUT%20PubH%202.jpg",
              "image_2": "__PUBLIC_URL__/service-sut/image/2025/08/Student-Act/Student%20Act%20-%20SUT%20PubH%203.jpg",
              "image_3": "__PUBLIC_URL__/service-sut/image/2025/08/Student-Act/Student%20Act%20-%20SUT%20PubH%204.jpg"
            }
          ]
        },
        "teachter_system": {
          "title": "ระบบการให้คําปรึกษาของอาจารย์ที่ปรึกษา",
          "text": [
            {
              "text_0": ""
            }
          ],
          "image": [
            {
              "image_0": "__PUBLIC_URL__/service-sut/image/public-health/Group%20445.png",
              "image_1": "__PUBLIC_URL__/service-sut/image/public-health/PubH-StudentServiceSystem2.pdf"
            }
          ]
        },
        "studen_system": {
          "title": "ระบบบริการนักศึกษาของสำนักวิชา ฯ",
          "text": [
            {
              "text_0": "1) ระบบบริการนักศึกษา\n",
              "text_1": "สำนักวิชาฯ มีระบบบริการนักศึกษา เพื่อให้นักศึกษายื่นเอกสารได้ด้วยตนเอง ในการยื่นเอกสารและการขอให้ออกหนังสือ ผ่านระบบบริการนักศึกษา ตลอด 24 ชั่วโมง โดยสามารถติดตามผลการดำเนินการของเอกสารที่ยื่นหรือขอได้ทาง E-mail ของนักศึกษา ได้แก่\n",
              "text_2": "1) การยื่นเอกสารให้อาจารย์หรือผู้บริหารของสำนักวิชาลงนาม\n",
              "text_3": "2) การขอให้สำนักวิชาออกหนังสือถึงหน่วยงานต่าง ๆ ในรายวิชาโครงงาน\n\n",
              "text_4": "ลงทะเบียนก่อนเข้าใช้ระบบบริการนักศึกษา\n",
              "text_5": "1) ลงทะเบียนที่ https://iph.sut.ac.th/iph-mis/\n",
              "text_6": "2) เลือกเมนู ลงทะเบียน (นักศึกษา)\n\n",
              "text_7": "2) ขอตรวจสอบคะแนนการประเมินผลรายวิชา และ การอุทธรณ์เกี่ยวกับการประเมินผลรายวิชา\n        ",
              "text_8": "กรณีที่นักศึกษามีข้อสงสัยเกี่ยวกับคะแนนการประเมินผลรายวิชาที่ได้ลงทะเบียนเรียน และประสงค์จะขอให้อาจารย์ทบทวน สามารถสอบถามอาจารย์ผู้สอน ได้ทาง e-mail หลังจากที่ได้รับคำตอบจากอาจารย์ผู้สอนแล้ว หากยังมีข้อสงสัย สามารถดำเนินการยื่นคำร้องที่สำนักวิชา โดยใช้คำร้อง “ขอตรวจสอบคะแนนการประเมินผลรายวิชา” ทั้งนี้ ก่อนสอบถามอาจารย์ผู้สอน หรือยื่นคำร้องข้างต้น ขอให้นักศึกษาตรวจสอบตนเองว่า ได้เข้าเรียนครบตามตารางเรียน  ส่งงานครบทุกชิ้น สอบย่อยทุกครั้ง และอื่น ๆ ตามที่อาจารย์ผู้สอนมอบหมาย\n\n",
              "text_9": "แบบขอตรวจสอบคะแนนการประเมินผลรายวิชา\n",
              "text_10": "การอุทธรณ์เกี่ยวกับการประเมินผลรายวิชา"
            }
          ],
          "image": [
            {
              "image_0": "__PUBLIC_URL__/service-sut/image/public-health/Group%20443.png"
            }
          ]
        },
        "about": {
          "title": "เกี่ยวกับการเรียน",
          "text": [
            {
              "text_0": "สำนักวิชาได้จัดการเรียนการสอนที่เน้นให้ผู้เรียนได้ลงมือปฏิบัติจริงเพื่อให้เกิดการเรียนรู้และประสบการณ์จริงให้สอดคล้องกับสถานการณ์ปัจจุบัน ตามปรัชญาของหลักสูตรแต่ละหลักสูตร “รู้ชัด ปฏิบัติได้”\n\n",
              "text_1": "ดูตารางเทียบรหัสรายวิชาเก่าใหม่ __PUBLIC_URL__/service-sut/file/public-health/7%20%E0%B8%95%E0%B8%B2%E0%B8%A3%E0%B8%B2%E0%B8%87%E0%B9%80%E0%B8%97%E0%B8%B5%E0%B8%A2%E0%B8%9A%E0%B8%A3%E0%B8%AB%E0%B8%B1%E0%B8%AA%20IPH.pdf\n\n",
              "text_2": "แต่ละหลักสูตรได้กำหนดผลการเรียนรู้ที่คาดหวังของหลักสูตร (Program Learning Outcomes: PLOs) ดังนี้\n",
              "text_3": "วท.บ. (อนามัยสิ่งแวดล้อม)\n",
              "text_4": "PLO1 : อธิบายวิทยาศาสตร์พื้นฐาน และ องค์ความรู้พื้นฐานทางด้านสุขภาพ\n",
              "text_5": "PLO2 : อธิบายศาสตร์พื้นฐานด้านอนามัยสิ่งแวดล้อมได้\n",
              "text_6": "PLO3 : วางแผนงานด้านวิทยาศาสตร์อนามัยสิ่งแวดล้อม\n",
              "text_7": "PLO4 : ปฏิบัติงานด้านวิทยาศาสตร์อนามัยสิ่งแวดล้อมตามขอบเขตองค์ความรู้สาขาอนามัยสิ่งแวดล้อม\n",
              "text_8": "PLO5 : วิเคราะห์ข้อมูลสารสนเทศทางด้านวิทยาศาสตร์อนามัยสิ่งแวดล้อม และสถานการณ์ด้านสุขภาพและสิ่งแวดล้อม ในระดับบุคคล ครอบครัว กลุ่ม และชุมชนได้อย่างเป็นองค์รวม\n",
              "text_9": "PLO6 : ประเมินสถานการณ์สุขภาพ ผลกระทบ และความเสี่ยงด้านสิ่งแวดล้อม\n",
              "text_10": "PLO7 : พัฒนาโครงการศึกษาด้านอนามัยสิ่งแวดล้อมตามหลักระเบียบวิธีวิจัย วิทยาศาสตร์และเทคโนโลยีที่เกี่ยวข้อง\n",
              "text_11": "PLO8 : ปฏิบัติตามจรรยาบรรณและมีความรับผิดชอบต่อตนเองและสังคม\n",
              "text_12": "PLO9 : สื่อสารได้ในบทบาทของผู้รับสาร (ฟังเป็น และ อ่านเป็น) และในบทบาทของผู้ส่งสาร (นำเสนอได้ทั้งการพูด และการเขียน)\n\n",
              "text_13": "วท.บ. (อาชีวอนามัยและความปลอดภัย)\n",
              "text_14": "PLO1 : อธิบายความรู้พื้นฐานของศาสตร์ที่เกี่ยวข้องกับงานอาชีวอนามัยและความปลอดภัยในการทำงาน\n",
              "text_15": "PLO2 : อธิบายองค์ความรู้ด้านอาชีวอนามัยและความปลอดภัยในการทำงาน และกฎหมายที่เกี่ยวข้อง\n",
              "text_16": "PLO3 : ปฏิบัติงานด้านอาชีวอนามัยและความปลอดภัยในสถานประกอบการได้ \n",
              "text_17": "PLO4 : วางแผนและพัฒนาโครงการเพื่อแก้ไขปัญหาด้านอาชีวอนามัยและความปลอดภัยในการทำงาน หรือการสร้างนวัตกรรม\n",
              "text_18": "PLO5 : สื่อสารและนำเสนอข้อมูลให้ผู้อื่นเข้าใจได้\n",
              "text_19": "PLO6 : ค้นคว้าหาความรู้เพิ่มเติมได้ด้วยตนเอง วิเคราะห์ และแปลผลข้อมูลโดยใช้เทคโนโลยีทางคอมพิวเตอร์และสารสนเทศ\n",
              "text_20": "PLO7 : รับผิดชอบต่อตนเอง สังคม งานที่ได้รับมอบหมาย และทำงานร่วมกับผู้อื่นได้\n\n",
              "text_21": "วท.บ. (โภชนวิทยาและการกำหนดอาหาร)\n",
              "text_22": "PLO1 : อธิบายศาสตร์พื้นฐานที่เกี่ยวข้องกับองค์ความรู้ทางด้านโภชนาการและการกำหนดอาหารและศาสตร์ที่เกี่ยวข้อง\n",
              "text_23": "PLO2 : ปฏิบัติตนตามจรรยาบรรณวิชาชีพและมีความรับผิดชอบต่อตนเองและสังคม\n",
              "text_24": "PLO3 : สื่อสารโดยใช้ภาษาอังกฤษได้ทั้งการพูด การฟัง การอ่านและการเขียน\n",
              "text_25": "PLO4 : ปฏิบัติงานด้านโภชนาการและการกำหนดอาหาร\n",
              "text_26": "PLO5 : วิเคราะห์สถานการณ์ด้านโภชนาการและการกำหนดอาหารในระดับบุคคล ครอบครัว กลุ่มและชุมชนได้อย่างเป็นองค์รวม\n",
              "text_27": "PLO6 : วิเคราะห์และนำเสนอข้อมูลโดยเลือกใช้เทคโนโลยีสารสนเทศเป็นองค์ประกอบในด้านโภชนาการและการกำหนดอาหาร\n",
              "text_28": "PLO7 : วางแผนงานด้านโภชนาการและการกำหนดอาหาร\n",
              "text_29": "PLO8 : ดำเนินการวิจัยวิทยาศาสตร์และเทคโนโลยีด้านโภชนาการและการกำหนดอาหาร"
            }
          ],
          "image": [
            {
              "image_0": "__PUBLIC_URL__/service-sut/image/2023/department-public-health/photoslide-1.png",
              "image_1": "__PUBLIC_URL__/service-sut/image/image_2024/Img/08-PubH/02-1.jpg",
              "image_2": "__PUBLIC_URL__/service-sut/image/2025/08/Occ%20SUT%20PubH%20Learning.JPG"
            }
          ]
        },
        "evaluation_student": {
          "title": "ความสำคัญของการประเมินการสอน",
          "text": [
            {
              "text_0": "มหาวิทยาลัยเทคโนโลยีสุรนารีจัดให้มีการประเมินการสอนอาจารย์โดยนักศึกษาเป็นผู้ประเมิน ทุกภาคการศึกษาในรายวิชาที่ลงทะเบียนเรียน ซึ่งการประเมินมีความสำคัญ ดังนี้\n",
              "text_1": "1) เป็นตัวบ่งชี้ความพึงพอใจของนักศึกษาที่มีต่อการเรียนการสอนของอาจารย์ ในองค์ประกอบ ด้านการเรียนการสอน ในการประกันคุณภาพการศึกษาของมหาวิทยาลัย\n",
              "text_2": "2) ประโยชน์ด้านการบริหารจัดการ\n",
              "text_3": "3) เป็นข้อมูลแก่ผู้บริหารในระดับต่าง ๆ เพื่อการกำหนดแนวทางการจัดการเรียนการสอนให้เหมาะสม \n",
              "text_4": "4) เป็นข้อมูลเบื้องต้นประกอบการพิจารณาต่าง ๆ อาทิ การพิจารณาคัดเลือกพนักงานดีเด่นสายวิชาการ (ด้านการสอน) หรือ การต่อสัญญาจ้างงาน เป็นต้น\n",
              "text_5": "5) เป็นข้อมูลเบื้องต้นในการจัดอบรมและพัฒนาทักษะด้านการสอนให้แก่คณาจารย์\n",
              "text_6": "6)  เป็นช่องทางหนึ่งที่นักศึกษาสามารถ ติชม หรือให้ข้อเสนอแนะต่าง ๆ ที่เกี่ยวข้องกับการสอน เพื่อประโยชน์ในการจัดการเรียนการสอนของนักศึกษารุ่นต่อไป\n\n",
              "text_7": "วิธีเข้าประเมินการสอน\n",
              "text_8": "1) Log in : reg.sut.ac.th\n",
              "text_9": "2) ไปที่เมนู “ประเมินอาจารย์”\n",
              "text_10": "3) นักศึกษาตอบคำถามในแบบประเมิน และสามารถแสดงความคิดเห็นได้ โดยที่อาจารย์ไม่สามารถเห็นชื่อนักศึกษาที่เข้าประเมินได้\n",
              "text_11": "4) สามารถเข้าประเมินได้ในสัปดาห์ที่ 6 ถึงสอบปลายภาคการศึกษา\n\n",
              "text_12": "อ้างอิง: สถานพัฒนาคณาจารย์ มหาวิทยาลัยเทคโนโลยีสุรนารี\n"
            }
          ],
          "image": [
            {
              "image_0": "__PUBLIC_URL__/service-sut/image/public-health/5%20Teacher%20Occ%201.png",
              "image_1": "__PUBLIC_URL__/service-sut/image/public-health/5%20Teacher%20envi%202.png",
              "image_2": "__PUBLIC_URL__/service-sut/image/2025/08/ND.jpg"
            }
          ]
        },
        "continuous_course": {
          "title": "รายวิชาต่อเนื่อง",
          "text": [
            {
              "text_0": "สาขาวิชาอนามัยสิ่งแวดล้อม\n",
              "text_1": "สาขาวิชาอาชีวอนามัยและความปลอดภัย\n",
              "text_2": "สาขาวิชาโภชนวิทยาและการกำหนดอาหาร"
            }
          ],
          "image": [
            {
              "image_0": ""
            }
          ],
          "link": [
            {
              "link_0": "__PUBLIC_URL__/service-sut/file/2025/08/%e0%b8%a3%e0%b8%b2%e0%b8%a2%e0%b8%a7%e0%b8%b4%e0%b8%8a%e0%b8%b2%e0%b8%95%e0%b9%88%e0%b8%ad%e0%b9%80%e0%b8%99%e0%b8%b7%e0%b9%88%e0%b8%ad%e0%b8%87%20%e0%b8%aa%e0%b8%b2%e0%b8%82%e0%b8%b2%e0%b8%a7%e0%b8%b4%e0%b8%8a%e0%b8%b2%e0%b8%ad%e0%b8%99%e0%b8%b2%e0%b8%a1%e0%b8%b1%e0%b8%a2%e0%b8%aa%e0%b8%b4%e0%b9%88%e0%b8%87%e0%b9%81%e0%b8%a7%e0%b8%94%e0%b8%a5%e0%b9%89%e0%b8%ad%e0%b8%a1%202567.pdf",
              "link_1": "__PUBLIC_URL__/service-sut/file/2025/08/%e0%b8%a3%e0%b8%b2%e0%b8%a2%e0%b8%a7%e0%b8%b4%e0%b8%8a%e0%b8%b2%e0%b8%95%e0%b9%88%e0%b8%ad%e0%b9%80%e0%b8%99%e0%b8%b7%e0%b9%88%e0%b8%ad%e0%b8%87%20%e0%b8%aa%e0%b8%b2%e0%b8%82%e0%b8%b2%e0%b8%a7%e0%b8%b4%e0%b8%8a%e0%b8%b2%e0%b8%ad%e0%b8%99%e0%b8%b2%e0%b8%a1%e0%b8%b1%e0%b8%a2%e0%b9%81%e0%b8%a5%e0%b8%b0%e0%b8%84%e0%b8%a7%e0%b8%b2%e0%b8%a1%e0%b8%9b%e0%b8%a5%e0%b8%ad%e0%b8%94%e0%b8%a0%e0%b8%b1%e0%b8%a2%202567.pdf",
              "link_2": "__PUBLIC_URL__/service-sut/image/image_2024/PDF/%e0%b8%a3%e0%b8%b2%e0%b8%a2%e0%b8%a7%e0%b8%b4%e0%b8%8a%e0%b8%b2%e0%b8%95%e0%b9%88%e0%b8%ad%e0%b9%80%e0%b8%99%e0%b8%b7%e0%b9%88%e0%b8%ad%e0%b8%87%20%e0%b8%aa%e0%b8%b2%e0%b8%82%e0%b8%b2%e0%b8%a7%e0%b8%b4%e0%b8%8a%e0%b8%b2%e0%b9%82%e0%b8%a0%e0%b8%8a%e0%b8%99%e0%b8%a7%e0%b8%b4%e0%b8%97%e0%b8%a2%e0%b8%b2%e0%b9%81%e0%b8%a5%e0%b8%b0%e0%b8%81%e0%b8%b2%e0%b8%a3%e0%b8%81%e0%b8%b3%e0%b8%ab%e0%b8%99%e0%b8%94%e0%b8%ad%e0%b8%b2%e0%b8%ab%e0%b8%b2%e0%b8%a3%202566.pdf"
            }
          ]
        },
        "criteria": {
          "title": "เกณฑ์การย้ายสังกัดสาขาวิชา",
          "text": [
            {
              "text_0": "สาขาวิชาอนามัยสิ่งแวดล้อม\n",
              "text_1": "สาขาวิชาอาชีวอนามัยและความปลอดภัย\n",
              "text_2": "สาขาวิชาโภชนวิทยาและการกำหนดอาหาร"
            }
          ],
          "image": [
            {
              "image_0": ""
            }
          ],
          "link": [
            {
              "link_0": "https://iph.sut.ac.th/iph-mis/upload-file/upload_document/IPH_document_4_2025_03_05_17_42_31.pdf",
              "link_1": "https://iph.sut.ac.th/iph-mis/upload-file/upload_document/IPH_document_4_2025_03_05_17_42_39.pdf",
              "link_2": "https://iph.sut.ac.th/iph-mis/upload-file/upload_document/IPH_document_4_2024_03_04_11_52_52.pdf"
            }
          ]
        },
        "end_3": {
          "title": "3) สาขาวิชาโภชนวิทยาและการกำหนดอาหาร",
          "text": [
            {
              "text_0": "ศึกษาเกี่ยวกับองค์ความรู้ด้านวิทยาศาสตร์สุขภาพทางโภชนาการในมนุษย์ โดยครอบคลุมองค์ความรู้ด้านอาหารและโภชนาการ อาทิ ด้านโภชนาการคลินิก ด้านโภชนบริการ ด้านโภชนาการชุมชน และด้านวิทยาศาสตร์การอาหาร โดยนำความรู้ที่ได้จากการเรียนทั้งภาคทฤษฎี ภาคปฏิบัติ การฝึกประสบการณ์วิชาชีพ และการปฏิบัติงานในโครงการสหกิจศึกษา มาบูรณาการเพื่อสามารถวางแผนงานด้านโภชนาการและการกำหนดอาหารให้แก่ประชาชนทั่วไปและผู้ป่วยเฉพาะโรค รวมทั้งสามารถประยุกต์ใช้องค์ความรู้เพื่อดำเนินการวิจัยด้านวิทยาศาสตร์และเทคโนโลยีทางอาหารและโภชนาการ สร้างเครือข่ายวิจัยและพัฒนาวิทยาศาสตร์และเทคโนโลยีอาหารในการสร้างสรรค์นวัตกรรมอาหาร เพื่อเพิ่มประสิทธิภาพการปฏิบัติงานในอุตสาหกรรมอาหารและโภชนาการให้สอดคล้องกับสถานการณ์ปัจจุบัน โดยคำนึงการส่งเสริมสุขภาพและสุขภาวะที่ดี นอกจากนี้ผู้เรียนสามารถเลือกเรียนรายวิชาที่เป็นเป็นพื้นฐานสำคัญของการสร้างนวัตกรรมและการเป็นผู้ประกอบการได้ต่อไปในอนาคต\n",
              "text_1": "อาชีพที่เกี่ยวข้อง\n",
              "text_2": "ภาคเอกชน\n",
              "text_3": "- นักกำหนดอาหารวิชาชีพ/นักโภชนาการในโรงพยาบาลเอกชน\n",
              "text_4": "- ผู้ให้คำปรึกษาด้านสุขภาพ/โภชนาการในศูนย์สุขภาพ\n",
              "text_5": "- ผู้แทนจำหน่ายผลิตภัณฑ์อาหารทางการแพทย์\n",
              "text_6": "- ผู้ประกอบการธุรกิจด้านอาหารและสุขภาพ\n",
              "text_7": "ภาครัฐบาล\n",
              "text_8": "- นักกำหนดอาหารวิชาชีพ/นักโภชนาการในโรงพยาบาลของรัฐ\n",
              "text_9": "- นักวิชาการโภชนาการ\n",
              "text_10": "- นักวิจัยทางด้านอาหารและโภชนาการ"
            }
          ],
          "image": [
            {
              "image_0": "__PUBLIC_URL__/service-sut/image/2023/department-public-health/08-04-03.png"
            }
          ]
        },
        "opinions_and_complaints": {
          "title": "การรับฟังความคิดเห็นและข้อร้องเรียน",
          "text": [
            {
              "text_0": "เป็นระบบที่จัดทำขึ้นเพื่อรับฟังความคิดเห็น ข้อเสนอแนะ และข้อร้องเรียน จากผู้มีส่วนได้ส่วนเสียทุกภาคส่วน ได้แก่ ผู้เรียน นักศึกษา ศิษย์เก่า ผู้ปกครอง ผู้ใช้บัณฑิต ผู้รับบริการเกี่ยวกับงานวิจัยและงานบริการวิชาการของสำนักวิชา เพื่อนำไปปรับปรุงการดำเนินงานของสำนักวิชาให้มีประสิทธิภาพยิ่งขึ้น”\n\n",
              "text_1": "ดูขั้นตอน ",
              "text_2": "ไปยังระบบ"
            }
          ],
          "image": [
            {
              "image_0": "__PUBLIC_URL__/service-sut/image/2025/08/illus-bulletin%20PubH.png"
            }
          ],
          "link": [
            {
              "link_0": "__PUBLIC_URL__/service-sut/image/2025/08/SUT%20Bulletin%20PubH.pdf",
              "link_1": "https://iph.sut.ac.th/iph-mis/index.php/Main_voc"
            }
          ]
        },
        "study": {
          "title": "เรียนอย่างไรให้จบตามเวลา ?",
          "data": [
            {
              "id": "79",
              "courseID": "8",
              "detail": "1) การเรียนตามแผนการศึกษา จะทำให้นักศึกษาจบการศึกษาตามกำหนด 4 ปี จบตามเกณฑ์ การลงทะเบียนเรียนตามแผนการศึกษา จะทำให้นักศึกษามีตารางสอน ตารางสอบตรงกับเพื่อน ๆ ส่วนใหญ่ ทำให้มีตารางเวลาเรียน ทำกิจกรรมที่ตรงกับเพื่อน ๆ และกรณีนักศึกษาที่ได้รับทุนการศึกษา นักศึกษาในกลุ่มนี้จะต้องเรียนตามแผนการศึกษาเพื่อให้ผลการเรียนอยู่ในเกณฑ์ที่รับทุนได้ต่อไป",
              "image": "__PUBLIC_URL__/service-sut/image/public-health/H06-pubh-1.png",
              "createAt": "2022-07-23 11:59:01",
              "updataAt": "2022-07-23 11:59:01",
              "year": "2025"
            },
            {
              "id": "80",
              "courseID": "8",
              "detail": "2) เราเรียนระบบ 3 เทอม แต่ละเทอมจะมีเพียง 12 สัปดาห์ สิ่งที่ต้องทำให้ได้คือ การแบ่งเวลา เวลาเรียน เวลาเล่น เวลาทำกิจกรรม ทำทุกอย่างให้สมดุล",
              "image": "__PUBLIC_URL__/service-sut/image/public-health/H06-pubh-2.png",
              "createAt": "2022-07-23 11:59:01",
              "updataAt": "2022-07-23 11:59:01",
              "year": "2025"
            },
            {
              "id": "81",
              "courseID": "8",
              "detail": "3) ตั้งใจที่จะไม่ขาดเรียน อาศัยความเพียรและความมุ่งมั่นเป็นที่ตั้ง หมั่นทบทวนบทเรียน หลังการเรียนทุกครั้ง",
              "image": "__PUBLIC_URL__/service-sut/image/public-health/H06-pubh-3.png",
              "createAt": "2022-07-23 11:59:01",
              "updataAt": "2022-07-23 11:59:01",
              "year": "2025"
            },
            {
              "id": "82",
              "courseID": "8",
              "detail": "4) ยึดหลักการที่จะไม่ลอกการบ้านใคร ทำการบ้านไม่ได้ให้ไปหาอาจารย์ผู้สอน",
              "image": "__PUBLIC_URL__/service-sut/image/public-health/H06-pubh-4.png",
              "createAt": "2022-07-23 11:59:01",
              "updataAt": "2022-07-23 11:59:01",
              "year": "2025"
            },
            {
              "id": "83",
              "courseID": "8",
              "detail": "5) พบอาจารย์ที่ปรึกษาอย่างสม่ำเสมอ จะทำให้เราได้ที่พึ่งทั้งการเรียนและการใช้ชีวิต",
              "image": "__PUBLIC_URL__/service-sut/image/public-health/H06-pubh-5.png",
              "createAt": "2022-07-23 11:59:01",
              "updataAt": "2022-07-23 11:59:01",
              "year": "2025"
            },
            {
              "id": "84",
              "courseID": "8",
              "detail": "6) เมื่อใดที่เริ่มตามบทเรียนไม่ทัน ต้องหยุดทำกิจกรรมและมุ่งที่การเรียนก่อน",
              "image": "__PUBLIC_URL__/service-sut/image/public-health/H06-pubh-6.png",
              "createAt": "2022-07-23 11:59:01",
              "updataAt": "2022-07-23 11:59:01",
              "year": "2025"
            },
            {
              "id": "85",
              "courseID": "8",
              "detail": "7) อย่าลืมออกกำลังกายเป็นประจำ ถ้าร่างกายไม่แข็งแรงจะเป็นส่วนสำคัญมากที่จะทำให้ไม่สำเร็จการศึกษา",
              "image": "__PUBLIC_URL__/service-sut/image/public-health/H06-pubh-7.png",
              "createAt": "0000-00-00 00:00:00",
              "updataAt": "0000-00-00 00:00:00",
              "year": "2025"
            }
          ]
        },
        "misstion": {
          "title": "วิสัยทัศน์/พันธกิจ/ค่านิยม",
          "data": [
            {
              "title": "วิสัยทัศน์ (Vision)",
              "image": "__PUBLIC_URL__/service-sut/image/image_2024/Img/08-PubH/01-1.png",
              "text_0": "เป็นสถาบันการศึกษาที่มุ่งเน้นสุขภาพ สิ่งแวดล้อม และความปลอดภัย เพื่อสังคมที่่ยั่งยืน (Higher Educational Institute on Health, Environment, and Safety Focused for Sustainable Society)"
            },
            {
              "title": "พันธกิจ (Mission)",
              "image": "__PUBLIC_URL__/service-sut/image/public-health/vis-mis-val/mission.png",
              "text_0": "ผลิตและพัฒนากำลังคนด้านสาธารณสุขศาสตร์ วิจัยและพัฒนาความรู้ และผลงานวิชาการ ด้านอนามัยสิ่งแวดล้อม  และอาชีวอนามัยและความปลอดภัย ให้บริการวิชาการแก่ชุมชน เพื่อการพัฒนาที่ยั่งยืน"
            },
            {
              "title": "ค่านิยมหลัก (Core values) : IPH SMART",
              "image": "__PUBLIC_URL__/service-sut/image/public-health/vis-mis-val/value.png",
              "text_0": "I : Integrity ซื่อตรง \r\n",
              "text_1": "P : Professional คงความเชี่ยวชาญในวิชาชีพ \r\n",
              "text_2": "H : Human values จุดประทีปในใจคน \r\n",
              "text_3": "S : Societal contribution สร้างตนให้เป็นประโยชน์ต่อสังคม \r\n",
              "text_4": "M : Management by fact บริหารจัดการด้วยความจริง \r\n",
              "text_5": "A : Agility and Resilience แม้ล้ม..จะลุก..และวิ่ง..อย่างแคล่วคล่อง \r\n",
              "text_6": "R : Responsive to stakeholder needs ตอบสนอง..รับฟัง..เพื่อการพัฒนา \r\n",
              "text_7": "T : Technology and innovation focus นำพา สร้างสรรค์นวัตกรรม และเทคโนโลยี"
            }
          ]
        },
        "contract": [
          {
            "id": "451",
            "courseID": "8",
            "slang": "",
            "department": "สาขาวิชาของสำนัก ฯ",
            "phone": "044-223-820",
            "site": "WWW: http://iph.sut.ac.th/",
            "createAt": "2022-07-16 14:41:52",
            "updateAt": "2022-07-16 14:41:52",
            "year": "2025"
          },
          {
            "id": "456",
            "courseID": "8",
            "slang": "environmental-health",
            "department": "สาขาวิชาอนามัยสิ่งแวดล้อม",
            "phone": "",
            "site": "http://iph.sut.ac.th/personnel/envi-teacher/",
            "createAt": "2022-07-30 11:50:09",
            "updateAt": "2022-07-30 11:50:09",
            "year": "2025"
          },
          {
            "id": "457",
            "courseID": "8",
            "slang": "occupational-health-and-safety",
            "department": "สาขาวิชาอาชีวอนามัยและความปลอดภัย",
            "phone": "",
            "site": "http://iph.sut.ac.th/personnel/occ-teacher/",
            "createAt": "2022-07-30 11:50:09",
            "updateAt": "2022-07-30 11:50:09",
            "year": "2025"
          },
          {
            "id": "463",
            "courseID": "8",
            "slang": "nutrition-and-dietetics",
            "department": "สาขาวิชาโภชนวิทยาและการกำหนดอาหาร",
            "phone": "",
            "site": "http://iph.sut.ac.th/personnel/food-teacher/",
            "createAt": "0000-00-00 00:00:00",
            "updateAt": "0000-00-00 00:00:00",
            "year": "2025"
          }
        ],
        "visitor": 7000,
        "visitor_of_year": 894
      }
    },
    "department-degitech": {
      "code": 200,
      "status": "Get data success",
      "data": {
        "id": "9",
        "nameTH": "สำนักวิชาศาสตร์และศิลป์ดิจิทัล",
        "nameEN": "Institute of Digital Art and Science",
        "slang": "department-degitech",
        "image": "__PUBLIC_URL__/service-sut/image/Institute/pic-09.png",
        "createAt": "2022-07-09 03:50:32",
        "updataAt": "2022-07-09 03:50:32",
        "y2025": null,
        "y2024": null,
        "y2023": "__PUBLIC_URL__/service-sut/ebook-freshmen/2566/Institute_of_Digital_Arts_&_Science/Institute_of_Digital_Arts_&_Science.html",
        "y2022": "__PUBLIC_URL__/service-sut/ebook-freshmen/2565/Institute_of_Digital_Arts_&_Science/Institute_of_Digital_Arts_&_Science.html",
        "y2021": "__PUBLIC_URL__/service-sut/ebook-freshmen/2564/Digital_Arts_&_Science/Digital_Arts_&_Science.html",
        "y2020": "__PUBLIC_URL__/service-sut/ebook-freshmen/2563/DIGITECH-Digital%20Arts%20&%20Science/DIGITECH-Digital%20Arts%20&%20Science.html",
        "message": {
          "title": "สารจากคณบดี\nรองศาสตราจารย์ ดร.ธรา อั่งสกุล",
          "text": [
            {
              "text_0": "ในนามของผู้บริหารและคณาจารย์สำนักวิชาศาสตร์และศิลป์ดิจิทัล มหาวิทยาลัยเทคโนโลยีสุรนารี ขอต้อนรับนักศึกษาใหม่ปีบทองช่อที่ 32 DIGITECH รุ่นที่ 5 ทุกคน เข้าสู่รั้วมหาวิทยาลัยด้วยความยินดียิ่ง\n\n            ",
              "text_1": "มหาวิทยาลัยฯ ร่วมขานรับนโยบายรัฐบาลในการพัฒนาประเทศไทย 4.0 ด้านวิทยาศาสตร์และเทคโนโลยี เพื่อสร้างบัณฑิตที่มีสมรรถนะและศักยภาพสูงตรงตามความต้องการของสถานประกอบการ ด้วยเล็งเห็นถึงความสำคัญของอุตสาหกรรมดิจิทัลที่จะเติบโตอย่างก้าวกระโดดในอีก 5 ปีข้างหน้า ประกอบกับวิชาชีพด้านดิจิทัลเป็นหนึ่งในอาชีพที่สร้างรายได้ดีและกำลังเป็นที่ต้องการของตลาดแรงงานอย่างมาก จึงได้ยกระดับหลักสูตรด้านเทคโนโลยีสารสนเทศที่มหาวิทยาลัยเชี่ยวชาญอยู่เดิมและสอนมาแล้วถึง 28 ปี เป็นหลักสูตรศาสตร์และศิลป์ดิจิทัล ที่เน้นการสอนด้านเทคโนโลยีดิจิทัลและนิเทศศาสตร์ดิจิทัล\n\n            ",
              "text_2": "การจัดการศึกษาในหลักสูตรศาสตร์และศิลป์ดิจิทัลนี้ มุ่งเน้นการเรียนการสอนเพื่อให้นักศึกษาได้รับสมรรถนะที่สามารถนำไปประกอบอาชีพได้จริง โดยมีทั้งการเรียนการสอนในชั้นเรียน การเรียนการสอนออนไลน์ การฝึกปฏิบัติการ และการปฏิบัติงานจริงในสถานประกอบการ ซึ่งนับเป็นหลักสูตรรูปแบบใหม่ที่จัดการเรียนการสอนในรูปแบบชุดวิชา โดยนักศึกษาสามารถออกแบบหลักสูตรได้ตามความสนใจ เลือกชุดวิชาให้ตรงกับอาชีพที่อยากจะเป็น ทำให้ผู้เรียนมีทักษะและสามารถประกอบอาชีพได้ทันทีหลังสำเร็จการศึกษา ทั้งยังได้รับสัมฤทธิบัตรเพื่อเป็นใบเบิกทางในการประกอบอาชีพ และสะสมหน่วยกิตเพื่อขอรับปริญญาได้\n\n            ",
              "text_3": "อนึ่ง ขอให้นักศึกษาตระหนักถึงการเปลี่ยนแปลงสภาวะแวดล้อมของสังคมไทยและสังคมโลกที่ทำให้คนในสังคมจำเป็นต้องเปลี่ยนวิถีชีวิตเป็นแบบใหม่ หรือที่เรียกว่า New Normal อีกทั้งการก้าวเข้าสู่รั้วมหาวิทยาลัยถือเป็นอีกหนึ่งการเปลี่ยนแปลงครั้งยิ่งใหญ่ของชีวิตนักศึกษา ดังนั้นการปรับตัวได้อย่างรวดเร็วจึงจะทำให้นักศึกษาเป็นบัณฑิตที่พร้อมต่อสังคมไทยและสังคมโลกในยุคดิจิทัลได้ นอกจากนี้ การเรียนการสอนของมหาวิทยาลัยอาจแตกต่างจากชั้นมัธยมศึกษา ซึ่งหากนักศึกษาต้องการความช่วยเหลือสามารถปรึกษากับ “อาจารย์ที่ปรึกษา” ซึ่งคณาจารย์ทุกท่านมีความยินดีอย่างยิ่งที่จะช่วยเหลือนักศึกษาในการฟันฝ่าอุปสรรคต่าง ๆ ในรั้วมหาวิทยาลัย สุดท้ายนี้ ขอให้นักศึกษาประสบความสำเร็จในการศึกษา และสามารถจบการศึกษาเป็นบัณฑิตที่มีความสมบูรณ์พร้อมทั้ง ภูมิรู้ ภูมิธรรม ภูมิปัญญา และภูมิฐาน"
            }
          ],
          "image": [
            {
              "image_0": "__PUBLIC_URL__/service-sut/image/2023/department-degitech/09-Digitech.png",
              "image_1": "__PUBLIC_URL__/service-sut/image/2023/department-degitech/vdo-cover.png",
              "image_2": "__PUBLIC_URL__/service-sut/image/2023/department-degitech/vdo.mp4"
            }
          ]
        },
        "q1": {
          "title": "แนะนำสำนักวิชา",
          "text": [
            {
              "text_0": "เปิดสอนในหลักสูตรด้านเทคโนโลยีดิจิทัล และหลักสูตรด้านนิเทศศาสตร์ดิจิทัล ซึ่งสอดคล้องกับความต้องการของภาคธุรกิจและอุตสาหกรรม นโยบาย Thailand 4.0 และแนวโน้มสำคัญของโลก\n",
              "text_1": "จัดการศึกษาแบบมอดูล (Modular Program) คือ การเรียนเป็นชุดวิชา ที่ทำให้ผู้เรียนได้รับทักษะและความรู้แบบเบ็ดเสร็จภายในชุดวิชา\n",
              "text_2": "ผู้เรียนสามารถออกแบบโปรแกรมการเรียนตามวิชาชีพที่สนใจได้ด้วยตนเอง โดยมีอาจารย์ผู้สอนคอยให้คำแนะนำ (CREPES Model)\n",
              "text_3": "ผู้เรียนผ่านการเรียนในแต่ละมอดูล และประเมินสมรรถนะผ่าน จะได้รับสัมฤทธิบัตร (Certificate) เพื่อแสดงสมรรถนะดิจิทัลในด้านนั้น ๆ เพื่อเป็นใบเบิกทางในการประกอบอาชีพ และสามารถสะสมเพื่อขอรับปริญญาตรีได้"
            }
          ],
          "image": [
            {
              "image_0": "__PUBLIC_URL__/service-sut/image/2023/department-degitech/13.jpg",
              "image_1": "__PUBLIC_URL__/service-sut/image/2023/department-degitech/1686119818152.jpg",
              "image_2": "__PUBLIC_URL__/service-sut/image/2023/department-degitech/1686119817920.jpg",
              "image_3": "__PUBLIC_URL__/service-sut/image/2023/department-degitech/1686119818271.jpg"
            }
          ]
        },
        "q2": {
          "title": "Modular Program คืออะไร ?",
          "text": [
            {
              "text_0": "Modular Program หรือการศึกษาแบบมอดูล เป็นรูปแบบการจัดการเรียนการสอนที่ทาง DIGITECH ริเริ่มขึ้นในมหาวิทยาลัยเทคโนโลยีสุรนารีตามแนวนโยบายของอธิการบดี (ผู้อำนวยการโครงการ DIGITECH) โดยมีวัตถุประสงค์ที่มุ่งให้ผู้เรียนมีความรู้และทักษะที่สามารถปฏิบัติงานได้จริง \n        ",
              "text_1": "โดยการจัดการเรียนการสอน นักศึกษาจะลงทะเบียนเป็นชุดวิชา กล่าวคือ ใน 1 ชุดวิชานักศึกษาลงทะเบียน 3 รายวิชาที่มีความเกี่ยวข้องกัน นักศึกษาจะสามารถบูรณาการความรู้จากรายวิชาที่ 1 ไปสู่รายวิชาที่ 2 และสร้างสรรค์ผลงานจริงในรายวิชาโครงงาน ซึ่งเป็นรายวิชาที่ 3 ทำให้นักศึกษาได้รับทักษะและความรู้แบบเบ็ดเสร็จภายในชุดวิชานั้น ๆ  \r\n"
            }
          ],
          "image": [
            {
              "image_0": "__PUBLIC_URL__/service-sut/image/digi/02.png"
            }
          ]
        },
        "q3": {
          "title": "Modular Program คืออะไร ?",
          "text": [
            {
              "text_0": "ตัวอย่างเช่น \r\n ",
              "text_1": "ชุดรายวิชาการออกแบบประสบการณ์ผู้ใช้ (User Experience Design Module) ประกอบด้วย\n        ",
              "text_2": "1. รายวิชาหลักการปฏิสัมพันธ์ระหว่างมนุษย์กับคอมพิวเตอร์\n        ",
              "text_3": "2. รายวิชาการออกแบบประสบการณ์ผู้ใช้ และ\n        ",
              "text_4": "3. รายวิชาโครงงานการออกแบบส่วนต่อประสานงานผู้ใช้และประสบการณ์ผู้ใช้ \n\n        ",
              "text_5": "ในรายวิชาหลักการปฏิสัมพันธ์ระหว่างมนุษย์กับคอมพิวเตอร์  นักศึกษาจะเข้าใจเรื่องการสื่อสารระหว่างมนุษย์กับคอมพิวเตอร์ วิธีการ\nนำเข้า ประมวลผลและแสดงผลของคอมพิวเตอร์ และข้อจำกัดต่าง ๆ ของมนุษย์ ซึ่งความรู้เหล่านี้จะนำมาใช้ในการเรียนรายวิชาการออกแบบประสบการณ์ผู้ใช้ ที่มุ่งให้ผู้ใช้ระบบคอมพิวเตอร์มีประสบการณ์ที่ดีต่อระบบ ผลิตภัณฑ์ดิจิทัล รวมถึงแบรนด์ และเพื่อฝึกฝนทักษะนักศึกษาจะได้ทำผลงานการออกแบบส่วนต่อประสานงานผู้ใช้ (UI) และการออกแบบประสบการณ์ผู้ใช้ (UX) ภายใต้การดูแลของอาจารย์ในรายวิชาโครงงาน  \r\n"
            }
          ],
          "image": [
            {
              "image_0": "__PUBLIC_URL__/service-sut/image/digi/learn-1.png",
              "image_1": "__PUBLIC_URL__/service-sut/image/digi/learn-2.png",
              "image_2": "__PUBLIC_URL__/service-sut/image/digi/learn-3.png"
            }
          ]
        },
        "crepes_model": {
          "title": "CREPES MODEL คืออะไร ?",
          "text": [
            {
              "text_0": "CREPES Model (เครปส์โมเดล) คือ รูปแบบการจัดการศึกษาแบบมอดูลที่ ถูกพัฒนาขึ้นใหม่ โดยแบ่งออกเป็น 2 สาขาวิชา ได้แก่ สาขาวิชาเทคโนโลยีดิจิทัล (Digital Technology) เทียบได้กับเครปสูตรวานิลลา และ สาขาวิชานิเทศศาสตร์ดิจิทัล (Digital Communication) เทียบได้กับเครปสูตรชาร์โคล โดยมีมอดูลต่าง ๆ ซึ่งเทียบได้กับไส้เครป ที่ผู้เรียนสามารถเลือกได้ตามกลุ่มวิชาชีพที่สนใจ แต่ละรายวิชาย่อยในมอดูลต่าง ๆ สามารถหมุนเวียนใช้ร่วมกันได้ในทั้ง 2 สาขาวิชา ทําให้ผู้เรียนเป็นบัณฑิตที่มีสมรรถนะด้านดิจิทัลที่มีภูมิรู้ ภูมิธรรม และภูมิปัญญาทั้งด้านศาสตร์และศิลป์ โดยมีระบบสนับสนุนการตัดสินใจ ซึ่งช่วยให้ผู้เรียนสามารถเลือกสูตรเครปที่เหมาะสมกับตนเองมากที่สุด\n\n",
              "text_1": "CERTIFICATION\n        ",
              "text_2": "จัดการเรียนการสอนแบบมอดูล (ชุดวิชา) เมื่อเรียนจบหนึ่งมอดูล หากสอบวัดสมรรถนะผ่าน จะได้รับสัมฤทธิบัตร\nเพื่อแสดงความสามารถของนักศึกษา และเก็บสะสมได้เพื่อขอรับปริญญา\n\n",
              "text_3": "RE & UP-SKILL\n        ",
              "text_4": "ศิษย์เก่า คนทำงาน หรือนักศึกษาสาขาวิชาอื่นที่สนใจ สามารถมาเรียนเพิ่มพูนหรือปรับเปลี่ยนทักษะ โดยสามารถเลือกเรียนมอดูลที่สนใจ เป็นการส่งเสริมทักษะการเรียนรู้ตลอดชีวิต\n\n",
              "text_5": "EXPERIENCE\n        ",
              "text_6": "เน้นทักษะที่ผู้เรียนจะได้รับ จากการพัฒนาโครงงานและนวัตกรรม รวมทั้งเน้นประสบการณ์ในด้านนั้น ๆ จากผู้ประกอบการจริง\n\n",
              "text_7": "PERSONALIZATION\n        ",
              "text_8": "ผู้เรียนสามารถออกแบบหลักสูตรได้ตามความเหมาะสมของตนเองโดยมีอาจารย์คอยให้คำแนะนำ ในการเลือกมอดูล ให้ตรงกับอาชีพที่อยากจะเป็น\n\n",
              "text_9": "EMERGING EDUTECH\n        ",
              "text_10": "การนำเทคโนโลยีทางการศึกษาใหม่ ๆ มาใช้ในการเรียนการสอน ไม่ว่าจะเป็นการจัดการเรียนการสอนแบบในห้องเรียน ผสมผสานกับ Online Learning ในทุกมอดูล รวมถึงการใช้ Active Learning เพื่อส่งเสริมการเรียนรู้และทักษะของนักศึกษาในยุคดิจิทัล\n"
            }
          ],
          "image": [
            {
              "image_0": "__PUBLIC_URL__/service-sut/image/2023/department-degitech/09-03-01.png",
              "image_1": "__PUBLIC_URL__/service-sut/image/2023/department-degitech/09-03-02.png",
              "image_2": "__PUBLIC_URL__/service-sut/image/2023/department-degitech/09-03-03.png"
            }
          ]
        },
        "about": {
          "title": "ข้อมูลหลักสูตร",
          "text": [
            {
              "text_0": "เปิดสอนใน 2 หลักสูตร ได้แก่ สาขาวิชาเทคโนโลยีดิจิทัล และสาขาวิชานิเทศศาสตร์ดิจิทัล ซึ่งสอดคล้องกับความต้องการของภาคธุรกิจและอุตสาหกรรม ตามนโยบาย Thailand 4.0 และแนวโน้มสําคัญของโลก และจัดการศึกษาแบบมอดูล (Modular Program) คือ การเรียนเป็นชุดวิชาที่ทําให้ผู้เรียนได้รับทักษะและความรู้แบบเบ็ดเสร็จภายในชุดวิชา ซึ่งเป็นการจัดการศึกษารูปแบบใหม่ที่เน้นให้ผู้เรียนสามารถเลือกเรียนตามกลุ่มวิชาชีพที่สนใจพัฒนาทักษะที่จําเป็นให้ผู้เรียนสามารถทํางานได้จริงและส่งเสริมการเรียนรู้ตลอดชีวิต เมื่อผู้เรียนผ่านการเรียนในแต่ละมอดูลจะได้รับสัมฤทธิบัตรเพื่อแสดงสมรรถนะดิจิทัลในด้านนั้น ๆ"
            }
          ],
          "image": [
            {
              "image_0": "__PUBLIC_URL__/service-sut/image/digi/06.png",
              "image_1": "__PUBLIC_URL__/service-sut/image/digi/DC-1.png"
            }
          ]
        },
        "activity": {
          "title": "กิจกรรมฝึกประสบการณ์",
          "text": [
            {
              "text_0": "DIGITECH Showcase งานนิทรรศการแสดงผลงานของนักศึกษาระดับปริญญาตรี ชั้นปีที่ 4"
            }
          ],
          "image": [
            {
              "image_0": "__PUBLIC_URL__/service-sut/image/image-2023/department-degitech/09-05-01.png",
              "image_1": "__PUBLIC_URL__/service-sut/image/image-2023/department-degitech/09-05-02.png",
              "image_2": "__PUBLIC_URL__/service-sut/image/image-2023/department-degitech/09-05-03.png"
            }
          ]
        },
        "advice": {
          "title": "ข้อแนะนำของสำนักวิชาศาสตร์และศิลป์ดิจิทัล",
          "text": [
            {
              "text_0": "แนะนำสำนักวิชา",
              "text_1": "Modular Program คืออะไร ?",
              "text_2": "CREPES MODEL คืออะไร ?",
              "text_3": "ข้อมูลหลักสูตร",
              "text_4": "กิจกรรมฝึกประสบการณ์"
            }
          ],
          "image": [
            {
              "image_0": ""
            }
          ]
        },
        "nature": {
          "title": "ลักษณะวิชาที่ศึกษาของสาขาวิชาเทคโนโลยีดิจิทัล",
          "text": [
            {
              "text_0": "ศึกษาเกี่ยวกับการบริหารเทคโนโลยีดิจิทัล  การพัฒนาซอฟต์แวร์  การจัดการข้อมูลและวิทยาศาสตร์ข้อมูล  เพื่อคิดวิเคราะห์ วางแผนการทำงานอย่างเป็นระบบและบูรณาการความรู้เพื่อสร้างสรรค์นวัตกรรมดิจิทัล  โดยมีกลุ่มวิชาชีพที่สามารถเลือกศึกษา ดังนี้\n \n",
              "text_1": "1 กลุ่มวิชาชีพด้านโปรแกรมประยุกต์บนเว็บ (Web Application Professionals)  \n",
              "text_2": "2 กลุ่มวิชาชีพด้านโปรแกรมประยุกต์บนมือถือ (Mobile Application Professionals)  \n",
              "text_3": "3 กลุ่มวิชาชีพด้านซอฟต์แวร์วิสาหกิจ (Enterprise Software Professionals)  \n",
              "text_4": "4 กลุ่มวิชาชีพด้านการจัดการข้อมูล (Data Handling Professionals)  \n",
              "text_5": "5 กลุ่มวิชาชีพด้านวิทยาศาสตร์ข้อมูล (Data Science Professionals)  \n",
              "text_6": "6 กลุ่มวิชาชีพด้านเทคโนโลยีคลาวด์ (Cloud Technology Professionals)"
            }
          ],
          "image": [
            {
              "image_0": "__PUBLIC_URL__/service-sut/image/digi/DT-2.png"
            }
          ]
        },
        "dc": {
          "title": "ลักษณะวิชาที่ศึกษาของสาขาวิชานิเทศศาสตร์ดิจิทัล",
          "text": [
            {
              "text_0": "ศึกษาเกี่ยวกับเทคโนโลยีดิจิทัล เพื่อบูรณาการกับองค์ความรู้ทางด้านนิเทศศาสตร์ดิจิทัล เพื่อคิดสร้างสรรค์ วางแผน เตรียมการผลิต ผลิต เผยแพร่ ประเมินผล และวิเคราะห์วิพากษ์ผลงานสื่อดิจิทัล โดยมีกลุ่มวิชาชีพที่สามารถเลือกศึกษา ดังนี้ ",
              "text_1": "1 กลุ่มวิชาชีพด้านการออกแบบวิชวล (Visual Design Professionals) ",
              "text_2": "2 กลุ่มวิชาชีพด้านเนื้อหาดิจิทัล (Digital Content Professionals) ",
              "text_3": "3 กลุ่มวิชาชีพด้านแอนิเมชัน (Animation Professionals) ",
              "text_4": "4 กลุ่มวิชาชีพด้านวีดิทัศน์ดิจิทัล (Digital Video Professionals) ",
              "text_5": "5 กลุ่มวิชาชีพด้านเกมคอมพิวเตอร์ (Computer Game Professionals) ",
              "text_6": "6 กลุ่มวิชาชีพด้านการวางแผนสื่อดิจิทัล (Digital Media Planning Professionals) ",
              "text_7": "7 กลุ่มวิชาชีพด้านการรายงานข่าวแบบเรียลไทม์ (Real-time Reporting Professionals) ",
              "text_8": "8 กลุ่มวิชาชีพด้านโปรแกรมประยุกต์บนมือถือ (Mobile Application Professionals) ",
              "text_9": "9 กลุ่มวิชาชีพด้านการวิจัยสื่อดิจิทัล (Digital Media Research Professionals)"
            }
          ],
          "image": [
            {
              "image_0": "__PUBLIC_URL__/service-sut/image/digi/DC-1.png"
            }
          ]
        },
        "crepes": [
          {
            "id": "7",
            "title": "CERTIFICATION",
            "detail": "จัดการเรียนการสอนแบบมอดูล (ชุดวิชา) เมื่อเรียนจบหนึ่งมอดูล หากสอบวัดสมรรถนะผ่าน จะได้รับสัมฤทธิบัตร เพื่อแสดงความสามารถของนักศึกษา และเก็บสะสมได้เพื่อขอรับปริญญา",
            "image": "",
            "year": "2025"
          },
          {
            "id": "8",
            "title": "RE & UP-SKILL",
            "detail": "ศิษย์เก่า คนทำงาน หรือนักศึกษาสาขาวิชาอื่นที่สนใจ สามารถมาเรียนเพิ่มพูนหรือ ปรับเปลี่ยนทักษะ โดยสามารถเลือกเรียนมอดูลที่สนใจ เป็นการส่งเสริมทักษะการเรียนรู้ตลอดชีวิต",
            "image": "",
            "year": "2025"
          },
          {
            "id": "9",
            "title": "EXPERIENCE BASE",
            "detail": "เน้นทักษะที่ผู้เรียนจะได้รับ จากการพัฒนาโครงงานและนวัตกรรม รวมทั้งเน้นประสบการณ์ในด้านนั้น ๆ จากผู้ประกอบการจริง",
            "image": "",
            "year": "2025"
          },
          {
            "id": "10",
            "title": "PERSONALIZATION",
            "detail": "ผู้เรียนสามารถออกแบบหลักสูตรได้ตามความเหมาะสมของตนเอง โดยมีอาจารย์คอยให้คำแนะนำในการเลือกมอดูล ให้ตรงกับอาชีพที่อยากจะเป็น",
            "image": "",
            "year": "2025"
          },
          {
            "id": "11",
            "title": "EMERGING EDUTECH",
            "detail": "การนำเทคโนโลยีทางการศึกษาใหม่ ๆ มาใช้ในการเรียนการสอน ไม่ว่าจะเป็น การจัดการเรียนการสอนแบบในห้องเรียน ผสมผสานกับ Online Learning ในทุกมอดูล รวมถึงการใช้ Active Learning เพื่อส่งเสริมการเรียนรู้และทักษะของนักศึกษาในยุคดิจิทัล",
            "image": "",
            "year": "2025"
          },
          {
            "id": "12",
            "title": "STANDARDIZATION",
            "detail": "ออกแบบหลักสูตรตามมาตรฐานคุณวุฒิระดับปริญญาตรีตามประกาศกระทรวงศึกษาธิการ และตามมาตรฐานสากล IEEE และ ACM นอกจากนี้มอดูลต่าง ๆ ในหลักสูตร ยังออกแบบโดย อิงตามมาตรฐานของบริษัท ที่ถูกยอมรับในด้านนั้น ๆ",
            "image": "",
            "year": "2025"
          }
        ],
        "contract": [
          {
            "id": "452",
            "courseID": "9",
            "slang": "",
            "department": "สาขาวิชาของสำนักวิชาศาสตร์และศิลป์ดิจิทัล",
            "phone": "0 4422 3789 \r\n0 4422 4205",
            "site": "http://digitech.sut.ac.th/",
            "createAt": "2022-07-16 14:43:50",
            "updateAt": "2022-07-16 14:43:50",
            "year": "2025"
          },
          {
            "id": "454",
            "courseID": "9",
            "slang": "digital-technology",
            "department": "สาขาวิชาเทคโนโลยีดิจิทัล",
            "phone": "",
            "site": "",
            "createAt": "2022-07-27 05:27:38",
            "updateAt": "2022-07-27 05:27:38",
            "year": "2025"
          },
          {
            "id": "458",
            "courseID": "9",
            "slang": "digital-communication",
            "department": "สาขาวิชานิเทศศาสตร์ดิจิทัล",
            "phone": "",
            "site": "",
            "createAt": "2022-07-30 12:02:27",
            "updateAt": "2022-07-30 12:02:27",
            "year": "2025"
          }
        ],
        "visitor": 5857,
        "visitor_of_year": 1121
      }
    }
  },
  "branches": {
    "technology-program-in-innovative-agripreneur": {
      "code": 200,
      "status": "Get data success",
      "data": {
        "information": {
          "id": "54",
          "courseID": "3",
          "titleTH": "หลักสูตรเทคโนโลยีบัณฑิตสาขาวิชาผู้ประกอบการเกษตรเชิงนวัตกรรม",
          "titleEN": "Bachelor of Technology Program in Innovative Agripreneur",
          "slang": "technology-program-in-innovative-agripreneur",
          "nameTH": "หลักสูตรเทคโนโลยีบัณฑิต สาขาวิชาผู้ประกอบการเกษตรเชิงนวัตกรรม",
          "nameEN": "Bachelor of Technology Program in Innovative Agripreneur",
          "nameDegreeTH": "เทคโนโลยีบัณฑิต (ผู้ประกอบการเกษตรเชิงนวัตกรรม)",
          "nameDegreeEN": "Bachelor of Technology (Innovative Agripreneur)",
          "vision": "สำนักวิชาเทคโนโลยีการเกษตร เป็นองค์กรชั้นนำที่สุ่งสู่ความเป็นเลิศด้านการเกษตรบูรณาการ โดยการใช้วิทยาศาสตร์ เทคโนโลยี และนวัตกรรม เป็นฐานในการพัฒนาเศรษฐกิจ ให้สอดคล้องกับการพัฒนายุทธศาสตร์ของประเทศไทยอย่างยั่งยืน",
          "mission": "1) ผลิตและพัฒนากำลังคนทางด้านวิทยาศาสตร์ เทคโนโลยี และนวัตกรรม เพื่อตอบสนองต่อความต้องการ ในการพัฒนาประเทศ\n|2) วิจัยและค้นคว้า เพื่อสร้างสรรค์ความก้าวหน้าทางวิชาการ และการนำผลการวิจัยและพัฒนา ไปใช้ในการพัฒนาประเทศ\n|3) ให้บริการทางวิชาการแก่ประชาชนและหน่วยงานต่าง ๆ ทั้งภาครัฐและภาคเอกชน\n|4) ทะนุบำรุงศิลปะและวัฒนธรรมของชาติและของท้องถิ่นโดยเฉพาะอย่างยิ่งศิลปะและวัฒนธรรมของภาคตะวันออกเฉียงเหนือ\n|5) ปรับแปลงถ่ายทอดและพัฒนาเทคโนโลยีด้านการเกษตรเพื่อให้ประเทศไทยพึ่งพาตนเองทางเทคโนโลยีเพื่อการพัฒนาได้มากขึ้น",
          "course_structure": "https://iat.sut.ac.th/curriculum/agripreneur-bsc/",
          "study_plan": "https://iat.sut.ac.th/curriculum/agripreneur-bsc/",
          "teacher": "https://iat.sut.ac.th/academic-staff/",
          "graduation_goals": "",
          "graduation_results": "",
          "employment_goals": "",
          "image": "__PUBLIC_URL__/service-sut/image/2_Institute/3_agri/04_innoagri/slide1.jpg,__PUBLIC_URL__/service-sut/image/2_Institute/3_agri/04_innoagri/slide2.jpg,__PUBLIC_URL__/service-sut/image/2_Institute/3_agri/04_innoagri/slide3.jpg",
          "footer": "__PUBLIC_URL__/service-sut/image/2_Institute/3_agri/04_innoagri/foot1.jpg,__PUBLIC_URL__/service-sut/image/2_Institute/3_agri/04_innoagri/foot2.jpg,__PUBLIC_URL__/service-sut/image/2_Institute/3_agri/04_innoagri/foot3.jpg",
          "createAt": null,
          "updateAt": null,
          "year": "2025"
        },
        "vision": {
          "vision_0": "สำนักวิชาเทคโนโลยีการเกษตร เป็นองค์กรชั้นนำที่สุ่งสู่ความเป็นเลิศด้านการเกษตรบูรณาการ โดยการใช้วิทยาศาสตร์ เทคโนโลยี และนวัตกรรม เป็นฐานในการพัฒนาเศรษฐกิจ ให้สอดคล้องกับการพัฒนายุทธศาสตร์ของประเทศไทยอย่างยั่งยืน"
        },
        "mission": {
          "mission_0": "1) ผลิตและพัฒนากำลังคนทางด้านวิทยาศาสตร์ เทคโนโลยี และนวัตกรรม เพื่อตอบสนองต่อความต้องการ ในการพัฒนาประเทศ\n",
          "mission_1": "2) วิจัยและค้นคว้า เพื่อสร้างสรรค์ความก้าวหน้าทางวิชาการ และการนำผลการวิจัยและพัฒนา ไปใช้ในการพัฒนาประเทศ\n",
          "mission_2": "3) ให้บริการทางวิชาการแก่ประชาชนและหน่วยงานต่าง ๆ ทั้งภาครัฐและภาคเอกชน\n",
          "mission_3": "4) ทะนุบำรุงศิลปะและวัฒนธรรมของชาติและของท้องถิ่นโดยเฉพาะอย่างยิ่งศิลปะและวัฒนธรรมของภาคตะวันออกเฉียงเหนือ\n",
          "mission_4": "5) ปรับแปลงถ่ายทอดและพัฒนาเทคโนโลยีด้านการเกษตรเพื่อให้ประเทศไทยพึ่งพาตนเองทางเทคโนโลยีเพื่อการพัฒนาได้มากขึ้น"
        },
        "image": {
          "image_0": "__PUBLIC_URL__/service-sut/image/2_Institute/3_agri/04_innoagri/slide1.jpg",
          "image_1": "__PUBLIC_URL__/service-sut/image/2_Institute/3_agri/04_innoagri/slide2.jpg",
          "image_2": "__PUBLIC_URL__/service-sut/image/2_Institute/3_agri/04_innoagri/slide3.jpg"
        },
        "footer": {
          "image_0": "__PUBLIC_URL__/service-sut/image/2_Institute/3_agri/04_innoagri/foot1.jpg",
          "image_1": "__PUBLIC_URL__/service-sut/image/2_Institute/3_agri/04_innoagri/foot2.jpg",
          "image_2": "__PUBLIC_URL__/service-sut/image/2_Institute/3_agri/04_innoagri/foot3.jpg"
        },
        "icon": [
          {
            "id": "18",
            "courseID": "3",
            "branchID": "0",
            "detail": "ชื่อหลักสูตร",
            "image": "__PUBLIC_URL__/service-sut/image/icon/school-agri-01.svg"
          },
          {
            "id": "19",
            "courseID": "3",
            "branchID": "0",
            "detail": "ชื่อปริญญาบัตรและสาขา",
            "image": "__PUBLIC_URL__/service-sut/image/icon/school-agri-02.svg"
          },
          {
            "id": "20",
            "courseID": "3",
            "branchID": "0",
            "detail": "โครงสร้างหลักสูตร",
            "image": "__PUBLIC_URL__/service-sut/image/icon/school-agri-03.svg"
          },
          {
            "id": "21",
            "courseID": "3",
            "branchID": "0",
            "detail": "แผนการศึกษา",
            "image": "__PUBLIC_URL__/service-sut/image/icon/school-agri-04.svg"
          },
          {
            "id": "22",
            "courseID": "3",
            "branchID": "0",
            "detail": "อาจารย์ประจำหลักสูตร",
            "image": "__PUBLIC_URL__/service-sut/image/icon/school-agri-05.svg"
          },
          {
            "id": "23",
            "courseID": "3",
            "branchID": "0",
            "detail": "เป้าหมายการรับและ การสำเร็จการศึกษา",
            "image": "__PUBLIC_URL__/service-sut/image/icon/school-agri-06.svg"
          },
          {
            "id": "24",
            "courseID": "3",
            "branchID": "0",
            "detail": "ผลการรับและ สำเร็จการศึกษา",
            "image": "__PUBLIC_URL__/service-sut/image/icon/school-agri-07.svg"
          },
          {
            "id": "25",
            "courseID": "3",
            "branchID": "0",
            "detail": "เป้าหมายการได้งานทำ ของบัณฑิต",
            "image": "__PUBLIC_URL__/service-sut/image/icon/school-agri-08.svg"
          }
        ],
        "header": {
          "header_0": "ชื่อปริญญาและสาขา",
          "header_1": "วิสัยทัศน์",
          "header_2": "พันธกิจ",
          "header_3": "โครงสร้างหลักสูตร",
          "header_4": "แผนการศึกษา",
          "header_5": "ผลการรับและสำเร็จการศึกษา",
          "header_6": "เป้าหมายการรับและการสำเร็จการศึกษา",
          "header_7": "ผลการรับและสำเร็จการศึกษา",
          "header_8": "เป้าหมายการได้งานทำของบัณฑิต"
        },
        "visitor": 546,
        "visitor_of_year": 59
      }
    },
    "mathematics": {
      "code": 200,
      "status": "Get data success",
      "data": {
        "information": {
          "id": "55",
          "courseID": "1",
          "titleTH": "หลักสูตรวิทยาศาสตรบัณฑิต สาขาวิชาคณิตศาสตร์",
          "titleEN": "Bachelor of Science Program in Mathematics",
          "slang": "mathematics",
          "nameTH": "หลักสูตรวิทยาศาสตรบัณฑิต สาขาวิชาคณิตศาสตร์ (หลักสูตรปรับปรุง พ.ศ. 2565)",
          "nameEN": "Bachelor of Science Program in Mathematics",
          "nameDegreeTH": "วิทยาศาสตรบัณฑิต (คณิตศาสตร์)",
          "nameDegreeEN": "Bachelor of Science (Mathematics)\nB.Sc. (Mathematics)",
          "vision": "ลุ่มลึกในคณิตศาสตร์ สื่อสารด้วยบรรยากาศครอบครัว",
          "mission": "1. มีความรู้ความเข้าใจในเนื้อหาสาระทางด้านคณิตศาสตร์เป็นอย่างดี มีเหตุผล สามารถคิดวิเคราะห์ และแก้ปัญหาได้อย่างเป็นระบบ มีความคิดสร้างสรรค์ ใฝ่เรียนรู้ สามารถนำเครื่องมือทางคณิตศาสตร์ไปประยุกต์แก้ปัญหาในศาสตร์อื่น ๆ ที่เกี่ยวข้องได้ ตลอดจนสามารถติดตามความก้าวหน้าทางวิชาการ และพัฒนาองค์ความรู้ใหม่ เพื่อการเรียนรู้ตลอดชีวิต\n|2. มีทักษะด้านภาษา การสื่อสาร และเทคโนโลยีสารสนเทศ มีมนุษยสัมพันธ์ที่ดี สามารถทำงานร่วมกับผู้อื่นได้ทั้งในฐานะผู้นำและผู้ตาม ตลอดจนมีความรับผิดชอบต่อตนเอง สังคม และมีจิตสาธารณะ\n|3. มีความพร้อมและมีศักยภาพในการประกอบอาชีพ หรือศึกษาต่อและวิจัยในระดับบัณฑิตศึกษา ด้วยคุณภาพและมาตรฐานสากลในการเข้าสู่ประชาคมอาเซียนและนานาชาติ\n|4. มีจิตสำนึกวัฒนธรรมที่ดีงามและรู้คุณค่าของความเป็นไทย ควบคู่ไปกับการมีคุณธรรมและจริยธรรมในการดำเนินชีวิตและประกอบอาชีพ",
          "course_structure": "http://reg4.sut.ac.th/registrar/program_info_1.asp?f_cmd=2&acadyear=-1&levelid=1&programid=101030101650&facultyid=10100&programname=%A4%B3%D4%B5%C8%D2%CA%B5%C3%EC%2D2565&facultyname=%CA%D3%B9%D1%A1%C7%D4%AA%D2%C7%D4%B7%C2%D2%C8%D2%CA%B5%C3%EC&levelname=%BB%C3%D4%AD%AD%D2%B5%C3%D5",
          "study_plan": "http://reg4.sut.ac.th/registrar/studyplan_info1.asp?avs669746568=19&acadyear=-1&levelid=1&programid=101030101650&facultyid=10100&programname=%A4%B3%D4%B5%C8%D2%CA%B5%C3%EC%2D2565&facultyname=%CA%D3%B9%D1%A1%C7%D4%AA%D2%C7%D4%B7%C2%D2%C8%D2%CA%B5%C3%EC&levelname=%BB%C3%D4%AD%AD%D2%B5%C3%D5",
          "teacher": "https://beta.sut.ac.th/is-mathematics/คณาจารย์-บุคลากร/คณาจารย์",
          "graduation_goals": "รอข้อมูลจากสำนัก",
          "graduation_results": "รอข้อมูลจากสำนัก",
          "employment_goals": "รอข้อมูลจากสำนัก",
          "image": "__PUBLIC_URL__/service-sut/image/2_Institute/1_sci/01_math/slide1.jpg,__PUBLIC_URL__/service-sut/image/2_Institute/1_sci/01_math/slide2.JPG",
          "footer": "__PUBLIC_URL__/service-sut/image/2_Institute/1_sci/01_math/foot1.JPG,__PUBLIC_URL__/service-sut/image/2_Institute/1_sci/01_math/foot2.JPG,__PUBLIC_URL__/service-sut/image/2_Institute/1_sci/01_math/foot3.JPG",
          "createAt": null,
          "updateAt": null,
          "year": "2025"
        },
        "vision": {
          "vision_0": "ลุ่มลึกในคณิตศาสตร์ สื่อสารด้วยบรรยากาศครอบครัว"
        },
        "mission": {
          "mission_0": "1. มีความรู้ความเข้าใจในเนื้อหาสาระทางด้านคณิตศาสตร์เป็นอย่างดี มีเหตุผล สามารถคิดวิเคราะห์ และแก้ปัญหาได้อย่างเป็นระบบ มีความคิดสร้างสรรค์ ใฝ่เรียนรู้ สามารถนำเครื่องมือทางคณิตศาสตร์ไปประยุกต์แก้ปัญหาในศาสตร์อื่น ๆ ที่เกี่ยวข้องได้ ตลอดจนสามารถติดตามความก้าวหน้าทางวิชาการ และพัฒนาองค์ความรู้ใหม่ เพื่อการเรียนรู้ตลอดชีวิต\n",
          "mission_1": "2. มีทักษะด้านภาษา การสื่อสาร และเทคโนโลยีสารสนเทศ มีมนุษยสัมพันธ์ที่ดี สามารถทำงานร่วมกับผู้อื่นได้ทั้งในฐานะผู้นำและผู้ตาม ตลอดจนมีความรับผิดชอบต่อตนเอง สังคม และมีจิตสาธารณะ\n",
          "mission_2": "3. มีความพร้อมและมีศักยภาพในการประกอบอาชีพ หรือศึกษาต่อและวิจัยในระดับบัณฑิตศึกษา ด้วยคุณภาพและมาตรฐานสากลในการเข้าสู่ประชาคมอาเซียนและนานาชาติ\n",
          "mission_3": "4. มีจิตสำนึกวัฒนธรรมที่ดีงามและรู้คุณค่าของความเป็นไทย ควบคู่ไปกับการมีคุณธรรมและจริยธรรมในการดำเนินชีวิตและประกอบอาชีพ"
        },
        "image": {
          "image_0": "__PUBLIC_URL__/service-sut/image/2_Institute/1_sci/01_math/slide1.jpg",
          "image_1": "__PUBLIC_URL__/service-sut/image/2_Institute/1_sci/01_math/slide2.JPG"
        },
        "footer": {
          "image_0": "__PUBLIC_URL__/service-sut/image/2_Institute/1_sci/01_math/foot1.JPG",
          "image_1": "__PUBLIC_URL__/service-sut/image/2_Institute/1_sci/01_math/foot2.JPG",
          "image_2": "__PUBLIC_URL__/service-sut/image/2_Institute/1_sci/01_math/foot3.JPG"
        },
        "icon": [
          {
            "id": "1",
            "courseID": "1",
            "branchID": "3",
            "detail": "ชื่อหลักสูตร",
            "image": "__PUBLIC_URL__/service-sut/image/icon/school-sci-01.svg"
          },
          {
            "id": "2",
            "courseID": "1",
            "branchID": "3",
            "detail": "ชื่อปริญญาบัตรและสาขา",
            "image": "__PUBLIC_URL__/service-sut/image/icon/school-sci-02.svg"
          },
          {
            "id": "3",
            "courseID": "1",
            "branchID": "3",
            "detail": "โครงสร้างหลักสูตร",
            "image": "__PUBLIC_URL__/service-sut/image/icon/school-sci-03.svg"
          },
          {
            "id": "4",
            "courseID": "1",
            "branchID": "3",
            "detail": "แผนการศึกษา",
            "image": "__PUBLIC_URL__/service-sut/image/icon/school-sci-04.svg"
          },
          {
            "id": "5",
            "courseID": "1",
            "branchID": "3",
            "detail": "อาจารย์ประจำหลักสูตร",
            "image": "__PUBLIC_URL__/service-sut/image/icon/school-sci-05.svg"
          },
          {
            "id": "6",
            "courseID": "1",
            "branchID": "3",
            "detail": "เป้าหมายการรับและ การสำเร็จการศึกษา",
            "image": "__PUBLIC_URL__/service-sut/image/icon/school-sci-06.svg"
          },
          {
            "id": "7",
            "courseID": "1",
            "branchID": "3",
            "detail": "ผลการรับและ สำเร็จการศึกษา",
            "image": "__PUBLIC_URL__/service-sut/image/icon/school-sci-07.svg"
          },
          {
            "id": "8",
            "courseID": "1",
            "branchID": "3",
            "detail": "เป้าหมายการได้งานทำ ของบัณฑิต",
            "image": "__PUBLIC_URL__/service-sut/image/icon/school-sci-08.svg"
          }
        ],
        "header": {
          "header_0": "ชื่อปริญญาและสาขา",
          "header_1": "วิสัยทัศน์",
          "header_2": "พันธกิจ",
          "header_3": "โครงสร้างหลักสูตร",
          "header_4": "แผนการศึกษา",
          "header_5": "ผลการรับและสำเร็จการศึกษา",
          "header_6": "เป้าหมายการรับและการสำเร็จการศึกษา",
          "header_7": "ผลการรับและสำเร็จการศึกษา",
          "header_8": "เป้าหมายการได้งานทำของบัณฑิต"
        },
        "visitor": 496,
        "visitor_of_year": 77
      }
    },
    "biology": {
      "code": 200,
      "status": "Get data success",
      "data": {
        "information": {
          "id": "56",
          "courseID": "1",
          "titleTH": "หลักสูตรวิทยาศาสตรบัณฑิต สาขาวิชาชีววิทยา",
          "titleEN": "Bachelor of Science Program in Biology",
          "slang": "biology",
          "nameTH": "หลักสูตรวิทยาศาสตรบัณฑิต สาขาวิชาชีววิทยา (หลักสูตรปรับปรุง พ.ศ. 2565)",
          "nameEN": "Bachelor of Science Program in Biology",
          "nameDegreeTH": "วิทยาศาสตรบัณฑิต (ชีววิทยา)",
          "nameDegreeEN": "Bachelor of Science (Biology)\nB.Sc. (Biology)",
          "vision": "มุ่งผลิตบันฑิตทางชีววิทยาที่มีภูมิรู้ ภูมิธรรม และภูมิปัญญา เพื่อร่วมพัฒนาประเทศอย่างยั่งยืน",
          "mission": "1. เพื่อผลิตบัณฑิตทางชีววิทยาที่สามารถเชื่อมโยงและบูรณาการความรู้ทางชีววิทยาสาขาต่างๆ และศาสตร์อื่นๆ\n|2. เพื่อผลิตบัณฑิตทางชีววิทยาที่สามารถเรียนรู้ด้วยตนเอง สามารถใช้เทคโนโลยีสารสนเทศและการสื่อสารที่เหมาะสม\n|3. เพื่อผลิตบัณฑิตทางชีววิทยาที่เข้าใจหลักการเป็นผู้ประกอบการ\n|4. เพื่อผลิตบัณฑิตทางชีววิทยาที่มีพร้อมทั้งความรู้ คุณธรรม จริยธรรมและทัศนคติสำหรับการทำงาน เพื่อสร้างประโยชน์แก่ส่วนรวม\n|5. เพื่อผลิตบัณฑิตที่สามารถวิเคราะห์และประยุกต์ความรู้ทางชีววิทยาสำหรับการทำงานทางด้านวิทยาศาสตร์และเทคโนโลยี",
          "course_structure": "http://reg4.sut.ac.th/registrar/program_info_1.asp?f_cmd=2&acadyear=-1&levelid=1&programid=101040101650&facultyid=10100&programname=%AA%D5%C7%C7%D4%B7%C2%D2%2D2565&facultyname=%CA%D3%B9%D1%A1%C7%D4%AA%D2%C7%D4%B7%C2%D2%C8%D2%CA%B5%C3%EC&levelname=%BB%C3%D4%AD%AD%D2%B5%C3%D5",
          "study_plan": "http://reg4.sut.ac.th/registrar/studyplan_info1.asp?avs669746568=25&acadyear=-1&levelid=1&programid=101040101650&facultyid=10100&programname=%AA%D5%C7%C7%D4%B7%C2%D2%2D2565&facultyname=%CA%D3%B9%D1%A1%C7%D4%AA%D2%C7%D4%B7%C2%D2%C8%D2%CA%B5%C3%EC&levelname=%BB%C3%D4%AD%AD%D2%B5%C3%D5",
          "teacher": "https://beta.sut.ac.th/is-biology/คณาจารย์-บุคลากร/คณาจารย์",
          "graduation_goals": "รอข้อมูลจากสำนัก",
          "graduation_results": "รอข้อมูลจากสำนัก",
          "employment_goals": "รอข้อมูลจากสำนัก",
          "image": "__PUBLIC_URL__/service-sut/image/2_Institute/1_sci/02_bio/slide1.JPG,__PUBLIC_URL__/service-sut/image/2_Institute/1_sci/02_bio/slide2.JPG,__PUBLIC_URL__/service-sut/image/2_Institute/1_sci/02_bio/slide3.JPG,__PUBLIC_URL__/service-sut/image/2_Institute/1_sci/02_bio/slide4.JPG",
          "footer": "__PUBLIC_URL__/service-sut/image/2_Institute/1_sci/02_bio/foot1.JPG,__PUBLIC_URL__/service-sut/image/2_Institute/1_sci/02_bio/foot2.JPG,__PUBLIC_URL__/service-sut/image/2_Institute/1_sci/02_bio/foot3.JPG",
          "createAt": null,
          "updateAt": "2023-07-07 14:16:3",
          "year": "2025"
        },
        "vision": {
          "vision_0": "มุ่งผลิตบันฑิตทางชีววิทยาที่มีภูมิรู้ ภูมิธรรม และภูมิปัญญา เพื่อร่วมพัฒนาประเทศอย่างยั่งยืน"
        },
        "mission": {
          "mission_0": "1. เพื่อผลิตบัณฑิตทางชีววิทยาที่สามารถเชื่อมโยงและบูรณาการความรู้ทางชีววิทยาสาขาต่างๆ และศาสตร์อื่นๆ\n",
          "mission_1": "2. เพื่อผลิตบัณฑิตทางชีววิทยาที่สามารถเรียนรู้ด้วยตนเอง สามารถใช้เทคโนโลยีสารสนเทศและการสื่อสารที่เหมาะสม\n",
          "mission_2": "3. เพื่อผลิตบัณฑิตทางชีววิทยาที่เข้าใจหลักการเป็นผู้ประกอบการ\n",
          "mission_3": "4. เพื่อผลิตบัณฑิตทางชีววิทยาที่มีพร้อมทั้งความรู้ คุณธรรม จริยธรรมและทัศนคติสำหรับการทำงาน เพื่อสร้างประโยชน์แก่ส่วนรวม\n",
          "mission_4": "5. เพื่อผลิตบัณฑิตที่สามารถวิเคราะห์และประยุกต์ความรู้ทางชีววิทยาสำหรับการทำงานทางด้านวิทยาศาสตร์และเทคโนโลยี"
        },
        "image": {
          "image_0": "__PUBLIC_URL__/service-sut/image/2_Institute/1_sci/02_bio/slide1.JPG",
          "image_1": "__PUBLIC_URL__/service-sut/image/2_Institute/1_sci/02_bio/slide2.JPG",
          "image_2": "__PUBLIC_URL__/service-sut/image/2_Institute/1_sci/02_bio/slide3.JPG",
          "image_3": "__PUBLIC_URL__/service-sut/image/2_Institute/1_sci/02_bio/slide4.JPG"
        },
        "footer": {
          "image_0": "__PUBLIC_URL__/service-sut/image/2_Institute/1_sci/02_bio/foot1.JPG",
          "image_1": "__PUBLIC_URL__/service-sut/image/2_Institute/1_sci/02_bio/foot2.JPG",
          "image_2": "__PUBLIC_URL__/service-sut/image/2_Institute/1_sci/02_bio/foot3.JPG"
        },
        "icon": [
          {
            "id": "1",
            "courseID": "1",
            "branchID": "3",
            "detail": "ชื่อหลักสูตร",
            "image": "__PUBLIC_URL__/service-sut/image/icon/school-sci-01.svg"
          },
          {
            "id": "2",
            "courseID": "1",
            "branchID": "3",
            "detail": "ชื่อปริญญาบัตรและสาขา",
            "image": "__PUBLIC_URL__/service-sut/image/icon/school-sci-02.svg"
          },
          {
            "id": "3",
            "courseID": "1",
            "branchID": "3",
            "detail": "โครงสร้างหลักสูตร",
            "image": "__PUBLIC_URL__/service-sut/image/icon/school-sci-03.svg"
          },
          {
            "id": "4",
            "courseID": "1",
            "branchID": "3",
            "detail": "แผนการศึกษา",
            "image": "__PUBLIC_URL__/service-sut/image/icon/school-sci-04.svg"
          },
          {
            "id": "5",
            "courseID": "1",
            "branchID": "3",
            "detail": "อาจารย์ประจำหลักสูตร",
            "image": "__PUBLIC_URL__/service-sut/image/icon/school-sci-05.svg"
          },
          {
            "id": "6",
            "courseID": "1",
            "branchID": "3",
            "detail": "เป้าหมายการรับและ การสำเร็จการศึกษา",
            "image": "__PUBLIC_URL__/service-sut/image/icon/school-sci-06.svg"
          },
          {
            "id": "7",
            "courseID": "1",
            "branchID": "3",
            "detail": "ผลการรับและ สำเร็จการศึกษา",
            "image": "__PUBLIC_URL__/service-sut/image/icon/school-sci-07.svg"
          },
          {
            "id": "8",
            "courseID": "1",
            "branchID": "3",
            "detail": "เป้าหมายการได้งานทำ ของบัณฑิต",
            "image": "__PUBLIC_URL__/service-sut/image/icon/school-sci-08.svg"
          }
        ],
        "header": {
          "header_0": "ชื่อปริญญาและสาขา",
          "header_1": "วิสัยทัศน์",
          "header_2": "พันธกิจ",
          "header_3": "โครงสร้างหลักสูตร",
          "header_4": "แผนการศึกษา",
          "header_5": "ผลการรับและสำเร็จการศึกษา",
          "header_6": "เป้าหมายการรับและการสำเร็จการศึกษา",
          "header_7": "ผลการรับและสำเร็จการศึกษา",
          "header_8": "เป้าหมายการได้งานทำของบัณฑิต"
        },
        "visitor": 737,
        "visitor_of_year": 80
      }
    },
    "chemical": {
      "code": 200,
      "status": "Get data success",
      "data": {
        "information": {
          "id": "57",
          "courseID": "1",
          "titleTH": "หลักสูตรวิทยาศาสตรบัณฑิต สาขาวิชาเคมี",
          "titleEN": "Bachelor of Science Program in Chemistry",
          "slang": "chemical",
          "nameTH": "หลักสูตรวิทยาศาสตรบัณฑิต สาขาวิชาเคมี (หลักสูตรปรับปรุง พ.ศ. 2565)",
          "nameEN": "Bachelor of Science Program in Chemistry",
          "nameDegreeTH": "วิทยาศาสตรบัณฑิต (เคมี)\nวท.บ. (เคมี)",
          "nameDegreeEN": "Bachelor of Science (Chemistry)\nB.Sc. (Chemistry)",
          "vision": "ผลิตบัณฑิตที่มีความรู้ทางเคมีที่เข้มแข็งและมีคุณธรรม เพื่อการศึกษาและวิจัยขั้นสูงมีความพร้อมในการประกอบอาชีพและนำไปสู่การพัฒนาอย่างยั่งยืน",
          "mission": "1. ผลิตบัณฑิตเคมีผู้มีภูมิรู้ ภูมิธรรม และภูมิปัญญา เพื่อร่วมพัฒนาประเทศอย่างยั่งยืน\n|2. สนับสนุนให้นักศึกษาได้มีโอกาสเรียนรู้ในการวิจัยและพัฒนาจากนักวิทยาศาสตร์ผู้เชี่ยวชาญเพื่อให้ทราบถึงแนวทางการค้นคว้าเพื่อสร้างความก้าวหน้าทางวิชาการ และการนำองค์ความรู้ที่ได้ไปใช้ในการพัฒนาประเทศ\n|3. ผลิตบัณฑิตเคมีที่มีคุณภาพ มีความสามารถที่ปรับแปลง ถ่ายทอด และพัฒนาองค์ความรู้ที่เหมาะสมเพื่อให้ประเทศไทยพึ่งพาตนเองทางวิทยาศาสตร์และเทคโนโลยี เพื่อการพัฒนาได้มากยิ่งขึ้น\n|4. สนับสนุนการให้บริการทางวิชาการแก่ประชาชนและหน่วยงานต่างๆ ทั้งภาครัฐและภาคเอกชน โดยใช้กิจกรรมที่เกี่ยวข้องกับการผลิตบัณฑิตเคมี\n|5. ผลิตบัณฑิตที่มีความโดดเด่นตามอัตลักษณ์ของมหาวิทยาลัยเทคโนโลยีสุรนารี รวมทั้งมีความตระหนักในคุณค่าของศิลปะวัฒนธรรมท้องถิ่น",
          "course_structure": "http://reg4.sut.ac.th/registrar/program_info_1.asp?f_cmd=2&acadyear=-1&levelid=1&programid=101020101650&facultyid=10100&programname=%E0%A4%C1%D5%2D2565&facultyname=%CA%D3%B9%D1%A1%C7%D4%AA%D2%C7%D4%B7%C2%D2%C8%D2%CA%B5%C3%EC&levelname=%BB%C3%D4%AD%AD%D2%B5%C3%D5",
          "study_plan": "http://reg4.sut.ac.th/registrar/studyplan_info1.asp?avs277099844=71&acadyear=-1&levelid=1&programid=101020101650&facultyid=10100&programname=%E0%A4%C1%D5%2D2565&facultyname=%CA%D3%B9%D1%A1%C7%D4%AA%D2%C7%D4%B7%C2%D2%C8%D2%CA%B5%C3%EC&levelname=%BB%C3%D4%AD%AD%D2%B5%C3%D5",
          "teacher": "https://beta.sut.ac.th/is-chemistry/คณาจารย์",
          "graduation_goals": "ปีละ 60 คน สำเร็จการศึกษาตามเวลา 100 %",
          "graduation_results": "รอข้อมูลจากสำนัก",
          "employment_goals": "ร้อยละ 90",
          "image": "__PUBLIC_URL__/service-sut/image/2_Institute/1_sci/03_chem/slide1.JPG,__PUBLIC_URL__/service-sut/image/2_Institute/1_sci/03_chem/slide2.JPG,__PUBLIC_URL__/service-sut/image/2_Institute/1_sci/03_chem/slide3.JPG,__PUBLIC_URL__/service-sut/image/2_Institute/1_sci/03_chem/slide4.JPG",
          "footer": "__PUBLIC_URL__/service-sut/image/2_Institute/1_sci/03_chem/foot1.jpg,__PUBLIC_URL__/service-sut/image/2_Institute/1_sci/03_chem/foot2.JPG,__PUBLIC_URL__/service-sut/image/2_Institute/1_sci/03_chem/foot3.JPG",
          "createAt": "2022-07-17 2:52:33",
          "updateAt": "2023-07-07",
          "year": "2025"
        },
        "vision": {
          "vision_0": "ผลิตบัณฑิตที่มีความรู้ทางเคมีที่เข้มแข็งและมีคุณธรรม เพื่อการศึกษาและวิจัยขั้นสูงมีความพร้อมในการประกอบอาชีพและนำไปสู่การพัฒนาอย่างยั่งยืน"
        },
        "mission": {
          "mission_0": "1. ผลิตบัณฑิตเคมีผู้มีภูมิรู้ ภูมิธรรม และภูมิปัญญา เพื่อร่วมพัฒนาประเทศอย่างยั่งยืน\n",
          "mission_1": "2. สนับสนุนให้นักศึกษาได้มีโอกาสเรียนรู้ในการวิจัยและพัฒนาจากนักวิทยาศาสตร์ผู้เชี่ยวชาญเพื่อให้ทราบถึงแนวทางการค้นคว้าเพื่อสร้างความก้าวหน้าทางวิชาการ และการนำองค์ความรู้ที่ได้ไปใช้ในการพัฒนาประเทศ\n",
          "mission_2": "3. ผลิตบัณฑิตเคมีที่มีคุณภาพ มีความสามารถที่ปรับแปลง ถ่ายทอด และพัฒนาองค์ความรู้ที่เหมาะสมเพื่อให้ประเทศไทยพึ่งพาตนเองทางวิทยาศาสตร์และเทคโนโลยี เพื่อการพัฒนาได้มากยิ่งขึ้น\n",
          "mission_3": "4. สนับสนุนการให้บริการทางวิชาการแก่ประชาชนและหน่วยงานต่างๆ ทั้งภาครัฐและภาคเอกชน โดยใช้กิจกรรมที่เกี่ยวข้องกับการผลิตบัณฑิตเคมี\n",
          "mission_4": "5. ผลิตบัณฑิตที่มีความโดดเด่นตามอัตลักษณ์ของมหาวิทยาลัยเทคโนโลยีสุรนารี รวมทั้งมีความตระหนักในคุณค่าของศิลปะวัฒนธรรมท้องถิ่น"
        },
        "image": {
          "image_0": "__PUBLIC_URL__/service-sut/image/2_Institute/1_sci/03_chem/slide1.JPG",
          "image_1": "__PUBLIC_URL__/service-sut/image/2_Institute/1_sci/03_chem/slide2.JPG",
          "image_2": "__PUBLIC_URL__/service-sut/image/2_Institute/1_sci/03_chem/slide3.JPG",
          "image_3": "__PUBLIC_URL__/service-sut/image/2_Institute/1_sci/03_chem/slide4.JPG"
        },
        "footer": {
          "image_0": "__PUBLIC_URL__/service-sut/image/2_Institute/1_sci/03_chem/foot1.jpg",
          "image_1": "__PUBLIC_URL__/service-sut/image/2_Institute/1_sci/03_chem/foot2.JPG",
          "image_2": "__PUBLIC_URL__/service-sut/image/2_Institute/1_sci/03_chem/foot3.JPG"
        },
        "icon": [
          {
            "id": "1",
            "courseID": "1",
            "branchID": "3",
            "detail": "ชื่อหลักสูตร",
            "image": "__PUBLIC_URL__/service-sut/image/icon/school-sci-01.svg"
          },
          {
            "id": "2",
            "courseID": "1",
            "branchID": "3",
            "detail": "ชื่อปริญญาบัตรและสาขา",
            "image": "__PUBLIC_URL__/service-sut/image/icon/school-sci-02.svg"
          },
          {
            "id": "3",
            "courseID": "1",
            "branchID": "3",
            "detail": "โครงสร้างหลักสูตร",
            "image": "__PUBLIC_URL__/service-sut/image/icon/school-sci-03.svg"
          },
          {
            "id": "4",
            "courseID": "1",
            "branchID": "3",
            "detail": "แผนการศึกษา",
            "image": "__PUBLIC_URL__/service-sut/image/icon/school-sci-04.svg"
          },
          {
            "id": "5",
            "courseID": "1",
            "branchID": "3",
            "detail": "อาจารย์ประจำหลักสูตร",
            "image": "__PUBLIC_URL__/service-sut/image/icon/school-sci-05.svg"
          },
          {
            "id": "6",
            "courseID": "1",
            "branchID": "3",
            "detail": "เป้าหมายการรับและ การสำเร็จการศึกษา",
            "image": "__PUBLIC_URL__/service-sut/image/icon/school-sci-06.svg"
          },
          {
            "id": "7",
            "courseID": "1",
            "branchID": "3",
            "detail": "ผลการรับและ สำเร็จการศึกษา",
            "image": "__PUBLIC_URL__/service-sut/image/icon/school-sci-07.svg"
          },
          {
            "id": "8",
            "courseID": "1",
            "branchID": "3",
            "detail": "เป้าหมายการได้งานทำ ของบัณฑิต",
            "image": "__PUBLIC_URL__/service-sut/image/icon/school-sci-08.svg"
          }
        ],
        "header": {
          "header_0": "ชื่อปริญญาและสาขา",
          "header_1": "วิสัยทัศน์",
          "header_2": "พันธกิจ",
          "header_3": "โครงสร้างหลักสูตร",
          "header_4": "แผนการศึกษา",
          "header_5": "ผลการรับและสำเร็จการศึกษา",
          "header_6": "เป้าหมายการรับและการสำเร็จการศึกษา",
          "header_7": "ผลการรับและสำเร็จการศึกษา",
          "header_8": "เป้าหมายการได้งานทำของบัณฑิต"
        },
        "visitor": 676,
        "visitor_of_year": 88
      }
    },
    "physics": {
      "code": 200,
      "status": "Get data success",
      "data": {
        "information": {
          "id": "58",
          "courseID": "1",
          "titleTH": "หลักสูตรวิทยาศาสตรบัณฑิต สาขาวิชาฟิสิกส์",
          "titleEN": "Bachelor of Science Program in Physics",
          "slang": "physics",
          "nameTH": "หลักสูตรวิทยาศาสตรบัณฑิต สาขาวิชาฟิสิกส์ (หลักสูตรปรับปรุง พ.ศ. 2565)",
          "nameEN": "Bachelor of Science Program in Physics",
          "nameDegreeTH": "วิทยาศาสตรบัณฑิต (ฟิสิกส์)\nวท.บ. (ฟิสิกส์)",
          "nameDegreeEN": "Bachelor of Science (Physics)\nB.Sc. (Physics)",
          "vision": "มุ่งผลิตบัณฑิตที่มีความรู้และทักษะของนักฟิสิกส์ในสายงานที่เหมาะสมกับตนเอง ตระหนักถึงหน้าที่และความรับผิดชอบของตนในสังคม และสนใจใฝ่รู้อย่างมีวิจารณญาณ",
          "mission": "1. ผลิตบัณฑิตฟิสิกส์ที่สามารถอธิบายและประยุกต์หลักการสำคัญทางฟิสิกส์ได้ \n|2. ผลิตบัณฑิตฟิสิกส์ที่สามารถประยุกต์ทักษะทางคณิตศาสตร์ ทักษะดิจิทัล และทักษะการเขียนโปรแกรมคอมพิวเตอร์เพื่อแก้ปัญหาได้\n|3. ผลิตบัณฑิตฟิสิกส์ที่มีทักษะการใช้เครื่องมือสำหรับการทดลองและวิเคราะห์ผลเพื่อทดสอบสมมติฐาน \n|4. ผลิตบัณฑิตฟิสิกส์ที่มีทักษะการใช้เทคโนโลยีสารสนเทศในการสืบค้นข้อมูลอย่างมีวิจารณญาณและสามารถถ่ายทอดองค์ความรู้ ออกแบบสื่อ และนำเสนอด้วยวิธีการหรือช่องทางสื่อสารต่าง ๆ ได้อย่างเหมาะสม\n|5. ผลิตบัณฑิตฟิสิกส์ที่มีความสามารถวางแผนเบื้องต้น เสนอแนวทางแก้ปัญหาโดยใช้วิธีการและความรู้วิทยาศาสตร์และดำเนินงานวิจัยได้\n|6. ผลิตบัณฑิตฟิสิกส์ที่ตระหนักถึงความรับผิดชอบต่อตนเอง องค์กร สังคมและสิ่งแวดล้อม มีระเบียบวินัย และมีทักษะการทำงานร่วมกับผู้อื่น\n|7. ผลิตบัณฑิตฟิสิกส์ที่มีความพร้อมต่อการทำงานทั้งทางด้านวิชาการ/ด้านการศึกษา/ด้านอุตสาหกรรมสมัยใหม่ที่มีความสำคัญต่อการพัฒนาประเทศ/มีทักษะความเป็นผู้ประกอบการด้านเทคโนโลยีตามความสนใจของแต่ละบุคคล",
          "course_structure": "http://reg4.sut.ac.th/registrar/program_info_1.asp?avs1024530932=7&acadyear=-1&levelid=1&programid=101050101650&facultyid=10100&programname=%BF%D4%CA%D4%A1%CA%EC%2D2565&facultyname=%CA%D3%B9%D1%A1%C7%D4%AA%D2%C7%D4%B7%C2%D2%C8%D2%CA%B5%C3%EC&levelname=%BB%C3%D4%AD%AD%D2%B5%C3%D5",
          "study_plan": "http://reg4.sut.ac.th/registrar/studyplan_info1.asp?avs700022880=21&acadyear=-1&levelid=1&programid=101050101650&facultyid=10100&programname=%BF%D4%CA%D4%A1%CA%EC%2D2565&facultyname=%CA%D3%B9%D1%A1%C7%D4%AA%D2%C7%D4%B7%C2%D2%C8%D2%CA%B5%C3%EC&levelname=%BB%C3%D4%AD%AD%D2%B5%C3%D5",
          "teacher": "https://beta.sut.ac.th/is-physics/คณาจารย์-บุคลากร/คณาจารย์",
          "graduation_goals": "https://beta.sut.ac.th/is-physics/คณาจารย์-บุคลากร/คณาจารย์",
          "graduation_results": "https://beta.sut.ac.th/is-physics/คณาจารย์-บุคลากร/คณาจารย์",
          "employment_goals": "รอข้อมูลจากสำนัก",
          "image": "__PUBLIC_URL__/service-sut/image/2_Institute/1_sci/04_phys/slide1.JPG,__PUBLIC_URL__/service-sut/image/2_Institute/1_sci/04_phys/slide2.JPG,__PUBLIC_URL__/service-sut/image/2_Institute/1_sci/04_phys/slide3.JPG",
          "footer": "__PUBLIC_URL__/service-sut/image/2_Institute/1_sci/04_phys/foot1.JPG,__PUBLIC_URL__/service-sut/image/2_Institute/1_sci/04_phys/foot2.JPG,__PUBLIC_URL__/service-sut/image/2_Institute/1_sci/04_phys/foot3.JPG",
          "createAt": null,
          "updateAt": null,
          "year": "2025"
        },
        "vision": {
          "vision_0": "มุ่งผลิตบัณฑิตที่มีความรู้และทักษะของนักฟิสิกส์ในสายงานที่เหมาะสมกับตนเอง ตระหนักถึงหน้าที่และความรับผิดชอบของตนในสังคม และสนใจใฝ่รู้อย่างมีวิจารณญาณ"
        },
        "mission": {
          "mission_0": "1. ผลิตบัณฑิตฟิสิกส์ที่สามารถอธิบายและประยุกต์หลักการสำคัญทางฟิสิกส์ได้ \n",
          "mission_1": "2. ผลิตบัณฑิตฟิสิกส์ที่สามารถประยุกต์ทักษะทางคณิตศาสตร์ ทักษะดิจิทัล และทักษะการเขียนโปรแกรมคอมพิวเตอร์เพื่อแก้ปัญหาได้\n",
          "mission_2": "3. ผลิตบัณฑิตฟิสิกส์ที่มีทักษะการใช้เครื่องมือสำหรับการทดลองและวิเคราะห์ผลเพื่อทดสอบสมมติฐาน \n",
          "mission_3": "4. ผลิตบัณฑิตฟิสิกส์ที่มีทักษะการใช้เทคโนโลยีสารสนเทศในการสืบค้นข้อมูลอย่างมีวิจารณญาณและสามารถถ่ายทอดองค์ความรู้ ออกแบบสื่อ และนำเสนอด้วยวิธีการหรือช่องทางสื่อสารต่าง ๆ ได้อย่างเหมาะสม\n",
          "mission_4": "5. ผลิตบัณฑิตฟิสิกส์ที่มีความสามารถวางแผนเบื้องต้น เสนอแนวทางแก้ปัญหาโดยใช้วิธีการและความรู้วิทยาศาสตร์และดำเนินงานวิจัยได้\n",
          "mission_5": "6. ผลิตบัณฑิตฟิสิกส์ที่ตระหนักถึงความรับผิดชอบต่อตนเอง องค์กร สังคมและสิ่งแวดล้อม มีระเบียบวินัย และมีทักษะการทำงานร่วมกับผู้อื่น\n",
          "mission_6": "7. ผลิตบัณฑิตฟิสิกส์ที่มีความพร้อมต่อการทำงานทั้งทางด้านวิชาการ/ด้านการศึกษา/ด้านอุตสาหกรรมสมัยใหม่ที่มีความสำคัญต่อการพัฒนาประเทศ/มีทักษะความเป็นผู้ประกอบการด้านเทคโนโลยีตามความสนใจของแต่ละบุคคล"
        },
        "image": {
          "image_0": "__PUBLIC_URL__/service-sut/image/2_Institute/1_sci/04_phys/slide1.JPG",
          "image_1": "__PUBLIC_URL__/service-sut/image/2_Institute/1_sci/04_phys/slide2.JPG",
          "image_2": "__PUBLIC_URL__/service-sut/image/2_Institute/1_sci/04_phys/slide3.JPG"
        },
        "footer": {
          "image_0": "__PUBLIC_URL__/service-sut/image/2_Institute/1_sci/04_phys/foot1.JPG",
          "image_1": "__PUBLIC_URL__/service-sut/image/2_Institute/1_sci/04_phys/foot2.JPG",
          "image_2": "__PUBLIC_URL__/service-sut/image/2_Institute/1_sci/04_phys/foot3.JPG"
        },
        "icon": [
          {
            "id": "1",
            "courseID": "1",
            "branchID": "3",
            "detail": "ชื่อหลักสูตร",
            "image": "__PUBLIC_URL__/service-sut/image/icon/school-sci-01.svg"
          },
          {
            "id": "2",
            "courseID": "1",
            "branchID": "3",
            "detail": "ชื่อปริญญาบัตรและสาขา",
            "image": "__PUBLIC_URL__/service-sut/image/icon/school-sci-02.svg"
          },
          {
            "id": "3",
            "courseID": "1",
            "branchID": "3",
            "detail": "โครงสร้างหลักสูตร",
            "image": "__PUBLIC_URL__/service-sut/image/icon/school-sci-03.svg"
          },
          {
            "id": "4",
            "courseID": "1",
            "branchID": "3",
            "detail": "แผนการศึกษา",
            "image": "__PUBLIC_URL__/service-sut/image/icon/school-sci-04.svg"
          },
          {
            "id": "5",
            "courseID": "1",
            "branchID": "3",
            "detail": "อาจารย์ประจำหลักสูตร",
            "image": "__PUBLIC_URL__/service-sut/image/icon/school-sci-05.svg"
          },
          {
            "id": "6",
            "courseID": "1",
            "branchID": "3",
            "detail": "เป้าหมายการรับและ การสำเร็จการศึกษา",
            "image": "__PUBLIC_URL__/service-sut/image/icon/school-sci-06.svg"
          },
          {
            "id": "7",
            "courseID": "1",
            "branchID": "3",
            "detail": "ผลการรับและ สำเร็จการศึกษา",
            "image": "__PUBLIC_URL__/service-sut/image/icon/school-sci-07.svg"
          },
          {
            "id": "8",
            "courseID": "1",
            "branchID": "3",
            "detail": "เป้าหมายการได้งานทำ ของบัณฑิต",
            "image": "__PUBLIC_URL__/service-sut/image/icon/school-sci-08.svg"
          }
        ],
        "header": {
          "header_0": "ชื่อปริญญาและสาขา",
          "header_1": "วิสัยทัศน์",
          "header_2": "พันธกิจ",
          "header_3": "โครงสร้างหลักสูตร",
          "header_4": "แผนการศึกษา",
          "header_5": "ผลการรับและสำเร็จการศึกษา",
          "header_6": "เป้าหมายการรับและการสำเร็จการศึกษา",
          "header_7": "ผลการรับและสำเร็จการศึกษา",
          "header_8": "เป้าหมายการได้งานทำของบัณฑิต"
        },
        "visitor": 498,
        "visitor_of_year": 69
      }
    },
    "sports-science": {
      "code": 200,
      "status": "Get data success",
      "data": {
        "information": {
          "id": "59",
          "courseID": "1",
          "titleTH": "หลักสูตรวิทยาศาสตรบัณฑิต สาขาวิชาวิทยาศาสตร์การกีฬา",
          "titleEN": "Bachelor of Science Program in Sports Science",
          "slang": "sports-science",
          "nameTH": "หลักสูตรวิทยาศาสตรบัณฑิต สาขาวิชาวิทยาศาสตร์การกีฬา (หลักสูตรปรับปรุง พ.ศ. 2565)",
          "nameEN": "Bachelor of Science Program in Sports Science",
          "nameDegreeTH": "วิทยาศาสตรบัณฑิต (วิทยาศาสตร์การกีฬา)\nวท.บ. (วิทยาศาสตร์การกีฬา)",
          "nameDegreeEN": "Bachelor of Science (Sports Science)\nB.Sc. (Sports Science)",
          "vision": "มุ่งผลิตบัณฑิตวิทยาศาสตร์การกีฬาที่มีความรู้ ความเชี่ยวชาญ เพื่อส่งเสริมสุขภาพและพัฒนาความเป็นเลิศทางการกีฬา",
          "mission": "1. เพื่อผลิตบัณฑิตที่มีความรู้ ความเชี่ยวชาญทางด้านวิทยาศาสตร์และเทคโนโลยีการกีฬาเพื่อส่งเสริมสุขภาพและสมรรถภาพทางกายให้กับประชาชนทั่วไป โดยมีความรู้ ความเชี่ยวชาญและได้รับใบรับรองมาตรฐานในการเป็นผู้ฝึกสอนส่วนบุคคล หรือ\n|2. เพื่อผลิตบัณฑิตที่มีความรู้ ความเชี่ยวชาญทางด้านวิทยาศาสตร์และเทคโนโลยีการกีฬาเพื่อพัฒนาด้านการกีฬาให้กับหน่วยงานต่างๆ เช่น สถานศึกษา สโมสรกีฬา โรงพยาบาล องค์การบริหารส่วนท้องถิ่น เป็นต้น โดยมีความรู้ ความเชี่ยวชาญและได้รับใบรับรองมาตรฐานในการเป็นผู้ฝึกสอนกีฬา\n|3. เพื่อผลิตบัณฑิตที่มีทัศนคติที่ดีต่อวิชาชีพวิทยาศาสตร์การกีฬา มีจริยธรรมคุณธรรม และจิตสาธารณะในการประกอบอาชีพ หรือศึกษาต่อในระดับที่สูงขึ้น",
          "course_structure": "http://reg4.sut.ac.th/registrar/program_info_1.asp?f_cmd=2&acadyear=-1&levelid=1&programid=101140101650&facultyid=10100&programname=%C7%D4%B7%C2%D2%C8%D2%CA%B5%C3%EC%A1%D2%C3%A1%D5%CC%D2%2D2565&facultyname=%CA%D3%B9%D1%A1%C7%D4%AA%D2%C7%D4%B7%C2%D2%C8%D2%CA%B5%C3%EC&levelname=%BB%C3%D4%AD%AD%D2%B5%C3%D5",
          "study_plan": "http://reg4.sut.ac.th/registrar/studyplan_info1.asp?avs923107103=22&acadyear=-1&levelid=1&programid=101140101650&facultyid=10100&programname=%C7%D4%B7%C2%D2%C8%D2%CA%B5%C3%EC%A1%D2%C3%A1%D5%CC%D2%2D2565&facultyname=%CA%D3%B9%D1%A1%C7%D4%AA%D2%C7%D4%B7%C2%D2%C8%D2%CA%B5%C3%EC&levelname=%BB%C3%D4%AD%AD%D2%B5%C3%D5",
          "teacher": "https://beta.sut.ac.th/is-sports/คณาจารย์-บุคลากร/คณาจารย์",
          "graduation_goals": "รอข้อมูลจากสำนัก",
          "graduation_results": "รอข้อมูลจากสำนัก",
          "employment_goals": "รอข้อมูลจากสำนัก",
          "image": "__PUBLIC_URL__/service-sut/image/2_Institute/1_sci/05_sport/slide1.jpg,__PUBLIC_URL__/service-sut/image/2_Institute/1_sci/05_sport/slide2.JPG,__PUBLIC_URL__/service-sut/image/2_Institute/1_sci/05_sport/slide3.JPG,__PUBLIC_URL__/service-sut/image/2_Institute/1_sci/05_sport/slide1.jpg",
          "footer": "__PUBLIC_URL__/service-sut/image/2_Institute/1_sci/05_sport/foot1.jpg,__PUBLIC_URL__/service-sut/image/2_Institute/1_sci/05_sport/foot2.JPG,__PUBLIC_URL__/service-sut/image/2_Institute/1_sci/05_sport/foot3.jpg",
          "createAt": null,
          "updateAt": null,
          "year": "2025"
        },
        "vision": {
          "vision_0": "มุ่งผลิตบัณฑิตวิทยาศาสตร์การกีฬาที่มีความรู้ ความเชี่ยวชาญ เพื่อส่งเสริมสุขภาพและพัฒนาความเป็นเลิศทางการกีฬา"
        },
        "mission": {
          "mission_0": "1. เพื่อผลิตบัณฑิตที่มีความรู้ ความเชี่ยวชาญทางด้านวิทยาศาสตร์และเทคโนโลยีการกีฬาเพื่อส่งเสริมสุขภาพและสมรรถภาพทางกายให้กับประชาชนทั่วไป โดยมีความรู้ ความเชี่ยวชาญและได้รับใบรับรองมาตรฐานในการเป็นผู้ฝึกสอนส่วนบุคคล หรือ\n",
          "mission_1": "2. เพื่อผลิตบัณฑิตที่มีความรู้ ความเชี่ยวชาญทางด้านวิทยาศาสตร์และเทคโนโลยีการกีฬาเพื่อพัฒนาด้านการกีฬาให้กับหน่วยงานต่างๆ เช่น สถานศึกษา สโมสรกีฬา โรงพยาบาล องค์การบริหารส่วนท้องถิ่น เป็นต้น โดยมีความรู้ ความเชี่ยวชาญและได้รับใบรับรองมาตรฐานในการเป็นผู้ฝึกสอนกีฬา\n",
          "mission_2": "3. เพื่อผลิตบัณฑิตที่มีทัศนคติที่ดีต่อวิชาชีพวิทยาศาสตร์การกีฬา มีจริยธรรมคุณธรรม และจิตสาธารณะในการประกอบอาชีพ หรือศึกษาต่อในระดับที่สูงขึ้น"
        },
        "image": {
          "image_0": "__PUBLIC_URL__/service-sut/image/2_Institute/1_sci/05_sport/slide1.jpg",
          "image_1": "__PUBLIC_URL__/service-sut/image/2_Institute/1_sci/05_sport/slide2.JPG",
          "image_2": "__PUBLIC_URL__/service-sut/image/2_Institute/1_sci/05_sport/slide3.JPG",
          "image_3": "__PUBLIC_URL__/service-sut/image/2_Institute/1_sci/05_sport/slide1.jpg"
        },
        "footer": {
          "image_0": "__PUBLIC_URL__/service-sut/image/2_Institute/1_sci/05_sport/foot1.jpg",
          "image_1": "__PUBLIC_URL__/service-sut/image/2_Institute/1_sci/05_sport/foot2.JPG",
          "image_2": "__PUBLIC_URL__/service-sut/image/2_Institute/1_sci/05_sport/foot3.jpg"
        },
        "icon": [
          {
            "id": "1",
            "courseID": "1",
            "branchID": "3",
            "detail": "ชื่อหลักสูตร",
            "image": "__PUBLIC_URL__/service-sut/image/icon/school-sci-01.svg"
          },
          {
            "id": "2",
            "courseID": "1",
            "branchID": "3",
            "detail": "ชื่อปริญญาบัตรและสาขา",
            "image": "__PUBLIC_URL__/service-sut/image/icon/school-sci-02.svg"
          },
          {
            "id": "3",
            "courseID": "1",
            "branchID": "3",
            "detail": "โครงสร้างหลักสูตร",
            "image": "__PUBLIC_URL__/service-sut/image/icon/school-sci-03.svg"
          },
          {
            "id": "4",
            "courseID": "1",
            "branchID": "3",
            "detail": "แผนการศึกษา",
            "image": "__PUBLIC_URL__/service-sut/image/icon/school-sci-04.svg"
          },
          {
            "id": "5",
            "courseID": "1",
            "branchID": "3",
            "detail": "อาจารย์ประจำหลักสูตร",
            "image": "__PUBLIC_URL__/service-sut/image/icon/school-sci-05.svg"
          },
          {
            "id": "6",
            "courseID": "1",
            "branchID": "3",
            "detail": "เป้าหมายการรับและ การสำเร็จการศึกษา",
            "image": "__PUBLIC_URL__/service-sut/image/icon/school-sci-06.svg"
          },
          {
            "id": "7",
            "courseID": "1",
            "branchID": "3",
            "detail": "ผลการรับและ สำเร็จการศึกษา",
            "image": "__PUBLIC_URL__/service-sut/image/icon/school-sci-07.svg"
          },
          {
            "id": "8",
            "courseID": "1",
            "branchID": "3",
            "detail": "เป้าหมายการได้งานทำ ของบัณฑิต",
            "image": "__PUBLIC_URL__/service-sut/image/icon/school-sci-08.svg"
          }
        ],
        "header": {
          "header_0": "ชื่อปริญญาและสาขา",
          "header_1": "วิสัยทัศน์",
          "header_2": "พันธกิจ",
          "header_3": "โครงสร้างหลักสูตร",
          "header_4": "แผนการศึกษา",
          "header_5": "ผลการรับและสำเร็จการศึกษา",
          "header_6": "เป้าหมายการรับและการสำเร็จการศึกษา",
          "header_7": "ผลการรับและสำเร็จการศึกษา",
          "header_8": "เป้าหมายการได้งานทำของบัณฑิต"
        },
        "visitor": 397,
        "visitor_of_year": 79
      }
    },
    "geographical-informatics": {
      "code": 200,
      "status": "Get data success",
      "data": {
        "information": {
          "id": "60",
          "courseID": "1",
          "titleTH": "หลักสูตรสาขาวิชาวิทยาการข้อมูลและภูมิสารสนเทศประยุกต์",
          "titleEN": "Bachelor of Science Program in Data Science and Applied Geoinformatics",
          "slang": "geographical-informatics",
          "nameTH": "หลักสูตรวิทยาศาสตรบัณฑิตสาขาวิชาวิทยาการข้อมูลและภูมิสารสนเทศประยุกต์",
          "nameEN": "Bachelor of Science Program in Data Science and Applied Geoinformatics",
          "nameDegreeTH": "วิทยาศาสตรบัณฑิต (วิทยาการข้อมูลและภูมิสารสนเทศประยุกต์) \nวท.บ.(วิทยาการข้อมูลและภูมิสารสนเทศประยุกต์",
          "nameDegreeEN": "Bachelor of Science (Data Science and Applied Geoinformatics) \nB.Sc. (Data Science and Applied Geoinformatics)",
          "vision": "การศึกษาทางวิทยาการข้อมูลและภูมิสารสนเทศที่ทันสมัย มีคุณภาพและได้มาตรฐาน เป็นที่ยอมรับในระดับชาติ",
          "mission": "1. ด้านความรู้ความเข้าใจ ในศาสตร์ทางวิทยาการข้อมูลและภูมิสารสนเทศประยุกต์ที่ก้าวหน้า ทันสมัย\n|2.ด้านทักษะที่สำคัญสำหรับการศึกษาและปฏิบัติงานทางวิทยาการข้อมูลและภูมิสารสนเทศประยุกต์อย่างมีประสิทธิภาพ\n|3.ด้านการบูรณาการวิทยาการข้อมูลและภูมิสารสนเทศประยุกต์ ในการศึกษาและปฏิบัติงานของตนให้บรรลุผลได้อย่างมีประสิทธิภาพ\n|4.ด้านศักยภาพในการเรียนรู้และพัฒนาตนเองทั้งในเชิงวิชาการ วิชาชีพ และคุณลักษณะส่วนบุคคล อย่างเป็นระบบและต่อเนื่อง\n|5.ด้านความรู้ความสามารถที่พึงประสงค์สำหรับบัณฑิตในศตวรรษที่ 21 และบัณฑิตตามอัตลักษณ์ของมหาวิทยาลัยเทคโนโลยีสุรนารี",
          "course_structure": "https://reg3.sut.ac.th/registrar/program_info_1.asp?avs500389058=7&acadyear=-1&levelid=1&programid=101060401680&facultyid=10100&programname=%C7%D4%B7%C2%D2%A1%D2%C3%A2%E9%CD%C1%D9%C5%E1%C5%D0%C0%D9%C1%D4%CA%D2%C3%CA%B9%E0%B7%C8%BB%C3%D0%C2%D8%A1%B5%EC%2D2568&facultyname=%CA%D3%B9%D1%A1%C7%D4%AA%D2%C7%D4%B7%C2%D2%C8%D2%CA%B5%C3%EC&levelname=%BB%C3%D4%AD%AD%D2%B5%C3%D5",
          "study_plan": "https://reg3.sut.ac.th/registrar/studyplan_info1.asp?avs500389058=9&acadyear=-1&levelid=1&programid=101060401680&facultyid=10100&programname=%C7%D4%B7%C2%D2%A1%D2%C3%A2%E9%CD%C1%D9%C5%E1%C5%D0%C0%D9%C1%D4%CA%D2%C3%CA%B9%E0%B7%C8%BB%C3%D0%C2%D8%A1%B5%EC%2D2568&facultyname=%CA%D3%B9%D1%A1%C7%D4%AA%D2%C7%D4%B7%C2%D2%C8%D2%CA%B5%C3%EC&levelname=%BB%C3%D4%AD%AD%D2%B5%C3%D5",
          "teacher": "https://beta.sut.ac.th/is-geoinformatics/%E0%B8%84%E0%B8%93%E0%B8%B2%E0%B8%88%E0%B8%B2%E0%B8%A3%E0%B8%A2%E0%B9%8C-%E0%B8%9A%E0%B8%B8%E0%B8%84%E0%B8%A5%E0%B8%B2%E0%B8%81%E0%B8%A3/%E0%B8%84%E0%B8%93%E0%B8%B2%E0%B8%88%E0%B8%B2%E0%B8%A3%E0%B8%A2%E0%B9%8C",
          "graduation_goals": "รอข้อมูลจากสำนัก",
          "graduation_results": "รอข้อมูลจากสำนัก",
          "employment_goals": "รอข้อมูลจากสำนัก",
          "image": "__PUBLIC_URL__/service-sut/image/2_Institute/1_sci/06_geo/slide1.jpg",
          "footer": "__PUBLIC_URL__/service-sut/image/2_Institute/1_sci/06_geo/foot1.jpg,__PUBLIC_URL__/service-sut/image/2_Institute/1_sci/06_geo/foot2.jpg,__PUBLIC_URL__/service-sut/image/2_Institute/1_sci/06_geo/foot3.jpg",
          "createAt": null,
          "updateAt": null,
          "year": "2025"
        },
        "vision": {
          "vision_0": "การศึกษาทางวิทยาการข้อมูลและภูมิสารสนเทศที่ทันสมัย มีคุณภาพและได้มาตรฐาน เป็นที่ยอมรับในระดับชาติ"
        },
        "mission": {
          "mission_0": "1. ด้านความรู้ความเข้าใจ ในศาสตร์ทางวิทยาการข้อมูลและภูมิสารสนเทศประยุกต์ที่ก้าวหน้า ทันสมัย\n",
          "mission_1": "2.ด้านทักษะที่สำคัญสำหรับการศึกษาและปฏิบัติงานทางวิทยาการข้อมูลและภูมิสารสนเทศประยุกต์อย่างมีประสิทธิภาพ\n",
          "mission_2": "3.ด้านการบูรณาการวิทยาการข้อมูลและภูมิสารสนเทศประยุกต์ ในการศึกษาและปฏิบัติงานของตนให้บรรลุผลได้อย่างมีประสิทธิภาพ\n",
          "mission_3": "4.ด้านศักยภาพในการเรียนรู้และพัฒนาตนเองทั้งในเชิงวิชาการ วิชาชีพ และคุณลักษณะส่วนบุคคล อย่างเป็นระบบและต่อเนื่อง\n",
          "mission_4": "5.ด้านความรู้ความสามารถที่พึงประสงค์สำหรับบัณฑิตในศตวรรษที่ 21 และบัณฑิตตามอัตลักษณ์ของมหาวิทยาลัยเทคโนโลยีสุรนารี"
        },
        "image": {
          "image_0": "__PUBLIC_URL__/service-sut/image/2_Institute/1_sci/06_geo/slide1.jpg"
        },
        "footer": {
          "image_0": "__PUBLIC_URL__/service-sut/image/2_Institute/1_sci/06_geo/foot1.jpg",
          "image_1": "__PUBLIC_URL__/service-sut/image/2_Institute/1_sci/06_geo/foot2.jpg",
          "image_2": "__PUBLIC_URL__/service-sut/image/2_Institute/1_sci/06_geo/foot3.jpg"
        },
        "icon": [
          {
            "id": "1",
            "courseID": "1",
            "branchID": "3",
            "detail": "ชื่อหลักสูตร",
            "image": "__PUBLIC_URL__/service-sut/image/icon/school-sci-01.svg"
          },
          {
            "id": "2",
            "courseID": "1",
            "branchID": "3",
            "detail": "ชื่อปริญญาบัตรและสาขา",
            "image": "__PUBLIC_URL__/service-sut/image/icon/school-sci-02.svg"
          },
          {
            "id": "3",
            "courseID": "1",
            "branchID": "3",
            "detail": "โครงสร้างหลักสูตร",
            "image": "__PUBLIC_URL__/service-sut/image/icon/school-sci-03.svg"
          },
          {
            "id": "4",
            "courseID": "1",
            "branchID": "3",
            "detail": "แผนการศึกษา",
            "image": "__PUBLIC_URL__/service-sut/image/icon/school-sci-04.svg"
          },
          {
            "id": "5",
            "courseID": "1",
            "branchID": "3",
            "detail": "อาจารย์ประจำหลักสูตร",
            "image": "__PUBLIC_URL__/service-sut/image/icon/school-sci-05.svg"
          },
          {
            "id": "6",
            "courseID": "1",
            "branchID": "3",
            "detail": "เป้าหมายการรับและ การสำเร็จการศึกษา",
            "image": "__PUBLIC_URL__/service-sut/image/icon/school-sci-06.svg"
          },
          {
            "id": "7",
            "courseID": "1",
            "branchID": "3",
            "detail": "ผลการรับและ สำเร็จการศึกษา",
            "image": "__PUBLIC_URL__/service-sut/image/icon/school-sci-07.svg"
          },
          {
            "id": "8",
            "courseID": "1",
            "branchID": "3",
            "detail": "เป้าหมายการได้งานทำ ของบัณฑิต",
            "image": "__PUBLIC_URL__/service-sut/image/icon/school-sci-08.svg"
          }
        ],
        "header": {
          "header_0": "ชื่อปริญญาและสาขา",
          "header_1": "วิสัยทัศน์",
          "header_2": "พันธกิจ",
          "header_3": "โครงสร้างหลักสูตร",
          "header_4": "แผนการศึกษา",
          "header_5": "ผลการรับและสำเร็จการศึกษา",
          "header_6": "เป้าหมายการรับและการสำเร็จการศึกษา",
          "header_7": "ผลการรับและสำเร็จการศึกษา",
          "header_8": "เป้าหมายการได้งานทำของบัณฑิต"
        },
        "visitor": 560,
        "visitor_of_year": 116
      }
    },
    "management-tectnology": {
      "code": 200,
      "status": "Get data success",
      "data": {
        "information": {
          "id": "61",
          "courseID": "2",
          "titleTH": "หลักสูตรการจัดการบัณฑิต",
          "titleEN": "Bachelor of Management",
          "slang": "management-tectnology",
          "nameTH": "หลักสูตรการจัดการบัณฑิต",
          "nameEN": "Bachelor of Management Program",
          "nameDegreeTH": "การจัดการบัณฑิต",
          "nameDegreeEN": "Bachelor of Management",
          "vision": "สำนักวิชาเทคโนโลยีสังคม มุ่งยกระดับการเรียนรู้การวิจัย ด้านเทคโนโลยีสังคมสู่การเรียนรู้ตลอดชีวิต",
          "mission": "การผลิตบัณฑิต วิจัย บริการวิชาการ ทำนุบำรุงศิลปะและวัฒนธรรม ปรับแปลง ถ่ายทอดและพัฒนาเทคโนโลยี",
          "course_structure": "https://reg3.sut.ac.th/registrar/program_info_1.asp?f_cmd=2&acadyear=2568&levelid=1&programid=102050001680&facultyid=10200&programname=%A1%D2%C3%A8%D1%B4%A1%D2%C3%BA%D1%B3%B1%D4%B5%2D2568&facultyname=%CA%D3%B9%D1%A1%C7%D4%AA%D2%E0%B7%A4%E2%B9%E2%C5%C2%D5%CA%D1%A7%A4%C1&levelname=%BB%C3%D4%AD%AD%D2%B5%C3%D5",
          "study_plan": "https://reg3.sut.ac.th/registrar/studyplan_info1.asp?avs264720134=11&acadyear=2568&levelid=1&programid=102050001680&facultyid=10200&programname=%A1%D2%C3%A8%D1%B4%A1%D2%C3%BA%D1%B3%B1%D4%B5%2D2568&facultyname=%CA%D3%B9%D1%A1%C7%D4%AA%D2%E0%B7%A4%E2%B9%E2%C5%C2%D5%CA%D1%A7%A4%C1&levelname=%BB%C3%D4%AD%AD%D2%B5%C3%D5",
          "teacher": "http://mt.sut.ac.th/staff/Index",
          "graduation_goals": "รอข้อมูลจากสำนัก",
          "graduation_results": "รอข้อมูลจากสำนัก",
          "employment_goals": "รอข้อมูลจากสำนัก",
          "image": "__PUBLIC_URL__/service-sut/image/2_Institute/2_soct/01_mang/slide1.jpg,__PUBLIC_URL__/service-sut/image/2_Institute/2_soct/01_mang/slide2.jpg,__PUBLIC_URL__/service-sut/image/2_Institute/2_soct/01_mang/slide3.jpg",
          "footer": "__PUBLIC_URL__/service-sut/image/2_Institute/2_soct/01_mang/foot1.jpg,__PUBLIC_URL__/service-sut/image/2_Institute/2_soct/01_mang/foot2.jpg,__PUBLIC_URL__/service-sut/image/2_Institute/2_soct/01_mang/foot3.jpg",
          "createAt": null,
          "updateAt": null,
          "year": "2025"
        },
        "vision": {
          "vision_0": "สำนักวิชาเทคโนโลยีสังคม มุ่งยกระดับการเรียนรู้การวิจัย ด้านเทคโนโลยีสังคมสู่การเรียนรู้ตลอดชีวิต"
        },
        "mission": {
          "mission_0": "การผลิตบัณฑิต วิจัย บริการวิชาการ ทำนุบำรุงศิลปะและวัฒนธรรม ปรับแปลง ถ่ายทอดและพัฒนาเทคโนโลยี"
        },
        "image": {
          "image_0": "__PUBLIC_URL__/service-sut/image/2_Institute/2_soct/01_mang/slide1.jpg",
          "image_1": "__PUBLIC_URL__/service-sut/image/2_Institute/2_soct/01_mang/slide2.jpg",
          "image_2": "__PUBLIC_URL__/service-sut/image/2_Institute/2_soct/01_mang/slide3.jpg"
        },
        "footer": {
          "image_0": "__PUBLIC_URL__/service-sut/image/2_Institute/2_soct/01_mang/foot1.jpg",
          "image_1": "__PUBLIC_URL__/service-sut/image/2_Institute/2_soct/01_mang/foot2.jpg",
          "image_2": "__PUBLIC_URL__/service-sut/image/2_Institute/2_soct/01_mang/foot3.jpg"
        },
        "icon": [
          {
            "id": "10",
            "courseID": "2",
            "branchID": "0",
            "detail": "ชื่อหลักสูตร",
            "image": "__PUBLIC_URL__/service-sut/image/icon/school-soct-01.svg"
          },
          {
            "id": "11",
            "courseID": "2",
            "branchID": "0",
            "detail": "ชื่อปริญญาบัตรและสาขา",
            "image": "__PUBLIC_URL__/service-sut/image/icon/school-soct-02.svg"
          },
          {
            "id": "12",
            "courseID": "2",
            "branchID": "0",
            "detail": "โครงสร้างหลักสูตร",
            "image": "__PUBLIC_URL__/service-sut/image/icon/school-soct-03.svg"
          },
          {
            "id": "13",
            "courseID": "2",
            "branchID": "0",
            "detail": "แผนการศึกษา",
            "image": "__PUBLIC_URL__/service-sut/image/icon/school-soct-04.svg"
          },
          {
            "id": "14",
            "courseID": "2",
            "branchID": "0",
            "detail": "อาจารย์ประจำหลักสูตร",
            "image": "__PUBLIC_URL__/service-sut/image/icon/school-soct-05.svg"
          },
          {
            "id": "15",
            "courseID": "2",
            "branchID": "0",
            "detail": "เป้าหมายการรับและ การสำเร็จการศึกษา",
            "image": "__PUBLIC_URL__/service-sut/image/icon/school-soct-06.svg"
          },
          {
            "id": "16",
            "courseID": "2",
            "branchID": "0",
            "detail": "ผลการรับและ สำเร็จการศึกษา",
            "image": "__PUBLIC_URL__/service-sut/image/icon/school-soct-07.svg"
          },
          {
            "id": "17",
            "courseID": "2",
            "branchID": "0",
            "detail": "เป้าหมายการได้งานทำ ของบัณฑิต",
            "image": "__PUBLIC_URL__/service-sut/image/icon/school-soct-08.svg"
          }
        ],
        "header": {
          "header_0": "ชื่อปริญญาและสาขา",
          "header_1": "วิสัยทัศน์",
          "header_2": "พันธกิจ",
          "header_3": "โครงสร้างหลักสูตร",
          "header_4": "แผนการศึกษา",
          "header_5": "ผลการรับและสำเร็จการศึกษา",
          "header_6": "เป้าหมายการรับและการสำเร็จการศึกษา",
          "header_7": "ผลการรับและสำเร็จการศึกษา",
          "header_8": "เป้าหมายการได้งานทำของบัณฑิต"
        },
        "visitor": 865,
        "visitor_of_year": 119
      }
    },
    "management-tectnology-innovation": {
      "code": 200,
      "status": "Get data success",
      "data": {
        "information": {
          "id": "62",
          "courseID": "2",
          "titleTH": "หลักสูตรการจัดการบัณฑิต สาขาวิชานวัตกรรมเทคโนโลยีอุตสาหกรรมบริการ",
          "titleEN": "Bachelor of Management Program in Hospitality Technology Innovation",
          "slang": "management-tectnology-innovation",
          "nameTH": "หลักสูตรการจัดการบัณฑิต สาขาวิชานวัตกรรมเทคโนโลยีอุตสาหกรรมบริการ",
          "nameEN": "Bachelor of Management Program in Hospitality Technology Innovation",
          "nameDegreeTH": "การจัดการบัณฑิต (นวัตกรรมเทคโนโลยีอุตสาหกรรมบริการ)",
          "nameDegreeEN": "Bachelor of Management (Hospitality Technology Innovation)",
          "vision": "สำนักวิชาเทคโนโลยีสังคม มุ่งยกระดับการเรียนรู้การวิจัย ด้านเทคโนโลยีสังคมสู่การเรียนรู้ตลอดชีวิต",
          "mission": "การผลิตบัณฑิต วิจัย บริการวิชาการ ทำนุบำรุงศิลปะและวัฒนธรรม ปรับแปลง ถ่ายทอดและพัฒนาเทคโนโลยี",
          "course_structure": "https://reg5.sut.ac.th/registrar/program_info_1.asp?avs288807406=5&acadyear=-1&levelid=1&programid=102080101660&facultyid=10200&programname=%A1%D2%C3%A8%D1%B4%A1%D2%C3%BA%D1%B3%B1%D4%B5+%B9%C7%D1%B5%A1%C3%C3%C1%E0%B7%A4%E2%B9%E2%C5%C2%D5%CD%D8%B5%CA%D2%CB%A1%C3%C3%C1%BA%C3%D4%A1%D2%C3%2D2566&facultyname=%CA%D3%B9%D1%A1%C7%D4%AA%D2%E0%B7%A4%E2%B9%E2%C5%C2%D5%CA%D1%A7%A4%C1&levelname=%BB%C3%D4%AD%AD%D2%B5%C3%D5",
          "study_plan": "https://reg5.sut.ac.th/registrar/studyplan_info1.asp?avs288807406=7&acadyear=-1&levelid=1&programid=102080101660&facultyid=10200&programname=%A1%D2%C3%A8%D1%B4%A1%D2%C3%BA%D1%B3%B1%D4%B5+%B9%C7%D1%B5%A1%C3%C3%C1%E0%B7%A4%E2%B9%E2%C5%C2%D5%CD%D8%B5%CA%D2%CB%A1%C3%C3%C1%BA%C3%D4%A1%D2%C3%2D2566&facultyname=%CA%D3%B9%D1%A1%C7%D4%AA%D2%E0%B7%A4%E2%B9%E2%C5%C2%D5%CA%D1%A7%A4%C1&levelname=%BB%C3%D4%AD%AD%D2%B5%C3%D5",
          "teacher": "https://beta.sut.ac.th/ist-mt/ist-bhti",
          "graduation_goals": "รอข้อมูลจากสำนัก",
          "graduation_results": "รอข้อมูลจากสำนัก",
          "employment_goals": "รอข้อมูลจากสำนัก",
          "image": "__PUBLIC_URL__/service-sut/image/2_Institute/2_soct/03_hosp/slide1.jpg",
          "footer": "__PUBLIC_URL__/service-sut/image/2_Institute/2_soct/03_hosp/foot1.jpg,__PUBLIC_URL__/service-sut/image/2_Institute/2_soct/03_hosp/foot2.jpg,__PUBLIC_URL__/service-sut/image/2_Institute/2_soct/03_hosp/foot3.jpg",
          "createAt": null,
          "updateAt": null,
          "year": "2025"
        },
        "vision": {
          "vision_0": "สำนักวิชาเทคโนโลยีสังคม มุ่งยกระดับการเรียนรู้การวิจัย ด้านเทคโนโลยีสังคมสู่การเรียนรู้ตลอดชีวิต"
        },
        "mission": {
          "mission_0": "การผลิตบัณฑิต วิจัย บริการวิชาการ ทำนุบำรุงศิลปะและวัฒนธรรม ปรับแปลง ถ่ายทอดและพัฒนาเทคโนโลยี"
        },
        "image": {
          "image_0": "__PUBLIC_URL__/service-sut/image/2_Institute/2_soct/03_hosp/slide1.jpg"
        },
        "footer": {
          "image_0": "__PUBLIC_URL__/service-sut/image/2_Institute/2_soct/03_hosp/foot1.jpg",
          "image_1": "__PUBLIC_URL__/service-sut/image/2_Institute/2_soct/03_hosp/foot2.jpg",
          "image_2": "__PUBLIC_URL__/service-sut/image/2_Institute/2_soct/03_hosp/foot3.jpg"
        },
        "icon": [
          {
            "id": "10",
            "courseID": "2",
            "branchID": "0",
            "detail": "ชื่อหลักสูตร",
            "image": "__PUBLIC_URL__/service-sut/image/icon/school-soct-01.svg"
          },
          {
            "id": "11",
            "courseID": "2",
            "branchID": "0",
            "detail": "ชื่อปริญญาบัตรและสาขา",
            "image": "__PUBLIC_URL__/service-sut/image/icon/school-soct-02.svg"
          },
          {
            "id": "12",
            "courseID": "2",
            "branchID": "0",
            "detail": "โครงสร้างหลักสูตร",
            "image": "__PUBLIC_URL__/service-sut/image/icon/school-soct-03.svg"
          },
          {
            "id": "13",
            "courseID": "2",
            "branchID": "0",
            "detail": "แผนการศึกษา",
            "image": "__PUBLIC_URL__/service-sut/image/icon/school-soct-04.svg"
          },
          {
            "id": "14",
            "courseID": "2",
            "branchID": "0",
            "detail": "อาจารย์ประจำหลักสูตร",
            "image": "__PUBLIC_URL__/service-sut/image/icon/school-soct-05.svg"
          },
          {
            "id": "15",
            "courseID": "2",
            "branchID": "0",
            "detail": "เป้าหมายการรับและ การสำเร็จการศึกษา",
            "image": "__PUBLIC_URL__/service-sut/image/icon/school-soct-06.svg"
          },
          {
            "id": "16",
            "courseID": "2",
            "branchID": "0",
            "detail": "ผลการรับและ สำเร็จการศึกษา",
            "image": "__PUBLIC_URL__/service-sut/image/icon/school-soct-07.svg"
          },
          {
            "id": "17",
            "courseID": "2",
            "branchID": "0",
            "detail": "เป้าหมายการได้งานทำ ของบัณฑิต",
            "image": "__PUBLIC_URL__/service-sut/image/icon/school-soct-08.svg"
          }
        ],
        "header": {
          "header_0": "ชื่อปริญญาและสาขา",
          "header_1": "วิสัยทัศน์",
          "header_2": "พันธกิจ",
          "header_3": "โครงสร้างหลักสูตร",
          "header_4": "แผนการศึกษา",
          "header_5": "ผลการรับและสำเร็จการศึกษา",
          "header_6": "เป้าหมายการรับและการสำเร็จการศึกษา",
          "header_7": "ผลการรับและสำเร็จการศึกษา",
          "header_8": "เป้าหมายการได้งานทำของบัณฑิต"
        },
        "visitor": 1955,
        "visitor_of_year": 290
      }
    },
    "crop-production-technology": {
      "code": 200,
      "status": "Get data success",
      "data": {
        "information": {
          "id": "63",
          "courseID": "3",
          "titleTH": "สาขาวิชาเทคโนโลยีการผลิตพืช",
          "titleEN": "Crop Production Technology",
          "slang": "crop-production-technology",
          "nameTH": "หลักสูตรวิทยาศาสตรบัณฑิต สาขาวิชาเทคโนโลยีการผลิตพืช",
          "nameEN": "Bachelor of Science Program in Crop Production Technology",
          "nameDegreeTH": "วิทยาศาสตรบัณฑิต (เทคโนโลยีการผลิตพืช)",
          "nameDegreeEN": "Bachelor of Science (Crop Production Technology)",
          "vision": "สำนักวิชาเทคโนโลยีการเกษตรเป็นองค์กรแห่งการเรียนรู้  ที่มุ่งผลิตบัณฑิตทางด้านวิทยาศาสตร์และเทคโนโลยีการเกษตร ให้มีภูมิรู้  ภูมิธรรม  และภูมิปัญญา เพื่อการพัฒนาที่ยั่งยืน",
          "mission": "1) ผลิตและพัฒนากำลังคนทางด้านวิทยาศาสตร์ เทคโนโลยี และนวัตกรรม เพื่อตอบสนองต่อความต้องการ ในการพัฒนาประเทศ\n|2) วิจัยและค้นคว้า เพื่อสร้างสรรค์ความก้าวหน้าทางวิชาการ และการนำผลการวิจัยและพัฒนา ไปใช้ในการพัฒนาประเทศ\n|3) ให้บริการทางวิชาการแก่ประชาชนและหน่วยงานต่าง ๆ ทั้งภาครัฐและภาคเอกชน\n|4) ทะนุบำรุงศิลปะและวัฒนธรรมของชาติและของท้องถิ่นโดยเฉพาะอย่างยิ่งศิลปะและวัฒนธรรมของภาคตะวันออกเฉียงเหนือ\n|5) ปรับแปลงถ่ายทอดและพัฒนาเทคโนโลยีด้านการเกษตรเพื่อให้ประเทศไทยพึ่งพาตนเองทางเทคโนโลยีเพื่อการพัฒนาได้มากขึ้น",
          "course_structure": "https://iat.sut.ac.th/curriculum/croptech-bsc/",
          "study_plan": "https://iat.sut.ac.th/curriculum/croptech-bsc/",
          "teacher": "https://iat.sut.ac.th/academic-staff/",
          "graduation_goals": "รอข้อมูลจากสำนัก",
          "graduation_results": "รอข้อมูลจากสำนัก",
          "employment_goals": "รอข้อมูลจากสำนัก",
          "image": "__PUBLIC_URL__/service-sut/image/2_Institute/3_agri/01_crop/slide1.jpg,__PUBLIC_URL__/service-sut/image/2_Institute/3_agri/01_crop/slide2.jpg,__PUBLIC_URL__/service-sut/image/2_Institute/3_agri/01_crop/slide3.jpg",
          "footer": "__PUBLIC_URL__/service-sut/image/2_Institute/3_agri/01_crop/foot1.jpg,__PUBLIC_URL__/service-sut/image/2_Institute/3_agri/01_crop/foot2.jpg,__PUBLIC_URL__/service-sut/image/2_Institute/3_agri/01_crop/foot3.jpg",
          "createAt": null,
          "updateAt": null,
          "year": "2025"
        },
        "vision": {
          "vision_0": "สำนักวิชาเทคโนโลยีการเกษตรเป็นองค์กรแห่งการเรียนรู้  ที่มุ่งผลิตบัณฑิตทางด้านวิทยาศาสตร์และเทคโนโลยีการเกษตร ให้มีภูมิรู้  ภูมิธรรม  และภูมิปัญญา เพื่อการพัฒนาที่ยั่งยืน"
        },
        "mission": {
          "mission_0": "1) ผลิตและพัฒนากำลังคนทางด้านวิทยาศาสตร์ เทคโนโลยี และนวัตกรรม เพื่อตอบสนองต่อความต้องการ ในการพัฒนาประเทศ\n",
          "mission_1": "2) วิจัยและค้นคว้า เพื่อสร้างสรรค์ความก้าวหน้าทางวิชาการ และการนำผลการวิจัยและพัฒนา ไปใช้ในการพัฒนาประเทศ\n",
          "mission_2": "3) ให้บริการทางวิชาการแก่ประชาชนและหน่วยงานต่าง ๆ ทั้งภาครัฐและภาคเอกชน\n",
          "mission_3": "4) ทะนุบำรุงศิลปะและวัฒนธรรมของชาติและของท้องถิ่นโดยเฉพาะอย่างยิ่งศิลปะและวัฒนธรรมของภาคตะวันออกเฉียงเหนือ\n",
          "mission_4": "5) ปรับแปลงถ่ายทอดและพัฒนาเทคโนโลยีด้านการเกษตรเพื่อให้ประเทศไทยพึ่งพาตนเองทางเทคโนโลยีเพื่อการพัฒนาได้มากขึ้น"
        },
        "image": {
          "image_0": "__PUBLIC_URL__/service-sut/image/2_Institute/3_agri/01_crop/slide1.jpg",
          "image_1": "__PUBLIC_URL__/service-sut/image/2_Institute/3_agri/01_crop/slide2.jpg",
          "image_2": "__PUBLIC_URL__/service-sut/image/2_Institute/3_agri/01_crop/slide3.jpg"
        },
        "footer": {
          "image_0": "__PUBLIC_URL__/service-sut/image/2_Institute/3_agri/01_crop/foot1.jpg",
          "image_1": "__PUBLIC_URL__/service-sut/image/2_Institute/3_agri/01_crop/foot2.jpg",
          "image_2": "__PUBLIC_URL__/service-sut/image/2_Institute/3_agri/01_crop/foot3.jpg"
        },
        "icon": [
          {
            "id": "18",
            "courseID": "3",
            "branchID": "0",
            "detail": "ชื่อหลักสูตร",
            "image": "__PUBLIC_URL__/service-sut/image/icon/school-agri-01.svg"
          },
          {
            "id": "19",
            "courseID": "3",
            "branchID": "0",
            "detail": "ชื่อปริญญาบัตรและสาขา",
            "image": "__PUBLIC_URL__/service-sut/image/icon/school-agri-02.svg"
          },
          {
            "id": "20",
            "courseID": "3",
            "branchID": "0",
            "detail": "โครงสร้างหลักสูตร",
            "image": "__PUBLIC_URL__/service-sut/image/icon/school-agri-03.svg"
          },
          {
            "id": "21",
            "courseID": "3",
            "branchID": "0",
            "detail": "แผนการศึกษา",
            "image": "__PUBLIC_URL__/service-sut/image/icon/school-agri-04.svg"
          },
          {
            "id": "22",
            "courseID": "3",
            "branchID": "0",
            "detail": "อาจารย์ประจำหลักสูตร",
            "image": "__PUBLIC_URL__/service-sut/image/icon/school-agri-05.svg"
          },
          {
            "id": "23",
            "courseID": "3",
            "branchID": "0",
            "detail": "เป้าหมายการรับและ การสำเร็จการศึกษา",
            "image": "__PUBLIC_URL__/service-sut/image/icon/school-agri-06.svg"
          },
          {
            "id": "24",
            "courseID": "3",
            "branchID": "0",
            "detail": "ผลการรับและ สำเร็จการศึกษา",
            "image": "__PUBLIC_URL__/service-sut/image/icon/school-agri-07.svg"
          },
          {
            "id": "25",
            "courseID": "3",
            "branchID": "0",
            "detail": "เป้าหมายการได้งานทำ ของบัณฑิต",
            "image": "__PUBLIC_URL__/service-sut/image/icon/school-agri-08.svg"
          }
        ],
        "header": {
          "header_0": "ชื่อปริญญาและสาขา",
          "header_1": "วิสัยทัศน์",
          "header_2": "พันธกิจ",
          "header_3": "โครงสร้างหลักสูตร",
          "header_4": "แผนการศึกษา",
          "header_5": "ผลการรับและสำเร็จการศึกษา",
          "header_6": "เป้าหมายการรับและการสำเร็จการศึกษา",
          "header_7": "ผลการรับและสำเร็จการศึกษา",
          "header_8": "เป้าหมายการได้งานทำของบัณฑิต"
        },
        "visitor": 133,
        "visitor_of_year": 36
      }
    },
    "animal-technology-and-innovation": {
      "code": 200,
      "status": "Get data success",
      "data": {
        "information": {
          "id": "64",
          "courseID": "3",
          "titleTH": "สาขาวิชาเทคโนโลยีและนวัตกรรมทางสัตว์",
          "titleEN": "Animal Technology and Innovation",
          "slang": "animal-technology-and-innovation",
          "nameTH": "หลักสูตรวิทยาศาสตรบัณฑิต สาขาวิชาเทคโนโลยีและนวัตกรรมทางสัตว์",
          "nameEN": "Bachelor of Science Program in Animal Technology and Innovation",
          "nameDegreeTH": "วิทยาศาสตรบัณฑิต (เทคโนโลยีและนวัตกรรมทางสัตว์)",
          "nameDegreeEN": "Bachelor of Science (Animal Technology and Innovation)",
          "vision": "สำนักวิชาเทคโนโลยีการเกษตร เป็นองค์กรชั้นนำที่สุ่งสู่ความเป็นเลิศด้านการเกษตรบูรณาการ โดยการใช้วิทยาศาสตร์ เทคโนโลยี และนวัตกรรม เป็นฐานในการพัฒนาเศรษฐกิจ ให้สอดคล้องกับการพัฒนายุทธศาสตร์ของประเทศไทยอย่างยั่งยืน",
          "mission": "1) ผลิตและพัฒนากำลังคนทางด้านวิทยาศาสตร์ เทคโนโลยี และนวัตกรรม เพื่อตอบสนองต่อความต้องการ ในการพัฒนาประเทศ\n|2) วิจัยและค้นคว้า เพื่อสร้างสรรค์ความก้าวหน้าทางวิชาการ และการนำผลการวิจัยและพัฒนา ไปใช้ในการพัฒนาประเทศ\n|3) ให้บริการทางวิชาการแก่ประชาชนและหน่วยงานต่าง ๆ ทั้งภาครัฐและภาคเอกชน\n|4) ทะนุบำรุงศิลปะและวัฒนธรรมของชาติและของท้องถิ่นโดยเฉพาะอย่างยิ่งศิลปะและวัฒนธรรมของภาคตะวันออกเฉียงเหนือ\n|5) ปรับแปลงถ่ายทอดและพัฒนาเทคโนโลยีด้านการเกษตรเพื่อให้ประเทศไทยพึ่งพาตนเองทางเทคโนโลยีเพื่อการพัฒนาได้มากขึ้น",
          "course_structure": "https://iat.sut.ac.th/curriculum/animal-bsc/",
          "study_plan": "https://iat.sut.ac.th/curriculum/animal-bsc/",
          "teacher": "https://iat.sut.ac.th/academic-staff/",
          "graduation_goals": "รอข้อมูลจากสำนัก",
          "graduation_results": "รอข้อมูลจากสำนัก",
          "employment_goals": "รอข้อมูลจากสำนัก",
          "image": "__PUBLIC_URL__/service-sut/image/2_Institute/3_agri/02_anit/slide1.jpg,__PUBLIC_URL__/service-sut/image/2_Institute/3_agri/02_anit/slide2.jpg,__PUBLIC_URL__/service-sut/image/2_Institute/3_agri/02_anit/slide3.jpg,__PUBLIC_URL__/service-sut/image/2_Institute/3_agri/02_anit/slide4.jpg,__PUBLIC_URL__/service-sut/image/2_Institute/3_agri/02_anit/slide5.jpg",
          "footer": "__PUBLIC_URL__/service-sut/image/2_Institute/3_agri/02_anit/foot1.jpg,__PUBLIC_URL__/service-sut/image/2_Institute/3_agri/02_anit/foot2.jpg,__PUBLIC_URL__/service-sut/image/2_Institute/3_agri/02_anit/foot3.jpg",
          "createAt": null,
          "updateAt": null,
          "year": "2025"
        },
        "vision": {
          "vision_0": "สำนักวิชาเทคโนโลยีการเกษตร เป็นองค์กรชั้นนำที่สุ่งสู่ความเป็นเลิศด้านการเกษตรบูรณาการ โดยการใช้วิทยาศาสตร์ เทคโนโลยี และนวัตกรรม เป็นฐานในการพัฒนาเศรษฐกิจ ให้สอดคล้องกับการพัฒนายุทธศาสตร์ของประเทศไทยอย่างยั่งยืน"
        },
        "mission": {
          "mission_0": "1) ผลิตและพัฒนากำลังคนทางด้านวิทยาศาสตร์ เทคโนโลยี และนวัตกรรม เพื่อตอบสนองต่อความต้องการ ในการพัฒนาประเทศ\n",
          "mission_1": "2) วิจัยและค้นคว้า เพื่อสร้างสรรค์ความก้าวหน้าทางวิชาการ และการนำผลการวิจัยและพัฒนา ไปใช้ในการพัฒนาประเทศ\n",
          "mission_2": "3) ให้บริการทางวิชาการแก่ประชาชนและหน่วยงานต่าง ๆ ทั้งภาครัฐและภาคเอกชน\n",
          "mission_3": "4) ทะนุบำรุงศิลปะและวัฒนธรรมของชาติและของท้องถิ่นโดยเฉพาะอย่างยิ่งศิลปะและวัฒนธรรมของภาคตะวันออกเฉียงเหนือ\n",
          "mission_4": "5) ปรับแปลงถ่ายทอดและพัฒนาเทคโนโลยีด้านการเกษตรเพื่อให้ประเทศไทยพึ่งพาตนเองทางเทคโนโลยีเพื่อการพัฒนาได้มากขึ้น"
        },
        "image": {
          "image_0": "__PUBLIC_URL__/service-sut/image/2_Institute/3_agri/02_anit/slide1.jpg",
          "image_1": "__PUBLIC_URL__/service-sut/image/2_Institute/3_agri/02_anit/slide2.jpg",
          "image_2": "__PUBLIC_URL__/service-sut/image/2_Institute/3_agri/02_anit/slide3.jpg",
          "image_3": "__PUBLIC_URL__/service-sut/image/2_Institute/3_agri/02_anit/slide4.jpg",
          "image_4": "__PUBLIC_URL__/service-sut/image/2_Institute/3_agri/02_anit/slide5.jpg"
        },
        "footer": {
          "image_0": "__PUBLIC_URL__/service-sut/image/2_Institute/3_agri/02_anit/foot1.jpg",
          "image_1": "__PUBLIC_URL__/service-sut/image/2_Institute/3_agri/02_anit/foot2.jpg",
          "image_2": "__PUBLIC_URL__/service-sut/image/2_Institute/3_agri/02_anit/foot3.jpg"
        },
        "icon": [
          {
            "id": "18",
            "courseID": "3",
            "branchID": "0",
            "detail": "ชื่อหลักสูตร",
            "image": "__PUBLIC_URL__/service-sut/image/icon/school-agri-01.svg"
          },
          {
            "id": "19",
            "courseID": "3",
            "branchID": "0",
            "detail": "ชื่อปริญญาบัตรและสาขา",
            "image": "__PUBLIC_URL__/service-sut/image/icon/school-agri-02.svg"
          },
          {
            "id": "20",
            "courseID": "3",
            "branchID": "0",
            "detail": "โครงสร้างหลักสูตร",
            "image": "__PUBLIC_URL__/service-sut/image/icon/school-agri-03.svg"
          },
          {
            "id": "21",
            "courseID": "3",
            "branchID": "0",
            "detail": "แผนการศึกษา",
            "image": "__PUBLIC_URL__/service-sut/image/icon/school-agri-04.svg"
          },
          {
            "id": "22",
            "courseID": "3",
            "branchID": "0",
            "detail": "อาจารย์ประจำหลักสูตร",
            "image": "__PUBLIC_URL__/service-sut/image/icon/school-agri-05.svg"
          },
          {
            "id": "23",
            "courseID": "3",
            "branchID": "0",
            "detail": "เป้าหมายการรับและ การสำเร็จการศึกษา",
            "image": "__PUBLIC_URL__/service-sut/image/icon/school-agri-06.svg"
          },
          {
            "id": "24",
            "courseID": "3",
            "branchID": "0",
            "detail": "ผลการรับและ สำเร็จการศึกษา",
            "image": "__PUBLIC_URL__/service-sut/image/icon/school-agri-07.svg"
          },
          {
            "id": "25",
            "courseID": "3",
            "branchID": "0",
            "detail": "เป้าหมายการได้งานทำ ของบัณฑิต",
            "image": "__PUBLIC_URL__/service-sut/image/icon/school-agri-08.svg"
          }
        ],
        "header": {
          "header_0": "ชื่อปริญญาและสาขา",
          "header_1": "วิสัยทัศน์",
          "header_2": "พันธกิจ",
          "header_3": "โครงสร้างหลักสูตร",
          "header_4": "แผนการศึกษา",
          "header_5": "ผลการรับและสำเร็จการศึกษา",
          "header_6": "เป้าหมายการรับและการสำเร็จการศึกษา",
          "header_7": "ผลการรับและสำเร็จการศึกษา",
          "header_8": "เป้าหมายการได้งานทำของบัณฑิต"
        },
        "visitor": 152,
        "visitor_of_year": 33
      }
    },
    "food-technology": {
      "code": 200,
      "status": "Get data success",
      "data": {
        "information": {
          "id": "65",
          "courseID": "3",
          "titleTH": "สาขาวิชาเทคโนโลยีอาหาร",
          "titleEN": "Food Technology",
          "slang": "food-technology",
          "nameTH": "หลักสูตรวิทยาศาสตรบัณฑิต สาขาวิชาเทคโนโลยีอาหาร",
          "nameEN": "Bachelor of Science Program in Food Technology",
          "nameDegreeTH": "วิทยาศาสตรบัณฑิต (เทคโนโลยีอาหาร)",
          "nameDegreeEN": "Bachelor of Science (Food Technology)",
          "vision": "เป็นสาขาที่สร้างคนและองค์ความรู้เพื่อพัฒนาและเสริมสร้างความเข้มแข็งด้านวิทยาศาสตร์ด้านอาหารของประเทศและภูมิภาค",
          "mission": "ผลิตบัณฑิตที่มีองค์ความรู้ด้านเทคโนโลยีอาหารแบบสากลที่สามารถนำความรู้ไปประยุกต์ใช้อย่างมีประสิทธิภาพ และมีทัศนคติที่ดี มีคุณธรรม มีความเป็นผู้นำ และมีความรับผิดชอบต่อสังคม",
          "course_structure": "https://iat.sut.ac.th/curriculum/foodtech-bsc/",
          "study_plan": "https://iat.sut.ac.th/curriculum/foodtech-bsc/",
          "teacher": "https://iat.sut.ac.th/academic-staff/",
          "graduation_goals": "รอข้อมูลจากสำนัก",
          "graduation_results": "รอข้อมูลจากสำนัก",
          "employment_goals": "รอข้อมูลจากสำนัก",
          "image": "__PUBLIC_URL__/service-sut/image/2_Institute/3_agri/03_foodt/slide1.jpg,__PUBLIC_URL__/service-sut/image/2_Institute/3_agri/03_foodt/slide2.jpg,__PUBLIC_URL__/service-sut/image/2_Institute/3_agri/03_foodt/slide3.jpg,__PUBLIC_URL__/service-sut/image/2_Institute/3_agri/03_foodt/slide4.jpg",
          "footer": "__PUBLIC_URL__/service-sut/image/2_Institute/3_agri/03_foodt/foot1.jpg,__PUBLIC_URL__/service-sut/image/2_Institute/3_agri/03_foodt/foot2.jpg,__PUBLIC_URL__/service-sut/image/2_Institute/3_agri/03_foodt/foot3.jpg",
          "createAt": null,
          "updateAt": null,
          "year": "2025"
        },
        "vision": {
          "vision_0": "เป็นสาขาที่สร้างคนและองค์ความรู้เพื่อพัฒนาและเสริมสร้างความเข้มแข็งด้านวิทยาศาสตร์ด้านอาหารของประเทศและภูมิภาค"
        },
        "mission": {
          "mission_0": "ผลิตบัณฑิตที่มีองค์ความรู้ด้านเทคโนโลยีอาหารแบบสากลที่สามารถนำความรู้ไปประยุกต์ใช้อย่างมีประสิทธิภาพ และมีทัศนคติที่ดี มีคุณธรรม มีความเป็นผู้นำ และมีความรับผิดชอบต่อสังคม"
        },
        "image": {
          "image_0": "__PUBLIC_URL__/service-sut/image/2_Institute/3_agri/03_foodt/slide1.jpg",
          "image_1": "__PUBLIC_URL__/service-sut/image/2_Institute/3_agri/03_foodt/slide2.jpg",
          "image_2": "__PUBLIC_URL__/service-sut/image/2_Institute/3_agri/03_foodt/slide3.jpg",
          "image_3": "__PUBLIC_URL__/service-sut/image/2_Institute/3_agri/03_foodt/slide4.jpg"
        },
        "footer": {
          "image_0": "__PUBLIC_URL__/service-sut/image/2_Institute/3_agri/03_foodt/foot1.jpg",
          "image_1": "__PUBLIC_URL__/service-sut/image/2_Institute/3_agri/03_foodt/foot2.jpg",
          "image_2": "__PUBLIC_URL__/service-sut/image/2_Institute/3_agri/03_foodt/foot3.jpg"
        },
        "icon": [
          {
            "id": "18",
            "courseID": "3",
            "branchID": "0",
            "detail": "ชื่อหลักสูตร",
            "image": "__PUBLIC_URL__/service-sut/image/icon/school-agri-01.svg"
          },
          {
            "id": "19",
            "courseID": "3",
            "branchID": "0",
            "detail": "ชื่อปริญญาบัตรและสาขา",
            "image": "__PUBLIC_URL__/service-sut/image/icon/school-agri-02.svg"
          },
          {
            "id": "20",
            "courseID": "3",
            "branchID": "0",
            "detail": "โครงสร้างหลักสูตร",
            "image": "__PUBLIC_URL__/service-sut/image/icon/school-agri-03.svg"
          },
          {
            "id": "21",
            "courseID": "3",
            "branchID": "0",
            "detail": "แผนการศึกษา",
            "image": "__PUBLIC_URL__/service-sut/image/icon/school-agri-04.svg"
          },
          {
            "id": "22",
            "courseID": "3",
            "branchID": "0",
            "detail": "อาจารย์ประจำหลักสูตร",
            "image": "__PUBLIC_URL__/service-sut/image/icon/school-agri-05.svg"
          },
          {
            "id": "23",
            "courseID": "3",
            "branchID": "0",
            "detail": "เป้าหมายการรับและ การสำเร็จการศึกษา",
            "image": "__PUBLIC_URL__/service-sut/image/icon/school-agri-06.svg"
          },
          {
            "id": "24",
            "courseID": "3",
            "branchID": "0",
            "detail": "ผลการรับและ สำเร็จการศึกษา",
            "image": "__PUBLIC_URL__/service-sut/image/icon/school-agri-07.svg"
          },
          {
            "id": "25",
            "courseID": "3",
            "branchID": "0",
            "detail": "เป้าหมายการได้งานทำ ของบัณฑิต",
            "image": "__PUBLIC_URL__/service-sut/image/icon/school-agri-08.svg"
          }
        ],
        "header": {
          "header_0": "ชื่อปริญญาและสาขา",
          "header_1": "วิสัยทัศน์",
          "header_2": "พันธกิจ",
          "header_3": "โครงสร้างหลักสูตร",
          "header_4": "แผนการศึกษา",
          "header_5": "ผลการรับและสำเร็จการศึกษา",
          "header_6": "เป้าหมายการรับและการสำเร็จการศึกษา",
          "header_7": "ผลการรับและสำเร็จการศึกษา",
          "header_8": "เป้าหมายการได้งานทำของบัณฑิต"
        },
        "visitor": 187,
        "visitor_of_year": 52
      }
    },
    "manufacturing-automation-and-robotics-engineering": {
      "code": 200,
      "status": "Get data success",
      "data": {
        "information": {
          "id": "66",
          "courseID": "4",
          "titleTH": "สาขาวิชาวิศวกรรมการผลิต",
          "titleEN": "Manufacturing Automation and Robotics Engineering",
          "slang": "manufacturing-automation-and-robotics-engineering",
          "nameTH": "หลักสูตรวิศวกรรมศาสตรบัณฑิต สาขาวิชาวิศวกรรมการผลิตอัตโนมัติและหุ่นยนต์",
          "nameEN": "Bachelor of Engineering Program in Manufacturing Automation and Robotics Engineering",
          "nameDegreeTH": "วิศวกรรมศาสตรบัณฑิต (วิศวกรรมการผลิตอัตโนมัติและหุ่นยนต์)",
          "nameDegreeEN": "Bachelor of Engineering (Manufacturing Automation and Robotics Engineering)",
          "vision": "เป็นองค์กรที่โดดเด่นในการสร้างกำลังคนและความรู้ด้านวิศวกรรมศาสตร์ของประเทศ เป้าหมาย: เป็น 1 ใน 3 ของประเทศด้านวิศวกรรมศาสตร์ ภายในปี พ.ศ. 2568",
          "mission": "1) ผลิตและพัฒนากำลังคนทางด้านวิศวกรรมศาสตร์ที่มีความรู้และทักษะพร้อมในการทำงานภาคอุตสาหกรรม\n|2) วิจัยและพัฒนาทางด้านวิศวกรรมศาสตร์ที่ตอบสนองความต้องการของประเทศและภูมิภาค\n|3) บริการวิชาการ ปรับแปลง และถ่ายทอดเทคโนโลยี เพื่อส่งเสริมศักยภาพในการแข่งขันของภาคอุตสาหกรรมและบริการของประเทศและสร้างสรรค์คุณค่าแก่สังคม",
          "course_structure": "http://reg3.sut.ac.th/registrar/program_info_1.asp?f_cmd=2&acadyear=2564&levelid=1&programid=107460101640&facultyid=10700&programname=%C7%D4%C8%C7%A1%C3%C3%C1%A1%D2%C3%BC%C5%D4%B5%CD%D1%B5%E2%B9%C1%D1%B5%D4%E1%C5%D0%CB%D8%E8%B9%C2%B9%B5%EC%2D2564&facultyname=%CA%D3%B9%D1%A1%C7%D4%AA%D2%C7%D4%C8%C7%A1%C3%C3%C1%C8%D2%CA%B5%C3%EC&levelname=%BB%C3%D4%AD%AD%D2%B5%C3%D5",
          "study_plan": "http://reg3.sut.ac.th/registrar/studyplan_info1.asp?avs908969082=5&acadyear=2564&levelid=1&programid=107460101640&facultyid=10700&programname=%C7%D4%C8%C7%A1%C3%C3%C1%A1%D2%C3%BC%C5%D4%B5%CD%D1%B5%E2%B9%C1%D1%B5%D4%E1%C5%D0%CB%D8%E8%B9%C2%B9%B5%EC%2D2564&facultyname=%CA%D3%B9%D1%A1%C7%D4%AA%D2%C7%D4%C8%C7%A1%C3%C3%C1%C8%D2%CA%B5%C3%EC&levelname=%BB%C3%D4%AD%AD%D2%B5%C3%D5",
          "teacher": "http://www.maesut.com/index.php/people/",
          "graduation_goals": "รอข้อมูลจากสำนัก",
          "graduation_results": "รอข้อมูลจากสำนัก",
          "employment_goals": "รอข้อมูลจากสำนัก",
          "image": "__PUBLIC_URL__/service-sut/image/2_Institute/4-engi/01_manu/slide1.jpg,__PUBLIC_URL__/service-sut/image/2_Institute/4-engi/01_manu/slide2.jpg,__PUBLIC_URL__/service-sut/image/2_Institute/4-engi/01_manu/slide3.jpg",
          "footer": "__PUBLIC_URL__/service-sut/image/2_Institute/4-engi/01_manu/foot1.jpg,__PUBLIC_URL__/service-sut/image/2_Institute/4-engi/01_manu/foot2.jpg,__PUBLIC_URL__/service-sut/image/2_Institute/4-engi/01_manu/foot3.jpg",
          "createAt": null,
          "updateAt": null,
          "year": "2025"
        },
        "vision": {
          "vision_0": "เป็นองค์กรที่โดดเด่นในการสร้างกำลังคนและความรู้ด้านวิศวกรรมศาสตร์ของประเทศ เป้าหมาย: เป็น 1 ใน 3 ของประเทศด้านวิศวกรรมศาสตร์ ภายในปี พ.ศ. 2568"
        },
        "mission": {
          "mission_0": "1) ผลิตและพัฒนากำลังคนทางด้านวิศวกรรมศาสตร์ที่มีความรู้และทักษะพร้อมในการทำงานภาคอุตสาหกรรม\n",
          "mission_1": "2) วิจัยและพัฒนาทางด้านวิศวกรรมศาสตร์ที่ตอบสนองความต้องการของประเทศและภูมิภาค\n",
          "mission_2": "3) บริการวิชาการ ปรับแปลง และถ่ายทอดเทคโนโลยี เพื่อส่งเสริมศักยภาพในการแข่งขันของภาคอุตสาหกรรมและบริการของประเทศและสร้างสรรค์คุณค่าแก่สังคม"
        },
        "image": {
          "image_0": "__PUBLIC_URL__/service-sut/image/2_Institute/4-engi/01_manu/slide1.jpg",
          "image_1": "__PUBLIC_URL__/service-sut/image/2_Institute/4-engi/01_manu/slide2.jpg",
          "image_2": "__PUBLIC_URL__/service-sut/image/2_Institute/4-engi/01_manu/slide3.jpg"
        },
        "footer": {
          "image_0": "__PUBLIC_URL__/service-sut/image/2_Institute/4-engi/01_manu/foot1.jpg",
          "image_1": "__PUBLIC_URL__/service-sut/image/2_Institute/4-engi/01_manu/foot2.jpg",
          "image_2": "__PUBLIC_URL__/service-sut/image/2_Institute/4-engi/01_manu/foot3.jpg"
        },
        "icon": [
          {
            "id": "26",
            "courseID": "4",
            "branchID": "0",
            "detail": "ชื่อหลักสูตร",
            "image": "__PUBLIC_URL__/service-sut/image/icon/school-engi-01.svg"
          },
          {
            "id": "27",
            "courseID": "4",
            "branchID": "0",
            "detail": "ชื่อปริญญาบัตรและสาขา",
            "image": "__PUBLIC_URL__/service-sut/image/icon/school-engi-02.svg"
          },
          {
            "id": "28",
            "courseID": "4",
            "branchID": "0",
            "detail": "โครงสร้างหลักสูตร",
            "image": "__PUBLIC_URL__/service-sut/image/icon/school-engi-03.svg"
          },
          {
            "id": "29",
            "courseID": "4",
            "branchID": "0",
            "detail": "แผนการศึกษา",
            "image": "__PUBLIC_URL__/service-sut/image/icon/school-engi-04.svg"
          },
          {
            "id": "30",
            "courseID": "4",
            "branchID": "0",
            "detail": "อาจารย์ประจำหลักสูตร",
            "image": "__PUBLIC_URL__/service-sut/image/icon/school-engi-05.svg"
          },
          {
            "id": "31",
            "courseID": "4",
            "branchID": "0",
            "detail": "เป้าหมายการรับและ การสำเร็จการศึกษา",
            "image": "__PUBLIC_URL__/service-sut/image/icon/school-engi-06.svg"
          },
          {
            "id": "32",
            "courseID": "4",
            "branchID": "0",
            "detail": "ผลการรับและ สำเร็จการศึกษา",
            "image": "__PUBLIC_URL__/service-sut/image/icon/school-engi-07.svg"
          },
          {
            "id": "33",
            "courseID": "4",
            "branchID": "0",
            "detail": "เป้าหมายการได้งานทำ ของบัณฑิต",
            "image": "__PUBLIC_URL__/service-sut/image/icon/school-engi-08.svg"
          }
        ],
        "header": {
          "header_0": "ชื่อปริญญาและสาขา",
          "header_1": "วิสัยทัศน์",
          "header_2": "พันธกิจ",
          "header_3": "โครงสร้างหลักสูตร",
          "header_4": "แผนการศึกษา",
          "header_5": "ผลการรับและสำเร็จการศึกษา",
          "header_6": "เป้าหมายการรับและการสำเร็จการศึกษา",
          "header_7": "ผลการรับและสำเร็จการศึกษา",
          "header_8": "เป้าหมายการได้งานทำของบัณฑิต"
        },
        "visitor": 1858,
        "visitor_of_year": 375
      }
    },
    "agricultural-and-food-engineering": {
      "code": 200,
      "status": "Get data success",
      "data": {
        "information": {
          "id": "67",
          "courseID": "4",
          "titleTH": "สาขาวิชาวิศวกรรมเกษตร",
          "titleEN": "Agricultural and Food Engineering",
          "slang": "agricultural-and-food-engineering",
          "nameTH": "หลักสูตรวิศวกรรมศาสตรบัณฑิต สาขาวิชาวิศวกรรมเกษตรและอาหาร",
          "nameEN": "Bachelor of Engineering Program in Agricultural and Food Engineering",
          "nameDegreeTH": "วิศวกรรมศาสตรบัณฑิต (วิศวกรรมเกษตรและอาหาร)",
          "nameDegreeEN": "Bachelor of Engineering (Agricultural and Food Engineering)",
          "vision": "สาขาวิชาวิศวกรรมชั้นนำด้านการเกษตร อาหาร พลังงานและสิ่งแวดล้อมเพื่อตอบสนองต่อการพัฒนาประเทศ",
          "mission": "1.ผลิตบัณฑิตและพัฒนากำลังคนทางด้านวิศวกรรมเกษตร และวิศวกรรมอาหารเพื่อตอบสนองความต้องการของการพัฒนาประเทศ\n|2.วิจัยและค้นคว้าเพื่อสร้างสรรค์ จรรโลงความก้าวหน้าทางวิชาการ และการนำผลการวิจัยและพัฒนาไปใช้ในการพัฒนาประเทศ\n|3.ปรับแปลงและถ่ายทอดเทคโนโลยี เพื่อให้ประเทศพึ่งพาตนเองได้ รวมทั้งให้บริการทางวิชาการ\n|4.ทะนุบำรุงศิลปะวัฒนธรรมของชาติและของท้องถิ่น",
          "course_structure": "http://reg3.sut.ac.th/registrar/program_info_1.asp?f_cmd=2&acadyear=-1&levelid=1&programid=107260101640&facultyid=10700&programname=%C7%D4%C8%C7%A1%C3%C3%C1%E0%A1%C9%B5%C3%E1%C5%D0%CD%D2%CB%D2%C3%2D2564&facultyname=%CA%D3%B9%D1%A1%C7%D4%AA%D2%C7%D4%C8%C7%A1%C3%C3%C1%C8%D2%CA%B5%C3%EC&levelname=%BB%C3%D4%AD%AD%D2%B5%C3%D5",
          "study_plan": "http://reg3.sut.ac.th/registrar/studyplan_info1.asp?avs1024806187=32&acadyear=-1&levelid=1&programid=107260101640&facultyid=10700&programname=%C7%D4%C8%C7%A1%C3%C3%C1%E0%A1%C9%B5%C3%E1%C5%D0%CD%D2%CB%D2%C3%2D2564&facultyname=%CA%D3%B9%D1%A1%C7%D4%AA%D2%C7%D4%C8%C7%A1%C3%C3%C1%C8%D2%CA%B5%C3%EC&levelname=%BB%C3%D4%AD%AD%D2%B5%C3%D5",
          "teacher": "https://beta.sut.ac.th/ie-ae/คณาจารย์-บุคลากร",
          "graduation_goals": "รอข้อมูลจากสำนัก",
          "graduation_results": "รอข้อมูลจากสำนัก",
          "employment_goals": "รอข้อมูลจากสำนัก",
          "image": "__PUBLIC_URL__/service-sut/image/2_Institute/4-engi/02_agri/slide1.jpg,__PUBLIC_URL__/service-sut/image/2_Institute/4-engi/02_agri/slide2.jpg,__PUBLIC_URL__/service-sut/image/2_Institute/4-engi/02_agri/slide3.jpg",
          "footer": "__PUBLIC_URL__/service-sut/image/2_Institute/4-engi/02_agri/foot1.jpg,__PUBLIC_URL__/service-sut/image/2_Institute/4-engi/02_agri/foot2.jpg,__PUBLIC_URL__/service-sut/image/2_Institute/4-engi/02_agri/foot3.jpg",
          "createAt": null,
          "updateAt": null,
          "year": "2025"
        },
        "vision": {
          "vision_0": "สาขาวิชาวิศวกรรมชั้นนำด้านการเกษตร อาหาร พลังงานและสิ่งแวดล้อมเพื่อตอบสนองต่อการพัฒนาประเทศ"
        },
        "mission": {
          "mission_0": "1.ผลิตบัณฑิตและพัฒนากำลังคนทางด้านวิศวกรรมเกษตร และวิศวกรรมอาหารเพื่อตอบสนองความต้องการของการพัฒนาประเทศ\n",
          "mission_1": "2.วิจัยและค้นคว้าเพื่อสร้างสรรค์ จรรโลงความก้าวหน้าทางวิชาการ และการนำผลการวิจัยและพัฒนาไปใช้ในการพัฒนาประเทศ\n",
          "mission_2": "3.ปรับแปลงและถ่ายทอดเทคโนโลยี เพื่อให้ประเทศพึ่งพาตนเองได้ รวมทั้งให้บริการทางวิชาการ\n",
          "mission_3": "4.ทะนุบำรุงศิลปะวัฒนธรรมของชาติและของท้องถิ่น"
        },
        "image": {
          "image_0": "__PUBLIC_URL__/service-sut/image/2_Institute/4-engi/02_agri/slide1.jpg",
          "image_1": "__PUBLIC_URL__/service-sut/image/2_Institute/4-engi/02_agri/slide2.jpg",
          "image_2": "__PUBLIC_URL__/service-sut/image/2_Institute/4-engi/02_agri/slide3.jpg"
        },
        "footer": {
          "image_0": "__PUBLIC_URL__/service-sut/image/2_Institute/4-engi/02_agri/foot1.jpg",
          "image_1": "__PUBLIC_URL__/service-sut/image/2_Institute/4-engi/02_agri/foot2.jpg",
          "image_2": "__PUBLIC_URL__/service-sut/image/2_Institute/4-engi/02_agri/foot3.jpg"
        },
        "icon": [
          {
            "id": "26",
            "courseID": "4",
            "branchID": "0",
            "detail": "ชื่อหลักสูตร",
            "image": "__PUBLIC_URL__/service-sut/image/icon/school-engi-01.svg"
          },
          {
            "id": "27",
            "courseID": "4",
            "branchID": "0",
            "detail": "ชื่อปริญญาบัตรและสาขา",
            "image": "__PUBLIC_URL__/service-sut/image/icon/school-engi-02.svg"
          },
          {
            "id": "28",
            "courseID": "4",
            "branchID": "0",
            "detail": "โครงสร้างหลักสูตร",
            "image": "__PUBLIC_URL__/service-sut/image/icon/school-engi-03.svg"
          },
          {
            "id": "29",
            "courseID": "4",
            "branchID": "0",
            "detail": "แผนการศึกษา",
            "image": "__PUBLIC_URL__/service-sut/image/icon/school-engi-04.svg"
          },
          {
            "id": "30",
            "courseID": "4",
            "branchID": "0",
            "detail": "อาจารย์ประจำหลักสูตร",
            "image": "__PUBLIC_URL__/service-sut/image/icon/school-engi-05.svg"
          },
          {
            "id": "31",
            "courseID": "4",
            "branchID": "0",
            "detail": "เป้าหมายการรับและ การสำเร็จการศึกษา",
            "image": "__PUBLIC_URL__/service-sut/image/icon/school-engi-06.svg"
          },
          {
            "id": "32",
            "courseID": "4",
            "branchID": "0",
            "detail": "ผลการรับและ สำเร็จการศึกษา",
            "image": "__PUBLIC_URL__/service-sut/image/icon/school-engi-07.svg"
          },
          {
            "id": "33",
            "courseID": "4",
            "branchID": "0",
            "detail": "เป้าหมายการได้งานทำ ของบัณฑิต",
            "image": "__PUBLIC_URL__/service-sut/image/icon/school-engi-08.svg"
          }
        ],
        "header": {
          "header_0": "ชื่อปริญญาและสาขา",
          "header_1": "วิสัยทัศน์",
          "header_2": "พันธกิจ",
          "header_3": "โครงสร้างหลักสูตร",
          "header_4": "แผนการศึกษา",
          "header_5": "ผลการรับและสำเร็จการศึกษา",
          "header_6": "เป้าหมายการรับและการสำเร็จการศึกษา",
          "header_7": "ผลการรับและสำเร็จการศึกษา",
          "header_8": "เป้าหมายการได้งานทำของบัณฑิต"
        },
        "visitor": 143,
        "visitor_of_year": 97
      }
    },
    "transportation-and-logistics-engineering": {
      "code": 200,
      "status": "Get data success",
      "data": {
        "information": {
          "id": "68",
          "courseID": "4",
          "titleTH": "สาขาวิชาวิศวกรรมขนส่ง",
          "titleEN": "Transportation and Logistics Engineering",
          "slang": "transportation-and-logistics-engineering",
          "nameTH": "หลักสูตรวิศวกรรมศาสตรบัณฑิต สาขาวิชาวิศวกรรมขนส่งและโลจิสติกส์",
          "nameEN": "Bachelor of Engineering Program in Transportation and Logistics Engineering",
          "nameDegreeTH": "วิศวกรรมศาสตรบัณฑิต (วิศวกรรมขนส่งและโลจิสติกส์)",
          "nameDegreeEN": "Bachelor of Engineering (Transportation and Logistics Engineering)",
          "vision": "รอข้อมูลจากสำนัก",
          "mission": "รอข้อมูลจากสำนัก",
          "course_structure": "http://reg3.sut.ac.th/registrar/program_info_1.asp?f_cmd=2&acadyear=-1&levelid=1&programid=107300101650&facultyid=10700&programname=%C7%D4%C8%C7%A1%C3%C3%C1%A2%B9%CA%E8%A7%E1%C5%D0%E2%C5%A8%D4%CA%B5%D4%A1%CA%EC%2D2565&facultyname=%CA%D3%B9%D1%A1%C7%D4%AA%D2%C7%D4%C8%C7%A1%C3%C3%C1%C8%D2%CA%B5%C3%EC&levelname=%BB%C3%D4%AD%AD%D2%B5%C3%D5",
          "study_plan": "http://reg3.sut.ac.th/registrar/studyplan_info1.asp?avs1024806187=35&acadyear=-1&levelid=1&programid=107300101650&facultyid=10700&programname=%C7%D4%C8%C7%A1%C3%C3%C1%A2%B9%CA%E8%A7%E1%C5%D0%E2%C5%A8%D4%CA%B5%D4%A1%CA%EC%2D2565&facultyname=%CA%D3%B9%D1%A1%C7%D4%AA%D2%C7%D4%C8%C7%A1%C3%C3%C1%C8%D2%CA%B5%C3%EC&levelname=%BB%C3%D4%AD%AD%D2%B5%C3%D5",
          "teacher": "รอข้อมูลจากสำนัก",
          "graduation_goals": "รอข้อมูลจากสำนัก",
          "graduation_results": "รอข้อมูลจากสำนัก",
          "employment_goals": "รอข้อมูลจากสำนัก",
          "image": "__PUBLIC_URL__/service-sut/image/2_Institute/4-engi/03_trans/slide1.jpg,__PUBLIC_URL__/service-sut/image/2_Institute/4-engi/03_trans/slide2.jpg",
          "footer": "__PUBLIC_URL__/service-sut/image/2_Institute/4-engi/03_trans/foot1.jpg,__PUBLIC_URL__/service-sut/image/2_Institute/4-engi/03_trans/foot2.jpg,__PUBLIC_URL__/service-sut/image/2_Institute/4-engi/03_trans/foot3.jpg",
          "createAt": null,
          "updateAt": null,
          "year": "2025"
        },
        "vision": {
          "vision_0": "รอข้อมูลจากสำนัก"
        },
        "mission": {
          "mission_0": "รอข้อมูลจากสำนัก"
        },
        "image": {
          "image_0": "__PUBLIC_URL__/service-sut/image/2_Institute/4-engi/03_trans/slide1.jpg",
          "image_1": "__PUBLIC_URL__/service-sut/image/2_Institute/4-engi/03_trans/slide2.jpg"
        },
        "footer": {
          "image_0": "__PUBLIC_URL__/service-sut/image/2_Institute/4-engi/03_trans/foot1.jpg",
          "image_1": "__PUBLIC_URL__/service-sut/image/2_Institute/4-engi/03_trans/foot2.jpg",
          "image_2": "__PUBLIC_URL__/service-sut/image/2_Institute/4-engi/03_trans/foot3.jpg"
        },
        "icon": [
          {
            "id": "26",
            "courseID": "4",
            "branchID": "0",
            "detail": "ชื่อหลักสูตร",
            "image": "__PUBLIC_URL__/service-sut/image/icon/school-engi-01.svg"
          },
          {
            "id": "27",
            "courseID": "4",
            "branchID": "0",
            "detail": "ชื่อปริญญาบัตรและสาขา",
            "image": "__PUBLIC_URL__/service-sut/image/icon/school-engi-02.svg"
          },
          {
            "id": "28",
            "courseID": "4",
            "branchID": "0",
            "detail": "โครงสร้างหลักสูตร",
            "image": "__PUBLIC_URL__/service-sut/image/icon/school-engi-03.svg"
          },
          {
            "id": "29",
            "courseID": "4",
            "branchID": "0",
            "detail": "แผนการศึกษา",
            "image": "__PUBLIC_URL__/service-sut/image/icon/school-engi-04.svg"
          },
          {
            "id": "30",
            "courseID": "4",
            "branchID": "0",
            "detail": "อาจารย์ประจำหลักสูตร",
            "image": "__PUBLIC_URL__/service-sut/image/icon/school-engi-05.svg"
          },
          {
            "id": "31",
            "courseID": "4",
            "branchID": "0",
            "detail": "เป้าหมายการรับและ การสำเร็จการศึกษา",
            "image": "__PUBLIC_URL__/service-sut/image/icon/school-engi-06.svg"
          },
          {
            "id": "32",
            "courseID": "4",
            "branchID": "0",
            "detail": "ผลการรับและ สำเร็จการศึกษา",
            "image": "__PUBLIC_URL__/service-sut/image/icon/school-engi-07.svg"
          },
          {
            "id": "33",
            "courseID": "4",
            "branchID": "0",
            "detail": "เป้าหมายการได้งานทำ ของบัณฑิต",
            "image": "__PUBLIC_URL__/service-sut/image/icon/school-engi-08.svg"
          }
        ],
        "header": {
          "header_0": "ชื่อปริญญาและสาขา",
          "header_1": "วิสัยทัศน์",
          "header_2": "พันธกิจ",
          "header_3": "โครงสร้างหลักสูตร",
          "header_4": "แผนการศึกษา",
          "header_5": "ผลการรับและสำเร็จการศึกษา",
          "header_6": "เป้าหมายการรับและการสำเร็จการศึกษา",
          "header_7": "ผลการรับและสำเร็จการศึกษา",
          "header_8": "เป้าหมายการได้งานทำของบัณฑิต"
        },
        "visitor": 690,
        "visitor_of_year": 160
      }
    },
    "computer-engineering": {
      "code": 200,
      "status": "Get data success",
      "data": {
        "information": {
          "id": "69",
          "courseID": "4",
          "titleTH": "สาขาวิชาวิศวกรรมคอมพิวเตอร์",
          "titleEN": "Computer Engineering",
          "slang": "computer-engineering",
          "nameTH": "หลักสูตรวิศวกรรมศาสตรบัณฑิต สาขาวิชาวิศวกรรมคอมพิวเตอร์",
          "nameEN": "Bachelor of Engineering Program in Computer Engineering",
          "nameDegreeTH": "วิศวกรรมศาสตรบัณฑิต (วิศวกรรมคอมพิวเตอร์)",
          "nameDegreeEN": "Bachelor of  Engineering (Computer Engineering)",
          "vision": "มุ่งผลิตวิศวกรคอมพิวเตอร์ที่มีความตระหนักในคุณธรรมและจริยธรรมของวิชาชีพ\nสามารถพัฒนาตนเองในเชิงวิชาการ เรียนรู้ที่จะปรับแปลงและพัฒนาเทคโนโลยีที่เหมาะสมเพื่อให้ประเทศไทย\nพึ่งพาตนเองได้ในด้านเทคโนโลยี",
          "mission": "มุ่งผลิตวิศวกรคอมพิวเตอร์ที่มีความตระหนักในคุณธรรมและจริยธรรมของวิชาชีพ\nสามารถพัฒนาตนเองในเชิงวิชาการ เรียนรู้ที่จะปรับแปลงและพัฒนาเทคโนโลยีที่เหมาะสมเพื่อให้ประเทศไทย\nพึ่งพาตนเองได้ในด้านเทคโนโลยี",
          "course_structure": "http://reg3.sut.ac.th/registrar/program_info_1.asp?f_cmd=2&acadyear=-1&levelid=1&programid=107050101650&facultyid=10700&programname=%C7%D4%C8%C7%A1%C3%C3%C1%A4%CD%C1%BE%D4%C7%E0%B5%CD%C3%EC%2D2565&facultyname=%CA%D3%B9%D1%A1%C7%D4%AA%D2%C7%D4%C8%C7%A1%C3%C3%C1%C8%D2%CA%B5%C3%EC&levelname=%BB%C3%D4%AD%AD%D2%B5%C3%D5",
          "study_plan": "http://reg3.sut.ac.th/registrar/studyplan_info1.asp?avs1024806187=38&acadyear=-1&levelid=1&programid=107050101650&facultyid=10700&programname=%C7%D4%C8%C7%A1%C3%C3%C1%A4%CD%C1%BE%D4%C7%E0%B5%CD%C3%EC%2D2565&facultyname=%CA%D3%B9%D1%A1%C7%D4%AA%D2%C7%D4%C8%C7%A1%C3%C3%C1%C8%D2%CA%B5%C3%EC&levelname=%BB%C3%D4%AD%AD%D2%B5%C3%D5",
          "teacher": "https://beta.sut.ac.th/ie-cpe/คณาจารย์-บุคลากร/คณาจารย์/คณาจารย์สาขา",
          "graduation_goals": "รอข้อมูลจากสำนัก",
          "graduation_results": "รอข้อมูลจากสำนัก",
          "employment_goals": "รอข้อมูลจากสำนัก",
          "image": "__PUBLIC_URL__/service-sut/image/2_Institute/4-engi/04_comp/slide1.png,__PUBLIC_URL__/service-sut/image/2_Institute/4-engi/04_comp/slide2.png,__PUBLIC_URL__/service-sut/image/2_Institute/4-engi/04_comp/slide3.png",
          "footer": "__PUBLIC_URL__/service-sut/image/2_Institute/4-engi/04_comp/foot1.png,__PUBLIC_URL__/service-sut/image/2_Institute/4-engi/04_comp/foot2.png,__PUBLIC_URL__/service-sut/image/2_Institute/4-engi/04_comp/foot3.png",
          "createAt": null,
          "updateAt": null,
          "year": "2025"
        },
        "vision": {
          "vision_0": "มุ่งผลิตวิศวกรคอมพิวเตอร์ที่มีความตระหนักในคุณธรรมและจริยธรรมของวิชาชีพ\nสามารถพัฒนาตนเองในเชิงวิชาการ เรียนรู้ที่จะปรับแปลงและพัฒนาเทคโนโลยีที่เหมาะสมเพื่อให้ประเทศไทย\nพึ่งพาตนเองได้ในด้านเทคโนโลยี"
        },
        "mission": {
          "mission_0": "มุ่งผลิตวิศวกรคอมพิวเตอร์ที่มีความตระหนักในคุณธรรมและจริยธรรมของวิชาชีพ\nสามารถพัฒนาตนเองในเชิงวิชาการ เรียนรู้ที่จะปรับแปลงและพัฒนาเทคโนโลยีที่เหมาะสมเพื่อให้ประเทศไทย\nพึ่งพาตนเองได้ในด้านเทคโนโลยี"
        },
        "image": {
          "image_0": "__PUBLIC_URL__/service-sut/image/2_Institute/4-engi/04_comp/slide1.png",
          "image_1": "__PUBLIC_URL__/service-sut/image/2_Institute/4-engi/04_comp/slide2.png",
          "image_2": "__PUBLIC_URL__/service-sut/image/2_Institute/4-engi/04_comp/slide3.png"
        },
        "footer": {
          "image_0": "__PUBLIC_URL__/service-sut/image/2_Institute/4-engi/04_comp/foot1.png",
          "image_1": "__PUBLIC_URL__/service-sut/image/2_Institute/4-engi/04_comp/foot2.png",
          "image_2": "__PUBLIC_URL__/service-sut/image/2_Institute/4-engi/04_comp/foot3.png"
        },
        "icon": [
          {
            "id": "26",
            "courseID": "4",
            "branchID": "0",
            "detail": "ชื่อหลักสูตร",
            "image": "__PUBLIC_URL__/service-sut/image/icon/school-engi-01.svg"
          },
          {
            "id": "27",
            "courseID": "4",
            "branchID": "0",
            "detail": "ชื่อปริญญาบัตรและสาขา",
            "image": "__PUBLIC_URL__/service-sut/image/icon/school-engi-02.svg"
          },
          {
            "id": "28",
            "courseID": "4",
            "branchID": "0",
            "detail": "โครงสร้างหลักสูตร",
            "image": "__PUBLIC_URL__/service-sut/image/icon/school-engi-03.svg"
          },
          {
            "id": "29",
            "courseID": "4",
            "branchID": "0",
            "detail": "แผนการศึกษา",
            "image": "__PUBLIC_URL__/service-sut/image/icon/school-engi-04.svg"
          },
          {
            "id": "30",
            "courseID": "4",
            "branchID": "0",
            "detail": "อาจารย์ประจำหลักสูตร",
            "image": "__PUBLIC_URL__/service-sut/image/icon/school-engi-05.svg"
          },
          {
            "id": "31",
            "courseID": "4",
            "branchID": "0",
            "detail": "เป้าหมายการรับและ การสำเร็จการศึกษา",
            "image": "__PUBLIC_URL__/service-sut/image/icon/school-engi-06.svg"
          },
          {
            "id": "32",
            "courseID": "4",
            "branchID": "0",
            "detail": "ผลการรับและ สำเร็จการศึกษา",
            "image": "__PUBLIC_URL__/service-sut/image/icon/school-engi-07.svg"
          },
          {
            "id": "33",
            "courseID": "4",
            "branchID": "0",
            "detail": "เป้าหมายการได้งานทำ ของบัณฑิต",
            "image": "__PUBLIC_URL__/service-sut/image/icon/school-engi-08.svg"
          }
        ],
        "header": {
          "header_0": "ชื่อปริญญาและสาขา",
          "header_1": "วิสัยทัศน์",
          "header_2": "พันธกิจ",
          "header_3": "โครงสร้างหลักสูตร",
          "header_4": "แผนการศึกษา",
          "header_5": "ผลการรับและสำเร็จการศึกษา",
          "header_6": "เป้าหมายการรับและการสำเร็จการศึกษา",
          "header_7": "ผลการรับและสำเร็จการศึกษา",
          "header_8": "เป้าหมายการได้งานทำของบัณฑิต"
        },
        "visitor": 6198,
        "visitor_of_year": 1713
      }
    },
    "chemical-engineering": {
      "code": 200,
      "status": "Get data success",
      "data": {
        "information": {
          "id": "70",
          "courseID": "4",
          "titleTH": "สาขาวิชาวิศวกรรมเคมี",
          "titleEN": "Chemical Engineering",
          "slang": "chemical-engineering",
          "nameTH": "หลักสูตรวิศวกรรมศาสตรบัณฑิต สาขาวิชาวิศวกรรมเคมี",
          "nameEN": "Bachelor of Engineering Program in Chemical Engineering",
          "nameDegreeTH": "วิศวกรรมศาสตรบัณฑิต (วิศวกรรมเคมี)",
          "nameDegreeEN": "Bachelor of Engineering (Chemical Engineering)",
          "vision": "เป็นองค์กรที่โดดเด่นในการสร้างกำลังคนและความรู้ด้านวิศวกรรมศาสตร์ของประเทศ",
          "mission": "ผลิตและพัฒนากำลังคนทางด้านวิศวกรรมศาสตร์ที่มีความรู้และทักษะพร้อมในการทำงานภาคอุตสาหกรรม\nวิจัยและพัฒนาทางด้านวิศวกรรมศาสตร์ที่ตอบสนองความต้องการของประเทศและภูมิภาค\nบริการวิชาการ ปรับแปลง และถ่ายทอดเทคโนโลยี เพื่อส่งเสริมศักยภาพในการแข่งขันของภาคอุตสาหกรรมและบริการของประเทศและสร้างสรรค์คุณค่าแก่สังคม (10 มีนาคม 2563)",
          "course_structure": "http://reg3.sut.ac.th/registrar/program_info_1.asp?f_cmd=2&acadyear=-1&levelid=1&programid=107060101640&facultyid=10700&programname=%C7%D4%C8%C7%A1%C3%C3%C1%E0%A4%C1%D5%2D2564&facultyname=%CA%D3%B9%D1%A1%C7%D4%AA%D2%C7%D4%C8%C7%A1%C3%C3%C1%C8%D2%CA%B5%C3%EC&levelname=%BB%C3%D4%AD%AD%D2%B5%C3%D5",
          "study_plan": "http://reg3.sut.ac.th/registrar/studyplan_info1.asp?avs1024806187=42&acadyear=-1&levelid=1&programid=107060101640&facultyid=10700&programname=%C7%D4%C8%C7%A1%C3%C3%C1%E0%A4%C1%D5%2D2564&facultyname=%CA%D3%B9%D1%A1%C7%D4%AA%D2%C7%D4%C8%C7%A1%C3%C3%C1%C8%D2%CA%B5%C3%EC&levelname=%BB%C3%D4%AD%AD%D2%B5%C3%D5",
          "teacher": "https://beta.sut.ac.th/ie-che/คณาจารย์-บุคคลากร",
          "graduation_goals": "รอข้อมูลจากสำนัก",
          "graduation_results": "รอข้อมูลจากสำนัก",
          "employment_goals": "รอข้อมูลจากสำนัก",
          "image": "__PUBLIC_URL__/service-sut/image/2_Institute/4-engi/05_chem/slide1.jpg,__PUBLIC_URL__/service-sut/image/2_Institute/4-engi/05_chem/slide2.jpg,__PUBLIC_URL__/service-sut/image/2_Institute/4-engi/05_chem/slide3.jpg",
          "footer": "__PUBLIC_URL__/service-sut/image/2_Institute/4-engi/05_chem/foot1.jpg,__PUBLIC_URL__/service-sut/image/2_Institute/4-engi/05_chem/foot2.jpg,__PUBLIC_URL__/service-sut/image/2_Institute/4-engi/05_chem/foot3.jpg",
          "createAt": null,
          "updateAt": null,
          "year": "2025"
        },
        "vision": {
          "vision_0": "เป็นองค์กรที่โดดเด่นในการสร้างกำลังคนและความรู้ด้านวิศวกรรมศาสตร์ของประเทศ"
        },
        "mission": {
          "mission_0": "ผลิตและพัฒนากำลังคนทางด้านวิศวกรรมศาสตร์ที่มีความรู้และทักษะพร้อมในการทำงานภาคอุตสาหกรรม\nวิจัยและพัฒนาทางด้านวิศวกรรมศาสตร์ที่ตอบสนองความต้องการของประเทศและภูมิภาค\nบริการวิชาการ ปรับแปลง และถ่ายทอดเทคโนโลยี เพื่อส่งเสริมศักยภาพในการแข่งขันของภาคอุตสาหกรรมและบริการของประเทศและสร้างสรรค์คุณค่าแก่สังคม (10 มีนาคม 2563)"
        },
        "image": {
          "image_0": "__PUBLIC_URL__/service-sut/image/2_Institute/4-engi/05_chem/slide1.jpg",
          "image_1": "__PUBLIC_URL__/service-sut/image/2_Institute/4-engi/05_chem/slide2.jpg",
          "image_2": "__PUBLIC_URL__/service-sut/image/2_Institute/4-engi/05_chem/slide3.jpg"
        },
        "footer": {
          "image_0": "__PUBLIC_URL__/service-sut/image/2_Institute/4-engi/05_chem/foot1.jpg",
          "image_1": "__PUBLIC_URL__/service-sut/image/2_Institute/4-engi/05_chem/foot2.jpg",
          "image_2": "__PUBLIC_URL__/service-sut/image/2_Institute/4-engi/05_chem/foot3.jpg"
        },
        "icon": [
          {
            "id": "26",
            "courseID": "4",
            "branchID": "0",
            "detail": "ชื่อหลักสูตร",
            "image": "__PUBLIC_URL__/service-sut/image/icon/school-engi-01.svg"
          },
          {
            "id": "27",
            "courseID": "4",
            "branchID": "0",
            "detail": "ชื่อปริญญาบัตรและสาขา",
            "image": "__PUBLIC_URL__/service-sut/image/icon/school-engi-02.svg"
          },
          {
            "id": "28",
            "courseID": "4",
            "branchID": "0",
            "detail": "โครงสร้างหลักสูตร",
            "image": "__PUBLIC_URL__/service-sut/image/icon/school-engi-03.svg"
          },
          {
            "id": "29",
            "courseID": "4",
            "branchID": "0",
            "detail": "แผนการศึกษา",
            "image": "__PUBLIC_URL__/service-sut/image/icon/school-engi-04.svg"
          },
          {
            "id": "30",
            "courseID": "4",
            "branchID": "0",
            "detail": "อาจารย์ประจำหลักสูตร",
            "image": "__PUBLIC_URL__/service-sut/image/icon/school-engi-05.svg"
          },
          {
            "id": "31",
            "courseID": "4",
            "branchID": "0",
            "detail": "เป้าหมายการรับและ การสำเร็จการศึกษา",
            "image": "__PUBLIC_URL__/service-sut/image/icon/school-engi-06.svg"
          },
          {
            "id": "32",
            "courseID": "4",
            "branchID": "0",
            "detail": "ผลการรับและ สำเร็จการศึกษา",
            "image": "__PUBLIC_URL__/service-sut/image/icon/school-engi-07.svg"
          },
          {
            "id": "33",
            "courseID": "4",
            "branchID": "0",
            "detail": "เป้าหมายการได้งานทำ ของบัณฑิต",
            "image": "__PUBLIC_URL__/service-sut/image/icon/school-engi-08.svg"
          }
        ],
        "header": {
          "header_0": "ชื่อปริญญาและสาขา",
          "header_1": "วิสัยทัศน์",
          "header_2": "พันธกิจ",
          "header_3": "โครงสร้างหลักสูตร",
          "header_4": "แผนการศึกษา",
          "header_5": "ผลการรับและสำเร็จการศึกษา",
          "header_6": "เป้าหมายการรับและการสำเร็จการศึกษา",
          "header_7": "ผลการรับและสำเร็จการศึกษา",
          "header_8": "เป้าหมายการได้งานทำของบัณฑิต"
        },
        "visitor": 1259,
        "visitor_of_year": 415
      }
    },
    "mechanical-engineering": {
      "code": 200,
      "status": "Get data success",
      "data": {
        "information": {
          "id": "71",
          "courseID": "4",
          "titleTH": "สาขาวิชาวิศวกรรมเครื่องกล",
          "titleEN": "Mechanical Engineering",
          "slang": "mechanical-engineering",
          "nameTH": "หลักสูตรวิศวกรรมศาสตรบัณฑิต สาขาวิชาวิศวกรรมเครื่องกล",
          "nameEN": "Bachelor of Engineering Program in Mechanical Engineering",
          "nameDegreeTH": "วิศวกรรมศาสตรบัณฑิต (วิศวกรรมเครื่องกล)",
          "nameDegreeEN": "Bachelor of Engineering (Mechanical Engineering)",
          "vision": "การบริหารจัดการงานภาคอุตสาหกรรมต้องอาศัยความรู้แบบบูรณาการเพื่อประยุกต์ใช้ในการออกแบบและควบคุมระบบให้เป็นไปอย่างมาตรฐานและปลอดภัย ความรู้ด้านวิศวกรรมเครื่องกลซึ่งสอดคล้องกับปรัชญาดังกล่าวจึงเป็นที่ต้องการของตลาดแรงงานมากที่สุดสาขาหนึ่ง ตั้งแต่อดีตจนถึงปัจจุบัน วัตถุประสงค์ในการผลิตวิศวกรเครื่องกล เพื่อต้องการผู้ที่มีความรู้ในการออกแบบและผลิตอุปกรณ์ทางวิศวกรรม ระบบควบคุมอัตโนมัติ การติดตั้ง การใช้งาน ความปลอดภัย และการบำรุงรักษาเครื่องจักกล การประยุกต์ใช้เทคโนโลยีใหม่ๆ ในการออกแบบและผลิต บนพื้นฐานทางเศรษฐศาสตร์วิศวกรรม",
          "mission": "วัตถุประสงค์ของหลักสูตรวิศวกรรมศาสตรบัณฑิตสาขาวิชาวิศวกรรมเครื่องกลเพื่อต้องการพัฒนาให้นักศึกษา\n|1) มีความรู้อย่างพอเพียงที่จะนำไปใช้ประกอบวิชาชีพ ได้รับใบประกอบวิชาชีพ มีความก้าวหน้าในการทำงาน และสามารถเป็นผู้นำองค์กร\n|2) สามารถปฏิบัติงานได้ตามกรอบมาตรฐานและจรรยาบรรณวิชาชีพที่กำหนด\n|3) มีความรู้ในการดำเนินโครงการ\n|4) สามารถสื่อสาร และปรับตัวทำงานร่วมกับผู้อื่นได้อย่างมีประสิทธิภาพ ทั้งในสหสาขาวิชาชีพและในสังคมพหุวัฒนธรรม\n|5) เป็นผู้มีความรู้ร่วมสมัย สามารถพัฒนาตนเองได้อย่างต่อเนื่อง\n|6) เป็นผู้มีสามารถทำงานในภาคอุตสาหกรรมได้หลากหลายประเภท",
          "course_structure": "http://reg3.sut.ac.th/registrar/program_info_1.asp?f_cmd=2&acadyear=-1&levelid=1&programid=107070101640&facultyid=10700&programname=%C7%D4%C8%C7%A1%C3%C3%C1%E0%A4%C3%D7%E8%CD%A7%A1%C5%2D2564&facultyname=%CA%D3%B9%D1%A1%C7%D4%AA%D2%C7%D4%C8%C7%A1%C3%C3%C1%C8%D2%CA%B5%C3%EC&levelname=%BB%C3%D4%AD%AD%D2%B5%C3%D5",
          "study_plan": "http://reg3.sut.ac.th/registrar/studyplan_info1.asp?avs1024806187=48&acadyear=-1&levelid=1&programid=107070101640&facultyid=10700&programname=%C7%D4%C8%C7%A1%C3%C3%C1%E0%A4%C3%D7%E8%CD%A7%A1%C5%2D2564&facultyname=%CA%D3%B9%D1%A1%C7%D4%AA%D2%C7%D4%C8%C7%A1%C3%C3%C1%C8%D2%CA%B5%C3%EC&levelname=%BB%C3%D4%AD%AD%D2%B5%C3%D5",
          "teacher": "https://beta.sut.ac.th/ie-me/คณาจารย์-บุคลากร/คณาจารย์",
          "graduation_goals": "รอข้อมูลจากสำนัก",
          "graduation_results": "รอข้อมูลจากสำนัก",
          "employment_goals": "รอข้อมูลจากสำนัก",
          "image": "__PUBLIC_URL__/service-sut/image/2_Institute/4-engi/06_mecha/slide1.png,__PUBLIC_URL__/service-sut/image/2_Institute/4-engi/06_mecha/slide2.png,__PUBLIC_URL__/service-sut/image/2_Institute/4-engi/06_mecha/slide3.png,__PUBLIC_URL__/service-sut/image/2_Institute/4-engi/06_mecha/slide4.png",
          "footer": "__PUBLIC_URL__/service-sut/image/2_Institute/4-engi/06_mecha/foot1.png,__PUBLIC_URL__/service-sut/image/2_Institute/4-engi/06_mecha/foot2.png,__PUBLIC_URL__/service-sut/image/2_Institute/4-engi/06_mecha/foot3.png",
          "createAt": null,
          "updateAt": null,
          "year": "2025"
        },
        "vision": {
          "vision_0": "การบริหารจัดการงานภาคอุตสาหกรรมต้องอาศัยความรู้แบบบูรณาการเพื่อประยุกต์ใช้ในการออกแบบและควบคุมระบบให้เป็นไปอย่างมาตรฐานและปลอดภัย ความรู้ด้านวิศวกรรมเครื่องกลซึ่งสอดคล้องกับปรัชญาดังกล่าวจึงเป็นที่ต้องการของตลาดแรงงานมากที่สุดสาขาหนึ่ง ตั้งแต่อดีตจนถึงปัจจุบัน วัตถุประสงค์ในการผลิตวิศวกรเครื่องกล เพื่อต้องการผู้ที่มีความรู้ในการออกแบบและผลิตอุปกรณ์ทางวิศวกรรม ระบบควบคุมอัตโนมัติ การติดตั้ง การใช้งาน ความปลอดภัย และการบำรุงรักษาเครื่องจักกล การประยุกต์ใช้เทคโนโลยีใหม่ๆ ในการออกแบบและผลิต บนพื้นฐานทางเศรษฐศาสตร์วิศวกรรม"
        },
        "mission": {
          "mission_0": "วัตถุประสงค์ของหลักสูตรวิศวกรรมศาสตรบัณฑิตสาขาวิชาวิศวกรรมเครื่องกลเพื่อต้องการพัฒนาให้นักศึกษา\n",
          "mission_1": "1) มีความรู้อย่างพอเพียงที่จะนำไปใช้ประกอบวิชาชีพ ได้รับใบประกอบวิชาชีพ มีความก้าวหน้าในการทำงาน และสามารถเป็นผู้นำองค์กร\n",
          "mission_2": "2) สามารถปฏิบัติงานได้ตามกรอบมาตรฐานและจรรยาบรรณวิชาชีพที่กำหนด\n",
          "mission_3": "3) มีความรู้ในการดำเนินโครงการ\n",
          "mission_4": "4) สามารถสื่อสาร และปรับตัวทำงานร่วมกับผู้อื่นได้อย่างมีประสิทธิภาพ ทั้งในสหสาขาวิชาชีพและในสังคมพหุวัฒนธรรม\n",
          "mission_5": "5) เป็นผู้มีความรู้ร่วมสมัย สามารถพัฒนาตนเองได้อย่างต่อเนื่อง\n",
          "mission_6": "6) เป็นผู้มีสามารถทำงานในภาคอุตสาหกรรมได้หลากหลายประเภท"
        },
        "image": {
          "image_0": "__PUBLIC_URL__/service-sut/image/2_Institute/4-engi/06_mecha/slide1.png",
          "image_1": "__PUBLIC_URL__/service-sut/image/2_Institute/4-engi/06_mecha/slide2.png",
          "image_2": "__PUBLIC_URL__/service-sut/image/2_Institute/4-engi/06_mecha/slide3.png",
          "image_3": "__PUBLIC_URL__/service-sut/image/2_Institute/4-engi/06_mecha/slide4.png"
        },
        "footer": {
          "image_0": "__PUBLIC_URL__/service-sut/image/2_Institute/4-engi/06_mecha/foot1.png",
          "image_1": "__PUBLIC_URL__/service-sut/image/2_Institute/4-engi/06_mecha/foot2.png",
          "image_2": "__PUBLIC_URL__/service-sut/image/2_Institute/4-engi/06_mecha/foot3.png"
        },
        "icon": [
          {
            "id": "26",
            "courseID": "4",
            "branchID": "0",
            "detail": "ชื่อหลักสูตร",
            "image": "__PUBLIC_URL__/service-sut/image/icon/school-engi-01.svg"
          },
          {
            "id": "27",
            "courseID": "4",
            "branchID": "0",
            "detail": "ชื่อปริญญาบัตรและสาขา",
            "image": "__PUBLIC_URL__/service-sut/image/icon/school-engi-02.svg"
          },
          {
            "id": "28",
            "courseID": "4",
            "branchID": "0",
            "detail": "โครงสร้างหลักสูตร",
            "image": "__PUBLIC_URL__/service-sut/image/icon/school-engi-03.svg"
          },
          {
            "id": "29",
            "courseID": "4",
            "branchID": "0",
            "detail": "แผนการศึกษา",
            "image": "__PUBLIC_URL__/service-sut/image/icon/school-engi-04.svg"
          },
          {
            "id": "30",
            "courseID": "4",
            "branchID": "0",
            "detail": "อาจารย์ประจำหลักสูตร",
            "image": "__PUBLIC_URL__/service-sut/image/icon/school-engi-05.svg"
          },
          {
            "id": "31",
            "courseID": "4",
            "branchID": "0",
            "detail": "เป้าหมายการรับและ การสำเร็จการศึกษา",
            "image": "__PUBLIC_URL__/service-sut/image/icon/school-engi-06.svg"
          },
          {
            "id": "32",
            "courseID": "4",
            "branchID": "0",
            "detail": "ผลการรับและ สำเร็จการศึกษา",
            "image": "__PUBLIC_URL__/service-sut/image/icon/school-engi-07.svg"
          },
          {
            "id": "33",
            "courseID": "4",
            "branchID": "0",
            "detail": "เป้าหมายการได้งานทำ ของบัณฑิต",
            "image": "__PUBLIC_URL__/service-sut/image/icon/school-engi-08.svg"
          }
        ],
        "header": {
          "header_0": "ชื่อปริญญาและสาขา",
          "header_1": "วิสัยทัศน์",
          "header_2": "พันธกิจ",
          "header_3": "โครงสร้างหลักสูตร",
          "header_4": "แผนการศึกษา",
          "header_5": "ผลการรับและสำเร็จการศึกษา",
          "header_6": "เป้าหมายการรับและการสำเร็จการศึกษา",
          "header_7": "ผลการรับและสำเร็จการศึกษา",
          "header_8": "เป้าหมายการได้งานทำของบัณฑิต"
        },
        "visitor": 1615,
        "visitor_of_year": 362
      }
    },
    "ceramic-engineering": {
      "code": 200,
      "status": "Get data success",
      "data": {
        "information": {
          "id": "72",
          "courseID": "4",
          "titleTH": "สาขาวิชาวิศวกรรมเซรามิก",
          "titleEN": "Ceramic Engineering",
          "slang": "ceramic-engineering",
          "nameTH": "หลักสูตรวิศวกรรมศาสตรบัณฑิต สาขาวิชาวิศวกรรมเซรามิก",
          "nameEN": "Bachelor of Engineering Program in Ceramic Engineering",
          "nameDegreeTH": "วิศวกรรมศาสตรบัณฑิต (วิศวกรรมเซรามิก)",
          "nameDegreeEN": "Bachelor of Engineering (Ceramic Engineering)",
          "vision": "รอข้อมูลจากสำนัก",
          "mission": "รอข้อมูลจากสำนัก",
          "course_structure": "http://reg3.sut.ac.th/registrar/program_info_1.asp?f_cmd=2&acadyear=-1&levelid=1&programid=107080101650&facultyid=10700&programname=%C7%D4%C8%C7%A1%C3%C3%C1%E0%AB%C3%D2%C1%D4%A1%2D2565&facultyname=%CA%D3%B9%D1%A1%C7%D4%AA%D2%C7%D4%C8%C7%A1%C3%C3%C1%C8%D2%CA%B5%C3%EC&levelname=%BB%C3%D4%AD%AD%D2%B5%C3%D5",
          "study_plan": "http://reg3.sut.ac.th/registrar/studyplan_info1.asp?avs1024808493=4&acadyear=-1&levelid=1&programid=107080101650&facultyid=10700&programname=%C7%D4%C8%C7%A1%C3%C3%C1%E0%AB%C3%D2%C1%D4%A1%2D2565&facultyname=%CA%D3%B9%D1%A1%C7%D4%AA%D2%C7%D4%C8%C7%A1%C3%C3%C1%C8%D2%CA%B5%C3%EC&levelname=%BB%C3%D4%AD%AD%D2%B5%C3%D5",
          "teacher": "รอข้อมูลจากสำนัก",
          "graduation_goals": "รอข้อมูลจากสำนัก",
          "graduation_results": "รอข้อมูลจากสำนัก",
          "employment_goals": "รอข้อมูลจากสำนัก",
          "image": "__PUBLIC_URL__/service-sut/image/2_Institute/4-engi/07_ceramic/slide1.jpg,__PUBLIC_URL__/service-sut/image/2_Institute/4-engi/07_ceramic/slide2.jpg,__PUBLIC_URL__/service-sut/image/2_Institute/4-engi/07_ceramic/slide3.jpg",
          "footer": "__PUBLIC_URL__/service-sut/image/2_Institute/4-engi/07_ceramic/foot1.jpg,__PUBLIC_URL__/service-sut/image/2_Institute/4-engi/07_ceramic/foot2.jpg,__PUBLIC_URL__/service-sut/image/2_Institute/4-engi/07_ceramic/foot3.jpg",
          "createAt": null,
          "updateAt": null,
          "year": "2025"
        },
        "vision": {
          "vision_0": "รอข้อมูลจากสำนัก"
        },
        "mission": {
          "mission_0": "รอข้อมูลจากสำนัก"
        },
        "image": {
          "image_0": "__PUBLIC_URL__/service-sut/image/2_Institute/4-engi/07_ceramic/slide1.jpg",
          "image_1": "__PUBLIC_URL__/service-sut/image/2_Institute/4-engi/07_ceramic/slide2.jpg",
          "image_2": "__PUBLIC_URL__/service-sut/image/2_Institute/4-engi/07_ceramic/slide3.jpg"
        },
        "footer": {
          "image_0": "__PUBLIC_URL__/service-sut/image/2_Institute/4-engi/07_ceramic/foot1.jpg",
          "image_1": "__PUBLIC_URL__/service-sut/image/2_Institute/4-engi/07_ceramic/foot2.jpg",
          "image_2": "__PUBLIC_URL__/service-sut/image/2_Institute/4-engi/07_ceramic/foot3.jpg"
        },
        "icon": [
          {
            "id": "26",
            "courseID": "4",
            "branchID": "0",
            "detail": "ชื่อหลักสูตร",
            "image": "__PUBLIC_URL__/service-sut/image/icon/school-engi-01.svg"
          },
          {
            "id": "27",
            "courseID": "4",
            "branchID": "0",
            "detail": "ชื่อปริญญาบัตรและสาขา",
            "image": "__PUBLIC_URL__/service-sut/image/icon/school-engi-02.svg"
          },
          {
            "id": "28",
            "courseID": "4",
            "branchID": "0",
            "detail": "โครงสร้างหลักสูตร",
            "image": "__PUBLIC_URL__/service-sut/image/icon/school-engi-03.svg"
          },
          {
            "id": "29",
            "courseID": "4",
            "branchID": "0",
            "detail": "แผนการศึกษา",
            "image": "__PUBLIC_URL__/service-sut/image/icon/school-engi-04.svg"
          },
          {
            "id": "30",
            "courseID": "4",
            "branchID": "0",
            "detail": "อาจารย์ประจำหลักสูตร",
            "image": "__PUBLIC_URL__/service-sut/image/icon/school-engi-05.svg"
          },
          {
            "id": "31",
            "courseID": "4",
            "branchID": "0",
            "detail": "เป้าหมายการรับและ การสำเร็จการศึกษา",
            "image": "__PUBLIC_URL__/service-sut/image/icon/school-engi-06.svg"
          },
          {
            "id": "32",
            "courseID": "4",
            "branchID": "0",
            "detail": "ผลการรับและ สำเร็จการศึกษา",
            "image": "__PUBLIC_URL__/service-sut/image/icon/school-engi-07.svg"
          },
          {
            "id": "33",
            "courseID": "4",
            "branchID": "0",
            "detail": "เป้าหมายการได้งานทำ ของบัณฑิต",
            "image": "__PUBLIC_URL__/service-sut/image/icon/school-engi-08.svg"
          }
        ],
        "header": {
          "header_0": "ชื่อปริญญาและสาขา",
          "header_1": "วิสัยทัศน์",
          "header_2": "พันธกิจ",
          "header_3": "โครงสร้างหลักสูตร",
          "header_4": "แผนการศึกษา",
          "header_5": "ผลการรับและสำเร็จการศึกษา",
          "header_6": "เป้าหมายการรับและการสำเร็จการศึกษา",
          "header_7": "ผลการรับและสำเร็จการศึกษา",
          "header_8": "เป้าหมายการได้งานทำของบัณฑิต"
        },
        "visitor": 509,
        "visitor_of_year": 45
      }
    },
    "telecommunication-engineering": {
      "code": 200,
      "status": "Get data success",
      "data": {
        "information": {
          "id": "73",
          "courseID": "4",
          "titleTH": "สาขาวิชาวิศวกรรมโทรคมนาคม",
          "titleEN": "Telecommunication Engineering",
          "slang": "telecommunication-engineering",
          "nameTH": "หลักสูตรวิศวกรรมศาสตรบัณฑิต  สาขาวิชาวิศวกรรมโทรคมนาคม",
          "nameEN": "Bachelor of Engineering Program in Telecommunication Engineering",
          "nameDegreeTH": "วิศวกรรมศาสตรบัณฑิต (วิศวกรรมโทรคมนาคม)",
          "nameDegreeEN": "Bachelor of Engineering (Telecommunication Engineering)",
          "vision": "ผลิตวิศวกรโทรคมนาคม ที่มีคุณภาพ  มีความสามารถนำเทคโนโลยีมาใช้ได้อย่างเหมาะสม มีประสิทธิภาพและประสิทธิผล รวมทั้งสามารถพัฒนาเทคโนโลยีของตนเองได้อย่างยั่งยืน",
          "mission": "รอข้อมูลจากสำนัก",
          "course_structure": "http://reg3.sut.ac.th/registrar/program_info_1.asp?f_cmd=2&acadyear=-1&levelid=1&programid=107090101620&facultyid=10700&programname=%C7%D4%C8%C7%A1%C3%C3%C1%E2%B7%C3%A4%C1%B9%D2%A4%C1%2D2562&facultyname=%CA%D3%B9%D1%A1%C7%D4%AA%D2%C7%D4%C8%C7%A1%C3%C3%C1%C8%D2%CA%B5%C3%EC&levelname=%BB%C3%D4%AD%AD%D2%B5%C3%D5",
          "study_plan": "http://reg3.sut.ac.th/registrar/studyplan_info1.asp?avs1024808493=7&acadyear=-1&levelid=1&programid=107090101620&facultyid=10700&programname=%C7%D4%C8%C7%A1%C3%C3%C1%E2%B7%C3%A4%C1%B9%D2%A4%C1%2D2562&facultyname=%CA%D3%B9%D1%A1%C7%D4%AA%D2%C7%D4%C8%C7%A1%C3%C3%C1%C8%D2%CA%B5%C3%EC&levelname=%BB%C3%D4%AD%AD%D2%B5%C3%D5",
          "teacher": "https://beta.sut.ac.th/ie-tce/คณาจารย์-บุคลากร/คณาจารย์สาขาวิชา",
          "graduation_goals": "รอข้อมูลจากสำนัก",
          "graduation_results": "รอข้อมูลจากสำนัก",
          "employment_goals": "รอข้อมูลจากสำนัก",
          "image": "__PUBLIC_URL__/service-sut/image/2_Institute/4-engi/08_Tele/slide1.jpg,__PUBLIC_URL__/service-sut/image/2_Institute/4-engi/08_Tele/slide2.jpg,__PUBLIC_URL__/service-sut/image/2_Institute/4-engi/08_Tele/slide3.jpg",
          "footer": "__PUBLIC_URL__/service-sut/image/2_Institute/4-engi/08_Tele/foot1.jpg,__PUBLIC_URL__/service-sut/image/2_Institute/4-engi/08_Tele/foot2.jpg,__PUBLIC_URL__/service-sut/image/2_Institute/4-engi/08_Tele/foot3.jpg",
          "createAt": null,
          "updateAt": null,
          "year": "2025"
        },
        "vision": {
          "vision_0": "ผลิตวิศวกรโทรคมนาคม ที่มีคุณภาพ  มีความสามารถนำเทคโนโลยีมาใช้ได้อย่างเหมาะสม มีประสิทธิภาพและประสิทธิผล รวมทั้งสามารถพัฒนาเทคโนโลยีของตนเองได้อย่างยั่งยืน"
        },
        "mission": {
          "mission_0": "รอข้อมูลจากสำนัก"
        },
        "image": {
          "image_0": "__PUBLIC_URL__/service-sut/image/2_Institute/4-engi/08_Tele/slide1.jpg",
          "image_1": "__PUBLIC_URL__/service-sut/image/2_Institute/4-engi/08_Tele/slide2.jpg",
          "image_2": "__PUBLIC_URL__/service-sut/image/2_Institute/4-engi/08_Tele/slide3.jpg"
        },
        "footer": {
          "image_0": "__PUBLIC_URL__/service-sut/image/2_Institute/4-engi/08_Tele/foot1.jpg",
          "image_1": "__PUBLIC_URL__/service-sut/image/2_Institute/4-engi/08_Tele/foot2.jpg",
          "image_2": "__PUBLIC_URL__/service-sut/image/2_Institute/4-engi/08_Tele/foot3.jpg"
        },
        "icon": [
          {
            "id": "26",
            "courseID": "4",
            "branchID": "0",
            "detail": "ชื่อหลักสูตร",
            "image": "__PUBLIC_URL__/service-sut/image/icon/school-engi-01.svg"
          },
          {
            "id": "27",
            "courseID": "4",
            "branchID": "0",
            "detail": "ชื่อปริญญาบัตรและสาขา",
            "image": "__PUBLIC_URL__/service-sut/image/icon/school-engi-02.svg"
          },
          {
            "id": "28",
            "courseID": "4",
            "branchID": "0",
            "detail": "โครงสร้างหลักสูตร",
            "image": "__PUBLIC_URL__/service-sut/image/icon/school-engi-03.svg"
          },
          {
            "id": "29",
            "courseID": "4",
            "branchID": "0",
            "detail": "แผนการศึกษา",
            "image": "__PUBLIC_URL__/service-sut/image/icon/school-engi-04.svg"
          },
          {
            "id": "30",
            "courseID": "4",
            "branchID": "0",
            "detail": "อาจารย์ประจำหลักสูตร",
            "image": "__PUBLIC_URL__/service-sut/image/icon/school-engi-05.svg"
          },
          {
            "id": "31",
            "courseID": "4",
            "branchID": "0",
            "detail": "เป้าหมายการรับและ การสำเร็จการศึกษา",
            "image": "__PUBLIC_URL__/service-sut/image/icon/school-engi-06.svg"
          },
          {
            "id": "32",
            "courseID": "4",
            "branchID": "0",
            "detail": "ผลการรับและ สำเร็จการศึกษา",
            "image": "__PUBLIC_URL__/service-sut/image/icon/school-engi-07.svg"
          },
          {
            "id": "33",
            "courseID": "4",
            "branchID": "0",
            "detail": "เป้าหมายการได้งานทำ ของบัณฑิต",
            "image": "__PUBLIC_URL__/service-sut/image/icon/school-engi-08.svg"
          }
        ],
        "header": {
          "header_0": "ชื่อปริญญาและสาขา",
          "header_1": "วิสัยทัศน์",
          "header_2": "พันธกิจ",
          "header_3": "โครงสร้างหลักสูตร",
          "header_4": "แผนการศึกษา",
          "header_5": "ผลการรับและสำเร็จการศึกษา",
          "header_6": "เป้าหมายการรับและการสำเร็จการศึกษา",
          "header_7": "ผลการรับและสำเร็จการศึกษา",
          "header_8": "เป้าหมายการได้งานทำของบัณฑิต"
        },
        "visitor": 475,
        "visitor_of_year": 84
      }
    },
    "polymer-engineering": {
      "code": 200,
      "status": "Get data success",
      "data": {
        "information": {
          "id": "74",
          "courseID": "4",
          "titleTH": "สาขาวิชาวิศวกรรมพอลิเมอร์",
          "titleEN": "Polymer Engineering",
          "slang": "polymer-engineering",
          "nameTH": "หลักสูตรวิศวกรรมศาสตรบัณฑิต สาขาวิชาวิศวกรรมพอลิเมอร์",
          "nameEN": "Bachelor of Engineering Program in Polymer Engineering",
          "nameDegreeTH": "วิศวกรรมศาสตรบัณฑิต (วิศวกรรมพอลิเมอร์)",
          "nameDegreeEN": "Bachelor of Engineering (Polymer Engineering)",
          "vision": "มุ่งผลิตบัณฑิตที่มีความรู้ ความสามารถและคุณธรรมในการประกอบอาชีพด้านวิศวกรรมพอลิเมอร์",
          "mission": "ผลิตบัณฑิตที่ลักษณะพึงประสงค์ตามวิชาชีพ มีทักษะการคิดอย่างมีวิจารณญาณและการเรียนรู้ตลอดชีวิต (life-long learning)",
          "course_structure": "http://reg3.sut.ac.th/registrar/program_info_1.asp?f_cmd=2&acadyear=-1&levelid=1&programid=107100101640&facultyid=10700&programname=%C7%D4%C8%C7%A1%C3%C3%C1%BE%CD%C5%D4%E0%C1%CD%C3%EC%2D2564&facultyname=%CA%D3%B9%D1%A1%C7%D4%AA%D2%C7%D4%C8%C7%A1%C3%C3%C1%C8%D2%CA%B5%C3%EC&levelname=%BB%C3%D4%AD%AD%D2%B5%C3%D5",
          "study_plan": "http://reg3.sut.ac.th/registrar/studyplan_info1.asp?avs1024808493=10&acadyear=-1&levelid=1&programid=107100101640&facultyid=10700&programname=%C7%D4%C8%C7%A1%C3%C3%C1%BE%CD%C5%D4%E0%C1%CD%C3%EC%2D2564&facultyname=%CA%D3%B9%D1%A1%C7%D4%AA%D2%C7%D4%C8%C7%A1%C3%C3%C1%C8%D2%CA%B5%C3%EC&levelname=%BB%C3%D4%AD%AD%D2%B5%C3%D5",
          "teacher": "https://beta.sut.ac.th/ie-pe/คณาจารย์-บุคลากร/คณาจารย์",
          "graduation_goals": "รอข้อมูลจากสำนัก",
          "graduation_results": "รอข้อมูลจากสำนัก",
          "employment_goals": "รอข้อมูลจากสำนัก",
          "image": "__PUBLIC_URL__/service-sut/image/2_Institute/4-engi/09_polymer/slide1.jpg,__PUBLIC_URL__/service-sut/image/2_Institute/4-engi/09_polymer/slide2.jpg,__PUBLIC_URL__/service-sut/image/2_Institute/4-engi/09_polymer/slide3.jpg,__PUBLIC_URL__/service-sut/image/2_Institute/4-engi/09_polymer/slide4.jpg",
          "footer": "__PUBLIC_URL__/service-sut/image/2_Institute/4-engi/09_polymer/foot1.jpg,__PUBLIC_URL__/service-sut/image/2_Institute/4-engi/09_polymer/foot2.jpg,__PUBLIC_URL__/service-sut/image/2_Institute/4-engi/09_polymer/foot3.jpg",
          "createAt": null,
          "updateAt": null,
          "year": "2025"
        },
        "vision": {
          "vision_0": "มุ่งผลิตบัณฑิตที่มีความรู้ ความสามารถและคุณธรรมในการประกอบอาชีพด้านวิศวกรรมพอลิเมอร์"
        },
        "mission": {
          "mission_0": "ผลิตบัณฑิตที่ลักษณะพึงประสงค์ตามวิชาชีพ มีทักษะการคิดอย่างมีวิจารณญาณและการเรียนรู้ตลอดชีวิต (life-long learning)"
        },
        "image": {
          "image_0": "__PUBLIC_URL__/service-sut/image/2_Institute/4-engi/09_polymer/slide1.jpg",
          "image_1": "__PUBLIC_URL__/service-sut/image/2_Institute/4-engi/09_polymer/slide2.jpg",
          "image_2": "__PUBLIC_URL__/service-sut/image/2_Institute/4-engi/09_polymer/slide3.jpg",
          "image_3": "__PUBLIC_URL__/service-sut/image/2_Institute/4-engi/09_polymer/slide4.jpg"
        },
        "footer": {
          "image_0": "__PUBLIC_URL__/service-sut/image/2_Institute/4-engi/09_polymer/foot1.jpg",
          "image_1": "__PUBLIC_URL__/service-sut/image/2_Institute/4-engi/09_polymer/foot2.jpg",
          "image_2": "__PUBLIC_URL__/service-sut/image/2_Institute/4-engi/09_polymer/foot3.jpg"
        },
        "icon": [
          {
            "id": "26",
            "courseID": "4",
            "branchID": "0",
            "detail": "ชื่อหลักสูตร",
            "image": "__PUBLIC_URL__/service-sut/image/icon/school-engi-01.svg"
          },
          {
            "id": "27",
            "courseID": "4",
            "branchID": "0",
            "detail": "ชื่อปริญญาบัตรและสาขา",
            "image": "__PUBLIC_URL__/service-sut/image/icon/school-engi-02.svg"
          },
          {
            "id": "28",
            "courseID": "4",
            "branchID": "0",
            "detail": "โครงสร้างหลักสูตร",
            "image": "__PUBLIC_URL__/service-sut/image/icon/school-engi-03.svg"
          },
          {
            "id": "29",
            "courseID": "4",
            "branchID": "0",
            "detail": "แผนการศึกษา",
            "image": "__PUBLIC_URL__/service-sut/image/icon/school-engi-04.svg"
          },
          {
            "id": "30",
            "courseID": "4",
            "branchID": "0",
            "detail": "อาจารย์ประจำหลักสูตร",
            "image": "__PUBLIC_URL__/service-sut/image/icon/school-engi-05.svg"
          },
          {
            "id": "31",
            "courseID": "4",
            "branchID": "0",
            "detail": "เป้าหมายการรับและ การสำเร็จการศึกษา",
            "image": "__PUBLIC_URL__/service-sut/image/icon/school-engi-06.svg"
          },
          {
            "id": "32",
            "courseID": "4",
            "branchID": "0",
            "detail": "ผลการรับและ สำเร็จการศึกษา",
            "image": "__PUBLIC_URL__/service-sut/image/icon/school-engi-07.svg"
          },
          {
            "id": "33",
            "courseID": "4",
            "branchID": "0",
            "detail": "เป้าหมายการได้งานทำ ของบัณฑิต",
            "image": "__PUBLIC_URL__/service-sut/image/icon/school-engi-08.svg"
          }
        ],
        "header": {
          "header_0": "ชื่อปริญญาและสาขา",
          "header_1": "วิสัยทัศน์",
          "header_2": "พันธกิจ",
          "header_3": "โครงสร้างหลักสูตร",
          "header_4": "แผนการศึกษา",
          "header_5": "ผลการรับและสำเร็จการศึกษา",
          "header_6": "เป้าหมายการรับและการสำเร็จการศึกษา",
          "header_7": "ผลการรับและสำเร็จการศึกษา",
          "header_8": "เป้าหมายการได้งานทำของบัณฑิต"
        },
        "visitor": 164,
        "visitor_of_year": 43
      }
    },
    "polymer-engineering-inter": {
      "code": 200,
      "status": "Get data success",
      "data": {
        "information": {
          "id": "75",
          "courseID": "4",
          "titleTH": "วิศวกรรมปิโตรเคมีและพอลิเมอร์ (นานาชาติ)",
          "titleEN": "Polymer Engineering",
          "slang": "polymer-engineering-inter",
          "nameTH": "หลักสูตรวิศวกรรมศาสตรบัณฑิต สาขาวิชาวิศวกรรมปิโตรเคมีและพอลิเมอร์\n(หลักสูตรนานาชาติ)",
          "nameEN": "Bachelor of Engineering Program in Petrochemical and Polymer Engineering (International Program)",
          "nameDegreeTH": "วิศวกรรมศาสตรบัณฑิต (วิศวกรรมปิโตรเคมีและพอลิเมอร์)",
          "nameDegreeEN": "Bachelor of Engineering (Petrochemical and Polymer Engineering)",
          "vision": "มุ่งผลิตบัณฑิตที่มีความรู้ ความสามารถและคุณธรรมในการประกอบอาชีพด้านวิศวกรรมพอลิเมอร์",
          "mission": "ผลิตบัณฑิตที่ลักษณะพึงประสงค์ตามวิชาชีพ มีทักษะการคิดอย่างมีวิจารณญาณและการเรียนรู้ตลอดชีวิต (life-long learning)",
          "course_structure": "http://reg3.sut.ac.th/registrar/program_info_1.asp?f_cmd=2&acadyear=-1&levelid=1&programid=107440301650&facultyid=10700&programname=%C7%D4%C8%C7%A1%C3%C3%C1%BB%D4%E2%B5%C3%E0%A4%C1%D5%E1%C5%D0%BE%CD%C5%D4%E0%C1%CD%C3%EC%2D2565+%28%CB%C5%D1%A1%CA%D9%B5%C3%B9%D2%B9%D2%AA%D2%B5%D4%29&facultyname=%CA%D3%B9%D1%A1%C7%D4%AA%D2%C7%D4%C8%C7%A1%C3%C3%C1%C8%D2%CA%B5%C3%EC&levelname=%BB%C3%D4%AD%AD%D2%B5%C3%D5",
          "study_plan": "http://reg3.sut.ac.th/registrar/studyplan_info1.asp?avs1024808493=13&acadyear=-1&levelid=1&programid=107440301650&facultyid=10700&programname=%C7%D4%C8%C7%A1%C3%C3%C1%BB%D4%E2%B5%C3%E0%A4%C1%D5%E1%C5%D0%BE%CD%C5%D4%E0%C1%CD%C3%EC%2D2565+%28%CB%C5%D1%A1%CA%D9%B5%C3%B9%D2%B9%D2%AA%D2%B5%D4%29&facultyname=%CA%D3%B9%D1%A1%C7%D4%AA%D2%C7%D4%C8%C7%A1%C3%C3%C1%C8%D2%CA%B5%C3%EC&levelname=%BB%C3%D4%AD%AD%D2%B5%C3%D5",
          "teacher": "https://beta.sut.ac.th/ie-pe/คณาจารย์-บุคลากร/คณาจารย์",
          "graduation_goals": "รอข้อมูลจากสำนัก",
          "graduation_results": "รอข้อมูลจากสำนัก",
          "employment_goals": "รอข้อมูลจากสำนัก",
          "image": "__PUBLIC_URL__/service-sut/image/2_Institute/4-engi/10_polymer_inter/slide1.jpg,__PUBLIC_URL__/service-sut/image/2_Institute/4-engi/10_polymer_inter/slide2.jpg,__PUBLIC_URL__/service-sut/image/2_Institute/4-engi/10_polymer_inter/slide3.jpg",
          "footer": "__PUBLIC_URL__/service-sut/image/2_Institute/4-engi/10_polymer_inter/foot1.jpg,__PUBLIC_URL__/service-sut/image/2_Institute/4-engi/10_polymer_inter/foot2.jpg,__PUBLIC_URL__/service-sut/image/2_Institute/4-engi/10_polymer_inter/foot3.jpg",
          "createAt": null,
          "updateAt": null,
          "year": "2025"
        },
        "vision": {
          "vision_0": "มุ่งผลิตบัณฑิตที่มีความรู้ ความสามารถและคุณธรรมในการประกอบอาชีพด้านวิศวกรรมพอลิเมอร์"
        },
        "mission": {
          "mission_0": "ผลิตบัณฑิตที่ลักษณะพึงประสงค์ตามวิชาชีพ มีทักษะการคิดอย่างมีวิจารณญาณและการเรียนรู้ตลอดชีวิต (life-long learning)"
        },
        "image": {
          "image_0": "__PUBLIC_URL__/service-sut/image/2_Institute/4-engi/10_polymer_inter/slide1.jpg",
          "image_1": "__PUBLIC_URL__/service-sut/image/2_Institute/4-engi/10_polymer_inter/slide2.jpg",
          "image_2": "__PUBLIC_URL__/service-sut/image/2_Institute/4-engi/10_polymer_inter/slide3.jpg"
        },
        "footer": {
          "image_0": "__PUBLIC_URL__/service-sut/image/2_Institute/4-engi/10_polymer_inter/foot1.jpg",
          "image_1": "__PUBLIC_URL__/service-sut/image/2_Institute/4-engi/10_polymer_inter/foot2.jpg",
          "image_2": "__PUBLIC_URL__/service-sut/image/2_Institute/4-engi/10_polymer_inter/foot3.jpg"
        },
        "icon": [
          {
            "id": "26",
            "courseID": "4",
            "branchID": "0",
            "detail": "ชื่อหลักสูตร",
            "image": "__PUBLIC_URL__/service-sut/image/icon/school-engi-01.svg"
          },
          {
            "id": "27",
            "courseID": "4",
            "branchID": "0",
            "detail": "ชื่อปริญญาบัตรและสาขา",
            "image": "__PUBLIC_URL__/service-sut/image/icon/school-engi-02.svg"
          },
          {
            "id": "28",
            "courseID": "4",
            "branchID": "0",
            "detail": "โครงสร้างหลักสูตร",
            "image": "__PUBLIC_URL__/service-sut/image/icon/school-engi-03.svg"
          },
          {
            "id": "29",
            "courseID": "4",
            "branchID": "0",
            "detail": "แผนการศึกษา",
            "image": "__PUBLIC_URL__/service-sut/image/icon/school-engi-04.svg"
          },
          {
            "id": "30",
            "courseID": "4",
            "branchID": "0",
            "detail": "อาจารย์ประจำหลักสูตร",
            "image": "__PUBLIC_URL__/service-sut/image/icon/school-engi-05.svg"
          },
          {
            "id": "31",
            "courseID": "4",
            "branchID": "0",
            "detail": "เป้าหมายการรับและ การสำเร็จการศึกษา",
            "image": "__PUBLIC_URL__/service-sut/image/icon/school-engi-06.svg"
          },
          {
            "id": "32",
            "courseID": "4",
            "branchID": "0",
            "detail": "ผลการรับและ สำเร็จการศึกษา",
            "image": "__PUBLIC_URL__/service-sut/image/icon/school-engi-07.svg"
          },
          {
            "id": "33",
            "courseID": "4",
            "branchID": "0",
            "detail": "เป้าหมายการได้งานทำ ของบัณฑิต",
            "image": "__PUBLIC_URL__/service-sut/image/icon/school-engi-08.svg"
          }
        ],
        "header": {
          "header_0": "ชื่อปริญญาและสาขา",
          "header_1": "วิสัยทัศน์",
          "header_2": "พันธกิจ",
          "header_3": "โครงสร้างหลักสูตร",
          "header_4": "แผนการศึกษา",
          "header_5": "ผลการรับและสำเร็จการศึกษา",
          "header_6": "เป้าหมายการรับและการสำเร็จการศึกษา",
          "header_7": "ผลการรับและสำเร็จการศึกษา",
          "header_8": "เป้าหมายการได้งานทำของบัณฑิต"
        },
        "visitor": 811,
        "visitor_of_year": 76
      }
    },
    "electrical-engineering": {
      "code": 200,
      "status": "Get data success",
      "data": {
        "information": {
          "id": "76",
          "courseID": "4",
          "titleTH": "สาขาวิชาวิศวกรรมไฟฟ้า",
          "titleEN": "Electrical Engineering",
          "slang": "electrical-engineering",
          "nameTH": "หลักสูตรวิศวกรรมศาสตรบัณฑิต สาขาวิชาวิศวกรรมไฟฟ้า",
          "nameEN": "Bachelor of Engineering Program in Electrical Engineering",
          "nameDegreeTH": "วิศวกรรมศาสตรบัณฑิต (วิศวกรรมไฟฟ้า)",
          "nameDegreeEN": "Bachelor of Engineering (Electrical Engineering)",
          "vision": "มุ่งเป็นแหล่งผลิตบัณฑิตที่เป็นที่ยอมรับในระดับอาเซียน สร้างสรรค์งานวิจัยและนวัตกรรมในระดับสากล เป็นที่พึ่ง ทางวิชาการให้กับภาคอุตสาหกรรมและชุมชน",
          "mission": "ผลิตบัณฑิตด้านวิศวกรรมไฟฟ้า ที่มีคุณภาพ จรรยาบรรณ และความรับผิดชอบต่อ สังสม สร้างสรรค์งานวิจัยประยุกต์ และนวัตกรรมที่สอดคล้อง กับความต้องการของอุตสาหกรรมและชุมชน เพื่อปรับแปลง ถ่ายทอดเทคโนโลยี และบริการวิชาการแก่อุตสาหกรรมและ ชุมชนเพื่อการพัฒนาที่ยั่งยืน",
          "course_structure": "http://reg3.sut.ac.th/registrar/program_info_1.asp?f_cmd=2&acadyear=-1&levelid=1&programid=107110101640&facultyid=10700&programname=%C7%D4%C8%C7%A1%C3%C3%C1%E4%BF%BF%E9%D2%2D2564&facultyname=%CA%D3%B9%D1%A1%C7%D4%AA%D2%C7%D4%C8%C7%A1%C3%C3%C1%C8%D2%CA%B5%C3%EC&levelname=%BB%C3%D4%AD%AD%D2%B5%C3%D5",
          "study_plan": "http://reg3.sut.ac.th/registrar/studyplan_info1.asp?avs1024808493=16&acadyear=-1&levelid=1&programid=107110101640&facultyid=10700&programname=%C7%D4%C8%C7%A1%C3%C3%C1%E4%BF%BF%E9%D2%2D2564&facultyname=%CA%D3%B9%D1%A1%C7%D4%AA%D2%C7%D4%C8%C7%A1%C3%C3%C1%C8%D2%CA%B5%C3%EC&levelname=%BB%C3%D4%AD%AD%D2%B5%C3%D5",
          "teacher": "https://beta.sut.ac.th/ie-ee/คณาจารย์-บุคลากร",
          "graduation_goals": "รอข้อมูลจากสำนัก",
          "graduation_results": "รอข้อมูลจากสำนัก",
          "employment_goals": "รอข้อมูลจากสำนัก",
          "image": "__PUBLIC_URL__/service-sut/image/2_Institute/4-engi/11_elec/slide1.jpg",
          "footer": "__PUBLIC_URL__/service-sut/image/2_Institute/4-engi/11_elec/foot1.jpg,__PUBLIC_URL__/service-sut/image/2_Institute/4-engi/11_elec/foot2.jpg,__PUBLIC_URL__/service-sut/image/2_Institute/4-engi/11_elec/foot3.jpg",
          "createAt": null,
          "updateAt": null,
          "year": "2025"
        },
        "vision": {
          "vision_0": "มุ่งเป็นแหล่งผลิตบัณฑิตที่เป็นที่ยอมรับในระดับอาเซียน สร้างสรรค์งานวิจัยและนวัตกรรมในระดับสากล เป็นที่พึ่ง ทางวิชาการให้กับภาคอุตสาหกรรมและชุมชน"
        },
        "mission": {
          "mission_0": "ผลิตบัณฑิตด้านวิศวกรรมไฟฟ้า ที่มีคุณภาพ จรรยาบรรณ และความรับผิดชอบต่อ สังสม สร้างสรรค์งานวิจัยประยุกต์ และนวัตกรรมที่สอดคล้อง กับความต้องการของอุตสาหกรรมและชุมชน เพื่อปรับแปลง ถ่ายทอดเทคโนโลยี และบริการวิชาการแก่อุตสาหกรรมและ ชุมชนเพื่อการพัฒนาที่ยั่งยืน"
        },
        "image": {
          "image_0": "__PUBLIC_URL__/service-sut/image/2_Institute/4-engi/11_elec/slide1.jpg"
        },
        "footer": {
          "image_0": "__PUBLIC_URL__/service-sut/image/2_Institute/4-engi/11_elec/foot1.jpg",
          "image_1": "__PUBLIC_URL__/service-sut/image/2_Institute/4-engi/11_elec/foot2.jpg",
          "image_2": "__PUBLIC_URL__/service-sut/image/2_Institute/4-engi/11_elec/foot3.jpg"
        },
        "icon": [
          {
            "id": "26",
            "courseID": "4",
            "branchID": "0",
            "detail": "ชื่อหลักสูตร",
            "image": "__PUBLIC_URL__/service-sut/image/icon/school-engi-01.svg"
          },
          {
            "id": "27",
            "courseID": "4",
            "branchID": "0",
            "detail": "ชื่อปริญญาบัตรและสาขา",
            "image": "__PUBLIC_URL__/service-sut/image/icon/school-engi-02.svg"
          },
          {
            "id": "28",
            "courseID": "4",
            "branchID": "0",
            "detail": "โครงสร้างหลักสูตร",
            "image": "__PUBLIC_URL__/service-sut/image/icon/school-engi-03.svg"
          },
          {
            "id": "29",
            "courseID": "4",
            "branchID": "0",
            "detail": "แผนการศึกษา",
            "image": "__PUBLIC_URL__/service-sut/image/icon/school-engi-04.svg"
          },
          {
            "id": "30",
            "courseID": "4",
            "branchID": "0",
            "detail": "อาจารย์ประจำหลักสูตร",
            "image": "__PUBLIC_URL__/service-sut/image/icon/school-engi-05.svg"
          },
          {
            "id": "31",
            "courseID": "4",
            "branchID": "0",
            "detail": "เป้าหมายการรับและ การสำเร็จการศึกษา",
            "image": "__PUBLIC_URL__/service-sut/image/icon/school-engi-06.svg"
          },
          {
            "id": "32",
            "courseID": "4",
            "branchID": "0",
            "detail": "ผลการรับและ สำเร็จการศึกษา",
            "image": "__PUBLIC_URL__/service-sut/image/icon/school-engi-07.svg"
          },
          {
            "id": "33",
            "courseID": "4",
            "branchID": "0",
            "detail": "เป้าหมายการได้งานทำ ของบัณฑิต",
            "image": "__PUBLIC_URL__/service-sut/image/icon/school-engi-08.svg"
          }
        ],
        "header": {
          "header_0": "ชื่อปริญญาและสาขา",
          "header_1": "วิสัยทัศน์",
          "header_2": "พันธกิจ",
          "header_3": "โครงสร้างหลักสูตร",
          "header_4": "แผนการศึกษา",
          "header_5": "ผลการรับและสำเร็จการศึกษา",
          "header_6": "เป้าหมายการรับและการสำเร็จการศึกษา",
          "header_7": "ผลการรับและสำเร็จการศึกษา",
          "header_8": "เป้าหมายการได้งานทำของบัณฑิต"
        },
        "visitor": 1911,
        "visitor_of_year": 597
      }
    },
    "civil-engineering": {
      "code": 200,
      "status": "Get data success",
      "data": {
        "information": {
          "id": "77",
          "courseID": "4",
          "titleTH": "สาขาวิชาวิศวกรรมโยธา",
          "titleEN": "Civil Engineering",
          "slang": "civil-engineering",
          "nameTH": "หลักสูตรวิศวกรรมศาสตรบัณฑิต สาขาวิชาวิศวกรรมโยธา",
          "nameEN": "Bachelor of Engineering Program in Civil Engineering",
          "nameDegreeTH": "วิศวกรรมศาสตรบัณฑิต (วิศวกรรมโยธา)",
          "nameDegreeEN": "Bachelor of Engineering (Civil Engineering)",
          "vision": "สาขาวิชาวิศวกรรมโยธา เป็นเลิศทางวิชาการวิศวกรรมโยธา ด้านการสอน วิจัย และบริการวิชาการ",
          "mission": "สาขาวิชาวิศวกรรมโยธา ให้โอกาสการเรียนรู้แก่นักศึกษา จัดการศึกษาให้นักศึกษาได้ปฏิบัติ สร้างประสบการณ์และทัศนคติ ในการทำโครงการทางวิศวกรรมโยธาให้ประสบผลสำเร็จ ซึ่งต้องการการบูรณาการ ความรู้สหวิทยาการในวิศวกรรมโยธา เพื่อให้นักศึกษาสามารถแก้ปัญหาที่ซับซ้อนทางวิศวกรรมโยธาได้",
          "course_structure": "http://reg3.sut.ac.th/registrar/program_info_1.asp?f_cmd=2&acadyear=-1&levelid=1&programid=107120101620&facultyid=10700&programname=%C7%D4%C8%C7%A1%C3%C3%C1%E2%C2%B8%D2%2D2562&facultyname=%CA%D3%B9%D1%A1%C7%D4%AA%D2%C7%D4%C8%C7%A1%C3%C3%C1%C8%D2%CA%B5%C3%EC&levelname=%BB%C3%D4%AD%AD%D2%B5%C3%D5",
          "study_plan": "http://reg3.sut.ac.th/registrar/studyplan_info1.asp?avs1024808493=21&acadyear=-1&levelid=1&programid=107120101620&facultyid=10700&programname=%C7%D4%C8%C7%A1%C3%C3%C1%E2%C2%B8%D2%2D2562&facultyname=%CA%D3%B9%D1%A1%C7%D4%AA%D2%C7%D4%C8%C7%A1%C3%C3%C1%C8%D2%CA%B5%C3%EC&levelname=%BB%C3%D4%AD%AD%D2%B5%C3%D5",
          "teacher": "https://beta.sut.ac.th/ie-ce/คณาจารย์-บุคลากร/คณาจารย์",
          "graduation_goals": "รอข้อมูลจากสำนัก",
          "graduation_results": "รอข้อมูลจากสำนัก",
          "employment_goals": "รอข้อมูลจากสำนัก",
          "image": "__PUBLIC_URL__/service-sut/image/2_Institute/4-engi/12_civil/slide1.jpg",
          "footer": "__PUBLIC_URL__/service-sut/image/2_Institute/4-engi/12_civil/foot1.jpg,__PUBLIC_URL__/service-sut/image/2_Institute/4-engi/12_civil/foot2.jpg,__PUBLIC_URL__/service-sut/image/2_Institute/4-engi/12_civil/foot3.jpg",
          "createAt": null,
          "updateAt": null,
          "year": "2025"
        },
        "vision": {
          "vision_0": "สาขาวิชาวิศวกรรมโยธา เป็นเลิศทางวิชาการวิศวกรรมโยธา ด้านการสอน วิจัย และบริการวิชาการ"
        },
        "mission": {
          "mission_0": "สาขาวิชาวิศวกรรมโยธา ให้โอกาสการเรียนรู้แก่นักศึกษา จัดการศึกษาให้นักศึกษาได้ปฏิบัติ สร้างประสบการณ์และทัศนคติ ในการทำโครงการทางวิศวกรรมโยธาให้ประสบผลสำเร็จ ซึ่งต้องการการบูรณาการ ความรู้สหวิทยาการในวิศวกรรมโยธา เพื่อให้นักศึกษาสามารถแก้ปัญหาที่ซับซ้อนทางวิศวกรรมโยธาได้"
        },
        "image": {
          "image_0": "__PUBLIC_URL__/service-sut/image/2_Institute/4-engi/12_civil/slide1.jpg"
        },
        "footer": {
          "image_0": "__PUBLIC_URL__/service-sut/image/2_Institute/4-engi/12_civil/foot1.jpg",
          "image_1": "__PUBLIC_URL__/service-sut/image/2_Institute/4-engi/12_civil/foot2.jpg",
          "image_2": "__PUBLIC_URL__/service-sut/image/2_Institute/4-engi/12_civil/foot3.jpg"
        },
        "icon": [
          {
            "id": "26",
            "courseID": "4",
            "branchID": "0",
            "detail": "ชื่อหลักสูตร",
            "image": "__PUBLIC_URL__/service-sut/image/icon/school-engi-01.svg"
          },
          {
            "id": "27",
            "courseID": "4",
            "branchID": "0",
            "detail": "ชื่อปริญญาบัตรและสาขา",
            "image": "__PUBLIC_URL__/service-sut/image/icon/school-engi-02.svg"
          },
          {
            "id": "28",
            "courseID": "4",
            "branchID": "0",
            "detail": "โครงสร้างหลักสูตร",
            "image": "__PUBLIC_URL__/service-sut/image/icon/school-engi-03.svg"
          },
          {
            "id": "29",
            "courseID": "4",
            "branchID": "0",
            "detail": "แผนการศึกษา",
            "image": "__PUBLIC_URL__/service-sut/image/icon/school-engi-04.svg"
          },
          {
            "id": "30",
            "courseID": "4",
            "branchID": "0",
            "detail": "อาจารย์ประจำหลักสูตร",
            "image": "__PUBLIC_URL__/service-sut/image/icon/school-engi-05.svg"
          },
          {
            "id": "31",
            "courseID": "4",
            "branchID": "0",
            "detail": "เป้าหมายการรับและ การสำเร็จการศึกษา",
            "image": "__PUBLIC_URL__/service-sut/image/icon/school-engi-06.svg"
          },
          {
            "id": "32",
            "courseID": "4",
            "branchID": "0",
            "detail": "ผลการรับและ สำเร็จการศึกษา",
            "image": "__PUBLIC_URL__/service-sut/image/icon/school-engi-07.svg"
          },
          {
            "id": "33",
            "courseID": "4",
            "branchID": "0",
            "detail": "เป้าหมายการได้งานทำ ของบัณฑิต",
            "image": "__PUBLIC_URL__/service-sut/image/icon/school-engi-08.svg"
          }
        ],
        "header": {
          "header_0": "ชื่อปริญญาและสาขา",
          "header_1": "วิสัยทัศน์",
          "header_2": "พันธกิจ",
          "header_3": "โครงสร้างหลักสูตร",
          "header_4": "แผนการศึกษา",
          "header_5": "ผลการรับและสำเร็จการศึกษา",
          "header_6": "เป้าหมายการรับและการสำเร็จการศึกษา",
          "header_7": "ผลการรับและสำเร็จการศึกษา",
          "header_8": "เป้าหมายการได้งานทำของบัณฑิต"
        },
        "visitor": 1082,
        "visitor_of_year": 222
      }
    },
    "metallurgical-engineering": {
      "code": 200,
      "status": "Get data success",
      "data": {
        "information": {
          "id": "78",
          "courseID": "4",
          "titleTH": "สาขาวิชาวิศวกรรมโลหการ",
          "titleEN": "Metallurgical Engineering",
          "slang": "metallurgical-engineering",
          "nameTH": "หลักสูตรวิศวกรรมศาสตรบัณฑิต สาขาวิชาวิศวกรรมโลหการ",
          "nameEN": "Bachelor of Engineering Program in Metallurgical Engineering",
          "nameDegreeTH": "วิศวกรรมศาสตรบัณฑิต (วิศวกรรมโลหการ)",
          "nameDegreeEN": "Bachelor of Engineering (Metallurgical Engineering)",
          "vision": "สาขาวิชาวิศวกรรมโลหการเป็นแหล่งเรียนรู้ บริการวิชาการและวิจัยชั้นนำทางด้านวิศวกรรมโลหการ ในระดับประเทศ",
          "mission": "1. เป็นแหล่งเรียนรู้ ให้บริการด้านการสอน บ่มเพาะวิศวกรโลหการและนักวิจัยที่มีคุณภาพ พร้อมด้วยจรรยาบรรณวิชาชีพและความรับผิดชอบ\n|2. ให้บริการวิชาการและวิชาชีพแก่ภาคอุตสาหกรรม ส่งเสริมการพัฒนาสังคมและเศรษฐกิจของประเทศ\n|3. พัฒนางานวิจัยและนวัตกรรมในการขับเคลื่อนอุตสาหกรรมด้านโลหะเพื่อการพัฒนาประเทศอย่างยั่งยืน",
          "course_structure": "http://reg3.sut.ac.th/registrar/program_info_1.asp?f_cmd=2&acadyear=-1&levelid=1&programid=107130101650&facultyid=10700&programname=%C7%D4%C8%C7%A1%C3%C3%C1%E2%C5%CB%A1%D2%C3%2D2565&facultyname=%CA%D3%B9%D1%A1%C7%D4%AA%D2%C7%D4%C8%C7%A1%C3%C3%C1%C8%D2%CA%B5%C3%EC&levelname=%BB%C3%D4%AD%AD%D2%B5%C3%D5",
          "study_plan": "http://reg3.sut.ac.th/registrar/studyplan_info1.asp?avs1024808493=26&acadyear=-1&levelid=1&programid=107130101650&facultyid=10700&programname=%C7%D4%C8%C7%A1%C3%C3%C1%E2%C5%CB%A1%D2%C3%2D2565&facultyname=%CA%D3%B9%D1%A1%C7%D4%AA%D2%C7%D4%C8%C7%A1%C3%C3%C1%C8%D2%CA%B5%C3%EC&levelname=%BB%C3%D4%AD%AD%D2%B5%C3%D5",
          "teacher": "https://beta.sut.ac.th/ie-met/คณาจารย์-บุคลากร/คณาจารย์",
          "graduation_goals": "รอข้อมูลจากสำนัก",
          "graduation_results": "รอข้อมูลจากสำนัก",
          "employment_goals": "รอข้อมูลจากสำนัก",
          "image": "__PUBLIC_URL__/service-sut/image/2_Institute/4-engi/13_metall/slide1.jpg,__PUBLIC_URL__/service-sut/image/2_Institute/4-engi/13_metall/slide2.jpg,__PUBLIC_URL__/service-sut/image/2_Institute/4-engi/13_metall/slide3.jpg",
          "footer": "__PUBLIC_URL__/service-sut/image/2_Institute/4-engi/13_metall/foot1.jpg,__PUBLIC_URL__/service-sut/image/2_Institute/4-engi/13_metall/foot2.jpg,__PUBLIC_URL__/service-sut/image/2_Institute/4-engi/13_metall/foot3.jpg",
          "createAt": null,
          "updateAt": null,
          "year": "2025"
        },
        "vision": {
          "vision_0": "สาขาวิชาวิศวกรรมโลหการเป็นแหล่งเรียนรู้ บริการวิชาการและวิจัยชั้นนำทางด้านวิศวกรรมโลหการ ในระดับประเทศ"
        },
        "mission": {
          "mission_0": "1. เป็นแหล่งเรียนรู้ ให้บริการด้านการสอน บ่มเพาะวิศวกรโลหการและนักวิจัยที่มีคุณภาพ พร้อมด้วยจรรยาบรรณวิชาชีพและความรับผิดชอบ\n",
          "mission_1": "2. ให้บริการวิชาการและวิชาชีพแก่ภาคอุตสาหกรรม ส่งเสริมการพัฒนาสังคมและเศรษฐกิจของประเทศ\n",
          "mission_2": "3. พัฒนางานวิจัยและนวัตกรรมในการขับเคลื่อนอุตสาหกรรมด้านโลหะเพื่อการพัฒนาประเทศอย่างยั่งยืน"
        },
        "image": {
          "image_0": "__PUBLIC_URL__/service-sut/image/2_Institute/4-engi/13_metall/slide1.jpg",
          "image_1": "__PUBLIC_URL__/service-sut/image/2_Institute/4-engi/13_metall/slide2.jpg",
          "image_2": "__PUBLIC_URL__/service-sut/image/2_Institute/4-engi/13_metall/slide3.jpg"
        },
        "footer": {
          "image_0": "__PUBLIC_URL__/service-sut/image/2_Institute/4-engi/13_metall/foot1.jpg",
          "image_1": "__PUBLIC_URL__/service-sut/image/2_Institute/4-engi/13_metall/foot2.jpg",
          "image_2": "__PUBLIC_URL__/service-sut/image/2_Institute/4-engi/13_metall/foot3.jpg"
        },
        "icon": [
          {
            "id": "26",
            "courseID": "4",
            "branchID": "0",
            "detail": "ชื่อหลักสูตร",
            "image": "__PUBLIC_URL__/service-sut/image/icon/school-engi-01.svg"
          },
          {
            "id": "27",
            "courseID": "4",
            "branchID": "0",
            "detail": "ชื่อปริญญาบัตรและสาขา",
            "image": "__PUBLIC_URL__/service-sut/image/icon/school-engi-02.svg"
          },
          {
            "id": "28",
            "courseID": "4",
            "branchID": "0",
            "detail": "โครงสร้างหลักสูตร",
            "image": "__PUBLIC_URL__/service-sut/image/icon/school-engi-03.svg"
          },
          {
            "id": "29",
            "courseID": "4",
            "branchID": "0",
            "detail": "แผนการศึกษา",
            "image": "__PUBLIC_URL__/service-sut/image/icon/school-engi-04.svg"
          },
          {
            "id": "30",
            "courseID": "4",
            "branchID": "0",
            "detail": "อาจารย์ประจำหลักสูตร",
            "image": "__PUBLIC_URL__/service-sut/image/icon/school-engi-05.svg"
          },
          {
            "id": "31",
            "courseID": "4",
            "branchID": "0",
            "detail": "เป้าหมายการรับและ การสำเร็จการศึกษา",
            "image": "__PUBLIC_URL__/service-sut/image/icon/school-engi-06.svg"
          },
          {
            "id": "32",
            "courseID": "4",
            "branchID": "0",
            "detail": "ผลการรับและ สำเร็จการศึกษา",
            "image": "__PUBLIC_URL__/service-sut/image/icon/school-engi-07.svg"
          },
          {
            "id": "33",
            "courseID": "4",
            "branchID": "0",
            "detail": "เป้าหมายการได้งานทำ ของบัณฑิต",
            "image": "__PUBLIC_URL__/service-sut/image/icon/school-engi-08.svg"
          }
        ],
        "header": {
          "header_0": "ชื่อปริญญาและสาขา",
          "header_1": "วิสัยทัศน์",
          "header_2": "พันธกิจ",
          "header_3": "โครงสร้างหลักสูตร",
          "header_4": "แผนการศึกษา",
          "header_5": "ผลการรับและสำเร็จการศึกษา",
          "header_6": "เป้าหมายการรับและการสำเร็จการศึกษา",
          "header_7": "ผลการรับและสำเร็จการศึกษา",
          "header_8": "เป้าหมายการได้งานทำของบัณฑิต"
        },
        "visitor": 474,
        "visitor_of_year": 89
      }
    },
    "environmental-engineering": {
      "code": 200,
      "status": "Get data success",
      "data": {
        "information": {
          "id": "79",
          "courseID": "4",
          "titleTH": "สาขาวิชาวิศวกรรมสิ่งแวดล้อม",
          "titleEN": "Environmental Engineering",
          "slang": "environmental-engineering",
          "nameTH": "หลักสูตรวิศวกรรมศาสตรบัณฑิต สาขาวิชาวิศวกรรมสิ่งแวดล้อม",
          "nameEN": "Bachelor of Engineering Program in Environmental Engineering",
          "nameDegreeTH": "วิศวกรรมศาสตรบัณฑิต (วิศวกรรมสิ่งแวดล้อม)",
          "nameDegreeEN": "Bachelor of Engineering (Environmental Engineering)",
          "vision": "องค์กรที่โดดเด่นในการสร้างกำลังคนและความรู้ด้านวิศวกรรมศาสตร์ของประเทศ",
          "mission": "ผลิตและพัฒนากำลังคนระดับสูงทางด้านวิศวกรรมศาสตร์ เพื่อตอบสนองความต้องการของการพัฒนาประเทศ\n\n|วิจัยและค้นคว้าเพื่อสร้างสรรค์ จรรโลงความก้าวหน้าทางวิชาการ และการนำผลการวิจัยและพัฒนาไปใช้ในการพัฒนาประเทศ\n\n|ปรับแปลง ถ่ายทอด และพัฒนาเทคโนโลยีที่เหมาะสมเพื่อให้ประเทศไทยพึ่งพาตนเองทางเทคโนโลยีเพื่อการพัฒนาได้มากขึ้น\n\n|ให้บริการทางวิชาการแก่ประชาชนและหน่วยงานต่าง ๆ ทั้งภาครัฐและเอกชน\n\n|ทะนุบำรุงศิลปะและวัฒนธรรมของชาติและของท้องถิ่น โดยเฉพาะอย่างยิ่งศิลปะและวัฒนธรรมของภาคตะวันออกเฉียงเหนือ",
          "course_structure": "http://reg3.sut.ac.th/registrar/program_info_1.asp?f_cmd=2&acadyear=-1&levelid=1&programid=107150101640&facultyid=10700&programname=%C7%D4%C8%C7%A1%C3%C3%C1%CA%D4%E8%A7%E1%C7%B4%C5%E9%CD%C1%2D2564&facultyname=%CA%D3%B9%D1%A1%C7%D4%AA%D2%C7%D4%C8%C7%A1%C3%C3%C1%C8%D2%CA%B5%C3%EC&levelname=%BB%C3%D4%AD%AD%D2%B5%C3%D5",
          "study_plan": "http://reg3.sut.ac.th/registrar/studyplan_info1.asp?avs1024808493=31&acadyear=-1&levelid=1&programid=107150101640&facultyid=10700&programname=%C7%D4%C8%C7%A1%C3%C3%C1%CA%D4%E8%A7%E1%C7%B4%C5%E9%CD%C1%2D2564&facultyname=%CA%D3%B9%D1%A1%C7%D4%AA%D2%C7%D4%C8%C7%A1%C3%C3%C1%C8%D2%CA%B5%C3%EC&levelname=%BB%C3%D4%AD%AD%D2%B5%C3%D5",
          "teacher": "https://beta.sut.ac.th/ie-envi/คณาจารย์-บุคลากร/ผู้ช่วยสอนและวิจัย/คณาจารย์",
          "graduation_goals": "รอข้อมูลจากสำนัก",
          "graduation_results": "รอข้อมูลจากสำนัก",
          "employment_goals": "รอข้อมูลจากสำนัก",
          "image": "__PUBLIC_URL__/service-sut/image/2_Institute/4-engi/14_envi/slide1.jpg,__PUBLIC_URL__/service-sut/image/2_Institute/4-engi/14_envi/slide2.jpg,__PUBLIC_URL__/service-sut/image/2_Institute/4-engi/14_envi/slide3.jpg",
          "footer": "__PUBLIC_URL__/service-sut/image/2_Institute/4-engi/14_envi/foot1.jpg,__PUBLIC_URL__/service-sut/image/2_Institute/4-engi/14_envi/foot2.jpg,__PUBLIC_URL__/service-sut/image/2_Institute/4-engi/14_envi/foot3.jpg",
          "createAt": null,
          "updateAt": null,
          "year": "2025"
        },
        "vision": {
          "vision_0": "องค์กรที่โดดเด่นในการสร้างกำลังคนและความรู้ด้านวิศวกรรมศาสตร์ของประเทศ"
        },
        "mission": {
          "mission_0": "ผลิตและพัฒนากำลังคนระดับสูงทางด้านวิศวกรรมศาสตร์ เพื่อตอบสนองความต้องการของการพัฒนาประเทศ\n\n",
          "mission_1": "วิจัยและค้นคว้าเพื่อสร้างสรรค์ จรรโลงความก้าวหน้าทางวิชาการ และการนำผลการวิจัยและพัฒนาไปใช้ในการพัฒนาประเทศ\n\n",
          "mission_2": "ปรับแปลง ถ่ายทอด และพัฒนาเทคโนโลยีที่เหมาะสมเพื่อให้ประเทศไทยพึ่งพาตนเองทางเทคโนโลยีเพื่อการพัฒนาได้มากขึ้น\n\n",
          "mission_3": "ให้บริการทางวิชาการแก่ประชาชนและหน่วยงานต่าง ๆ ทั้งภาครัฐและเอกชน\n\n",
          "mission_4": "ทะนุบำรุงศิลปะและวัฒนธรรมของชาติและของท้องถิ่น โดยเฉพาะอย่างยิ่งศิลปะและวัฒนธรรมของภาคตะวันออกเฉียงเหนือ"
        },
        "image": {
          "image_0": "__PUBLIC_URL__/service-sut/image/2_Institute/4-engi/14_envi/slide1.jpg",
          "image_1": "__PUBLIC_URL__/service-sut/image/2_Institute/4-engi/14_envi/slide2.jpg",
          "image_2": "__PUBLIC_URL__/service-sut/image/2_Institute/4-engi/14_envi/slide3.jpg"
        },
        "footer": {
          "image_0": "__PUBLIC_URL__/service-sut/image/2_Institute/4-engi/14_envi/foot1.jpg",
          "image_1": "__PUBLIC_URL__/service-sut/image/2_Institute/4-engi/14_envi/foot2.jpg",
          "image_2": "__PUBLIC_URL__/service-sut/image/2_Institute/4-engi/14_envi/foot3.jpg"
        },
        "icon": [
          {
            "id": "26",
            "courseID": "4",
            "branchID": "0",
            "detail": "ชื่อหลักสูตร",
            "image": "__PUBLIC_URL__/service-sut/image/icon/school-engi-01.svg"
          },
          {
            "id": "27",
            "courseID": "4",
            "branchID": "0",
            "detail": "ชื่อปริญญาบัตรและสาขา",
            "image": "__PUBLIC_URL__/service-sut/image/icon/school-engi-02.svg"
          },
          {
            "id": "28",
            "courseID": "4",
            "branchID": "0",
            "detail": "โครงสร้างหลักสูตร",
            "image": "__PUBLIC_URL__/service-sut/image/icon/school-engi-03.svg"
          },
          {
            "id": "29",
            "courseID": "4",
            "branchID": "0",
            "detail": "แผนการศึกษา",
            "image": "__PUBLIC_URL__/service-sut/image/icon/school-engi-04.svg"
          },
          {
            "id": "30",
            "courseID": "4",
            "branchID": "0",
            "detail": "อาจารย์ประจำหลักสูตร",
            "image": "__PUBLIC_URL__/service-sut/image/icon/school-engi-05.svg"
          },
          {
            "id": "31",
            "courseID": "4",
            "branchID": "0",
            "detail": "เป้าหมายการรับและ การสำเร็จการศึกษา",
            "image": "__PUBLIC_URL__/service-sut/image/icon/school-engi-06.svg"
          },
          {
            "id": "32",
            "courseID": "4",
            "branchID": "0",
            "detail": "ผลการรับและ สำเร็จการศึกษา",
            "image": "__PUBLIC_URL__/service-sut/image/icon/school-engi-07.svg"
          },
          {
            "id": "33",
            "courseID": "4",
            "branchID": "0",
            "detail": "เป้าหมายการได้งานทำ ของบัณฑิต",
            "image": "__PUBLIC_URL__/service-sut/image/icon/school-engi-08.svg"
          }
        ],
        "header": {
          "header_0": "ชื่อปริญญาและสาขา",
          "header_1": "วิสัยทัศน์",
          "header_2": "พันธกิจ",
          "header_3": "โครงสร้างหลักสูตร",
          "header_4": "แผนการศึกษา",
          "header_5": "ผลการรับและสำเร็จการศึกษา",
          "header_6": "เป้าหมายการรับและการสำเร็จการศึกษา",
          "header_7": "ผลการรับและสำเร็จการศึกษา",
          "header_8": "เป้าหมายการได้งานทำของบัณฑิต"
        },
        "visitor": 780,
        "visitor_of_year": 132
      }
    },
    "industrial-engineering": {
      "code": 200,
      "status": "Get data success",
      "data": {
        "information": {
          "id": "80",
          "courseID": "4",
          "titleTH": "สาขาวิชาวิศวกรรมอุตสาหการ",
          "titleEN": "Industrial Engineering",
          "slang": "industrial-engineering",
          "nameTH": "หลักสูตรวิศวกรรมศาสตรบัณฑิต สาขาวิชาวิศวกรรมอุตสาหการ",
          "nameEN": "Bachelor of Engineering Program in Industrial Engineering",
          "nameDegreeTH": "หลักสูตรวิศวกรรมศาสตรบัณฑิต สาขาวิชาวิศวกรรมอุตสาหการ",
          "nameDegreeEN": "Bachelor of Engineering Program in Industrial Engineering",
          "vision": "มุ่งเป็นแหล่งผลิตบัณฑิตที่เป็นที่ยอมรับในระดับอาเซียน สร้างสรรค์งานวิจัยและนวัตกรรมในระดับสากล เป็นที่พึ่ง ทางวิชาการให้กับภาคอุตสาหกรรมและชุมชน",
          "mission": "ผลิตบัณฑิตด้านวิศวกรรมการผลิต และวิศวกรรมออกแบบ ผลิตภัณฑ์ที่มีคุณภาพ จรรยาบรรณ และความรับผิดชอบต่อ สังสม สร้างสรรค์งานวิจัยประยุกต์ และนวัตกรรมที่สอดคล้อง กับความต้องการของอุตสาหกรรมและชุมชน เพื่อปรับแปลง ถ่ายทอดเทคโนโลยี และบริการวิชาการแก่อุตสาหกรรมและ ชุมชนเพื่อการพัฒนาที่ยั่งยืน",
          "course_structure": "http://reg3.sut.ac.th/registrar/program_info_1.asp?f_cmd=2&acadyear=-1&levelid=1&programid=107170101620&facultyid=10700&programname=%C7%D4%C8%C7%A1%C3%C3%C1%CD%D8%B5%CA%D2%CB%A1%D2%C3%2D2562&facultyname=%CA%D3%B9%D1%A1%C7%D4%AA%D2%C7%D4%C8%C7%A1%C3%C3%C1%C8%D2%CA%B5%C3%EC&levelname=%BB%C3%D4%AD%AD%D2%B5%C3%D5",
          "study_plan": "http://reg3.sut.ac.th/registrar/studyplan_info1.asp?avs1024808493=36&acadyear=-1&levelid=1&programid=107170101620&facultyid=10700&programname=%C7%D4%C8%C7%A1%C3%C3%C1%CD%D8%B5%CA%D2%CB%A1%D2%C3%2D2562&facultyname=%CA%D3%B9%D1%A1%C7%D4%AA%D2%C7%D4%C8%C7%A1%C3%C3%C1%C8%D2%CA%B5%C3%EC&levelname=%BB%C3%D4%AD%AD%D2%B5%C3%D5",
          "teacher": "https://beta.sut.ac.th/ie-ie/คณาจารย์-บุคลากร/คณาจารย์",
          "graduation_goals": "รอข้อมูลจากสำนัก",
          "graduation_results": "รอข้อมูลจากสำนัก",
          "employment_goals": "รอข้อมูลจากสำนัก",
          "image": "__PUBLIC_URL__/service-sut/image/2_Institute/4-engi/15_indus/slide1.jpg,__PUBLIC_URL__/service-sut/image/2_Institute/4-engi/15_indus/slide2.jpg,__PUBLIC_URL__/service-sut/image/2_Institute/4-engi/15_indus/slide3.jpg",
          "footer": "__PUBLIC_URL__/service-sut/image/2_Institute/4-engi/15_indus/foot1.jpg,__PUBLIC_URL__/service-sut/image/2_Institute/4-engi/15_indus/foot2.jpg,__PUBLIC_URL__/service-sut/image/2_Institute/4-engi/15_indus/foot3.jpg",
          "createAt": null,
          "updateAt": null,
          "year": "2025"
        },
        "vision": {
          "vision_0": "มุ่งเป็นแหล่งผลิตบัณฑิตที่เป็นที่ยอมรับในระดับอาเซียน สร้างสรรค์งานวิจัยและนวัตกรรมในระดับสากล เป็นที่พึ่ง ทางวิชาการให้กับภาคอุตสาหกรรมและชุมชน"
        },
        "mission": {
          "mission_0": "ผลิตบัณฑิตด้านวิศวกรรมการผลิต และวิศวกรรมออกแบบ ผลิตภัณฑ์ที่มีคุณภาพ จรรยาบรรณ และความรับผิดชอบต่อ สังสม สร้างสรรค์งานวิจัยประยุกต์ และนวัตกรรมที่สอดคล้อง กับความต้องการของอุตสาหกรรมและชุมชน เพื่อปรับแปลง ถ่ายทอดเทคโนโลยี และบริการวิชาการแก่อุตสาหกรรมและ ชุมชนเพื่อการพัฒนาที่ยั่งยืน"
        },
        "image": {
          "image_0": "__PUBLIC_URL__/service-sut/image/2_Institute/4-engi/15_indus/slide1.jpg",
          "image_1": "__PUBLIC_URL__/service-sut/image/2_Institute/4-engi/15_indus/slide2.jpg",
          "image_2": "__PUBLIC_URL__/service-sut/image/2_Institute/4-engi/15_indus/slide3.jpg"
        },
        "footer": {
          "image_0": "__PUBLIC_URL__/service-sut/image/2_Institute/4-engi/15_indus/foot1.jpg",
          "image_1": "__PUBLIC_URL__/service-sut/image/2_Institute/4-engi/15_indus/foot2.jpg",
          "image_2": "__PUBLIC_URL__/service-sut/image/2_Institute/4-engi/15_indus/foot3.jpg"
        },
        "icon": [
          {
            "id": "26",
            "courseID": "4",
            "branchID": "0",
            "detail": "ชื่อหลักสูตร",
            "image": "__PUBLIC_URL__/service-sut/image/icon/school-engi-01.svg"
          },
          {
            "id": "27",
            "courseID": "4",
            "branchID": "0",
            "detail": "ชื่อปริญญาบัตรและสาขา",
            "image": "__PUBLIC_URL__/service-sut/image/icon/school-engi-02.svg"
          },
          {
            "id": "28",
            "courseID": "4",
            "branchID": "0",
            "detail": "โครงสร้างหลักสูตร",
            "image": "__PUBLIC_URL__/service-sut/image/icon/school-engi-03.svg"
          },
          {
            "id": "29",
            "courseID": "4",
            "branchID": "0",
            "detail": "แผนการศึกษา",
            "image": "__PUBLIC_URL__/service-sut/image/icon/school-engi-04.svg"
          },
          {
            "id": "30",
            "courseID": "4",
            "branchID": "0",
            "detail": "อาจารย์ประจำหลักสูตร",
            "image": "__PUBLIC_URL__/service-sut/image/icon/school-engi-05.svg"
          },
          {
            "id": "31",
            "courseID": "4",
            "branchID": "0",
            "detail": "เป้าหมายการรับและ การสำเร็จการศึกษา",
            "image": "__PUBLIC_URL__/service-sut/image/icon/school-engi-06.svg"
          },
          {
            "id": "32",
            "courseID": "4",
            "branchID": "0",
            "detail": "ผลการรับและ สำเร็จการศึกษา",
            "image": "__PUBLIC_URL__/service-sut/image/icon/school-engi-07.svg"
          },
          {
            "id": "33",
            "courseID": "4",
            "branchID": "0",
            "detail": "เป้าหมายการได้งานทำ ของบัณฑิต",
            "image": "__PUBLIC_URL__/service-sut/image/icon/school-engi-08.svg"
          }
        ],
        "header": {
          "header_0": "ชื่อปริญญาและสาขา",
          "header_1": "วิสัยทัศน์",
          "header_2": "พันธกิจ",
          "header_3": "โครงสร้างหลักสูตร",
          "header_4": "แผนการศึกษา",
          "header_5": "ผลการรับและสำเร็จการศึกษา",
          "header_6": "เป้าหมายการรับและการสำเร็จการศึกษา",
          "header_7": "ผลการรับและสำเร็จการศึกษา",
          "header_8": "เป้าหมายการได้งานทำของบัณฑิต"
        },
        "visitor": 723,
        "visitor_of_year": 135
      }
    },
    "geological-engineering": {
      "code": 200,
      "status": "Get data success",
      "data": {
        "information": {
          "id": "81",
          "courseID": "4",
          "titleTH": "สาขาวิชาเทคโนโลยีธรณี (หลักสูตรวิศวกรรมธรณี)",
          "titleEN": "Geotechnology (Geological Engineering)",
          "slang": "geological-engineering",
          "nameTH": "หลักสูตรวิศวกรรมศาสตรบัณฑิต สาขาวิชาวิศวกรรมธรณี",
          "nameEN": "Bachelor of Engineering Program in Geological Engineering",
          "nameDegreeTH": "วิศวกรรมศาสตรบัณฑิต (วิศวกรรมธรณี)",
          "nameDegreeEN": "Bachelor of Engineering (Geological Engineering)",
          "vision": "มหาวิทยาลัยเป็นสถาบันแห่งการเรียนรู้ทางด้านวิทยาศาสตร์และเทคโนโลยีชั้นเลิศ และเป็นที่พึ่งของสังคม",
          "mission": "ผลิตและพัฒนากำลังคนระดับสูงทางด้านวิทยาศาสตร์และเทคโนโลยี\nวิจัยและค้นคว้าเพื่อสร้างสรรค์จรรโลงความก้าวหน้าทางวิชาการ\nปรับแปลง ถ่ายทอด และพัฒนาเทคโนโลยีที่เหมาะสม\nให้บริการวิชาการแก่ประชาชนและหน่วยงานต่างๆ\nทำนุบำรุงศิลปวัฒนธรรมของชาติและของท้องถิ่น",
          "course_structure": "https://reg6.sut.ac.th/registrar/program_info_1.asp?f_cmd=2&acadyear=2564&levelid=1&programid=107310401640&facultyid=10700&programname=%C7%D4%C8%C7%A1%C3%C3%C1%B8%C3%B3%D5%2D2564+%28%CB%C5%D1%A1%CA%D9%B5%C3%CA%CB%C7%D4%B7%C2%D2%A1%D2%C3%29&facultyname=%CA%D3%B9%D1%A1%C7%D4%AA%D2%C7%D4%C8%C7%A1%C3%C3%C1%C8%D2%CA%B5%C3%EC&levelname=%BB%C3%D4%AD%AD%D2%B5%C3%D5",
          "study_plan": "https://reg6.sut.ac.th/registrar/studyplan_info1.asp?avs616954852=10&acadyear=2564&levelid=1&programid=107310401640&facultyid=10700&programname=%C7%D4%C8%C7%A1%C3%C3%C1%B8%C3%B3%D5%2D2564+%28%CB%C5%D1%A1%CA%D9%B5%C3%CA%CB%C7%D4%B7%C2%D2%A1%D2%C3%29&facultyname=%CA%D3%B9%D1%A1%C7%D4%AA%D2%C7%D4%C8%C7%A1%C3%C3%C1%C8%D2%CA%B5%C3%EC&levelname=%BB%C3%D4%AD%AD%D2%B5%C3%D5",
          "teacher": "https://www.geoengsut.com/faculty",
          "graduation_goals": "รอข้อมูลจากสำนัก",
          "graduation_results": "รอข้อมูลจากสำนัก",
          "employment_goals": "รอข้อมูลจากสำนัก",
          "image": "__PUBLIC_URL__/service-sut/image/2_Institute/4-engi/16_geo/slide1.jpg,__PUBLIC_URL__/service-sut/image/2_Institute/4-engi/16_geo/slide2.jpg,__PUBLIC_URL__/service-sut/image/2_Institute/4-engi/16_geo/slide3.jpg",
          "footer": "__PUBLIC_URL__/service-sut/image/2_Institute/4-engi/16_geo/foot1.jpg,__PUBLIC_URL__/service-sut/image/2_Institute/4-engi/16_geo/foot2.jpg,__PUBLIC_URL__/service-sut/image/2_Institute/4-engi/16_geo/foot3.jpg",
          "createAt": null,
          "updateAt": null,
          "year": "2025"
        },
        "vision": {
          "vision_0": "มหาวิทยาลัยเป็นสถาบันแห่งการเรียนรู้ทางด้านวิทยาศาสตร์และเทคโนโลยีชั้นเลิศ และเป็นที่พึ่งของสังคม"
        },
        "mission": {
          "mission_0": "ผลิตและพัฒนากำลังคนระดับสูงทางด้านวิทยาศาสตร์และเทคโนโลยี\nวิจัยและค้นคว้าเพื่อสร้างสรรค์จรรโลงความก้าวหน้าทางวิชาการ\nปรับแปลง ถ่ายทอด และพัฒนาเทคโนโลยีที่เหมาะสม\nให้บริการวิชาการแก่ประชาชนและหน่วยงานต่างๆ\nทำนุบำรุงศิลปวัฒนธรรมของชาติและของท้องถิ่น"
        },
        "image": {
          "image_0": "__PUBLIC_URL__/service-sut/image/2_Institute/4-engi/16_geo/slide1.jpg",
          "image_1": "__PUBLIC_URL__/service-sut/image/2_Institute/4-engi/16_geo/slide2.jpg",
          "image_2": "__PUBLIC_URL__/service-sut/image/2_Institute/4-engi/16_geo/slide3.jpg"
        },
        "footer": {
          "image_0": "__PUBLIC_URL__/service-sut/image/2_Institute/4-engi/16_geo/foot1.jpg",
          "image_1": "__PUBLIC_URL__/service-sut/image/2_Institute/4-engi/16_geo/foot2.jpg",
          "image_2": "__PUBLIC_URL__/service-sut/image/2_Institute/4-engi/16_geo/foot3.jpg"
        },
        "icon": [
          {
            "id": "26",
            "courseID": "4",
            "branchID": "0",
            "detail": "ชื่อหลักสูตร",
            "image": "__PUBLIC_URL__/service-sut/image/icon/school-engi-01.svg"
          },
          {
            "id": "27",
            "courseID": "4",
            "branchID": "0",
            "detail": "ชื่อปริญญาบัตรและสาขา",
            "image": "__PUBLIC_URL__/service-sut/image/icon/school-engi-02.svg"
          },
          {
            "id": "28",
            "courseID": "4",
            "branchID": "0",
            "detail": "โครงสร้างหลักสูตร",
            "image": "__PUBLIC_URL__/service-sut/image/icon/school-engi-03.svg"
          },
          {
            "id": "29",
            "courseID": "4",
            "branchID": "0",
            "detail": "แผนการศึกษา",
            "image": "__PUBLIC_URL__/service-sut/image/icon/school-engi-04.svg"
          },
          {
            "id": "30",
            "courseID": "4",
            "branchID": "0",
            "detail": "อาจารย์ประจำหลักสูตร",
            "image": "__PUBLIC_URL__/service-sut/image/icon/school-engi-05.svg"
          },
          {
            "id": "31",
            "courseID": "4",
            "branchID": "0",
            "detail": "เป้าหมายการรับและ การสำเร็จการศึกษา",
            "image": "__PUBLIC_URL__/service-sut/image/icon/school-engi-06.svg"
          },
          {
            "id": "32",
            "courseID": "4",
            "branchID": "0",
            "detail": "ผลการรับและ สำเร็จการศึกษา",
            "image": "__PUBLIC_URL__/service-sut/image/icon/school-engi-07.svg"
          },
          {
            "id": "33",
            "courseID": "4",
            "branchID": "0",
            "detail": "เป้าหมายการได้งานทำ ของบัณฑิต",
            "image": "__PUBLIC_URL__/service-sut/image/icon/school-engi-08.svg"
          }
        ],
        "header": {
          "header_0": "ชื่อปริญญาและสาขา",
          "header_1": "วิสัยทัศน์",
          "header_2": "พันธกิจ",
          "header_3": "โครงสร้างหลักสูตร",
          "header_4": "แผนการศึกษา",
          "header_5": "ผลการรับและสำเร็จการศึกษา",
          "header_6": "เป้าหมายการรับและการสำเร็จการศึกษา",
          "header_7": "ผลการรับและสำเร็จการศึกษา",
          "header_8": "เป้าหมายการได้งานทำของบัณฑิต"
        },
        "visitor": 394,
        "visitor_of_year": 78
      }
    },
    "geological-engineering-petro": {
      "code": 200,
      "status": "Get data success",
      "data": {
        "information": {
          "id": "82",
          "courseID": "4",
          "titleTH": "สาขาวิชาเทคโนโลยีธรณี (หลักสูตรปิโตรเลียมและเทคโนโลยีธรณี)",
          "titleEN": "Geotechnology (Petroleum Engineering and Geotechnology)",
          "slang": "geological-engineering-petro",
          "nameTH": "หลักสูตรวิศวกรรมศาสตรบัณฑิต สาขาวิชาวิศวกรรมปิโตรเลียมและเทคโนโลยีธรณี",
          "nameEN": "Bachelor of Engineering Program in Petroleum Engineering and Geotechnology",
          "nameDegreeTH": "วิศวกรรมศาสตรบัณฑิต (วิศวกรรมปิโตรเลียมและเทคโนโลยีธรณี)",
          "nameDegreeEN": "Bachelor of Engineering (Petroleum Engineering and Geotechnology)",
          "vision": "เป็นหลักสูตรวิศวกรรมปิโตรเลียมและเทคโนโลยีธรณีชั้นนําของอาเซียน",
          "mission": "1. ผลิตและพัฒนากําลังคนทางด้านวิศวกรรมปิโตรเลียมและเทคโนโลยีธรณีเพื่อให้สามารถเข้าสู่การแข่งขันในระดับนานาชาติสอดรับกับการเป็นสมาชิกประชาคมเศรษฐกิจอาเซียน (AEC) และเป็นผู้ขับเคลื่อนเศรษฐกิจในยุคประเทศไทย 4.0 ได้\n|2. พัฒนาบัณฑิตให้ปฏิบัติวิชาชีพด้วยความรับผิดชอบ มีวินัย คุณธรรม จริยธรรม ซื่อสัตย์สุจริต และเสียสละ ทําหน้าที่พลเมืองที่เข้มแข็ง\n|3. ส่งเสริมและพัฒนาบัณฑิตให้เป็นผู้มีทักษะในการเรียนรู้ตลอดชีพ สามารถเรียนรู้เทคโนโลยีใหม่เพื่อพัฒนาตนเองและเพื่อใช้ในการแก้ปัญหาจริงทั้งในเชิงวิศวกรรมและเชิงธุรกิจ มีความคิดริเริ่มในการประยุกต์และบูรณาการศาสตร์ต่าง ๆ เพื่อสร้างสรรค์เป็นนวัตกรรมได้",
          "course_structure": "https://reg3.sut.ac.th/registrar/program_info_1.asp?f_cmd=2&acadyear=2562&levelid=1&programid=107420401620&facultyid=10700&programname=%C7%D4%C8%C7%A1%C3%C3%C1%BB%D4%E2%B5%C3%E0%C5%D5%C2%C1%E1%C5%D0%E0%B7%A4%E2%B9%E2%C5%C2%D5%B8%C3%B3%D5%2D2562%28%CB%C5%D1%A1%CA%D9%B5%C3%CA%CB%C7%D4%B7%C2%D2%A1%D2%C3%29&facultyname=%CA%D3%B9%D1%A1%C7%D4%AA%D2%C7%D4%C8%C7%A1%C3%C3%C1%C8%D2%CA%B5%C3%EC&levelname=%BB%C3%D4%AD%AD%D2%B5%C3%D5",
          "study_plan": "https://reg3.sut.ac.th/registrar/studyplan_info1.asp?avs690504360=6&acadyear=2562&levelid=1&programid=107420401620&facultyid=10700&programname=%C7%D4%C8%C7%A1%C3%C3%C1%BB%D4%E2%B5%C3%E0%C5%D5%C2%C1%E1%C5%D0%E0%B7%A4%E2%B9%E2%C5%C2%D5%B8%C3%B3%D5%2D2562%28%CB%C5%D1%A1%CA%D9%B5%C3%CA%CB%C7%D4%B7%C2%D2%A1%D2%C3%29&facultyname=%CA%D3%B9%D1%A1%C7%D4%AA%D2%C7%D4%C8%C7%A1%C3%C3%C1%C8%D2%CA%B5%C3%EC&levelname=%BB%C3%D4%AD%AD%D2%B5%C3%D5",
          "teacher": "https://beta.sut.ac.th/%e0%b8%99%e0%b8%b1%e0%b8%81%e0%b8%a8%e0%b8%b6%e0%b8%81%e0%b8%a9%e0%b8%b2-%e0%b8%9a%e0%b8%b8%e0%b8%84%e0%b8%84%e0%b8%a5%e0%b8%b2%e0%b8%81%e0%b8%a3/%e0%b8%9a%e0%b8%b8%e0%b8%84%e0%b8%a5%e0%b8%b2%e0%b8%81%e0%b8%a3",
          "graduation_goals": "รอข้อมูลจากสำนัก",
          "graduation_results": "รอข้อมูลจากสำนัก",
          "employment_goals": "รอข้อมูลจากสำนัก",
          "image": "__PUBLIC_URL__/service-sut/image/2_Institute/4-engi/17_geopetro/slide1.jpg,__PUBLIC_URL__/service-sut/image/2_Institute/4-engi/17_geopetro/slide2.jpg,__PUBLIC_URL__/service-sut/image/2_Institute/4-engi/17_geopetro/slide3.jpg",
          "footer": "__PUBLIC_URL__/service-sut/image/2_Institute/4-engi/17_geopetro/foot1.jpg,__PUBLIC_URL__/service-sut/image/2_Institute/4-engi/17_geopetro/foot2.png,__PUBLIC_URL__/service-sut/image/2_Institute/4-engi/17_geopetro/foot3.jpg",
          "createAt": null,
          "updateAt": null,
          "year": "2025"
        },
        "vision": {
          "vision_0": "เป็นหลักสูตรวิศวกรรมปิโตรเลียมและเทคโนโลยีธรณีชั้นนําของอาเซียน"
        },
        "mission": {
          "mission_0": "1. ผลิตและพัฒนากําลังคนทางด้านวิศวกรรมปิโตรเลียมและเทคโนโลยีธรณีเพื่อให้สามารถเข้าสู่การแข่งขันในระดับนานาชาติสอดรับกับการเป็นสมาชิกประชาคมเศรษฐกิจอาเซียน (AEC) และเป็นผู้ขับเคลื่อนเศรษฐกิจในยุคประเทศไทย 4.0 ได้\n",
          "mission_1": "2. พัฒนาบัณฑิตให้ปฏิบัติวิชาชีพด้วยความรับผิดชอบ มีวินัย คุณธรรม จริยธรรม ซื่อสัตย์สุจริต และเสียสละ ทําหน้าที่พลเมืองที่เข้มแข็ง\n",
          "mission_2": "3. ส่งเสริมและพัฒนาบัณฑิตให้เป็นผู้มีทักษะในการเรียนรู้ตลอดชีพ สามารถเรียนรู้เทคโนโลยีใหม่เพื่อพัฒนาตนเองและเพื่อใช้ในการแก้ปัญหาจริงทั้งในเชิงวิศวกรรมและเชิงธุรกิจ มีความคิดริเริ่มในการประยุกต์และบูรณาการศาสตร์ต่าง ๆ เพื่อสร้างสรรค์เป็นนวัตกรรมได้"
        },
        "image": {
          "image_0": "__PUBLIC_URL__/service-sut/image/2_Institute/4-engi/17_geopetro/slide1.jpg",
          "image_1": "__PUBLIC_URL__/service-sut/image/2_Institute/4-engi/17_geopetro/slide2.jpg",
          "image_2": "__PUBLIC_URL__/service-sut/image/2_Institute/4-engi/17_geopetro/slide3.jpg"
        },
        "footer": {
          "image_0": "__PUBLIC_URL__/service-sut/image/2_Institute/4-engi/17_geopetro/foot1.jpg",
          "image_1": "__PUBLIC_URL__/service-sut/image/2_Institute/4-engi/17_geopetro/foot2.png",
          "image_2": "__PUBLIC_URL__/service-sut/image/2_Institute/4-engi/17_geopetro/foot3.jpg"
        },
        "icon": [
          {
            "id": "26",
            "courseID": "4",
            "branchID": "0",
            "detail": "ชื่อหลักสูตร",
            "image": "__PUBLIC_URL__/service-sut/image/icon/school-engi-01.svg"
          },
          {
            "id": "27",
            "courseID": "4",
            "branchID": "0",
            "detail": "ชื่อปริญญาบัตรและสาขา",
            "image": "__PUBLIC_URL__/service-sut/image/icon/school-engi-02.svg"
          },
          {
            "id": "28",
            "courseID": "4",
            "branchID": "0",
            "detail": "โครงสร้างหลักสูตร",
            "image": "__PUBLIC_URL__/service-sut/image/icon/school-engi-03.svg"
          },
          {
            "id": "29",
            "courseID": "4",
            "branchID": "0",
            "detail": "แผนการศึกษา",
            "image": "__PUBLIC_URL__/service-sut/image/icon/school-engi-04.svg"
          },
          {
            "id": "30",
            "courseID": "4",
            "branchID": "0",
            "detail": "อาจารย์ประจำหลักสูตร",
            "image": "__PUBLIC_URL__/service-sut/image/icon/school-engi-05.svg"
          },
          {
            "id": "31",
            "courseID": "4",
            "branchID": "0",
            "detail": "เป้าหมายการรับและ การสำเร็จการศึกษา",
            "image": "__PUBLIC_URL__/service-sut/image/icon/school-engi-06.svg"
          },
          {
            "id": "32",
            "courseID": "4",
            "branchID": "0",
            "detail": "ผลการรับและ สำเร็จการศึกษา",
            "image": "__PUBLIC_URL__/service-sut/image/icon/school-engi-07.svg"
          },
          {
            "id": "33",
            "courseID": "4",
            "branchID": "0",
            "detail": "เป้าหมายการได้งานทำ ของบัณฑิต",
            "image": "__PUBLIC_URL__/service-sut/image/icon/school-engi-08.svg"
          }
        ],
        "header": {
          "header_0": "ชื่อปริญญาและสาขา",
          "header_1": "วิสัยทัศน์",
          "header_2": "พันธกิจ",
          "header_3": "โครงสร้างหลักสูตร",
          "header_4": "แผนการศึกษา",
          "header_5": "ผลการรับและสำเร็จการศึกษา",
          "header_6": "เป้าหมายการรับและการสำเร็จการศึกษา",
          "header_7": "ผลการรับและสำเร็จการศึกษา",
          "header_8": "เป้าหมายการได้งานทำของบัณฑิต"
        },
        "visitor": 2791,
        "visitor_of_year": 140
      }
    },
    "electronic-engineering": {
      "code": 200,
      "status": "Get data success",
      "data": {
        "information": {
          "id": "83",
          "courseID": "4",
          "titleTH": "สาขาวิชาวิศวกรรมอิเล็กทรอนิกส์",
          "titleEN": "Electronic Engineering",
          "slang": "electronic-engineering",
          "nameTH": "หลักสูตรวิศวกรรมศาสตรบัณฑิต สาขาวิชาวิศวกรรมอิเล็กทรอนิกส์",
          "nameEN": "Bachelor of Engineering Program in Electronic Engineering",
          "nameDegreeTH": "วิศวกรรมศาสตรบัณฑิต (วิศวกรรมอิเล็กทรอนิกส์)",
          "nameDegreeEN": "Bachelor of Engineering (Electronic Engineering)",
          "vision": "วิศวกรอิเล็กทรอนิกส์จะเป็นผู้ที่มีความรู้เกี่ยวข้องกับการออกแบบและวิเคราะห์วงจรอิเล็กทรอนิกส์\nย่านความถี่ต่ำและควาถี่สูงรวมถึงการกำหนดการทำงานของวงจรไอซีรวมถึงระดับเกต\nนอกจากนี้ยังสามารถตรวจสอบและซ่อมแซมอุปกรณ์อิเล็กทรอนิกส์ทุกประเภท",
          "mission": "รอข้อมูลจากสำนัก",
          "course_structure": "http://reg3.sut.ac.th/registrar/program_info_1.asp?f_cmd=2&acadyear=-1&levelid=1&programid=107160101600&facultyid=10700&programname=%C7%D4%C8%C7%A1%C3%C3%C1%CD%D4%E0%C5%E7%A1%B7%C3%CD%B9%D4%A1%CA%EC%2D2560%282557%29&facultyname=%CA%D3%B9%D1%A1%C7%D4%AA%D2%C7%D4%C8%C7%A1%C3%C3%C1%C8%D2%CA%B5%C3%EC&levelname=%BB%C3%D4%AD%AD%D2%B5%C3%D5",
          "study_plan": "http://reg3.sut.ac.th/registrar/studyplan_info1.asp?avs1024808493=49&acadyear=-1&levelid=1&programid=107160101600&facultyid=10700&programname=%C7%D4%C8%C7%A1%C3%C3%C1%CD%D4%E0%C5%E7%A1%B7%C3%CD%B9%D4%A1%CA%EC%2D2560%282557%29&facultyname=%CA%D3%B9%D1%A1%C7%D4%AA%D2%C7%D4%C8%C7%A1%C3%C3%C1%C8%D2%CA%B5%C3%EC&levelname=%BB%C3%D4%AD%AD%D2%B5%C3%D5",
          "teacher": "https://beta.sut.ac.th/ie-elec/คณาจารย์",
          "graduation_goals": "รอข้อมูลจากสำนัก",
          "graduation_results": "รอข้อมูลจากสำนัก",
          "employment_goals": "รอข้อมูลจากสำนัก",
          "image": "__PUBLIC_URL__/service-sut/image/2_Institute/4-engi/18_elect/slide1.jpg,__PUBLIC_URL__/service-sut/image/2_Institute/4-engi/18_elect/slide2.jpg,__PUBLIC_URL__/service-sut/image/2_Institute/4-engi/18_elect/slide3.jpg",
          "footer": "__PUBLIC_URL__/service-sut/image/2_Institute/4-engi/18_elect/foot1.jpg,__PUBLIC_URL__/service-sut/image/2_Institute/4-engi/18_elect/foot2.jpg,__PUBLIC_URL__/service-sut/image/2_Institute/4-engi/18_elect/foot3.jpg",
          "createAt": null,
          "updateAt": null,
          "year": "2025"
        },
        "vision": {
          "vision_0": "วิศวกรอิเล็กทรอนิกส์จะเป็นผู้ที่มีความรู้เกี่ยวข้องกับการออกแบบและวิเคราะห์วงจรอิเล็กทรอนิกส์\nย่านความถี่ต่ำและควาถี่สูงรวมถึงการกำหนดการทำงานของวงจรไอซีรวมถึงระดับเกต\nนอกจากนี้ยังสามารถตรวจสอบและซ่อมแซมอุปกรณ์อิเล็กทรอนิกส์ทุกประเภท"
        },
        "mission": {
          "mission_0": "รอข้อมูลจากสำนัก"
        },
        "image": {
          "image_0": "__PUBLIC_URL__/service-sut/image/2_Institute/4-engi/18_elect/slide1.jpg",
          "image_1": "__PUBLIC_URL__/service-sut/image/2_Institute/4-engi/18_elect/slide2.jpg",
          "image_2": "__PUBLIC_URL__/service-sut/image/2_Institute/4-engi/18_elect/slide3.jpg"
        },
        "footer": {
          "image_0": "__PUBLIC_URL__/service-sut/image/2_Institute/4-engi/18_elect/foot1.jpg",
          "image_1": "__PUBLIC_URL__/service-sut/image/2_Institute/4-engi/18_elect/foot2.jpg",
          "image_2": "__PUBLIC_URL__/service-sut/image/2_Institute/4-engi/18_elect/foot3.jpg"
        },
        "icon": [
          {
            "id": "26",
            "courseID": "4",
            "branchID": "0",
            "detail": "ชื่อหลักสูตร",
            "image": "__PUBLIC_URL__/service-sut/image/icon/school-engi-01.svg"
          },
          {
            "id": "27",
            "courseID": "4",
            "branchID": "0",
            "detail": "ชื่อปริญญาบัตรและสาขา",
            "image": "__PUBLIC_URL__/service-sut/image/icon/school-engi-02.svg"
          },
          {
            "id": "28",
            "courseID": "4",
            "branchID": "0",
            "detail": "โครงสร้างหลักสูตร",
            "image": "__PUBLIC_URL__/service-sut/image/icon/school-engi-03.svg"
          },
          {
            "id": "29",
            "courseID": "4",
            "branchID": "0",
            "detail": "แผนการศึกษา",
            "image": "__PUBLIC_URL__/service-sut/image/icon/school-engi-04.svg"
          },
          {
            "id": "30",
            "courseID": "4",
            "branchID": "0",
            "detail": "อาจารย์ประจำหลักสูตร",
            "image": "__PUBLIC_URL__/service-sut/image/icon/school-engi-05.svg"
          },
          {
            "id": "31",
            "courseID": "4",
            "branchID": "0",
            "detail": "เป้าหมายการรับและ การสำเร็จการศึกษา",
            "image": "__PUBLIC_URL__/service-sut/image/icon/school-engi-06.svg"
          },
          {
            "id": "32",
            "courseID": "4",
            "branchID": "0",
            "detail": "ผลการรับและ สำเร็จการศึกษา",
            "image": "__PUBLIC_URL__/service-sut/image/icon/school-engi-07.svg"
          },
          {
            "id": "33",
            "courseID": "4",
            "branchID": "0",
            "detail": "เป้าหมายการได้งานทำ ของบัณฑิต",
            "image": "__PUBLIC_URL__/service-sut/image/icon/school-engi-08.svg"
          }
        ],
        "header": {
          "header_0": "ชื่อปริญญาและสาขา",
          "header_1": "วิสัยทัศน์",
          "header_2": "พันธกิจ",
          "header_3": "โครงสร้างหลักสูตร",
          "header_4": "แผนการศึกษา",
          "header_5": "ผลการรับและสำเร็จการศึกษา",
          "header_6": "เป้าหมายการรับและการสำเร็จการศึกษา",
          "header_7": "ผลการรับและสำเร็จการศึกษา",
          "header_8": "เป้าหมายการได้งานทำของบัณฑิต"
        },
        "visitor": 917,
        "visitor_of_year": 93
      }
    },
    "material-innovation-and-design-engineering": {
      "code": 200,
      "status": "Get data success",
      "data": {
        "information": {
          "id": "84",
          "courseID": "4",
          "titleTH": "สาขาวิชาเทคโนโลยีการออกแบบ",
          "titleEN": "Material Innovation and Design Engineering",
          "slang": "material-innovation-and-design-engineering",
          "nameTH": "หลักสูตรวิศวกรรมศาสตรบัณฑิต สาขาวิชาวิศวกรรมนวัตกรรมและการออกแบบวัสดุ",
          "nameEN": "Bachelor of Engineering Program in Material Innovation and Design Engineering",
          "nameDegreeTH": "วิศวกรรมศาสตรบัณฑิต (วิศวกรรมนวัตกรรมและการออกแบบวัสดุ)",
          "nameDegreeEN": "Bachelor of Engineering (Material Innovation and Design Engineering)",
          "vision": "เป็นองค์กรที่โดดเด่นในการสร้างกำลังคนและความรู้ด้านวิศวกรรมศาสตร์ของประเทศ",
          "mission": "(1) ผลิตและพัฒนากำลังคนทางด้านวิศวกรรมศาสตร์ที่มีความรู้และทักษะพร้อมในการทำงานภาคอุตสาหกรรม\n|(2) วิจัยและพัฒนาทางด้านวิศวกรรมศาสตร์ที่ตอบสนองความต้องการของประเทศและภูมิภาค\n|(3) บริการวิชาการ ปรับแปลง และถ่ายทอดเทคโนโลยี เพื่อส่งเสริมศักยภาพในการแข่งขันของภาคอุตสาหกรรมและบริการของประเทศและสร้างสรรค์คุณค่าแก่สังคม",
          "course_structure": "http://reg3.sut.ac.th/registrar/program_info_1.asp?f_cmd=2&acadyear=-1&levelid=1&programid=107430301600&facultyid=10700&programname=%C7%D4%C8%C7%A1%C3%C3%C1%B9%C7%D1%B5%A1%C3%C3%C1%E1%C5%D0%A1%D2%C3%CD%CD%A1%E1%BA%BA%C7%D1%CA%B4%D8%2D2560+%28%CB%C5%D1%A1%CA%D9%B5%C3%B9%D2%B9%D2%AA%D2%B5%D4%29&facultyname=%CA%D3%B9%D1%A1%C7%D4%AA%D2%C7%D4%C8%C7%A1%C3%C3%C1%C8%D2%CA%B5%C3%EC&levelname=%BB%C3%D4%AD%AD%D2%B5%C3%D5",
          "study_plan": "http://reg3.sut.ac.th/registrar/studyplan_info1.asp?avs1024808493=52&acadyear=-1&levelid=1&programid=107430301600&facultyid=10700&programname=%C7%D4%C8%C7%A1%C3%C3%C1%B9%C7%D1%B5%A1%C3%C3%C1%E1%C5%D0%A1%D2%C3%CD%CD%A1%E1%BA%BA%C7%D1%CA%B4%D8%2D2560+%28%CB%C5%D1%A1%CA%D9%B5%C3%B9%D2%B9%D2%AA%D2%B5%D4%29&facultyname=%CA%D3%B9%D1%A1%C7%D4%AA%D2%C7%D4%C8%C7%A1%C3%C3%C1%C8%D2%CA%B5%C3%EC&levelname=%BB%C3%D4%AD%AD%D2%B5%C3%D5",
          "teacher": "รอข้อมูลจากสำนัก",
          "graduation_goals": "รอข้อมูลจากสำนัก",
          "graduation_results": "รอข้อมูลจากสำนัก",
          "employment_goals": "รอข้อมูลจากสำนัก",
          "image": "",
          "footer": "",
          "createAt": null,
          "updateAt": null,
          "year": "2025"
        },
        "vision": {
          "vision_0": "เป็นองค์กรที่โดดเด่นในการสร้างกำลังคนและความรู้ด้านวิศวกรรมศาสตร์ของประเทศ"
        },
        "mission": {
          "mission_0": "(1) ผลิตและพัฒนากำลังคนทางด้านวิศวกรรมศาสตร์ที่มีความรู้และทักษะพร้อมในการทำงานภาคอุตสาหกรรม\n",
          "mission_1": "(2) วิจัยและพัฒนาทางด้านวิศวกรรมศาสตร์ที่ตอบสนองความต้องการของประเทศและภูมิภาค\n",
          "mission_2": "(3) บริการวิชาการ ปรับแปลง และถ่ายทอดเทคโนโลยี เพื่อส่งเสริมศักยภาพในการแข่งขันของภาคอุตสาหกรรมและบริการของประเทศและสร้างสรรค์คุณค่าแก่สังคม"
        },
        "icon": [
          {
            "id": "26",
            "courseID": "4",
            "branchID": "0",
            "detail": "ชื่อหลักสูตร",
            "image": "__PUBLIC_URL__/service-sut/image/icon/school-engi-01.svg"
          },
          {
            "id": "27",
            "courseID": "4",
            "branchID": "0",
            "detail": "ชื่อปริญญาบัตรและสาขา",
            "image": "__PUBLIC_URL__/service-sut/image/icon/school-engi-02.svg"
          },
          {
            "id": "28",
            "courseID": "4",
            "branchID": "0",
            "detail": "โครงสร้างหลักสูตร",
            "image": "__PUBLIC_URL__/service-sut/image/icon/school-engi-03.svg"
          },
          {
            "id": "29",
            "courseID": "4",
            "branchID": "0",
            "detail": "แผนการศึกษา",
            "image": "__PUBLIC_URL__/service-sut/image/icon/school-engi-04.svg"
          },
          {
            "id": "30",
            "courseID": "4",
            "branchID": "0",
            "detail": "อาจารย์ประจำหลักสูตร",
            "image": "__PUBLIC_URL__/service-sut/image/icon/school-engi-05.svg"
          },
          {
            "id": "31",
            "courseID": "4",
            "branchID": "0",
            "detail": "เป้าหมายการรับและ การสำเร็จการศึกษา",
            "image": "__PUBLIC_URL__/service-sut/image/icon/school-engi-06.svg"
          },
          {
            "id": "32",
            "courseID": "4",
            "branchID": "0",
            "detail": "ผลการรับและ สำเร็จการศึกษา",
            "image": "__PUBLIC_URL__/service-sut/image/icon/school-engi-07.svg"
          },
          {
            "id": "33",
            "courseID": "4",
            "branchID": "0",
            "detail": "เป้าหมายการได้งานทำ ของบัณฑิต",
            "image": "__PUBLIC_URL__/service-sut/image/icon/school-engi-08.svg"
          }
        ],
        "header": {
          "header_0": "ชื่อปริญญาและสาขา",
          "header_1": "วิสัยทัศน์",
          "header_2": "พันธกิจ",
          "header_3": "โครงสร้างหลักสูตร",
          "header_4": "แผนการศึกษา",
          "header_5": "ผลการรับและสำเร็จการศึกษา",
          "header_6": "เป้าหมายการรับและการสำเร็จการศึกษา",
          "header_7": "ผลการรับและสำเร็จการศึกษา",
          "header_8": "เป้าหมายการได้งานทำของบัณฑิต"
        },
        "visitor": 128,
        "visitor_of_year": 53
      }
    },
    "medicine": {
      "code": 200,
      "status": "Get data success",
      "data": {
        "information": {
          "id": "85",
          "courseID": "5",
          "titleTH": "แพทยศาสตรบัณฑิต",
          "titleEN": "Doctor of Medicine Program",
          "slang": "medicine",
          "nameTH": "แพทยศาสตรบัณฑิต",
          "nameEN": "Doctor of Medicine",
          "nameDegreeTH": "แพทยศาสตรบัณฑิต",
          "nameDegreeEN": "Doctor of Medicine",
          "vision": "เป็นโรงเรียนแพทย์ที่มุ่งมั่นพัฒนาการแพทย์\nของภูมิภาคและประเทศ\nสู่ระดับมาตรฐานสากล สร้างคุณค่าให้กับชุมชน",
          "mission": "1. ผลิตบัณฑิตที่มีคุณภาพสามารถเป็นผู้นำในการดูแลสุขภาพแบบองค์รวมในชุมชน\n|2. จัดให้มีการรักษาที่ รพ.มทส. ให้มีคุณภาพระดับสากล เพื่อเป็นแหล่งเรียนรู้และวิจัย\n|3. วิจัยและสร้างนวัตกรรมเน้นแก้ปัญหาในพื้นที่และชุมชน ผลงานมีมาตรฐานยอมรับในระดับชาติและนานาชาติ\n|4. การบริการวิชาการเพื่อส่งเสริมการศึกษาและสุขภาพของประชาชนในเขตสุขภาพ",
          "course_structure": "https://drive.google.com/file/d/13Oa0URa9sJ1AesHRosV5BaAwuRAlWTEJ/view?usp=sharing",
          "study_plan": "https://drive.google.com/file/d/1QNFLW4v5kD28RlhjaoJwQHg___E7fwfK/view?usp=sharing",
          "teacher": "https://drive.google.com/file/d/1wFlZmeuVh_s-mD88Okw0433hB7TGjFhf/view?usp=sharing",
          "graduation_goals": "รอข้อมูลจากสำนัก",
          "graduation_results": "รอข้อมูลจากสำนัก",
          "employment_goals": "รอข้อมูลจากสำนัก",
          "image": "__PUBLIC_URL__/service-sut/image/2_Institute/5-med/slide1.png",
          "footer": "__PUBLIC_URL__/service-sut/image/2_Institute/5-med/foot1.png,__PUBLIC_URL__/service-sut/image/2_Institute/5-med/foot2.png,__PUBLIC_URL__/service-sut/image/2_Institute/5-med/foot3.png",
          "createAt": null,
          "updateAt": null,
          "year": "2025"
        },
        "vision": {
          "vision_0": "เป็นโรงเรียนแพทย์ที่มุ่งมั่นพัฒนาการแพทย์\nของภูมิภาคและประเทศ\nสู่ระดับมาตรฐานสากล สร้างคุณค่าให้กับชุมชน"
        },
        "mission": {
          "mission_0": "1. ผลิตบัณฑิตที่มีคุณภาพสามารถเป็นผู้นำในการดูแลสุขภาพแบบองค์รวมในชุมชน\n",
          "mission_1": "2. จัดให้มีการรักษาที่ รพ.มทส. ให้มีคุณภาพระดับสากล เพื่อเป็นแหล่งเรียนรู้และวิจัย\n",
          "mission_2": "3. วิจัยและสร้างนวัตกรรมเน้นแก้ปัญหาในพื้นที่และชุมชน ผลงานมีมาตรฐานยอมรับในระดับชาติและนานาชาติ\n",
          "mission_3": "4. การบริการวิชาการเพื่อส่งเสริมการศึกษาและสุขภาพของประชาชนในเขตสุขภาพ"
        },
        "image": {
          "image_0": "__PUBLIC_URL__/service-sut/image/2_Institute/5-med/slide1.png"
        },
        "footer": {
          "image_0": "__PUBLIC_URL__/service-sut/image/2_Institute/5-med/foot1.png",
          "image_1": "__PUBLIC_URL__/service-sut/image/2_Institute/5-med/foot2.png",
          "image_2": "__PUBLIC_URL__/service-sut/image/2_Institute/5-med/foot3.png"
        },
        "icon": [
          {
            "id": "34",
            "courseID": "5",
            "branchID": "0",
            "detail": "ชื่อหลักสูตร",
            "image": "__PUBLIC_URL__/service-sut/image/icon/school-med-01.svg"
          },
          {
            "id": "35",
            "courseID": "5",
            "branchID": "0",
            "detail": "ชื่อปริญญาบัตรและสาขา",
            "image": "__PUBLIC_URL__/service-sut/image/icon/school-med-02.svg"
          },
          {
            "id": "36",
            "courseID": "5",
            "branchID": "0",
            "detail": "โครงสร้างหลักสูตร",
            "image": "__PUBLIC_URL__/service-sut/image/icon/school-med-03.svg"
          },
          {
            "id": "37",
            "courseID": "5",
            "branchID": "0",
            "detail": "แผนการศึกษา",
            "image": "__PUBLIC_URL__/service-sut/image/icon/school-med-04.svg"
          },
          {
            "id": "38",
            "courseID": "5",
            "branchID": "0",
            "detail": "อาจารย์ประจำหลักสูตร",
            "image": "__PUBLIC_URL__/service-sut/image/icon/school-med-05.svg"
          },
          {
            "id": "39",
            "courseID": "5",
            "branchID": "0",
            "detail": "เป้าหมายการรับและ การสำเร็จการศึกษา",
            "image": "__PUBLIC_URL__/service-sut/image/icon/school-med-06.svg"
          },
          {
            "id": "40",
            "courseID": "5",
            "branchID": "0",
            "detail": "ผลการรับและ สำเร็จการศึกษา",
            "image": "__PUBLIC_URL__/service-sut/image/icon/school-med-07.svg"
          },
          {
            "id": "41",
            "courseID": "5",
            "branchID": "0",
            "detail": "เป้าหมายการได้งานทำ ของบัณฑิต",
            "image": "__PUBLIC_URL__/service-sut/image/icon/school-med-08.svg"
          }
        ],
        "header": {
          "header_0": "ชื่อปริญญาและสาขา",
          "header_1": "วิสัยทัศน์",
          "header_2": "พันธกิจ",
          "header_3": "โครงสร้างหลักสูตร",
          "header_4": "แผนการศึกษา",
          "header_5": "ผลการรับและสำเร็จการศึกษา",
          "header_6": "เป้าหมายการรับและการสำเร็จการศึกษา",
          "header_7": "ผลการรับและสำเร็จการศึกษา",
          "header_8": "เป้าหมายการได้งานทำของบัณฑิต"
        },
        "visitor": 309,
        "visitor_of_year": 65
      }
    },
    "nursing-science-60": {
      "code": 200,
      "status": "Get data success",
      "data": {
        "information": {
          "id": "86",
          "courseID": "6",
          "titleTH": "พยาบาลศาสตรบัณฑิต หลักสูตรปรับปรุง 2560",
          "titleEN": "Nursing Science",
          "slang": "nursing-science-60",
          "nameTH": "หลักสูตรพยาบาลศาสตรบัณฑิต",
          "nameEN": "Bachelor of Nursing Science Program",
          "nameDegreeTH": "พยาบาลศาสตรบัณฑิต",
          "nameDegreeEN": "Bachelor of Nursing Science",
          "vision": "เป็นสถาบันแห่งการเรียนรู้ชั้นเลิศทางการพยาบาล  พัฒนาสุขภาพเพื่อสังคมที่พึ่งตนเองได้",
          "mission": "1. ผลิตบัณฑิตพยาบาลวิชาชีพเพื่อสนองความต้องการของประเทศและนานาชาติ\n|2. ผลิตผลงานวิจัย และนวัตกรรม เพื่อนำผลการวิจัยไปใช้ในการดูแลสุขภาพประชาชน\n|3. ปรับแปลง ถ่ายทอด และพัฒนานวัตกรรมในการจัดการสุขภาพ\n|4. ให้บริการวิชาการที่สอดคล้องกับความต้องของชุมชนและสร้างความเข้มแข็งเพื่อการพึ่งตนเองด้านสุขภาพของชุมชนและสังคม",
          "course_structure": "__PUBLIC_URL__/service-sut/image/nursing/pdf/%E0%B9%82%E0%B8%84%E0%B8%A3%E0%B8%87%E0%B8%AA%E0%B8%A3%E0%B9%89%E0%B8%B2%E0%B8%87%E0%B8%AB%E0%B8%A5%E0%B8%B1%E0%B8%81%E0%B8%AA%E0%B8%B9%E0%B8%95%E0%B8%A32560%202.pdf",
          "study_plan": "__PUBLIC_URL__/service-sut/image/nursing/pdf/%E0%B9%81%E0%B8%9C%E0%B8%99%E0%B8%81%E0%B8%B2%E0%B8%A3%E0%B8%A8%E0%B8%B6%E0%B8%81%E0%B8%A9%E0%B8%B22560%202.pdf",
          "teacher": "https://beta.sut.ac.th/in/employees/professor-employees",
          "graduation_goals": "รอข้อมูลจากสำนัก",
          "graduation_results": "รอข้อมูลจากสำนัก",
          "employment_goals": "รอข้อมูลจากสำนัก",
          "image": "__PUBLIC_URL__/service-sut/image/2_Institute/6-nurs/slide1.jpg,__PUBLIC_URL__/service-sut/image/2_Institute/6-nurs/slide2.jpg",
          "footer": "__PUBLIC_URL__/service-sut/image/2_Institute/6-nurs/foot1.jpg,__PUBLIC_URL__/service-sut/image/2_Institute/6-nurs/foot2.jpg,__PUBLIC_URL__/service-sut/image/2_Institute/6-nurs/foot3.jpg",
          "createAt": null,
          "updateAt": null,
          "year": "2025"
        },
        "vision": {
          "vision_0": "เป็นสถาบันแห่งการเรียนรู้ชั้นเลิศทางการพยาบาล  พัฒนาสุขภาพเพื่อสังคมที่พึ่งตนเองได้"
        },
        "mission": {
          "mission_0": "1. ผลิตบัณฑิตพยาบาลวิชาชีพเพื่อสนองความต้องการของประเทศและนานาชาติ\n",
          "mission_1": "2. ผลิตผลงานวิจัย และนวัตกรรม เพื่อนำผลการวิจัยไปใช้ในการดูแลสุขภาพประชาชน\n",
          "mission_2": "3. ปรับแปลง ถ่ายทอด และพัฒนานวัตกรรมในการจัดการสุขภาพ\n",
          "mission_3": "4. ให้บริการวิชาการที่สอดคล้องกับความต้องของชุมชนและสร้างความเข้มแข็งเพื่อการพึ่งตนเองด้านสุขภาพของชุมชนและสังคม"
        },
        "image": {
          "image_0": "__PUBLIC_URL__/service-sut/image/2_Institute/6-nurs/slide1.jpg",
          "image_1": "__PUBLIC_URL__/service-sut/image/2_Institute/6-nurs/slide2.jpg"
        },
        "footer": {
          "image_0": "__PUBLIC_URL__/service-sut/image/2_Institute/6-nurs/foot1.jpg",
          "image_1": "__PUBLIC_URL__/service-sut/image/2_Institute/6-nurs/foot2.jpg",
          "image_2": "__PUBLIC_URL__/service-sut/image/2_Institute/6-nurs/foot3.jpg"
        },
        "icon": [
          {
            "id": "42",
            "courseID": "6",
            "branchID": "0",
            "detail": "ชื่อหลักสูตร",
            "image": "__PUBLIC_URL__/service-sut/image/icon/school-nurs-01.svg"
          },
          {
            "id": "43",
            "courseID": "6",
            "branchID": "0",
            "detail": "ชื่อปริญญาบัตรและสาขา",
            "image": "__PUBLIC_URL__/service-sut/image/icon/school-nurs-02.svg"
          },
          {
            "id": "44",
            "courseID": "6",
            "branchID": "0",
            "detail": "โครงสร้างหลักสูตร",
            "image": "__PUBLIC_URL__/service-sut/image/icon/school-nurs-03.svg"
          },
          {
            "id": "45",
            "courseID": "6",
            "branchID": "0",
            "detail": "แผนการศึกษา",
            "image": "__PUBLIC_URL__/service-sut/image/icon/school-nurs-04.svg"
          },
          {
            "id": "46",
            "courseID": "6",
            "branchID": "0",
            "detail": "อาจารย์ประจำหลักสูตร",
            "image": "__PUBLIC_URL__/service-sut/image/icon/school-nurs-05.svg"
          },
          {
            "id": "47",
            "courseID": "6",
            "branchID": "0",
            "detail": "เป้าหมายการรับและ การสำเร็จการศึกษา",
            "image": "__PUBLIC_URL__/service-sut/image/icon/school-nurs-06.svg"
          },
          {
            "id": "48",
            "courseID": "6",
            "branchID": "0",
            "detail": "ผลการรับและ สำเร็จการศึกษา",
            "image": "__PUBLIC_URL__/service-sut/image/icon/school-nurs-07.svg"
          },
          {
            "id": "49",
            "courseID": "6",
            "branchID": "0",
            "detail": "เป้าหมายการได้งานทำ ของบัณฑิต",
            "image": "__PUBLIC_URL__/service-sut/image/icon/school-nurs-08.svg"
          }
        ],
        "header": {
          "header_0": "ชื่อปริญญาและสาขา",
          "header_1": "วิสัยทัศน์",
          "header_2": "พันธกิจ",
          "header_3": "โครงสร้างหลักสูตร",
          "header_4": "แผนการศึกษา",
          "header_5": "ผลการรับและสำเร็จการศึกษา",
          "header_6": "เป้าหมายการรับและการสำเร็จการศึกษา",
          "header_7": "ผลการรับและสำเร็จการศึกษา",
          "header_8": "เป้าหมายการได้งานทำของบัณฑิต"
        },
        "visitor": 158,
        "visitor_of_year": 59
      }
    },
    "doctor-of-dental-surgery": {
      "code": 200,
      "status": "Get data success",
      "data": {
        "information": {
          "id": "87",
          "courseID": "7",
          "titleTH": "ทันตแพทยศาสตรบัณฑิต",
          "titleEN": "Doctor of Dental Surgery",
          "slang": "doctor-of-dental-surgery",
          "nameTH": "ทันตแพทยศาสตรบัณฑิต",
          "nameEN": "Doctor of Dental Surgery",
          "nameDegreeTH": "ทันตแพทยศาสตรบัณฑิต (ท.บ.)",
          "nameDegreeEN": "Doctor of Dental Surgery (D.D.S.)",
          "vision": "สถาบันชั้นนำ ผลิตบุคลากรทันตสาธารณสุขที่มีคุณภาพ ด้วยการเติบโตอย่างยั่งยืน",
          "mission": "1. ผลิตบุคลากรทางด้านทันตสาธารณสุขที่มีคุณภาพตามมาตรฐานวิชาชีพและมหาวิทยาลัย\n|2. ผลิตผลงานวิจัยและนวัตกรรมที่เสนอความรู้ใหม่ และแนวทางแก้ปัญหาทางทันตสาธารณสุขในระดับชาติและนานาชาติ\n|3. การให้บริการวิชาการเพื่อตอบสนองความต้องการของสังคม\n|4. การให้บริการทางทันตกรรมที่ได้มาตรฐานและน้ำใจ\n",
          "course_structure": "https://drive.google.com/file/d/1WuROZTqkrAL0ycdaRoFjguIfB8P9Be5w/view",
          "study_plan": "https://beta.sut.ac.th/id/%e0%b8%99%e0%b8%b1%e0%b8%81%e0%b8%a8%e0%b8%b6%e0%b8%81%e0%b8%a9%e0%b8%b2/%e0%b9%81%e0%b8%9c%e0%b8%99%e0%b8%81%e0%b8%b2%e0%b8%a3%e0%b8%a8%e0%b8%b6%e0%b8%81%e0%b8%a9%e0%b8%b2",
          "teacher": "https://beta.sut.ac.th/id/about-us/%e0%b8%84%e0%b8%93%e0%b8%b2%e0%b8%88%e0%b8%b2%e0%b8%a3%e0%b8%a2%e0%b9%8c-%e0%b8%9a%e0%b8%b8%e0%b8%84%e0%b8%a5%e0%b8%b2%e0%b8%81%e0%b8%a3",
          "graduation_goals": "รอข้อมูลจากสำนัก",
          "graduation_results": "รอข้อมูลจากสำนัก",
          "employment_goals": "รอข้อมูลจากสำนัก",
          "image": "__PUBLIC_URL__/service-sut/image/2_Institute/7-dent/slide1.jpg,__PUBLIC_URL__/service-sut/image/2_Institute/7-dent/slide2.jpg,__PUBLIC_URL__/service-sut/image/2_Institute/7-dent/slide3.jpg,__PUBLIC_URL__/service-sut/image/2023/department-dentistry/doctor-of-dental-surgery/slide4.jpg.jpg",
          "footer": "__PUBLIC_URL__/service-sut/image/2023/department-dentistry/doctor-of-dental-surgery/foot1.png,__PUBLIC_URL__/service-sut/image/2023/department-dentistry/doctor-of-dental-surgery/foot2.png,__PUBLIC_URL__/service-sut/image/image-2023/department-dentistry/doctor-of-dental-surgery/foot3.png",
          "createAt": null,
          "updateAt": "2023-07-07 14:16:3",
          "year": "2025"
        },
        "vision": {
          "vision_0": "สถาบันชั้นนำ ผลิตบุคลากรทันตสาธารณสุขที่มีคุณภาพ ด้วยการเติบโตอย่างยั่งยืน"
        },
        "mission": {
          "mission_0": "1. ผลิตบุคลากรทางด้านทันตสาธารณสุขที่มีคุณภาพตามมาตรฐานวิชาชีพและมหาวิทยาลัย\n",
          "mission_1": "2. ผลิตผลงานวิจัยและนวัตกรรมที่เสนอความรู้ใหม่ และแนวทางแก้ปัญหาทางทันตสาธารณสุขในระดับชาติและนานาชาติ\n",
          "mission_2": "3. การให้บริการวิชาการเพื่อตอบสนองความต้องการของสังคม\n",
          "mission_3": "4. การให้บริการทางทันตกรรมที่ได้มาตรฐานและน้ำใจ\n"
        },
        "image": {
          "image_0": "__PUBLIC_URL__/service-sut/image/2_Institute/7-dent/slide1.jpg",
          "image_1": "__PUBLIC_URL__/service-sut/image/2_Institute/7-dent/slide2.jpg",
          "image_2": "__PUBLIC_URL__/service-sut/image/2_Institute/7-dent/slide3.jpg",
          "image_3": "__PUBLIC_URL__/service-sut/image/2023/department-dentistry/doctor-of-dental-surgery/slide4.jpg.jpg"
        },
        "footer": {
          "image_0": "__PUBLIC_URL__/service-sut/image/2023/department-dentistry/doctor-of-dental-surgery/foot1.png",
          "image_1": "__PUBLIC_URL__/service-sut/image/2023/department-dentistry/doctor-of-dental-surgery/foot2.png",
          "image_2": "__PUBLIC_URL__/service-sut/image/image-2023/department-dentistry/doctor-of-dental-surgery/foot3.png"
        },
        "icon": [
          {
            "id": "50",
            "courseID": "7",
            "branchID": "0",
            "detail": "ชื่อหลักสูตร",
            "image": "__PUBLIC_URL__/service-sut/image/icon/school-dent-01.svg"
          },
          {
            "id": "51",
            "courseID": "7",
            "branchID": "0",
            "detail": "ชื่อปริญญาบัตรและสาขา",
            "image": "__PUBLIC_URL__/service-sut/image/icon/school-dent-02.svg"
          },
          {
            "id": "52",
            "courseID": "7",
            "branchID": "0",
            "detail": "โครงสร้างหลักสูตร",
            "image": "__PUBLIC_URL__/service-sut/image/icon/school-dent-03.svg"
          },
          {
            "id": "53",
            "courseID": "7",
            "branchID": "0",
            "detail": "แผนการศึกษา",
            "image": "__PUBLIC_URL__/service-sut/image/icon/school-dent-04.svg"
          },
          {
            "id": "54",
            "courseID": "7",
            "branchID": "0",
            "detail": "อาจารย์ประจำหลักสูตร",
            "image": "__PUBLIC_URL__/service-sut/image/icon/school-dent-05.svg"
          },
          {
            "id": "55",
            "courseID": "7",
            "branchID": "0",
            "detail": "เป้าหมายการรับและ การสำเร็จการศึกษา",
            "image": "__PUBLIC_URL__/service-sut/image/icon/school-dent-06.svg"
          },
          {
            "id": "56",
            "courseID": "7",
            "branchID": "0",
            "detail": "ผลการรับและ สำเร็จการศึกษา",
            "image": "__PUBLIC_URL__/service-sut/image/icon/school-dent-07.svg"
          },
          {
            "id": "57",
            "courseID": "7",
            "branchID": "0",
            "detail": "เป้าหมายการได้งานทำ ของบัณฑิต",
            "image": "__PUBLIC_URL__/service-sut/image/icon/school-dent-08.svg"
          }
        ],
        "header": {
          "header_0": "ชื่อปริญญาและสาขา",
          "header_1": "วิสัยทัศน์",
          "header_2": "พันธกิจ",
          "header_3": "โครงสร้างหลักสูตร",
          "header_4": "แผนการศึกษา",
          "header_5": "ผลการรับและสำเร็จการศึกษา",
          "header_6": "เป้าหมายการรับและการสำเร็จการศึกษา",
          "header_7": "ผลการรับและสำเร็จการศึกษา",
          "header_8": "เป้าหมายการได้งานทำของบัณฑิต"
        },
        "visitor": 194,
        "visitor_of_year": 32
      }
    },
    "environmental-health": {
      "code": 200,
      "status": "Get data success",
      "data": {
        "information": {
          "id": "88",
          "courseID": "8",
          "titleTH": "สาขาวิชาอนามัยสิ่งแวดล้อม",
          "titleEN": "Environmental Health",
          "slang": "environmental-health",
          "nameTH": "หลักสูตรวิทยาศาสตรบัณฑิต สาขาวิชาอนามัยสิ่งแวดล้อม",
          "nameEN": "Bachelor of Science Program in Environmental Health",
          "nameDegreeTH": "วิทยาศาสตรบัณฑิต (อนามัยสิ่งแวดล้อม)",
          "nameDegreeEN": "Bachelor of Science (Environmental Health)",
          "vision": "เป็นสถาบันการศึกษาที่มุ่งเน้นสุขภาพ สิ่งแวดล้อม และความปลอดภัย เพื่อสังคมที่่ยั่งยืน (Higher Educational Institute on Health, Environment, and Safety Focused for Sustainable Society)",
          "mission": "ผลิตและพัฒนากำลังคนด้านสาธารณสุขศาสตร์ วิจัยและพัฒนาความรู้ และผลงานวิชาการ ด้านอนามัยสิ่งแวดล้อม และอาชีวอนามัยและความปลอดภัย ให้บริการวิชาการแก่ชุมชน เพื่อการพัฒนาที่ยั่งยืน",
          "course_structure": "https://reg4.sut.ac.th/registrar/program_info_1.asp?avs711423106=9&acadyear=-1&levelid=0&programid=110170101670&facultyid=11000&programname=%CD%B9%D2%C1%D1%C2%CA%D4%E8%A7%E1%C7%B4%C5%E9%CD%C1%2D2567&facultyname=%CA%D3%B9%D1%A1%C7%D4%AA%D2%CA%D2%B8%D2%C3%B3%CA%D8%A2%C8%D2%CA%B5%C3%EC&levelname=%BB%C3%D4%AD%AD%D2%B5%C3%D5",
          "study_plan": "https://reg4.sut.ac.th/registrar/studyplan_info1.asp?avs711423106=11&acadyear=-1&levelid=0&programid=110170101670&facultyid=11000&programname=%CD%B9%D2%C1%D1%C2%CA%D4%E8%A7%E1%C7%B4%C5%E9%CD%C1%2D2567&facultyname=%CA%D3%B9%D1%A1%C7%D4%AA%D2%CA%D2%B8%D2%C3%B3%CA%D8%A2%C8%D2%CA%B5%C3%EC&levelname=%BB%C3%D4%AD%AD%D2%B5%C3%D5",
          "teacher": "http://iph.sut.ac.th/personnel/envi-teacher/",
          "graduation_goals": "รอข้อมูลจากสำนัก",
          "graduation_results": "รอข้อมูลจากสำนัก",
          "employment_goals": "รอข้อมูลจากสำนัก",
          "image": "__PUBLIC_URL__/service-sut/image/2_Institute/8-pubh/01_envi/slide1.jpg",
          "footer": "__PUBLIC_URL__/service-sut/image/2023/department-public-health/environmental-health/footer1.png,__PUBLIC_URL__/service-sut/image/2023/department-public-health/environmental-health/footer2.png,__PUBLIC_URL__/service-sut/image/2023/department-public-health/environmental-health/footer3.png",
          "createAt": null,
          "updateAt": null,
          "year": "2025"
        },
        "vision": {
          "vision_0": "เป็นสถาบันการศึกษาที่มุ่งเน้นสุขภาพ สิ่งแวดล้อม และความปลอดภัย เพื่อสังคมที่่ยั่งยืน (Higher Educational Institute on Health, Environment, and Safety Focused for Sustainable Society)"
        },
        "mission": {
          "mission_0": "ผลิตและพัฒนากำลังคนด้านสาธารณสุขศาสตร์ วิจัยและพัฒนาความรู้ และผลงานวิชาการ ด้านอนามัยสิ่งแวดล้อม และอาชีวอนามัยและความปลอดภัย ให้บริการวิชาการแก่ชุมชน เพื่อการพัฒนาที่ยั่งยืน"
        },
        "image": {
          "image_0": "__PUBLIC_URL__/service-sut/image/2_Institute/8-pubh/01_envi/slide1.jpg"
        },
        "footer": {
          "image_0": "__PUBLIC_URL__/service-sut/image/2023/department-public-health/environmental-health/footer1.png",
          "image_1": "__PUBLIC_URL__/service-sut/image/2023/department-public-health/environmental-health/footer2.png",
          "image_2": "__PUBLIC_URL__/service-sut/image/2023/department-public-health/environmental-health/footer3.png"
        },
        "icon": [
          {
            "id": "58",
            "courseID": "8",
            "branchID": "0",
            "detail": "ชื่อหลักสูตร",
            "image": "__PUBLIC_URL__/service-sut/image/icon/school-pubh-01.svg"
          },
          {
            "id": "59",
            "courseID": "8",
            "branchID": "0",
            "detail": "ชื่อปริญญาบัตรและสาขา",
            "image": "__PUBLIC_URL__/service-sut/image/icon/school-pubh-02.svg"
          },
          {
            "id": "60",
            "courseID": "8",
            "branchID": "0",
            "detail": "โครงสร้างหลักสูตร",
            "image": "__PUBLIC_URL__/service-sut/image/icon/school-pubh-03.svg"
          },
          {
            "id": "61",
            "courseID": "8",
            "branchID": "0",
            "detail": "แผนการศึกษา",
            "image": "__PUBLIC_URL__/service-sut/image/icon/school-pubh-04.svg"
          },
          {
            "id": "62",
            "courseID": "8",
            "branchID": "0",
            "detail": "อาจารย์ประจำหลักสูตร",
            "image": "__PUBLIC_URL__/service-sut/image/icon/school-pubh-05.svg"
          },
          {
            "id": "63",
            "courseID": "8",
            "branchID": "0",
            "detail": "เป้าหมายการรับและ การสำเร็จการศึกษา",
            "image": "__PUBLIC_URL__/service-sut/image/icon/school-pubh-06.svg"
          },
          {
            "id": "64",
            "courseID": "8",
            "branchID": "0",
            "detail": "ผลการรับและ สำเร็จการศึกษา",
            "image": "__PUBLIC_URL__/service-sut/image/icon/school-pubh-07.svg"
          },
          {
            "id": "65",
            "courseID": "8",
            "branchID": "0",
            "detail": "เป้าหมายการได้งานทำ ของบัณฑิต",
            "image": "__PUBLIC_URL__/service-sut/image/icon/school-pubh-08.svg"
          }
        ],
        "header": {
          "header_0": "ชื่อปริญญาและสาขา",
          "header_1": "วิสัยทัศน์",
          "header_2": "พันธกิจ",
          "header_3": "โครงสร้างหลักสูตร",
          "header_4": "แผนการศึกษา",
          "header_5": "ผลการรับและสำเร็จการศึกษา",
          "header_6": "เป้าหมายการรับและการสำเร็จการศึกษา",
          "header_7": "ผลการรับและสำเร็จการศึกษา",
          "header_8": "เป้าหมายการได้งานทำของบัณฑิต"
        },
        "visitor": 652,
        "visitor_of_year": 68
      }
    },
    "occupational-health-and-safety": {
      "code": 200,
      "status": "Get data success",
      "data": {
        "information": {
          "id": "89",
          "courseID": "8",
          "titleTH": "สาขาวิชาอาชีวอนามัยและความปลอดภัย",
          "titleEN": "Occupational Health and Safety",
          "slang": "occupational-health-and-safety",
          "nameTH": "หลักสูตรวิทยาศาสตรบัณฑิต สาขาวิชาอาชีวอนามัยและความปลอดภัย",
          "nameEN": "Bachelor of Science Program in Occupational Health and Safety",
          "nameDegreeTH": "วิทยาศาสตรบัณฑิต (อาชีวอนามัยและความปลอดภัย)",
          "nameDegreeEN": "Bachelor of Science (Occupational Health and Safety)",
          "vision": "เป็นสถาบันการศึกษาที่มุ่งเน้นสุขภาพ สิ่งแวดล้อม และความปลอดภัย เพื่อสังคมที่่ยั่งยืน (Higher Educational Institute on Health, Environment, and Safety Focused for Sustainable Society)",
          "mission": "ผลิตและพัฒนากำลังคนด้านสาธารณสุขศาสตร์ วิจัยและพัฒนาความรู้ และผลงานวิชาการ ด้านอนามัยสิ่งแวดล้อม และอาชีวอนามัยและความปลอดภัย ให้บริการวิชาการแก่ชุมชน เพื่อการพัฒนาที่ยั่งยืน",
          "course_structure": "https://reg4.sut.ac.th/registrar/program_info_1.asp?f_cmd=2&acadyear=-1&levelid=0&programid=110160101670&facultyid=11000&programname=%CD%D2%AA%D5%C7%CD%B9%D2%C1%D1%C2%E1%C5%D0%A4%C7%D2%C1%BB%C5%CD%B4%C0%D1%C2%2D2567&facultyname=%CA%D3%B9%D1%A1%C7%D4%AA%D2%CA%D2%B8%D2%C3%B3%CA%D8%A2%C8%D2%CA%B5%C3%EC&levelname=%BB%C3%D4%AD%AD%D2%B5%C3%D5",
          "study_plan": "https://reg4.sut.ac.th/registrar/studyplan_info1.asp?avs711423106=14&acadyear=-1&levelid=0&programid=110160101670&facultyid=11000&programname=%CD%D2%AA%D5%C7%CD%B9%D2%C1%D1%C2%E1%C5%D0%A4%C7%D2%C1%BB%C5%CD%B4%C0%D1%C2%2D2567&facultyname=%CA%D3%B9%D1%A1%C7%D4%AA%D2%CA%D2%B8%D2%C3%B3%CA%D8%A2%C8%D2%CA%B5%C3%EC&levelname=%BB%C3%D4%AD%AD%D2%B5%C3%D5",
          "teacher": "http://iph.sut.ac.th/personnel/occ-teacher/",
          "graduation_goals": "รอข้อมูลจากสำนัก",
          "graduation_results": "รอข้อมูลจากสำนัก",
          "employment_goals": "รอข้อมูลจากสำนัก",
          "image": "__PUBLIC_URL__/service-sut/image/2025/08/branch/OCC%2001.jpg",
          "footer": "__PUBLIC_URL__/service-sut/image/2025/08/branch/OCC%20Foot%2001.jpg,__PUBLIC_URL__/service-sut/image/2025/08/branch/OCC%20Foot%2002.jpg,__PUBLIC_URL__/service-sut/image/2025/08/branch/OCC%20Foot%2003.jpg",
          "createAt": null,
          "updateAt": null,
          "year": "2025"
        },
        "vision": {
          "vision_0": "เป็นสถาบันการศึกษาที่มุ่งเน้นสุขภาพ สิ่งแวดล้อม และความปลอดภัย เพื่อสังคมที่่ยั่งยืน (Higher Educational Institute on Health, Environment, and Safety Focused for Sustainable Society)"
        },
        "mission": {
          "mission_0": "ผลิตและพัฒนากำลังคนด้านสาธารณสุขศาสตร์ วิจัยและพัฒนาความรู้ และผลงานวิชาการ ด้านอนามัยสิ่งแวดล้อม และอาชีวอนามัยและความปลอดภัย ให้บริการวิชาการแก่ชุมชน เพื่อการพัฒนาที่ยั่งยืน"
        },
        "image": {
          "image_0": "__PUBLIC_URL__/service-sut/image/2025/08/branch/OCC%2001.jpg"
        },
        "footer": {
          "image_0": "__PUBLIC_URL__/service-sut/image/2025/08/branch/OCC%20Foot%2001.jpg",
          "image_1": "__PUBLIC_URL__/service-sut/image/2025/08/branch/OCC%20Foot%2002.jpg",
          "image_2": "__PUBLIC_URL__/service-sut/image/2025/08/branch/OCC%20Foot%2003.jpg"
        },
        "icon": [
          {
            "id": "58",
            "courseID": "8",
            "branchID": "0",
            "detail": "ชื่อหลักสูตร",
            "image": "__PUBLIC_URL__/service-sut/image/icon/school-pubh-01.svg"
          },
          {
            "id": "59",
            "courseID": "8",
            "branchID": "0",
            "detail": "ชื่อปริญญาบัตรและสาขา",
            "image": "__PUBLIC_URL__/service-sut/image/icon/school-pubh-02.svg"
          },
          {
            "id": "60",
            "courseID": "8",
            "branchID": "0",
            "detail": "โครงสร้างหลักสูตร",
            "image": "__PUBLIC_URL__/service-sut/image/icon/school-pubh-03.svg"
          },
          {
            "id": "61",
            "courseID": "8",
            "branchID": "0",
            "detail": "แผนการศึกษา",
            "image": "__PUBLIC_URL__/service-sut/image/icon/school-pubh-04.svg"
          },
          {
            "id": "62",
            "courseID": "8",
            "branchID": "0",
            "detail": "อาจารย์ประจำหลักสูตร",
            "image": "__PUBLIC_URL__/service-sut/image/icon/school-pubh-05.svg"
          },
          {
            "id": "63",
            "courseID": "8",
            "branchID": "0",
            "detail": "เป้าหมายการรับและ การสำเร็จการศึกษา",
            "image": "__PUBLIC_URL__/service-sut/image/icon/school-pubh-06.svg"
          },
          {
            "id": "64",
            "courseID": "8",
            "branchID": "0",
            "detail": "ผลการรับและ สำเร็จการศึกษา",
            "image": "__PUBLIC_URL__/service-sut/image/icon/school-pubh-07.svg"
          },
          {
            "id": "65",
            "courseID": "8",
            "branchID": "0",
            "detail": "เป้าหมายการได้งานทำ ของบัณฑิต",
            "image": "__PUBLIC_URL__/service-sut/image/icon/school-pubh-08.svg"
          }
        ],
        "header": {
          "header_0": "ชื่อปริญญาและสาขา",
          "header_1": "วิสัยทัศน์",
          "header_2": "พันธกิจ",
          "header_3": "โครงสร้างหลักสูตร",
          "header_4": "แผนการศึกษา",
          "header_5": "ผลการรับและสำเร็จการศึกษา",
          "header_6": "เป้าหมายการรับและการสำเร็จการศึกษา",
          "header_7": "ผลการรับและสำเร็จการศึกษา",
          "header_8": "เป้าหมายการได้งานทำของบัณฑิต"
        },
        "visitor": 885,
        "visitor_of_year": 150
      }
    },
    "digital-technology": {
      "code": 200,
      "status": "Get data success",
      "data": {
        "information": {
          "id": "90",
          "courseID": "9",
          "titleTH": "สาขาวิชาเทคโนโลยีดิจิทัล",
          "titleEN": "Digital Technology",
          "slang": "digital-technology",
          "nameTH": "หลักสูตรวิทยาการสารสนเทศบัณฑิต สาขาวิชาเทคโนโลยีดิจิทัล",
          "nameEN": "Bachelor of Information Science Program in Digital Technology",
          "nameDegreeTH": "วิทยาการสารสนเทศบัณฑิต (เทคโนโลยีดิจิทัล)",
          "nameDegreeEN": "Bachelor of Information Science (Digital Technology)",
          "vision": "เป็นเลิศทางวิชาการด้านเทคโนโลยีดิจิทัล และมีความรับผิดชอบต่อสังคม",
          "mission": "เป็นสาขาเฉพาะทางด้านเทคโนโลยีดิจิทัลที่มุ่งผลิตบัณฑิตทั้งระดับปริญญาตรี ปริญญาโท และปริญญาเอก ที่รู้ชัด ปฏิบัติได้ มีภูมิธรรม ภูมิปัญญา และมุ่งเน้นการสร้างสรรค์ผลงานวิจัยและผลงานทางวิชาการ อันเป็นนวัตกรรมดิจิทัลเพื่อสังคม ทั้งนี้เพื่อนำกลับไปใช้ในการบูรณาการการเรียนการสอน การบริการวิชาการ และการทะนุบำรุงศิลปวัฒนธรรม",
          "course_structure": "https://digitech.sut.ac.th/pdf/dt/โครงสร้างหลักสูตร-DT.pdf",
          "study_plan": "https://digitech.sut.ac.th/pdf/dt/แผนการศึกษา-DT.pdf",
          "teacher": "https://digitech.sut.ac.th/personnal-professor.php",
          "graduation_goals": "รอข้อมูลจากสำนัก",
          "graduation_results": "รอข้อมูลจากสำนัก",
          "employment_goals": "รอข้อมูลจากสำนัก",
          "image": "__PUBLIC_URL__/service-sut/image/2_Institute/9_digit/01_techdi/slide1.png",
          "footer": "__PUBLIC_URL__/service-sut/image/2_Institute/9_digit/01_techdi/foot1.jpg,__PUBLIC_URL__/service-sut/image/2_Institute/9_digit/01_techdi/foot2.jpg,__PUBLIC_URL__/service-sut/image/2_Institute/9_digit/01_techdi/foot3.jpg",
          "createAt": null,
          "updateAt": null,
          "year": "2025"
        },
        "vision": {
          "vision_0": "เป็นเลิศทางวิชาการด้านเทคโนโลยีดิจิทัล และมีความรับผิดชอบต่อสังคม"
        },
        "mission": {
          "mission_0": "เป็นสาขาเฉพาะทางด้านเทคโนโลยีดิจิทัลที่มุ่งผลิตบัณฑิตทั้งระดับปริญญาตรี ปริญญาโท และปริญญาเอก ที่รู้ชัด ปฏิบัติได้ มีภูมิธรรม ภูมิปัญญา และมุ่งเน้นการสร้างสรรค์ผลงานวิจัยและผลงานทางวิชาการ อันเป็นนวัตกรรมดิจิทัลเพื่อสังคม ทั้งนี้เพื่อนำกลับไปใช้ในการบูรณาการการเรียนการสอน การบริการวิชาการ และการทะนุบำรุงศิลปวัฒนธรรม"
        },
        "image": {
          "image_0": "__PUBLIC_URL__/service-sut/image/2_Institute/9_digit/01_techdi/slide1.png"
        },
        "footer": {
          "image_0": "__PUBLIC_URL__/service-sut/image/2_Institute/9_digit/01_techdi/foot1.jpg",
          "image_1": "__PUBLIC_URL__/service-sut/image/2_Institute/9_digit/01_techdi/foot2.jpg",
          "image_2": "__PUBLIC_URL__/service-sut/image/2_Institute/9_digit/01_techdi/foot3.jpg"
        },
        "icon": [
          {
            "id": "66",
            "courseID": "9",
            "branchID": "0",
            "detail": "ชื่อหลักสูตร",
            "image": "__PUBLIC_URL__/service-sut/image/icon/school-digi-01.svg"
          },
          {
            "id": "67",
            "courseID": "9",
            "branchID": "0",
            "detail": "ชื่อปริญญาบัตรและสาขา",
            "image": "__PUBLIC_URL__/service-sut/image/icon/school-digi-02.svg"
          },
          {
            "id": "68",
            "courseID": "9",
            "branchID": "0",
            "detail": "โครงสร้างหลักสูตร",
            "image": "__PUBLIC_URL__/service-sut/image/icon/school-digi-03.svg"
          },
          {
            "id": "69",
            "courseID": "9",
            "branchID": "0",
            "detail": "แผนการศึกษา",
            "image": "__PUBLIC_URL__/service-sut/image/icon/school-digi-04.svg"
          },
          {
            "id": "70",
            "courseID": "9",
            "branchID": "0",
            "detail": "อาจารย์ประจำหลักสูตร",
            "image": "__PUBLIC_URL__/service-sut/image/icon/school-digi-05.svg"
          },
          {
            "id": "71",
            "courseID": "9",
            "branchID": "0",
            "detail": "เป้าหมายการรับและ การสำเร็จการศึกษา",
            "image": "__PUBLIC_URL__/service-sut/image/icon/school-digi-06.svg"
          },
          {
            "id": "72",
            "courseID": "9",
            "branchID": "0",
            "detail": "ผลการรับและ สำเร็จการศึกษา",
            "image": "__PUBLIC_URL__/service-sut/image/icon/school-digi-07.svg"
          },
          {
            "id": "73",
            "courseID": "9",
            "branchID": "0",
            "detail": "เป้าหมายการได้งานทำ ของบัณฑิต",
            "image": "__PUBLIC_URL__/service-sut/image/icon/school-digi-08.svg"
          }
        ],
        "header": {
          "header_0": "ชื่อปริญญาและสาขา",
          "header_1": "วิสัยทัศน์",
          "header_2": "พันธกิจ",
          "header_3": "โครงสร้างหลักสูตร",
          "header_4": "แผนการศึกษา",
          "header_5": "ผลการรับและสำเร็จการศึกษา",
          "header_6": "เป้าหมายการรับและการสำเร็จการศึกษา",
          "header_7": "ผลการรับและสำเร็จการศึกษา",
          "header_8": "เป้าหมายการได้งานทำของบัณฑิต"
        },
        "visitor": 1631,
        "visitor_of_year": 212
      }
    },
    "digital-communication": {
      "code": 200,
      "status": "Get data success",
      "data": {
        "information": {
          "id": "91",
          "courseID": "9",
          "titleTH": "สาขาวิชานิเทศศาสตร์ดิจิทัล",
          "titleEN": "Digital Communication",
          "slang": "digital-communication",
          "nameTH": "หลักสูตรวิทยาการสารสนเทศบัณฑิต สาขาวิชานิเทศศาสตรดิจิทัล",
          "nameEN": "Bachelor of Information Science Program in Digital Communication",
          "nameDegreeTH": "วิทยาการสารสนเทศบัณฑิต (นิเทศศาสตร์ดิจิทัล)",
          "nameDegreeEN": "Bachelor of Information Science (Digital Communication)",
          "vision": "เป็นเลิศทางวิชาการด้านเทคโนโลยีดิจิทัล และมีความรับผิดชอบต่อสังคม",
          "mission": "เป็นสาขาเฉพาะทางด้านเทคโนโลยีดิจิทัลที่มุ่งผลิตบัณฑิตทั้งระดับปริญญาตรี ปริญญาโท และปริญญาเอก ที่รู้ชัด ปฏิบัติได้ มีภูมิธรรม ภูมิปัญญา และมุ่งเน้นการสร้างสรรค์ผลงานวิจัยและผลงานทางวิชาการ อันเป็นนวัตกรรมดิจิทัลเพื่อสังคม ทั้งนี้เพื่อนำกลับไปใช้ในการบูรณาการการเรียนการสอน การบริการวิชาการ และการทะนุบำรุงศิลปวัฒนธรรม",
          "course_structure": "https://digitech.sut.ac.th/pdf/dc/โครงสร้างหลักสูตร-DC.pdf",
          "study_plan": "https://digitech.sut.ac.th/pdf/dc/แผนการศึกษา-DC.pdf",
          "teacher": "https://digitech.sut.ac.th/personnal-professor.php",
          "graduation_goals": "รอข้อมูลจากสำนัก",
          "graduation_results": "รอข้อมูลจากสำนัก",
          "employment_goals": "รอข้อมูลจากสำนัก",
          "image": "__PUBLIC_URL__/service-sut/image/2_Institute/9_digit/02_comdi/slide1.jpg,__PUBLIC_URL__/service-sut/image/2_Institute/9_digit/02_comdi/slide2.jpg",
          "footer": "__PUBLIC_URL__/service-sut/image/2_Institute/9_digit/02_comdi/foot1.jpg,__PUBLIC_URL__/service-sut/image/2_Institute/9_digit/02_comdi/foot2.jpg,__PUBLIC_URL__/service-sut/image/2_Institute/9_digit/02_comdi/foot3.jpg",
          "createAt": null,
          "updateAt": null,
          "year": "2025"
        },
        "vision": {
          "vision_0": "เป็นเลิศทางวิชาการด้านเทคโนโลยีดิจิทัล และมีความรับผิดชอบต่อสังคม"
        },
        "mission": {
          "mission_0": "เป็นสาขาเฉพาะทางด้านเทคโนโลยีดิจิทัลที่มุ่งผลิตบัณฑิตทั้งระดับปริญญาตรี ปริญญาโท และปริญญาเอก ที่รู้ชัด ปฏิบัติได้ มีภูมิธรรม ภูมิปัญญา และมุ่งเน้นการสร้างสรรค์ผลงานวิจัยและผลงานทางวิชาการ อันเป็นนวัตกรรมดิจิทัลเพื่อสังคม ทั้งนี้เพื่อนำกลับไปใช้ในการบูรณาการการเรียนการสอน การบริการวิชาการ และการทะนุบำรุงศิลปวัฒนธรรม"
        },
        "image": {
          "image_0": "__PUBLIC_URL__/service-sut/image/2_Institute/9_digit/02_comdi/slide1.jpg",
          "image_1": "__PUBLIC_URL__/service-sut/image/2_Institute/9_digit/02_comdi/slide2.jpg"
        },
        "footer": {
          "image_0": "__PUBLIC_URL__/service-sut/image/2_Institute/9_digit/02_comdi/foot1.jpg",
          "image_1": "__PUBLIC_URL__/service-sut/image/2_Institute/9_digit/02_comdi/foot2.jpg",
          "image_2": "__PUBLIC_URL__/service-sut/image/2_Institute/9_digit/02_comdi/foot3.jpg"
        },
        "icon": [
          {
            "id": "66",
            "courseID": "9",
            "branchID": "0",
            "detail": "ชื่อหลักสูตร",
            "image": "__PUBLIC_URL__/service-sut/image/icon/school-digi-01.svg"
          },
          {
            "id": "67",
            "courseID": "9",
            "branchID": "0",
            "detail": "ชื่อปริญญาบัตรและสาขา",
            "image": "__PUBLIC_URL__/service-sut/image/icon/school-digi-02.svg"
          },
          {
            "id": "68",
            "courseID": "9",
            "branchID": "0",
            "detail": "โครงสร้างหลักสูตร",
            "image": "__PUBLIC_URL__/service-sut/image/icon/school-digi-03.svg"
          },
          {
            "id": "69",
            "courseID": "9",
            "branchID": "0",
            "detail": "แผนการศึกษา",
            "image": "__PUBLIC_URL__/service-sut/image/icon/school-digi-04.svg"
          },
          {
            "id": "70",
            "courseID": "9",
            "branchID": "0",
            "detail": "อาจารย์ประจำหลักสูตร",
            "image": "__PUBLIC_URL__/service-sut/image/icon/school-digi-05.svg"
          },
          {
            "id": "71",
            "courseID": "9",
            "branchID": "0",
            "detail": "เป้าหมายการรับและ การสำเร็จการศึกษา",
            "image": "__PUBLIC_URL__/service-sut/image/icon/school-digi-06.svg"
          },
          {
            "id": "72",
            "courseID": "9",
            "branchID": "0",
            "detail": "ผลการรับและ สำเร็จการศึกษา",
            "image": "__PUBLIC_URL__/service-sut/image/icon/school-digi-07.svg"
          },
          {
            "id": "73",
            "courseID": "9",
            "branchID": "0",
            "detail": "เป้าหมายการได้งานทำ ของบัณฑิต",
            "image": "__PUBLIC_URL__/service-sut/image/icon/school-digi-08.svg"
          }
        ],
        "header": {
          "header_0": "ชื่อปริญญาและสาขา",
          "header_1": "วิสัยทัศน์",
          "header_2": "พันธกิจ",
          "header_3": "โครงสร้างหลักสูตร",
          "header_4": "แผนการศึกษา",
          "header_5": "ผลการรับและสำเร็จการศึกษา",
          "header_6": "เป้าหมายการรับและการสำเร็จการศึกษา",
          "header_7": "ผลการรับและสำเร็จการศึกษา",
          "header_8": "เป้าหมายการได้งานทำของบัณฑิต"
        },
        "visitor": 1245,
        "visitor_of_year": 216
      }
    },
    "nutrition-and-dietetics": {
      "code": 200,
      "status": "Get data success",
      "data": {
        "information": {
          "id": "92",
          "courseID": "8",
          "titleTH": "สาขาวิชาโภชนวิทยาและการกำหนดอาหาร",
          "titleEN": "Nutrition and Dietetics",
          "slang": "nutrition-and-dietetics",
          "nameTH": "หลักสูตรวิทยาศาสตรบัณฑิต สาขาวิชาโภชนวิทยาและการกำหนดอาหาร",
          "nameEN": "Bachelor of Science Program in Nutrition and Dietetics",
          "nameDegreeTH": "วิทยาศาสตรบัณฑิต (โภชนวิทยาและการกำหนดอาหาร)",
          "nameDegreeEN": "Bachelor of Science (Nutrition and Dietetics)",
          "vision": "เป็นสถาบันการศึกษาที่มุ่งเน้นสุขภาพ สิ่งแวดล้อม และความปลอดภัย เพื่อสังคมที่่ยั่งยืน (Higher Educational Institute on Health, Environment, and Safety Focused for Sustainable Society)",
          "mission": "ผลิตและพัฒนากำลังคนด้านสาธารณสุขศาสตร์ วิจัยและพัฒนาความรู้ และผลงานวิชาการ ด้านอนามัยสิ่งแวดล้อม และอาชีวอนามัยและความปลอดภัย ให้บริการวิชาการแก่ชุมชน เพื่อการพัฒนาที่ยั่งยืน",
          "course_structure": "https://reg4.sut.ac.th/registrar/program_info_1.asp?f_cmd=2&acadyear=-1&levelid=0&programid=110040101660&facultyid=11000&programname=%E2%C0%AA%B9%C7%D4%B7%C2%D2%E1%C5%D0%A1%D2%C3%A1%D3%CB%B9%B4%CD%D2%CB%D2%C3%2D2566&facultyname=%CA%D3%B9%D1%A1%C7%D4%AA%D2%CA%D2%B8%D2%C3%B3%CA%D8%A2%C8%D2%CA%B5%C3%EC&levelname=%BB%C3%D4%AD%AD%D2%B5%C3%D5",
          "study_plan": "https://reg4.sut.ac.th/registrar/studyplan_info1.asp?avs711423106=17&acadyear=-1&levelid=0&programid=110040101660&facultyid=11000&programname=%E2%C0%AA%B9%C7%D4%B7%C2%D2%E1%C5%D0%A1%D2%C3%A1%D3%CB%B9%B4%CD%D2%CB%D2%C3%2D2566&facultyname=%CA%D3%B9%D1%A1%C7%D4%AA%D2%CA%D2%B8%D2%C3%B3%CA%D8%A2%C8%D2%CA%B5%C3%EC&levelname=%BB%C3%D4%AD%AD%D2%B5%C3%D5",
          "teacher": "http://iph.sut.ac.th/personnel/food-teacher/",
          "graduation_goals": "รอข้อมูลจากสำนัก",
          "graduation_results": "รอข้อมูลจากสำนัก",
          "employment_goals": "รอข้อมูลจากสำนัก",
          "image": "__PUBLIC_URL__/service-sut/image/2025/08/branch/ND%20Slide%2001.jpg,__PUBLIC_URL__/service-sut/image/2025/08/branch/ND%20Slide%2002.jpg,__PUBLIC_URL__/service-sut/image/2025/08/branch/ND%20Slide%2003.jpg",
          "footer": "__PUBLIC_URL__/service-sut/image/2025/08/branch/ND%20Foot%2001.jpg,__PUBLIC_URL__/service-sut/image/2025/08/branch/ND%20Foot%2002.jpg,__PUBLIC_URL__/service-sut/image/2025/08/branch/ND%20Foot%2003.jpg",
          "createAt": null,
          "updateAt": null,
          "year": "2025"
        },
        "vision": {
          "vision_0": "เป็นสถาบันการศึกษาที่มุ่งเน้นสุขภาพ สิ่งแวดล้อม และความปลอดภัย เพื่อสังคมที่่ยั่งยืน (Higher Educational Institute on Health, Environment, and Safety Focused for Sustainable Society)"
        },
        "mission": {
          "mission_0": "ผลิตและพัฒนากำลังคนด้านสาธารณสุขศาสตร์ วิจัยและพัฒนาความรู้ และผลงานวิชาการ ด้านอนามัยสิ่งแวดล้อม และอาชีวอนามัยและความปลอดภัย ให้บริการวิชาการแก่ชุมชน เพื่อการพัฒนาที่ยั่งยืน"
        },
        "image": {
          "image_0": "__PUBLIC_URL__/service-sut/image/2025/08/branch/ND%20Slide%2001.jpg",
          "image_1": "__PUBLIC_URL__/service-sut/image/2025/08/branch/ND%20Slide%2002.jpg",
          "image_2": "__PUBLIC_URL__/service-sut/image/2025/08/branch/ND%20Slide%2003.jpg"
        },
        "footer": {
          "image_0": "__PUBLIC_URL__/service-sut/image/2025/08/branch/ND%20Foot%2001.jpg",
          "image_1": "__PUBLIC_URL__/service-sut/image/2025/08/branch/ND%20Foot%2002.jpg",
          "image_2": "__PUBLIC_URL__/service-sut/image/2025/08/branch/ND%20Foot%2003.jpg"
        },
        "icon": [
          {
            "id": "58",
            "courseID": "8",
            "branchID": "0",
            "detail": "ชื่อหลักสูตร",
            "image": "__PUBLIC_URL__/service-sut/image/icon/school-pubh-01.svg"
          },
          {
            "id": "59",
            "courseID": "8",
            "branchID": "0",
            "detail": "ชื่อปริญญาบัตรและสาขา",
            "image": "__PUBLIC_URL__/service-sut/image/icon/school-pubh-02.svg"
          },
          {
            "id": "60",
            "courseID": "8",
            "branchID": "0",
            "detail": "โครงสร้างหลักสูตร",
            "image": "__PUBLIC_URL__/service-sut/image/icon/school-pubh-03.svg"
          },
          {
            "id": "61",
            "courseID": "8",
            "branchID": "0",
            "detail": "แผนการศึกษา",
            "image": "__PUBLIC_URL__/service-sut/image/icon/school-pubh-04.svg"
          },
          {
            "id": "62",
            "courseID": "8",
            "branchID": "0",
            "detail": "อาจารย์ประจำหลักสูตร",
            "image": "__PUBLIC_URL__/service-sut/image/icon/school-pubh-05.svg"
          },
          {
            "id": "63",
            "courseID": "8",
            "branchID": "0",
            "detail": "เป้าหมายการรับและ การสำเร็จการศึกษา",
            "image": "__PUBLIC_URL__/service-sut/image/icon/school-pubh-06.svg"
          },
          {
            "id": "64",
            "courseID": "8",
            "branchID": "0",
            "detail": "ผลการรับและ สำเร็จการศึกษา",
            "image": "__PUBLIC_URL__/service-sut/image/icon/school-pubh-07.svg"
          },
          {
            "id": "65",
            "courseID": "8",
            "branchID": "0",
            "detail": "เป้าหมายการได้งานทำ ของบัณฑิต",
            "image": "__PUBLIC_URL__/service-sut/image/icon/school-pubh-08.svg"
          }
        ],
        "header": {
          "header_0": "ชื่อปริญญาและสาขา",
          "header_1": "วิสัยทัศน์",
          "header_2": "พันธกิจ",
          "header_3": "โครงสร้างหลักสูตร",
          "header_4": "แผนการศึกษา",
          "header_5": "ผลการรับและสำเร็จการศึกษา",
          "header_6": "เป้าหมายการรับและการสำเร็จการศึกษา",
          "header_7": "ผลการรับและสำเร็จการศึกษา",
          "header_8": "เป้าหมายการได้งานทำของบัณฑิต"
        },
        "visitor": 827,
        "visitor_of_year": 50
      }
    },
    "mechatronics-engineering": {
      "code": 200,
      "status": "Get data success",
      "data": {
        "information": {
          "id": "93",
          "courseID": "4",
          "titleTH": "สาขาวิชาวิศวกรรมเมคคาทรอนิกส์",
          "titleEN": "Mechatronics Engineering",
          "slang": "mechatronics-engineering",
          "nameTH": "หลักสูตรวิศวกรรมศาสตรบัณฑิต สาขาวิชาวิศวกรรมเมคคาทรอนิกส์",
          "nameEN": "Bachelor of Engineering Program in Mechatronics Engineering",
          "nameDegreeTH": "วิศวกรรมศาสตรบัณฑิต (วิศวกรรมเมคคาทรอนิกส์)",
          "nameDegreeEN": "Bachelor of Engineering (Mechatronics Engineering)",
          "vision": "เป็นองค์กรที่โดดเด่นในการสร้างกำลังคนและความรู้ด้านวิศวกรรมศาสตร์ของประเทศ",
          "mission": "(1) ผลิตและพัฒนากำลังคนทางด้านวิศวกรรมศาสตร์ที่มีความรู้และทักษะพร้อมในการทำงานภาคอุตสาหกรรม\n|(2) วิจัยและพัฒนาทางด้านวิศวกรรมศาสตร์ที่ตอบสนองความต้องการของประเทศและภูมิภาค\n|(3) บริการวิชาการ ปรับแปลง และถ่ายทอดเทคโนโลยี เพื่อส่งเสริมศักยภาพในการแข่งขันของภาคอุตสาหกรรมและบริการของประเทศและสร้างสรรค์คุณค่าแก่สังคม",
          "course_structure": "http://reg4.sut.ac.th/registrar/program_info_1.asp?f_cmd=2&acadyear=-1&levelid=1&programid=107230404610&facultyid=10700&programname=%C7%D4%C8%C7%A1%C3%C3%C1%E0%C1%A4%A4%D2%B7%C3%CD%B9%D4%A1%CA%EC%2D2561%28%CB%C5%D1%A1%CA%D9%B5%C3%CA%CB%C7%D4%B7%C2%D2%A1%D2%C3%29&facultyname=%CA%D3%B9%D1%A1%C7%D4%AA%D2%C7%D4%C8%C7%A1%C3%C3%C1%C8%D2%CA%B5%C3%EC&levelname=%BB%C3%D4%AD%AD%D2%B5%C3%D5",
          "study_plan": "http://reg4.sut.ac.th/registrar/studyplan_info1.asp?avs913756916=7&acadyear=-1&levelid=1&programid=107230404610&facultyid=10700&programname=%C7%D4%C8%C7%A1%C3%C3%C1%E0%C1%A4%A4%D2%B7%C3%CD%B9%D4%A1%CA%EC%2D2561%28%CB%C5%D1%A1%CA%D9%B5%C3%CA%CB%C7%D4%B7%C2%D2%A1%D2%C3%29&facultyname=%CA%D3%B9%D1%A1%C7%D4%AA%D2%C7%D4%C8%C7%A1%C3%C3%C1%C8%D2%CA%B5%C3%EC&levelname=%BB%C3%D4%AD%AD%D2%B5%C3%D5",
          "teacher": "http://mecha.sut.ac.th/staff.php",
          "graduation_goals": "รอข้อมูลจากสำนัก",
          "graduation_results": "รอข้อมูลจากสำนัก",
          "employment_goals": "รอข้อมูลจากสำนัก",
          "image": "__PUBLIC_URL__/service-sut/image/2_Institute/4-engi/06_mecha/slide1.png,__PUBLIC_URL__/service-sut/image/2_Institute/4-engi/06_mecha/slide2.png,__PUBLIC_URL__/service-sut/image/2_Institute/4-engi/06_mecha/slide3.png",
          "footer": "__PUBLIC_URL__/service-sut/image/2_Institute/4-engi/06_mecha/foot1.png,__PUBLIC_URL__/service-sut/image/2_Institute/4-engi/06_mecha/foot2.png,__PUBLIC_URL__/service-sut/image/2_Institute/4-engi/06_mecha/foot3.png",
          "createAt": null,
          "updateAt": null,
          "year": "2025"
        },
        "vision": {
          "vision_0": "เป็นองค์กรที่โดดเด่นในการสร้างกำลังคนและความรู้ด้านวิศวกรรมศาสตร์ของประเทศ"
        },
        "mission": {
          "mission_0": "(1) ผลิตและพัฒนากำลังคนทางด้านวิศวกรรมศาสตร์ที่มีความรู้และทักษะพร้อมในการทำงานภาคอุตสาหกรรม\n",
          "mission_1": "(2) วิจัยและพัฒนาทางด้านวิศวกรรมศาสตร์ที่ตอบสนองความต้องการของประเทศและภูมิภาค\n",
          "mission_2": "(3) บริการวิชาการ ปรับแปลง และถ่ายทอดเทคโนโลยี เพื่อส่งเสริมศักยภาพในการแข่งขันของภาคอุตสาหกรรมและบริการของประเทศและสร้างสรรค์คุณค่าแก่สังคม"
        },
        "image": {
          "image_0": "__PUBLIC_URL__/service-sut/image/2_Institute/4-engi/06_mecha/slide1.png",
          "image_1": "__PUBLIC_URL__/service-sut/image/2_Institute/4-engi/06_mecha/slide2.png",
          "image_2": "__PUBLIC_URL__/service-sut/image/2_Institute/4-engi/06_mecha/slide3.png"
        },
        "footer": {
          "image_0": "__PUBLIC_URL__/service-sut/image/2_Institute/4-engi/06_mecha/foot1.png",
          "image_1": "__PUBLIC_URL__/service-sut/image/2_Institute/4-engi/06_mecha/foot2.png",
          "image_2": "__PUBLIC_URL__/service-sut/image/2_Institute/4-engi/06_mecha/foot3.png"
        },
        "icon": [
          {
            "id": "26",
            "courseID": "4",
            "branchID": "0",
            "detail": "ชื่อหลักสูตร",
            "image": "__PUBLIC_URL__/service-sut/image/icon/school-engi-01.svg"
          },
          {
            "id": "27",
            "courseID": "4",
            "branchID": "0",
            "detail": "ชื่อปริญญาบัตรและสาขา",
            "image": "__PUBLIC_URL__/service-sut/image/icon/school-engi-02.svg"
          },
          {
            "id": "28",
            "courseID": "4",
            "branchID": "0",
            "detail": "โครงสร้างหลักสูตร",
            "image": "__PUBLIC_URL__/service-sut/image/icon/school-engi-03.svg"
          },
          {
            "id": "29",
            "courseID": "4",
            "branchID": "0",
            "detail": "แผนการศึกษา",
            "image": "__PUBLIC_URL__/service-sut/image/icon/school-engi-04.svg"
          },
          {
            "id": "30",
            "courseID": "4",
            "branchID": "0",
            "detail": "อาจารย์ประจำหลักสูตร",
            "image": "__PUBLIC_URL__/service-sut/image/icon/school-engi-05.svg"
          },
          {
            "id": "31",
            "courseID": "4",
            "branchID": "0",
            "detail": "เป้าหมายการรับและ การสำเร็จการศึกษา",
            "image": "__PUBLIC_URL__/service-sut/image/icon/school-engi-06.svg"
          },
          {
            "id": "32",
            "courseID": "4",
            "branchID": "0",
            "detail": "ผลการรับและ สำเร็จการศึกษา",
            "image": "__PUBLIC_URL__/service-sut/image/icon/school-engi-07.svg"
          },
          {
            "id": "33",
            "courseID": "4",
            "branchID": "0",
            "detail": "เป้าหมายการได้งานทำ ของบัณฑิต",
            "image": "__PUBLIC_URL__/service-sut/image/icon/school-engi-08.svg"
          }
        ],
        "header": {
          "header_0": "ชื่อปริญญาและสาขา",
          "header_1": "วิสัยทัศน์",
          "header_2": "พันธกิจ",
          "header_3": "โครงสร้างหลักสูตร",
          "header_4": "แผนการศึกษา",
          "header_5": "ผลการรับและสำเร็จการศึกษา",
          "header_6": "เป้าหมายการรับและการสำเร็จการศึกษา",
          "header_7": "ผลการรับและสำเร็จการศึกษา",
          "header_8": "เป้าหมายการได้งานทำของบัณฑิต"
        },
        "visitor": 1000,
        "visitor_of_year": 73
      }
    },
    "automotive-engineering": {
      "code": 200,
      "status": "Get data success",
      "data": {
        "information": {
          "id": "94",
          "courseID": "4",
          "titleTH": "สาขาวิชาวิศวกรรมยานยนต์สมัยใหม่",
          "titleEN": "Modern Automotive Engineering",
          "slang": "automotive-engineering",
          "nameTH": "หลักสูตรวิศวกรรมศาสตรบัณฑิต สาขาวิชาวิศวกรรมยานยนต์สมัยใหม่",
          "nameEN": "Bachelor of Engineering Program in Modern Automotive Engineering",
          "nameDegreeTH": "วิศวกรรมศาสตรบัณฑิต (วิศวกรรมยานยนต์สมัยใหม่)",
          "nameDegreeEN": "Bachelor of Engineering (Modern Automotive Engineering)",
          "vision": "เป็นองค์กรที่โดดเด่นในการสร้างกำลังคนและความรู้ด้านวิศวกรรมศาสตร์ของประเทศ",
          "mission": "(1) ผลิตและพัฒนากำลังคนทางด้านวิศวกรรมศาสตร์ที่มีความรู้และทักษะพร้อมในการทำงานภาคอุตสาหกรรม\n|(2) วิจัยและพัฒนาทางด้านวิศวกรรมศาสตร์ที่ตอบสนองความต้องการของประเทศและภูมิภาค\n|(3) บริการวิชาการ ปรับแปลง และถ่ายทอดเทคโนโลยี เพื่อส่งเสริมศักยภาพในการแข่งขันของภาคอุตสาหกรรมและบริการของประเทศและสร้างสรรค์คุณค่าแก่สังคม",
          "course_structure": "http://reg4.sut.ac.th/registrar/program_info_1.asp?f_cmd=2&acadyear=-1&levelid=1&programid=107350401622&facultyid=10700&programname=%C7%D4%C8%C7%A1%C3%C3%C1%BE%C3%D5%AB%D4%AA%D1%E8%B9%2D2562%28%CB%C5%D1%A1%CA%D9%B5%C3%CA%CB%C7%D4%B7%C2%D2%A1%D2%C3%29+%28%BB%C7%CA%2E%29&facultyname=%CA%D3%B9%D1%A1%C7%D4%AA%D2%C7%D4%C8%C7%A1%C3%C3%C1%C8%D2%CA%B5%C3%EC&levelname=%BB%C3%D4%AD%AD%D2%B5%C3%D5",
          "study_plan": "http://reg4.sut.ac.th/registrar/studyplan_info1.asp?avs913756916=2&acadyear=-1&levelid=1&programid=107350401622&facultyid=10700&programname=%C7%D4%C8%C7%A1%C3%C3%C1%BE%C3%D5%AB%D4%AA%D1%E8%B9%2D2562%28%CB%C5%D1%A1%CA%D9%B5%C3%CA%CB%C7%D4%B7%C2%D2%A1%D2%C3%29+%28%BB%C7%CA%2E%29&facultyname=%CA%D3%B9%D1%A1%C7%D4%AA%D2%C7%D4%C8%C7%A1%C3%C3%C1%C8%D2%CA%B5%C3%EC&levelname=%BB%C3%D4%AD%AD%D2%B5%C3%D5",
          "teacher": "http://mecha.sut.ac.th/staff.php",
          "graduation_goals": "รอข้อมูลจากสำนัก",
          "graduation_results": "รอข้อมูลจากสำนัก",
          "employment_goals": "",
          "image": "__PUBLIC_URL__/service-sut/image/image-2023/department-engineering/moto/Slide1.png",
          "footer": "__PUBLIC_URL__/service-sut/image/image-2023/department-engineering/moto/Footer1.png,__PUBLIC_URL__/service-sut/image/image-2023/department-engineering/moto/Footer2.png,__PUBLIC_URL__/service-sut/image/image-2023/department-engineering/moto/Footer3.png",
          "createAt": null,
          "updateAt": null,
          "year": "2025"
        },
        "vision": {
          "vision_0": "เป็นองค์กรที่โดดเด่นในการสร้างกำลังคนและความรู้ด้านวิศวกรรมศาสตร์ของประเทศ"
        },
        "mission": {
          "mission_0": "(1) ผลิตและพัฒนากำลังคนทางด้านวิศวกรรมศาสตร์ที่มีความรู้และทักษะพร้อมในการทำงานภาคอุตสาหกรรม\n",
          "mission_1": "(2) วิจัยและพัฒนาทางด้านวิศวกรรมศาสตร์ที่ตอบสนองความต้องการของประเทศและภูมิภาค\n",
          "mission_2": "(3) บริการวิชาการ ปรับแปลง และถ่ายทอดเทคโนโลยี เพื่อส่งเสริมศักยภาพในการแข่งขันของภาคอุตสาหกรรมและบริการของประเทศและสร้างสรรค์คุณค่าแก่สังคม"
        },
        "image": {
          "image_0": "__PUBLIC_URL__/service-sut/image/image-2023/department-engineering/moto/Slide1.png"
        },
        "footer": {
          "image_0": "__PUBLIC_URL__/service-sut/image/image-2023/department-engineering/moto/Footer1.png",
          "image_1": "__PUBLIC_URL__/service-sut/image/image-2023/department-engineering/moto/Footer2.png",
          "image_2": "__PUBLIC_URL__/service-sut/image/image-2023/department-engineering/moto/Footer3.png"
        },
        "icon": [
          {
            "id": "26",
            "courseID": "4",
            "branchID": "0",
            "detail": "ชื่อหลักสูตร",
            "image": "__PUBLIC_URL__/service-sut/image/icon/school-engi-01.svg"
          },
          {
            "id": "27",
            "courseID": "4",
            "branchID": "0",
            "detail": "ชื่อปริญญาบัตรและสาขา",
            "image": "__PUBLIC_URL__/service-sut/image/icon/school-engi-02.svg"
          },
          {
            "id": "28",
            "courseID": "4",
            "branchID": "0",
            "detail": "โครงสร้างหลักสูตร",
            "image": "__PUBLIC_URL__/service-sut/image/icon/school-engi-03.svg"
          },
          {
            "id": "29",
            "courseID": "4",
            "branchID": "0",
            "detail": "แผนการศึกษา",
            "image": "__PUBLIC_URL__/service-sut/image/icon/school-engi-04.svg"
          },
          {
            "id": "30",
            "courseID": "4",
            "branchID": "0",
            "detail": "อาจารย์ประจำหลักสูตร",
            "image": "__PUBLIC_URL__/service-sut/image/icon/school-engi-05.svg"
          },
          {
            "id": "31",
            "courseID": "4",
            "branchID": "0",
            "detail": "เป้าหมายการรับและ การสำเร็จการศึกษา",
            "image": "__PUBLIC_URL__/service-sut/image/icon/school-engi-06.svg"
          },
          {
            "id": "32",
            "courseID": "4",
            "branchID": "0",
            "detail": "ผลการรับและ สำเร็จการศึกษา",
            "image": "__PUBLIC_URL__/service-sut/image/icon/school-engi-07.svg"
          },
          {
            "id": "33",
            "courseID": "4",
            "branchID": "0",
            "detail": "เป้าหมายการได้งานทำ ของบัณฑิต",
            "image": "__PUBLIC_URL__/service-sut/image/icon/school-engi-08.svg"
          }
        ],
        "header": {
          "header_0": "ชื่อปริญญาและสาขา",
          "header_1": "วิสัยทัศน์",
          "header_2": "พันธกิจ",
          "header_3": "โครงสร้างหลักสูตร",
          "header_4": "แผนการศึกษา",
          "header_5": "ผลการรับและสำเร็จการศึกษา",
          "header_6": "เป้าหมายการรับและการสำเร็จการศึกษา",
          "header_7": "ผลการรับและสำเร็จการศึกษา",
          "header_8": "เป้าหมายการได้งานทำของบัณฑิต"
        },
        "visitor": 2078,
        "visitor_of_year": 581
      }
    },
    "nursing-science-65": {
      "code": 200,
      "status": "Get data success",
      "data": {
        "information": {
          "id": "95",
          "courseID": "6",
          "titleTH": "พยาบาลศาสตรบัณฑิต (หลักสูตรปรับปรุง พ.ศ. 2565)",
          "titleEN": "Bachelor of Science Program in Nursing Science",
          "slang": "nursing-science-65",
          "nameTH": "หลักสูตรพยาบาลศาสตรบัณฑิต",
          "nameEN": "Bachelor of Nursing Science Program",
          "nameDegreeTH": "พยาบาลศาสตรบัณฑิต",
          "nameDegreeEN": "Bachelor of Nursing Science",
          "vision": "เป็นสถาบันแห่งโอกาสทางการพยาบาลที่ขับเคลื่อนด้วยการวิจัย นวัตกรรมเพื่อสุขภาพ",
          "mission": "1. ผลิตบัณฑิตพยาบาลวิชาชีพเพื่อสนองความต้องการของประเทศและนานาชาติ\n|2. ผลิตผลงานวิจัย และนวัตกรรม เพื่อนำผลการวิจัยไปใช้ในการดูแลสุขภาพประชาชน\n|3. ปรับแปลง ถ่ายทอด และพัฒนานวัตกรรมในการจัดการสุขภาพ\n|4. ให้บริการวิชาการที่สอดคล้องกับความต้องของชุมชนและสร้างความเข้มแข็งเพื่อการพึ่งตนเองด้านสุขภาพของชุมชนและสังคม",
          "course_structure": "__PUBLIC_URL__/service-sut/image/nursing/pdf/%E0%B9%82%E0%B8%84%E0%B8%A3%E0%B8%87%E0%B8%AA%E0%B8%A3%E0%B9%89%E0%B8%B2%E0%B8%87%E0%B8%AB%E0%B8%A5%E0%B8%B1%E0%B8%81%E0%B8%AA%E0%B8%B9%E0%B8%95%E0%B8%A32565%202.pdf",
          "study_plan": "__PUBLIC_URL__/service-sut/image/nursing/pdf/%E0%B9%81%E0%B8%9C%E0%B8%99%E0%B8%81%E0%B8%B2%E0%B8%A3%E0%B8%A8%E0%B8%B6%E0%B8%81%E0%B8%A9%E0%B8%B22565%202.pdf",
          "teacher": "https://nurse.sut.ac.th/about-us/personal/academic/",
          "graduation_goals": "รอข้อมูลจากสำนัก",
          "graduation_results": "รอข้อมูลจากสำนัก",
          "employment_goals": "รอข้อมูลจากสำนัก",
          "image": "__PUBLIC_URL__/service-sut/image/2_Institute/6-nurs/slide1.jpg,__PUBLIC_URL__/service-sut/image/2_Institute/6-nurs/slide2.jpg",
          "footer": "__PUBLIC_URL__/service-sut/image/2_Institute/6-nurs/foot1.jpg,__PUBLIC_URL__/service-sut/image/2_Institute/6-nurs/foot2.jpg,__PUBLIC_URL__/service-sut/image/2_Institute/6-nurs/foot3.jpg",
          "createAt": null,
          "updateAt": null,
          "year": "2025"
        },
        "vision": {
          "vision_0": "เป็นสถาบันแห่งโอกาสทางการพยาบาลที่ขับเคลื่อนด้วยการวิจัย นวัตกรรมเพื่อสุขภาพ"
        },
        "mission": {
          "mission_0": "1. ผลิตบัณฑิตพยาบาลวิชาชีพเพื่อสนองความต้องการของประเทศและนานาชาติ\n",
          "mission_1": "2. ผลิตผลงานวิจัย และนวัตกรรม เพื่อนำผลการวิจัยไปใช้ในการดูแลสุขภาพประชาชน\n",
          "mission_2": "3. ปรับแปลง ถ่ายทอด และพัฒนานวัตกรรมในการจัดการสุขภาพ\n",
          "mission_3": "4. ให้บริการวิชาการที่สอดคล้องกับความต้องของชุมชนและสร้างความเข้มแข็งเพื่อการพึ่งตนเองด้านสุขภาพของชุมชนและสังคม"
        },
        "image": {
          "image_0": "__PUBLIC_URL__/service-sut/image/2_Institute/6-nurs/slide1.jpg",
          "image_1": "__PUBLIC_URL__/service-sut/image/2_Institute/6-nurs/slide2.jpg"
        },
        "footer": {
          "image_0": "__PUBLIC_URL__/service-sut/image/2_Institute/6-nurs/foot1.jpg",
          "image_1": "__PUBLIC_URL__/service-sut/image/2_Institute/6-nurs/foot2.jpg",
          "image_2": "__PUBLIC_URL__/service-sut/image/2_Institute/6-nurs/foot3.jpg"
        },
        "icon": [
          {
            "id": "42",
            "courseID": "6",
            "branchID": "0",
            "detail": "ชื่อหลักสูตร",
            "image": "__PUBLIC_URL__/service-sut/image/icon/school-nurs-01.svg"
          },
          {
            "id": "43",
            "courseID": "6",
            "branchID": "0",
            "detail": "ชื่อปริญญาบัตรและสาขา",
            "image": "__PUBLIC_URL__/service-sut/image/icon/school-nurs-02.svg"
          },
          {
            "id": "44",
            "courseID": "6",
            "branchID": "0",
            "detail": "โครงสร้างหลักสูตร",
            "image": "__PUBLIC_URL__/service-sut/image/icon/school-nurs-03.svg"
          },
          {
            "id": "45",
            "courseID": "6",
            "branchID": "0",
            "detail": "แผนการศึกษา",
            "image": "__PUBLIC_URL__/service-sut/image/icon/school-nurs-04.svg"
          },
          {
            "id": "46",
            "courseID": "6",
            "branchID": "0",
            "detail": "อาจารย์ประจำหลักสูตร",
            "image": "__PUBLIC_URL__/service-sut/image/icon/school-nurs-05.svg"
          },
          {
            "id": "47",
            "courseID": "6",
            "branchID": "0",
            "detail": "เป้าหมายการรับและ การสำเร็จการศึกษา",
            "image": "__PUBLIC_URL__/service-sut/image/icon/school-nurs-06.svg"
          },
          {
            "id": "48",
            "courseID": "6",
            "branchID": "0",
            "detail": "ผลการรับและ สำเร็จการศึกษา",
            "image": "__PUBLIC_URL__/service-sut/image/icon/school-nurs-07.svg"
          },
          {
            "id": "49",
            "courseID": "6",
            "branchID": "0",
            "detail": "เป้าหมายการได้งานทำ ของบัณฑิต",
            "image": "__PUBLIC_URL__/service-sut/image/icon/school-nurs-08.svg"
          }
        ],
        "header": {
          "header_0": "ชื่อปริญญาและสาขา",
          "header_1": "วิสัยทัศน์",
          "header_2": "พันธกิจ",
          "header_3": "โครงสร้างหลักสูตร",
          "header_4": "แผนการศึกษา",
          "header_5": "ผลการรับและสำเร็จการศึกษา",
          "header_6": "เป้าหมายการรับและการสำเร็จการศึกษา",
          "header_7": "ผลการรับและสำเร็จการศึกษา",
          "header_8": "เป้าหมายการได้งานทำของบัณฑิต"
        },
        "visitor": 508,
        "visitor_of_year": 106
      }
    },
    "micorbiology": {
      "code": 200,
      "status": "Get data success",
      "data": {
        "information": {
          "id": "96",
          "courseID": "1",
          "titleTH": "หลักสูตรวิทยาศาสตรบัณฑิต สาขาวิชาจุลชีววิทยา",
          "titleEN": "Bachelor of Science Program in Microbiology",
          "slang": "micorbiology",
          "nameTH": "หลักสูตรวิทยาศาสตรบัณฑิต สาขาวิชาจุลชีววิทยา (หลักสูตรใหม่ พ.ศ. 2566)",
          "nameEN": "Bachelor of Science Program in Microbiology",
          "nameDegreeTH": "วิทยาศาสตรบัณฑิต (จุลชีววิทยา)\r\nวท.บ. (จุลชีววิทยา)",
          "nameDegreeEN": "Bachelor of Science (Microbiology)\r\nB.Sc. (Microbiology)",
          "vision": "มุ่งผลิตบัณฑิตที่มีความรู้และทักษะทางจุลชีววิทยา เพื่อนำไปสู่การสร้างนวัตกรรม สนใจใฝ่รู้แสวงหาองค์ความรู้ใหม่ทางด้านจุลชีววิทยาเพื่อการเรียนรู้ตลอดชีวิต ตระหนักถึงหน้าที่และความรับผิดชอบต่อตนเองและสังคม",
          "mission": "1. เพื่อผลิตบัณฑิตที่สามารถอธิบาย ประยุกต์ใช้ คิดวิเคราะห์และสังเคราะห์องค์ความรู้ทางจุลชีววิทยา สามารถบูรณาการองค์ความรู้ ทักษะ และการใช้เครื่องมือทางจุลชีววิทยา เพื่อแก้ปัญหาในการปฏิบัติงานหรือวิจัยอย่างมีประสิทธิภาพ นำไปสู่การสร้างนวัตกรรมด้านจุลชีววิทยาได้อย่างเป็นระบบ\n|2. เพื่อผลิตบัณฑิตทางจุลชีววิทยาที่สามารถใช้เทคโนโลยีสารสนเทศและการสื่อสารที่เหมาะสม แสวงหาองค์ความรู้ใหม่ทางด้านจุลชีววิทยาเพื่อการเรียนรู้ตลอดชีวิต\n|3. เพื่อผลิตบัณฑิตทางจุลชีววิทยาที่มีพร้อมทั้งความรู้ คุณธรรม จริยธรรม ทัศนคติ และจิตสำนึกที่ดีต่อตนเองและสังคม",
          "course_structure": "http://reg4.sut.ac.th/registrar/program_info_1.asp?f_cmd=2&acadyear=-1&levelid=1&programid=101080101660&facultyid=10100&programname=%A8%D8%C5%AA%D5%C7%C7%D4%B7%C2%D2%2D2566&facultyname=%CA%D3%B9%D1%A1%C7%D4%AA%D2%C7%D4%B7%C2%D2%C8%D2%CA%B5%C3%EC&levelname=%BB%C3%D4%AD%AD%D2%B5%C3%D5",
          "study_plan": "http://reg4.sut.ac.th/registrar/studyplan_info1.asp?avs669746568=32&acadyear=-1&levelid=1&programid=101080101660&facultyid=10100&programname=%A8%D8%C5%AA%D5%C7%C7%D4%B7%C2%D2%2D2566&facultyname=%CA%D3%B9%D1%A1%C7%D4%AA%D2%C7%D4%B7%C2%D2%C8%D2%CA%B5%C3%EC&levelname=%BB%C3%D4%AD%AD%D2%B5%C3%D5",
          "teacher": "",
          "graduation_goals": "",
          "graduation_results": "",
          "employment_goals": "",
          "image": "__PUBLIC_URL__/service-sut/image/2023/department-science/micorbiology/slide-1.png",
          "footer": "__PUBLIC_URL__/service-sut/image/2023/department-science/micorbiology/footer-1.png,__PUBLIC_URL__/service-sut/image/2023/department-science/micorbiology/footer-2.png,__PUBLIC_URL__/service-sut/image/2023/department-science/micorbiology/footer-3.png",
          "createAt": null,
          "updateAt": null,
          "year": "2025"
        },
        "vision": {
          "vision_0": "มุ่งผลิตบัณฑิตที่มีความรู้และทักษะทางจุลชีววิทยา เพื่อนำไปสู่การสร้างนวัตกรรม สนใจใฝ่รู้แสวงหาองค์ความรู้ใหม่ทางด้านจุลชีววิทยาเพื่อการเรียนรู้ตลอดชีวิต ตระหนักถึงหน้าที่และความรับผิดชอบต่อตนเองและสังคม"
        },
        "mission": {
          "mission_0": "1. เพื่อผลิตบัณฑิตที่สามารถอธิบาย ประยุกต์ใช้ คิดวิเคราะห์และสังเคราะห์องค์ความรู้ทางจุลชีววิทยา สามารถบูรณาการองค์ความรู้ ทักษะ และการใช้เครื่องมือทางจุลชีววิทยา เพื่อแก้ปัญหาในการปฏิบัติงานหรือวิจัยอย่างมีประสิทธิภาพ นำไปสู่การสร้างนวัตกรรมด้านจุลชีววิทยาได้อย่างเป็นระบบ\n",
          "mission_1": "2. เพื่อผลิตบัณฑิตทางจุลชีววิทยาที่สามารถใช้เทคโนโลยีสารสนเทศและการสื่อสารที่เหมาะสม แสวงหาองค์ความรู้ใหม่ทางด้านจุลชีววิทยาเพื่อการเรียนรู้ตลอดชีวิต\n",
          "mission_2": "3. เพื่อผลิตบัณฑิตทางจุลชีววิทยาที่มีพร้อมทั้งความรู้ คุณธรรม จริยธรรม ทัศนคติ และจิตสำนึกที่ดีต่อตนเองและสังคม"
        },
        "image": {
          "image_0": "__PUBLIC_URL__/service-sut/image/2023/department-science/micorbiology/slide-1.png"
        },
        "footer": {
          "image_0": "__PUBLIC_URL__/service-sut/image/2023/department-science/micorbiology/footer-1.png",
          "image_1": "__PUBLIC_URL__/service-sut/image/2023/department-science/micorbiology/footer-2.png",
          "image_2": "__PUBLIC_URL__/service-sut/image/2023/department-science/micorbiology/footer-3.png"
        },
        "icon": [
          {
            "id": "1",
            "courseID": "1",
            "branchID": "3",
            "detail": "ชื่อหลักสูตร",
            "image": "__PUBLIC_URL__/service-sut/image/icon/school-sci-01.svg"
          },
          {
            "id": "2",
            "courseID": "1",
            "branchID": "3",
            "detail": "ชื่อปริญญาบัตรและสาขา",
            "image": "__PUBLIC_URL__/service-sut/image/icon/school-sci-02.svg"
          },
          {
            "id": "3",
            "courseID": "1",
            "branchID": "3",
            "detail": "โครงสร้างหลักสูตร",
            "image": "__PUBLIC_URL__/service-sut/image/icon/school-sci-03.svg"
          },
          {
            "id": "4",
            "courseID": "1",
            "branchID": "3",
            "detail": "แผนการศึกษา",
            "image": "__PUBLIC_URL__/service-sut/image/icon/school-sci-04.svg"
          },
          {
            "id": "5",
            "courseID": "1",
            "branchID": "3",
            "detail": "อาจารย์ประจำหลักสูตร",
            "image": "__PUBLIC_URL__/service-sut/image/icon/school-sci-05.svg"
          },
          {
            "id": "6",
            "courseID": "1",
            "branchID": "3",
            "detail": "เป้าหมายการรับและ การสำเร็จการศึกษา",
            "image": "__PUBLIC_URL__/service-sut/image/icon/school-sci-06.svg"
          },
          {
            "id": "7",
            "courseID": "1",
            "branchID": "3",
            "detail": "ผลการรับและ สำเร็จการศึกษา",
            "image": "__PUBLIC_URL__/service-sut/image/icon/school-sci-07.svg"
          },
          {
            "id": "8",
            "courseID": "1",
            "branchID": "3",
            "detail": "เป้าหมายการได้งานทำ ของบัณฑิต",
            "image": "__PUBLIC_URL__/service-sut/image/icon/school-sci-08.svg"
          }
        ],
        "header": {
          "header_0": "ชื่อปริญญาและสาขา",
          "header_1": "วิสัยทัศน์",
          "header_2": "พันธกิจ",
          "header_3": "โครงสร้างหลักสูตร",
          "header_4": "แผนการศึกษา",
          "header_5": "ผลการรับและสำเร็จการศึกษา",
          "header_6": "เป้าหมายการรับและการสำเร็จการศึกษา",
          "header_7": "ผลการรับและสำเร็จการศึกษา",
          "header_8": "เป้าหมายการได้งานทำของบัณฑิต"
        },
        "visitor": 1172,
        "visitor_of_year": 194
      }
    },
    "medical-sciences": {
      "code": 200,
      "status": "Get data success",
      "data": {
        "information": {
          "id": "97",
          "courseID": "1",
          "titleTH": "หลักสูตรวิทยาศาสตรบัณฑิต สาขาวิชาวิทยาศาสตร์การแพทย์",
          "titleEN": "Bachelor of Science Program in Medical Sciences",
          "slang": "medical-sciences",
          "nameTH": "หลักสูตรวิทยาศาสตรบัณฑิต สาขาวิชาวิทยาศาสตร์การแพทย์ (หลักสูตรใหม่ พ.ศ. 2566)",
          "nameEN": "Bachelor of Science Program in Medical Sciences",
          "nameDegreeTH": "วิทยาศาสตรบัณฑิต (วิทยาศาสตร์การแพทย์)\r\nวท.บ. (วิทยาศาสตร์การแพทย์)",
          "nameDegreeEN": "Bachelor of Science (Medical Sciences)\r\nB.Sc. (Medical Sciences)",
          "vision": "มุ่งผลิตบัณฑิตที่มีความรู้และทักษะทางวิทยาศาสตร์การแพทย์ เพื่อนำไปสู่การสร้างนวัตกรรม สนใจใฝ่รู้แสวงหาองค์ความรู้ใหม่ทางด้านวิทยาศาสตร์การแพทย์เพื่อการเรียนรู้ตลอดชีวิต ตระหนักถึงหน้าที่และความรับผิดชอบต่อตนเองและสังคม",
          "mission": "1. เพื่อผลิตบัณฑิตที่สามารถอธิบาย ประยุกต์ใช้ คิดวิเคราะห์และสังเคราะห์องค์ความรู้ทางวิทยาศาสตร์การแพทย์ สามารถบูรณาการองค์ความรู้ ทักษะ และการใช้เครื่องมือทางวิทยาศาสตร์การแพทย์ เพื่อแก้ปัญหาในการปฏิบัติงานหรือวิจัยอย่างมีประสิทธิภาพ นำไปสู่การสร้างนวัตกรรมด้านวิทยาศาสตร์การแพทย์ได้อย่างเป็นระบบ\n|2. เพื่อผลิตบัณฑิตทางวิทยาศาสตร์การแพทย์ที่สามารถใช้เทคโนโลยีสารสนเทศและการสื่อสารที่เหมาะสม แสวงหาองค์ความรู้ใหม่ทางด้านวิทยาศาสตร์การแพทย์เพื่อการเรียนรู้ตลอดชีวิต\n|3. เพื่อผลิตบัณฑิตทางวิทยาศาสตร์การแพทย์ที่มีพร้อมทั้งความรู้ คุณธรรม จริยธรรม ทัศนคติ และจิตสำนึกที่ดีต่อตนเองและสังคม",
          "course_structure": "http://reg4.sut.ac.th/registrar/program_info_1.asp?f_cmd=2&acadyear=-1&levelid=1&programid=101210101660&facultyid=10100&programname=%C7%D4%B7%C2%D2%C8%D2%CA%B5%C3%EC%A1%D2%C3%E1%BE%B7%C2%EC%2D2566&facultyname=%CA%D3%B9%D1%A1%C7%D4%AA%D2%C7%D4%B7%C2%D2%C8%D2%CA%B5%C3%EC&levelname=%BB%C3%D4%AD%AD%D2%B5%C3%D5",
          "study_plan": "http://reg4.sut.ac.th/registrar/studyplan_info1.asp?avs669746568=50&acadyear=-1&levelid=1&programid=101210101660&facultyid=10100&programname=%C7%D4%B7%C2%D2%C8%D2%CA%B5%C3%EC%A1%D2%C3%E1%BE%B7%C2%EC%2D2566&facultyname=%CA%D3%B9%D1%A1%C7%D4%AA%D2%C7%D4%B7%C2%D2%C8%D2%CA%B5%C3%EC&levelname=%BB%C3%D4%AD%AD%D2%B5%C3%D5",
          "teacher": "",
          "graduation_goals": "",
          "graduation_results": "",
          "employment_goals": "",
          "image": "__PUBLIC_URL__/service-sut/image/2023/department-science/medical-sciences/slide-1.png",
          "footer": "__PUBLIC_URL__/service-sut/image/2023/department-science/medical-sciences/footer-1.png,__PUBLIC_URL__/service-sut/image/2023/department-science/medical-sciences/footer-2.png,__PUBLIC_URL__/service-sut/image/2023/department-science/medical-sciences/footer-3.png",
          "createAt": null,
          "updateAt": null,
          "year": "2025"
        },
        "vision": {
          "vision_0": "มุ่งผลิตบัณฑิตที่มีความรู้และทักษะทางวิทยาศาสตร์การแพทย์ เพื่อนำไปสู่การสร้างนวัตกรรม สนใจใฝ่รู้แสวงหาองค์ความรู้ใหม่ทางด้านวิทยาศาสตร์การแพทย์เพื่อการเรียนรู้ตลอดชีวิต ตระหนักถึงหน้าที่และความรับผิดชอบต่อตนเองและสังคม"
        },
        "mission": {
          "mission_0": "1. เพื่อผลิตบัณฑิตที่สามารถอธิบาย ประยุกต์ใช้ คิดวิเคราะห์และสังเคราะห์องค์ความรู้ทางวิทยาศาสตร์การแพทย์ สามารถบูรณาการองค์ความรู้ ทักษะ และการใช้เครื่องมือทางวิทยาศาสตร์การแพทย์ เพื่อแก้ปัญหาในการปฏิบัติงานหรือวิจัยอย่างมีประสิทธิภาพ นำไปสู่การสร้างนวัตกรรมด้านวิทยาศาสตร์การแพทย์ได้อย่างเป็นระบบ\n",
          "mission_1": "2. เพื่อผลิตบัณฑิตทางวิทยาศาสตร์การแพทย์ที่สามารถใช้เทคโนโลยีสารสนเทศและการสื่อสารที่เหมาะสม แสวงหาองค์ความรู้ใหม่ทางด้านวิทยาศาสตร์การแพทย์เพื่อการเรียนรู้ตลอดชีวิต\n",
          "mission_2": "3. เพื่อผลิตบัณฑิตทางวิทยาศาสตร์การแพทย์ที่มีพร้อมทั้งความรู้ คุณธรรม จริยธรรม ทัศนคติ และจิตสำนึกที่ดีต่อตนเองและสังคม"
        },
        "image": {
          "image_0": "__PUBLIC_URL__/service-sut/image/2023/department-science/medical-sciences/slide-1.png"
        },
        "footer": {
          "image_0": "__PUBLIC_URL__/service-sut/image/2023/department-science/medical-sciences/footer-1.png",
          "image_1": "__PUBLIC_URL__/service-sut/image/2023/department-science/medical-sciences/footer-2.png",
          "image_2": "__PUBLIC_URL__/service-sut/image/2023/department-science/medical-sciences/footer-3.png"
        },
        "icon": [
          {
            "id": "1",
            "courseID": "1",
            "branchID": "3",
            "detail": "ชื่อหลักสูตร",
            "image": "__PUBLIC_URL__/service-sut/image/icon/school-sci-01.svg"
          },
          {
            "id": "2",
            "courseID": "1",
            "branchID": "3",
            "detail": "ชื่อปริญญาบัตรและสาขา",
            "image": "__PUBLIC_URL__/service-sut/image/icon/school-sci-02.svg"
          },
          {
            "id": "3",
            "courseID": "1",
            "branchID": "3",
            "detail": "โครงสร้างหลักสูตร",
            "image": "__PUBLIC_URL__/service-sut/image/icon/school-sci-03.svg"
          },
          {
            "id": "4",
            "courseID": "1",
            "branchID": "3",
            "detail": "แผนการศึกษา",
            "image": "__PUBLIC_URL__/service-sut/image/icon/school-sci-04.svg"
          },
          {
            "id": "5",
            "courseID": "1",
            "branchID": "3",
            "detail": "อาจารย์ประจำหลักสูตร",
            "image": "__PUBLIC_URL__/service-sut/image/icon/school-sci-05.svg"
          },
          {
            "id": "6",
            "courseID": "1",
            "branchID": "3",
            "detail": "เป้าหมายการรับและ การสำเร็จการศึกษา",
            "image": "__PUBLIC_URL__/service-sut/image/icon/school-sci-06.svg"
          },
          {
            "id": "7",
            "courseID": "1",
            "branchID": "3",
            "detail": "ผลการรับและ สำเร็จการศึกษา",
            "image": "__PUBLIC_URL__/service-sut/image/icon/school-sci-07.svg"
          },
          {
            "id": "8",
            "courseID": "1",
            "branchID": "3",
            "detail": "เป้าหมายการได้งานทำ ของบัณฑิต",
            "image": "__PUBLIC_URL__/service-sut/image/icon/school-sci-08.svg"
          }
        ],
        "header": {
          "header_0": "ชื่อปริญญาและสาขา",
          "header_1": "วิสัยทัศน์",
          "header_2": "พันธกิจ",
          "header_3": "โครงสร้างหลักสูตร",
          "header_4": "แผนการศึกษา",
          "header_5": "ผลการรับและสำเร็จการศึกษา",
          "header_6": "เป้าหมายการรับและการสำเร็จการศึกษา",
          "header_7": "ผลการรับและสำเร็จการศึกษา",
          "header_8": "เป้าหมายการได้งานทำของบัณฑิต"
        },
        "visitor": 3236,
        "visitor_of_year": 233
      }
    },
    "computer-science": {
      "code": 200,
      "status": "Get data success",
      "data": {
        "information": {
          "id": "98",
          "courseID": "1",
          "titleTH": "หลักสูตรวิทยาศาสตรบัณฑิต สาขาวิชาวิทยาการคอมพิวเตอร์",
          "titleEN": "Bachelor of Science Program in Computer Science",
          "slang": "computer-science",
          "nameTH": "หลักสูตรวิทยาศาสตรบัณฑิต สาขาวิชาวิทยาการคอมพิวเตอร์ (หลักสูตรใหม่ พ.ศ. 2566)",
          "nameEN": "Bachelor of Science Program in Computer Science",
          "nameDegreeTH": "วิทยาศาสตรบัณฑิต (วิทยาการคอมพิวเตอร์)\r\nวท.บ. (วิทยาการคอมพิวเตอร์)",
          "nameDegreeEN": "Bachelor of Science (Computer Science)\r\nB.Sc. (Computer Science)",
          "vision": "หลักสูตรมุ่งผลิตบัณฑิตที่มีความเข้าใจอย่างถ่องแท้ ความรู้เชิงทฤษฎี ความสามารถเชิงปฏิบัติเฉพาะทางในการพัฒนาและประยุกต์ใช้วิทยาการคอมพิวเตอร์ และมีจริยธรรมในวิชาชีพ สามารถตอบสนองความต้องการและเป็นกำลังสำคัญในการพัฒนาประเทศ",
          "mission": "1. เพื่อผลิตบัณฑิตที่มีความรู้ ความสามารถ และทักษะด้านวิทยาการคอมพิวเตอร์\n|2. เพื่อผลิตบัณฑิตที่มีคุณธรรม จริยธรรม และความรับผิดชอบต่อตนเอง สังคม และวิชาชีพด้านวิทยาการคอมพิวเตอร์\n|3. เพื่อผลิตบัณฑิตที่มีแนวคิดเชิงออกแบบ มีความเข้าอกเข้าใจ มีทักษะในการคิดวิเคราะห์ และการวางแผนการทำงานอย่างเป็นระบบ\n|4. เพื่อผลิตบัณฑิตที่มีแนวคิดของผู้ประกอบการ กล้านำเสนอทางเลือกแก่สังคมเพื่อประสบการณ์ที่ดีกว่าโดยการขับเคลื่อนด้วยข้อมูล\n|5. เพื่อตอบสนองความต้องการกำลังคนทางด้านวิทยาการคอมพิวเตอร์ของหน่วยงานภาครัฐ ภาคเอกชน และการประกอบอาชีพอิสระที่สร้างคุณค่าแก่สังคมอย่างยั่งยืน",
          "course_structure": "http://reg4.sut.ac.th/registrar/program_info_1.asp?f_cmd=2&acadyear=-1&levelid=1&programid=101220101660&facultyid=10100&programname=%C7%D4%B7%C2%D2%A1%D2%C3%A4%CD%C1%BE%D4%C7%E0%B5%CD%C3%EC%2D2566&facultyname=%CA%D3%B9%D1%A1%C7%D4%AA%D2%C7%D4%B7%C2%D2%C8%D2%CA%B5%C3%EC&levelname=%BB%C3%D4%AD%AD%D2%B5%C3%D5\r\n",
          "study_plan": "http://reg4.sut.ac.th/registrar/studyplan_info1.asp?avs669746568=61&acadyear=-1&levelid=1&programid=101220101660&facultyid=10100&programname=%C7%D4%B7%C2%D2%A1%D2%C3%A4%CD%C1%BE%D4%C7%E0%B5%CD%C3%EC%2D2566&facultyname=%CA%D3%B9%D1%A1%C7%D4%AA%D2%C7%D4%B7%C2%D2%C8%D2%CA%B5%C3%EC&levelname=%BB%C3%D4%AD%AD%D2%B5%C3%D5\r\n",
          "teacher": "",
          "graduation_goals": "",
          "graduation_results": "",
          "employment_goals": "",
          "image": "__PUBLIC_URL__/service-sut/image/2023/department-science/computer-science/slide-1.png",
          "footer": "__PUBLIC_URL__/service-sut/image/2023/department-science/computer-science/footer-1.png,__PUBLIC_URL__/service-sut/image/2023/department-science/computer-science/footer-2.png,__PUBLIC_URL__/service-sut/image/2023/department-science/computer-science/footer-3.png",
          "createAt": null,
          "updateAt": null,
          "year": "2025"
        },
        "vision": {
          "vision_0": "หลักสูตรมุ่งผลิตบัณฑิตที่มีความเข้าใจอย่างถ่องแท้ ความรู้เชิงทฤษฎี ความสามารถเชิงปฏิบัติเฉพาะทางในการพัฒนาและประยุกต์ใช้วิทยาการคอมพิวเตอร์ และมีจริยธรรมในวิชาชีพ สามารถตอบสนองความต้องการและเป็นกำลังสำคัญในการพัฒนาประเทศ"
        },
        "mission": {
          "mission_0": "1. เพื่อผลิตบัณฑิตที่มีความรู้ ความสามารถ และทักษะด้านวิทยาการคอมพิวเตอร์\n",
          "mission_1": "2. เพื่อผลิตบัณฑิตที่มีคุณธรรม จริยธรรม และความรับผิดชอบต่อตนเอง สังคม และวิชาชีพด้านวิทยาการคอมพิวเตอร์\n",
          "mission_2": "3. เพื่อผลิตบัณฑิตที่มีแนวคิดเชิงออกแบบ มีความเข้าอกเข้าใจ มีทักษะในการคิดวิเคราะห์ และการวางแผนการทำงานอย่างเป็นระบบ\n",
          "mission_3": "4. เพื่อผลิตบัณฑิตที่มีแนวคิดของผู้ประกอบการ กล้านำเสนอทางเลือกแก่สังคมเพื่อประสบการณ์ที่ดีกว่าโดยการขับเคลื่อนด้วยข้อมูล\n",
          "mission_4": "5. เพื่อตอบสนองความต้องการกำลังคนทางด้านวิทยาการคอมพิวเตอร์ของหน่วยงานภาครัฐ ภาคเอกชน และการประกอบอาชีพอิสระที่สร้างคุณค่าแก่สังคมอย่างยั่งยืน"
        },
        "image": {
          "image_0": "__PUBLIC_URL__/service-sut/image/2023/department-science/computer-science/slide-1.png"
        },
        "footer": {
          "image_0": "__PUBLIC_URL__/service-sut/image/2023/department-science/computer-science/footer-1.png",
          "image_1": "__PUBLIC_URL__/service-sut/image/2023/department-science/computer-science/footer-2.png",
          "image_2": "__PUBLIC_URL__/service-sut/image/2023/department-science/computer-science/footer-3.png"
        },
        "icon": [
          {
            "id": "1",
            "courseID": "1",
            "branchID": "3",
            "detail": "ชื่อหลักสูตร",
            "image": "__PUBLIC_URL__/service-sut/image/icon/school-sci-01.svg"
          },
          {
            "id": "2",
            "courseID": "1",
            "branchID": "3",
            "detail": "ชื่อปริญญาบัตรและสาขา",
            "image": "__PUBLIC_URL__/service-sut/image/icon/school-sci-02.svg"
          },
          {
            "id": "3",
            "courseID": "1",
            "branchID": "3",
            "detail": "โครงสร้างหลักสูตร",
            "image": "__PUBLIC_URL__/service-sut/image/icon/school-sci-03.svg"
          },
          {
            "id": "4",
            "courseID": "1",
            "branchID": "3",
            "detail": "แผนการศึกษา",
            "image": "__PUBLIC_URL__/service-sut/image/icon/school-sci-04.svg"
          },
          {
            "id": "5",
            "courseID": "1",
            "branchID": "3",
            "detail": "อาจารย์ประจำหลักสูตร",
            "image": "__PUBLIC_URL__/service-sut/image/icon/school-sci-05.svg"
          },
          {
            "id": "6",
            "courseID": "1",
            "branchID": "3",
            "detail": "เป้าหมายการรับและ การสำเร็จการศึกษา",
            "image": "__PUBLIC_URL__/service-sut/image/icon/school-sci-06.svg"
          },
          {
            "id": "7",
            "courseID": "1",
            "branchID": "3",
            "detail": "ผลการรับและ สำเร็จการศึกษา",
            "image": "__PUBLIC_URL__/service-sut/image/icon/school-sci-07.svg"
          },
          {
            "id": "8",
            "courseID": "1",
            "branchID": "3",
            "detail": "เป้าหมายการได้งานทำ ของบัณฑิต",
            "image": "__PUBLIC_URL__/service-sut/image/icon/school-sci-08.svg"
          }
        ],
        "header": {
          "header_0": "ชื่อปริญญาและสาขา",
          "header_1": "วิสัยทัศน์",
          "header_2": "พันธกิจ",
          "header_3": "โครงสร้างหลักสูตร",
          "header_4": "แผนการศึกษา",
          "header_5": "ผลการรับและสำเร็จการศึกษา",
          "header_6": "เป้าหมายการรับและการสำเร็จการศึกษา",
          "header_7": "ผลการรับและสำเร็จการศึกษา",
          "header_8": "เป้าหมายการได้งานทำของบัณฑิต"
        },
        "visitor": 4100,
        "visitor_of_year": 613
      }
    },
    "mechanical-and-aeronautical-engineering": {
      "code": 200,
      "status": "Get data success",
      "data": {
        "information": {
          "id": "99",
          "courseID": "4",
          "titleTH": "สาขาวิชาวิศวกรรมเครื่องกลและอากาศยาน\n(หลักสูตรนานาชาติ)",
          "titleEN": "Mechanical and Aeronautical Engineering (International Program)",
          "slang": "mechanical-and-aeronautical-engineering",
          "nameTH": "หลักสูตรวิศวกรรมศาสตรบัณฑิต สาขาวิชาวิศวกรรมเครื่องกลและอากาศยาน (หลักสูตรนานาชาติ)",
          "nameEN": "Bachelor of Engineering Program in Mechanical and Aeronautical Engineering (International Program)",
          "nameDegreeTH": "วิศวกรรมศาสตรบัณฑิต (วิศวกรรมเครื่องกลและอากาศยาน)",
          "nameDegreeEN": "Bachelor of Engineering (Mechanical and Aeronautical Engineering)",
          "vision": "มุ่งเป็นแหล่งผลิตบัณฑิตที่เน้นทักษะการทำงานด้านวิศวกรรมไฟฟ้าควบคู่กับการบริหารจัดการอุตสาหกรรมที่สามารถทำงานได้จริง",
          "mission": "ผลิตบัณฑิตที่เชี่ยวชาญด้านวิศวกรรมไฟฟ้าควบคู่ด้วยทักษะด้านการบริหารจัดการอุตสาหกรรม โดยเน้นการผลิตบัณฑิตที่มีความรู้ความชำนาญด้านระบบไฟฟ้า ระบบอิเล็กทรอนิกส์ ระบบควบคุมและอัตโนมัติในโรงงานอุตสาหกรรม และมีทักษะด้านการจัดการทางอุตสาหกรรม ระบบการผลิต และการปรับปรุงประสิทธิภาพ มีความสามารถในการปฏิบัติงาน รวมถึงการประยุกต์ใช้เทคโนโลยีอย่างเหมาะสมและมีประสิทธิภาพ",
          "course_structure": "https://drive.google.com/file/d/19Bo_T_3Yh1f7ntog0zlyhkXLx8XHjKFX/view?usp=sharing",
          "study_plan": "https://reg5.sut.ac.th/registrar/studyplan_info1.asp?avs469685745=3&acadyear=2565&levelid=1&programid=107070301650&facultyid=10700&programname=%C7%D4%C8%C7%A1%C3%C3%C1%E0%A4%C3%D7%E8%CD%A7%A1%C5%E1%C5%D0%CD%D2%A1%D2%C8%C2%D2%B9%2D2565+%28%CB%C5%D1%A1%CA%D9%B5%C3%B9%D2%B9%D2%AA%D2%B5%D4%29&facultyname=%CA%D3%B9%D1%A1%C7%D4%AA%D2%C7%D4%C8%C7%A1%C3%C3%C1%C8%D2%CA%B5%C3%EC&levelname=%BB%C3%D4%AD%AD%D2%B5%C3%D5",
          "teacher": "https://beta.sut.ac.th/ie/employees",
          "graduation_goals": "",
          "graduation_results": "",
          "employment_goals": "",
          "image": "__PUBLIC_URL__/service-sut/image/image-2023/department-engineering/mechanical/slide1.png",
          "footer": "__PUBLIC_URL__/service-sut/image/image-2023/department-engineering/mechanical/footer1.png,__PUBLIC_URL__/service-sut/image/image-2023/department-engineering/mechanical/footer2.png,__PUBLIC_URL__/service-sut/image/image-2023/department-engineering/mechanical/footer3.png",
          "createAt": null,
          "updateAt": null,
          "year": "2025"
        },
        "vision": {
          "vision_0": "มุ่งเป็นแหล่งผลิตบัณฑิตที่เน้นทักษะการทำงานด้านวิศวกรรมไฟฟ้าควบคู่กับการบริหารจัดการอุตสาหกรรมที่สามารถทำงานได้จริง"
        },
        "mission": {
          "mission_0": "ผลิตบัณฑิตที่เชี่ยวชาญด้านวิศวกรรมไฟฟ้าควบคู่ด้วยทักษะด้านการบริหารจัดการอุตสาหกรรม โดยเน้นการผลิตบัณฑิตที่มีความรู้ความชำนาญด้านระบบไฟฟ้า ระบบอิเล็กทรอนิกส์ ระบบควบคุมและอัตโนมัติในโรงงานอุตสาหกรรม และมีทักษะด้านการจัดการทางอุตสาหกรรม ระบบการผลิต และการปรับปรุงประสิทธิภาพ มีความสามารถในการปฏิบัติงาน รวมถึงการประยุกต์ใช้เทคโนโลยีอย่างเหมาะสมและมีประสิทธิภาพ"
        },
        "image": {
          "image_0": "__PUBLIC_URL__/service-sut/image/image-2023/department-engineering/mechanical/slide1.png"
        },
        "footer": {
          "image_0": "__PUBLIC_URL__/service-sut/image/image-2023/department-engineering/mechanical/footer1.png",
          "image_1": "__PUBLIC_URL__/service-sut/image/image-2023/department-engineering/mechanical/footer2.png",
          "image_2": "__PUBLIC_URL__/service-sut/image/image-2023/department-engineering/mechanical/footer3.png"
        },
        "icon": [
          {
            "id": "26",
            "courseID": "4",
            "branchID": "0",
            "detail": "ชื่อหลักสูตร",
            "image": "__PUBLIC_URL__/service-sut/image/icon/school-engi-01.svg"
          },
          {
            "id": "27",
            "courseID": "4",
            "branchID": "0",
            "detail": "ชื่อปริญญาบัตรและสาขา",
            "image": "__PUBLIC_URL__/service-sut/image/icon/school-engi-02.svg"
          },
          {
            "id": "28",
            "courseID": "4",
            "branchID": "0",
            "detail": "โครงสร้างหลักสูตร",
            "image": "__PUBLIC_URL__/service-sut/image/icon/school-engi-03.svg"
          },
          {
            "id": "29",
            "courseID": "4",
            "branchID": "0",
            "detail": "แผนการศึกษา",
            "image": "__PUBLIC_URL__/service-sut/image/icon/school-engi-04.svg"
          },
          {
            "id": "30",
            "courseID": "4",
            "branchID": "0",
            "detail": "อาจารย์ประจำหลักสูตร",
            "image": "__PUBLIC_URL__/service-sut/image/icon/school-engi-05.svg"
          },
          {
            "id": "31",
            "courseID": "4",
            "branchID": "0",
            "detail": "เป้าหมายการรับและ การสำเร็จการศึกษา",
            "image": "__PUBLIC_URL__/service-sut/image/icon/school-engi-06.svg"
          },
          {
            "id": "32",
            "courseID": "4",
            "branchID": "0",
            "detail": "ผลการรับและ สำเร็จการศึกษา",
            "image": "__PUBLIC_URL__/service-sut/image/icon/school-engi-07.svg"
          },
          {
            "id": "33",
            "courseID": "4",
            "branchID": "0",
            "detail": "เป้าหมายการได้งานทำ ของบัณฑิต",
            "image": "__PUBLIC_URL__/service-sut/image/icon/school-engi-08.svg"
          }
        ],
        "header": {
          "header_0": "ชื่อปริญญาและสาขา",
          "header_1": "วิสัยทัศน์",
          "header_2": "พันธกิจ",
          "header_3": "โครงสร้างหลักสูตร",
          "header_4": "แผนการศึกษา",
          "header_5": "ผลการรับและสำเร็จการศึกษา",
          "header_6": "เป้าหมายการรับและการสำเร็จการศึกษา",
          "header_7": "ผลการรับและสำเร็จการศึกษา",
          "header_8": "เป้าหมายการได้งานทำของบัณฑิต"
        },
        "visitor": 1319,
        "visitor_of_year": 203
      }
    },
    "civil-engineering-inter": {
      "code": 200,
      "status": "Get data success",
      "data": {
        "information": {
          "id": "100",
          "courseID": "4",
          "titleTH": "สาขาวิชาวิศวกรรมโยธา (นานาชาติ)",
          "titleEN": "Civil Engineering (International Program)",
          "slang": "civil-engineering-inter",
          "nameTH": "หลักสูตรวิศวกรรมศาสตรบัณฑิต สาขาวิชาวิศวกรรมโยธา (หลักสูตรนานาชาติ)",
          "nameEN": "Bachalor of Engineering Program in Civil Engineering (International Program)",
          "nameDegreeTH": "วิศวกรรมศาสตรบัณฑิต (วิศวกรรมโยธา)",
          "nameDegreeEN": "Bachelor of Engineering (Civil Engineering)",
          "vision": "มุ่งเป็นแหล่งผลิตบัณฑิตที่เน้นทักษะการทำงานด้านวิศวกรรมไฟฟ้าควบคู่กับการบริหารจัดการอุตสาหกรรมที่สามารถทำงานได้จริง",
          "mission": "ผลิตบัณฑิตที่เชี่ยวชาญด้านวิศวกรรมไฟฟ้าควบคู่ด้วยทักษะด้านการบริหารจัดการอุตสาหกรรม โดยเน้นการผลิตบัณฑิตที่มีความรู้ความชำนาญด้านระบบไฟฟ้า ระบบอิเล็กทรอนิกส์ ระบบควบคุมและอัตโนมัติในโรงงานอุตสาหกรรม และมีทักษะด้านการจัดการทางอุตสาหกรรม ระบบการผลิต และการปรับปรุงประสิทธิภาพ มีความสามารถในการปฏิบัติงาน รวมถึงการประยุกต์ใช้เทคโนโลยีอย่างเหมาะสมและมีประสิทธิภาพ",
          "course_structure": "https://drive.google.com/file/d/1_Xhf7JykH0NG2AkqyFhXQj-BZ98FWX2Y/view?usp=sharing",
          "study_plan": "https://reg5.sut.ac.th/registrar/studyplan_info1.asp?avs469685745=6&acadyear=2565&levelid=1&programid=107120301650&facultyid=10700&programname=%C7%D4%C8%C7%A1%C3%C3%C1%E2%C2%B8%D2%2D2565+%28%CB%C5%D1%A1%CA%D9%B5%C3%B9%D2%B9%D2%AA%D2%B5%D4%29&facultyname=%CA%D3%B9%D1%A1%C7%D4%AA%D2%C7%D4%C8%C7%A1%C3%C3%C1%C8%D2%CA%B5%C3%EC&levelname=%BB%C3%D4%AD%AD%D2%B5%C3%D5",
          "teacher": "https://beta.sut.ac.th/ie/employees",
          "graduation_goals": "",
          "graduation_results": "",
          "employment_goals": "",
          "image": "__PUBLIC_URL__/service-sut/image/image-2023/department-engineering/civil-inter/slide1.png",
          "footer": "__PUBLIC_URL__/service-sut/image/image-2023/department-engineering/civil-inter/footer1.png,__PUBLIC_URL__/service-sut/image/image-2023/department-engineering/civil-inter/footer2.png,__PUBLIC_URL__/service-sut/image/image-2023/department-engineering/civil-inter/footer3.png",
          "createAt": null,
          "updateAt": null,
          "year": "2025"
        },
        "vision": {
          "vision_0": "มุ่งเป็นแหล่งผลิตบัณฑิตที่เน้นทักษะการทำงานด้านวิศวกรรมไฟฟ้าควบคู่กับการบริหารจัดการอุตสาหกรรมที่สามารถทำงานได้จริง"
        },
        "mission": {
          "mission_0": "ผลิตบัณฑิตที่เชี่ยวชาญด้านวิศวกรรมไฟฟ้าควบคู่ด้วยทักษะด้านการบริหารจัดการอุตสาหกรรม โดยเน้นการผลิตบัณฑิตที่มีความรู้ความชำนาญด้านระบบไฟฟ้า ระบบอิเล็กทรอนิกส์ ระบบควบคุมและอัตโนมัติในโรงงานอุตสาหกรรม และมีทักษะด้านการจัดการทางอุตสาหกรรม ระบบการผลิต และการปรับปรุงประสิทธิภาพ มีความสามารถในการปฏิบัติงาน รวมถึงการประยุกต์ใช้เทคโนโลยีอย่างเหมาะสมและมีประสิทธิภาพ"
        },
        "image": {
          "image_0": "__PUBLIC_URL__/service-sut/image/image-2023/department-engineering/civil-inter/slide1.png"
        },
        "footer": {
          "image_0": "__PUBLIC_URL__/service-sut/image/image-2023/department-engineering/civil-inter/footer1.png",
          "image_1": "__PUBLIC_URL__/service-sut/image/image-2023/department-engineering/civil-inter/footer2.png",
          "image_2": "__PUBLIC_URL__/service-sut/image/image-2023/department-engineering/civil-inter/footer3.png"
        },
        "icon": [
          {
            "id": "26",
            "courseID": "4",
            "branchID": "0",
            "detail": "ชื่อหลักสูตร",
            "image": "__PUBLIC_URL__/service-sut/image/icon/school-engi-01.svg"
          },
          {
            "id": "27",
            "courseID": "4",
            "branchID": "0",
            "detail": "ชื่อปริญญาบัตรและสาขา",
            "image": "__PUBLIC_URL__/service-sut/image/icon/school-engi-02.svg"
          },
          {
            "id": "28",
            "courseID": "4",
            "branchID": "0",
            "detail": "โครงสร้างหลักสูตร",
            "image": "__PUBLIC_URL__/service-sut/image/icon/school-engi-03.svg"
          },
          {
            "id": "29",
            "courseID": "4",
            "branchID": "0",
            "detail": "แผนการศึกษา",
            "image": "__PUBLIC_URL__/service-sut/image/icon/school-engi-04.svg"
          },
          {
            "id": "30",
            "courseID": "4",
            "branchID": "0",
            "detail": "อาจารย์ประจำหลักสูตร",
            "image": "__PUBLIC_URL__/service-sut/image/icon/school-engi-05.svg"
          },
          {
            "id": "31",
            "courseID": "4",
            "branchID": "0",
            "detail": "เป้าหมายการรับและ การสำเร็จการศึกษา",
            "image": "__PUBLIC_URL__/service-sut/image/icon/school-engi-06.svg"
          },
          {
            "id": "32",
            "courseID": "4",
            "branchID": "0",
            "detail": "ผลการรับและ สำเร็จการศึกษา",
            "image": "__PUBLIC_URL__/service-sut/image/icon/school-engi-07.svg"
          },
          {
            "id": "33",
            "courseID": "4",
            "branchID": "0",
            "detail": "เป้าหมายการได้งานทำ ของบัณฑิต",
            "image": "__PUBLIC_URL__/service-sut/image/icon/school-engi-08.svg"
          }
        ],
        "header": {
          "header_0": "ชื่อปริญญาและสาขา",
          "header_1": "วิสัยทัศน์",
          "header_2": "พันธกิจ",
          "header_3": "โครงสร้างหลักสูตร",
          "header_4": "แผนการศึกษา",
          "header_5": "ผลการรับและสำเร็จการศึกษา",
          "header_6": "เป้าหมายการรับและการสำเร็จการศึกษา",
          "header_7": "ผลการรับและสำเร็จการศึกษา",
          "header_8": "เป้าหมายการได้งานทำของบัณฑิต"
        },
        "visitor": 467,
        "visitor_of_year": 83
      }
    },
    "civil-and-infrastructure-engineering": {
      "code": 200,
      "status": "Get data success",
      "data": {
        "information": {
          "id": "101",
          "courseID": "4",
          "titleTH": "สาขาวิชาวิศวกรรมโยธาและโครงสร้างพื้นฐาน",
          "titleEN": "Civil and Infrastructure Engineering",
          "slang": "civil-and-infrastructure-engineering",
          "nameTH": "วิศวกรรมศาสตรบัณฑิต สาขาวิชาวิศวกรรมโยธาและโครงสร้างพื้นฐาน",
          "nameEN": "Bachelor of Engineering Program in Civil and Infrastructure Engineering",
          "nameDegreeTH": "วิศวกรรมศาสตรบัณฑิต (วิศวกรรมโยธาและโครงสร้างพื้นฐาน) \nวศ.บ. (วิศวกรรมโยธาและโครงสร้างพื้นฐาน)",
          "nameDegreeEN": "Bachelor of Engineering (Civil and Infrastructure Engineering)\nB.Eng. (Civil and Infrastructure Engineering)",
          "vision": "มุ่งเป็นแหล่งผลิตบัณฑิตที่เน้นทักษะการทำงานด้านวิศวกรรมไฟฟ้าควบคู่กับการบริหารจัดการอุตสาหกรรมที่สามารถทำงานได้จริง",
          "mission": "ผลิตบัณฑิตที่เชี่ยวชาญด้านวิศวกรรมไฟฟ้าควบคู่ด้วยทักษะด้านการบริหารจัดการอุตสาหกรรม โดยเน้นการผลิตบัณฑิตที่มีความรู้ความชำนาญด้านระบบไฟฟ้า ระบบอิเล็กทรอนิกส์ ระบบควบคุมและอัตโนมัติในโรงงานอุตสาหกรรม และมีทักษะด้านการจัดการทางอุตสาหกรรม ระบบการผลิต และการปรับปรุงประสิทธิภาพ มีความสามารถในการปฏิบัติงาน รวมถึงการประยุกต์ใช้เทคโนโลยีอย่างเหมาะสมและมีประสิทธิภาพ",
          "course_structure": "https://drive.google.com/file/d/1hLPCI1KAtMOnV8pTDR3RSV0MmGS2VGAz/view?usp=sharing",
          "study_plan": "https://drive.google.com/file/d/1hLPCI1KAtMOnV8pTDR3RSV0MmGS2VGAz/view?usp=sharing",
          "teacher": "https://beta.sut.ac.th/ie/employees",
          "graduation_goals": "",
          "graduation_results": "",
          "employment_goals": "",
          "image": "__PUBLIC_URL__/service-sut/image/image-2023/department-engineering/civil/slide1.png",
          "footer": "__PUBLIC_URL__/service-sut/image/image-2023/department-engineering/civil/footer1.png,__PUBLIC_URL__/service-sut/image/image-2023/department-engineering/civil/footer2.png,__PUBLIC_URL__/service-sut/image/image-2023/department-engineering/civil/footer3.png",
          "createAt": null,
          "updateAt": null,
          "year": "2025"
        },
        "vision": {
          "vision_0": "มุ่งเป็นแหล่งผลิตบัณฑิตที่เน้นทักษะการทำงานด้านวิศวกรรมไฟฟ้าควบคู่กับการบริหารจัดการอุตสาหกรรมที่สามารถทำงานได้จริง"
        },
        "mission": {
          "mission_0": "ผลิตบัณฑิตที่เชี่ยวชาญด้านวิศวกรรมไฟฟ้าควบคู่ด้วยทักษะด้านการบริหารจัดการอุตสาหกรรม โดยเน้นการผลิตบัณฑิตที่มีความรู้ความชำนาญด้านระบบไฟฟ้า ระบบอิเล็กทรอนิกส์ ระบบควบคุมและอัตโนมัติในโรงงานอุตสาหกรรม และมีทักษะด้านการจัดการทางอุตสาหกรรม ระบบการผลิต และการปรับปรุงประสิทธิภาพ มีความสามารถในการปฏิบัติงาน รวมถึงการประยุกต์ใช้เทคโนโลยีอย่างเหมาะสมและมีประสิทธิภาพ"
        },
        "image": {
          "image_0": "__PUBLIC_URL__/service-sut/image/image-2023/department-engineering/civil/slide1.png"
        },
        "footer": {
          "image_0": "__PUBLIC_URL__/service-sut/image/image-2023/department-engineering/civil/footer1.png",
          "image_1": "__PUBLIC_URL__/service-sut/image/image-2023/department-engineering/civil/footer2.png",
          "image_2": "__PUBLIC_URL__/service-sut/image/image-2023/department-engineering/civil/footer3.png"
        },
        "icon": [
          {
            "id": "26",
            "courseID": "4",
            "branchID": "0",
            "detail": "ชื่อหลักสูตร",
            "image": "__PUBLIC_URL__/service-sut/image/icon/school-engi-01.svg"
          },
          {
            "id": "27",
            "courseID": "4",
            "branchID": "0",
            "detail": "ชื่อปริญญาบัตรและสาขา",
            "image": "__PUBLIC_URL__/service-sut/image/icon/school-engi-02.svg"
          },
          {
            "id": "28",
            "courseID": "4",
            "branchID": "0",
            "detail": "โครงสร้างหลักสูตร",
            "image": "__PUBLIC_URL__/service-sut/image/icon/school-engi-03.svg"
          },
          {
            "id": "29",
            "courseID": "4",
            "branchID": "0",
            "detail": "แผนการศึกษา",
            "image": "__PUBLIC_URL__/service-sut/image/icon/school-engi-04.svg"
          },
          {
            "id": "30",
            "courseID": "4",
            "branchID": "0",
            "detail": "อาจารย์ประจำหลักสูตร",
            "image": "__PUBLIC_URL__/service-sut/image/icon/school-engi-05.svg"
          },
          {
            "id": "31",
            "courseID": "4",
            "branchID": "0",
            "detail": "เป้าหมายการรับและ การสำเร็จการศึกษา",
            "image": "__PUBLIC_URL__/service-sut/image/icon/school-engi-06.svg"
          },
          {
            "id": "32",
            "courseID": "4",
            "branchID": "0",
            "detail": "ผลการรับและ สำเร็จการศึกษา",
            "image": "__PUBLIC_URL__/service-sut/image/icon/school-engi-07.svg"
          },
          {
            "id": "33",
            "courseID": "4",
            "branchID": "0",
            "detail": "เป้าหมายการได้งานทำ ของบัณฑิต",
            "image": "__PUBLIC_URL__/service-sut/image/icon/school-engi-08.svg"
          }
        ],
        "header": {
          "header_0": "ชื่อปริญญาและสาขา",
          "header_1": "วิสัยทัศน์",
          "header_2": "พันธกิจ",
          "header_3": "โครงสร้างหลักสูตร",
          "header_4": "แผนการศึกษา",
          "header_5": "ผลการรับและสำเร็จการศึกษา",
          "header_6": "เป้าหมายการรับและการสำเร็จการศึกษา",
          "header_7": "ผลการรับและสำเร็จการศึกษา",
          "header_8": "เป้าหมายการได้งานทำของบัณฑิต"
        },
        "visitor": 1255,
        "visitor_of_year": 63
      }
    },
    "intelligent-embedded-engineering": {
      "code": 200,
      "status": "Get data success",
      "data": {
        "information": {
          "id": "102",
          "courseID": "4",
          "titleTH": "หลักสูตรวิชาวิศวกรรมสมองกลอัจฉริยะและอิเล็กทรอนิกส์ความถี่สูง",
          "titleEN": "Intelligent Embedded Systems And High Frequency Electronic Engineering",
          "slang": "intelligent-embedded-engineering",
          "nameTH": "วิศวกรรมระบบสมองกลอัจฉริยะและอิเล็กทรอนิกส์ความถี่สูง",
          "nameEN": "Intelligent Embedded Systems And High Frequency Electronic Engineering",
          "nameDegreeTH": "วิศวกรรมศาสตรบัณฑิต (วิศวกรรมระบบสมองกลอัจฉริยะและอิเล็กทรอนิกส์ความถี่สูง)\nวศ.บ. (วิศวกรรมระบบสมองกลอัจฉริยะและอิเล็กทรอนิกส์ความถี่สูง) :",
          "nameDegreeEN": "Bachelor of Engineering (Intelligent Embedded Systems and High Frequency Electronic Engineering)\nB.Eng. (Intelligent Embedded Systems And High Frequency Electronic Engineering)",
          "vision": "มุ่งเป็นแหล่งผลิตบัณฑิตที่เน้นทักษะการทำงานด้านวิศวกรรมไฟฟ้าควบคู่กับการบริหารจัดการอุตสาหกรรมที่สามารถทำงานได้จริง",
          "mission": "ผลิตบัณฑิตที่เชี่ยวชาญด้านวิศวกรรมไฟฟ้าควบคู่ด้วยทักษะด้านการบริหารจัดการอุตสาหกรรม โดยเน้นการผลิตบัณฑิตที่มีความรู้ความชำนาญด้านระบบไฟฟ้า ระบบอิเล็กทรอนิกส์ ระบบควบคุมและอัตโนมัติในโรงงานอุตสาหกรรม และมีทักษะด้านการจัดการทางอุตสาหกรรม ระบบการผลิต และการปรับปรุงประสิทธิภาพ มีความสามารถในการปฏิบัติงาน รวมถึงการประยุกต์ใช้เทคโนโลยีอย่างเหมาะสมและมีประสิทธิภาพ",
          "course_structure": "https://reg6.sut.ac.th/registrar/program_info_1.asp?f_cmd=2&acadyear=2566&levelid=1&programid=107530101660&facultyid=10700&programname=%C7%D4%C8%C7%A1%C3%C3%C1%C3%D0%BA%BA%CA%C1%CD%A7%A1%C5%CD%D1%A8%A9%C3%D4%C2%D0%E1%C5%D0%CD%D4%E0%C5%E7%A1%B7%C3%CD%B9%D4%A1%CA%EC%A4%C7%D2%C1%B6%D5%E8%CA%D9%A7+%28%C1%2E%BB%C5%D2%C2%29&facultyname=%CA%D3%B9%D1%A1%C7%D4%AA%D2%C7%D4%C8%C7%A1%C3%C3%C1%C8%D2%CA%B5%C3%EC&levelname=%BB%C3%D4%AD%AD%D2%B5%C3%D5",
          "study_plan": "https://reg6.sut.ac.th/registrar/studyplan_info1.asp?avs161377631=8&acadyear=2566&levelid=1&programid=107530101660&facultyid=10700&programname=%C7%D4%C8%C7%A1%C3%C3%C1%C3%D0%BA%BA%CA%C1%CD%A7%A1%C5%CD%D1%A8%A9%C3%D4%C2%D0%E1%C5%D0%CD%D4%E0%C5%E7%A1%B7%C3%CD%B9%D4%A1%CA%EC%A4%C7%D2%C1%B6%D5%E8%CA%D9%A7+%28%C1%2E%BB%C5%D2%C2%29&facultyname=%CA%D3%B9%D1%A1%C7%D4%AA%D2%C7%D4%C8%C7%A1%C3%C3%C1%C8%D2%CA%B5%C3%EC&levelname=%BB%C3%D4%AD%AD%D2%B5%C3%D5",
          "teacher": "https://beta.sut.ac.th/ie-elec/",
          "graduation_goals": "",
          "graduation_results": "",
          "employment_goals": "",
          "image": "__PUBLIC_URL__/service-sut/image/image-2023/department-engineering/intelligent-embedded/slide1.png",
          "footer": "__PUBLIC_URL__/service-sut/image/image-2023/department-engineering/intelligent-embedded/footer1.png,__PUBLIC_URL__/service-sut/image/image-2023/department-engineering/intelligent-embedded/footer2.png,__PUBLIC_URL__/service-sut/image/image-2023/department-engineering/intelligent-embedded/footer3.png",
          "createAt": null,
          "updateAt": null,
          "year": "2025"
        },
        "vision": {
          "vision_0": "มุ่งเป็นแหล่งผลิตบัณฑิตที่เน้นทักษะการทำงานด้านวิศวกรรมไฟฟ้าควบคู่กับการบริหารจัดการอุตสาหกรรมที่สามารถทำงานได้จริง"
        },
        "mission": {
          "mission_0": "ผลิตบัณฑิตที่เชี่ยวชาญด้านวิศวกรรมไฟฟ้าควบคู่ด้วยทักษะด้านการบริหารจัดการอุตสาหกรรม โดยเน้นการผลิตบัณฑิตที่มีความรู้ความชำนาญด้านระบบไฟฟ้า ระบบอิเล็กทรอนิกส์ ระบบควบคุมและอัตโนมัติในโรงงานอุตสาหกรรม และมีทักษะด้านการจัดการทางอุตสาหกรรม ระบบการผลิต และการปรับปรุงประสิทธิภาพ มีความสามารถในการปฏิบัติงาน รวมถึงการประยุกต์ใช้เทคโนโลยีอย่างเหมาะสมและมีประสิทธิภาพ"
        },
        "image": {
          "image_0": "__PUBLIC_URL__/service-sut/image/image-2023/department-engineering/intelligent-embedded/slide1.png"
        },
        "footer": {
          "image_0": "__PUBLIC_URL__/service-sut/image/image-2023/department-engineering/intelligent-embedded/footer1.png",
          "image_1": "__PUBLIC_URL__/service-sut/image/image-2023/department-engineering/intelligent-embedded/footer2.png",
          "image_2": "__PUBLIC_URL__/service-sut/image/image-2023/department-engineering/intelligent-embedded/footer3.png"
        },
        "icon": [
          {
            "id": "26",
            "courseID": "4",
            "branchID": "0",
            "detail": "ชื่อหลักสูตร",
            "image": "__PUBLIC_URL__/service-sut/image/icon/school-engi-01.svg"
          },
          {
            "id": "27",
            "courseID": "4",
            "branchID": "0",
            "detail": "ชื่อปริญญาบัตรและสาขา",
            "image": "__PUBLIC_URL__/service-sut/image/icon/school-engi-02.svg"
          },
          {
            "id": "28",
            "courseID": "4",
            "branchID": "0",
            "detail": "โครงสร้างหลักสูตร",
            "image": "__PUBLIC_URL__/service-sut/image/icon/school-engi-03.svg"
          },
          {
            "id": "29",
            "courseID": "4",
            "branchID": "0",
            "detail": "แผนการศึกษา",
            "image": "__PUBLIC_URL__/service-sut/image/icon/school-engi-04.svg"
          },
          {
            "id": "30",
            "courseID": "4",
            "branchID": "0",
            "detail": "อาจารย์ประจำหลักสูตร",
            "image": "__PUBLIC_URL__/service-sut/image/icon/school-engi-05.svg"
          },
          {
            "id": "31",
            "courseID": "4",
            "branchID": "0",
            "detail": "เป้าหมายการรับและ การสำเร็จการศึกษา",
            "image": "__PUBLIC_URL__/service-sut/image/icon/school-engi-06.svg"
          },
          {
            "id": "32",
            "courseID": "4",
            "branchID": "0",
            "detail": "ผลการรับและ สำเร็จการศึกษา",
            "image": "__PUBLIC_URL__/service-sut/image/icon/school-engi-07.svg"
          },
          {
            "id": "33",
            "courseID": "4",
            "branchID": "0",
            "detail": "เป้าหมายการได้งานทำ ของบัณฑิต",
            "image": "__PUBLIC_URL__/service-sut/image/icon/school-engi-08.svg"
          }
        ],
        "header": {
          "header_0": "ชื่อปริญญาและสาขา",
          "header_1": "วิสัยทัศน์",
          "header_2": "พันธกิจ",
          "header_3": "โครงสร้างหลักสูตร",
          "header_4": "แผนการศึกษา",
          "header_5": "ผลการรับและสำเร็จการศึกษา",
          "header_6": "เป้าหมายการรับและการสำเร็จการศึกษา",
          "header_7": "ผลการรับและสำเร็จการศึกษา",
          "header_8": "เป้าหมายการได้งานทำของบัณฑิต"
        },
        "visitor": 1895,
        "visitor_of_year": 122
      }
    },
    "industrial-electrical-engineering": {
      "code": 200,
      "status": "Get data success",
      "data": {
        "information": {
          "id": "103",
          "courseID": "4",
          "titleTH": "สาขาวิชาวิศวกรรมไฟฟ้าอุตสาหกรรม",
          "titleEN": "Industrial Electrical Engineering",
          "slang": "industrial-electrical-engineering",
          "nameTH": "วิศวกรรมไฟฟ้าอุตสาหกรรม",
          "nameEN": "Industrial Electrical Engineering",
          "nameDegreeTH": "วิศวกรรมศาสตรบัณฑิต (วิศวกรรมไฟฟ้าอุตสาหกรรม)\nวศ.บ. (วิศวกรรมไฟฟ้าอุตสาหกรรม)",
          "nameDegreeEN": "Bachelor of Engineering (Industrial Electrical Engineering)\nB.Eng. (Industrial Electrical Engineering)",
          "vision": "มุ่งเป็นแหล่งผลิตบัณฑิตที่เน้นทักษะการทำงานด้านวิศวกรรมไฟฟ้าควบคู่กับการบริหารจัดการอุตสาหกรรมที่สามารถทำงานได้จริง",
          "mission": "ผลิตบัณฑิตที่เชี่ยวชาญด้านวิศวกรรมไฟฟ้าควบคู่ด้วยทักษะด้านการบริหารจัดการอุตสาหกรรม โดยเน้นการผลิตบัณฑิตที่มีความรู้ความชำนาญด้านระบบไฟฟ้า ระบบอิเล็กทรอนิกส์ ระบบควบคุมและอัตโนมัติในโรงงานอุตสาหกรรม และมีทักษะด้านการจัดการทางอุตสาหกรรม ระบบการผลิต และการปรับปรุงประสิทธิภาพ มีความสามารถในการปฏิบัติงาน รวมถึงการประยุกต์ใช้เทคโนโลยีอย่างเหมาะสมและมีประสิทธิภาพ",
          "course_structure": "https://reg4.sut.ac.th/registrar/program_info_1.asp?f_cmd=2&acadyear=2564&levelid=1&programid=107520101640&facultyid=10700&programname=%C7%D4%C8%C7%A1%C3%C3%C1%E4%BF%BF%E9%D2%CD%D8%B5%CA%D2%CB%A1%C3%C3%C1+%28%C1%2E%BB%C5%D2%C2+%2F+%BB%C7%AA%2E%29&facultyname=%CA%D3%B9%D1%A1%C7%D4%AA%D2%C7%D4%C8%C7%A1%C3%C3%C1%C8%D2%CA%B5%C3%EC&levelname=%BB%C3%D4%AD%AD%D2%B5%C3%D5",
          "study_plan": "https://reg4.sut.ac.th/registrar/studyplan_info1.asp?avs267737472=17&acadyear=2564&levelid=1&programid=107520101640&facultyid=10700&programname=%C7%D4%C8%C7%A1%C3%C3%C1%E4%BF%BF%E9%D2%CD%D8%B5%CA%D2%CB%A1%C3%C3%C1+%28%C1%2E%BB%C5%D2%C2+%2F+%BB%C7%AA%2E%29&facultyname=%CA%D3%B9%D1%A1%C7%D4%AA%D2%C7%D4%C8%C7%A1%C3%C3%C1%C8%D2%CA%B5%C3%EC&levelname=%BB%C3%D4%AD%AD%D2%B5%C3%D5",
          "teacher": "https://beta.sut.ac.th/ie/employees",
          "graduation_goals": "",
          "graduation_results": "",
          "employment_goals": "",
          "image": "__PUBLIC_URL__/service-sut/image/image-2023/department-engineering/industrial-electrical/slide1.png",
          "footer": "__PUBLIC_URL__/service-sut/image/image-2023/department-engineering/industrial-electrical/footer1.png,__PUBLIC_URL__/service-sut/image/image-2023/department-engineering/industrial-electrical/footer2.png,__PUBLIC_URL__/service-sut/image/image-2023/department-engineering/industrial-electrical/footer3.png",
          "createAt": null,
          "updateAt": null,
          "year": "2025"
        },
        "vision": {
          "vision_0": "มุ่งเป็นแหล่งผลิตบัณฑิตที่เน้นทักษะการทำงานด้านวิศวกรรมไฟฟ้าควบคู่กับการบริหารจัดการอุตสาหกรรมที่สามารถทำงานได้จริง"
        },
        "mission": {
          "mission_0": "ผลิตบัณฑิตที่เชี่ยวชาญด้านวิศวกรรมไฟฟ้าควบคู่ด้วยทักษะด้านการบริหารจัดการอุตสาหกรรม โดยเน้นการผลิตบัณฑิตที่มีความรู้ความชำนาญด้านระบบไฟฟ้า ระบบอิเล็กทรอนิกส์ ระบบควบคุมและอัตโนมัติในโรงงานอุตสาหกรรม และมีทักษะด้านการจัดการทางอุตสาหกรรม ระบบการผลิต และการปรับปรุงประสิทธิภาพ มีความสามารถในการปฏิบัติงาน รวมถึงการประยุกต์ใช้เทคโนโลยีอย่างเหมาะสมและมีประสิทธิภาพ"
        },
        "image": {
          "image_0": "__PUBLIC_URL__/service-sut/image/image-2023/department-engineering/industrial-electrical/slide1.png"
        },
        "footer": {
          "image_0": "__PUBLIC_URL__/service-sut/image/image-2023/department-engineering/industrial-electrical/footer1.png",
          "image_1": "__PUBLIC_URL__/service-sut/image/image-2023/department-engineering/industrial-electrical/footer2.png",
          "image_2": "__PUBLIC_URL__/service-sut/image/image-2023/department-engineering/industrial-electrical/footer3.png"
        },
        "icon": [
          {
            "id": "26",
            "courseID": "4",
            "branchID": "0",
            "detail": "ชื่อหลักสูตร",
            "image": "__PUBLIC_URL__/service-sut/image/icon/school-engi-01.svg"
          },
          {
            "id": "27",
            "courseID": "4",
            "branchID": "0",
            "detail": "ชื่อปริญญาบัตรและสาขา",
            "image": "__PUBLIC_URL__/service-sut/image/icon/school-engi-02.svg"
          },
          {
            "id": "28",
            "courseID": "4",
            "branchID": "0",
            "detail": "โครงสร้างหลักสูตร",
            "image": "__PUBLIC_URL__/service-sut/image/icon/school-engi-03.svg"
          },
          {
            "id": "29",
            "courseID": "4",
            "branchID": "0",
            "detail": "แผนการศึกษา",
            "image": "__PUBLIC_URL__/service-sut/image/icon/school-engi-04.svg"
          },
          {
            "id": "30",
            "courseID": "4",
            "branchID": "0",
            "detail": "อาจารย์ประจำหลักสูตร",
            "image": "__PUBLIC_URL__/service-sut/image/icon/school-engi-05.svg"
          },
          {
            "id": "31",
            "courseID": "4",
            "branchID": "0",
            "detail": "เป้าหมายการรับและ การสำเร็จการศึกษา",
            "image": "__PUBLIC_URL__/service-sut/image/icon/school-engi-06.svg"
          },
          {
            "id": "32",
            "courseID": "4",
            "branchID": "0",
            "detail": "ผลการรับและ สำเร็จการศึกษา",
            "image": "__PUBLIC_URL__/service-sut/image/icon/school-engi-07.svg"
          },
          {
            "id": "33",
            "courseID": "4",
            "branchID": "0",
            "detail": "เป้าหมายการได้งานทำ ของบัณฑิต",
            "image": "__PUBLIC_URL__/service-sut/image/icon/school-engi-08.svg"
          }
        ],
        "header": {
          "header_0": "ชื่อปริญญาและสาขา",
          "header_1": "วิสัยทัศน์",
          "header_2": "พันธกิจ",
          "header_3": "โครงสร้างหลักสูตร",
          "header_4": "แผนการศึกษา",
          "header_5": "ผลการรับและสำเร็จการศึกษา",
          "header_6": "เป้าหมายการรับและการสำเร็จการศึกษา",
          "header_7": "ผลการรับและสำเร็จการศึกษา",
          "header_8": "เป้าหมายการได้งานทำของบัณฑิต"
        },
        "visitor": 587,
        "visitor_of_year": 266
      }
    },
    "electronics-and-embedded-system-egineering": {
      "code": 200,
      "status": "Get data success",
      "data": {
        "information": {
          "id": "104",
          "courseID": "4",
          "titleTH": "สาขาวิชาวิศวกรรมอิเล็กทรอนิกส์และระบบสมองกลฝังตัว",
          "titleEN": "Electronics and Embedded System Engineering",
          "slang": "electronics-and-embedded-system-egineering",
          "nameTH": "วิศวกรรมอิเล็กทรอนิกส์และระบบสมองกลฝังตัว",
          "nameEN": "Electronics and Embedded System Engineering",
          "nameDegreeTH": "วิศวกรรมศาสตรบัณฑิต (วิศวกรรมอิเล็กทรอนิกส์และระบบสมองกลฝังตัว)\nวศ.บ. (วิศวกรรมอิเล็กทรอนิกส์และระบบสมองกลฝังตัว)",
          "nameDegreeEN": "Bachelor of Engineering (Electronics and Embedded System Engineering)",
          "vision": "มุ่งเป็นแหล่งผลิตบัณฑิตที่เน้นทักษะการทำงานด้านวิศวกรรมไฟฟ้าควบคู่กับการบริหารจัดการอุตสาหกรรมที่สามารถทำงานได้จริง",
          "mission": "ผลิตบัณฑิตที่เชี่ยวชาญด้านวิศวกรรมไฟฟ้าควบคู่ด้วยทักษะด้านการบริหารจัดการอุตสาหกรรม โดยเน้นการผลิตบัณฑิตที่มีความรู้ความชำนาญด้านระบบไฟฟ้า ระบบอิเล็กทรอนิกส์ ระบบควบคุมและอัตโนมัติในโรงงานอุตสาหกรรม และมีทักษะด้านการจัดการทางอุตสาหกรรม ระบบการผลิต และการปรับปรุงประสิทธิภาพ มีความสามารถในการปฏิบัติงาน รวมถึงการประยุกต์ใช้เทคโนโลยีอย่างเหมาะสมและมีประสิทธิภาพ",
          "course_structure": "https://reg6.sut.ac.th/registrar/program_info_1.asp?f_cmd=2&acadyear=2565&levelid=1&programid=107160101650&facultyid=10700&programname=%C7%D4%C8%C7%A1%C3%C3%C1%CD%D4%E0%C5%E7%A1%B7%C3%CD%B9%D4%A1%CA%EC%E1%C5%D0%C3%D0%BA%BA%CA%C1%CD%A7%A1%C5%BD%D1%A7%B5%D1%C7%2D%E2%A4%C3%A7%A7%D2%B9%B9%C7%D1%B5%A1%C3%C3%C1%2D2565&facultyname=%CA%D3%B9%D1%A1%C7%D4%AA%D2%C7%D4%C8%C7%A1%C3%C3%C1%C8%D2%CA%B5%C3%EC&levelname=%BB%C3%D4%AD%AD%D2%B5%C3%D5",
          "study_plan": "https://reg6.sut.ac.th/registrar/studyplan_info1.asp?avs161377631=18&acadyear=2565&levelid=1&programid=107160101650&facultyid=10700&programname=%C7%D4%C8%C7%A1%C3%C3%C1%CD%D4%E0%C5%E7%A1%B7%C3%CD%B9%D4%A1%CA%EC%E1%C5%D0%C3%D0%BA%BA%CA%C1%CD%A7%A1%C5%BD%D1%A7%B5%D1%C7%2D%E2%A4%C3%A7%A7%D2%B9%B9%C7%D1%B5%A1%C3%C3%C1%2D2565&facultyname=%CA%D3%B9%D1%A1%C7%D4%AA%D2%C7%D4%C8%C7%A1%C3%C3%C1%C8%D2%CA%B5%C3%EC&levelname=%BB%C3%D4%AD%AD%D2%B5%C3%D5",
          "teacher": "https://beta.sut.ac.th/ie-elec/",
          "graduation_goals": "",
          "graduation_results": "",
          "employment_goals": "",
          "image": "__PUBLIC_URL__/service-sut/image/image-2023/department-engineering/electronics-embedded/slide1.png",
          "footer": "__PUBLIC_URL__/service-sut/image/image-2023/department-engineering/electronics-embedded/footer1.png,__PUBLIC_URL__/service-sut/image/image-2023/department-engineering/electronics-embedded/footer2.png,__PUBLIC_URL__/service-sut/image/image-2023/department-engineering/electronics-embedded/footer3.png",
          "createAt": null,
          "updateAt": null,
          "year": "2025"
        },
        "vision": {
          "vision_0": "มุ่งเป็นแหล่งผลิตบัณฑิตที่เน้นทักษะการทำงานด้านวิศวกรรมไฟฟ้าควบคู่กับการบริหารจัดการอุตสาหกรรมที่สามารถทำงานได้จริง"
        },
        "mission": {
          "mission_0": "ผลิตบัณฑิตที่เชี่ยวชาญด้านวิศวกรรมไฟฟ้าควบคู่ด้วยทักษะด้านการบริหารจัดการอุตสาหกรรม โดยเน้นการผลิตบัณฑิตที่มีความรู้ความชำนาญด้านระบบไฟฟ้า ระบบอิเล็กทรอนิกส์ ระบบควบคุมและอัตโนมัติในโรงงานอุตสาหกรรม และมีทักษะด้านการจัดการทางอุตสาหกรรม ระบบการผลิต และการปรับปรุงประสิทธิภาพ มีความสามารถในการปฏิบัติงาน รวมถึงการประยุกต์ใช้เทคโนโลยีอย่างเหมาะสมและมีประสิทธิภาพ"
        },
        "image": {
          "image_0": "__PUBLIC_URL__/service-sut/image/image-2023/department-engineering/electronics-embedded/slide1.png"
        },
        "footer": {
          "image_0": "__PUBLIC_URL__/service-sut/image/image-2023/department-engineering/electronics-embedded/footer1.png",
          "image_1": "__PUBLIC_URL__/service-sut/image/image-2023/department-engineering/electronics-embedded/footer2.png",
          "image_2": "__PUBLIC_URL__/service-sut/image/image-2023/department-engineering/electronics-embedded/footer3.png"
        },
        "icon": [
          {
            "id": "26",
            "courseID": "4",
            "branchID": "0",
            "detail": "ชื่อหลักสูตร",
            "image": "__PUBLIC_URL__/service-sut/image/icon/school-engi-01.svg"
          },
          {
            "id": "27",
            "courseID": "4",
            "branchID": "0",
            "detail": "ชื่อปริญญาบัตรและสาขา",
            "image": "__PUBLIC_URL__/service-sut/image/icon/school-engi-02.svg"
          },
          {
            "id": "28",
            "courseID": "4",
            "branchID": "0",
            "detail": "โครงสร้างหลักสูตร",
            "image": "__PUBLIC_URL__/service-sut/image/icon/school-engi-03.svg"
          },
          {
            "id": "29",
            "courseID": "4",
            "branchID": "0",
            "detail": "แผนการศึกษา",
            "image": "__PUBLIC_URL__/service-sut/image/icon/school-engi-04.svg"
          },
          {
            "id": "30",
            "courseID": "4",
            "branchID": "0",
            "detail": "อาจารย์ประจำหลักสูตร",
            "image": "__PUBLIC_URL__/service-sut/image/icon/school-engi-05.svg"
          },
          {
            "id": "31",
            "courseID": "4",
            "branchID": "0",
            "detail": "เป้าหมายการรับและ การสำเร็จการศึกษา",
            "image": "__PUBLIC_URL__/service-sut/image/icon/school-engi-06.svg"
          },
          {
            "id": "32",
            "courseID": "4",
            "branchID": "0",
            "detail": "ผลการรับและ สำเร็จการศึกษา",
            "image": "__PUBLIC_URL__/service-sut/image/icon/school-engi-07.svg"
          },
          {
            "id": "33",
            "courseID": "4",
            "branchID": "0",
            "detail": "เป้าหมายการได้งานทำ ของบัณฑิต",
            "image": "__PUBLIC_URL__/service-sut/image/icon/school-engi-08.svg"
          }
        ],
        "header": {
          "header_0": "ชื่อปริญญาและสาขา",
          "header_1": "วิสัยทัศน์",
          "header_2": "พันธกิจ",
          "header_3": "โครงสร้างหลักสูตร",
          "header_4": "แผนการศึกษา",
          "header_5": "ผลการรับและสำเร็จการศึกษา",
          "header_6": "เป้าหมายการรับและการสำเร็จการศึกษา",
          "header_7": "ผลการรับและสำเร็จการศึกษา",
          "header_8": "เป้าหมายการได้งานทำของบัณฑิต"
        },
        "visitor": 1141,
        "visitor_of_year": 126
      }
    }
  },
  "branch_contract": {
    "996": {
      "code": 200,
      "status": "Get data success",
      "data": [
        {
          "id": "2599601",
          "courseID": "996",
          "title": "ศูนย์บริการการศึกษา",
          "phone_1": "0-4422-3011 ถึง 2",
          "phone_2": "",
          "email_1": "",
          "email_2": "",
          "site": "http://www.sut.ac.th/ces",
          "fb": "",
          "line": "",
          "image": "",
          "address": "อาคารเรียนรวม 2",
          "email_3": "",
          "fb_2": "",
          "year": "2025",
          "IG": "",
          "title0": "ศูนย์บริการการศึกษา"
        },
        {
          "id": "2599602",
          "courseID": "996",
          "title": "งานทุนการศึกษา",
          "phone_1": "0-4422-3114 ถึง 5, 0-4422-3129",
          "phone_2": "",
          "email_1": "",
          "email_2": "",
          "site": "http://scholarship.sut.ac.th/sutfundNew/",
          "fb": "",
          "line": "",
          "image": "",
          "address": "อาคารส่วนกิจการนักศึกษา",
          "email_3": "",
          "fb_2": "",
          "year": "2025",
          "IG": "",
          "title0": "งานทุนการศึกษา"
        },
        {
          "id": "2599603",
          "courseID": "996",
          "title": "ศูนย์บรรณสารและสื่อการศึกษา",
          "phone_1": "0-4422-3061-3",
          "phone_2": "",
          "email_1": "",
          "email_2": "",
          "site": "http://library.sut.ac.th/",
          "fb": "",
          "line": "",
          "image": "",
          "address": "อาคารศูนย์บรรณสารและสื่อการศึกษา",
          "email_3": "",
          "fb_2": "",
          "year": "2025",
          "IG": "",
          "title0": "ศูนย์บรรณสารและสื่อการศึกษา"
        },
        {
          "id": "2599604",
          "courseID": "996",
          "title": "ศูนย์นวัตกรรมและเทคโนโลยีการศึกษา",
          "phone_1": "0-4422-4972",
          "phone_2": "",
          "email_1": "",
          "email_2": "",
          "site": "https://ceit.sut.ac.th/",
          "fb": "",
          "line": "",
          "image": "",
          "address": "อาคารเครื่องมือ 7",
          "email_3": "",
          "fb_2": "",
          "year": "2025",
          "IG": "",
          "title0": "ศูนย์นวัตกรรมและเทคโนโลยีการศึกษา"
        },
        {
          "id": "2599605",
          "courseID": "996",
          "title": "ศูนย์คอมพิวเตอร์",
          "phone_1": "0-4422-4801",
          "phone_2": "",
          "email_1": "",
          "email_2": "",
          "site": "http://ccs.sut.ac.th/",
          "fb": "",
          "line": "",
          "image": "",
          "address": "อาคารวิจัย (ชั้น 2)",
          "email_3": "",
          "fb_2": "",
          "year": "2025",
          "IG": "",
          "title0": "ศูนย์คอมพิวเตอร์"
        },
        {
          "id": "2599606",
          "courseID": "996",
          "title": "ส่วนการเงินและบัญชี",
          "phone_1": "0-4422-4916",
          "phone_2": "",
          "email_1": "",
          "email_2": "",
          "site": "http://web.sut.ac.th/dfa",
          "fb": "",
          "line": "",
          "image": "",
          "address": "อาคารบริหาร",
          "email_3": "",
          "fb_2": "",
          "year": "2025",
          "IG": "",
          "title0": "ส่วนการเงินและบัญชี"
        },
        {
          "id": "2599607",
          "courseID": "996",
          "title": "โรงพยาบาลมหาวิทยาลัยเทคโนโลยีสุรนารี",
          "phone_1": "0-4437-6555",
          "phone_2": "",
          "email_1": "",
          "email_2": "",
          "site": "www.suth.go.th",
          "fb": "",
          "line": "",
          "image": "",
          "address": "อาคารรัตนเวชพัฒน์",
          "email_3": "",
          "fb_2": "",
          "year": "2025",
          "IG": "",
          "title0": "โรงพยาบาลมหาวิทยาลัยเทคโนโลยีสุรนารี"
        },
        {
          "id": "2599608",
          "courseID": "996",
          "title": "หน่วยงานรักษาความปลอดภัย มทส.",
          "phone_1": "1234,0-4422-4567",
          "phone_2": "",
          "email_1": "",
          "email_2": "",
          "site": "",
          "fb": "",
          "line": "",
          "image": "",
          "address": "",
          "email_3": "",
          "fb_2": "",
          "year": "2025",
          "IG": "",
          "title0": "หน่วยงานรักษาความปลอดภัย มทส."
        }
      ]
    },
    "0": {
      "code": 404,
      "status": "Not found",
      "data": []
    },
    "1": {
      "code": 200,
      "status": "Get data success",
      "data": [
        {
          "id": "250101",
          "courseID": "1",
          "title": "สํานักวิชาวิทยาศาสตร์",
          "phone_1": "0-4422-4187",
          "phone_2": "0-4422-4185",
          "email_1": "",
          "email_2": "",
          "site": "http://science.sut.ac.th/2013/",
          "fb": "",
          "line": "",
          "image": "__PUBLIC_URL__/service-sut/image/00-FooterContact/01-Sci.png",
          "address": "",
          "email_3": "",
          "fb_2": "",
          "year": "2025",
          "IG": "",
          "title0": "สํานักวิชาวิทยาศาสตร์"
        },
        {
          "id": "250102",
          "courseID": "1",
          "title": "หลักสูตรฯ สาขาวิชาเคมี",
          "phone_1": "0-4422-4639",
          "phone_2": "0-4422-4185",
          "email_1": "",
          "email_2": "",
          "site": "http://science.sut.ac.th/curri/major/modules/index.php?name=chem",
          "fb": "",
          "line": "",
          "image": "",
          "address": "",
          "email_3": "",
          "fb_2": "",
          "year": "2025",
          "IG": "",
          "title0": "หลักสูตรฯ สาขาวิชาเคมี"
        },
        {
          "id": "250103",
          "courseID": "1",
          "title": "หลักสูตรฯ สาขาวิชาฟิสิกส์",
          "phone_1": "0-4422-4319",
          "phone_2": "0-4422-4185",
          "email_1": "",
          "email_2": "",
          "site": "http://science.sut.ac.th/curri/major/modules/index.php?name=physics",
          "fb": "",
          "line": "",
          "image": "",
          "address": "",
          "email_3": "",
          "fb_2": "",
          "year": "2025",
          "IG": "",
          "title0": "หลักสูตรฯ สาขาวิชาฟิสิกส์"
        },
        {
          "id": "250104",
          "courseID": "1",
          "title": "หลักสูตรฯ สาขาวิชาคณิตศาสตร์",
          "phone_1": "0-4422-4626",
          "phone_2": "0-4422-4185",
          "email_1": "sutmath@gmail.com",
          "email_2": "",
          "site": "https://science.sut.ac.th/curri/major/modules/index.php?name=math",
          "fb": "",
          "line": "",
          "image": "",
          "address": "",
          "email_3": "",
          "fb_2": "",
          "year": "2025",
          "IG": "",
          "title0": "หลักสูตรฯ สาขาวิชาคณิตศาสตร์"
        },
        {
          "id": "250105",
          "courseID": "1",
          "title": "หลักสูตรฯ สาขาวิชาวิทยาศาสตร์การกีฬา",
          "phone_1": "0-4422-4158",
          "phone_2": "0-4422-4185",
          "email_1": "lalida@g.sut.ac.th",
          "email_2": "dangbubpha@sut.ac.th",
          "site": "http://science.sut.ac.th/curri/major/modules/index.php?name=sportsci",
          "fb": "",
          "line": "",
          "image": "",
          "address": "",
          "email_3": "terawat.d@sut.ac.th",
          "fb_2": "",
          "year": "2025",
          "IG": "",
          "title0": "หลักสูตรฯ สาขาวิชาวิทยาศาสตร์การกีฬา"
        },
        {
          "id": "250106",
          "courseID": "1",
          "title": "หลักสูตรฯ สาขาวิชาชีววิทยา",
          "phone_1": "0-4422-4633",
          "phone_2": "0-4422-4185",
          "email_1": "",
          "email_2": "",
          "site": "http://science.sut.ac.th/curri/major/modules/index.php?name=bio",
          "fb": "",
          "line": "",
          "image": "",
          "address": "",
          "email_3": "",
          "fb_2": "",
          "year": "2025",
          "IG": "",
          "title0": "หลักสูตรฯ สาขาวิชาชีววิทยา"
        },
        {
          "id": "250107",
          "courseID": "1",
          "title": "หลักสูตรฯ สาขาวิชาวิทยาการข้อมูลและภูมิสารสนเทศประยุกต์",
          "phone_1": "0-4422-4626",
          "phone_2": "0-4422-4185",
          "email_1": "songkot@sut.ac.th",
          "email_2": "",
          "site": "http://science.sut.ac.th/curri/major/modules/index.php?name=gi",
          "fb": "",
          "line": "",
          "image": "",
          "address": "",
          "email_3": "",
          "fb_2": "",
          "year": "2025",
          "IG": "",
          "title0": "หลักสูตรฯ สาขาวิชาวิทยาการข้อมูลและภูมิสารสนเทศประยุกต์"
        },
        {
          "id": "250108",
          "courseID": "1",
          "title": "หลักสูตรฯ สาขาวิชาจุลชีววิทยา",
          "phone_1": "0-4422-4673",
          "phone_2": "0-4422-4185",
          "email_1": "sajeera@sut.ac.th",
          "email_2": "siriwan53@sut.ac.th",
          "site": "http://science.sut.ac.th/curri/major/modules/index.php?name=micro",
          "fb": "https://www.facebook.com/profile.php?id=100064488985006",
          "line": "",
          "image": "",
          "address": "",
          "email_3": "",
          "fb_2": "",
          "year": "2025",
          "IG": "",
          "title0": "หลักสูตรฯ สาขาวิชาจุลชีววิทยา"
        },
        {
          "id": "250109",
          "courseID": "1",
          "title": "หลักสูตรฯ สาขาวิชาวิทยาศาสตร์การแพทย์",
          "phone_1": "0-4422-4673",
          "phone_2": "0-4422-4185",
          "email_1": "sajeera@sut.ac.th",
          "email_2": "siriwan53@sut.ac.th",
          "site": "http://science.sut.ac.th/curri/major/modules/index.php?name=medical",
          "fb": "https://www.facebook.com/profile.php?id=100064488985006",
          "line": "",
          "image": "",
          "address": "",
          "email_3": "",
          "fb_2": "",
          "year": "2025",
          "IG": "",
          "title0": "หลักสูตรฯ สาขาวิชาวิทยาศาสตร์การแพทย์"
        },
        {
          "id": "250110",
          "courseID": "1",
          "title": "หลักสูตรฯ สาขาวิชาวิทยาการคอมพิวเตอร์",
          "phone_1": "0-4422-4626",
          "phone_2": "0-4422-4185",
          "email_1": "sirichok@sut.ac.th",
          "email_2": "",
          "site": "http://science.sut.ac.th/curri/major/modules/index.php?name=comsci",
          "fb": "",
          "line": "",
          "image": "",
          "address": "",
          "email_3": "",
          "fb_2": "",
          "year": "2025",
          "IG": "",
          "title0": "หลักสูตรฯ สาขาวิชาวิทยาการคอมพิวเตอร์"
        }
      ]
    },
    "2": {
      "code": 200,
      "status": "Get data success",
      "data": [
        {
          "id": "250201",
          "courseID": "2",
          "title": "สำนักวิชาเทคโนโลยีสังคม",
          "phone_1": "0-4422-4207-9",
          "phone_2": "0-4422-4205",
          "email_1": "socialtech@sut.ac.th",
          "email_2": "",
          "site": "http://soctech.sut.ac.th",
          "fb": "",
          "line": "",
          "image": "__PUBLIC_URL__/service-sut/image/00-FooterContact/02-Soctech.png",
          "address": "",
          "email_3": "",
          "fb_2": "",
          "year": "2025",
          "IG": "",
          "title0": "สำนักวิชาเทคโนโลยีสังคม"
        },
        {
          "id": "250202",
          "courseID": "2",
          "title": "หลักสูตรการจัดการบัณฑิต สาขาวิชาเทคโนโลยีการจัดการ",
          "phone_1": "0-4422-4267, 0-4422-4307",
          "phone_2": "0-4422-4521",
          "email_1": "mtech@sut.ac.th",
          "email_2": "",
          "site": "https://beta.sut.ac.th/ist-mt",
          "fb": "https://www.facebook.com/SUTMT",
          "line": "",
          "image": "",
          "address": "",
          "email_3": "",
          "fb_2": "",
          "year": "2025",
          "IG": "",
          "title0": "หลักสูตรการจัดการบัณฑิต สาขาวิชาเทคโนโลยีการจัดการ"
        },
        {
          "id": "250203",
          "courseID": "2",
          "title": "หลักสูตรการจัดการบัณฑิต สาขาวิชานวัตกรรมเทคโนโลยีอุตสาหกรรมบริการ",
          "phone_1": "0-4422-4249",
          "phone_2": "0-4422-4521",
          "email_1": "mtech@sut.ac.th",
          "email_2": "",
          "site": "https://mt.sut.ac.th/courses/coursedetail?coursecode=d6d5d6a2pe333cpe4e2bpe89d0pedf51ef1f72c9",
          "fb": "https://www.facebook.com/people/Hospitality-Technology-Innovation-SUT/100069312228425/",
          "line": "",
          "image": "",
          "address": "",
          "email_3": "",
          "fb_2": "",
          "year": "2025",
          "IG": "",
          "title0": "หลักสูตรการจัดการบัณฑิต สาขาวิชานวัตกรรมเทคโนโลยีอุตสาหกรรมบริการ"
        },
        {
          "id": "250204",
          "courseID": "2",
          "title": "หลักสูตรหมวดวิชาศึกษาทั่วไป สาขาวิชาศึกษาทั่วไป",
          "phone_1": "0-4422-4258",
          "phone_2": "",
          "email_1": "ge@sut.ac.th",
          "email_2": "",
          "site": "",
          "fb": "",
          "line": "",
          "image": "",
          "address": "",
          "email_3": "",
          "fb_2": "",
          "year": "2025",
          "IG": "",
          "title0": "หลักสูตรหมวดวิชาศึกษาทั่วไป สาขาวิชาศึกษาทั่วไป"
        },
        {
          "id": "250205",
          "courseID": "2",
          "title": "สาขาวิชาภาษาต่างประเทศ",
          "phone_1": "0-4422-4213-15",
          "phone_2": "",
          "email_1": "fl@sut.ac.th",
          "email_2": "",
          "site": "",
          "fb": "",
          "line": "",
          "image": "",
          "address": "",
          "email_3": "",
          "fb_2": "",
          "year": "2025",
          "IG": "",
          "title0": "สาขาวิชาภาษาต่างประเทศ"
        },
        {
          "id": "250206",
          "courseID": "2",
          "title": "สาขาวิชาเทคโนโลยีการจัดการ",
          "phone_1": "0-4422-4267, 0-4422-4307",
          "phone_2": "0-4422-4521",
          "email_1": "mtech@sut.ac.th",
          "email_2": "",
          "site": "https://beta.sut.ac.th/ist-mt",
          "fb": "https://www.facebook.com/SUTMT",
          "line": "",
          "image": "",
          "address": "",
          "email_3": "",
          "fb_2": "",
          "year": "2025",
          "IG": "",
          "title0": "สาขาวิชาเทคโนโลยีการจัดการ"
        },
        {
          "id": "250207",
          "courseID": "2",
          "title": "ช่องทางรับการร้องเรียน/ข้อเสนอแนะ",
          "phone_1": "",
          "phone_2": "",
          "email_1": "complaintist@sut.ac.th",
          "email_2": "",
          "site": "",
          "fb": "",
          "line": "",
          "image": "",
          "address": "",
          "email_3": "",
          "fb_2": "",
          "year": "2025",
          "IG": "",
          "title0": "ช่องทางรับการร้องเรียน/ข้อเสนอแนะ"
        }
      ]
    },
    "3": {
      "code": 200,
      "status": "Get data success",
      "data": [
        {
          "id": "250301",
          "courseID": "3",
          "title": "สำนักวิชาเทคโนโลยีการเกษตร",
          "phone_1": "0-4422-4743, 0-4422-4152 - 3",
          "phone_2": "",
          "email_1": "",
          "email_2": "",
          "site": "https://iat.sut.ac.th",
          "fb": "",
          "line": "",
          "image": "__PUBLIC_URL__/service-sut/image/00-FooterContact/03-Agri.png",
          "address": "",
          "email_3": "",
          "fb_2": "",
          "year": "2025",
          "IG": "",
          "title0": "สำนักวิชาเทคโนโลยีการเกษตร"
        },
        {
          "id": "250302",
          "courseID": "3",
          "title": "สำนักงานคณบดี",
          "phone_1": "0-4422-4743, 0-4422-4152-3",
          "phone_2": "0-4422-4150",
          "email_1": "",
          "email_2": "",
          "site": "",
          "fb": "",
          "line": "",
          "image": "",
          "address": "",
          "email_3": "",
          "fb_2": "",
          "year": "2025",
          "IG": "",
          "title0": "สำนักงานคณบดี"
        },
        {
          "id": "250303",
          "courseID": "3",
          "title": "สาขาวิชาเทคโนโลยีการผลิตพืช",
          "phone_1": "0-4422-4202, 4204",
          "phone_2": "0-4422-4281",
          "email_1": "",
          "email_2": "",
          "site": "https://iat.sut.ac.th/croptech/",
          "fb": "https://www.facebook.com/sutcroptech",
          "line": "",
          "image": "",
          "address": "",
          "email_3": "",
          "fb_2": "",
          "year": "2025",
          "IG": "",
          "title0": "สาขาวิชาเทคโนโลยีการผลิตพืช"
        },
        {
          "id": "250304",
          "courseID": "3",
          "title": "สาขาวิชาเทคโนโลยีและนวัตกรรมทางสัตว์",
          "phone_1": "0-4422-4378",
          "phone_2": "0-4422-4150",
          "email_1": "",
          "email_2": "",
          "site": "https://iat.sut.ac.th/ati",
          "fb": "https://www.facebook.com/profile.php?id=100063774211093",
          "line": "",
          "image": "",
          "address": "",
          "email_3": "",
          "fb_2": "",
          "year": "2025",
          "IG": "",
          "title0": "สาขาวิชาเทคโนโลยีและนวัตกรรมทางสัตว์"
        },
        {
          "id": "250305",
          "courseID": "3",
          "title": "สาขาวิชาเทคโนโลยีอาหาร",
          "phone_1": "0-4422-4240, 4233",
          "phone_2": "0-4422-4150",
          "email_1": "",
          "email_2": "",
          "site": "https://iat.sut.ac.th/foodtech",
          "fb": "https://www.facebook.com/FoodTechnologySUT",
          "line": "",
          "image": "",
          "address": "",
          "email_3": "",
          "fb_2": "",
          "year": "2025",
          "IG": "",
          "title0": "สาขาวิชาเทคโนโลยีอาหาร"
        },
        {
          "id": "250306",
          "courseID": "3",
          "title": "หลักสูตรเทคโนโลยีบัณฑิตสาขาวิชา ผู้ประกอบการเกษตรเชิงนวัตกรรม (หลักสูตรนานาชาติ)",
          "phone_1": "0-44224-356",
          "phone_2": "0-4422-4150",
          "email_1": "",
          "email_2": "",
          "site": "https://iat.sut.ac.th/innoagri/",
          "fb": "https://www.facebook.com/InnoAgriSUT",
          "line": "",
          "image": "",
          "address": "",
          "email_3": "",
          "fb_2": "",
          "year": "2025",
          "IG": "",
          "title0": "หลักสูตรเทคโนโลยีบัณฑิตสาขาวิชา ผู้ประกอบการเกษตรเชิงนวัตกรรม (หลักสูตรนานาชาติ)"
        }
      ]
    },
    "4": {
      "code": 200,
      "status": "Get data success",
      "data": [
        {
          "id": "250401",
          "courseID": "4",
          "title": "สำนักวิชาวิศวกรรมศาสตร์",
          "phone_1": "0-4422-4224",
          "phone_2": "",
          "email_1": "ieadmin@g.sut.ac.th",
          "email_2": "",
          "site": "https://eng.sut.ac.th/ENG2023/",
          "fb": "https://www.facebook.com/EngineeringSUT",
          "line": "",
          "image": "__PUBLIC_URL__/service-sut/image/00-FooterContact/04-Engi.png",
          "address": "",
          "email_3": "",
          "fb_2": "",
          "year": "2025",
          "IG": "",
          "title0": "สำนักวิชาวิศวกรรมศาสตร์"
        },
        {
          "id": "250402",
          "courseID": "4",
          "title": "สาขาวิชาวิศวกรรมเกษตรและอาหาร",
          "phone_1": "0-4422-4225",
          "phone_2": "",
          "email_1": "agri_eng@g.sut.ac.th",
          "email_2": "",
          "site": "https://eng.sut.ac.th/ENG2023/schools/school-of-agricultural-engineering/",
          "fb": "https://www.facebook.com/AESUT",
          "line": "",
          "image": "",
          "address": "",
          "email_3": "",
          "fb_2": "",
          "year": "2025",
          "IG": "",
          "title0": "สาขาวิชาวิศวกรรมเกษตรและอาหาร"
        },
        {
          "id": "250403",
          "courseID": "4",
          "title": "สาขาวิชาวิศวกรรมเซรามิก",
          "phone_1": "0-4422-4471",
          "phone_2": "",
          "email_1": "panpipar@sut.ac.th",
          "email_2": "",
          "site": "https://eng.sut.ac.th/ENG2023/schools/school-of-ceramic-engineering/",
          "fb": "https://www.facebook.com/ceramic.suranaree",
          "line": "",
          "image": "",
          "address": "",
          "email_3": "",
          "fb_2": "",
          "year": "2025",
          "IG": "",
          "title0": "สาขาวิชาวิศวกรรมเซรามิก"
        },
        {
          "id": "250404",
          "courseID": "4",
          "title": "สาขาวิชาวิศวกรรมเคมี",
          "phone_1": "0-4422-4491",
          "phone_2": "",
          "email_1": "terasut@sut.ac.th",
          "email_2": "",
          "site": "https://sites.google.com/g.sut.ac.th/chemengsut/home",
          "fb": "https://www.facebook.com/chem.eng.sut",
          "line": "",
          "image": "",
          "address": "",
          "email_3": "",
          "fb_2": "",
          "year": "2025",
          "IG": "",
          "title0": "สาขาวิชาวิศวกรรมเคมี"
        },
        {
          "id": "250405",
          "courseID": "4",
          "title": "สาขาวิชาวิศวกรรมโยธา",
          "phone_1": "",
          "phone_2": "",
          "email_1": "civilengineering.sut@gmail.com",
          "email_2": "",
          "site": "https://eng.sut.ac.th/ENG2023/undergraduate-study/",
          "fb": "",
          "line": "",
          "image": "",
          "address": "",
          "email_3": "",
          "fb_2": "",
          "year": "2025",
          "IG": "",
          "title0": "สาขาวิชาวิศวกรรมโยธา"
        },
        {
          "id": "250406",
          "courseID": "4",
          "title": "สาขาวิชาวิศวกรรมคอมพิวเตอร์",
          "phone_1": "0-4422-4422",
          "phone_2": "",
          "email_1": "cpesut.th@g.sut.ac.th",
          "email_2": "",
          "site": "https://eng.sut.ac.th/ENG2023/schools/school-of-computer-engineering/",
          "fb": "https://www.facebook.com/cpesut",
          "line": "",
          "image": "",
          "address": "",
          "email_3": "",
          "fb_2": "",
          "year": "2025",
          "IG": "",
          "title0": "สาขาวิชาวิศวกรรมคอมพิวเตอร์"
        },
        {
          "id": "250407",
          "courseID": "4",
          "title": "สาขาวิชาวิศวกรรมไฟฟ้า",
          "phone_1": "0-4422-4400",
          "phone_2": "",
          "email_1": "ee@sut.ac.th",
          "email_2": "",
          "site": "https://eng.sut.ac.th/ENG2023/schools/school-of-electrical-engineering/",
          "fb": "https://www.facebook.com/eesut",
          "line": "",
          "image": "",
          "address": "",
          "email_3": "",
          "fb_2": "",
          "year": "2025",
          "IG": "",
          "title0": "สาขาวิชาวิศวกรรมไฟฟ้า"
        },
        {
          "id": "250408",
          "courseID": "4",
          "title": "สาขาวิชาวิศวกรรมอิเล็กทรอนิกส์และระบบสมองกลฝังตัว",
          "phone_1": "0-4422-4171",
          "phone_2": "",
          "email_1": "electronic@sut.ac.th",
          "email_2": "",
          "site": "https://eng.sut.ac.th/ENG2023/schools/school-of-electronic-engineering/",
          "fb": "https://www.facebook.com/profile.php?id=100057592354372",
          "line": "",
          "image": "",
          "address": "",
          "email_3": "",
          "fb_2": "",
          "year": "2025",
          "IG": "",
          "title0": "สาขาวิชาวิศวกรรมอิเล็กทรอนิกส์และระบบสมองกลฝังตัว"
        },
        {
          "id": "250409",
          "courseID": "4",
          "title": "สาขาวิชาวิศวกรรมสิ่งแวดล้อม",
          "phone_1": "0-4422-4451",
          "phone_2": "",
          "email_1": "env_eng@sut.ac.th",
          "email_2": "",
          "site": "https://eng.sut.ac.th/ENG2023/schools/school-of-environmental-engineering/",
          "fb": "https://www.facebook.com/envisut",
          "line": "",
          "image": "",
          "address": "",
          "email_3": "",
          "fb_2": "",
          "year": "2025",
          "IG": "",
          "title0": "สาขาวิชาวิศวกรรมสิ่งแวดล้อม"
        },
        {
          "id": "250410",
          "courseID": "4",
          "title": "สาขาวิชาเทคโนโลยีธรณี",
          "phone_1": "0-4422-4441",
          "phone_2": "",
          "email_1": "geoeng@sut.ac.th",
          "email_2": "",
          "site": "https://eng.sut.ac.th/ENG2023/schools/school-of-geotechnology/",
          "fb": "https://www.facebook.com/profile.php?id=100014373256372&mibextid=nW3QTL",
          "line": "",
          "image": "",
          "address": "",
          "email_3": "",
          "fb_2": "",
          "year": "2025",
          "IG": "",
          "title0": "สาขาวิชาเทคโนโลยีธรณี"
        },
        {
          "id": "250411",
          "courseID": "4",
          "title": "สาขาวิชาวิศวกรรมอุตสาหการ",
          "phone_1": "0-4422-4264",
          "phone_2": "",
          "email_1": "industrial.sut@gmail.com",
          "email_2": "",
          "site": "https://eng.sut.ac.th/ENG2023/schools/school-of-industrial-engineering/",
          "fb": "https://www.facebook.com/Industrial.engineering.sut?locale=th_TH",
          "line": "",
          "image": "",
          "address": "",
          "email_3": "",
          "fb_2": "",
          "year": "2025",
          "IG": "",
          "title0": "สาขาวิชาวิศวกรรมอุตสาหการ"
        },
        {
          "id": "250412",
          "courseID": "4",
          "title": "สาขาวิศวกรรมการผลิตอัจฉริยะ",
          "phone_1": "0-4422-4411",
          "phone_2": "",
          "email_1": "mae@sut.ac.th",
          "email_2": "",
          "site": "https://eng.sut.ac.th/ENG2023/schools/school-of-manufacturing-engineering/",
          "fb": "https://www.facebook.com/ManufacturingSUT?locale=th_TH",
          "line": "",
          "image": "",
          "address": "",
          "email_3": "",
          "fb_2": "",
          "year": "2025",
          "IG": "",
          "title0": "สาขาวิศวกรรมการผลิตอัจฉริยะ"
        },
        {
          "id": "250413",
          "courseID": "4",
          "title": "สาขาวิชาวิศวกรรมเครื่องกล",
          "phone_1": "0-4422-4410",
          "phone_2": "",
          "email_1": "me-sut@sut.ac.th",
          "email_2": "",
          "site": "https://eng.sut.ac.th/ENG2023/schools/school-of-mechanical-engineering/",
          "fb": "https://www.facebook.com/SUTMEinformations",
          "line": "",
          "image": "",
          "address": "",
          "email_3": "",
          "fb_2": "",
          "year": "2025",
          "IG": "",
          "title0": "สาขาวิชาวิศวกรรมเครื่องกล"
        },
        {
          "id": "250414",
          "courseID": "4",
          "title": "สาขาวิชาวิศวกรรมโลหการ",
          "phone_1": "0-4422-4481",
          "phone_2": "",
          "email_1": "aimon@sut.ac.th",
          "email_2": "",
          "site": "https://eng.sut.ac.th/ENG2023/schools/school-of-metallurgical-engineering/",
          "fb": "https://www.facebook.com/metallurgysut",
          "line": "",
          "image": "",
          "address": "",
          "email_3": "",
          "fb_2": "",
          "year": "2025",
          "IG": "",
          "title0": "สาขาวิชาวิศวกรรมโลหการ"
        },
        {
          "id": "250415",
          "courseID": "4",
          "title": "สาขาวิชาวิศวกรรมปิโตรเลียมและเทคโนโลยีธรณี",
          "phone_1": "",
          "phone_2": "",
          "email_1": "",
          "email_2": "",
          "site": "https://eng.sut.ac.th/ENG2023/undergraduate-study/",
          "fb": "",
          "line": "",
          "image": "",
          "address": "",
          "email_3": "",
          "fb_2": "",
          "year": "2025",
          "IG": "",
          "title0": "สาขาวิชาวิศวกรรมปิโตรเลียมและเทคโนโลยีธรณี"
        },
        {
          "id": "250416",
          "courseID": "4",
          "title": "สาขาวิชาวิศวกรรมพอลิเมอร์",
          "phone_1": "0-4422-4431",
          "phone_2": "",
          "email_1": "wannaporn@sut.ac.th",
          "email_2": "",
          "site": "https://eng.sut.ac.th/ENG2023/schools/school-of-polymer-engineering/",
          "fb": "https://www.facebook.com/PolymerEngSUT",
          "line": "",
          "image": "",
          "address": "",
          "email_3": "",
          "fb_2": "",
          "year": "2025",
          "IG": "",
          "title0": "สาขาวิชาวิศวกรรมพอลิเมอร์"
        },
        {
          "id": "250417",
          "courseID": "4",
          "title": "สาขาวิชาวิศวกรรมโทรคมนาคมและโครงข่ายอัจฉริยะ",
          "phone_1": "0-4422-4422",
          "phone_2": "",
          "email_1": "cpesut.th@g.sut.ac.th",
          "email_2": "",
          "site": "https://eng.sut.ac.th/ENG2023/schools/school-of-computer-engineering/",
          "fb": "https://www.facebook.com/cpesut",
          "line": "",
          "image": "",
          "address": "",
          "email_3": "",
          "fb_2": "",
          "year": "2025",
          "IG": "",
          "title0": "สาขาวิชาวิศวกรรมโทรคมนาคมและโครงข่ายอัจฉริยะ"
        },
        {
          "id": "250418",
          "courseID": "4",
          "title": "สาขาวิชาวิศวกรรมขนส่งและโลจิสติกส์",
          "phone_1": "0-4422-4238",
          "phone_2": "",
          "email_1": "ie_tre@sut.ac.th",
          "email_2": "",
          "site": "https://eng.sut.ac.th/ENG2023/schools/school-of-transportation-engineering/",
          "fb": "https://www.facebook.com/profile.php?id=100070119465304",
          "line": "",
          "image": "",
          "address": "",
          "email_3": "",
          "fb_2": "",
          "year": "2025",
          "IG": "",
          "title0": "สาขาวิชาวิศวกรรมขนส่งและโลจิสติกส์"
        },
        {
          "id": "250419",
          "courseID": "4",
          "title": "สาขาวิชาวิศวกรรมโยธาและโครงสร้างพื้นฐาน (หลักสูตรนอกเวลา)",
          "phone_1": "0-4422-3014",
          "phone_2": "0-4422-3025",
          "email_1": "ci@sut.ac.th",
          "email_2": "",
          "site": "https://eng.sut.ac.th/ENG2023/beng-in-civil-and-infrastructure-engineering/#",
          "fb": "https://www.facebook.com/ci.sut2018",
          "line": "",
          "image": "",
          "address": "",
          "email_3": "",
          "fb_2": "",
          "year": "2025",
          "IG": "",
          "title0": "สาขาวิชาวิศวกรรมโยธาและโครงสร้างพื้นฐาน (หลักสูตรนอกเวลา)"
        },
        {
          "id": "250420",
          "courseID": "4",
          "title": "สาขาวิชาการประกอบการด้วยเทคโนโลยีดิจิทัล (หลักสูตรนอกเวลา)",
          "phone_1": "0-4422-6554",
          "phone_2": "",
          "email_1": "dte@sut.ac.th",
          "email_2": "",
          "site": "https://www.dte.sut.ac.th/en",
          "fb": "https://www.facebook.com/dte.sut.ac.th",
          "line": "",
          "image": "",
          "address": "",
          "email_3": "",
          "fb_2": "",
          "year": "2025",
          "IG": "",
          "title0": "สาขาวิชาการประกอบการด้วยเทคโนโลยีดิจิทัล (หลักสูตรนอกเวลา)"
        },
        {
          "id": "250421",
          "courseID": "4",
          "title": "สาขาวิชาวิศวกรรมไฟฟ้าอุตสาหกรรม (หลักสูตรนอกเวลา)",
          "phone_1": "0-4422-4224",
          "phone_2": "",
          "email_1": "padej@sut.ac.th",
          "email_2": "",
          "site": "https://iee.sut.ac.th/",
          "fb": "https://www.facebook.com/iee.sut",
          "line": "",
          "image": "",
          "address": "",
          "email_3": "",
          "fb_2": "",
          "year": "2025",
          "IG": "",
          "title0": "สาขาวิชาวิศวกรรมไฟฟ้าอุตสาหกรรม (หลักสูตรนอกเวลา)"
        },
        {
          "id": "250422",
          "courseID": "4",
          "title": "สาขาวิชาวิศวกรรมอุตสาหการและการจัดการข้อมูล (หลักสูตรนอกเวลา)",
          "phone_1": "0-4422-4264",
          "phone_2": "",
          "email_1": "industrial.sut@gmail.com",
          "email_2": "",
          "site": "https://eng.sut.ac.th/ENG2023/schools/school-of-industrial-engineering/",
          "fb": "https://www.facebook.com/Industrial.engineering.sut?locale=th_TH",
          "line": "",
          "image": "",
          "address": "",
          "email_3": "",
          "fb_2": "",
          "year": "2025",
          "IG": "",
          "title0": "สาขาวิชาวิศวกรรมอุตสาหการและการจัดการข้อมูล (หลักสูตรนอกเวลา)"
        },
        {
          "id": "250423",
          "courseID": "4",
          "title": "หลักสูตรวิชาวิศวกรรมสมองกลอัจฉริยะและอิเล็กทรอนิกส์ความถี่สูง",
          "phone_1": "0-4422-4171",
          "phone_2": "",
          "email_1": "electronic@sut.ac.th",
          "email_2": "",
          "site": "https://eng.sut.ac.th/ENG2023/schools/school-of-electronic-engineering/",
          "fb": "https://www.facebook.com/profile.php?id=100057592354372",
          "line": "",
          "image": "",
          "address": "",
          "email_3": "",
          "fb_2": "",
          "year": "2025",
          "IG": "",
          "title0": "หลักสูตรวิชาวิศวกรรมสมองกลอัจฉริยะและอิเล็กทรอนิกส์ความถี่สูง"
        },
        {
          "id": "250424",
          "courseID": "4",
          "title": "สาขาวิชาวิศวกรรมเครื่องกลและกระบวนการผลิต (หลักสูตรนอกเวลา)",
          "phone_1": "",
          "phone_2": "",
          "email_1": "",
          "email_2": "",
          "site": "https://eng.sut.ac.th/ENG2023/undergraduate-study/",
          "fb": "",
          "line": "",
          "image": "",
          "address": "",
          "email_3": "",
          "fb_2": "",
          "year": "2025",
          "IG": "",
          "title0": "สาขาวิชาวิศวกรรมเครื่องกลและกระบวนการผลิต (หลักสูตรนอกเวลา)"
        },
        {
          "id": "250425",
          "courseID": "4",
          "title": "สาขาวิชาวิศวกรรมเมคคาทรอนิกส์ (หลักสูตรนอกเวลา)",
          "phone_1": "0-4422-4576",
          "phone_2": "",
          "email_1": "mechatronics@sut.ac.th",
          "email_2": "",
          "site": "http://mecha.sut.ac.th/",
          "fb": "https://www.facebook.com/MeXSUTchannel",
          "line": "",
          "image": "",
          "address": "",
          "email_3": "",
          "fb_2": "",
          "year": "2025",
          "IG": "",
          "title0": "สาขาวิชาวิศวกรรมเมคคาทรอนิกส์ (หลักสูตรนอกเวลา)"
        },
        {
          "id": "250426",
          "courseID": "4",
          "title": "สาขาวิชาวิศวกรรมยานยนต์สมัยใหม่ (หลักสูตรนอกเวลา)",
          "phone_1": "0-4422-4576",
          "phone_2": "",
          "email_1": "mechatronics@sut.ac.th",
          "email_2": "",
          "site": "http://mecha.sut.ac.th/",
          "fb": "https://www.facebook.com/MeXSUTchannel",
          "line": "",
          "image": "",
          "address": "",
          "email_3": "",
          "fb_2": "",
          "year": "2025",
          "IG": "",
          "title0": "สาขาวิชาวิศวกรรมยานยนต์สมัยใหม่ (หลักสูตรนอกเวลา)"
        },
        {
          "id": "250427",
          "courseID": "4",
          "title": "สาขาวิชาวิศวกรรมโยธา (หลักสูตรนานาชาติ)",
          "phone_1": "",
          "phone_2": "",
          "email_1": "",
          "email_2": "",
          "site": "https://eng.sut.ac.th/ENG2023/undergraduate-study/",
          "fb": "",
          "line": "",
          "image": "",
          "address": "",
          "email_3": "",
          "fb_2": "",
          "year": "2025",
          "IG": "",
          "title0": "สาขาวิชาวิศวกรรมโยธา (หลักสูตรนานาชาติ)"
        },
        {
          "id": "250428",
          "courseID": "4",
          "title": "สาขาวิชาวิศวกรรมเครื่องกลและอากาศยาน (หลักสูตรนานาชาติ)",
          "phone_1": "0-4422 4410",
          "phone_2": "",
          "email_1": "me-sut@sut.ac.th",
          "email_2": "",
          "site": "https://eng.sut.ac.th/ENG2023/schools/school-of-mechanical-engineering/",
          "fb": "https://www.facebook.com/SUTMEinformations",
          "line": "",
          "image": "",
          "address": "",
          "email_3": "",
          "fb_2": "",
          "year": "2025",
          "IG": "",
          "title0": "สาขาวิชาวิศวกรรมเครื่องกลและอากาศยาน (หลักสูตรนานาชาติ)"
        },
        {
          "id": "250429",
          "courseID": "4",
          "title": "สาขาวิชาวิศวกรรมปิโตรเคมีและพอลิเมอร์ (หลักสูตรนานาชาติ)",
          "phone_1": "",
          "phone_2": "",
          "email_1": "",
          "email_2": "",
          "site": "https://eng.sut.ac.th/ENG2023/undergraduate-study/",
          "fb": "",
          "line": "",
          "image": "",
          "address": "",
          "email_3": "",
          "fb_2": "",
          "year": "2025",
          "IG": "",
          "title0": "สาขาวิชาวิศวกรรมปิโตรเคมีและพอลิเมอร์ (หลักสูตรนานาชาติ)"
        }
      ]
    },
    "5": {
      "code": 200,
      "status": "Get data success",
      "data": [
        {
          "id": "250501",
          "courseID": "5",
          "title": "สำนักวิชาแพทยศาสตร์",
          "phone_1": "0-4422-3917",
          "phone_2": "0-4422-3920",
          "email_1": "Imadmin@sut.ac.th,",
          "email_2": "Imadmin@g.sut.ac.th",
          "site": "http://imdata.sut.ac.th/im-sut/index.php",
          "fb": "http://www.facebook.com/MedSUT",
          "line": "",
          "image": "__PUBLIC_URL__/service-sut/image/00-FooterContact/05-Med.png",
          "address": "",
          "email_3": "",
          "fb_2": "",
          "year": "2025",
          "IG": "",
          "title0": "สำนักวิชาแพทยศาสตร์"
        },
        {
          "id": "250502",
          "courseID": "5",
          "title": "สำนักงานคณบดี",
          "phone_1": "0-4422-3922",
          "phone_2": "0-4422-3917",
          "email_1": "",
          "email_2": "",
          "site": "",
          "fb": "",
          "line": "",
          "image": "",
          "address": "",
          "email_3": "",
          "fb_2": "",
          "year": "2025",
          "IG": "",
          "title0": "สำนักงานคณบดี"
        },
        {
          "id": "250503",
          "courseID": "5",
          "title": "สถานแพทยศาสตรศึกษา",
          "phone_1": "0-4422-3975",
          "phone_2": "",
          "email_1": "",
          "email_2": "",
          "site": "",
          "fb": "",
          "line": "",
          "image": "",
          "address": "",
          "email_3": "",
          "fb_2": "",
          "year": "2025",
          "IG": "",
          "title0": "สถานแพทยศาสตรศึกษา"
        },
        {
          "id": "250504",
          "courseID": "5",
          "title": "งานการเรียนการสอนและประเมินผล",
          "phone_1": "0-4422-3919",
          "phone_2": "",
          "email_1": "",
          "email_2": "",
          "site": "",
          "fb": "",
          "line": "",
          "image": "",
          "address": "",
          "email_3": "",
          "fb_2": "",
          "year": "2025",
          "IG": "",
          "title0": "งานการเรียนการสอนและประเมินผล"
        },
        {
          "id": "250505",
          "courseID": "5",
          "title": "งานพัฒนาศักยภาพนักศึกษาฯ",
          "phone_1": "0-4422-3957",
          "phone_2": "",
          "email_1": "",
          "email_2": "",
          "site": "",
          "fb": "",
          "line": "",
          "image": "",
          "address": "",
          "email_3": "",
          "fb_2": "",
          "year": "2025",
          "IG": "",
          "title0": "งานพัฒนาศักยภาพนักศึกษาฯ"
        },
        {
          "id": "250506",
          "courseID": "5",
          "title": "ส่วนงานสถานวิจัย",
          "phone_1": "0-4422-3921",
          "phone_2": "",
          "email_1": "",
          "email_2": "",
          "site": "",
          "fb": "",
          "line": "",
          "image": "",
          "address": "",
          "email_3": "",
          "fb_2": "",
          "year": "2025",
          "IG": "",
          "title0": "ส่วนงานสถานวิจัย"
        }
      ]
    },
    "6": {
      "code": 200,
      "status": "Get data success",
      "data": [
        {
          "id": "250601",
          "courseID": "6",
          "title": "สำนักวิชาพยาบาลศาสตร์",
          "phone_1": "0-4422-3519, 0-4422-3562, 0-4422-3510",
          "phone_2": "0-4422-3506",
          "email_1": "inadmin@sut.ac.th",
          "email_2": "",
          "site": "https://beta.sut.ac.th/in/",
          "fb": "",
          "line": "",
          "image": "__PUBLIC_URL__/service-sut/image/00-FooterContact/06-Nurs.png",
          "address": "",
          "email_3": "",
          "fb_2": "",
          "year": "2025",
          "IG": "",
          "title0": "สำนักวิชาพยาบาลศาสตร์"
        },
        {
          "id": "250602",
          "courseID": "6",
          "title": "สำนักงานคณบดี",
          "phone_1": "0-4422-3519, 0-4422-3562, 0-4422-3510",
          "phone_2": "0-4422-3506",
          "email_1": "inadmin@sut.ac.th",
          "email_2": "",
          "site": "https://beta.sut.ac.th/in",
          "fb": "",
          "line": "",
          "image": "",
          "address": "",
          "email_3": "",
          "fb_2": "",
          "year": "2025",
          "IG": "",
          "title0": "สำนักงานคณบดี"
        }
      ]
    },
    "7": {
      "code": 200,
      "status": "Get data success",
      "data": [
        {
          "id": "250701",
          "courseID": "7",
          "title": "สำนักวิชาทันตแพทยศาสตร์",
          "phone_1": "0-4422-3582, 0-4422-3592, 0-4422-3593",
          "phone_2": "0-4422-3580",
          "email_1": "dentistry@sut.ac.th",
          "email_2": "",
          "site": "https://beta.sut.ac.th/id",
          "fb": "",
          "line": "",
          "image": "__PUBLIC_URL__/service-sut/image/00-FooterContact/07-Dent.png",
          "address": "",
          "email_3": "",
          "fb_2": "",
          "year": "2025",
          "IG": "",
          "title0": "สำนักวิชาทันตแพทยศาสตร์"
        },
        {
          "id": "250702",
          "courseID": "7",
          "title": "สำนักวิชาทันตแพทยศาสตร์ อาคารเทพรัตน์วิทยรักษ์ (อาคารเครื่องมือ 12) 111 ถนนมหาวิทยาลัย ตำบลสุรนารี อำเภอเมือง จังหวัดนครราชสีมา 30000",
          "phone_1": "",
          "phone_2": "",
          "email_1": "",
          "email_2": "",
          "site": "",
          "fb": "",
          "line": "",
          "image": "",
          "address": "",
          "email_3": "",
          "fb_2": "",
          "year": "2025",
          "IG": "",
          "title0": "สำนักวิชาทันตแพทยศาสตร์ อาคารเทพรัตน์วิทยรักษ์ (อาคารเครื่องมือ 12) 111 ถนนมหาวิทยาลัย ตำบลสุรนารี อำเภอเมือง จังหวัดนครราชสีมา 30000"
        },
        {
          "id": "250703",
          "courseID": "7",
          "title": "ชั้น 1,O สำนักงานคณบดี ,ชั้น 3,O สาขาวิชาสุขภาพช่องปากครอบครัวและชุมชน,O สาขาวิชาสุขภาพช่องปากเด็ก,O สาขาวิชาสุขภาพช่องปากวัยรุ่น,O สาขาวิชาสุขภาพช่องปากผู้ใหญ่,O สาขาวิชาสุขภาพช่องปากผู้สูงอายุ,O สถานทันตแพทยศาสตรศึกษา,O สถานวิจัยสำนักวิชาทันตแพทยศาสตร์",
          "phone_1": "",
          "phone_2": "",
          "email_1": "",
          "email_2": "",
          "site": "",
          "fb": "",
          "line": "",
          "image": "",
          "address": "",
          "email_3": "",
          "fb_2": "",
          "year": "2025",
          "IG": "",
          "title0": "ชั้น 1",
          "title1": "O สำนักงานคณบดี ",
          "title2": "ชั้น 3",
          "title3": "O สาขาวิชาสุขภาพช่องปากครอบครัวและชุมชน",
          "title4": "O สาขาวิชาสุขภาพช่องปากเด็ก",
          "title5": "O สาขาวิชาสุขภาพช่องปากวัยรุ่น",
          "title6": "O สาขาวิชาสุขภาพช่องปากผู้ใหญ่",
          "title7": "O สาขาวิชาสุขภาพช่องปากผู้สูงอายุ",
          "title8": "O สถานทันตแพทยศาสตรศึกษา",
          "title9": "O สถานวิจัยสำนักวิชาทันตแพทยศาสตร์"
        }
      ]
    },
    "8": {
      "code": 200,
      "status": "Get data success",
      "data": [
        {
          "id": "250801",
          "courseID": "8",
          "title": "สำนักวิชาสาธารณสุขศาสตร์",
          "phone_1": "0-44223-820",
          "phone_2": "",
          "email_1": "iphsutservice@sut.ac.th",
          "email_2": "",
          "site": "http://iph.sut.ac.th/",
          "fb": "https://www.facebook.com/sasuksut/",
          "line": "",
          "image": "__PUBLIC_URL__/service-sut/image/image_2024/Img/08-PubH/08-PubH.png",
          "address": "",
          "email_3": "",
          "fb_2": "",
          "year": "2025",
          "IG": "https://www.instagram.com/sasuk_sut/",
          "title0": "สำนักวิชาสาธารณสุขศาสตร์"
        },
        {
          "id": "250802",
          "courseID": "8",
          "title": "สาขาวิชาอนามัยสิ่งแวดล้อม",
          "phone_1": "0-4422-3923",
          "phone_2": "",
          "email_1": "",
          "email_2": "",
          "site": "",
          "fb": "https://www.facebook.com/ENVIHealthSUT",
          "line": "",
          "image": "",
          "address": "",
          "email_3": "",
          "fb_2": "",
          "year": "2025",
          "IG": "",
          "title0": "สาขาวิชาอนามัยสิ่งแวดล้อม"
        },
        {
          "id": "250803",
          "courseID": "8",
          "title": "สาขาวิชาอาชีวอนามัยและความปลอดภัย",
          "phone_1": "0-4422-3819",
          "phone_2": "",
          "email_1": "",
          "email_2": "",
          "site": "",
          "fb": "https://www.facebook.com/profile.php?id=61559529090018",
          "line": "",
          "image": "",
          "address": "",
          "email_3": "",
          "fb_2": "",
          "year": "2025",
          "IG": "",
          "title0": "สาขาวิชาอาชีวอนามัยและความปลอดภัย"
        },
        {
          "id": "250804",
          "courseID": "8",
          "title": "สาขาวิชาโภชนวิทยาและการกำหนดอาหาร",
          "phone_1": "0-4422-3811",
          "phone_2": "",
          "email_1": "",
          "email_2": "",
          "site": "",
          "fb": "https://www.facebook.com/NDIPHSUT",
          "line": "",
          "image": "",
          "address": "",
          "email_3": "",
          "fb_2": "",
          "year": "2025",
          "IG": "",
          "title0": "สาขาวิชาโภชนวิทยาและการกำหนดอาหาร"
        },
        {
          "id": "250805",
          "courseID": "8",
          "title": "สำนักงานคณบดี",
          "phone_1": "0-4422-3820",
          "phone_2": "",
          "email_1": "",
          "email_2": "",
          "site": "",
          "fb": "",
          "line": "",
          "image": "",
          "address": "",
          "email_3": "",
          "fb_2": "",
          "year": "2025",
          "IG": "",
          "title0": "สำนักงานคณบดี"
        },
        {
          "id": "250806",
          "courseID": "8",
          "title": "สถานวิจัย",
          "phone_1": "0-4422-3781",
          "phone_2": "",
          "email_1": "",
          "email_2": "",
          "site": "",
          "fb": "",
          "line": "",
          "image": "",
          "address": "",
          "email_3": "",
          "fb_2": "",
          "year": "2025",
          "IG": "",
          "title0": "สถานวิจัย"
        }
      ]
    },
    "9": {
      "code": 200,
      "status": "Get data success",
      "data": [
        {
          "id": "250901",
          "courseID": "9",
          "title": "สำนักวิชาศาสตร์และศิลป์ดิจิทัล",
          "phone_1": "0-4422-5789",
          "phone_2": "0-4422-5794",
          "email_1": "digitech.office@sut.ac.th",
          "email_2": "",
          "site": "http://digitech.sut.ac.th",
          "fb": "Facebook/DigiTech.TH",
          "line": "",
          "image": "__PUBLIC_URL__/service-sut/image/00-FooterContact/09-DigiT.png",
          "address": "111 ถนนมหาวิทยาลัย ตำบลสุรนารี อำเภอเมือง จังหวัดนครราชสีมา 30000",
          "email_3": "",
          "fb_2": "",
          "year": "2025",
          "IG": "",
          "title0": "สำนักวิชาศาสตร์และศิลป์ดิจิทัล"
        }
      ]
    }
  }
};

export default yearContent;
